[
  {
    "id": "us-flag-250",
    "name": "US Flag (250 Edition)",
    "brand": "crazy,pints,adult",
    "desc": "Sculpted American Flag cribbage board with engraved stripes and stars.",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/us-flag-250-thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/cd8a6a58625488d8/us-flag-250.glb",
    "holeSpacing": 7.5,
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "maple",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 190.5,
          "y": 10,
          "z": 55.0003
        },
        {
          "hole": 1,
          "x": 172.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 2,
          "x": 165,
          "y": 10,
          "z": 55
        },
        {
          "hole": 3,
          "x": 152.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 4,
          "x": 152.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 5,
          "x": 152.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 6,
          "x": 152.5,
          "y": 10,
          "z": 85
        },
        {
          "hole": 7,
          "x": 152.5,
          "y": 10,
          "z": 92.5
        },
        {
          "hole": 8,
          "x": 152.5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 9,
          "x": 165,
          "y": 10,
          "z": 105
        },
        {
          "hole": 10,
          "x": 172.5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 11,
          "x": 182.5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 12,
          "x": 190,
          "y": 10,
          "z": 105
        },
        {
          "hole": 13,
          "x": 232.5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 14,
          "x": 232.5,
          "y": 10,
          "z": 147.5
        },
        {
          "hole": 15,
          "x": 232.5,
          "y": 10,
          "z": 155
        },
        {
          "hole": 16,
          "x": 232.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 17,
          "x": 232.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 18,
          "x": 232.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 19,
          "x": 190,
          "y": 10,
          "z": 215
        },
        {
          "hole": 20,
          "x": 182.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 21,
          "x": 173,
          "y": 10,
          "z": 215
        },
        {
          "hole": 22,
          "x": 165.25,
          "y": 10,
          "z": 215
        },
        {
          "hole": 23,
          "x": 157.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 24,
          "x": 149.75,
          "y": 10,
          "z": 215
        },
        {
          "hole": 25,
          "x": 142,
          "y": 10,
          "z": 215
        },
        {
          "hole": 26,
          "x": 133,
          "y": 10,
          "z": 215
        },
        {
          "hole": 27,
          "x": 125.25,
          "y": 10,
          "z": 215
        },
        {
          "hole": 28,
          "x": 117.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 29,
          "x": 109.75,
          "y": 10,
          "z": 215
        },
        {
          "hole": 30,
          "x": 102,
          "y": 10,
          "z": 215
        },
        {
          "hole": 31,
          "x": 93,
          "y": 10,
          "z": 215
        },
        {
          "hole": 32,
          "x": 85.25,
          "y": 10,
          "z": 215
        },
        {
          "hole": 33,
          "x": 77.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 34,
          "x": 69.75,
          "y": 10,
          "z": 215
        },
        {
          "hole": 35,
          "x": 62,
          "y": 10,
          "z": 215
        },
        {
          "hole": 36,
          "x": 53,
          "y": 10,
          "z": 215
        },
        {
          "hole": 37,
          "x": 45.25,
          "y": 10,
          "z": 215
        },
        {
          "hole": 38,
          "x": 37.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 39,
          "x": 29.75,
          "y": 10,
          "z": 215
        },
        {
          "hole": 40,
          "x": 22,
          "y": 10,
          "z": 215
        },
        {
          "hole": 41,
          "x": 12.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 42,
          "x": 5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 43,
          "x": -37.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 44,
          "x": -37.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 45,
          "x": -37.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 46,
          "x": -37.5,
          "y": 10,
          "z": 155
        },
        {
          "hole": 47,
          "x": -37.5,
          "y": 10,
          "z": 147.5
        },
        {
          "hole": 48,
          "x": -37.5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 49,
          "x": 5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 50,
          "x": 12.5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 51,
          "x": 22.5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 52,
          "x": 30,
          "y": 10,
          "z": 105
        },
        {
          "hole": 53,
          "x": 42.5,
          "y": 10,
          "z": 105
        },
        {
          "hole": 54,
          "x": 42.5,
          "y": 10,
          "z": 92.5
        },
        {
          "hole": 55,
          "x": 42.5,
          "y": 10,
          "z": 85
        },
        {
          "hole": 56,
          "x": 42.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 57,
          "x": 42.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 58,
          "x": 42.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 59,
          "x": 30,
          "y": 10,
          "z": 55
        },
        {
          "hole": 60,
          "x": 22.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 61,
          "x": 13,
          "y": 10,
          "z": 55
        },
        {
          "hole": 62,
          "x": 5.25,
          "y": 10,
          "z": 55
        },
        {
          "hole": 63,
          "x": -2.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 64,
          "x": -10.25,
          "y": 10,
          "z": 55
        },
        {
          "hole": 65,
          "x": -18,
          "y": 10,
          "z": 55
        },
        {
          "hole": 66,
          "x": -27,
          "y": 10,
          "z": 55
        },
        {
          "hole": 67,
          "x": -34.75,
          "y": 10,
          "z": 55
        },
        {
          "hole": 68,
          "x": -42.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 69,
          "x": -50.25,
          "y": 10,
          "z": 55
        },
        {
          "hole": 70,
          "x": -58,
          "y": 10,
          "z": 55
        },
        {
          "hole": 71,
          "x": -67,
          "y": 10,
          "z": 55
        },
        {
          "hole": 72,
          "x": -74.75,
          "y": 10,
          "z": 55
        },
        {
          "hole": 73,
          "x": -82.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 74,
          "x": -90.25,
          "y": 10,
          "z": 55
        },
        {
          "hole": 75,
          "x": -98,
          "y": 10,
          "z": 55
        },
        {
          "hole": 76,
          "x": -107,
          "y": 10,
          "z": 55
        },
        {
          "hole": 77,
          "x": -114.75,
          "y": 10,
          "z": 55
        },
        {
          "hole": 78,
          "x": -122.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 79,
          "x": -130.25,
          "y": 10,
          "z": 55
        },
        {
          "hole": 80,
          "x": -138,
          "y": 10,
          "z": 55
        },
        {
          "hole": 81,
          "x": -147,
          "y": 10,
          "z": 55
        },
        {
          "hole": 82,
          "x": -154.75,
          "y": 10,
          "z": 55
        },
        {
          "hole": 83,
          "x": -162.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 84,
          "x": -170.25,
          "y": 10,
          "z": 55
        },
        {
          "hole": 85,
          "x": -178,
          "y": 10,
          "z": 55
        },
        {
          "hole": 86,
          "x": -187.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 87,
          "x": -195,
          "y": 10,
          "z": 55
        },
        {
          "hole": 88,
          "x": -207.5,
          "y": 10,
          "z": 55
        },
        {
          "hole": 89,
          "x": -207.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 90,
          "x": -207.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 91,
          "x": -207.5,
          "y": 10,
          "z": 84.5
        },
        {
          "hole": 92,
          "x": -207.5,
          "y": 10,
          "z": 92.25
        },
        {
          "hole": 93,
          "x": -207.5,
          "y": 10,
          "z": 100
        },
        {
          "hole": 94,
          "x": -207.5,
          "y": 10,
          "z": 107.75
        },
        {
          "hole": 95,
          "x": -207.5,
          "y": 10,
          "z": 115.5
        },
        {
          "hole": 96,
          "x": -207.5,
          "y": 10,
          "z": 124.5
        },
        {
          "hole": 97,
          "x": -207.5,
          "y": 10,
          "z": 132.25
        },
        {
          "hole": 98,
          "x": -207.5,
          "y": 10,
          "z": 140
        },
        {
          "hole": 99,
          "x": -207.5,
          "y": 10,
          "z": 147.75
        },
        {
          "hole": 100,
          "x": -207.5,
          "y": 10,
          "z": 155.5
        },
        {
          "hole": 101,
          "x": -207.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 102,
          "x": -207.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 103,
          "x": -207.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 104,
          "x": -195,
          "y": 10,
          "z": 185
        },
        {
          "hole": 105,
          "x": -187.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 106,
          "x": -178,
          "y": 10,
          "z": 185
        },
        {
          "hole": 107,
          "x": -170.25,
          "y": 10,
          "z": 185
        },
        {
          "hole": 108,
          "x": -162.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 109,
          "x": -154.75,
          "y": 10,
          "z": 185
        },
        {
          "hole": 110,
          "x": -147,
          "y": 10,
          "z": 185
        },
        {
          "hole": 111,
          "x": -137.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 112,
          "x": -130,
          "y": 10,
          "z": 185
        },
        {
          "hole": 113,
          "x": -117.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 114,
          "x": -117.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 115,
          "x": -117.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 116,
          "x": -117.5,
          "y": 10,
          "z": 155.5
        },
        {
          "hole": 117,
          "x": -117.5,
          "y": 10,
          "z": 147.75
        },
        {
          "hole": 118,
          "x": -117.5,
          "y": 10,
          "z": 140
        },
        {
          "hole": 119,
          "x": -117.5,
          "y": 10,
          "z": 132.25
        },
        {
          "hole": 120,
          "x": -117.5,
          "y": 10,
          "z": 124.5
        },
        {
          "hole": 121,
          "x": -102.5,
          "y": 10,
          "z": 90
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 190.5,
          "y": 10,
          "z": 45.0003
        },
        {
          "hole": 1,
          "x": 172.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 2,
          "x": 165,
          "y": 10,
          "z": 45
        },
        {
          "hole": 3,
          "x": 142.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 4,
          "x": 142.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 5,
          "x": 142.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 6,
          "x": 142.5,
          "y": 10,
          "z": 85
        },
        {
          "hole": 7,
          "x": 142.5,
          "y": 10,
          "z": 92.5
        },
        {
          "hole": 8,
          "x": 142.5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 9,
          "x": 165,
          "y": 10,
          "z": 115
        },
        {
          "hole": 10,
          "x": 172.5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 11,
          "x": 182.5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 12,
          "x": 190,
          "y": 10,
          "z": 115
        },
        {
          "hole": 13,
          "x": 222.5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 14,
          "x": 222.5,
          "y": 10,
          "z": 147.5
        },
        {
          "hole": 15,
          "x": 222.5,
          "y": 10,
          "z": 155
        },
        {
          "hole": 16,
          "x": 222.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 17,
          "x": 222.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 18,
          "x": 222.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 19,
          "x": 190,
          "y": 10,
          "z": 205
        },
        {
          "hole": 20,
          "x": 182.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 21,
          "x": 173,
          "y": 10,
          "z": 205
        },
        {
          "hole": 22,
          "x": 165.25,
          "y": 10,
          "z": 205
        },
        {
          "hole": 23,
          "x": 157.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 24,
          "x": 149.75,
          "y": 10,
          "z": 205
        },
        {
          "hole": 25,
          "x": 142,
          "y": 10,
          "z": 205
        },
        {
          "hole": 26,
          "x": 133,
          "y": 10,
          "z": 205
        },
        {
          "hole": 27,
          "x": 125.25,
          "y": 10,
          "z": 205
        },
        {
          "hole": 28,
          "x": 117.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 29,
          "x": 109.75,
          "y": 10,
          "z": 205
        },
        {
          "hole": 30,
          "x": 102,
          "y": 10,
          "z": 205
        },
        {
          "hole": 31,
          "x": 93,
          "y": 10,
          "z": 205
        },
        {
          "hole": 32,
          "x": 85.25,
          "y": 10,
          "z": 205
        },
        {
          "hole": 33,
          "x": 77.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 34,
          "x": 69.75,
          "y": 10,
          "z": 205
        },
        {
          "hole": 35,
          "x": 62,
          "y": 10,
          "z": 205
        },
        {
          "hole": 36,
          "x": 53,
          "y": 10,
          "z": 205
        },
        {
          "hole": 37,
          "x": 45.25,
          "y": 10,
          "z": 205
        },
        {
          "hole": 38,
          "x": 37.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 39,
          "x": 29.75,
          "y": 10,
          "z": 205
        },
        {
          "hole": 40,
          "x": 22,
          "y": 10,
          "z": 205
        },
        {
          "hole": 41,
          "x": 12.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 42,
          "x": 5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 43,
          "x": -27.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 44,
          "x": -27.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 45,
          "x": -27.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 46,
          "x": -27.5,
          "y": 10,
          "z": 155
        },
        {
          "hole": 47,
          "x": -27.5,
          "y": 10,
          "z": 147.5
        },
        {
          "hole": 48,
          "x": -27.5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 49,
          "x": 5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 50,
          "x": 12.5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 51,
          "x": 22.5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 52,
          "x": 30,
          "y": 10,
          "z": 115
        },
        {
          "hole": 53,
          "x": 52.5,
          "y": 10,
          "z": 115
        },
        {
          "hole": 54,
          "x": 52.5,
          "y": 10,
          "z": 92.5
        },
        {
          "hole": 55,
          "x": 52.5,
          "y": 10,
          "z": 85
        },
        {
          "hole": 56,
          "x": 52.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 57,
          "x": 52.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 58,
          "x": 52.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 59,
          "x": 30,
          "y": 10,
          "z": 45
        },
        {
          "hole": 60,
          "x": 22.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 61,
          "x": 13,
          "y": 10,
          "z": 45
        },
        {
          "hole": 62,
          "x": 5.25,
          "y": 10,
          "z": 45
        },
        {
          "hole": 63,
          "x": -2.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 64,
          "x": -10.25,
          "y": 10,
          "z": 45
        },
        {
          "hole": 65,
          "x": -18,
          "y": 10,
          "z": 45
        },
        {
          "hole": 66,
          "x": -27,
          "y": 10,
          "z": 45
        },
        {
          "hole": 67,
          "x": -34.75,
          "y": 10,
          "z": 45
        },
        {
          "hole": 68,
          "x": -42.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 69,
          "x": -50.25,
          "y": 10,
          "z": 45
        },
        {
          "hole": 70,
          "x": -58,
          "y": 10,
          "z": 45
        },
        {
          "hole": 71,
          "x": -67,
          "y": 10,
          "z": 45
        },
        {
          "hole": 72,
          "x": -74.75,
          "y": 10,
          "z": 45
        },
        {
          "hole": 73,
          "x": -82.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 74,
          "x": -90.25,
          "y": 10,
          "z": 45
        },
        {
          "hole": 75,
          "x": -98,
          "y": 10,
          "z": 45
        },
        {
          "hole": 76,
          "x": -107,
          "y": 10,
          "z": 45
        },
        {
          "hole": 77,
          "x": -114.75,
          "y": 10,
          "z": 45
        },
        {
          "hole": 78,
          "x": -122.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 79,
          "x": -130.25,
          "y": 10,
          "z": 45
        },
        {
          "hole": 80,
          "x": -138,
          "y": 10,
          "z": 45
        },
        {
          "hole": 81,
          "x": -147,
          "y": 10,
          "z": 45
        },
        {
          "hole": 82,
          "x": -154.75,
          "y": 10,
          "z": 45
        },
        {
          "hole": 83,
          "x": -162.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 84,
          "x": -170.25,
          "y": 10,
          "z": 45
        },
        {
          "hole": 85,
          "x": -178,
          "y": 10,
          "z": 45
        },
        {
          "hole": 86,
          "x": -187.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 87,
          "x": -195,
          "y": 10,
          "z": 45
        },
        {
          "hole": 88,
          "x": -217.5,
          "y": 10,
          "z": 45
        },
        {
          "hole": 89,
          "x": -217.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 90,
          "x": -217.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 91,
          "x": -217.5,
          "y": 10,
          "z": 84.5
        },
        {
          "hole": 92,
          "x": -217.5,
          "y": 10,
          "z": 92.25
        },
        {
          "hole": 93,
          "x": -217.5,
          "y": 10,
          "z": 100
        },
        {
          "hole": 94,
          "x": -217.5,
          "y": 10,
          "z": 107.75
        },
        {
          "hole": 95,
          "x": -217.5,
          "y": 10,
          "z": 115.5
        },
        {
          "hole": 96,
          "x": -217.5,
          "y": 10,
          "z": 124.5
        },
        {
          "hole": 97,
          "x": -217.5,
          "y": 10,
          "z": 132.25
        },
        {
          "hole": 98,
          "x": -217.5,
          "y": 10,
          "z": 140
        },
        {
          "hole": 99,
          "x": -217.5,
          "y": 10,
          "z": 147.75
        },
        {
          "hole": 100,
          "x": -217.5,
          "y": 10,
          "z": 155.5
        },
        {
          "hole": 101,
          "x": -217.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 102,
          "x": -217.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 103,
          "x": -217.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 104,
          "x": -195,
          "y": 10,
          "z": 195
        },
        {
          "hole": 105,
          "x": -187.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 106,
          "x": -178,
          "y": 10,
          "z": 195
        },
        {
          "hole": 107,
          "x": -170.25,
          "y": 10,
          "z": 195
        },
        {
          "hole": 108,
          "x": -162.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 109,
          "x": -154.75,
          "y": 10,
          "z": 195
        },
        {
          "hole": 110,
          "x": -147,
          "y": 10,
          "z": 195
        },
        {
          "hole": 111,
          "x": -137.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 112,
          "x": -130,
          "y": 10,
          "z": 195
        },
        {
          "hole": 113,
          "x": -107.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 114,
          "x": -107.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 115,
          "x": -107.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 116,
          "x": -107.5,
          "y": 10,
          "z": 155.5
        },
        {
          "hole": 117,
          "x": -107.5,
          "y": 10,
          "z": 147.75
        },
        {
          "hole": 118,
          "x": -107.5,
          "y": 10,
          "z": 140
        },
        {
          "hole": 119,
          "x": -107.5,
          "y": 10,
          "z": 132.25
        },
        {
          "hole": 120,
          "x": -107.5,
          "y": 10,
          "z": 124.5
        },
        {
          "hole": 121,
          "x": -102.5,
          "y": 10,
          "z": 90
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": 190.5,
          "y": 10,
          "z": 35.0003
        },
        {
          "hole": 1,
          "x": 172.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 2,
          "x": 165,
          "y": 10,
          "z": 35
        },
        {
          "hole": 3,
          "x": 132.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 4,
          "x": 132.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 5,
          "x": 132.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 6,
          "x": 132.5,
          "y": 10,
          "z": 85
        },
        {
          "hole": 7,
          "x": 132.5,
          "y": 10,
          "z": 92.5
        },
        {
          "hole": 8,
          "x": 132.5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 9,
          "x": 165,
          "y": 10,
          "z": 125
        },
        {
          "hole": 10,
          "x": 172.5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 11,
          "x": 182.5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 12,
          "x": 190,
          "y": 10,
          "z": 125
        },
        {
          "hole": 13,
          "x": 212.5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 14,
          "x": 212.5,
          "y": 10,
          "z": 147.5
        },
        {
          "hole": 15,
          "x": 212.5,
          "y": 10,
          "z": 155
        },
        {
          "hole": 16,
          "x": 212.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 17,
          "x": 212.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 18,
          "x": 212.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 19,
          "x": 190,
          "y": 10,
          "z": 195
        },
        {
          "hole": 20,
          "x": 182.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 21,
          "x": 173,
          "y": 10,
          "z": 195
        },
        {
          "hole": 22,
          "x": 165.25,
          "y": 10,
          "z": 195
        },
        {
          "hole": 23,
          "x": 157.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 24,
          "x": 149.75,
          "y": 10,
          "z": 195
        },
        {
          "hole": 25,
          "x": 142,
          "y": 10,
          "z": 195
        },
        {
          "hole": 26,
          "x": 133,
          "y": 10,
          "z": 195
        },
        {
          "hole": 27,
          "x": 125.25,
          "y": 10,
          "z": 195
        },
        {
          "hole": 28,
          "x": 117.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 29,
          "x": 109.75,
          "y": 10,
          "z": 195
        },
        {
          "hole": 30,
          "x": 102,
          "y": 10,
          "z": 195
        },
        {
          "hole": 31,
          "x": 93,
          "y": 10,
          "z": 195
        },
        {
          "hole": 32,
          "x": 85.25,
          "y": 10,
          "z": 195
        },
        {
          "hole": 33,
          "x": 77.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 34,
          "x": 69.75,
          "y": 10,
          "z": 195
        },
        {
          "hole": 35,
          "x": 62,
          "y": 10,
          "z": 195
        },
        {
          "hole": 36,
          "x": 53,
          "y": 10,
          "z": 195
        },
        {
          "hole": 37,
          "x": 45.25,
          "y": 10,
          "z": 195
        },
        {
          "hole": 38,
          "x": 37.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 39,
          "x": 29.75,
          "y": 10,
          "z": 195
        },
        {
          "hole": 40,
          "x": 22,
          "y": 10,
          "z": 195
        },
        {
          "hole": 41,
          "x": 12.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 42,
          "x": 5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 43,
          "x": -17.5,
          "y": 10,
          "z": 195
        },
        {
          "hole": 44,
          "x": -17.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 45,
          "x": -17.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 46,
          "x": -17.5,
          "y": 10,
          "z": 155
        },
        {
          "hole": 47,
          "x": -17.5,
          "y": 10,
          "z": 147.5
        },
        {
          "hole": 48,
          "x": -17.5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 49,
          "x": 5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 50,
          "x": 12.5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 51,
          "x": 22.5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 52,
          "x": 30,
          "y": 10,
          "z": 125
        },
        {
          "hole": 53,
          "x": 62.5,
          "y": 10,
          "z": 125
        },
        {
          "hole": 54,
          "x": 62.5,
          "y": 10,
          "z": 92.5
        },
        {
          "hole": 55,
          "x": 62.5,
          "y": 10,
          "z": 85
        },
        {
          "hole": 56,
          "x": 62.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 57,
          "x": 62.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 58,
          "x": 62.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 59,
          "x": 30,
          "y": 10,
          "z": 35
        },
        {
          "hole": 60,
          "x": 22.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 61,
          "x": 13,
          "y": 10,
          "z": 35
        },
        {
          "hole": 62,
          "x": 5.25,
          "y": 10,
          "z": 35
        },
        {
          "hole": 63,
          "x": -2.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 64,
          "x": -10.25,
          "y": 10,
          "z": 35
        },
        {
          "hole": 65,
          "x": -18,
          "y": 10,
          "z": 35
        },
        {
          "hole": 66,
          "x": -27,
          "y": 10,
          "z": 35
        },
        {
          "hole": 67,
          "x": -34.75,
          "y": 10,
          "z": 35
        },
        {
          "hole": 68,
          "x": -42.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 69,
          "x": -50.25,
          "y": 10,
          "z": 35
        },
        {
          "hole": 70,
          "x": -58,
          "y": 10,
          "z": 35
        },
        {
          "hole": 71,
          "x": -67,
          "y": 10,
          "z": 35
        },
        {
          "hole": 72,
          "x": -74.75,
          "y": 10,
          "z": 35
        },
        {
          "hole": 73,
          "x": -82.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 74,
          "x": -90.25,
          "y": 10,
          "z": 35
        },
        {
          "hole": 75,
          "x": -98,
          "y": 10,
          "z": 35
        },
        {
          "hole": 76,
          "x": -107,
          "y": 10,
          "z": 35
        },
        {
          "hole": 77,
          "x": -114.75,
          "y": 10,
          "z": 35
        },
        {
          "hole": 78,
          "x": -122.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 79,
          "x": -130.25,
          "y": 10,
          "z": 35
        },
        {
          "hole": 80,
          "x": -138,
          "y": 10,
          "z": 35
        },
        {
          "hole": 81,
          "x": -147,
          "y": 10,
          "z": 35
        },
        {
          "hole": 82,
          "x": -154.75,
          "y": 10,
          "z": 35
        },
        {
          "hole": 83,
          "x": -162.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 84,
          "x": -170.25,
          "y": 10,
          "z": 35
        },
        {
          "hole": 85,
          "x": -178,
          "y": 10,
          "z": 35
        },
        {
          "hole": 86,
          "x": -187.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 87,
          "x": -195,
          "y": 10,
          "z": 35
        },
        {
          "hole": 88,
          "x": -227.5,
          "y": 10,
          "z": 35
        },
        {
          "hole": 89,
          "x": -227.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 90,
          "x": -227.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 91,
          "x": -227.5,
          "y": 10,
          "z": 84.5
        },
        {
          "hole": 92,
          "x": -227.5,
          "y": 10,
          "z": 92.25
        },
        {
          "hole": 93,
          "x": -227.5,
          "y": 10,
          "z": 100
        },
        {
          "hole": 94,
          "x": -227.5,
          "y": 10,
          "z": 107.75
        },
        {
          "hole": 95,
          "x": -227.5,
          "y": 10,
          "z": 115.5
        },
        {
          "hole": 96,
          "x": -227.5,
          "y": 10,
          "z": 124.5
        },
        {
          "hole": 97,
          "x": -227.5,
          "y": 10,
          "z": 132.25
        },
        {
          "hole": 98,
          "x": -227.5,
          "y": 10,
          "z": 140
        },
        {
          "hole": 99,
          "x": -227.5,
          "y": 10,
          "z": 147.75
        },
        {
          "hole": 100,
          "x": -227.5,
          "y": 10,
          "z": 155.5
        },
        {
          "hole": 101,
          "x": -227.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 102,
          "x": -227.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 103,
          "x": -227.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 104,
          "x": -195,
          "y": 10,
          "z": 205
        },
        {
          "hole": 105,
          "x": -187.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 106,
          "x": -178,
          "y": 10,
          "z": 205
        },
        {
          "hole": 107,
          "x": -170.25,
          "y": 10,
          "z": 205
        },
        {
          "hole": 108,
          "x": -162.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 109,
          "x": -154.75,
          "y": 10,
          "z": 205
        },
        {
          "hole": 110,
          "x": -147,
          "y": 10,
          "z": 205
        },
        {
          "hole": 111,
          "x": -137.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 112,
          "x": -130,
          "y": 10,
          "z": 205
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 10,
          "z": 205
        },
        {
          "hole": 114,
          "x": -97.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 115,
          "x": -97.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 116,
          "x": -97.5,
          "y": 10,
          "z": 155.5
        },
        {
          "hole": 117,
          "x": -97.5,
          "y": 10,
          "z": 147.75
        },
        {
          "hole": 118,
          "x": -97.5,
          "y": 10,
          "z": 140
        },
        {
          "hole": 119,
          "x": -97.5,
          "y": 10,
          "z": 132.25
        },
        {
          "hole": 120,
          "x": -97.5,
          "y": 10,
          "z": 124.5
        },
        {
          "hole": 121,
          "x": -102.5,
          "y": 10,
          "z": 90
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": 190.5,
          "y": 10,
          "z": 25.0003
        },
        {
          "hole": 1,
          "x": 172.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 2,
          "x": 165,
          "y": 10,
          "z": 25
        },
        {
          "hole": 3,
          "x": 122.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 4,
          "x": 122.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 5,
          "x": 122.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 6,
          "x": 122.5,
          "y": 10,
          "z": 85
        },
        {
          "hole": 7,
          "x": 122.5,
          "y": 10,
          "z": 92.5
        },
        {
          "hole": 8,
          "x": 122.5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 9,
          "x": 165,
          "y": 10,
          "z": 135
        },
        {
          "hole": 10,
          "x": 172.5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 11,
          "x": 182.5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 12,
          "x": 190,
          "y": 10,
          "z": 135
        },
        {
          "hole": 13,
          "x": 202.5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 14,
          "x": 202.5,
          "y": 10,
          "z": 147.5
        },
        {
          "hole": 15,
          "x": 202.5,
          "y": 10,
          "z": 155
        },
        {
          "hole": 16,
          "x": 202.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 17,
          "x": 202.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 18,
          "x": 202.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 19,
          "x": 190,
          "y": 10,
          "z": 185
        },
        {
          "hole": 20,
          "x": 182.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 21,
          "x": 173,
          "y": 10,
          "z": 185
        },
        {
          "hole": 22,
          "x": 165.25,
          "y": 10,
          "z": 185
        },
        {
          "hole": 23,
          "x": 157.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 24,
          "x": 149.75,
          "y": 10,
          "z": 185
        },
        {
          "hole": 25,
          "x": 142,
          "y": 10,
          "z": 185
        },
        {
          "hole": 26,
          "x": 133,
          "y": 10,
          "z": 185
        },
        {
          "hole": 27,
          "x": 125.25,
          "y": 10,
          "z": 185
        },
        {
          "hole": 28,
          "x": 117.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 29,
          "x": 109.75,
          "y": 10,
          "z": 185
        },
        {
          "hole": 30,
          "x": 102,
          "y": 10,
          "z": 185
        },
        {
          "hole": 31,
          "x": 93,
          "y": 10,
          "z": 185
        },
        {
          "hole": 32,
          "x": 85.25,
          "y": 10,
          "z": 185
        },
        {
          "hole": 33,
          "x": 77.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 34,
          "x": 69.75,
          "y": 10,
          "z": 185
        },
        {
          "hole": 35,
          "x": 62,
          "y": 10,
          "z": 185
        },
        {
          "hole": 36,
          "x": 53,
          "y": 10,
          "z": 185
        },
        {
          "hole": 37,
          "x": 45.25,
          "y": 10,
          "z": 185
        },
        {
          "hole": 38,
          "x": 37.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 39,
          "x": 29.75,
          "y": 10,
          "z": 185
        },
        {
          "hole": 40,
          "x": 22,
          "y": 10,
          "z": 185
        },
        {
          "hole": 41,
          "x": 12.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 42,
          "x": 5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 43,
          "x": -7.5,
          "y": 10,
          "z": 185
        },
        {
          "hole": 44,
          "x": -7.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 45,
          "x": -7.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 46,
          "x": -7.5,
          "y": 10,
          "z": 155
        },
        {
          "hole": 47,
          "x": -7.5,
          "y": 10,
          "z": 147.5
        },
        {
          "hole": 48,
          "x": -7.5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 49,
          "x": 5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 50,
          "x": 12.5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 51,
          "x": 22.5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 52,
          "x": 30,
          "y": 10,
          "z": 135
        },
        {
          "hole": 53,
          "x": 72.5,
          "y": 10,
          "z": 135
        },
        {
          "hole": 54,
          "x": 72.5,
          "y": 10,
          "z": 92.5
        },
        {
          "hole": 55,
          "x": 72.5,
          "y": 10,
          "z": 85
        },
        {
          "hole": 56,
          "x": 72.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 57,
          "x": 72.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 58,
          "x": 72.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 59,
          "x": 30,
          "y": 10,
          "z": 25
        },
        {
          "hole": 60,
          "x": 22.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 61,
          "x": 13,
          "y": 10,
          "z": 25
        },
        {
          "hole": 62,
          "x": 5.25,
          "y": 10,
          "z": 25
        },
        {
          "hole": 63,
          "x": -2.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 64,
          "x": -10.25,
          "y": 10,
          "z": 25
        },
        {
          "hole": 65,
          "x": -18,
          "y": 10,
          "z": 25
        },
        {
          "hole": 66,
          "x": -27,
          "y": 10,
          "z": 25
        },
        {
          "hole": 67,
          "x": -34.75,
          "y": 10,
          "z": 25
        },
        {
          "hole": 68,
          "x": -42.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 69,
          "x": -50.25,
          "y": 10,
          "z": 25
        },
        {
          "hole": 70,
          "x": -58,
          "y": 10,
          "z": 25
        },
        {
          "hole": 71,
          "x": -67,
          "y": 10,
          "z": 25
        },
        {
          "hole": 72,
          "x": -74.75,
          "y": 10,
          "z": 25
        },
        {
          "hole": 73,
          "x": -82.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 74,
          "x": -90.25,
          "y": 10,
          "z": 25
        },
        {
          "hole": 75,
          "x": -98,
          "y": 10,
          "z": 25
        },
        {
          "hole": 76,
          "x": -107,
          "y": 10,
          "z": 25
        },
        {
          "hole": 77,
          "x": -114.75,
          "y": 10,
          "z": 25
        },
        {
          "hole": 78,
          "x": -122.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 79,
          "x": -130.25,
          "y": 10,
          "z": 25
        },
        {
          "hole": 80,
          "x": -138,
          "y": 10,
          "z": 25
        },
        {
          "hole": 81,
          "x": -147,
          "y": 10,
          "z": 25
        },
        {
          "hole": 82,
          "x": -154.75,
          "y": 10,
          "z": 25
        },
        {
          "hole": 83,
          "x": -162.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 84,
          "x": -170.25,
          "y": 10,
          "z": 25
        },
        {
          "hole": 85,
          "x": -178,
          "y": 10,
          "z": 25
        },
        {
          "hole": 86,
          "x": -187.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 87,
          "x": -195,
          "y": 10,
          "z": 25
        },
        {
          "hole": 88,
          "x": -237.5,
          "y": 10,
          "z": 25
        },
        {
          "hole": 89,
          "x": -237.5,
          "y": 10,
          "z": 67.5
        },
        {
          "hole": 90,
          "x": -237.5,
          "y": 10,
          "z": 75
        },
        {
          "hole": 91,
          "x": -237.5,
          "y": 10,
          "z": 84.5
        },
        {
          "hole": 92,
          "x": -237.5,
          "y": 10,
          "z": 92.25
        },
        {
          "hole": 93,
          "x": -237.5,
          "y": 10,
          "z": 100
        },
        {
          "hole": 94,
          "x": -237.5,
          "y": 10,
          "z": 107.75
        },
        {
          "hole": 95,
          "x": -237.5,
          "y": 10,
          "z": 115.5
        },
        {
          "hole": 96,
          "x": -237.5,
          "y": 10,
          "z": 124.5
        },
        {
          "hole": 97,
          "x": -237.5,
          "y": 10,
          "z": 132.25
        },
        {
          "hole": 98,
          "x": -237.5,
          "y": 10,
          "z": 140
        },
        {
          "hole": 99,
          "x": -237.5,
          "y": 10,
          "z": 147.75
        },
        {
          "hole": 100,
          "x": -237.5,
          "y": 10,
          "z": 155.5
        },
        {
          "hole": 101,
          "x": -237.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 102,
          "x": -237.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 103,
          "x": -237.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 104,
          "x": -195,
          "y": 10,
          "z": 215
        },
        {
          "hole": 105,
          "x": -187.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 106,
          "x": -178,
          "y": 10,
          "z": 215
        },
        {
          "hole": 107,
          "x": -170.25,
          "y": 10,
          "z": 215
        },
        {
          "hole": 108,
          "x": -162.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 109,
          "x": -154.75,
          "y": 10,
          "z": 215
        },
        {
          "hole": 110,
          "x": -147,
          "y": 10,
          "z": 215
        },
        {
          "hole": 111,
          "x": -137.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 112,
          "x": -130,
          "y": 10,
          "z": 215
        },
        {
          "hole": 113,
          "x": -87.5,
          "y": 10,
          "z": 215
        },
        {
          "hole": 114,
          "x": -87.5,
          "y": 10,
          "z": 172.5
        },
        {
          "hole": 115,
          "x": -87.5,
          "y": 10,
          "z": 165
        },
        {
          "hole": 116,
          "x": -87.5,
          "y": 10,
          "z": 155.5
        },
        {
          "hole": 117,
          "x": -87.5,
          "y": 10,
          "z": 147.75
        },
        {
          "hole": 118,
          "x": -87.5,
          "y": 10,
          "z": 140
        },
        {
          "hole": 119,
          "x": -87.5,
          "y": 10,
          "z": 132.25
        },
        {
          "hole": 120,
          "x": -87.5,
          "y": 10,
          "z": 124.5
        },
        {
          "hole": 121,
          "x": -102.5,
          "y": 10,
          "z": 90
        }
      ]
    }
  },
  {
    "id": "board-14",
    "name": "Board 14",
    "brand": "crazy,pints,adult",
    "desc": "3D Cribbage Board.",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/14-dimensional-thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/47004d12546aac4e/14.glb",
    "holeSpacing": 7.75,
    "cameraDefaults": {
      "fov": 44,
      "alphaDeg": 20,
      "betaDeg": 65,
      "target": [
        15,
        44,
        -12
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": -1,
          "x": 135,
          "y": 15,
          "z": 138.25
        },
        {
          "hole": 0,
          "x": 135,
          "y": 15,
          "z": 130.5
        },
        {
          "hole": 1,
          "x": 135,
          "y": 25,
          "z": 106.75
        },
        {
          "hole": 2,
          "x": 135,
          "y": 25,
          "z": 99
        },
        {
          "hole": 3,
          "x": 135,
          "y": 25,
          "z": 91.25
        },
        {
          "hole": 4,
          "x": 135,
          "y": 25,
          "z": 83.5
        },
        {
          "hole": 5,
          "x": 135,
          "y": 25,
          "z": 75.75
        },
        {
          "hole": 6,
          "x": 135,
          "y": 35,
          "z": 66.75
        },
        {
          "hole": 7,
          "x": 135,
          "y": 35,
          "z": 59
        },
        {
          "hole": 8,
          "x": 135,
          "y": 35,
          "z": 51.25
        },
        {
          "hole": 9,
          "x": 135,
          "y": 35,
          "z": 43.5
        },
        {
          "hole": 10,
          "x": 135,
          "y": 35,
          "z": 35.75
        },
        {
          "hole": 11,
          "x": 135,
          "y": 45,
          "z": 26.75
        },
        {
          "hole": 12,
          "x": 135,
          "y": 45,
          "z": 19
        },
        {
          "hole": 13,
          "x": 135,
          "y": 45,
          "z": 11.25
        },
        {
          "hole": 14,
          "x": 135,
          "y": 45,
          "z": 3.5
        },
        {
          "hole": 15,
          "x": 135,
          "y": 45,
          "z": -4.25
        },
        {
          "hole": 16,
          "x": 135,
          "y": 55,
          "z": -13.25
        },
        {
          "hole": 17,
          "x": 135,
          "y": 55,
          "z": -21
        },
        {
          "hole": 18,
          "x": 135,
          "y": 55,
          "z": -28.75
        },
        {
          "hole": 19,
          "x": 135,
          "y": 55,
          "z": -36.5
        },
        {
          "hole": 20,
          "x": 135,
          "y": 55,
          "z": -44.25
        },
        {
          "hole": 21,
          "x": 135,
          "y": 65,
          "z": -53.25
        },
        {
          "hole": 22,
          "x": 135,
          "y": 65,
          "z": -61
        },
        {
          "hole": 23,
          "x": 135,
          "y": 65,
          "z": -68.75
        },
        {
          "hole": 24,
          "x": 135,
          "y": 65,
          "z": -76.5
        },
        {
          "hole": 25,
          "x": 135,
          "y": 65,
          "z": -84.25
        },
        {
          "hole": 26,
          "x": 133.1259,
          "y": 75,
          "z": -101.735
        },
        {
          "hole": 27,
          "x": 127.6314,
          "y": 75,
          "z": -115
        },
        {
          "hole": 28,
          "x": 118.8909,
          "y": 75,
          "z": -126.3909
        },
        {
          "hole": 29,
          "x": 107.5,
          "y": 75,
          "z": -135.1314
        },
        {
          "hole": 30,
          "x": 94.235,
          "y": 75,
          "z": -140.6259
        },
        {
          "hole": 31,
          "x": 65.765,
          "y": 75,
          "z": -140.6259
        },
        {
          "hole": 32,
          "x": 52.5,
          "y": 75,
          "z": -135.1314
        },
        {
          "hole": 33,
          "x": 41.1091,
          "y": 75,
          "z": -126.3909
        },
        {
          "hole": 34,
          "x": 32.3686,
          "y": 75,
          "z": -115
        },
        {
          "hole": 35,
          "x": 26.8741,
          "y": 75,
          "z": -101.735
        },
        {
          "hole": 36,
          "x": 25,
          "y": 85,
          "z": -84.25
        },
        {
          "hole": 37,
          "x": 25,
          "y": 85,
          "z": -76.5
        },
        {
          "hole": 38,
          "x": 25,
          "y": 85,
          "z": -68.75
        },
        {
          "hole": 39,
          "x": 25,
          "y": 85,
          "z": -61
        },
        {
          "hole": 40,
          "x": 25,
          "y": 85,
          "z": -53.25
        },
        {
          "hole": 41,
          "x": 25,
          "y": 95,
          "z": -44.25
        },
        {
          "hole": 42,
          "x": 25,
          "y": 95,
          "z": -36.5
        },
        {
          "hole": 43,
          "x": 25,
          "y": 95,
          "z": -28.75
        },
        {
          "hole": 44,
          "x": 25,
          "y": 95,
          "z": -21
        },
        {
          "hole": 45,
          "x": 25,
          "y": 95,
          "z": -13.25
        },
        {
          "hole": 46,
          "x": 25,
          "y": 105,
          "z": -4.25
        },
        {
          "hole": 47,
          "x": 25,
          "y": 105,
          "z": 3.5
        },
        {
          "hole": 48,
          "x": 25,
          "y": 105,
          "z": 11.25
        },
        {
          "hole": 49,
          "x": 25,
          "y": 105,
          "z": 19
        },
        {
          "hole": 50,
          "x": 25,
          "y": 105,
          "z": 26.75
        },
        {
          "hole": 51,
          "x": 25,
          "y": 115,
          "z": 35.75
        },
        {
          "hole": 52,
          "x": 25,
          "y": 115,
          "z": 43.5
        },
        {
          "hole": 53,
          "x": 25,
          "y": 115,
          "z": 51.25
        },
        {
          "hole": 54,
          "x": 25,
          "y": 115,
          "z": 59
        },
        {
          "hole": 55,
          "x": 25,
          "y": 115,
          "z": 66.75
        },
        {
          "hole": 56,
          "x": 24.1481,
          "y": 125,
          "z": 77.7205
        },
        {
          "hole": 57,
          "x": 21.6506,
          "y": 125,
          "z": 83.75
        },
        {
          "hole": 58,
          "x": 17.6777,
          "y": 125,
          "z": 88.9277
        },
        {
          "hole": 59,
          "x": 12.5,
          "y": 125,
          "z": 92.9006
        },
        {
          "hole": 60,
          "x": 6.4705,
          "y": 125,
          "z": 95.3981
        },
        {
          "hole": 61,
          "x": -6.4705,
          "y": 125,
          "z": 95.3981
        },
        {
          "hole": 62,
          "x": -12.5,
          "y": 125,
          "z": 92.9006
        },
        {
          "hole": 63,
          "x": -17.6777,
          "y": 125,
          "z": 88.9277
        },
        {
          "hole": 64,
          "x": -21.6506,
          "y": 125,
          "z": 83.75
        },
        {
          "hole": 65,
          "x": -24.1481,
          "y": 125,
          "z": 77.7205
        },
        {
          "hole": 66,
          "x": -25,
          "y": 115,
          "z": 66.75
        },
        {
          "hole": 67,
          "x": -25,
          "y": 115,
          "z": 59
        },
        {
          "hole": 68,
          "x": -25,
          "y": 115,
          "z": 51.25
        },
        {
          "hole": 69,
          "x": -25,
          "y": 115,
          "z": 43.5
        },
        {
          "hole": 70,
          "x": -25,
          "y": 115,
          "z": 35.75
        },
        {
          "hole": 71,
          "x": -25,
          "y": 105,
          "z": 26.75
        },
        {
          "hole": 72,
          "x": -25,
          "y": 105,
          "z": 19
        },
        {
          "hole": 73,
          "x": -25,
          "y": 105,
          "z": 11.25
        },
        {
          "hole": 74,
          "x": -25,
          "y": 105,
          "z": 3.5
        },
        {
          "hole": 75,
          "x": -25,
          "y": 105,
          "z": -4.25
        },
        {
          "hole": 76,
          "x": -25,
          "y": 95,
          "z": -13.25
        },
        {
          "hole": 77,
          "x": -25,
          "y": 95,
          "z": -21
        },
        {
          "hole": 78,
          "x": -25,
          "y": 95,
          "z": -28.75
        },
        {
          "hole": 79,
          "x": -25,
          "y": 95,
          "z": -36.5
        },
        {
          "hole": 80,
          "x": -25,
          "y": 95,
          "z": -44.25
        },
        {
          "hole": 81,
          "x": -25,
          "y": 85,
          "z": -53.25
        },
        {
          "hole": 82,
          "x": -25,
          "y": 85,
          "z": -61
        },
        {
          "hole": 83,
          "x": -25,
          "y": 85,
          "z": -68.75
        },
        {
          "hole": 84,
          "x": -25,
          "y": 85,
          "z": -76.5
        },
        {
          "hole": 85,
          "x": -25,
          "y": 85,
          "z": -84.25
        },
        {
          "hole": 86,
          "x": -26.8741,
          "y": 75,
          "z": -101.735
        },
        {
          "hole": 87,
          "x": -32.3686,
          "y": 75,
          "z": -115
        },
        {
          "hole": 88,
          "x": -41.1091,
          "y": 75,
          "z": -126.3909
        },
        {
          "hole": 89,
          "x": -52.5,
          "y": 75,
          "z": -135.1314
        },
        {
          "hole": 90,
          "x": -65.765,
          "y": 75,
          "z": -140.6259
        },
        {
          "hole": 91,
          "x": -94.235,
          "y": 75,
          "z": -140.6259
        },
        {
          "hole": 92,
          "x": -107.5,
          "y": 75,
          "z": -135.1314
        },
        {
          "hole": 93,
          "x": -118.8909,
          "y": 75,
          "z": -126.3909
        },
        {
          "hole": 94,
          "x": -127.6314,
          "y": 75,
          "z": -115
        },
        {
          "hole": 95,
          "x": -133.1259,
          "y": 75,
          "z": -101.735
        },
        {
          "hole": 96,
          "x": -135,
          "y": 65,
          "z": -84.25
        },
        {
          "hole": 97,
          "x": -135,
          "y": 65,
          "z": -76.5
        },
        {
          "hole": 98,
          "x": -135,
          "y": 65,
          "z": -68.75
        },
        {
          "hole": 99,
          "x": -135,
          "y": 65,
          "z": -61
        },
        {
          "hole": 100,
          "x": -135,
          "y": 65,
          "z": -53.25
        },
        {
          "hole": 101,
          "x": -135,
          "y": 55,
          "z": -44.25
        },
        {
          "hole": 102,
          "x": -135,
          "y": 55,
          "z": -36.5
        },
        {
          "hole": 103,
          "x": -135,
          "y": 55,
          "z": -28.75
        },
        {
          "hole": 104,
          "x": -135,
          "y": 55,
          "z": -21
        },
        {
          "hole": 105,
          "x": -135,
          "y": 55,
          "z": -13.25
        },
        {
          "hole": 106,
          "x": -135,
          "y": 45,
          "z": -4.25
        },
        {
          "hole": 107,
          "x": -135,
          "y": 45,
          "z": 3.5
        },
        {
          "hole": 108,
          "x": -135,
          "y": 45,
          "z": 11.25
        },
        {
          "hole": 109,
          "x": -135,
          "y": 45,
          "z": 19
        },
        {
          "hole": 110,
          "x": -135,
          "y": 45,
          "z": 26.75
        },
        {
          "hole": 111,
          "x": -135,
          "y": 35,
          "z": 35.75
        },
        {
          "hole": 112,
          "x": -135,
          "y": 35,
          "z": 43.5
        },
        {
          "hole": 113,
          "x": -135,
          "y": 35,
          "z": 51.25
        },
        {
          "hole": 114,
          "x": -135,
          "y": 35,
          "z": 59
        },
        {
          "hole": 115,
          "x": -135,
          "y": 35,
          "z": 66.75
        },
        {
          "hole": 116,
          "x": -135,
          "y": 25,
          "z": 75.75
        },
        {
          "hole": 117,
          "x": -135,
          "y": 25,
          "z": 83.5
        },
        {
          "hole": 118,
          "x": -135,
          "y": 25,
          "z": 91.25
        },
        {
          "hole": 119,
          "x": -135,
          "y": 25,
          "z": 99
        },
        {
          "hole": 120,
          "x": -135,
          "y": 25,
          "z": 106.75
        },
        {
          "hole": 121,
          "x": -120,
          "y": 15,
          "z": 131.25
        }
      ],
      "p2": [
        {
          "hole": -1,
          "x": 125,
          "y": 15,
          "z": 138.25
        },
        {
          "hole": 0,
          "x": 125,
          "y": 15,
          "z": 130.5
        },
        {
          "hole": 1,
          "x": 125,
          "y": 25,
          "z": 106.75
        },
        {
          "hole": 2,
          "x": 125,
          "y": 25,
          "z": 99
        },
        {
          "hole": 3,
          "x": 125,
          "y": 25,
          "z": 91.25
        },
        {
          "hole": 4,
          "x": 125,
          "y": 25,
          "z": 83.5
        },
        {
          "hole": 5,
          "x": 125,
          "y": 25,
          "z": 75.75
        },
        {
          "hole": 6,
          "x": 125,
          "y": 35,
          "z": 66.75
        },
        {
          "hole": 7,
          "x": 125,
          "y": 35,
          "z": 59
        },
        {
          "hole": 8,
          "x": 125,
          "y": 35,
          "z": 51.25
        },
        {
          "hole": 9,
          "x": 125,
          "y": 35,
          "z": 43.5
        },
        {
          "hole": 10,
          "x": 125,
          "y": 35,
          "z": 35.75
        },
        {
          "hole": 11,
          "x": 125,
          "y": 45,
          "z": 26.75
        },
        {
          "hole": 12,
          "x": 125,
          "y": 45,
          "z": 19
        },
        {
          "hole": 13,
          "x": 125,
          "y": 45,
          "z": 11.25
        },
        {
          "hole": 14,
          "x": 125,
          "y": 45,
          "z": 3.5
        },
        {
          "hole": 15,
          "x": 125,
          "y": 45,
          "z": -4.25
        },
        {
          "hole": 16,
          "x": 125,
          "y": 55,
          "z": -13.25
        },
        {
          "hole": 17,
          "x": 125,
          "y": 55,
          "z": -21
        },
        {
          "hole": 18,
          "x": 125,
          "y": 55,
          "z": -28.75
        },
        {
          "hole": 19,
          "x": 125,
          "y": 55,
          "z": -36.5
        },
        {
          "hole": 20,
          "x": 125,
          "y": 55,
          "z": -44.25
        },
        {
          "hole": 21,
          "x": 125,
          "y": 65,
          "z": -53.25
        },
        {
          "hole": 22,
          "x": 125,
          "y": 65,
          "z": -61
        },
        {
          "hole": 23,
          "x": 125,
          "y": 65,
          "z": -68.75
        },
        {
          "hole": 24,
          "x": 125,
          "y": 65,
          "z": -76.5
        },
        {
          "hole": 25,
          "x": 125,
          "y": 65,
          "z": -84.25
        },
        {
          "hole": 26,
          "x": 123.4667,
          "y": 75,
          "z": -99.1469
        },
        {
          "hole": 27,
          "x": 118.9711,
          "y": 75,
          "z": -110
        },
        {
          "hole": 28,
          "x": 111.8198,
          "y": 75,
          "z": -119.3198
        },
        {
          "hole": 29,
          "x": 102.5,
          "y": 75,
          "z": -126.4711
        },
        {
          "hole": 30,
          "x": 91.6469,
          "y": 75,
          "z": -130.9667
        },
        {
          "hole": 31,
          "x": 68.3531,
          "y": 75,
          "z": -130.9667
        },
        {
          "hole": 32,
          "x": 57.5,
          "y": 75,
          "z": -126.4711
        },
        {
          "hole": 33,
          "x": 48.1802,
          "y": 75,
          "z": -119.3198
        },
        {
          "hole": 34,
          "x": 41.0289,
          "y": 75,
          "z": -110
        },
        {
          "hole": 35,
          "x": 36.5333,
          "y": 75,
          "z": -99.1469
        },
        {
          "hole": 36,
          "x": 35,
          "y": 85,
          "z": -84.25
        },
        {
          "hole": 37,
          "x": 35,
          "y": 85,
          "z": -76.5
        },
        {
          "hole": 38,
          "x": 35,
          "y": 85,
          "z": -68.75
        },
        {
          "hole": 39,
          "x": 35,
          "y": 85,
          "z": -61
        },
        {
          "hole": 40,
          "x": 35,
          "y": 85,
          "z": -53.25
        },
        {
          "hole": 41,
          "x": 35,
          "y": 95,
          "z": -44.25
        },
        {
          "hole": 42,
          "x": 35,
          "y": 95,
          "z": -36.5
        },
        {
          "hole": 43,
          "x": 35,
          "y": 95,
          "z": -28.75
        },
        {
          "hole": 44,
          "x": 35,
          "y": 95,
          "z": -21
        },
        {
          "hole": 45,
          "x": 35,
          "y": 95,
          "z": -13.25
        },
        {
          "hole": 46,
          "x": 35,
          "y": 105,
          "z": -4.25
        },
        {
          "hole": 47,
          "x": 35,
          "y": 105,
          "z": 3.5
        },
        {
          "hole": 48,
          "x": 35,
          "y": 105,
          "z": 11.25
        },
        {
          "hole": 49,
          "x": 35,
          "y": 105,
          "z": 19
        },
        {
          "hole": 50,
          "x": 35,
          "y": 105,
          "z": 26.75
        },
        {
          "hole": 51,
          "x": 35,
          "y": 115,
          "z": 35.75
        },
        {
          "hole": 52,
          "x": 35,
          "y": 115,
          "z": 43.5
        },
        {
          "hole": 53,
          "x": 35,
          "y": 115,
          "z": 51.25
        },
        {
          "hole": 54,
          "x": 35,
          "y": 115,
          "z": 59
        },
        {
          "hole": 55,
          "x": 35,
          "y": 115,
          "z": 66.75
        },
        {
          "hole": 56,
          "x": 33.8074,
          "y": 125,
          "z": 80.3087
        },
        {
          "hole": 57,
          "x": 30.3109,
          "y": 125,
          "z": 88.75
        },
        {
          "hole": 58,
          "x": 24.7487,
          "y": 125,
          "z": 95.9987
        },
        {
          "hole": 59,
          "x": 17.5,
          "y": 125,
          "z": 101.5609
        },
        {
          "hole": 60,
          "x": 9.0587,
          "y": 125,
          "z": 105.0574
        },
        {
          "hole": 61,
          "x": -9.0587,
          "y": 125,
          "z": 105.0574
        },
        {
          "hole": 62,
          "x": -17.5,
          "y": 125,
          "z": 101.5609
        },
        {
          "hole": 63,
          "x": -24.7487,
          "y": 125,
          "z": 95.9987
        },
        {
          "hole": 64,
          "x": -30.3109,
          "y": 125,
          "z": 88.75
        },
        {
          "hole": 65,
          "x": -33.8074,
          "y": 125,
          "z": 80.3087
        },
        {
          "hole": 66,
          "x": -35,
          "y": 115,
          "z": 66.75
        },
        {
          "hole": 67,
          "x": -35,
          "y": 115,
          "z": 59
        },
        {
          "hole": 68,
          "x": -35,
          "y": 115,
          "z": 51.25
        },
        {
          "hole": 69,
          "x": -35,
          "y": 115,
          "z": 43.5
        },
        {
          "hole": 70,
          "x": -35,
          "y": 115,
          "z": 35.75
        },
        {
          "hole": 71,
          "x": -35,
          "y": 105,
          "z": 26.75
        },
        {
          "hole": 72,
          "x": -35,
          "y": 105,
          "z": 19
        },
        {
          "hole": 73,
          "x": -35,
          "y": 105,
          "z": 11.25
        },
        {
          "hole": 74,
          "x": -35,
          "y": 105,
          "z": 3.5
        },
        {
          "hole": 75,
          "x": -35,
          "y": 105,
          "z": -4.25
        },
        {
          "hole": 76,
          "x": -35,
          "y": 95,
          "z": -13.25
        },
        {
          "hole": 77,
          "x": -35,
          "y": 95,
          "z": -21
        },
        {
          "hole": 78,
          "x": -35,
          "y": 95,
          "z": -28.75
        },
        {
          "hole": 79,
          "x": -35,
          "y": 95,
          "z": -36.5
        },
        {
          "hole": 80,
          "x": -35,
          "y": 95,
          "z": -44.25
        },
        {
          "hole": 81,
          "x": -35,
          "y": 85,
          "z": -53.25
        },
        {
          "hole": 82,
          "x": -35,
          "y": 85,
          "z": -61
        },
        {
          "hole": 83,
          "x": -35,
          "y": 85,
          "z": -68.75
        },
        {
          "hole": 84,
          "x": -35,
          "y": 85,
          "z": -76.5
        },
        {
          "hole": 85,
          "x": -35,
          "y": 85,
          "z": -84.25
        },
        {
          "hole": 86,
          "x": -36.5333,
          "y": 75,
          "z": -99.1469
        },
        {
          "hole": 87,
          "x": -41.0289,
          "y": 75,
          "z": -110
        },
        {
          "hole": 88,
          "x": -48.1802,
          "y": 75,
          "z": -119.3198
        },
        {
          "hole": 89,
          "x": -57.5,
          "y": 75,
          "z": -126.4711
        },
        {
          "hole": 90,
          "x": -68.3531,
          "y": 75,
          "z": -130.9667
        },
        {
          "hole": 91,
          "x": -91.6469,
          "y": 75,
          "z": -130.9667
        },
        {
          "hole": 92,
          "x": -102.5,
          "y": 75,
          "z": -126.4711
        },
        {
          "hole": 93,
          "x": -111.8198,
          "y": 75,
          "z": -119.3198
        },
        {
          "hole": 94,
          "x": -118.9711,
          "y": 75,
          "z": -110
        },
        {
          "hole": 95,
          "x": -123.4667,
          "y": 75,
          "z": -99.1469
        },
        {
          "hole": 96,
          "x": -125,
          "y": 65,
          "z": -84.25
        },
        {
          "hole": 97,
          "x": -125,
          "y": 65,
          "z": -76.5
        },
        {
          "hole": 98,
          "x": -125,
          "y": 65,
          "z": -68.75
        },
        {
          "hole": 99,
          "x": -125,
          "y": 65,
          "z": -61
        },
        {
          "hole": 100,
          "x": -125,
          "y": 65,
          "z": -53.25
        },
        {
          "hole": 101,
          "x": -125,
          "y": 55,
          "z": -44.25
        },
        {
          "hole": 102,
          "x": -125,
          "y": 55,
          "z": -36.5
        },
        {
          "hole": 103,
          "x": -125,
          "y": 55,
          "z": -28.75
        },
        {
          "hole": 104,
          "x": -125,
          "y": 55,
          "z": -21
        },
        {
          "hole": 105,
          "x": -125,
          "y": 55,
          "z": -13.25
        },
        {
          "hole": 106,
          "x": -125,
          "y": 45,
          "z": -4.25
        },
        {
          "hole": 107,
          "x": -125,
          "y": 45,
          "z": 3.5
        },
        {
          "hole": 108,
          "x": -125,
          "y": 45,
          "z": 11.25
        },
        {
          "hole": 109,
          "x": -125,
          "y": 45,
          "z": 19
        },
        {
          "hole": 110,
          "x": -125,
          "y": 45,
          "z": 26.75
        },
        {
          "hole": 111,
          "x": -125,
          "y": 35,
          "z": 35.75
        },
        {
          "hole": 112,
          "x": -125,
          "y": 35,
          "z": 43.5
        },
        {
          "hole": 113,
          "x": -125,
          "y": 35,
          "z": 51.25
        },
        {
          "hole": 114,
          "x": -125,
          "y": 35,
          "z": 59
        },
        {
          "hole": 115,
          "x": -125,
          "y": 35,
          "z": 66.75
        },
        {
          "hole": 116,
          "x": -125,
          "y": 25,
          "z": 75.75
        },
        {
          "hole": 117,
          "x": -125,
          "y": 25,
          "z": 83.5
        },
        {
          "hole": 118,
          "x": -125,
          "y": 25,
          "z": 91.25
        },
        {
          "hole": 119,
          "x": -125,
          "y": 25,
          "z": 99
        },
        {
          "hole": 120,
          "x": -125,
          "y": 25,
          "z": 106.75
        },
        {
          "hole": 121,
          "x": -120,
          "y": 15,
          "z": 131.25
        }
      ],
      "p3": [
        {
          "hole": -1,
          "x": 115,
          "y": 15,
          "z": 138.25
        },
        {
          "hole": 0,
          "x": 115,
          "y": 15,
          "z": 130.5
        },
        {
          "hole": 1,
          "x": 115,
          "y": 25,
          "z": 106.75
        },
        {
          "hole": 2,
          "x": 115,
          "y": 25,
          "z": 99
        },
        {
          "hole": 3,
          "x": 115,
          "y": 25,
          "z": 91.25
        },
        {
          "hole": 4,
          "x": 115,
          "y": 25,
          "z": 83.5
        },
        {
          "hole": 5,
          "x": 115,
          "y": 25,
          "z": 75.75
        },
        {
          "hole": 6,
          "x": 115,
          "y": 35,
          "z": 66.75
        },
        {
          "hole": 7,
          "x": 115,
          "y": 35,
          "z": 59
        },
        {
          "hole": 8,
          "x": 115,
          "y": 35,
          "z": 51.25
        },
        {
          "hole": 9,
          "x": 115,
          "y": 35,
          "z": 43.5
        },
        {
          "hole": 10,
          "x": 115,
          "y": 35,
          "z": 35.75
        },
        {
          "hole": 11,
          "x": 115,
          "y": 45,
          "z": 26.75
        },
        {
          "hole": 12,
          "x": 115,
          "y": 45,
          "z": 19
        },
        {
          "hole": 13,
          "x": 115,
          "y": 45,
          "z": 11.25
        },
        {
          "hole": 14,
          "x": 115,
          "y": 45,
          "z": 3.5
        },
        {
          "hole": 15,
          "x": 115,
          "y": 45,
          "z": -4.25
        },
        {
          "hole": 16,
          "x": 115,
          "y": 55,
          "z": -13.25
        },
        {
          "hole": 17,
          "x": 115,
          "y": 55,
          "z": -21
        },
        {
          "hole": 18,
          "x": 115,
          "y": 55,
          "z": -28.75
        },
        {
          "hole": 19,
          "x": 115,
          "y": 55,
          "z": -36.5
        },
        {
          "hole": 20,
          "x": 115,
          "y": 55,
          "z": -44.25
        },
        {
          "hole": 21,
          "x": 115,
          "y": 65,
          "z": -53.25
        },
        {
          "hole": 22,
          "x": 115,
          "y": 65,
          "z": -61
        },
        {
          "hole": 23,
          "x": 115,
          "y": 65,
          "z": -68.75
        },
        {
          "hole": 24,
          "x": 115,
          "y": 65,
          "z": -76.5
        },
        {
          "hole": 25,
          "x": 115,
          "y": 65,
          "z": -84.25
        },
        {
          "hole": 26,
          "x": 113.8074,
          "y": 75,
          "z": -96.5587
        },
        {
          "hole": 27,
          "x": 110.3109,
          "y": 75,
          "z": -105
        },
        {
          "hole": 28,
          "x": 104.7487,
          "y": 75,
          "z": -112.2487
        },
        {
          "hole": 29,
          "x": 97.5,
          "y": 75,
          "z": -117.8109
        },
        {
          "hole": 30,
          "x": 89.0587,
          "y": 75,
          "z": -121.3074
        },
        {
          "hole": 31,
          "x": 70.9413,
          "y": 75,
          "z": -121.3074
        },
        {
          "hole": 32,
          "x": 62.5,
          "y": 75,
          "z": -117.8109
        },
        {
          "hole": 33,
          "x": 55.2513,
          "y": 75,
          "z": -112.2487
        },
        {
          "hole": 34,
          "x": 49.6891,
          "y": 75,
          "z": -105
        },
        {
          "hole": 35,
          "x": 46.1926,
          "y": 75,
          "z": -96.5587
        },
        {
          "hole": 36,
          "x": 45,
          "y": 85,
          "z": -84.25
        },
        {
          "hole": 37,
          "x": 45,
          "y": 85,
          "z": -76.5
        },
        {
          "hole": 38,
          "x": 45,
          "y": 85,
          "z": -68.75
        },
        {
          "hole": 39,
          "x": 45,
          "y": 85,
          "z": -61
        },
        {
          "hole": 40,
          "x": 45,
          "y": 85,
          "z": -53.25
        },
        {
          "hole": 41,
          "x": 45,
          "y": 95,
          "z": -44.25
        },
        {
          "hole": 42,
          "x": 45,
          "y": 95,
          "z": -36.5
        },
        {
          "hole": 43,
          "x": 45,
          "y": 95,
          "z": -28.75
        },
        {
          "hole": 44,
          "x": 45,
          "y": 95,
          "z": -21
        },
        {
          "hole": 45,
          "x": 45,
          "y": 95,
          "z": -13.25
        },
        {
          "hole": 46,
          "x": 45,
          "y": 105,
          "z": -4.25
        },
        {
          "hole": 47,
          "x": 45,
          "y": 105,
          "z": 3.5
        },
        {
          "hole": 48,
          "x": 45,
          "y": 105,
          "z": 11.25
        },
        {
          "hole": 49,
          "x": 45,
          "y": 105,
          "z": 19
        },
        {
          "hole": 50,
          "x": 45,
          "y": 105,
          "z": 26.75
        },
        {
          "hole": 51,
          "x": 45,
          "y": 115,
          "z": 35.75
        },
        {
          "hole": 52,
          "x": 45,
          "y": 115,
          "z": 43.5
        },
        {
          "hole": 53,
          "x": 45,
          "y": 115,
          "z": 51.25
        },
        {
          "hole": 54,
          "x": 45,
          "y": 115,
          "z": 59
        },
        {
          "hole": 55,
          "x": 45,
          "y": 115,
          "z": 66.75
        },
        {
          "hole": 56,
          "x": 43.4667,
          "y": 125,
          "z": 82.8969
        },
        {
          "hole": 57,
          "x": 38.9711,
          "y": 125,
          "z": 93.75
        },
        {
          "hole": 58,
          "x": 31.8198,
          "y": 125,
          "z": 103.0698
        },
        {
          "hole": 59,
          "x": 22.5,
          "y": 125,
          "z": 110.2211
        },
        {
          "hole": 60,
          "x": 11.6469,
          "y": 125,
          "z": 114.7167
        },
        {
          "hole": 61,
          "x": -11.6469,
          "y": 125,
          "z": 114.7167
        },
        {
          "hole": 62,
          "x": -22.5,
          "y": 125,
          "z": 110.2211
        },
        {
          "hole": 63,
          "x": -31.8198,
          "y": 125,
          "z": 103.0698
        },
        {
          "hole": 64,
          "x": -38.9711,
          "y": 125,
          "z": 93.75
        },
        {
          "hole": 65,
          "x": -43.4667,
          "y": 125,
          "z": 82.8969
        },
        {
          "hole": 66,
          "x": -45,
          "y": 115,
          "z": 66.75
        },
        {
          "hole": 67,
          "x": -45,
          "y": 115,
          "z": 59
        },
        {
          "hole": 68,
          "x": -45,
          "y": 115,
          "z": 51.25
        },
        {
          "hole": 69,
          "x": -45,
          "y": 115,
          "z": 43.5
        },
        {
          "hole": 70,
          "x": -45,
          "y": 115,
          "z": 35.75
        },
        {
          "hole": 71,
          "x": -45,
          "y": 105,
          "z": 26.75
        },
        {
          "hole": 72,
          "x": -45,
          "y": 105,
          "z": 19
        },
        {
          "hole": 73,
          "x": -45,
          "y": 105,
          "z": 11.25
        },
        {
          "hole": 74,
          "x": -45,
          "y": 105,
          "z": 3.5
        },
        {
          "hole": 75,
          "x": -45,
          "y": 105,
          "z": -4.25
        },
        {
          "hole": 76,
          "x": -45,
          "y": 95,
          "z": -13.25
        },
        {
          "hole": 77,
          "x": -45,
          "y": 95,
          "z": -21
        },
        {
          "hole": 78,
          "x": -45,
          "y": 95,
          "z": -28.75
        },
        {
          "hole": 79,
          "x": -45,
          "y": 95,
          "z": -36.5
        },
        {
          "hole": 80,
          "x": -45,
          "y": 95,
          "z": -44.25
        },
        {
          "hole": 81,
          "x": -45,
          "y": 85,
          "z": -53.25
        },
        {
          "hole": 82,
          "x": -45,
          "y": 85,
          "z": -61
        },
        {
          "hole": 83,
          "x": -45,
          "y": 85,
          "z": -68.75
        },
        {
          "hole": 84,
          "x": -45,
          "y": 85,
          "z": -76.5
        },
        {
          "hole": 85,
          "x": -45,
          "y": 85,
          "z": -84.25
        },
        {
          "hole": 86,
          "x": -46.1926,
          "y": 75,
          "z": -96.5587
        },
        {
          "hole": 87,
          "x": -49.6891,
          "y": 75,
          "z": -105
        },
        {
          "hole": 88,
          "x": -55.2513,
          "y": 75,
          "z": -112.2487
        },
        {
          "hole": 89,
          "x": -62.5,
          "y": 75,
          "z": -117.8109
        },
        {
          "hole": 90,
          "x": -70.9413,
          "y": 75,
          "z": -121.3074
        },
        {
          "hole": 91,
          "x": -89.0587,
          "y": 75,
          "z": -121.3074
        },
        {
          "hole": 92,
          "x": -97.5,
          "y": 75,
          "z": -117.8109
        },
        {
          "hole": 93,
          "x": -104.7487,
          "y": 75,
          "z": -112.2487
        },
        {
          "hole": 94,
          "x": -110.3109,
          "y": 75,
          "z": -105
        },
        {
          "hole": 95,
          "x": -113.8074,
          "y": 75,
          "z": -96.5587
        },
        {
          "hole": 96,
          "x": -115,
          "y": 65,
          "z": -84.25
        },
        {
          "hole": 97,
          "x": -115,
          "y": 65,
          "z": -76.5
        },
        {
          "hole": 98,
          "x": -115,
          "y": 65,
          "z": -68.75
        },
        {
          "hole": 99,
          "x": -115,
          "y": 65,
          "z": -61
        },
        {
          "hole": 100,
          "x": -115,
          "y": 65,
          "z": -53.25
        },
        {
          "hole": 101,
          "x": -115,
          "y": 55,
          "z": -44.25
        },
        {
          "hole": 102,
          "x": -115,
          "y": 55,
          "z": -36.5
        },
        {
          "hole": 103,
          "x": -115,
          "y": 55,
          "z": -28.75
        },
        {
          "hole": 104,
          "x": -115,
          "y": 55,
          "z": -21
        },
        {
          "hole": 105,
          "x": -115,
          "y": 55,
          "z": -13.25
        },
        {
          "hole": 106,
          "x": -115,
          "y": 45,
          "z": -4.25
        },
        {
          "hole": 107,
          "x": -115,
          "y": 45,
          "z": 3.5
        },
        {
          "hole": 108,
          "x": -115,
          "y": 45,
          "z": 11.25
        },
        {
          "hole": 109,
          "x": -115,
          "y": 45,
          "z": 19
        },
        {
          "hole": 110,
          "x": -115,
          "y": 45,
          "z": 26.75
        },
        {
          "hole": 111,
          "x": -115,
          "y": 35,
          "z": 35.75
        },
        {
          "hole": 112,
          "x": -115,
          "y": 35,
          "z": 43.5
        },
        {
          "hole": 113,
          "x": -115,
          "y": 35,
          "z": 51.25
        },
        {
          "hole": 114,
          "x": -115,
          "y": 35,
          "z": 59
        },
        {
          "hole": 115,
          "x": -115,
          "y": 35,
          "z": 66.75
        },
        {
          "hole": 116,
          "x": -115,
          "y": 25,
          "z": 75.75
        },
        {
          "hole": 117,
          "x": -115,
          "y": 25,
          "z": 83.5
        },
        {
          "hole": 118,
          "x": -115,
          "y": 25,
          "z": 91.25
        },
        {
          "hole": 119,
          "x": -115,
          "y": 25,
          "z": 99
        },
        {
          "hole": 120,
          "x": -115,
          "y": 25,
          "z": 106.75
        },
        {
          "hole": 121,
          "x": -120,
          "y": 15,
          "z": 131.25
        }
      ],
      "p4": [
        {
          "hole": -1,
          "x": 105,
          "y": 15,
          "z": 138.25
        },
        {
          "hole": 0,
          "x": 105,
          "y": 15,
          "z": 130.5
        },
        {
          "hole": 1,
          "x": 105,
          "y": 25,
          "z": 106.75
        },
        {
          "hole": 2,
          "x": 105,
          "y": 25,
          "z": 99
        },
        {
          "hole": 3,
          "x": 105,
          "y": 25,
          "z": 91.25
        },
        {
          "hole": 4,
          "x": 105,
          "y": 25,
          "z": 83.5
        },
        {
          "hole": 5,
          "x": 105,
          "y": 25,
          "z": 75.75
        },
        {
          "hole": 6,
          "x": 105,
          "y": 35,
          "z": 66.75
        },
        {
          "hole": 7,
          "x": 105,
          "y": 35,
          "z": 59
        },
        {
          "hole": 8,
          "x": 105,
          "y": 35,
          "z": 51.25
        },
        {
          "hole": 9,
          "x": 105,
          "y": 35,
          "z": 43.5
        },
        {
          "hole": 10,
          "x": 105,
          "y": 35,
          "z": 35.75
        },
        {
          "hole": 11,
          "x": 105,
          "y": 45,
          "z": 26.75
        },
        {
          "hole": 12,
          "x": 105,
          "y": 45,
          "z": 19
        },
        {
          "hole": 13,
          "x": 105,
          "y": 45,
          "z": 11.25
        },
        {
          "hole": 14,
          "x": 105,
          "y": 45,
          "z": 3.5
        },
        {
          "hole": 15,
          "x": 105,
          "y": 45,
          "z": -4.25
        },
        {
          "hole": 16,
          "x": 105,
          "y": 55,
          "z": -13.25
        },
        {
          "hole": 17,
          "x": 105,
          "y": 55,
          "z": -21
        },
        {
          "hole": 18,
          "x": 105,
          "y": 55,
          "z": -28.75
        },
        {
          "hole": 19,
          "x": 105,
          "y": 55,
          "z": -36.5
        },
        {
          "hole": 20,
          "x": 105,
          "y": 55,
          "z": -44.25
        },
        {
          "hole": 21,
          "x": 105,
          "y": 65,
          "z": -53.25
        },
        {
          "hole": 22,
          "x": 105,
          "y": 65,
          "z": -61
        },
        {
          "hole": 23,
          "x": 105,
          "y": 65,
          "z": -68.75
        },
        {
          "hole": 24,
          "x": 105,
          "y": 65,
          "z": -76.5
        },
        {
          "hole": 25,
          "x": 105,
          "y": 65,
          "z": -84.25
        },
        {
          "hole": 26,
          "x": 104.1481,
          "y": 75,
          "z": -93.9705
        },
        {
          "hole": 27,
          "x": 101.6506,
          "y": 75,
          "z": -100
        },
        {
          "hole": 28,
          "x": 97.6777,
          "y": 75,
          "z": -105.1777
        },
        {
          "hole": 29,
          "x": 92.5,
          "y": 75,
          "z": -109.1506
        },
        {
          "hole": 30,
          "x": 86.4705,
          "y": 75,
          "z": -111.6481
        },
        {
          "hole": 31,
          "x": 73.5295,
          "y": 75,
          "z": -111.6481
        },
        {
          "hole": 32,
          "x": 67.5,
          "y": 75,
          "z": -109.1506
        },
        {
          "hole": 33,
          "x": 62.3223,
          "y": 75,
          "z": -105.1777
        },
        {
          "hole": 34,
          "x": 58.3494,
          "y": 75,
          "z": -100
        },
        {
          "hole": 35,
          "x": 55.8519,
          "y": 75,
          "z": -93.9705
        },
        {
          "hole": 36,
          "x": 55,
          "y": 85,
          "z": -84.25
        },
        {
          "hole": 37,
          "x": 55,
          "y": 85,
          "z": -76.5
        },
        {
          "hole": 38,
          "x": 55,
          "y": 85,
          "z": -68.75
        },
        {
          "hole": 39,
          "x": 55,
          "y": 85,
          "z": -61
        },
        {
          "hole": 40,
          "x": 55,
          "y": 85,
          "z": -53.25
        },
        {
          "hole": 41,
          "x": 55,
          "y": 95,
          "z": -44.25
        },
        {
          "hole": 42,
          "x": 55,
          "y": 95,
          "z": -36.5
        },
        {
          "hole": 43,
          "x": 55,
          "y": 95,
          "z": -28.75
        },
        {
          "hole": 44,
          "x": 55,
          "y": 95,
          "z": -21
        },
        {
          "hole": 45,
          "x": 55,
          "y": 95,
          "z": -13.25
        },
        {
          "hole": 46,
          "x": 55,
          "y": 105,
          "z": -4.25
        },
        {
          "hole": 47,
          "x": 55,
          "y": 105,
          "z": 3.5
        },
        {
          "hole": 48,
          "x": 55,
          "y": 105,
          "z": 11.25
        },
        {
          "hole": 49,
          "x": 55,
          "y": 105,
          "z": 19
        },
        {
          "hole": 50,
          "x": 55,
          "y": 105,
          "z": 26.75
        },
        {
          "hole": 51,
          "x": 55,
          "y": 115,
          "z": 35.75
        },
        {
          "hole": 52,
          "x": 55,
          "y": 115,
          "z": 43.5
        },
        {
          "hole": 53,
          "x": 55,
          "y": 115,
          "z": 51.25
        },
        {
          "hole": 54,
          "x": 55,
          "y": 115,
          "z": 59
        },
        {
          "hole": 55,
          "x": 55,
          "y": 115,
          "z": 66.75
        },
        {
          "hole": 56,
          "x": 53.1259,
          "y": 125,
          "z": 85.485
        },
        {
          "hole": 57,
          "x": 47.6314,
          "y": 125,
          "z": 98.75
        },
        {
          "hole": 58,
          "x": 38.8909,
          "y": 125,
          "z": 110.1409
        },
        {
          "hole": 59,
          "x": 27.5,
          "y": 125,
          "z": 118.8814
        },
        {
          "hole": 60,
          "x": 14.235,
          "y": 125,
          "z": 124.3759
        },
        {
          "hole": 61,
          "x": -14.235,
          "y": 125,
          "z": 124.3759
        },
        {
          "hole": 62,
          "x": -27.5,
          "y": 125,
          "z": 118.8814
        },
        {
          "hole": 63,
          "x": -38.8909,
          "y": 125,
          "z": 110.1409
        },
        {
          "hole": 64,
          "x": -47.6314,
          "y": 125,
          "z": 98.75
        },
        {
          "hole": 65,
          "x": -53.1259,
          "y": 125,
          "z": 85.485
        },
        {
          "hole": 66,
          "x": -55,
          "y": 115,
          "z": 66.75
        },
        {
          "hole": 67,
          "x": -55,
          "y": 115,
          "z": 59
        },
        {
          "hole": 68,
          "x": -55,
          "y": 115,
          "z": 51.25
        },
        {
          "hole": 69,
          "x": -55,
          "y": 115,
          "z": 43.5
        },
        {
          "hole": 70,
          "x": -55,
          "y": 115,
          "z": 35.75
        },
        {
          "hole": 71,
          "x": -55,
          "y": 105,
          "z": 26.75
        },
        {
          "hole": 72,
          "x": -55,
          "y": 105,
          "z": 19
        },
        {
          "hole": 73,
          "x": -55,
          "y": 105,
          "z": 11.25
        },
        {
          "hole": 74,
          "x": -55,
          "y": 105,
          "z": 3.5
        },
        {
          "hole": 75,
          "x": -55,
          "y": 105,
          "z": -4.25
        },
        {
          "hole": 76,
          "x": -55,
          "y": 95,
          "z": -13.25
        },
        {
          "hole": 77,
          "x": -55,
          "y": 95,
          "z": -21
        },
        {
          "hole": 78,
          "x": -55,
          "y": 95,
          "z": -28.75
        },
        {
          "hole": 79,
          "x": -55,
          "y": 95,
          "z": -36.5
        },
        {
          "hole": 80,
          "x": -55,
          "y": 95,
          "z": -44.25
        },
        {
          "hole": 81,
          "x": -55,
          "y": 85,
          "z": -53.25
        },
        {
          "hole": 82,
          "x": -55,
          "y": 85,
          "z": -61
        },
        {
          "hole": 83,
          "x": -55,
          "y": 85,
          "z": -68.75
        },
        {
          "hole": 84,
          "x": -55,
          "y": 85,
          "z": -76.5
        },
        {
          "hole": 85,
          "x": -55,
          "y": 85,
          "z": -84.25
        },
        {
          "hole": 86,
          "x": -55.8519,
          "y": 75,
          "z": -93.9705
        },
        {
          "hole": 87,
          "x": -58.3494,
          "y": 75,
          "z": -100
        },
        {
          "hole": 88,
          "x": -62.3223,
          "y": 75,
          "z": -105.1777
        },
        {
          "hole": 89,
          "x": -67.5,
          "y": 75,
          "z": -109.1506
        },
        {
          "hole": 90,
          "x": -73.5295,
          "y": 75,
          "z": -111.6481
        },
        {
          "hole": 91,
          "x": -86.4705,
          "y": 75,
          "z": -111.6481
        },
        {
          "hole": 92,
          "x": -92.5,
          "y": 75,
          "z": -109.1506
        },
        {
          "hole": 93,
          "x": -97.6777,
          "y": 75,
          "z": -105.1777
        },
        {
          "hole": 94,
          "x": -101.6506,
          "y": 75,
          "z": -100
        },
        {
          "hole": 95,
          "x": -104.1481,
          "y": 75,
          "z": -93.9705
        },
        {
          "hole": 96,
          "x": -105,
          "y": 65,
          "z": -84.25
        },
        {
          "hole": 97,
          "x": -105,
          "y": 65,
          "z": -76.5
        },
        {
          "hole": 98,
          "x": -105,
          "y": 65,
          "z": -68.75
        },
        {
          "hole": 99,
          "x": -105,
          "y": 65,
          "z": -61
        },
        {
          "hole": 100,
          "x": -105,
          "y": 65,
          "z": -53.25
        },
        {
          "hole": 101,
          "x": -105,
          "y": 55,
          "z": -44.25
        },
        {
          "hole": 102,
          "x": -105,
          "y": 55,
          "z": -36.5
        },
        {
          "hole": 103,
          "x": -105,
          "y": 55,
          "z": -28.75
        },
        {
          "hole": 104,
          "x": -105,
          "y": 55,
          "z": -21
        },
        {
          "hole": 105,
          "x": -105,
          "y": 55,
          "z": -13.25
        },
        {
          "hole": 106,
          "x": -105,
          "y": 45,
          "z": -4.25
        },
        {
          "hole": 107,
          "x": -105,
          "y": 45,
          "z": 3.5
        },
        {
          "hole": 108,
          "x": -105,
          "y": 45,
          "z": 11.25
        },
        {
          "hole": 109,
          "x": -105,
          "y": 45,
          "z": 19
        },
        {
          "hole": 110,
          "x": -105,
          "y": 45,
          "z": 26.75
        },
        {
          "hole": 111,
          "x": -105,
          "y": 35,
          "z": 35.75
        },
        {
          "hole": 112,
          "x": -105,
          "y": 35,
          "z": 43.5
        },
        {
          "hole": 113,
          "x": -105,
          "y": 35,
          "z": 51.25
        },
        {
          "hole": 114,
          "x": -105,
          "y": 35,
          "z": 59
        },
        {
          "hole": 115,
          "x": -105,
          "y": 35,
          "z": 66.75
        },
        {
          "hole": 116,
          "x": -105,
          "y": 25,
          "z": 75.75
        },
        {
          "hole": 117,
          "x": -105,
          "y": 25,
          "z": 83.5
        },
        {
          "hole": 118,
          "x": -105,
          "y": 25,
          "z": 91.25
        },
        {
          "hole": 119,
          "x": -105,
          "y": 25,
          "z": 99
        },
        {
          "hole": 120,
          "x": -105,
          "y": 25,
          "z": 106.75
        },
        {
          "hole": 121,
          "x": -120,
          "y": 15,
          "z": 131.25
        }
      ]
    }
  },
  {
    "id": "board-standard",
    "name": "Standard",
    "brand": "crazy,pints,adult",
    "desc": "Standard 3D cribbage board.",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/standard-thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/24aee48aaf03fae0/standard.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 75,
          "y": 5,
          "z": 187
        },
        {
          "hole": 1,
          "x": 75,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 2,
          "x": 75,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 3,
          "x": 75,
          "y": 5,
          "z": 140
        },
        {
          "hole": 4,
          "x": 75,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 5,
          "x": 75,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 6,
          "x": 75,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 7,
          "x": 75,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 8,
          "x": 75,
          "y": 5,
          "z": 100
        },
        {
          "hole": 9,
          "x": 75,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 10,
          "x": 75,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 11,
          "x": 75,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 12,
          "x": 75,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 13,
          "x": 75,
          "y": 5,
          "z": 60
        },
        {
          "hole": 14,
          "x": 75,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 15,
          "x": 75,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 16,
          "x": 75,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 17,
          "x": 75,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 18,
          "x": 75,
          "y": 5,
          "z": 20
        },
        {
          "hole": 19,
          "x": 75,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 20,
          "x": 75,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 21,
          "x": 75,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 22,
          "x": 75,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 23,
          "x": 75,
          "y": 5,
          "z": -20
        },
        {
          "hole": 24,
          "x": 75,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 25,
          "x": 75,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 26,
          "x": 75,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 27,
          "x": 75,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 28,
          "x": 75,
          "y": 5,
          "z": -60
        },
        {
          "hole": 29,
          "x": 75,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 30,
          "x": 75,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 31,
          "x": 75,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 32,
          "x": 75,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 33,
          "x": 75,
          "y": 5,
          "z": -100
        },
        {
          "hole": 34,
          "x": 75,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 35,
          "x": 75,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 36,
          "x": 71.763,
          "y": 5,
          "z": -144.5878
        },
        {
          "hole": 37,
          "x": 62.2724,
          "y": 5,
          "z": -167.5
        },
        {
          "hole": 38,
          "x": 47.1751,
          "y": 5,
          "z": -187.1751
        },
        {
          "hole": 39,
          "x": 27.5,
          "y": 5,
          "z": -202.2724
        },
        {
          "hole": 40,
          "x": 4.5878,
          "y": 5,
          "z": -211.763
        },
        {
          "hole": 41,
          "x": -44.5878,
          "y": 5,
          "z": -211.763
        },
        {
          "hole": 42,
          "x": -67.5,
          "y": 5,
          "z": -202.2724
        },
        {
          "hole": 43,
          "x": -87.1751,
          "y": 5,
          "z": -187.1751
        },
        {
          "hole": 44,
          "x": -102.2724,
          "y": 5,
          "z": -167.5
        },
        {
          "hole": 45,
          "x": -111.763,
          "y": 5,
          "z": -144.5878
        },
        {
          "hole": 46,
          "x": -115,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 47,
          "x": -115,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 48,
          "x": -115,
          "y": 5,
          "z": -100
        },
        {
          "hole": 49,
          "x": -115,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 50,
          "x": -115,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 51,
          "x": -115,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 52,
          "x": -115,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 53,
          "x": -115,
          "y": 5,
          "z": -60
        },
        {
          "hole": 54,
          "x": -115,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 55,
          "x": -115,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 56,
          "x": -115,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 57,
          "x": -115,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 58,
          "x": -115,
          "y": 5,
          "z": -20
        },
        {
          "hole": 59,
          "x": -115,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 60,
          "x": -115,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 61,
          "x": -115,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 62,
          "x": -115,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 63,
          "x": -115,
          "y": 5,
          "z": 20
        },
        {
          "hole": 64,
          "x": -115,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 65,
          "x": -115,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 66,
          "x": -115,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 67,
          "x": -115,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 68,
          "x": -115,
          "y": 5,
          "z": 60
        },
        {
          "hole": 69,
          "x": -115,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 70,
          "x": -115,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 71,
          "x": -115,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 72,
          "x": -115,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 73,
          "x": -115,
          "y": 5,
          "z": 100
        },
        {
          "hole": 74,
          "x": -115,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 75,
          "x": -115,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 76,
          "x": -115,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 77,
          "x": -115,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 78,
          "x": -115,
          "y": 5,
          "z": 140
        },
        {
          "hole": 79,
          "x": -115,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 80,
          "x": -115,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 81,
          "x": -107.6314,
          "y": 5,
          "z": 187.5
        },
        {
          "hole": 82,
          "x": -87.5,
          "y": 5,
          "z": 207.6314
        },
        {
          "hole": 83,
          "x": -60,
          "y": 5,
          "z": 215
        },
        {
          "hole": 84,
          "x": -32.5,
          "y": 5,
          "z": 207.6314
        },
        {
          "hole": 85,
          "x": -12.3686,
          "y": 5,
          "z": 187.5
        },
        {
          "hole": 86,
          "x": -5,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 87,
          "x": -5,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 88,
          "x": -5,
          "y": 5,
          "z": 140
        },
        {
          "hole": 89,
          "x": -5,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 90,
          "x": -5,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 91,
          "x": -5,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 92,
          "x": -5,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 93,
          "x": -5,
          "y": 5,
          "z": 100
        },
        {
          "hole": 94,
          "x": -5,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 95,
          "x": -5,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 96,
          "x": -5,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 97,
          "x": -5,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 98,
          "x": -5,
          "y": 5,
          "z": 60
        },
        {
          "hole": 99,
          "x": -5,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 100,
          "x": -5,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 101,
          "x": -5,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 102,
          "x": -5,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 103,
          "x": -5,
          "y": 5,
          "z": 20
        },
        {
          "hole": 104,
          "x": -5,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 105,
          "x": -5,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 106,
          "x": -5,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 107,
          "x": -5,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 108,
          "x": -5,
          "y": 5,
          "z": -20
        },
        {
          "hole": 109,
          "x": -5,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 110,
          "x": -5,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 111,
          "x": -5,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 112,
          "x": -5,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 113,
          "x": -5,
          "y": 5,
          "z": -60
        },
        {
          "hole": 114,
          "x": -5,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 115,
          "x": -5,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 116,
          "x": -5,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 117,
          "x": -5,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 118,
          "x": -5,
          "y": 5,
          "z": -100
        },
        {
          "hole": 119,
          "x": -5,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 120,
          "x": -5,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 121,
          "x": -20,
          "y": 5,
          "z": -140
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 65,
          "y": 5,
          "z": 187
        },
        {
          "hole": 1,
          "x": 65,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 2,
          "x": 65,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 3,
          "x": 65,
          "y": 5,
          "z": 140
        },
        {
          "hole": 4,
          "x": 65,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 5,
          "x": 65,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 6,
          "x": 65,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 7,
          "x": 65,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 8,
          "x": 65,
          "y": 5,
          "z": 100
        },
        {
          "hole": 9,
          "x": 65,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 10,
          "x": 65,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 11,
          "x": 65,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 12,
          "x": 65,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 13,
          "x": 65,
          "y": 5,
          "z": 60
        },
        {
          "hole": 14,
          "x": 65,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 15,
          "x": 65,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 16,
          "x": 65,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 17,
          "x": 65,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 18,
          "x": 65,
          "y": 5,
          "z": 20
        },
        {
          "hole": 19,
          "x": 65,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 20,
          "x": 65,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 21,
          "x": 65,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 22,
          "x": 65,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 23,
          "x": 65,
          "y": 5,
          "z": -20
        },
        {
          "hole": 24,
          "x": 65,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 25,
          "x": 65,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 26,
          "x": 65,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 27,
          "x": 65,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 28,
          "x": 65,
          "y": 5,
          "z": -60
        },
        {
          "hole": 29,
          "x": 65,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 30,
          "x": 65,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 31,
          "x": 65,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 32,
          "x": 65,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 33,
          "x": 65,
          "y": 5,
          "z": -100
        },
        {
          "hole": 34,
          "x": 65,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 35,
          "x": 65,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 36,
          "x": 62.1037,
          "y": 5,
          "z": -141.9996
        },
        {
          "hole": 37,
          "x": 53.6122,
          "y": 5,
          "z": -162.5
        },
        {
          "hole": 38,
          "x": 40.1041,
          "y": 5,
          "z": -180.1041
        },
        {
          "hole": 39,
          "x": 22.5,
          "y": 5,
          "z": -193.6122
        },
        {
          "hole": 40,
          "x": 1.9996,
          "y": 5,
          "z": -202.1037
        },
        {
          "hole": 41,
          "x": -41.9996,
          "y": 5,
          "z": -202.1037
        },
        {
          "hole": 42,
          "x": -62.5,
          "y": 5,
          "z": -193.6122
        },
        {
          "hole": 43,
          "x": -80.1041,
          "y": 5,
          "z": -180.1041
        },
        {
          "hole": 44,
          "x": -93.6122,
          "y": 5,
          "z": -162.5
        },
        {
          "hole": 45,
          "x": -102.1037,
          "y": 5,
          "z": -141.9996
        },
        {
          "hole": 46,
          "x": -105,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 47,
          "x": -105,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 48,
          "x": -105,
          "y": 5,
          "z": -100
        },
        {
          "hole": 49,
          "x": -105,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 50,
          "x": -105,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 51,
          "x": -105,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 52,
          "x": -105,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 53,
          "x": -105,
          "y": 5,
          "z": -60
        },
        {
          "hole": 54,
          "x": -105,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 55,
          "x": -105,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 56,
          "x": -105,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 57,
          "x": -105,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 58,
          "x": -105,
          "y": 5,
          "z": -20
        },
        {
          "hole": 59,
          "x": -105,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 60,
          "x": -105,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 61,
          "x": -105,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 62,
          "x": -105,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 63,
          "x": -105,
          "y": 5,
          "z": 20
        },
        {
          "hole": 64,
          "x": -105,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 65,
          "x": -105,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 66,
          "x": -105,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 67,
          "x": -105,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 68,
          "x": -105,
          "y": 5,
          "z": 60
        },
        {
          "hole": 69,
          "x": -105,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 70,
          "x": -105,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 71,
          "x": -105,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 72,
          "x": -105,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 73,
          "x": -105,
          "y": 5,
          "z": 100
        },
        {
          "hole": 74,
          "x": -105,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 75,
          "x": -105,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 76,
          "x": -105,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 77,
          "x": -105,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 78,
          "x": -105,
          "y": 5,
          "z": 140
        },
        {
          "hole": 79,
          "x": -105,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 80,
          "x": -105,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 81,
          "x": -98.9711,
          "y": 5,
          "z": 182.5
        },
        {
          "hole": 82,
          "x": -82.5,
          "y": 5,
          "z": 198.9711
        },
        {
          "hole": 83,
          "x": -60,
          "y": 5,
          "z": 205
        },
        {
          "hole": 84,
          "x": -37.5,
          "y": 5,
          "z": 198.9711
        },
        {
          "hole": 85,
          "x": -21.0289,
          "y": 5,
          "z": 182.5
        },
        {
          "hole": 86,
          "x": -15,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 87,
          "x": -15,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 88,
          "x": -15,
          "y": 5,
          "z": 140
        },
        {
          "hole": 89,
          "x": -15,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 90,
          "x": -15,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 91,
          "x": -15,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 92,
          "x": -15,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 93,
          "x": -15,
          "y": 5,
          "z": 100
        },
        {
          "hole": 94,
          "x": -15,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 95,
          "x": -15,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 96,
          "x": -15,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 97,
          "x": -15,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 98,
          "x": -15,
          "y": 5,
          "z": 60
        },
        {
          "hole": 99,
          "x": -15,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 100,
          "x": -15,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 101,
          "x": -15,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 102,
          "x": -15,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 103,
          "x": -15,
          "y": 5,
          "z": 20
        },
        {
          "hole": 104,
          "x": -15,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 105,
          "x": -15,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 106,
          "x": -15,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 107,
          "x": -15,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 108,
          "x": -15,
          "y": 5,
          "z": -20
        },
        {
          "hole": 109,
          "x": -15,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 110,
          "x": -15,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 111,
          "x": -15,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 112,
          "x": -15,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 113,
          "x": -15,
          "y": 5,
          "z": -60
        },
        {
          "hole": 114,
          "x": -15,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 115,
          "x": -15,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 116,
          "x": -15,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 117,
          "x": -15,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 118,
          "x": -15,
          "y": 5,
          "z": -100
        },
        {
          "hole": 119,
          "x": -15,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 120,
          "x": -15,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 121,
          "x": -20,
          "y": 5,
          "z": -140
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": 55,
          "y": 5,
          "z": 187
        },
        {
          "hole": 1,
          "x": 55,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 2,
          "x": 55,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 3,
          "x": 55,
          "y": 5,
          "z": 140
        },
        {
          "hole": 4,
          "x": 55,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 5,
          "x": 55,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 6,
          "x": 55,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 7,
          "x": 55,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 8,
          "x": 55,
          "y": 5,
          "z": 100
        },
        {
          "hole": 9,
          "x": 55,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 10,
          "x": 55,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 11,
          "x": 55,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 12,
          "x": 55,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 13,
          "x": 55,
          "y": 5,
          "z": 60
        },
        {
          "hole": 14,
          "x": 55,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 15,
          "x": 55,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 16,
          "x": 55,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 17,
          "x": 55,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 18,
          "x": 55,
          "y": 5,
          "z": 20
        },
        {
          "hole": 19,
          "x": 55,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 20,
          "x": 55,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 21,
          "x": 55,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 22,
          "x": 55,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 23,
          "x": 55,
          "y": 5,
          "z": -20
        },
        {
          "hole": 24,
          "x": 55,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 25,
          "x": 55,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 26,
          "x": 55,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 27,
          "x": 55,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 28,
          "x": 55,
          "y": 5,
          "z": -60
        },
        {
          "hole": 29,
          "x": 55,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 30,
          "x": 55,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 31,
          "x": 55,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 32,
          "x": 55,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 33,
          "x": 55,
          "y": 5,
          "z": -100
        },
        {
          "hole": 34,
          "x": 55,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 35,
          "x": 55,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 36,
          "x": 52.4444,
          "y": 5,
          "z": -139.4114
        },
        {
          "hole": 37,
          "x": 44.9519,
          "y": 5,
          "z": -157.5
        },
        {
          "hole": 38,
          "x": 33.033,
          "y": 5,
          "z": -173.033
        },
        {
          "hole": 39,
          "x": 17.5,
          "y": 5,
          "z": -184.9519
        },
        {
          "hole": 40,
          "x": -0.5886,
          "y": 5,
          "z": -192.4444
        },
        {
          "hole": 41,
          "x": -39.4114,
          "y": 5,
          "z": -192.4444
        },
        {
          "hole": 42,
          "x": -57.5,
          "y": 5,
          "z": -184.9519
        },
        {
          "hole": 43,
          "x": -73.033,
          "y": 5,
          "z": -173.033
        },
        {
          "hole": 44,
          "x": -84.9519,
          "y": 5,
          "z": -157.5
        },
        {
          "hole": 45,
          "x": -92.4444,
          "y": 5,
          "z": -139.4114
        },
        {
          "hole": 46,
          "x": -95,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 47,
          "x": -95,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 48,
          "x": -95,
          "y": 5,
          "z": -100
        },
        {
          "hole": 49,
          "x": -95,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 50,
          "x": -95,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 51,
          "x": -95,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 52,
          "x": -95,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 53,
          "x": -95,
          "y": 5,
          "z": -60
        },
        {
          "hole": 54,
          "x": -95,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 55,
          "x": -95,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 56,
          "x": -95,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 57,
          "x": -95,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 58,
          "x": -95,
          "y": 5,
          "z": -20
        },
        {
          "hole": 59,
          "x": -95,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 60,
          "x": -95,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 61,
          "x": -95,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 62,
          "x": -95,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 63,
          "x": -95,
          "y": 5,
          "z": 20
        },
        {
          "hole": 64,
          "x": -95,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 65,
          "x": -95,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 66,
          "x": -95,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 67,
          "x": -95,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 68,
          "x": -95,
          "y": 5,
          "z": 60
        },
        {
          "hole": 69,
          "x": -95,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 70,
          "x": -95,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 71,
          "x": -95,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 72,
          "x": -95,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 73,
          "x": -95,
          "y": 5,
          "z": 100
        },
        {
          "hole": 74,
          "x": -95,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 75,
          "x": -95,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 76,
          "x": -95,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 77,
          "x": -95,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 78,
          "x": -95,
          "y": 5,
          "z": 140
        },
        {
          "hole": 79,
          "x": -95,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 80,
          "x": -95,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 81,
          "x": -90.3109,
          "y": 5,
          "z": 177.5
        },
        {
          "hole": 82,
          "x": -77.5,
          "y": 5,
          "z": 190.3109
        },
        {
          "hole": 83,
          "x": -60,
          "y": 5,
          "z": 195
        },
        {
          "hole": 84,
          "x": -42.5,
          "y": 5,
          "z": 190.3109
        },
        {
          "hole": 85,
          "x": -29.6891,
          "y": 5,
          "z": 177.5
        },
        {
          "hole": 86,
          "x": -25,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 87,
          "x": -25,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 88,
          "x": -25,
          "y": 5,
          "z": 140
        },
        {
          "hole": 89,
          "x": -25,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 90,
          "x": -25,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 91,
          "x": -25,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 92,
          "x": -25,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 93,
          "x": -25,
          "y": 5,
          "z": 100
        },
        {
          "hole": 94,
          "x": -25,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 95,
          "x": -25,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 96,
          "x": -25,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 97,
          "x": -25,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 98,
          "x": -25,
          "y": 5,
          "z": 60
        },
        {
          "hole": 99,
          "x": -25,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 100,
          "x": -25,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 101,
          "x": -25,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 102,
          "x": -25,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 103,
          "x": -25,
          "y": 5,
          "z": 20
        },
        {
          "hole": 104,
          "x": -25,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 105,
          "x": -25,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 106,
          "x": -25,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 107,
          "x": -25,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 108,
          "x": -25,
          "y": 5,
          "z": -20
        },
        {
          "hole": 109,
          "x": -25,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 110,
          "x": -25,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 111,
          "x": -25,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 112,
          "x": -25,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 113,
          "x": -25,
          "y": 5,
          "z": -60
        },
        {
          "hole": 114,
          "x": -25,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 115,
          "x": -25,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 116,
          "x": -25,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 117,
          "x": -25,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 118,
          "x": -25,
          "y": 5,
          "z": -100
        },
        {
          "hole": 119,
          "x": -25,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 120,
          "x": -25,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 121,
          "x": -20,
          "y": 5,
          "z": -140
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": 45,
          "y": 5,
          "z": 187
        },
        {
          "hole": 1,
          "x": 45,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 2,
          "x": 45,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 3,
          "x": 45,
          "y": 5,
          "z": 140
        },
        {
          "hole": 4,
          "x": 45,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 5,
          "x": 45,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 6,
          "x": 45,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 7,
          "x": 45,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 8,
          "x": 45,
          "y": 5,
          "z": 100
        },
        {
          "hole": 9,
          "x": 45,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 10,
          "x": 45,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 11,
          "x": 45,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 12,
          "x": 45,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 13,
          "x": 45,
          "y": 5,
          "z": 60
        },
        {
          "hole": 14,
          "x": 45,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 15,
          "x": 45,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 16,
          "x": 45,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 17,
          "x": 45,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 18,
          "x": 45,
          "y": 5,
          "z": 20
        },
        {
          "hole": 19,
          "x": 45,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 20,
          "x": 45,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 21,
          "x": 45,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 22,
          "x": 45,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 23,
          "x": 45,
          "y": 5,
          "z": -20
        },
        {
          "hole": 24,
          "x": 45,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 25,
          "x": 45,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 26,
          "x": 45,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 27,
          "x": 45,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 28,
          "x": 45,
          "y": 5,
          "z": -60
        },
        {
          "hole": 29,
          "x": 45,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 30,
          "x": 45,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 31,
          "x": 45,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 32,
          "x": 45,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 33,
          "x": 45,
          "y": 5,
          "z": -100
        },
        {
          "hole": 34,
          "x": 45,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 35,
          "x": 45,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 36,
          "x": 42.7852,
          "y": 5,
          "z": -136.8232
        },
        {
          "hole": 37,
          "x": 36.2917,
          "y": 5,
          "z": -152.5
        },
        {
          "hole": 38,
          "x": 25.9619,
          "y": 5,
          "z": -165.9619
        },
        {
          "hole": 39,
          "x": 12.5,
          "y": 5,
          "z": -176.2917
        },
        {
          "hole": 40,
          "x": -3.1768,
          "y": 5,
          "z": -182.7852
        },
        {
          "hole": 41,
          "x": -36.8232,
          "y": 5,
          "z": -182.7852
        },
        {
          "hole": 42,
          "x": -52.5,
          "y": 5,
          "z": -176.2917
        },
        {
          "hole": 43,
          "x": -65.9619,
          "y": 5,
          "z": -165.9619
        },
        {
          "hole": 44,
          "x": -76.2917,
          "y": 5,
          "z": -152.5
        },
        {
          "hole": 45,
          "x": -82.7852,
          "y": 5,
          "z": -136.8232
        },
        {
          "hole": 46,
          "x": -85,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 47,
          "x": -85,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 48,
          "x": -85,
          "y": 5,
          "z": -100
        },
        {
          "hole": 49,
          "x": -85,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 50,
          "x": -85,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 51,
          "x": -85,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 52,
          "x": -85,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 53,
          "x": -85,
          "y": 5,
          "z": -60
        },
        {
          "hole": 54,
          "x": -85,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 55,
          "x": -85,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 56,
          "x": -85,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 57,
          "x": -85,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 58,
          "x": -85,
          "y": 5,
          "z": -20
        },
        {
          "hole": 59,
          "x": -85,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 60,
          "x": -85,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 61,
          "x": -85,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 62,
          "x": -85,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 63,
          "x": -85,
          "y": 5,
          "z": 20
        },
        {
          "hole": 64,
          "x": -85,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 65,
          "x": -85,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 66,
          "x": -85,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 67,
          "x": -85,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 68,
          "x": -85,
          "y": 5,
          "z": 60
        },
        {
          "hole": 69,
          "x": -85,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 70,
          "x": -85,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 71,
          "x": -85,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 72,
          "x": -85,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 73,
          "x": -85,
          "y": 5,
          "z": 100
        },
        {
          "hole": 74,
          "x": -85,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 75,
          "x": -85,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 76,
          "x": -85,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 77,
          "x": -85,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 78,
          "x": -85,
          "y": 5,
          "z": 140
        },
        {
          "hole": 79,
          "x": -85,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 80,
          "x": -85,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 81,
          "x": -81.6506,
          "y": 5,
          "z": 172.5
        },
        {
          "hole": 82,
          "x": -72.5,
          "y": 5,
          "z": 181.6506
        },
        {
          "hole": 83,
          "x": -60,
          "y": 5,
          "z": 185
        },
        {
          "hole": 84,
          "x": -47.5,
          "y": 5,
          "z": 181.6506
        },
        {
          "hole": 85,
          "x": -38.3494,
          "y": 5,
          "z": 172.5
        },
        {
          "hole": 86,
          "x": -35,
          "y": 5,
          "z": 155.5
        },
        {
          "hole": 87,
          "x": -35,
          "y": 5,
          "z": 147.75
        },
        {
          "hole": 88,
          "x": -35,
          "y": 5,
          "z": 140
        },
        {
          "hole": 89,
          "x": -35,
          "y": 5,
          "z": 132.25
        },
        {
          "hole": 90,
          "x": -35,
          "y": 5,
          "z": 124.5
        },
        {
          "hole": 91,
          "x": -35,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 92,
          "x": -35,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 93,
          "x": -35,
          "y": 5,
          "z": 100
        },
        {
          "hole": 94,
          "x": -35,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 95,
          "x": -35,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 96,
          "x": -35,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 97,
          "x": -35,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 98,
          "x": -35,
          "y": 5,
          "z": 60
        },
        {
          "hole": 99,
          "x": -35,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 100,
          "x": -35,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 101,
          "x": -35,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 102,
          "x": -35,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 103,
          "x": -35,
          "y": 5,
          "z": 20
        },
        {
          "hole": 104,
          "x": -35,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 105,
          "x": -35,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 106,
          "x": -35,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 107,
          "x": -35,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 108,
          "x": -35,
          "y": 5,
          "z": -20
        },
        {
          "hole": 109,
          "x": -35,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 110,
          "x": -35,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 111,
          "x": -35,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 112,
          "x": -35,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 113,
          "x": -35,
          "y": 5,
          "z": -60
        },
        {
          "hole": 114,
          "x": -35,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 115,
          "x": -35,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 116,
          "x": -35,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 117,
          "x": -35,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 118,
          "x": -35,
          "y": 5,
          "z": -100
        },
        {
          "hole": 119,
          "x": -35,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 120,
          "x": -35,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 121,
          "x": -20,
          "y": 5,
          "z": -140
        }
      ]
    }
  },
  {
    "id": "board-dimensional-tracks",
    "name": "Dimensional Tracks",
    "brand": "crazy,pints,adult",
    "desc": "Dimensional Tracks 3D cribbage board.",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/dimensional-tracks-thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/9b27f0e46bfcdc6e/dimensional-tracks.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": -47,
          "y": 5,
          "z": -105
        },
        {
          "hole": 1,
          "x": -64.5,
          "y": 5,
          "z": -105
        },
        {
          "hole": 2,
          "x": -72.25,
          "y": 5,
          "z": -105
        },
        {
          "hole": 3,
          "x": -80,
          "y": 5,
          "z": -105
        },
        {
          "hole": 4,
          "x": -87.75,
          "y": 5,
          "z": -105
        },
        {
          "hole": 5,
          "x": -95.5,
          "y": 5,
          "z": -105
        },
        {
          "hole": 6,
          "x": -106.4705,
          "y": 15,
          "z": -104.1481
        },
        {
          "hole": 7,
          "x": -112.5,
          "y": 15,
          "z": -101.6506
        },
        {
          "hole": 8,
          "x": -117.6777,
          "y": 15,
          "z": -97.6777
        },
        {
          "hole": 9,
          "x": -121.6506,
          "y": 15,
          "z": -92.5
        },
        {
          "hole": 10,
          "x": -124.1481,
          "y": 15,
          "z": -86.4705
        },
        {
          "hole": 11,
          "x": -124.1481,
          "y": 25,
          "z": -73.5295
        },
        {
          "hole": 12,
          "x": -121.6506,
          "y": 25,
          "z": -67.5
        },
        {
          "hole": 13,
          "x": -117.6777,
          "y": 25,
          "z": -62.3223
        },
        {
          "hole": 14,
          "x": -112.5,
          "y": 25,
          "z": -58.3494
        },
        {
          "hole": 15,
          "x": -106.4705,
          "y": 25,
          "z": -55.8519
        },
        {
          "hole": 16,
          "x": -95.5,
          "y": 35,
          "z": -55
        },
        {
          "hole": 17,
          "x": -87.75,
          "y": 35,
          "z": -55
        },
        {
          "hole": 18,
          "x": -80,
          "y": 35,
          "z": -55
        },
        {
          "hole": 19,
          "x": -72.25,
          "y": 35,
          "z": -55
        },
        {
          "hole": 20,
          "x": -64.5,
          "y": 35,
          "z": -55
        },
        {
          "hole": 21,
          "x": -45.765,
          "y": 45,
          "z": -53.1259
        },
        {
          "hole": 22,
          "x": -32.5,
          "y": 45,
          "z": -47.6314
        },
        {
          "hole": 23,
          "x": -21.1091,
          "y": 45,
          "z": -38.8909
        },
        {
          "hole": 24,
          "x": -12.3686,
          "y": 45,
          "z": -27.5
        },
        {
          "hole": 25,
          "x": -6.8741,
          "y": 45,
          "z": -14.235
        },
        {
          "hole": 26,
          "x": -6.8741,
          "y": 45,
          "z": 14.235
        },
        {
          "hole": 27,
          "x": -12.3686,
          "y": 45,
          "z": 27.5
        },
        {
          "hole": 28,
          "x": -21.1091,
          "y": 45,
          "z": 38.8909
        },
        {
          "hole": 29,
          "x": -32.5,
          "y": 45,
          "z": 47.6314
        },
        {
          "hole": 30,
          "x": -45.765,
          "y": 45,
          "z": 53.1259
        },
        {
          "hole": 31,
          "x": -64.5,
          "y": 35,
          "z": 55
        },
        {
          "hole": 32,
          "x": -72.25,
          "y": 35,
          "z": 55
        },
        {
          "hole": 33,
          "x": -80,
          "y": 35,
          "z": 55
        },
        {
          "hole": 34,
          "x": -87.75,
          "y": 35,
          "z": 55
        },
        {
          "hole": 35,
          "x": -95.5,
          "y": 35,
          "z": 55
        },
        {
          "hole": 36,
          "x": -106.4705,
          "y": 25,
          "z": 55.8519
        },
        {
          "hole": 37,
          "x": -112.5,
          "y": 25,
          "z": 58.3494
        },
        {
          "hole": 38,
          "x": -117.6777,
          "y": 25,
          "z": 62.3223
        },
        {
          "hole": 39,
          "x": -121.6506,
          "y": 25,
          "z": 67.5
        },
        {
          "hole": 40,
          "x": -124.1481,
          "y": 25,
          "z": 73.5295
        },
        {
          "hole": 41,
          "x": -124.1481,
          "y": 15,
          "z": 86.4705
        },
        {
          "hole": 42,
          "x": -121.6506,
          "y": 15,
          "z": 92.5
        },
        {
          "hole": 43,
          "x": -117.6777,
          "y": 15,
          "z": 97.6777
        },
        {
          "hole": 44,
          "x": -112.5,
          "y": 15,
          "z": 101.6506
        },
        {
          "hole": 45,
          "x": -106.4705,
          "y": 15,
          "z": 104.1481
        },
        {
          "hole": 46,
          "x": -95.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 47,
          "x": -87.75,
          "y": 5,
          "z": 105
        },
        {
          "hole": 48,
          "x": -80,
          "y": 5,
          "z": 105
        },
        {
          "hole": 49,
          "x": -72.25,
          "y": 5,
          "z": 105
        },
        {
          "hole": 50,
          "x": -64.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 51,
          "x": -55.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 52,
          "x": -47.75,
          "y": 5,
          "z": 105
        },
        {
          "hole": 53,
          "x": -40,
          "y": 5,
          "z": 105
        },
        {
          "hole": 54,
          "x": -32.25,
          "y": 5,
          "z": 105
        },
        {
          "hole": 55,
          "x": -24.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 56,
          "x": -15.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 57,
          "x": -7.75,
          "y": 5,
          "z": 105
        },
        {
          "hole": 58,
          "x": 0,
          "y": 5,
          "z": 105
        },
        {
          "hole": 59,
          "x": 7.75,
          "y": 5,
          "z": 105
        },
        {
          "hole": 60,
          "x": 15.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 61,
          "x": 24.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 62,
          "x": 32.25,
          "y": 5,
          "z": 105
        },
        {
          "hole": 63,
          "x": 40,
          "y": 5,
          "z": 105
        },
        {
          "hole": 64,
          "x": 47.75,
          "y": 5,
          "z": 105
        },
        {
          "hole": 65,
          "x": 55.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 66,
          "x": 64.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 67,
          "x": 72.25,
          "y": 5,
          "z": 105
        },
        {
          "hole": 68,
          "x": 80,
          "y": 5,
          "z": 105
        },
        {
          "hole": 69,
          "x": 87.75,
          "y": 5,
          "z": 105
        },
        {
          "hole": 70,
          "x": 95.5,
          "y": 5,
          "z": 105
        },
        {
          "hole": 71,
          "x": 106.4705,
          "y": 15,
          "z": 104.1481
        },
        {
          "hole": 72,
          "x": 112.5,
          "y": 15,
          "z": 101.6506
        },
        {
          "hole": 73,
          "x": 117.6777,
          "y": 15,
          "z": 97.6777
        },
        {
          "hole": 74,
          "x": 121.6506,
          "y": 15,
          "z": 92.5
        },
        {
          "hole": 75,
          "x": 124.1481,
          "y": 15,
          "z": 86.4705
        },
        {
          "hole": 76,
          "x": 124.1481,
          "y": 25,
          "z": 73.5295
        },
        {
          "hole": 77,
          "x": 121.6506,
          "y": 25,
          "z": 67.5
        },
        {
          "hole": 78,
          "x": 117.6777,
          "y": 25,
          "z": 62.3223
        },
        {
          "hole": 79,
          "x": 112.5,
          "y": 25,
          "z": 58.3494
        },
        {
          "hole": 80,
          "x": 106.4705,
          "y": 25,
          "z": 55.8519
        },
        {
          "hole": 81,
          "x": 95.5,
          "y": 35,
          "z": 55
        },
        {
          "hole": 82,
          "x": 87.75,
          "y": 35,
          "z": 55
        },
        {
          "hole": 83,
          "x": 80,
          "y": 35,
          "z": 55
        },
        {
          "hole": 84,
          "x": 72.25,
          "y": 35,
          "z": 55
        },
        {
          "hole": 85,
          "x": 64.5,
          "y": 35,
          "z": 55
        },
        {
          "hole": 86,
          "x": 45.765,
          "y": 45,
          "z": 53.1259
        },
        {
          "hole": 87,
          "x": 32.5,
          "y": 45,
          "z": 47.6314
        },
        {
          "hole": 88,
          "x": 21.1091,
          "y": 45,
          "z": 38.8909
        },
        {
          "hole": 89,
          "x": 12.3686,
          "y": 45,
          "z": 27.5
        },
        {
          "hole": 90,
          "x": 6.8741,
          "y": 45,
          "z": 14.235
        },
        {
          "hole": 91,
          "x": 6.8741,
          "y": 45,
          "z": -14.235
        },
        {
          "hole": 92,
          "x": 12.3686,
          "y": 45,
          "z": -27.5
        },
        {
          "hole": 93,
          "x": 21.1091,
          "y": 45,
          "z": -38.8909
        },
        {
          "hole": 94,
          "x": 32.5,
          "y": 45,
          "z": -47.6314
        },
        {
          "hole": 95,
          "x": 45.765,
          "y": 45,
          "z": -53.1259
        },
        {
          "hole": 96,
          "x": 64.5,
          "y": 35,
          "z": -55
        },
        {
          "hole": 97,
          "x": 72.25,
          "y": 35,
          "z": -55
        },
        {
          "hole": 98,
          "x": 80,
          "y": 35,
          "z": -55
        },
        {
          "hole": 99,
          "x": 87.75,
          "y": 35,
          "z": -55
        },
        {
          "hole": 100,
          "x": 95.5,
          "y": 35,
          "z": -55
        },
        {
          "hole": 101,
          "x": 106.4705,
          "y": 25,
          "z": -55.8519
        },
        {
          "hole": 102,
          "x": 112.5,
          "y": 25,
          "z": -58.3494
        },
        {
          "hole": 103,
          "x": 117.6777,
          "y": 25,
          "z": -62.3223
        },
        {
          "hole": 104,
          "x": 121.6506,
          "y": 25,
          "z": -67.5
        },
        {
          "hole": 105,
          "x": 124.1481,
          "y": 25,
          "z": -73.5295
        },
        {
          "hole": 106,
          "x": 124.1481,
          "y": 15,
          "z": -86.4705
        },
        {
          "hole": 107,
          "x": 121.6506,
          "y": 15,
          "z": -92.5
        },
        {
          "hole": 108,
          "x": 117.6777,
          "y": 15,
          "z": -97.6777
        },
        {
          "hole": 109,
          "x": 112.5,
          "y": 15,
          "z": -101.6506
        },
        {
          "hole": 110,
          "x": 106.4705,
          "y": 15,
          "z": -104.1481
        },
        {
          "hole": 111,
          "x": 95.5,
          "y": 5,
          "z": -105
        },
        {
          "hole": 112,
          "x": 87.75,
          "y": 5,
          "z": -105
        },
        {
          "hole": 113,
          "x": 80,
          "y": 5,
          "z": -105
        },
        {
          "hole": 114,
          "x": 72.25,
          "y": 5,
          "z": -105
        },
        {
          "hole": 115,
          "x": 64.5,
          "y": 5,
          "z": -105
        },
        {
          "hole": 116,
          "x": 55.5,
          "y": 5,
          "z": -105
        },
        {
          "hole": 117,
          "x": 47.75,
          "y": 5,
          "z": -105
        },
        {
          "hole": 118,
          "x": 40,
          "y": 5,
          "z": -105
        },
        {
          "hole": 119,
          "x": 32.25,
          "y": 5,
          "z": -105
        },
        {
          "hole": 120,
          "x": 24.5,
          "y": 5,
          "z": -105
        },
        {
          "hole": 121,
          "x": 0,
          "y": 5,
          "z": -120
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": -47,
          "y": 5,
          "z": -115
        },
        {
          "hole": 1,
          "x": -64.5,
          "y": 5,
          "z": -115
        },
        {
          "hole": 2,
          "x": -72.25,
          "y": 5,
          "z": -115
        },
        {
          "hole": 3,
          "x": -80,
          "y": 5,
          "z": -115
        },
        {
          "hole": 4,
          "x": -87.75,
          "y": 5,
          "z": -115
        },
        {
          "hole": 5,
          "x": -95.5,
          "y": 5,
          "z": -115
        },
        {
          "hole": 6,
          "x": -109.0587,
          "y": 15,
          "z": -113.8074
        },
        {
          "hole": 7,
          "x": -117.5,
          "y": 15,
          "z": -110.3109
        },
        {
          "hole": 8,
          "x": -124.7487,
          "y": 15,
          "z": -104.7487
        },
        {
          "hole": 9,
          "x": -130.3109,
          "y": 15,
          "z": -97.5
        },
        {
          "hole": 10,
          "x": -133.8074,
          "y": 15,
          "z": -89.0587
        },
        {
          "hole": 11,
          "x": -133.8074,
          "y": 25,
          "z": -70.9413
        },
        {
          "hole": 12,
          "x": -130.3109,
          "y": 25,
          "z": -62.5
        },
        {
          "hole": 13,
          "x": -124.7487,
          "y": 25,
          "z": -55.2513
        },
        {
          "hole": 14,
          "x": -117.5,
          "y": 25,
          "z": -49.6891
        },
        {
          "hole": 15,
          "x": -109.0587,
          "y": 25,
          "z": -46.1926
        },
        {
          "hole": 16,
          "x": -95.5,
          "y": 35,
          "z": -45
        },
        {
          "hole": 17,
          "x": -87.75,
          "y": 35,
          "z": -45
        },
        {
          "hole": 18,
          "x": -80,
          "y": 35,
          "z": -45
        },
        {
          "hole": 19,
          "x": -72.25,
          "y": 35,
          "z": -45
        },
        {
          "hole": 20,
          "x": -64.5,
          "y": 35,
          "z": -45
        },
        {
          "hole": 21,
          "x": -48.3531,
          "y": 45,
          "z": -43.4667
        },
        {
          "hole": 22,
          "x": -37.5,
          "y": 45,
          "z": -38.9711
        },
        {
          "hole": 23,
          "x": -28.1802,
          "y": 45,
          "z": -31.8198
        },
        {
          "hole": 24,
          "x": -21.0289,
          "y": 45,
          "z": -22.5
        },
        {
          "hole": 25,
          "x": -16.5333,
          "y": 45,
          "z": -11.6469
        },
        {
          "hole": 26,
          "x": -16.5333,
          "y": 45,
          "z": 11.6469
        },
        {
          "hole": 27,
          "x": -21.0289,
          "y": 45,
          "z": 22.5
        },
        {
          "hole": 28,
          "x": -28.1802,
          "y": 45,
          "z": 31.8198
        },
        {
          "hole": 29,
          "x": -37.5,
          "y": 45,
          "z": 38.9711
        },
        {
          "hole": 30,
          "x": -48.3531,
          "y": 45,
          "z": 43.4667
        },
        {
          "hole": 31,
          "x": -64.5,
          "y": 35,
          "z": 45
        },
        {
          "hole": 32,
          "x": -72.25,
          "y": 35,
          "z": 45
        },
        {
          "hole": 33,
          "x": -80,
          "y": 35,
          "z": 45
        },
        {
          "hole": 34,
          "x": -87.75,
          "y": 35,
          "z": 45
        },
        {
          "hole": 35,
          "x": -95.5,
          "y": 35,
          "z": 45
        },
        {
          "hole": 36,
          "x": -109.0587,
          "y": 25,
          "z": 46.1926
        },
        {
          "hole": 37,
          "x": -117.5,
          "y": 25,
          "z": 49.6891
        },
        {
          "hole": 38,
          "x": -124.7487,
          "y": 25,
          "z": 55.2513
        },
        {
          "hole": 39,
          "x": -130.3109,
          "y": 25,
          "z": 62.5
        },
        {
          "hole": 40,
          "x": -133.8074,
          "y": 25,
          "z": 70.9413
        },
        {
          "hole": 41,
          "x": -133.8074,
          "y": 15,
          "z": 89.0587
        },
        {
          "hole": 42,
          "x": -130.3109,
          "y": 15,
          "z": 97.5
        },
        {
          "hole": 43,
          "x": -124.7487,
          "y": 15,
          "z": 104.7487
        },
        {
          "hole": 44,
          "x": -117.5,
          "y": 15,
          "z": 110.3109
        },
        {
          "hole": 45,
          "x": -109.0587,
          "y": 15,
          "z": 113.8074
        },
        {
          "hole": 46,
          "x": -95.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 47,
          "x": -87.75,
          "y": 5,
          "z": 115
        },
        {
          "hole": 48,
          "x": -80,
          "y": 5,
          "z": 115
        },
        {
          "hole": 49,
          "x": -72.25,
          "y": 5,
          "z": 115
        },
        {
          "hole": 50,
          "x": -64.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 51,
          "x": -55.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 52,
          "x": -47.75,
          "y": 5,
          "z": 115
        },
        {
          "hole": 53,
          "x": -40,
          "y": 5,
          "z": 115
        },
        {
          "hole": 54,
          "x": -32.25,
          "y": 5,
          "z": 115
        },
        {
          "hole": 55,
          "x": -24.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 56,
          "x": -15.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 57,
          "x": -7.75,
          "y": 5,
          "z": 115
        },
        {
          "hole": 58,
          "x": 0,
          "y": 5,
          "z": 115
        },
        {
          "hole": 59,
          "x": 7.75,
          "y": 5,
          "z": 115
        },
        {
          "hole": 60,
          "x": 15.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 61,
          "x": 24.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 62,
          "x": 32.25,
          "y": 5,
          "z": 115
        },
        {
          "hole": 63,
          "x": 40,
          "y": 5,
          "z": 115
        },
        {
          "hole": 64,
          "x": 47.75,
          "y": 5,
          "z": 115
        },
        {
          "hole": 65,
          "x": 55.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 66,
          "x": 64.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 67,
          "x": 72.25,
          "y": 5,
          "z": 115
        },
        {
          "hole": 68,
          "x": 80,
          "y": 5,
          "z": 115
        },
        {
          "hole": 69,
          "x": 87.75,
          "y": 5,
          "z": 115
        },
        {
          "hole": 70,
          "x": 95.5,
          "y": 5,
          "z": 115
        },
        {
          "hole": 71,
          "x": 109.0587,
          "y": 15,
          "z": 113.8074
        },
        {
          "hole": 72,
          "x": 117.5,
          "y": 15,
          "z": 110.3109
        },
        {
          "hole": 73,
          "x": 124.7487,
          "y": 15,
          "z": 104.7487
        },
        {
          "hole": 74,
          "x": 130.3109,
          "y": 15,
          "z": 97.5
        },
        {
          "hole": 75,
          "x": 133.8074,
          "y": 15,
          "z": 89.0587
        },
        {
          "hole": 76,
          "x": 133.8074,
          "y": 25,
          "z": 70.9413
        },
        {
          "hole": 77,
          "x": 130.3109,
          "y": 25,
          "z": 62.5
        },
        {
          "hole": 78,
          "x": 124.7487,
          "y": 25,
          "z": 55.2513
        },
        {
          "hole": 79,
          "x": 117.5,
          "y": 25,
          "z": 49.6891
        },
        {
          "hole": 80,
          "x": 109.0587,
          "y": 25,
          "z": 46.1926
        },
        {
          "hole": 81,
          "x": 95.5,
          "y": 35,
          "z": 45
        },
        {
          "hole": 82,
          "x": 87.75,
          "y": 35,
          "z": 45
        },
        {
          "hole": 83,
          "x": 80,
          "y": 35,
          "z": 45
        },
        {
          "hole": 84,
          "x": 72.25,
          "y": 35,
          "z": 45
        },
        {
          "hole": 85,
          "x": 64.5,
          "y": 35,
          "z": 45
        },
        {
          "hole": 86,
          "x": 48.3531,
          "y": 45,
          "z": 43.4667
        },
        {
          "hole": 87,
          "x": 37.5,
          "y": 45,
          "z": 38.9711
        },
        {
          "hole": 88,
          "x": 28.1802,
          "y": 45,
          "z": 31.8198
        },
        {
          "hole": 89,
          "x": 21.0289,
          "y": 45,
          "z": 22.5
        },
        {
          "hole": 90,
          "x": 16.5333,
          "y": 45,
          "z": 11.6469
        },
        {
          "hole": 91,
          "x": 16.5333,
          "y": 45,
          "z": -11.6469
        },
        {
          "hole": 92,
          "x": 21.0289,
          "y": 45,
          "z": -22.5
        },
        {
          "hole": 93,
          "x": 28.1802,
          "y": 45,
          "z": -31.8198
        },
        {
          "hole": 94,
          "x": 37.5,
          "y": 45,
          "z": -38.9711
        },
        {
          "hole": 95,
          "x": 48.3531,
          "y": 45,
          "z": -43.4667
        },
        {
          "hole": 96,
          "x": 64.5,
          "y": 35,
          "z": -45
        },
        {
          "hole": 97,
          "x": 72.25,
          "y": 35,
          "z": -45
        },
        {
          "hole": 98,
          "x": 80,
          "y": 35,
          "z": -45
        },
        {
          "hole": 99,
          "x": 87.75,
          "y": 35,
          "z": -45
        },
        {
          "hole": 100,
          "x": 95.5,
          "y": 35,
          "z": -45
        },
        {
          "hole": 101,
          "x": 109.0587,
          "y": 25,
          "z": -46.1926
        },
        {
          "hole": 102,
          "x": 117.5,
          "y": 25,
          "z": -49.6891
        },
        {
          "hole": 103,
          "x": 124.7487,
          "y": 25,
          "z": -55.2513
        },
        {
          "hole": 104,
          "x": 130.3109,
          "y": 25,
          "z": -62.5
        },
        {
          "hole": 105,
          "x": 133.8074,
          "y": 25,
          "z": -70.9413
        },
        {
          "hole": 106,
          "x": 133.8074,
          "y": 15,
          "z": -89.0587
        },
        {
          "hole": 107,
          "x": 130.3109,
          "y": 15,
          "z": -97.5
        },
        {
          "hole": 108,
          "x": 124.7487,
          "y": 15,
          "z": -104.7487
        },
        {
          "hole": 109,
          "x": 117.5,
          "y": 15,
          "z": -110.3109
        },
        {
          "hole": 110,
          "x": 109.0587,
          "y": 15,
          "z": -113.8074
        },
        {
          "hole": 111,
          "x": 95.5,
          "y": 5,
          "z": -115
        },
        {
          "hole": 112,
          "x": 87.75,
          "y": 5,
          "z": -115
        },
        {
          "hole": 113,
          "x": 80,
          "y": 5,
          "z": -115
        },
        {
          "hole": 114,
          "x": 72.25,
          "y": 5,
          "z": -115
        },
        {
          "hole": 115,
          "x": 64.5,
          "y": 5,
          "z": -115
        },
        {
          "hole": 116,
          "x": 55.5,
          "y": 5,
          "z": -115
        },
        {
          "hole": 117,
          "x": 47.75,
          "y": 5,
          "z": -115
        },
        {
          "hole": 118,
          "x": 40,
          "y": 5,
          "z": -115
        },
        {
          "hole": 119,
          "x": 32.25,
          "y": 5,
          "z": -115
        },
        {
          "hole": 120,
          "x": 24.5,
          "y": 5,
          "z": -115
        },
        {
          "hole": 121,
          "x": 0,
          "y": 5,
          "z": -120
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": -47,
          "y": 5,
          "z": -125
        },
        {
          "hole": 1,
          "x": -64.5,
          "y": 5,
          "z": -125
        },
        {
          "hole": 2,
          "x": -72.25,
          "y": 5,
          "z": -125
        },
        {
          "hole": 3,
          "x": -80,
          "y": 5,
          "z": -125
        },
        {
          "hole": 4,
          "x": -87.75,
          "y": 5,
          "z": -125
        },
        {
          "hole": 5,
          "x": -95.5,
          "y": 5,
          "z": -125
        },
        {
          "hole": 6,
          "x": -111.6469,
          "y": 15,
          "z": -123.4667
        },
        {
          "hole": 7,
          "x": -122.5,
          "y": 15,
          "z": -118.9711
        },
        {
          "hole": 8,
          "x": -131.8198,
          "y": 15,
          "z": -111.8198
        },
        {
          "hole": 9,
          "x": -138.9711,
          "y": 15,
          "z": -102.5
        },
        {
          "hole": 10,
          "x": -143.4667,
          "y": 15,
          "z": -91.6469
        },
        {
          "hole": 11,
          "x": -143.4667,
          "y": 25,
          "z": -68.3531
        },
        {
          "hole": 12,
          "x": -138.9711,
          "y": 25,
          "z": -57.5
        },
        {
          "hole": 13,
          "x": -131.8198,
          "y": 25,
          "z": -48.1802
        },
        {
          "hole": 14,
          "x": -122.5,
          "y": 25,
          "z": -41.0289
        },
        {
          "hole": 15,
          "x": -111.6469,
          "y": 25,
          "z": -36.5333
        },
        {
          "hole": 16,
          "x": -95.5,
          "y": 35,
          "z": -35
        },
        {
          "hole": 17,
          "x": -87.75,
          "y": 35,
          "z": -35
        },
        {
          "hole": 18,
          "x": -80,
          "y": 35,
          "z": -35
        },
        {
          "hole": 19,
          "x": -72.25,
          "y": 35,
          "z": -35
        },
        {
          "hole": 20,
          "x": -64.5,
          "y": 35,
          "z": -35
        },
        {
          "hole": 21,
          "x": -50.9413,
          "y": 45,
          "z": -33.8074
        },
        {
          "hole": 22,
          "x": -42.5,
          "y": 45,
          "z": -30.3109
        },
        {
          "hole": 23,
          "x": -35.2513,
          "y": 45,
          "z": -24.7487
        },
        {
          "hole": 24,
          "x": -29.6891,
          "y": 45,
          "z": -17.5
        },
        {
          "hole": 25,
          "x": -26.1926,
          "y": 45,
          "z": -9.0587
        },
        {
          "hole": 26,
          "x": -26.1926,
          "y": 45,
          "z": 9.0587
        },
        {
          "hole": 27,
          "x": -29.6891,
          "y": 45,
          "z": 17.5
        },
        {
          "hole": 28,
          "x": -35.2513,
          "y": 45,
          "z": 24.7487
        },
        {
          "hole": 29,
          "x": -42.5,
          "y": 45,
          "z": 30.3109
        },
        {
          "hole": 30,
          "x": -50.9413,
          "y": 45,
          "z": 33.8074
        },
        {
          "hole": 31,
          "x": -64.5,
          "y": 35,
          "z": 35
        },
        {
          "hole": 32,
          "x": -72.25,
          "y": 35,
          "z": 35
        },
        {
          "hole": 33,
          "x": -80,
          "y": 35,
          "z": 35
        },
        {
          "hole": 34,
          "x": -87.75,
          "y": 35,
          "z": 35
        },
        {
          "hole": 35,
          "x": -95.5,
          "y": 35,
          "z": 35
        },
        {
          "hole": 36,
          "x": -111.6469,
          "y": 25,
          "z": 36.5333
        },
        {
          "hole": 37,
          "x": -122.5,
          "y": 25,
          "z": 41.0289
        },
        {
          "hole": 38,
          "x": -131.8198,
          "y": 25,
          "z": 48.1802
        },
        {
          "hole": 39,
          "x": -138.9711,
          "y": 25,
          "z": 57.5
        },
        {
          "hole": 40,
          "x": -143.4667,
          "y": 25,
          "z": 68.3531
        },
        {
          "hole": 41,
          "x": -143.4667,
          "y": 15,
          "z": 91.6469
        },
        {
          "hole": 42,
          "x": -138.9711,
          "y": 15,
          "z": 102.5
        },
        {
          "hole": 43,
          "x": -131.8198,
          "y": 15,
          "z": 111.8198
        },
        {
          "hole": 44,
          "x": -122.5,
          "y": 15,
          "z": 118.9711
        },
        {
          "hole": 45,
          "x": -111.6469,
          "y": 15,
          "z": 123.4667
        },
        {
          "hole": 46,
          "x": -95.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 47,
          "x": -87.75,
          "y": 5,
          "z": 125
        },
        {
          "hole": 48,
          "x": -80,
          "y": 5,
          "z": 125
        },
        {
          "hole": 49,
          "x": -72.25,
          "y": 5,
          "z": 125
        },
        {
          "hole": 50,
          "x": -64.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 51,
          "x": -55.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 52,
          "x": -47.75,
          "y": 5,
          "z": 125
        },
        {
          "hole": 53,
          "x": -40,
          "y": 5,
          "z": 125
        },
        {
          "hole": 54,
          "x": -32.25,
          "y": 5,
          "z": 125
        },
        {
          "hole": 55,
          "x": -24.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 56,
          "x": -15.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 57,
          "x": -7.75,
          "y": 5,
          "z": 125
        },
        {
          "hole": 58,
          "x": 0,
          "y": 5,
          "z": 125
        },
        {
          "hole": 59,
          "x": 7.75,
          "y": 5,
          "z": 125
        },
        {
          "hole": 60,
          "x": 15.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 61,
          "x": 24.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 62,
          "x": 32.25,
          "y": 5,
          "z": 125
        },
        {
          "hole": 63,
          "x": 40,
          "y": 5,
          "z": 125
        },
        {
          "hole": 64,
          "x": 47.75,
          "y": 5,
          "z": 125
        },
        {
          "hole": 65,
          "x": 55.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 66,
          "x": 64.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 67,
          "x": 72.25,
          "y": 5,
          "z": 125
        },
        {
          "hole": 68,
          "x": 80,
          "y": 5,
          "z": 125
        },
        {
          "hole": 69,
          "x": 87.75,
          "y": 5,
          "z": 125
        },
        {
          "hole": 70,
          "x": 95.5,
          "y": 5,
          "z": 125
        },
        {
          "hole": 71,
          "x": 111.6469,
          "y": 15,
          "z": 123.4667
        },
        {
          "hole": 72,
          "x": 122.5,
          "y": 15,
          "z": 118.9711
        },
        {
          "hole": 73,
          "x": 131.8198,
          "y": 15,
          "z": 111.8198
        },
        {
          "hole": 74,
          "x": 138.9711,
          "y": 15,
          "z": 102.5
        },
        {
          "hole": 75,
          "x": 143.4667,
          "y": 15,
          "z": 91.6469
        },
        {
          "hole": 76,
          "x": 143.4667,
          "y": 25,
          "z": 68.3531
        },
        {
          "hole": 77,
          "x": 138.9711,
          "y": 25,
          "z": 57.5
        },
        {
          "hole": 78,
          "x": 131.8198,
          "y": 25,
          "z": 48.1802
        },
        {
          "hole": 79,
          "x": 122.5,
          "y": 25,
          "z": 41.0289
        },
        {
          "hole": 80,
          "x": 111.6469,
          "y": 25,
          "z": 36.5333
        },
        {
          "hole": 81,
          "x": 95.5,
          "y": 35,
          "z": 35
        },
        {
          "hole": 82,
          "x": 87.75,
          "y": 35,
          "z": 35
        },
        {
          "hole": 83,
          "x": 80,
          "y": 35,
          "z": 35
        },
        {
          "hole": 84,
          "x": 72.25,
          "y": 35,
          "z": 35
        },
        {
          "hole": 85,
          "x": 64.5,
          "y": 35,
          "z": 35
        },
        {
          "hole": 86,
          "x": 50.9413,
          "y": 45,
          "z": 33.8074
        },
        {
          "hole": 87,
          "x": 42.5,
          "y": 45,
          "z": 30.3109
        },
        {
          "hole": 88,
          "x": 35.2513,
          "y": 45,
          "z": 24.7487
        },
        {
          "hole": 89,
          "x": 29.6891,
          "y": 45,
          "z": 17.5
        },
        {
          "hole": 90,
          "x": 26.1926,
          "y": 45,
          "z": 9.0587
        },
        {
          "hole": 91,
          "x": 26.1926,
          "y": 45,
          "z": -9.0587
        },
        {
          "hole": 92,
          "x": 29.6891,
          "y": 45,
          "z": -17.5
        },
        {
          "hole": 93,
          "x": 35.2513,
          "y": 45,
          "z": -24.7487
        },
        {
          "hole": 94,
          "x": 42.5,
          "y": 45,
          "z": -30.3109
        },
        {
          "hole": 95,
          "x": 50.9413,
          "y": 45,
          "z": -33.8074
        },
        {
          "hole": 96,
          "x": 64.5,
          "y": 35,
          "z": -35
        },
        {
          "hole": 97,
          "x": 72.25,
          "y": 35,
          "z": -35
        },
        {
          "hole": 98,
          "x": 80,
          "y": 35,
          "z": -35
        },
        {
          "hole": 99,
          "x": 87.75,
          "y": 35,
          "z": -35
        },
        {
          "hole": 100,
          "x": 95.5,
          "y": 35,
          "z": -35
        },
        {
          "hole": 101,
          "x": 111.6469,
          "y": 25,
          "z": -36.5333
        },
        {
          "hole": 102,
          "x": 122.5,
          "y": 25,
          "z": -41.0289
        },
        {
          "hole": 103,
          "x": 131.8198,
          "y": 25,
          "z": -48.1802
        },
        {
          "hole": 104,
          "x": 138.9711,
          "y": 25,
          "z": -57.5
        },
        {
          "hole": 105,
          "x": 143.4667,
          "y": 25,
          "z": -68.3531
        },
        {
          "hole": 106,
          "x": 143.4667,
          "y": 15,
          "z": -91.6469
        },
        {
          "hole": 107,
          "x": 138.9711,
          "y": 15,
          "z": -102.5
        },
        {
          "hole": 108,
          "x": 131.8198,
          "y": 15,
          "z": -111.8198
        },
        {
          "hole": 109,
          "x": 122.5,
          "y": 15,
          "z": -118.9711
        },
        {
          "hole": 110,
          "x": 111.6469,
          "y": 15,
          "z": -123.4667
        },
        {
          "hole": 111,
          "x": 95.5,
          "y": 5,
          "z": -125
        },
        {
          "hole": 112,
          "x": 87.75,
          "y": 5,
          "z": -125
        },
        {
          "hole": 113,
          "x": 80,
          "y": 5,
          "z": -125
        },
        {
          "hole": 114,
          "x": 72.25,
          "y": 5,
          "z": -125
        },
        {
          "hole": 115,
          "x": 64.5,
          "y": 5,
          "z": -125
        },
        {
          "hole": 116,
          "x": 55.5,
          "y": 5,
          "z": -125
        },
        {
          "hole": 117,
          "x": 47.75,
          "y": 5,
          "z": -125
        },
        {
          "hole": 118,
          "x": 40,
          "y": 5,
          "z": -125
        },
        {
          "hole": 119,
          "x": 32.25,
          "y": 5,
          "z": -125
        },
        {
          "hole": 120,
          "x": 24.5,
          "y": 5,
          "z": -125
        },
        {
          "hole": 121,
          "x": 0,
          "y": 5,
          "z": -120
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": -47,
          "y": 5,
          "z": -135
        },
        {
          "hole": 1,
          "x": -64.5,
          "y": 5,
          "z": -135
        },
        {
          "hole": 2,
          "x": -72.25,
          "y": 5,
          "z": -135
        },
        {
          "hole": 3,
          "x": -80,
          "y": 5,
          "z": -135
        },
        {
          "hole": 4,
          "x": -87.75,
          "y": 5,
          "z": -135
        },
        {
          "hole": 5,
          "x": -95.5,
          "y": 5,
          "z": -135
        },
        {
          "hole": 6,
          "x": -114.235,
          "y": 15,
          "z": -133.1259
        },
        {
          "hole": 7,
          "x": -127.5,
          "y": 15,
          "z": -127.6314
        },
        {
          "hole": 8,
          "x": -138.8909,
          "y": 15,
          "z": -118.8909
        },
        {
          "hole": 9,
          "x": -147.6314,
          "y": 15,
          "z": -107.5
        },
        {
          "hole": 10,
          "x": -153.1259,
          "y": 15,
          "z": -94.235
        },
        {
          "hole": 11,
          "x": -153.1259,
          "y": 25,
          "z": -65.765
        },
        {
          "hole": 12,
          "x": -147.6314,
          "y": 25,
          "z": -52.5
        },
        {
          "hole": 13,
          "x": -138.8909,
          "y": 25,
          "z": -41.1091
        },
        {
          "hole": 14,
          "x": -127.5,
          "y": 25,
          "z": -32.3686
        },
        {
          "hole": 15,
          "x": -114.235,
          "y": 25,
          "z": -26.8741
        },
        {
          "hole": 16,
          "x": -95.5,
          "y": 35,
          "z": -25
        },
        {
          "hole": 17,
          "x": -87.75,
          "y": 35,
          "z": -25
        },
        {
          "hole": 18,
          "x": -80,
          "y": 35,
          "z": -25
        },
        {
          "hole": 19,
          "x": -72.25,
          "y": 35,
          "z": -25
        },
        {
          "hole": 20,
          "x": -64.5,
          "y": 35,
          "z": -25
        },
        {
          "hole": 21,
          "x": -53.5295,
          "y": 45,
          "z": -24.1481
        },
        {
          "hole": 22,
          "x": -47.5,
          "y": 45,
          "z": -21.6506
        },
        {
          "hole": 23,
          "x": -42.3223,
          "y": 45,
          "z": -17.6777
        },
        {
          "hole": 24,
          "x": -38.3494,
          "y": 45,
          "z": -12.5
        },
        {
          "hole": 25,
          "x": -35.8519,
          "y": 45,
          "z": -6.4705
        },
        {
          "hole": 26,
          "x": -35.8519,
          "y": 45,
          "z": 6.4705
        },
        {
          "hole": 27,
          "x": -38.3494,
          "y": 45,
          "z": 12.5
        },
        {
          "hole": 28,
          "x": -42.3223,
          "y": 45,
          "z": 17.6777
        },
        {
          "hole": 29,
          "x": -47.5,
          "y": 45,
          "z": 21.6506
        },
        {
          "hole": 30,
          "x": -53.5295,
          "y": 45,
          "z": 24.1481
        },
        {
          "hole": 31,
          "x": -64.5,
          "y": 35,
          "z": 25
        },
        {
          "hole": 32,
          "x": -72.25,
          "y": 35,
          "z": 25
        },
        {
          "hole": 33,
          "x": -80,
          "y": 35,
          "z": 25
        },
        {
          "hole": 34,
          "x": -87.75,
          "y": 35,
          "z": 25
        },
        {
          "hole": 35,
          "x": -95.5,
          "y": 35,
          "z": 25
        },
        {
          "hole": 36,
          "x": -114.235,
          "y": 25,
          "z": 26.8741
        },
        {
          "hole": 37,
          "x": -127.5,
          "y": 25,
          "z": 32.3686
        },
        {
          "hole": 38,
          "x": -138.8909,
          "y": 25,
          "z": 41.1091
        },
        {
          "hole": 39,
          "x": -147.6314,
          "y": 25,
          "z": 52.5
        },
        {
          "hole": 40,
          "x": -153.1259,
          "y": 25,
          "z": 65.765
        },
        {
          "hole": 41,
          "x": -153.1259,
          "y": 15,
          "z": 94.235
        },
        {
          "hole": 42,
          "x": -147.6314,
          "y": 15,
          "z": 107.5
        },
        {
          "hole": 43,
          "x": -138.8909,
          "y": 15,
          "z": 118.8909
        },
        {
          "hole": 44,
          "x": -127.5,
          "y": 15,
          "z": 127.6314
        },
        {
          "hole": 45,
          "x": -114.235,
          "y": 15,
          "z": 133.1259
        },
        {
          "hole": 46,
          "x": -95.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 47,
          "x": -87.75,
          "y": 5,
          "z": 135
        },
        {
          "hole": 48,
          "x": -80,
          "y": 5,
          "z": 135
        },
        {
          "hole": 49,
          "x": -72.25,
          "y": 5,
          "z": 135
        },
        {
          "hole": 50,
          "x": -64.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 51,
          "x": -55.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 52,
          "x": -47.75,
          "y": 5,
          "z": 135
        },
        {
          "hole": 53,
          "x": -40,
          "y": 5,
          "z": 135
        },
        {
          "hole": 54,
          "x": -32.25,
          "y": 5,
          "z": 135
        },
        {
          "hole": 55,
          "x": -24.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 56,
          "x": -15.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 57,
          "x": -7.75,
          "y": 5,
          "z": 135
        },
        {
          "hole": 58,
          "x": 0,
          "y": 5,
          "z": 135
        },
        {
          "hole": 59,
          "x": 7.75,
          "y": 5,
          "z": 135
        },
        {
          "hole": 60,
          "x": 15.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 61,
          "x": 24.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 62,
          "x": 32.25,
          "y": 5,
          "z": 135
        },
        {
          "hole": 63,
          "x": 40,
          "y": 5,
          "z": 135
        },
        {
          "hole": 64,
          "x": 47.75,
          "y": 5,
          "z": 135
        },
        {
          "hole": 65,
          "x": 55.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 66,
          "x": 64.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 67,
          "x": 72.25,
          "y": 5,
          "z": 135
        },
        {
          "hole": 68,
          "x": 80,
          "y": 5,
          "z": 135
        },
        {
          "hole": 69,
          "x": 87.75,
          "y": 5,
          "z": 135
        },
        {
          "hole": 70,
          "x": 95.5,
          "y": 5,
          "z": 135
        },
        {
          "hole": 71,
          "x": 114.235,
          "y": 15,
          "z": 133.1259
        },
        {
          "hole": 72,
          "x": 127.5,
          "y": 15,
          "z": 127.6314
        },
        {
          "hole": 73,
          "x": 138.8909,
          "y": 15,
          "z": 118.8909
        },
        {
          "hole": 74,
          "x": 147.6314,
          "y": 15,
          "z": 107.5
        },
        {
          "hole": 75,
          "x": 153.1259,
          "y": 15,
          "z": 94.235
        },
        {
          "hole": 76,
          "x": 153.1259,
          "y": 25,
          "z": 65.765
        },
        {
          "hole": 77,
          "x": 147.6314,
          "y": 25,
          "z": 52.5
        },
        {
          "hole": 78,
          "x": 138.8909,
          "y": 25,
          "z": 41.1091
        },
        {
          "hole": 79,
          "x": 127.5,
          "y": 25,
          "z": 32.3686
        },
        {
          "hole": 80,
          "x": 114.235,
          "y": 25,
          "z": 26.8741
        },
        {
          "hole": 81,
          "x": 95.5,
          "y": 35,
          "z": 25
        },
        {
          "hole": 82,
          "x": 87.75,
          "y": 35,
          "z": 25
        },
        {
          "hole": 83,
          "x": 80,
          "y": 35,
          "z": 25
        },
        {
          "hole": 84,
          "x": 72.25,
          "y": 35,
          "z": 25
        },
        {
          "hole": 85,
          "x": 64.5,
          "y": 35,
          "z": 25
        },
        {
          "hole": 86,
          "x": 53.5295,
          "y": 45,
          "z": 24.1481
        },
        {
          "hole": 87,
          "x": 47.5,
          "y": 45,
          "z": 21.6506
        },
        {
          "hole": 88,
          "x": 42.3223,
          "y": 45,
          "z": 17.6777
        },
        {
          "hole": 89,
          "x": 38.3494,
          "y": 45,
          "z": 12.5
        },
        {
          "hole": 90,
          "x": 35.8519,
          "y": 45,
          "z": 6.4705
        },
        {
          "hole": 91,
          "x": 35.8519,
          "y": 45,
          "z": -6.4705
        },
        {
          "hole": 92,
          "x": 38.3494,
          "y": 45,
          "z": -12.5
        },
        {
          "hole": 93,
          "x": 42.3223,
          "y": 45,
          "z": -17.6777
        },
        {
          "hole": 94,
          "x": 47.5,
          "y": 45,
          "z": -21.6506
        },
        {
          "hole": 95,
          "x": 53.5295,
          "y": 45,
          "z": -24.1481
        },
        {
          "hole": 96,
          "x": 64.5,
          "y": 35,
          "z": -25
        },
        {
          "hole": 97,
          "x": 72.25,
          "y": 35,
          "z": -25
        },
        {
          "hole": 98,
          "x": 80,
          "y": 35,
          "z": -25
        },
        {
          "hole": 99,
          "x": 87.75,
          "y": 35,
          "z": -25
        },
        {
          "hole": 100,
          "x": 95.5,
          "y": 35,
          "z": -25
        },
        {
          "hole": 101,
          "x": 114.235,
          "y": 25,
          "z": -26.8741
        },
        {
          "hole": 102,
          "x": 127.5,
          "y": 25,
          "z": -32.3686
        },
        {
          "hole": 103,
          "x": 138.8909,
          "y": 25,
          "z": -41.1091
        },
        {
          "hole": 104,
          "x": 147.6314,
          "y": 25,
          "z": -52.5
        },
        {
          "hole": 105,
          "x": 153.1259,
          "y": 25,
          "z": -65.765
        },
        {
          "hole": 106,
          "x": 153.1259,
          "y": 15,
          "z": -94.235
        },
        {
          "hole": 107,
          "x": 147.6314,
          "y": 15,
          "z": -107.5
        },
        {
          "hole": 108,
          "x": 138.8909,
          "y": 15,
          "z": -118.8909
        },
        {
          "hole": 109,
          "x": 127.5,
          "y": 15,
          "z": -127.6314
        },
        {
          "hole": 110,
          "x": 114.235,
          "y": 15,
          "z": -133.1259
        },
        {
          "hole": 111,
          "x": 95.5,
          "y": 5,
          "z": -135
        },
        {
          "hole": 112,
          "x": 87.75,
          "y": 5,
          "z": -135
        },
        {
          "hole": 113,
          "x": 80,
          "y": 5,
          "z": -135
        },
        {
          "hole": 114,
          "x": 72.25,
          "y": 5,
          "z": -135
        },
        {
          "hole": 115,
          "x": 64.5,
          "y": 5,
          "z": -135
        },
        {
          "hole": 116,
          "x": 55.5,
          "y": 5,
          "z": -135
        },
        {
          "hole": 117,
          "x": 47.75,
          "y": 5,
          "z": -135
        },
        {
          "hole": 118,
          "x": 40,
          "y": 5,
          "z": -135
        },
        {
          "hole": 119,
          "x": 32.25,
          "y": 5,
          "z": -135
        },
        {
          "hole": 120,
          "x": 24.5,
          "y": 5,
          "z": -135
        },
        {
          "hole": 121,
          "x": 0,
          "y": 5,
          "z": -120
        }
      ]
    }
  },
  {
    "id": "board-cancer-ribbon",
    "name": "Cancer Ribbon",
    "brand": "crazy,pints,adult",
    "desc": "Cancer Ribbon 3D cribbage board.",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/cancer-ribbon-thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/ddf105366127887f/cancer-ribbon-3d.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 127,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 1,
          "x": 135.5,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 2,
          "x": 127.75,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 3,
          "x": 120,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 4,
          "x": 112.25,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 5,
          "x": 104.5,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 6,
          "x": 175.5,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 7,
          "x": 167.75,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 8,
          "x": 160,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 9,
          "x": 152.25,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 10,
          "x": 144.5,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 11,
          "x": 215.5,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 12,
          "x": 207.75,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 13,
          "x": 200,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 14,
          "x": 192.25,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 15,
          "x": 184.5,
          "y": 15,
          "z": -55.4951
        },
        {
          "hole": 16,
          "x": 225,
          "y": 15,
          "z": -55.7513
        },
        {
          "hole": 17,
          "x": 232.5,
          "y": 15,
          "z": -55.7513
        },
        {
          "hole": 18,
          "x": 264.7487,
          "y": 15,
          "z": -45.5001
        },
        {
          "hole": 19,
          "x": 275,
          "y": 15,
          "z": -13.2513
        },
        {
          "hole": 20,
          "x": 275,
          "y": 15,
          "z": -5.7513
        },
        {
          "hole": 21,
          "x": 275,
          "y": 15,
          "z": 43.8283
        },
        {
          "hole": 22,
          "x": 275,
          "y": 15,
          "z": 51.3283
        },
        {
          "hole": 23,
          "x": 264.7487,
          "y": 15,
          "z": 83.577
        },
        {
          "hole": 24,
          "x": 232.5,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 25,
          "x": 225,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 26,
          "x": 175.5,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 27,
          "x": 167.75,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 28,
          "x": 160,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 29,
          "x": 152.25,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 30,
          "x": 144.5,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 31,
          "x": 215.5,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 32,
          "x": 207.75,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 33,
          "x": 200,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 34,
          "x": 192.25,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 35,
          "x": 184.5,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 36,
          "x": 95,
          "y": 15,
          "z": 174.3282
        },
        {
          "hole": 37,
          "x": 95,
          "y": 15,
          "z": 166.5782
        },
        {
          "hole": 38,
          "x": 95,
          "y": 15,
          "z": 158.8282
        },
        {
          "hole": 39,
          "x": 95,
          "y": 15,
          "z": 151.0782
        },
        {
          "hole": 40,
          "x": 95,
          "y": 15,
          "z": 143.3282
        },
        {
          "hole": 41,
          "x": 95,
          "y": 15,
          "z": 214.3282
        },
        {
          "hole": 42,
          "x": 95,
          "y": 15,
          "z": 206.5782
        },
        {
          "hole": 43,
          "x": 95,
          "y": 15,
          "z": 198.8282
        },
        {
          "hole": 44,
          "x": 95,
          "y": 15,
          "z": 191.0782
        },
        {
          "hole": 45,
          "x": 95,
          "y": 15,
          "z": 183.3282
        },
        {
          "hole": 46,
          "x": 95,
          "y": 15,
          "z": 223.8282
        },
        {
          "hole": 47,
          "x": 95,
          "y": 15,
          "z": 231.3282
        },
        {
          "hole": 48,
          "x": 84.7487,
          "y": 15,
          "z": 263.577
        },
        {
          "hole": 49,
          "x": 52.5,
          "y": 15,
          "z": 273.8282
        },
        {
          "hole": 50,
          "x": 45,
          "y": 15,
          "z": 273.8282
        },
        {
          "hole": 51,
          "x": -5,
          "y": 15,
          "z": 273.8282
        },
        {
          "hole": 52,
          "x": -12.5,
          "y": 15,
          "z": 273.8282
        },
        {
          "hole": 53,
          "x": -44.7488,
          "y": 15,
          "z": 263.577
        },
        {
          "hole": 54,
          "x": -55,
          "y": 15,
          "z": 231.3282
        },
        {
          "hole": 55,
          "x": -55,
          "y": 15,
          "z": 223.8282
        },
        {
          "hole": 56,
          "x": -25.014,
          "y": 15,
          "z": 214.3282
        },
        {
          "hole": 57,
          "x": -25.014,
          "y": 15,
          "z": 206.5782
        },
        {
          "hole": 58,
          "x": -25.014,
          "y": 15,
          "z": 198.8282
        },
        {
          "hole": 59,
          "x": -25.014,
          "y": 15,
          "z": 191.0782
        },
        {
          "hole": 60,
          "x": -25.014,
          "y": 15,
          "z": 183.3282
        },
        {
          "hole": 61,
          "x": -25.014,
          "y": 15,
          "z": 174.3282
        },
        {
          "hole": 62,
          "x": -25.014,
          "y": 15,
          "z": 166.5782
        },
        {
          "hole": 63,
          "x": -25.014,
          "y": 15,
          "z": 158.8282
        },
        {
          "hole": 64,
          "x": -25.014,
          "y": 15,
          "z": 151.0782
        },
        {
          "hole": 65,
          "x": -25.014,
          "y": 15,
          "z": 143.3282
        },
        {
          "hole": 66,
          "x": -25.014,
          "y": 15,
          "z": 134.7536
        },
        {
          "hole": 67,
          "x": -25.014,
          "y": 15,
          "z": 127.0036
        },
        {
          "hole": 68,
          "x": -25.014,
          "y": 15,
          "z": 119.2536
        },
        {
          "hole": 69,
          "x": -25.014,
          "y": 15,
          "z": 111.5036
        },
        {
          "hole": 70,
          "x": -25.014,
          "y": 15,
          "z": 103.7536
        },
        {
          "hole": 71,
          "x": -70.1375,
          "y": 15,
          "z": 93.9168
        },
        {
          "hole": 72,
          "x": -80.2316,
          "y": 15,
          "z": 92.9226
        },
        {
          "hole": 73,
          "x": -90.239,
          "y": 15,
          "z": 91.2704
        },
        {
          "hole": 74,
          "x": -100.117,
          "y": 15,
          "z": 88.9672
        },
        {
          "hole": 75,
          "x": -109.8232,
          "y": 15,
          "z": 86.0229
        },
        {
          "hole": 76,
          "x": -128.5548,
          "y": 15,
          "z": 78.264
        },
        {
          "hole": 77,
          "x": -137.5,
          "y": 15,
          "z": 73.4826
        },
        {
          "hole": 78,
          "x": -146.1134,
          "y": 15,
          "z": 68.1265
        },
        {
          "hole": 79,
          "x": -154.358,
          "y": 15,
          "z": 62.2185
        },
        {
          "hole": 80,
          "x": -162.1986,
          "y": 15,
          "z": 55.7839
        },
        {
          "hole": 81,
          "x": -176.5352,
          "y": 15,
          "z": 41.4473
        },
        {
          "hole": 82,
          "x": -182.9698,
          "y": 15,
          "z": 33.6067
        },
        {
          "hole": 83,
          "x": -188.8778,
          "y": 15,
          "z": 25.3621
        },
        {
          "hole": 84,
          "x": -194.234,
          "y": 15,
          "z": 16.7487
        },
        {
          "hole": 85,
          "x": -199.0153,
          "y": 15,
          "z": 7.8034
        },
        {
          "hole": 86,
          "x": -206.7742,
          "y": 15,
          "z": -10.9282
        },
        {
          "hole": 87,
          "x": -209.7185,
          "y": 15,
          "z": -20.6344
        },
        {
          "hole": 88,
          "x": -212.0218,
          "y": 15,
          "z": -30.5123
        },
        {
          "hole": 89,
          "x": -213.674,
          "y": 15,
          "z": -40.5198
        },
        {
          "hole": 90,
          "x": -214.6682,
          "y": 15,
          "z": -50.6138
        },
        {
          "hole": 91,
          "x": -214.6682,
          "y": 15,
          "z": -70.8888
        },
        {
          "hole": 92,
          "x": -213.674,
          "y": 15,
          "z": -80.9829
        },
        {
          "hole": 93,
          "x": -212.0218,
          "y": 15,
          "z": -90.9903
        },
        {
          "hole": 94,
          "x": -209.7185,
          "y": 15,
          "z": -100.8683
        },
        {
          "hole": 95,
          "x": -206.7742,
          "y": 15,
          "z": -110.5744
        },
        {
          "hole": 96,
          "x": -199.0153,
          "y": 15,
          "z": -129.3061
        },
        {
          "hole": 97,
          "x": -194.234,
          "y": 15,
          "z": -138.2513
        },
        {
          "hole": 98,
          "x": -188.8778,
          "y": 15,
          "z": -146.8647
        },
        {
          "hole": 99,
          "x": -182.9698,
          "y": 15,
          "z": -155.1093
        },
        {
          "hole": 100,
          "x": -176.5352,
          "y": 15,
          "z": -162.9499
        },
        {
          "hole": 101,
          "x": -162.1986,
          "y": 15,
          "z": -177.2865
        },
        {
          "hole": 102,
          "x": -154.3581,
          "y": 15,
          "z": -183.7211
        },
        {
          "hole": 103,
          "x": -146.1134,
          "y": 15,
          "z": -189.6291
        },
        {
          "hole": 104,
          "x": -137.5,
          "y": 15,
          "z": -194.9852
        },
        {
          "hole": 105,
          "x": -128.5548,
          "y": 15,
          "z": -199.7666
        },
        {
          "hole": 106,
          "x": -109.8231,
          "y": 15,
          "z": -207.5255
        },
        {
          "hole": 107,
          "x": -100.117,
          "y": 15,
          "z": -210.4698
        },
        {
          "hole": 108,
          "x": -90.239,
          "y": 15,
          "z": -212.773
        },
        {
          "hole": 109,
          "x": -80.2316,
          "y": 15,
          "z": -214.4253
        },
        {
          "hole": 110,
          "x": -70.1375,
          "y": 15,
          "z": -215.4194
        },
        {
          "hole": 111,
          "x": -49.8626,
          "y": 15,
          "z": -215.4194
        },
        {
          "hole": 112,
          "x": -39.7685,
          "y": 15,
          "z": -214.4253
        },
        {
          "hole": 113,
          "x": -29.761,
          "y": 15,
          "z": -212.773
        },
        {
          "hole": 114,
          "x": -19.8831,
          "y": 15,
          "z": -210.4698
        },
        {
          "hole": 115,
          "x": -10.1769,
          "y": 15,
          "z": -207.5255
        },
        {
          "hole": 116,
          "x": 8.5547,
          "y": 15,
          "z": -199.7666
        },
        {
          "hole": 117,
          "x": 17.5,
          "y": 15,
          "z": -194.9852
        },
        {
          "hole": 118,
          "x": 26.1134,
          "y": 15,
          "z": -189.6291
        },
        {
          "hole": 119,
          "x": 34.358,
          "y": 15,
          "z": -183.7211
        },
        {
          "hole": 120,
          "x": 42.1986,
          "y": 15,
          "z": -177.2865
        },
        {
          "hole": 121,
          "x": 56.5351,
          "y": 15,
          "z": -162.9499
        },
        {
          "hole": 122,
          "x": 62.9697,
          "y": 15,
          "z": -155.1093
        },
        {
          "hole": 123,
          "x": 68.8777,
          "y": 15,
          "z": -146.8647
        },
        {
          "hole": 124,
          "x": 74.2339,
          "y": 15,
          "z": -138.2513
        },
        {
          "hole": 125,
          "x": 79.0152,
          "y": 15,
          "z": -129.3061
        },
        {
          "hole": 126,
          "x": 86.7741,
          "y": 15,
          "z": -110.5744
        },
        {
          "hole": 127,
          "x": 89.7185,
          "y": 15,
          "z": -100.8683
        },
        {
          "hole": 128,
          "x": 92.0217,
          "y": 15,
          "z": -90.9903
        },
        {
          "hole": 129,
          "x": 93.6739,
          "y": 15,
          "z": -80.9829
        },
        {
          "hole": 130,
          "x": 94.6681,
          "y": 15,
          "z": -70.8888
        },
        {
          "hole": 121,
          "x": 80,
          "y": 15,
          "z": 118.8283
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 127,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 1,
          "x": 135.5,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 2,
          "x": 127.75,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 3,
          "x": 120,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 4,
          "x": 112.25,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 5,
          "x": 104.5,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 6,
          "x": 175.5,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 7,
          "x": 167.75,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 8,
          "x": 160,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 9,
          "x": 152.25,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 10,
          "x": 144.5,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 11,
          "x": 215.5,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 12,
          "x": 207.75,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 13,
          "x": 200,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 14,
          "x": 192.25,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 15,
          "x": 184.5,
          "y": 15,
          "z": -45.4951
        },
        {
          "hole": 16,
          "x": 225,
          "y": 15,
          "z": -45.7513
        },
        {
          "hole": 17,
          "x": 232.5,
          "y": 15,
          "z": -45.7513
        },
        {
          "hole": 18,
          "x": 257.6776,
          "y": 15,
          "z": -38.429
        },
        {
          "hole": 19,
          "x": 265,
          "y": 15,
          "z": -13.2513
        },
        {
          "hole": 20,
          "x": 265,
          "y": 15,
          "z": -5.7513
        },
        {
          "hole": 21,
          "x": 265,
          "y": 15,
          "z": 43.8283
        },
        {
          "hole": 22,
          "x": 265,
          "y": 15,
          "z": 51.3283
        },
        {
          "hole": 23,
          "x": 257.6776,
          "y": 15,
          "z": 76.5059
        },
        {
          "hole": 24,
          "x": 232.5,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 25,
          "x": 225,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 26,
          "x": 175.5,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 27,
          "x": 167.75,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 28,
          "x": 160,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 29,
          "x": 152.25,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 30,
          "x": 144.5,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 31,
          "x": 215.5,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 32,
          "x": 207.75,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 33,
          "x": 200,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 34,
          "x": 192.25,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 35,
          "x": 184.5,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 36,
          "x": 85,
          "y": 15,
          "z": 174.3282
        },
        {
          "hole": 37,
          "x": 85,
          "y": 15,
          "z": 166.5782
        },
        {
          "hole": 38,
          "x": 85,
          "y": 15,
          "z": 158.8282
        },
        {
          "hole": 39,
          "x": 85,
          "y": 15,
          "z": 151.0782
        },
        {
          "hole": 40,
          "x": 85,
          "y": 15,
          "z": 143.3282
        },
        {
          "hole": 41,
          "x": 85,
          "y": 15,
          "z": 214.3282
        },
        {
          "hole": 42,
          "x": 85,
          "y": 15,
          "z": 206.5782
        },
        {
          "hole": 43,
          "x": 85,
          "y": 15,
          "z": 198.8282
        },
        {
          "hole": 44,
          "x": 85,
          "y": 15,
          "z": 191.0782
        },
        {
          "hole": 45,
          "x": 85,
          "y": 15,
          "z": 183.3282
        },
        {
          "hole": 46,
          "x": 85,
          "y": 15,
          "z": 223.8282
        },
        {
          "hole": 47,
          "x": 85,
          "y": 15,
          "z": 231.3282
        },
        {
          "hole": 48,
          "x": 77.6776,
          "y": 15,
          "z": 256.5059
        },
        {
          "hole": 49,
          "x": 52.5,
          "y": 15,
          "z": 263.8282
        },
        {
          "hole": 50,
          "x": 45,
          "y": 15,
          "z": 263.8282
        },
        {
          "hole": 51,
          "x": -5,
          "y": 15,
          "z": 263.8282
        },
        {
          "hole": 52,
          "x": -12.5,
          "y": 15,
          "z": 263.8282
        },
        {
          "hole": 53,
          "x": -37.6777,
          "y": 15,
          "z": 256.5059
        },
        {
          "hole": 54,
          "x": -45,
          "y": 15,
          "z": 231.3282
        },
        {
          "hole": 55,
          "x": -45,
          "y": 15,
          "z": 223.8282
        },
        {
          "hole": 56,
          "x": -35.014,
          "y": 15,
          "z": 214.3282
        },
        {
          "hole": 57,
          "x": -35.014,
          "y": 15,
          "z": 206.5782
        },
        {
          "hole": 58,
          "x": -35.014,
          "y": 15,
          "z": 198.8282
        },
        {
          "hole": 59,
          "x": -35.014,
          "y": 15,
          "z": 191.0782
        },
        {
          "hole": 60,
          "x": -35.014,
          "y": 15,
          "z": 183.3282
        },
        {
          "hole": 61,
          "x": -35.014,
          "y": 15,
          "z": 174.3282
        },
        {
          "hole": 62,
          "x": -35.014,
          "y": 15,
          "z": 166.5782
        },
        {
          "hole": 63,
          "x": -35.014,
          "y": 15,
          "z": 158.8282
        },
        {
          "hole": 64,
          "x": -35.014,
          "y": 15,
          "z": 151.0782
        },
        {
          "hole": 65,
          "x": -35.014,
          "y": 15,
          "z": 143.3282
        },
        {
          "hole": 66,
          "x": -35.014,
          "y": 15,
          "z": 134.7536
        },
        {
          "hole": 67,
          "x": -35.014,
          "y": 15,
          "z": 127.0036
        },
        {
          "hole": 68,
          "x": -35.014,
          "y": 15,
          "z": 119.2536
        },
        {
          "hole": 69,
          "x": -35.014,
          "y": 15,
          "z": 111.5036
        },
        {
          "hole": 70,
          "x": -35.014,
          "y": 15,
          "z": 103.7536
        },
        {
          "hole": 71,
          "x": -69.4835,
          "y": 15,
          "z": 83.9382
        },
        {
          "hole": 72,
          "x": -78.9263,
          "y": 15,
          "z": 83.0082
        },
        {
          "hole": 73,
          "x": -88.2881,
          "y": 15,
          "z": 81.4626
        },
        {
          "hole": 74,
          "x": -97.5288,
          "y": 15,
          "z": 79.3079
        },
        {
          "hole": 75,
          "x": -106.6088,
          "y": 15,
          "z": 76.5536
        },
        {
          "hole": 76,
          "x": -124.1319,
          "y": 15,
          "z": 69.2952
        },
        {
          "hole": 77,
          "x": -132.5,
          "y": 15,
          "z": 64.8224
        },
        {
          "hole": 78,
          "x": -140.5577,
          "y": 15,
          "z": 59.8118
        },
        {
          "hole": 79,
          "x": -148.2704,
          "y": 15,
          "z": 54.2849
        },
        {
          "hole": 80,
          "x": -155.6052,
          "y": 15,
          "z": 48.2655
        },
        {
          "hole": 81,
          "x": -169.0168,
          "y": 15,
          "z": 34.8538
        },
        {
          "hole": 82,
          "x": -175.0363,
          "y": 15,
          "z": 27.5191
        },
        {
          "hole": 83,
          "x": -180.5631,
          "y": 15,
          "z": 19.8064
        },
        {
          "hole": 84,
          "x": -185.5737,
          "y": 15,
          "z": 11.7487
        },
        {
          "hole": 85,
          "x": -190.0466,
          "y": 15,
          "z": 3.3805
        },
        {
          "hole": 86,
          "x": -197.3049,
          "y": 15,
          "z": -14.1426
        },
        {
          "hole": 87,
          "x": -200.0593,
          "y": 15,
          "z": -23.2226
        },
        {
          "hole": 88,
          "x": -202.2139,
          "y": 15,
          "z": -32.4632
        },
        {
          "hole": 89,
          "x": -203.7595,
          "y": 15,
          "z": -41.825
        },
        {
          "hole": 90,
          "x": -204.6896,
          "y": 15,
          "z": -51.2679
        },
        {
          "hole": 91,
          "x": -204.6896,
          "y": 15,
          "z": -70.2348
        },
        {
          "hole": 92,
          "x": -203.7595,
          "y": 15,
          "z": -79.6776
        },
        {
          "hole": 93,
          "x": -202.2139,
          "y": 15,
          "z": -89.0394
        },
        {
          "hole": 94,
          "x": -200.0593,
          "y": 15,
          "z": -98.2801
        },
        {
          "hole": 95,
          "x": -197.3049,
          "y": 15,
          "z": -107.36
        },
        {
          "hole": 96,
          "x": -190.0466,
          "y": 15,
          "z": -124.8832
        },
        {
          "hole": 97,
          "x": -185.5737,
          "y": 15,
          "z": -133.2513
        },
        {
          "hole": 98,
          "x": -180.5631,
          "y": 15,
          "z": -141.309
        },
        {
          "hole": 99,
          "x": -175.0363,
          "y": 15,
          "z": -149.0217
        },
        {
          "hole": 100,
          "x": -169.0168,
          "y": 15,
          "z": -156.3565
        },
        {
          "hole": 101,
          "x": -155.6052,
          "y": 15,
          "z": -169.7681
        },
        {
          "hole": 102,
          "x": -148.2704,
          "y": 15,
          "z": -175.7875
        },
        {
          "hole": 103,
          "x": -140.5577,
          "y": 15,
          "z": -181.3144
        },
        {
          "hole": 104,
          "x": -132.5,
          "y": 15,
          "z": -186.325
        },
        {
          "hole": 105,
          "x": -124.1319,
          "y": 15,
          "z": -190.7979
        },
        {
          "hole": 106,
          "x": -106.6088,
          "y": 15,
          "z": -198.0562
        },
        {
          "hole": 107,
          "x": -97.5288,
          "y": 15,
          "z": -200.8106
        },
        {
          "hole": 108,
          "x": -88.2881,
          "y": 15,
          "z": -202.9652
        },
        {
          "hole": 109,
          "x": -78.9263,
          "y": 15,
          "z": -204.5108
        },
        {
          "hole": 110,
          "x": -69.4835,
          "y": 15,
          "z": -205.4408
        },
        {
          "hole": 111,
          "x": -50.5166,
          "y": 15,
          "z": -205.4409
        },
        {
          "hole": 112,
          "x": -41.0737,
          "y": 15,
          "z": -204.5108
        },
        {
          "hole": 113,
          "x": -31.7119,
          "y": 15,
          "z": -202.9652
        },
        {
          "hole": 114,
          "x": -22.4713,
          "y": 15,
          "z": -200.8106
        },
        {
          "hole": 115,
          "x": -13.3913,
          "y": 15,
          "z": -198.0562
        },
        {
          "hole": 116,
          "x": 4.1318,
          "y": 15,
          "z": -190.7979
        },
        {
          "hole": 117,
          "x": 12.5,
          "y": 15,
          "z": -186.325
        },
        {
          "hole": 118,
          "x": 20.5577,
          "y": 15,
          "z": -181.3144
        },
        {
          "hole": 119,
          "x": 28.2704,
          "y": 15,
          "z": -175.7875
        },
        {
          "hole": 120,
          "x": 35.6051,
          "y": 15,
          "z": -169.7681
        },
        {
          "hole": 121,
          "x": 49.0167,
          "y": 15,
          "z": -156.3565
        },
        {
          "hole": 122,
          "x": 55.0362,
          "y": 15,
          "z": -149.0217
        },
        {
          "hole": 123,
          "x": 60.5631,
          "y": 15,
          "z": -141.309
        },
        {
          "hole": 124,
          "x": 65.5736,
          "y": 15,
          "z": -133.2513
        },
        {
          "hole": 125,
          "x": 70.0465,
          "y": 15,
          "z": -124.8832
        },
        {
          "hole": 126,
          "x": 77.3048,
          "y": 15,
          "z": -107.36
        },
        {
          "hole": 127,
          "x": 80.0592,
          "y": 15,
          "z": -98.2801
        },
        {
          "hole": 128,
          "x": 82.2138,
          "y": 15,
          "z": -89.0394
        },
        {
          "hole": 129,
          "x": 83.7595,
          "y": 15,
          "z": -79.6776
        },
        {
          "hole": 130,
          "x": 84.6895,
          "y": 15,
          "z": -70.2348
        },
        {
          "hole": 121,
          "x": 80,
          "y": 15,
          "z": 118.8283
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": 127,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 1,
          "x": 135.5,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 2,
          "x": 127.75,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 3,
          "x": 120,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 4,
          "x": 112.25,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 5,
          "x": 104.5,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 6,
          "x": 175.5,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 7,
          "x": 167.75,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 8,
          "x": 160,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 9,
          "x": 152.25,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 10,
          "x": 144.5,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 11,
          "x": 215.5,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 12,
          "x": 207.75,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 13,
          "x": 200,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 14,
          "x": 192.25,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 15,
          "x": 184.5,
          "y": 15,
          "z": -35.4951
        },
        {
          "hole": 16,
          "x": 225,
          "y": 15,
          "z": -35.7513
        },
        {
          "hole": 17,
          "x": 232.5,
          "y": 15,
          "z": -35.7513
        },
        {
          "hole": 18,
          "x": 250.6066,
          "y": 15,
          "z": -31.3579
        },
        {
          "hole": 19,
          "x": 255,
          "y": 15,
          "z": -13.2513
        },
        {
          "hole": 20,
          "x": 255,
          "y": 15,
          "z": -5.7513
        },
        {
          "hole": 21,
          "x": 255,
          "y": 15,
          "z": 43.8283
        },
        {
          "hole": 22,
          "x": 255,
          "y": 15,
          "z": 51.3283
        },
        {
          "hole": 23,
          "x": 250.6066,
          "y": 15,
          "z": 69.4349
        },
        {
          "hole": 24,
          "x": 232.5,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 25,
          "x": 225,
          "y": 15,
          "z": 73.8283
        },
        {
          "hole": 26,
          "x": 175.5,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 27,
          "x": 167.75,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 28,
          "x": 160,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 29,
          "x": 152.25,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 30,
          "x": 144.5,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 31,
          "x": 215.5,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 32,
          "x": 207.75,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 33,
          "x": 200,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 34,
          "x": 192.25,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 35,
          "x": 184.5,
          "y": 15,
          "z": 83.8283
        },
        {
          "hole": 36,
          "x": 75,
          "y": 15,
          "z": 174.3282
        },
        {
          "hole": 37,
          "x": 75,
          "y": 15,
          "z": 166.5782
        },
        {
          "hole": 38,
          "x": 75,
          "y": 15,
          "z": 158.8282
        },
        {
          "hole": 39,
          "x": 75,
          "y": 15,
          "z": 151.0782
        },
        {
          "hole": 40,
          "x": 75,
          "y": 15,
          "z": 143.3282
        },
        {
          "hole": 41,
          "x": 75,
          "y": 15,
          "z": 214.3282
        },
        {
          "hole": 42,
          "x": 75,
          "y": 15,
          "z": 206.5782
        },
        {
          "hole": 43,
          "x": 75,
          "y": 15,
          "z": 198.8282
        },
        {
          "hole": 44,
          "x": 75,
          "y": 15,
          "z": 191.0782
        },
        {
          "hole": 45,
          "x": 75,
          "y": 15,
          "z": 183.3282
        },
        {
          "hole": 46,
          "x": 75,
          "y": 15,
          "z": 223.8282
        },
        {
          "hole": 47,
          "x": 75,
          "y": 15,
          "z": 231.3282
        },
        {
          "hole": 48,
          "x": 70.6066,
          "y": 15,
          "z": 249.4348
        },
        {
          "hole": 49,
          "x": 52.5,
          "y": 15,
          "z": 253.8282
        },
        {
          "hole": 50,
          "x": 45,
          "y": 15,
          "z": 253.8282
        },
        {
          "hole": 51,
          "x": -5,
          "y": 15,
          "z": 253.8282
        },
        {
          "hole": 52,
          "x": -12.5,
          "y": 15,
          "z": 253.8282
        },
        {
          "hole": 53,
          "x": -30.6066,
          "y": 15,
          "z": 249.4348
        },
        {
          "hole": 54,
          "x": -35,
          "y": 15,
          "z": 231.3282
        },
        {
          "hole": 55,
          "x": -35,
          "y": 15,
          "z": 223.8282
        },
        {
          "hole": 56,
          "x": -45.014,
          "y": 15,
          "z": 214.3282
        },
        {
          "hole": 57,
          "x": -45.014,
          "y": 15,
          "z": 206.5782
        },
        {
          "hole": 58,
          "x": -45.014,
          "y": 15,
          "z": 198.8282
        },
        {
          "hole": 59,
          "x": -45.014,
          "y": 15,
          "z": 191.0782
        },
        {
          "hole": 60,
          "x": -45.014,
          "y": 15,
          "z": 183.3282
        },
        {
          "hole": 61,
          "x": -45.014,
          "y": 15,
          "z": 174.3282
        },
        {
          "hole": 62,
          "x": -45.014,
          "y": 15,
          "z": 166.5782
        },
        {
          "hole": 63,
          "x": -45.014,
          "y": 15,
          "z": 158.8282
        },
        {
          "hole": 64,
          "x": -45.014,
          "y": 15,
          "z": 151.0782
        },
        {
          "hole": 65,
          "x": -45.014,
          "y": 15,
          "z": 143.3282
        },
        {
          "hole": 66,
          "x": -45.014,
          "y": 15,
          "z": 134.7536
        },
        {
          "hole": 67,
          "x": -45.014,
          "y": 15,
          "z": 127.0036
        },
        {
          "hole": 68,
          "x": -45.014,
          "y": 15,
          "z": 119.2536
        },
        {
          "hole": 69,
          "x": -45.014,
          "y": 15,
          "z": 111.5036
        },
        {
          "hole": 70,
          "x": -45.014,
          "y": 15,
          "z": 103.7536
        },
        {
          "hole": 71,
          "x": -68.8295,
          "y": 15,
          "z": 73.9596
        },
        {
          "hole": 72,
          "x": -77.6211,
          "y": 15,
          "z": 73.0937
        },
        {
          "hole": 73,
          "x": -86.3372,
          "y": 15,
          "z": 71.6547
        },
        {
          "hole": 74,
          "x": -94.9406,
          "y": 15,
          "z": 69.6487
        },
        {
          "hole": 75,
          "x": -103.3944,
          "y": 15,
          "z": 67.0843
        },
        {
          "hole": 76,
          "x": -119.709,
          "y": 15,
          "z": 60.3265
        },
        {
          "hole": 77,
          "x": -127.5,
          "y": 15,
          "z": 56.1621
        },
        {
          "hole": 78,
          "x": -135.002,
          "y": 15,
          "z": 51.4971
        },
        {
          "hole": 79,
          "x": -142.1828,
          "y": 15,
          "z": 46.3514
        },
        {
          "hole": 80,
          "x": -149.0117,
          "y": 15,
          "z": 40.7471
        },
        {
          "hole": 81,
          "x": -161.4984,
          "y": 15,
          "z": 28.2604
        },
        {
          "hole": 82,
          "x": -167.1027,
          "y": 15,
          "z": 21.4315
        },
        {
          "hole": 83,
          "x": -172.2484,
          "y": 15,
          "z": 14.2507
        },
        {
          "hole": 84,
          "x": -176.9135,
          "y": 15,
          "z": 6.7487
        },
        {
          "hole": 85,
          "x": -181.0779,
          "y": 15,
          "z": -1.0423
        },
        {
          "hole": 86,
          "x": -187.8356,
          "y": 15,
          "z": -17.357
        },
        {
          "hole": 87,
          "x": -190.4,
          "y": 15,
          "z": -25.8107
        },
        {
          "hole": 88,
          "x": -192.406,
          "y": 15,
          "z": -34.4141
        },
        {
          "hole": 89,
          "x": -193.8451,
          "y": 15,
          "z": -43.1303
        },
        {
          "hole": 90,
          "x": -194.711,
          "y": 15,
          "z": -51.9219
        },
        {
          "hole": 91,
          "x": -194.711,
          "y": 15,
          "z": -69.5807
        },
        {
          "hole": 92,
          "x": -193.8451,
          "y": 15,
          "z": -78.3723
        },
        {
          "hole": 93,
          "x": -192.4061,
          "y": 15,
          "z": -87.0885
        },
        {
          "hole": 94,
          "x": -190.4,
          "y": 15,
          "z": -95.6919
        },
        {
          "hole": 95,
          "x": -187.8356,
          "y": 15,
          "z": -104.1456
        },
        {
          "hole": 96,
          "x": -181.0779,
          "y": 15,
          "z": -120.4603
        },
        {
          "hole": 97,
          "x": -176.9135,
          "y": 15,
          "z": -128.2513
        },
        {
          "hole": 98,
          "x": -172.2484,
          "y": 15,
          "z": -135.7533
        },
        {
          "hole": 99,
          "x": -167.1027,
          "y": 15,
          "z": -142.9341
        },
        {
          "hole": 100,
          "x": -161.4984,
          "y": 15,
          "z": -149.763
        },
        {
          "hole": 101,
          "x": -149.0117,
          "y": 15,
          "z": -162.2497
        },
        {
          "hole": 102,
          "x": -142.1828,
          "y": 15,
          "z": -167.854
        },
        {
          "hole": 103,
          "x": -135.002,
          "y": 15,
          "z": -172.9997
        },
        {
          "hole": 104,
          "x": -127.5,
          "y": 15,
          "z": -177.6647
        },
        {
          "hole": 105,
          "x": -119.709,
          "y": 15,
          "z": -181.8291
        },
        {
          "hole": 106,
          "x": -103.3944,
          "y": 15,
          "z": -188.5869
        },
        {
          "hole": 107,
          "x": -94.9406,
          "y": 15,
          "z": -191.1513
        },
        {
          "hole": 108,
          "x": -86.3372,
          "y": 15,
          "z": -193.1573
        },
        {
          "hole": 109,
          "x": -77.6211,
          "y": 15,
          "z": -194.5964
        },
        {
          "hole": 110,
          "x": -68.8295,
          "y": 15,
          "z": -195.4623
        },
        {
          "hole": 111,
          "x": -51.1706,
          "y": 15,
          "z": -195.4623
        },
        {
          "hole": 112,
          "x": -42.379,
          "y": 15,
          "z": -194.5964
        },
        {
          "hole": 113,
          "x": -33.6628,
          "y": 15,
          "z": -193.1573
        },
        {
          "hole": 114,
          "x": -25.0595,
          "y": 15,
          "z": -191.1513
        },
        {
          "hole": 115,
          "x": -16.6057,
          "y": 15,
          "z": -188.5869
        },
        {
          "hole": 116,
          "x": -0.2911,
          "y": 15,
          "z": -181.8291
        },
        {
          "hole": 117,
          "x": 7.5,
          "y": 15,
          "z": -177.6647
        },
        {
          "hole": 118,
          "x": 15.0019,
          "y": 15,
          "z": -172.9997
        },
        {
          "hole": 119,
          "x": 22.1828,
          "y": 15,
          "z": -167.854
        },
        {
          "hole": 120,
          "x": 29.0117,
          "y": 15,
          "z": -162.2497
        },
        {
          "hole": 121,
          "x": 41.4983,
          "y": 15,
          "z": -149.763
        },
        {
          "hole": 122,
          "x": 47.1027,
          "y": 15,
          "z": -142.9341
        },
        {
          "hole": 123,
          "x": 52.2484,
          "y": 15,
          "z": -135.7533
        },
        {
          "hole": 124,
          "x": 56.9134,
          "y": 15,
          "z": -128.2513
        },
        {
          "hole": 125,
          "x": 61.0778,
          "y": 15,
          "z": -120.4603
        },
        {
          "hole": 126,
          "x": 67.8355,
          "y": 15,
          "z": -104.1456
        },
        {
          "hole": 127,
          "x": 70.3999,
          "y": 15,
          "z": -95.6919
        },
        {
          "hole": 128,
          "x": 72.406,
          "y": 15,
          "z": -87.0885
        },
        {
          "hole": 129,
          "x": 73.845,
          "y": 15,
          "z": -78.3723
        },
        {
          "hole": 130,
          "x": 74.7109,
          "y": 15,
          "z": -69.5807
        },
        {
          "hole": 121,
          "x": 80,
          "y": 15,
          "z": 118.8283
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": 127,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 1,
          "x": 135.5,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 2,
          "x": 127.75,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 3,
          "x": 120,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 4,
          "x": 112.25,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 5,
          "x": 104.5,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 6,
          "x": 175.5,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 7,
          "x": 167.75,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 8,
          "x": 160,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 9,
          "x": 152.25,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 10,
          "x": 144.5,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 11,
          "x": 215.5,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 12,
          "x": 207.75,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 13,
          "x": 200,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 14,
          "x": 192.25,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 15,
          "x": 184.5,
          "y": 15,
          "z": -25.4951
        },
        {
          "hole": 16,
          "x": 225,
          "y": 15,
          "z": -25.7513
        },
        {
          "hole": 17,
          "x": 232.5,
          "y": 15,
          "z": -25.7513
        },
        {
          "hole": 18,
          "x": 243.5355,
          "y": 15,
          "z": -24.2869
        },
        {
          "hole": 19,
          "x": 245,
          "y": 15,
          "z": -13.2513
        },
        {
          "hole": 20,
          "x": 245,
          "y": 15,
          "z": -5.7513
        },
        {
          "hole": 21,
          "x": 245,
          "y": 15,
          "z": 43.8283
        },
        {
          "hole": 22,
          "x": 245,
          "y": 15,
          "z": 51.3283
        },
        {
          "hole": 23,
          "x": 243.5355,
          "y": 15,
          "z": 62.3638
        },
        {
          "hole": 24,
          "x": 232.5,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 25,
          "x": 225,
          "y": 15,
          "z": 63.8283
        },
        {
          "hole": 26,
          "x": 175.5,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 27,
          "x": 167.75,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 28,
          "x": 160,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 29,
          "x": 152.25,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 30,
          "x": 144.5,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 31,
          "x": 215.5,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 32,
          "x": 207.75,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 33,
          "x": 200,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 34,
          "x": 192.25,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 35,
          "x": 184.5,
          "y": 15,
          "z": 93.8283
        },
        {
          "hole": 36,
          "x": 65,
          "y": 15,
          "z": 174.3282
        },
        {
          "hole": 37,
          "x": 65,
          "y": 15,
          "z": 166.5782
        },
        {
          "hole": 38,
          "x": 65,
          "y": 15,
          "z": 158.8282
        },
        {
          "hole": 39,
          "x": 65,
          "y": 15,
          "z": 151.0782
        },
        {
          "hole": 40,
          "x": 65,
          "y": 15,
          "z": 143.3282
        },
        {
          "hole": 41,
          "x": 65,
          "y": 15,
          "z": 214.3282
        },
        {
          "hole": 42,
          "x": 65,
          "y": 15,
          "z": 206.5782
        },
        {
          "hole": 43,
          "x": 65,
          "y": 15,
          "z": 198.8282
        },
        {
          "hole": 44,
          "x": 65,
          "y": 15,
          "z": 191.0782
        },
        {
          "hole": 45,
          "x": 65,
          "y": 15,
          "z": 183.3282
        },
        {
          "hole": 46,
          "x": 65,
          "y": 15,
          "z": 223.8282
        },
        {
          "hole": 47,
          "x": 65,
          "y": 15,
          "z": 231.3282
        },
        {
          "hole": 48,
          "x": 63.5355,
          "y": 15,
          "z": 242.3638
        },
        {
          "hole": 49,
          "x": 52.5,
          "y": 15,
          "z": 243.8282
        },
        {
          "hole": 50,
          "x": 45,
          "y": 15,
          "z": 243.8282
        },
        {
          "hole": 51,
          "x": -5,
          "y": 15,
          "z": 243.8282
        },
        {
          "hole": 52,
          "x": -12.5,
          "y": 15,
          "z": 243.8282
        },
        {
          "hole": 53,
          "x": -23.5356,
          "y": 15,
          "z": 242.3638
        },
        {
          "hole": 54,
          "x": -25,
          "y": 15,
          "z": 231.3282
        },
        {
          "hole": 55,
          "x": -25,
          "y": 15,
          "z": 223.8282
        },
        {
          "hole": 56,
          "x": -55.014,
          "y": 15,
          "z": 214.3282
        },
        {
          "hole": 57,
          "x": -55.014,
          "y": 15,
          "z": 206.5782
        },
        {
          "hole": 58,
          "x": -55.014,
          "y": 15,
          "z": 198.8282
        },
        {
          "hole": 59,
          "x": -55.014,
          "y": 15,
          "z": 191.0782
        },
        {
          "hole": 60,
          "x": -55.014,
          "y": 15,
          "z": 183.3282
        },
        {
          "hole": 61,
          "x": -55.014,
          "y": 15,
          "z": 174.3282
        },
        {
          "hole": 62,
          "x": -55.014,
          "y": 15,
          "z": 166.5782
        },
        {
          "hole": 63,
          "x": -55.014,
          "y": 15,
          "z": 158.8282
        },
        {
          "hole": 64,
          "x": -55.014,
          "y": 15,
          "z": 151.0782
        },
        {
          "hole": 65,
          "x": -55.014,
          "y": 15,
          "z": 143.3282
        },
        {
          "hole": 66,
          "x": -55.014,
          "y": 15,
          "z": 134.7536
        },
        {
          "hole": 67,
          "x": -55.014,
          "y": 15,
          "z": 127.0036
        },
        {
          "hole": 68,
          "x": -55.014,
          "y": 15,
          "z": 119.2536
        },
        {
          "hole": 69,
          "x": -55.014,
          "y": 15,
          "z": 111.5036
        },
        {
          "hole": 70,
          "x": -55.014,
          "y": 15,
          "z": 103.7536
        },
        {
          "hole": 71,
          "x": -68.1754,
          "y": 15,
          "z": 63.9811
        },
        {
          "hole": 72,
          "x": -76.3158,
          "y": 15,
          "z": 63.1793
        },
        {
          "hole": 73,
          "x": -84.3863,
          "y": 15,
          "z": 61.8468
        },
        {
          "hole": 74,
          "x": -92.3524,
          "y": 15,
          "z": 59.9894
        },
        {
          "hole": 75,
          "x": -100.18,
          "y": 15,
          "z": 57.615
        },
        {
          "hole": 76,
          "x": -115.2861,
          "y": 15,
          "z": 51.3578
        },
        {
          "hole": 77,
          "x": -122.5,
          "y": 15,
          "z": 47.5019
        },
        {
          "hole": 78,
          "x": -129.4463,
          "y": 15,
          "z": 43.1824
        },
        {
          "hole": 79,
          "x": -136.0952,
          "y": 15,
          "z": 38.4179
        },
        {
          "hole": 80,
          "x": -142.4183,
          "y": 15,
          "z": 33.2287
        },
        {
          "hole": 81,
          "x": -153.98,
          "y": 15,
          "z": 21.6669
        },
        {
          "hole": 82,
          "x": -159.1692,
          "y": 15,
          "z": 15.3439
        },
        {
          "hole": 83,
          "x": -163.9337,
          "y": 15,
          "z": 8.695
        },
        {
          "hole": 84,
          "x": -168.2532,
          "y": 15,
          "z": 1.7487
        },
        {
          "hole": 85,
          "x": -172.1091,
          "y": 15,
          "z": -5.4652
        },
        {
          "hole": 86,
          "x": -178.3663,
          "y": 15,
          "z": -20.5714
        },
        {
          "hole": 87,
          "x": -180.7408,
          "y": 15,
          "z": -28.3989
        },
        {
          "hole": 88,
          "x": -182.5982,
          "y": 15,
          "z": -36.365
        },
        {
          "hole": 89,
          "x": -183.9306,
          "y": 15,
          "z": -44.4355
        },
        {
          "hole": 90,
          "x": -184.7324,
          "y": 15,
          "z": -52.5759
        },
        {
          "hole": 91,
          "x": -184.7324,
          "y": 15,
          "z": -68.9267
        },
        {
          "hole": 92,
          "x": -183.9306,
          "y": 15,
          "z": -77.0671
        },
        {
          "hole": 93,
          "x": -182.5982,
          "y": 15,
          "z": -85.1376
        },
        {
          "hole": 94,
          "x": -180.7408,
          "y": 15,
          "z": -93.1037
        },
        {
          "hole": 95,
          "x": -178.3663,
          "y": 15,
          "z": -100.9312
        },
        {
          "hole": 96,
          "x": -172.1091,
          "y": 15,
          "z": -116.0374
        },
        {
          "hole": 97,
          "x": -168.2532,
          "y": 15,
          "z": -123.2513
        },
        {
          "hole": 98,
          "x": -163.9337,
          "y": 15,
          "z": -130.1976
        },
        {
          "hole": 99,
          "x": -159.1692,
          "y": 15,
          "z": -136.8465
        },
        {
          "hole": 100,
          "x": -153.98,
          "y": 15,
          "z": -143.1695
        },
        {
          "hole": 101,
          "x": -142.4183,
          "y": 15,
          "z": -154.7313
        },
        {
          "hole": 102,
          "x": -136.0952,
          "y": 15,
          "z": -159.9205
        },
        {
          "hole": 103,
          "x": -129.4463,
          "y": 15,
          "z": -164.685
        },
        {
          "hole": 104,
          "x": -122.5,
          "y": 15,
          "z": -169.0045
        },
        {
          "hole": 105,
          "x": -115.2861,
          "y": 15,
          "z": -172.8604
        },
        {
          "hole": 106,
          "x": -100.18,
          "y": 15,
          "z": -179.1176
        },
        {
          "hole": 107,
          "x": -92.3524,
          "y": 15,
          "z": -181.492
        },
        {
          "hole": 108,
          "x": -84.3863,
          "y": 15,
          "z": -183.3495
        },
        {
          "hole": 109,
          "x": -76.3158,
          "y": 15,
          "z": -184.6819
        },
        {
          "hole": 110,
          "x": -68.1754,
          "y": 15,
          "z": -185.4837
        },
        {
          "hole": 111,
          "x": -51.8246,
          "y": 15,
          "z": -185.4837
        },
        {
          "hole": 112,
          "x": -43.6843,
          "y": 15,
          "z": -184.6819
        },
        {
          "hole": 113,
          "x": -35.6137,
          "y": 15,
          "z": -183.3495
        },
        {
          "hole": 114,
          "x": -27.6477,
          "y": 15,
          "z": -181.492
        },
        {
          "hole": 115,
          "x": -19.8201,
          "y": 15,
          "z": -179.1176
        },
        {
          "hole": 116,
          "x": -4.7139,
          "y": 15,
          "z": -172.8604
        },
        {
          "hole": 117,
          "x": 2.5,
          "y": 15,
          "z": -169.0045
        },
        {
          "hole": 118,
          "x": 9.4462,
          "y": 15,
          "z": -164.685
        },
        {
          "hole": 119,
          "x": 16.0951,
          "y": 15,
          "z": -159.9205
        },
        {
          "hole": 120,
          "x": 22.4182,
          "y": 15,
          "z": -154.7313
        },
        {
          "hole": 121,
          "x": 33.9799,
          "y": 15,
          "z": -143.1695
        },
        {
          "hole": 122,
          "x": 39.1691,
          "y": 15,
          "z": -136.8465
        },
        {
          "hole": 123,
          "x": 43.9337,
          "y": 15,
          "z": -130.1976
        },
        {
          "hole": 124,
          "x": 48.2531,
          "y": 15,
          "z": -123.2513
        },
        {
          "hole": 125,
          "x": 52.1091,
          "y": 15,
          "z": -116.0374
        },
        {
          "hole": 126,
          "x": 58.3662,
          "y": 15,
          "z": -100.9312
        },
        {
          "hole": 127,
          "x": 60.7407,
          "y": 15,
          "z": -93.1037
        },
        {
          "hole": 128,
          "x": 62.5981,
          "y": 15,
          "z": -85.1376
        },
        {
          "hole": 129,
          "x": 63.9306,
          "y": 15,
          "z": -77.0671
        },
        {
          "hole": 130,
          "x": 64.7323,
          "y": 15,
          "z": -68.9267
        },
        {
          "hole": 121,
          "x": 80,
          "y": 15,
          "z": 118.8283
        }
      ]
    }
  },
  {
    "id": "board-cribbage-clash",
    "name": "Cribbage Clash",
    "brand": "clash",
    "desc": "Cribbage Clash 3D cribbage board (13.7 MB)",
    "target": 481,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/image_2026-09-28_120348350.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/5a81785101a7f569/cribbage-clash-no-bgimage.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 13,
          "y": 5,
          "z": 175
        },
        {
          "hole": 1,
          "x": 44.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 2,
          "x": 52.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 3,
          "x": 60,
          "y": 5,
          "z": 175
        },
        {
          "hole": 4,
          "x": 67.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 5,
          "x": 75.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 6,
          "x": 84.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 7,
          "x": 92.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 8,
          "x": 100,
          "y": 5,
          "z": 175
        },
        {
          "hole": 9,
          "x": 107.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 10,
          "x": 115.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 11,
          "x": 124.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 12,
          "x": 132.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 13,
          "x": 140,
          "y": 5,
          "z": 175
        },
        {
          "hole": 14,
          "x": 147.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 15,
          "x": 155.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 16,
          "x": 164.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 17,
          "x": 172.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 18,
          "x": 180,
          "y": 5,
          "z": 175
        },
        {
          "hole": 19,
          "x": 187.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 20,
          "x": 195.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 21,
          "x": 204.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 22,
          "x": 212.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 23,
          "x": 220,
          "y": 5,
          "z": 175
        },
        {
          "hole": 24,
          "x": 227.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 25,
          "x": 235.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 26,
          "x": 254.235,
          "y": 5,
          "z": 173.1259
        },
        {
          "hole": 27,
          "x": 267.5,
          "y": 5,
          "z": 167.6314
        },
        {
          "hole": 28,
          "x": 278.8909,
          "y": 5,
          "z": 158.8909
        },
        {
          "hole": 29,
          "x": 287.6314,
          "y": 5,
          "z": 147.5
        },
        {
          "hole": 30,
          "x": 293.1259,
          "y": 5,
          "z": 134.235
        },
        {
          "hole": 31,
          "x": 295,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 32,
          "x": 295,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 33,
          "x": 295,
          "y": 5,
          "z": 100
        },
        {
          "hole": 34,
          "x": 295,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 35,
          "x": 295,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 36,
          "x": 295,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 37,
          "x": 295,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 38,
          "x": 295,
          "y": 5,
          "z": 60
        },
        {
          "hole": 39,
          "x": 295,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 40,
          "x": 295,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 41,
          "x": 295,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 42,
          "x": 295,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 43,
          "x": 295,
          "y": 5,
          "z": 20
        },
        {
          "hole": 44,
          "x": 295,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 45,
          "x": 295,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 46,
          "x": 295,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 47,
          "x": 295,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 48,
          "x": 295,
          "y": 5,
          "z": -20
        },
        {
          "hole": 49,
          "x": 295,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 50,
          "x": 295,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 51,
          "x": 295,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 52,
          "x": 295,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 53,
          "x": 295,
          "y": 5,
          "z": -60
        },
        {
          "hole": 54,
          "x": 295,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 55,
          "x": 295,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 56,
          "x": 295,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 57,
          "x": 295,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 58,
          "x": 295,
          "y": 5,
          "z": -100
        },
        {
          "hole": 59,
          "x": 295,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 60,
          "x": 295,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 61,
          "x": 295,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 62,
          "x": 295,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 63,
          "x": 295,
          "y": 5,
          "z": -140
        },
        {
          "hole": 64,
          "x": 295,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 65,
          "x": 295,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 66,
          "x": 295,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 67,
          "x": 295,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 68,
          "x": 295,
          "y": 5,
          "z": -180
        },
        {
          "hole": 69,
          "x": 295,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 70,
          "x": 295,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 71,
          "x": 295,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 72,
          "x": 295,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 73,
          "x": 295,
          "y": 5,
          "z": -220
        },
        {
          "hole": 74,
          "x": 295,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 75,
          "x": 295,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 76,
          "x": 295,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 77,
          "x": 295,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 78,
          "x": 295,
          "y": 5,
          "z": -260
        },
        {
          "hole": 79,
          "x": 295,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 80,
          "x": 295,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 81,
          "x": 293.1259,
          "y": 5,
          "z": -294.235
        },
        {
          "hole": 82,
          "x": 287.6314,
          "y": 5,
          "z": -307.5
        },
        {
          "hole": 83,
          "x": 278.8909,
          "y": 5,
          "z": -318.8909
        },
        {
          "hole": 84,
          "x": 267.5,
          "y": 5,
          "z": -327.6314
        },
        {
          "hole": 85,
          "x": 254.235,
          "y": 5,
          "z": -333.1259
        },
        {
          "hole": 86,
          "x": 225.765,
          "y": 5,
          "z": -333.1259
        },
        {
          "hole": 87,
          "x": 212.5,
          "y": 5,
          "z": -327.6314
        },
        {
          "hole": 88,
          "x": 201.1091,
          "y": 5,
          "z": -318.8909
        },
        {
          "hole": 89,
          "x": 192.3686,
          "y": 5,
          "z": -307.5
        },
        {
          "hole": 90,
          "x": 186.8741,
          "y": 5,
          "z": -294.235
        },
        {
          "hole": 91,
          "x": 185,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 92,
          "x": 185,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 93,
          "x": 185,
          "y": 5,
          "z": -260
        },
        {
          "hole": 94,
          "x": 185,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 95,
          "x": 185,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 96,
          "x": 185,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 97,
          "x": 185,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 98,
          "x": 185,
          "y": 5,
          "z": -220
        },
        {
          "hole": 99,
          "x": 185,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 100,
          "x": 185,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 101,
          "x": 185,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 102,
          "x": 185,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 103,
          "x": 185,
          "y": 5,
          "z": -180
        },
        {
          "hole": 104,
          "x": 185,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 105,
          "x": 185,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 106,
          "x": 185,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 107,
          "x": 185,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 108,
          "x": 185,
          "y": 5,
          "z": -140
        },
        {
          "hole": 109,
          "x": 185,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 110,
          "x": 185,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 111,
          "x": 185,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 112,
          "x": 185,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 113,
          "x": 185,
          "y": 5,
          "z": -100
        },
        {
          "hole": 114,
          "x": 185,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 115,
          "x": 185,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 116,
          "x": 185,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 117,
          "x": 185,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 118,
          "x": 185,
          "y": 5,
          "z": -60
        },
        {
          "hole": 119,
          "x": 185,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 120,
          "x": 185,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 121,
          "x": 185,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 122,
          "x": 185,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 123,
          "x": 185,
          "y": 5,
          "z": -20
        },
        {
          "hole": 124,
          "x": 185,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 125,
          "x": 185,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 126,
          "x": 185,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 127,
          "x": 185,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 128,
          "x": 185,
          "y": 5,
          "z": 20
        },
        {
          "hole": 129,
          "x": 185,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 130,
          "x": 185,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 131,
          "x": 184.1481,
          "y": 5,
          "z": 46.4705
        },
        {
          "hole": 132,
          "x": 181.6506,
          "y": 5,
          "z": 52.5
        },
        {
          "hole": 133,
          "x": 177.6777,
          "y": 5,
          "z": 57.6777
        },
        {
          "hole": 134,
          "x": 172.5,
          "y": 5,
          "z": 61.6506
        },
        {
          "hole": 135,
          "x": 166.4705,
          "y": 5,
          "z": 64.1481
        },
        {
          "hole": 136,
          "x": 153.5295,
          "y": 5,
          "z": 64.1481
        },
        {
          "hole": 137,
          "x": 147.5,
          "y": 5,
          "z": 61.6506
        },
        {
          "hole": 138,
          "x": 142.3223,
          "y": 5,
          "z": 57.6777
        },
        {
          "hole": 139,
          "x": 138.3494,
          "y": 5,
          "z": 52.5
        },
        {
          "hole": 140,
          "x": 135.8519,
          "y": 5,
          "z": 46.4705
        },
        {
          "hole": 141,
          "x": 135,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 142,
          "x": 135,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 143,
          "x": 135,
          "y": 5,
          "z": 20
        },
        {
          "hole": 144,
          "x": 135,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 145,
          "x": 135,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 146,
          "x": 135,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 147,
          "x": 135,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 148,
          "x": 135,
          "y": 5,
          "z": -20
        },
        {
          "hole": 149,
          "x": 135,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 150,
          "x": 135,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 151,
          "x": 135,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 152,
          "x": 135,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 153,
          "x": 135,
          "y": 5,
          "z": -60
        },
        {
          "hole": 154,
          "x": 135,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 155,
          "x": 135,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 156,
          "x": 135,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 157,
          "x": 135,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 158,
          "x": 135,
          "y": 5,
          "z": -100
        },
        {
          "hole": 159,
          "x": 135,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 160,
          "x": 135,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 161,
          "x": 135,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 162,
          "x": 135,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 163,
          "x": 135,
          "y": 5,
          "z": -140
        },
        {
          "hole": 164,
          "x": 135,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 165,
          "x": 135,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 166,
          "x": 135,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 167,
          "x": 135,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 168,
          "x": 135,
          "y": 5,
          "z": -180
        },
        {
          "hole": 169,
          "x": 135,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 170,
          "x": 135,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 171,
          "x": 135,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 172,
          "x": 135,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 173,
          "x": 135,
          "y": 5,
          "z": -220
        },
        {
          "hole": 174,
          "x": 135,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 175,
          "x": 135,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 176,
          "x": 135,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 177,
          "x": 135,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 178,
          "x": 135,
          "y": 5,
          "z": -260
        },
        {
          "hole": 179,
          "x": 135,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 180,
          "x": 135,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 181,
          "x": 133.1259,
          "y": 5,
          "z": -294.235
        },
        {
          "hole": 182,
          "x": 127.6314,
          "y": 5,
          "z": -307.5
        },
        {
          "hole": 183,
          "x": 118.8909,
          "y": 5,
          "z": -318.8909
        },
        {
          "hole": 184,
          "x": 107.5,
          "y": 5,
          "z": -327.6314
        },
        {
          "hole": 185,
          "x": 94.235,
          "y": 5,
          "z": -333.1259
        },
        {
          "hole": 186,
          "x": 65.765,
          "y": 5,
          "z": -333.1259
        },
        {
          "hole": 187,
          "x": 52.5,
          "y": 5,
          "z": -327.6314
        },
        {
          "hole": 188,
          "x": 41.1091,
          "y": 5,
          "z": -318.8909
        },
        {
          "hole": 189,
          "x": 32.3686,
          "y": 5,
          "z": -307.5
        },
        {
          "hole": 190,
          "x": 26.8741,
          "y": 5,
          "z": -294.235
        },
        {
          "hole": 191,
          "x": 25,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 192,
          "x": 25,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 193,
          "x": 25,
          "y": 5,
          "z": -260
        },
        {
          "hole": 194,
          "x": 25,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 195,
          "x": 25,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 196,
          "x": 25,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 197,
          "x": 25,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 198,
          "x": 25,
          "y": 5,
          "z": -220
        },
        {
          "hole": 199,
          "x": 25,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 200,
          "x": 25,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 201,
          "x": 25,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 202,
          "x": 25,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 203,
          "x": 25,
          "y": 5,
          "z": -180
        },
        {
          "hole": 204,
          "x": 25,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 205,
          "x": 25,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 206,
          "x": 25,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 207,
          "x": 25,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 208,
          "x": 25,
          "y": 5,
          "z": -140
        },
        {
          "hole": 209,
          "x": 25,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 210,
          "x": 25,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 211,
          "x": 25,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 212,
          "x": 25,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 213,
          "x": 25,
          "y": 5,
          "z": -100
        },
        {
          "hole": 214,
          "x": 25,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 215,
          "x": 25,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 216,
          "x": 25,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 217,
          "x": 25,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 218,
          "x": 25,
          "y": 5,
          "z": -60
        },
        {
          "hole": 219,
          "x": 25,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 220,
          "x": 25,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 221,
          "x": 25,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 222,
          "x": 25,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 223,
          "x": 25,
          "y": 5,
          "z": -20
        },
        {
          "hole": 224,
          "x": 25,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 225,
          "x": 25,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 226,
          "x": 25,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 227,
          "x": 25,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 228,
          "x": 25,
          "y": 5,
          "z": 20
        },
        {
          "hole": 229,
          "x": 25,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 230,
          "x": 25,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 231,
          "x": 25,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 232,
          "x": 25,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 233,
          "x": 25,
          "y": 5,
          "z": 60
        },
        {
          "hole": 234,
          "x": 25,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 235,
          "x": 25,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 236,
          "x": 24.1481,
          "y": 5,
          "z": 86.4705
        },
        {
          "hole": 237,
          "x": 21.6506,
          "y": 5,
          "z": 92.5
        },
        {
          "hole": 238,
          "x": 17.6777,
          "y": 5,
          "z": 97.6777
        },
        {
          "hole": 239,
          "x": 12.5,
          "y": 5,
          "z": 101.6506
        },
        {
          "hole": 240,
          "x": 6.4705,
          "y": 5,
          "z": 104.1481
        },
        {
          "hole": 241,
          "x": -6.4705,
          "y": 5,
          "z": 104.1481
        },
        {
          "hole": 242,
          "x": -12.5,
          "y": 5,
          "z": 101.6506
        },
        {
          "hole": 243,
          "x": -17.6777,
          "y": 5,
          "z": 97.6777
        },
        {
          "hole": 244,
          "x": -21.6506,
          "y": 5,
          "z": 92.5
        },
        {
          "hole": 245,
          "x": -24.1481,
          "y": 5,
          "z": 86.4705
        },
        {
          "hole": 246,
          "x": -25,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 247,
          "x": -25,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 248,
          "x": -25,
          "y": 5,
          "z": 60
        },
        {
          "hole": 249,
          "x": -25,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 250,
          "x": -25,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 251,
          "x": -25,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 252,
          "x": -25,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 253,
          "x": -25,
          "y": 5,
          "z": 20
        },
        {
          "hole": 254,
          "x": -25,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 255,
          "x": -25,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 256,
          "x": -25,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 257,
          "x": -25,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 258,
          "x": -25,
          "y": 5,
          "z": -20
        },
        {
          "hole": 259,
          "x": -25,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 260,
          "x": -25,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 261,
          "x": -25,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 262,
          "x": -25,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 263,
          "x": -25,
          "y": 5,
          "z": -60
        },
        {
          "hole": 264,
          "x": -25,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 265,
          "x": -25,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 266,
          "x": -25,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 267,
          "x": -25,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 268,
          "x": -25,
          "y": 5,
          "z": -100
        },
        {
          "hole": 269,
          "x": -25,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 270,
          "x": -25,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 271,
          "x": -25,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 272,
          "x": -25,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 273,
          "x": -25,
          "y": 5,
          "z": -140
        },
        {
          "hole": 274,
          "x": -25,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 275,
          "x": -25,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 276,
          "x": -25,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 277,
          "x": -25,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 278,
          "x": -25,
          "y": 5,
          "z": -180
        },
        {
          "hole": 279,
          "x": -25,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 280,
          "x": -25,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 281,
          "x": -25,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 282,
          "x": -25,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 283,
          "x": -25,
          "y": 5,
          "z": -220
        },
        {
          "hole": 284,
          "x": -25,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 285,
          "x": -25,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 286,
          "x": -25,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 287,
          "x": -25,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 288,
          "x": -25,
          "y": 5,
          "z": -260
        },
        {
          "hole": 289,
          "x": -25,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 290,
          "x": -25,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 291,
          "x": -26.8741,
          "y": 5,
          "z": -294.235
        },
        {
          "hole": 292,
          "x": -32.3686,
          "y": 5,
          "z": -307.5
        },
        {
          "hole": 293,
          "x": -41.1091,
          "y": 5,
          "z": -318.8909
        },
        {
          "hole": 294,
          "x": -52.5,
          "y": 5,
          "z": -327.6314
        },
        {
          "hole": 295,
          "x": -65.765,
          "y": 5,
          "z": -333.1259
        },
        {
          "hole": 296,
          "x": -94.235,
          "y": 5,
          "z": -333.1259
        },
        {
          "hole": 297,
          "x": -107.5,
          "y": 5,
          "z": -327.6314
        },
        {
          "hole": 298,
          "x": -118.8909,
          "y": 5,
          "z": -318.8909
        },
        {
          "hole": 299,
          "x": -127.6314,
          "y": 5,
          "z": -307.5
        },
        {
          "hole": 300,
          "x": -133.1259,
          "y": 5,
          "z": -294.235
        },
        {
          "hole": 301,
          "x": -135,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 302,
          "x": -135,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 303,
          "x": -135,
          "y": 5,
          "z": -260
        },
        {
          "hole": 304,
          "x": -135,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 305,
          "x": -135,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 306,
          "x": -135,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 307,
          "x": -135,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 308,
          "x": -135,
          "y": 5,
          "z": -220
        },
        {
          "hole": 309,
          "x": -135,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 310,
          "x": -135,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 311,
          "x": -135,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 312,
          "x": -135,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 313,
          "x": -135,
          "y": 5,
          "z": -180
        },
        {
          "hole": 314,
          "x": -135,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 315,
          "x": -135,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 316,
          "x": -135,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 317,
          "x": -135,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 318,
          "x": -135,
          "y": 5,
          "z": -140
        },
        {
          "hole": 319,
          "x": -135,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 320,
          "x": -135,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 321,
          "x": -135,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 322,
          "x": -135,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 323,
          "x": -135,
          "y": 5,
          "z": -100
        },
        {
          "hole": 324,
          "x": -135,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 325,
          "x": -135,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 326,
          "x": -135,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 327,
          "x": -135,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 328,
          "x": -135,
          "y": 5,
          "z": -60
        },
        {
          "hole": 329,
          "x": -135,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 330,
          "x": -135,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 331,
          "x": -135,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 332,
          "x": -135,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 333,
          "x": -135,
          "y": 5,
          "z": -20
        },
        {
          "hole": 334,
          "x": -135,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 335,
          "x": -135,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 336,
          "x": -135,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 337,
          "x": -135,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 338,
          "x": -135,
          "y": 5,
          "z": 20
        },
        {
          "hole": 339,
          "x": -135,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 340,
          "x": -135,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 341,
          "x": -135.8519,
          "y": 5,
          "z": 46.4705
        },
        {
          "hole": 342,
          "x": -138.3494,
          "y": 5,
          "z": 52.5
        },
        {
          "hole": 343,
          "x": -142.3223,
          "y": 5,
          "z": 57.6777
        },
        {
          "hole": 344,
          "x": -147.5,
          "y": 5,
          "z": 61.6506
        },
        {
          "hole": 345,
          "x": -153.5295,
          "y": 5,
          "z": 64.1481
        },
        {
          "hole": 346,
          "x": -166.4705,
          "y": 5,
          "z": 64.1481
        },
        {
          "hole": 347,
          "x": -172.5,
          "y": 5,
          "z": 61.6506
        },
        {
          "hole": 348,
          "x": -177.6777,
          "y": 5,
          "z": 57.6777
        },
        {
          "hole": 349,
          "x": -181.6506,
          "y": 5,
          "z": 52.5
        },
        {
          "hole": 350,
          "x": -184.1481,
          "y": 5,
          "z": 46.4705
        },
        {
          "hole": 351,
          "x": -185,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 352,
          "x": -185,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 353,
          "x": -185,
          "y": 5,
          "z": 20
        },
        {
          "hole": 354,
          "x": -185,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 355,
          "x": -185,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 356,
          "x": -185,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 357,
          "x": -185,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 358,
          "x": -185,
          "y": 5,
          "z": -20
        },
        {
          "hole": 359,
          "x": -185,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 360,
          "x": -185,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 361,
          "x": -185,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 362,
          "x": -185,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 363,
          "x": -185,
          "y": 5,
          "z": -60
        },
        {
          "hole": 364,
          "x": -185,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 365,
          "x": -185,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 366,
          "x": -185,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 367,
          "x": -185,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 368,
          "x": -185,
          "y": 5,
          "z": -100
        },
        {
          "hole": 369,
          "x": -185,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 370,
          "x": -185,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 371,
          "x": -185,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 372,
          "x": -185,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 373,
          "x": -185,
          "y": 5,
          "z": -140
        },
        {
          "hole": 374,
          "x": -185,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 375,
          "x": -185,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 376,
          "x": -185,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 377,
          "x": -185,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 378,
          "x": -185,
          "y": 5,
          "z": -180
        },
        {
          "hole": 379,
          "x": -185,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 380,
          "x": -185,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 381,
          "x": -185,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 382,
          "x": -185,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 383,
          "x": -185,
          "y": 5,
          "z": -220
        },
        {
          "hole": 384,
          "x": -185,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 385,
          "x": -185,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 386,
          "x": -185,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 387,
          "x": -185,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 388,
          "x": -185,
          "y": 5,
          "z": -260
        },
        {
          "hole": 389,
          "x": -185,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 390,
          "x": -185,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 391,
          "x": -186.8741,
          "y": 5,
          "z": -294.235
        },
        {
          "hole": 392,
          "x": -192.3686,
          "y": 5,
          "z": -307.5
        },
        {
          "hole": 393,
          "x": -201.1091,
          "y": 5,
          "z": -318.8909
        },
        {
          "hole": 394,
          "x": -212.5,
          "y": 5,
          "z": -327.6314
        },
        {
          "hole": 395,
          "x": -225.765,
          "y": 5,
          "z": -333.1259
        },
        {
          "hole": 396,
          "x": -254.235,
          "y": 5,
          "z": -333.1259
        },
        {
          "hole": 397,
          "x": -267.5,
          "y": 5,
          "z": -327.6314
        },
        {
          "hole": 398,
          "x": -278.8909,
          "y": 5,
          "z": -318.8909
        },
        {
          "hole": 399,
          "x": -287.6314,
          "y": 5,
          "z": -307.5
        },
        {
          "hole": 400,
          "x": -293.1259,
          "y": 5,
          "z": -294.235
        },
        {
          "hole": 401,
          "x": -295,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 402,
          "x": -295,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 403,
          "x": -295,
          "y": 5,
          "z": -260
        },
        {
          "hole": 404,
          "x": -295,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 405,
          "x": -295,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 406,
          "x": -295,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 407,
          "x": -295,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 408,
          "x": -295,
          "y": 5,
          "z": -220
        },
        {
          "hole": 409,
          "x": -295,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 410,
          "x": -295,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 411,
          "x": -295,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 412,
          "x": -295,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 413,
          "x": -295,
          "y": 5,
          "z": -180
        },
        {
          "hole": 414,
          "x": -295,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 415,
          "x": -295,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 416,
          "x": -295,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 417,
          "x": -295,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 418,
          "x": -295,
          "y": 5,
          "z": -140
        },
        {
          "hole": 419,
          "x": -295,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 420,
          "x": -295,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 421,
          "x": -295,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 422,
          "x": -295,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 423,
          "x": -295,
          "y": 5,
          "z": -100
        },
        {
          "hole": 424,
          "x": -295,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 425,
          "x": -295,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 426,
          "x": -295,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 427,
          "x": -295,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 428,
          "x": -295,
          "y": 5,
          "z": -60
        },
        {
          "hole": 429,
          "x": -295,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 430,
          "x": -295,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 431,
          "x": -295,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 432,
          "x": -295,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 433,
          "x": -295,
          "y": 5,
          "z": -20
        },
        {
          "hole": 434,
          "x": -295,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 435,
          "x": -295,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 436,
          "x": -295,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 437,
          "x": -295,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 438,
          "x": -295,
          "y": 5,
          "z": 20
        },
        {
          "hole": 439,
          "x": -295,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 440,
          "x": -295,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 441,
          "x": -295,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 442,
          "x": -295,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 443,
          "x": -295,
          "y": 5,
          "z": 60
        },
        {
          "hole": 444,
          "x": -295,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 445,
          "x": -295,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 446,
          "x": -295,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 447,
          "x": -295,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 448,
          "x": -295,
          "y": 5,
          "z": 100
        },
        {
          "hole": 449,
          "x": -295,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 450,
          "x": -295,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 451,
          "x": -293.1259,
          "y": 5,
          "z": 134.235
        },
        {
          "hole": 452,
          "x": -287.6314,
          "y": 5,
          "z": 147.5
        },
        {
          "hole": 453,
          "x": -278.8909,
          "y": 5,
          "z": 158.8909
        },
        {
          "hole": 454,
          "x": -267.5,
          "y": 5,
          "z": 167.6314
        },
        {
          "hole": 455,
          "x": -254.235,
          "y": 5,
          "z": 173.1259
        },
        {
          "hole": 456,
          "x": -235.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 457,
          "x": -227.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 458,
          "x": -220,
          "y": 5,
          "z": 175
        },
        {
          "hole": 459,
          "x": -212.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 460,
          "x": -204.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 461,
          "x": -195.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 462,
          "x": -187.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 463,
          "x": -180,
          "y": 5,
          "z": 175
        },
        {
          "hole": 464,
          "x": -172.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 465,
          "x": -164.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 466,
          "x": -155.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 467,
          "x": -147.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 468,
          "x": -140,
          "y": 5,
          "z": 175
        },
        {
          "hole": 469,
          "x": -132.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 470,
          "x": -124.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 471,
          "x": -115.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 472,
          "x": -107.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 473,
          "x": -100,
          "y": 5,
          "z": 175
        },
        {
          "hole": 474,
          "x": -92.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 475,
          "x": -84.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 476,
          "x": -75.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 477,
          "x": -67.75,
          "y": 5,
          "z": 175
        },
        {
          "hole": 478,
          "x": -60,
          "y": 5,
          "z": 175
        },
        {
          "hole": 479,
          "x": -52.25,
          "y": 5,
          "z": 175
        },
        {
          "hole": 480,
          "x": -44.5,
          "y": 5,
          "z": 175
        },
        {
          "hole": 481,
          "x": -20,
          "y": 5,
          "z": 160
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 13,
          "y": 5,
          "z": 165
        },
        {
          "hole": 1,
          "x": 44.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 2,
          "x": 52.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 3,
          "x": 60,
          "y": 5,
          "z": 165
        },
        {
          "hole": 4,
          "x": 67.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 5,
          "x": 75.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 6,
          "x": 84.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 7,
          "x": 92.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 8,
          "x": 100,
          "y": 5,
          "z": 165
        },
        {
          "hole": 9,
          "x": 107.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 10,
          "x": 115.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 11,
          "x": 124.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 12,
          "x": 132.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 13,
          "x": 140,
          "y": 5,
          "z": 165
        },
        {
          "hole": 14,
          "x": 147.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 15,
          "x": 155.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 16,
          "x": 164.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 17,
          "x": 172.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 18,
          "x": 180,
          "y": 5,
          "z": 165
        },
        {
          "hole": 19,
          "x": 187.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 20,
          "x": 195.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 21,
          "x": 204.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 22,
          "x": 212.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 23,
          "x": 220,
          "y": 5,
          "z": 165
        },
        {
          "hole": 24,
          "x": 227.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 25,
          "x": 235.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 26,
          "x": 251.6469,
          "y": 5,
          "z": 163.4667
        },
        {
          "hole": 27,
          "x": 262.5,
          "y": 5,
          "z": 158.9711
        },
        {
          "hole": 28,
          "x": 271.8198,
          "y": 5,
          "z": 151.8198
        },
        {
          "hole": 29,
          "x": 278.9711,
          "y": 5,
          "z": 142.5
        },
        {
          "hole": 30,
          "x": 283.4667,
          "y": 5,
          "z": 131.6469
        },
        {
          "hole": 31,
          "x": 285,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 32,
          "x": 285,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 33,
          "x": 285,
          "y": 5,
          "z": 100
        },
        {
          "hole": 34,
          "x": 285,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 35,
          "x": 285,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 36,
          "x": 285,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 37,
          "x": 285,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 38,
          "x": 285,
          "y": 5,
          "z": 60
        },
        {
          "hole": 39,
          "x": 285,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 40,
          "x": 285,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 41,
          "x": 285,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 42,
          "x": 285,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 43,
          "x": 285,
          "y": 5,
          "z": 20
        },
        {
          "hole": 44,
          "x": 285,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 45,
          "x": 285,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 46,
          "x": 285,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 47,
          "x": 285,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 48,
          "x": 285,
          "y": 5,
          "z": -20
        },
        {
          "hole": 49,
          "x": 285,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 50,
          "x": 285,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 51,
          "x": 285,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 52,
          "x": 285,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 53,
          "x": 285,
          "y": 5,
          "z": -60
        },
        {
          "hole": 54,
          "x": 285,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 55,
          "x": 285,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 56,
          "x": 285,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 57,
          "x": 285,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 58,
          "x": 285,
          "y": 5,
          "z": -100
        },
        {
          "hole": 59,
          "x": 285,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 60,
          "x": 285,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 61,
          "x": 285,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 62,
          "x": 285,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 63,
          "x": 285,
          "y": 5,
          "z": -140
        },
        {
          "hole": 64,
          "x": 285,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 65,
          "x": 285,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 66,
          "x": 285,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 67,
          "x": 285,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 68,
          "x": 285,
          "y": 5,
          "z": -180
        },
        {
          "hole": 69,
          "x": 285,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 70,
          "x": 285,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 71,
          "x": 285,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 72,
          "x": 285,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 73,
          "x": 285,
          "y": 5,
          "z": -220
        },
        {
          "hole": 74,
          "x": 285,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 75,
          "x": 285,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 76,
          "x": 285,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 77,
          "x": 285,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 78,
          "x": 285,
          "y": 5,
          "z": -260
        },
        {
          "hole": 79,
          "x": 285,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 80,
          "x": 285,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 81,
          "x": 283.4667,
          "y": 5,
          "z": -291.6469
        },
        {
          "hole": 82,
          "x": 278.9711,
          "y": 5,
          "z": -302.5
        },
        {
          "hole": 83,
          "x": 271.8198,
          "y": 5,
          "z": -311.8198
        },
        {
          "hole": 84,
          "x": 262.5,
          "y": 5,
          "z": -318.9711
        },
        {
          "hole": 85,
          "x": 251.6469,
          "y": 5,
          "z": -323.4667
        },
        {
          "hole": 86,
          "x": 228.3531,
          "y": 5,
          "z": -323.4667
        },
        {
          "hole": 87,
          "x": 217.5,
          "y": 5,
          "z": -318.9711
        },
        {
          "hole": 88,
          "x": 208.1802,
          "y": 5,
          "z": -311.8198
        },
        {
          "hole": 89,
          "x": 201.0289,
          "y": 5,
          "z": -302.5
        },
        {
          "hole": 90,
          "x": 196.5333,
          "y": 5,
          "z": -291.6469
        },
        {
          "hole": 91,
          "x": 195,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 92,
          "x": 195,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 93,
          "x": 195,
          "y": 5,
          "z": -260
        },
        {
          "hole": 94,
          "x": 195,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 95,
          "x": 195,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 96,
          "x": 195,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 97,
          "x": 195,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 98,
          "x": 195,
          "y": 5,
          "z": -220
        },
        {
          "hole": 99,
          "x": 195,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 100,
          "x": 195,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 101,
          "x": 195,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 102,
          "x": 195,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 103,
          "x": 195,
          "y": 5,
          "z": -180
        },
        {
          "hole": 104,
          "x": 195,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 105,
          "x": 195,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 106,
          "x": 195,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 107,
          "x": 195,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 108,
          "x": 195,
          "y": 5,
          "z": -140
        },
        {
          "hole": 109,
          "x": 195,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 110,
          "x": 195,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 111,
          "x": 195,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 112,
          "x": 195,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 113,
          "x": 195,
          "y": 5,
          "z": -100
        },
        {
          "hole": 114,
          "x": 195,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 115,
          "x": 195,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 116,
          "x": 195,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 117,
          "x": 195,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 118,
          "x": 195,
          "y": 5,
          "z": -60
        },
        {
          "hole": 119,
          "x": 195,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 120,
          "x": 195,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 121,
          "x": 195,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 122,
          "x": 195,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 123,
          "x": 195,
          "y": 5,
          "z": -20
        },
        {
          "hole": 124,
          "x": 195,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 125,
          "x": 195,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 126,
          "x": 195,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 127,
          "x": 195,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 128,
          "x": 195,
          "y": 5,
          "z": 20
        },
        {
          "hole": 129,
          "x": 195,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 130,
          "x": 195,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 131,
          "x": 193.8074,
          "y": 5,
          "z": 49.0587
        },
        {
          "hole": 132,
          "x": 190.3109,
          "y": 5,
          "z": 57.5
        },
        {
          "hole": 133,
          "x": 184.7487,
          "y": 5,
          "z": 64.7487
        },
        {
          "hole": 134,
          "x": 177.5,
          "y": 5,
          "z": 70.3109
        },
        {
          "hole": 135,
          "x": 169.0587,
          "y": 5,
          "z": 73.8074
        },
        {
          "hole": 136,
          "x": 150.9413,
          "y": 5,
          "z": 73.8074
        },
        {
          "hole": 137,
          "x": 142.5,
          "y": 5,
          "z": 70.3109
        },
        {
          "hole": 138,
          "x": 135.2513,
          "y": 5,
          "z": 64.7487
        },
        {
          "hole": 139,
          "x": 129.6891,
          "y": 5,
          "z": 57.5
        },
        {
          "hole": 140,
          "x": 126.1926,
          "y": 5,
          "z": 49.0587
        },
        {
          "hole": 141,
          "x": 125,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 142,
          "x": 125,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 143,
          "x": 125,
          "y": 5,
          "z": 20
        },
        {
          "hole": 144,
          "x": 125,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 145,
          "x": 125,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 146,
          "x": 125,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 147,
          "x": 125,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 148,
          "x": 125,
          "y": 5,
          "z": -20
        },
        {
          "hole": 149,
          "x": 125,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 150,
          "x": 125,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 151,
          "x": 125,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 152,
          "x": 125,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 153,
          "x": 125,
          "y": 5,
          "z": -60
        },
        {
          "hole": 154,
          "x": 125,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 155,
          "x": 125,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 156,
          "x": 125,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 157,
          "x": 125,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 158,
          "x": 125,
          "y": 5,
          "z": -100
        },
        {
          "hole": 159,
          "x": 125,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 160,
          "x": 125,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 161,
          "x": 125,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 162,
          "x": 125,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 163,
          "x": 125,
          "y": 5,
          "z": -140
        },
        {
          "hole": 164,
          "x": 125,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 165,
          "x": 125,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 166,
          "x": 125,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 167,
          "x": 125,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 168,
          "x": 125,
          "y": 5,
          "z": -180
        },
        {
          "hole": 169,
          "x": 125,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 170,
          "x": 125,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 171,
          "x": 125,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 172,
          "x": 125,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 173,
          "x": 125,
          "y": 5,
          "z": -220
        },
        {
          "hole": 174,
          "x": 125,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 175,
          "x": 125,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 176,
          "x": 125,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 177,
          "x": 125,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 178,
          "x": 125,
          "y": 5,
          "z": -260
        },
        {
          "hole": 179,
          "x": 125,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 180,
          "x": 125,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 181,
          "x": 123.4667,
          "y": 5,
          "z": -291.6469
        },
        {
          "hole": 182,
          "x": 118.9711,
          "y": 5,
          "z": -302.5
        },
        {
          "hole": 183,
          "x": 111.8198,
          "y": 5,
          "z": -311.8198
        },
        {
          "hole": 184,
          "x": 102.5,
          "y": 5,
          "z": -318.9711
        },
        {
          "hole": 185,
          "x": 91.6469,
          "y": 5,
          "z": -323.4667
        },
        {
          "hole": 186,
          "x": 68.3531,
          "y": 5,
          "z": -323.4667
        },
        {
          "hole": 187,
          "x": 57.5,
          "y": 5,
          "z": -318.9711
        },
        {
          "hole": 188,
          "x": 48.1802,
          "y": 5,
          "z": -311.8198
        },
        {
          "hole": 189,
          "x": 41.0289,
          "y": 5,
          "z": -302.5
        },
        {
          "hole": 190,
          "x": 36.5333,
          "y": 5,
          "z": -291.6469
        },
        {
          "hole": 191,
          "x": 35,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 192,
          "x": 35,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 193,
          "x": 35,
          "y": 5,
          "z": -260
        },
        {
          "hole": 194,
          "x": 35,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 195,
          "x": 35,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 196,
          "x": 35,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 197,
          "x": 35,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 198,
          "x": 35,
          "y": 5,
          "z": -220
        },
        {
          "hole": 199,
          "x": 35,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 200,
          "x": 35,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 201,
          "x": 35,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 202,
          "x": 35,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 203,
          "x": 35,
          "y": 5,
          "z": -180
        },
        {
          "hole": 204,
          "x": 35,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 205,
          "x": 35,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 206,
          "x": 35,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 207,
          "x": 35,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 208,
          "x": 35,
          "y": 5,
          "z": -140
        },
        {
          "hole": 209,
          "x": 35,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 210,
          "x": 35,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 211,
          "x": 35,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 212,
          "x": 35,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 213,
          "x": 35,
          "y": 5,
          "z": -100
        },
        {
          "hole": 214,
          "x": 35,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 215,
          "x": 35,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 216,
          "x": 35,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 217,
          "x": 35,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 218,
          "x": 35,
          "y": 5,
          "z": -60
        },
        {
          "hole": 219,
          "x": 35,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 220,
          "x": 35,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 221,
          "x": 35,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 222,
          "x": 35,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 223,
          "x": 35,
          "y": 5,
          "z": -20
        },
        {
          "hole": 224,
          "x": 35,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 225,
          "x": 35,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 226,
          "x": 35,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 227,
          "x": 35,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 228,
          "x": 35,
          "y": 5,
          "z": 20
        },
        {
          "hole": 229,
          "x": 35,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 230,
          "x": 35,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 231,
          "x": 35,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 232,
          "x": 35,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 233,
          "x": 35,
          "y": 5,
          "z": 60
        },
        {
          "hole": 234,
          "x": 35,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 235,
          "x": 35,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 236,
          "x": 33.8074,
          "y": 5,
          "z": 89.0587
        },
        {
          "hole": 237,
          "x": 30.3109,
          "y": 5,
          "z": 97.5
        },
        {
          "hole": 238,
          "x": 24.7487,
          "y": 5,
          "z": 104.7487
        },
        {
          "hole": 239,
          "x": 17.5,
          "y": 5,
          "z": 110.3109
        },
        {
          "hole": 240,
          "x": 9.0587,
          "y": 5,
          "z": 113.8074
        },
        {
          "hole": 241,
          "x": -9.0587,
          "y": 5,
          "z": 113.8074
        },
        {
          "hole": 242,
          "x": -17.5,
          "y": 5,
          "z": 110.3109
        },
        {
          "hole": 243,
          "x": -24.7487,
          "y": 5,
          "z": 104.7487
        },
        {
          "hole": 244,
          "x": -30.3109,
          "y": 5,
          "z": 97.5
        },
        {
          "hole": 245,
          "x": -33.8074,
          "y": 5,
          "z": 89.0587
        },
        {
          "hole": 246,
          "x": -35,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 247,
          "x": -35,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 248,
          "x": -35,
          "y": 5,
          "z": 60
        },
        {
          "hole": 249,
          "x": -35,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 250,
          "x": -35,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 251,
          "x": -35,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 252,
          "x": -35,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 253,
          "x": -35,
          "y": 5,
          "z": 20
        },
        {
          "hole": 254,
          "x": -35,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 255,
          "x": -35,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 256,
          "x": -35,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 257,
          "x": -35,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 258,
          "x": -35,
          "y": 5,
          "z": -20
        },
        {
          "hole": 259,
          "x": -35,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 260,
          "x": -35,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 261,
          "x": -35,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 262,
          "x": -35,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 263,
          "x": -35,
          "y": 5,
          "z": -60
        },
        {
          "hole": 264,
          "x": -35,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 265,
          "x": -35,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 266,
          "x": -35,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 267,
          "x": -35,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 268,
          "x": -35,
          "y": 5,
          "z": -100
        },
        {
          "hole": 269,
          "x": -35,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 270,
          "x": -35,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 271,
          "x": -35,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 272,
          "x": -35,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 273,
          "x": -35,
          "y": 5,
          "z": -140
        },
        {
          "hole": 274,
          "x": -35,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 275,
          "x": -35,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 276,
          "x": -35,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 277,
          "x": -35,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 278,
          "x": -35,
          "y": 5,
          "z": -180
        },
        {
          "hole": 279,
          "x": -35,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 280,
          "x": -35,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 281,
          "x": -35,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 282,
          "x": -35,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 283,
          "x": -35,
          "y": 5,
          "z": -220
        },
        {
          "hole": 284,
          "x": -35,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 285,
          "x": -35,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 286,
          "x": -35,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 287,
          "x": -35,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 288,
          "x": -35,
          "y": 5,
          "z": -260
        },
        {
          "hole": 289,
          "x": -35,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 290,
          "x": -35,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 291,
          "x": -36.5333,
          "y": 5,
          "z": -291.6469
        },
        {
          "hole": 292,
          "x": -41.0289,
          "y": 5,
          "z": -302.5
        },
        {
          "hole": 293,
          "x": -48.1802,
          "y": 5,
          "z": -311.8198
        },
        {
          "hole": 294,
          "x": -57.5,
          "y": 5,
          "z": -318.9711
        },
        {
          "hole": 295,
          "x": -68.3531,
          "y": 5,
          "z": -323.4667
        },
        {
          "hole": 296,
          "x": -91.6469,
          "y": 5,
          "z": -323.4667
        },
        {
          "hole": 297,
          "x": -102.5,
          "y": 5,
          "z": -318.9711
        },
        {
          "hole": 298,
          "x": -111.8198,
          "y": 5,
          "z": -311.8198
        },
        {
          "hole": 299,
          "x": -118.9711,
          "y": 5,
          "z": -302.5
        },
        {
          "hole": 300,
          "x": -123.4667,
          "y": 5,
          "z": -291.6469
        },
        {
          "hole": 301,
          "x": -125,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 302,
          "x": -125,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 303,
          "x": -125,
          "y": 5,
          "z": -260
        },
        {
          "hole": 304,
          "x": -125,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 305,
          "x": -125,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 306,
          "x": -125,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 307,
          "x": -125,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 308,
          "x": -125,
          "y": 5,
          "z": -220
        },
        {
          "hole": 309,
          "x": -125,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 310,
          "x": -125,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 311,
          "x": -125,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 312,
          "x": -125,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 313,
          "x": -125,
          "y": 5,
          "z": -180
        },
        {
          "hole": 314,
          "x": -125,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 315,
          "x": -125,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 316,
          "x": -125,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 317,
          "x": -125,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 318,
          "x": -125,
          "y": 5,
          "z": -140
        },
        {
          "hole": 319,
          "x": -125,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 320,
          "x": -125,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 321,
          "x": -125,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 322,
          "x": -125,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 323,
          "x": -125,
          "y": 5,
          "z": -100
        },
        {
          "hole": 324,
          "x": -125,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 325,
          "x": -125,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 326,
          "x": -125,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 327,
          "x": -125,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 328,
          "x": -125,
          "y": 5,
          "z": -60
        },
        {
          "hole": 329,
          "x": -125,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 330,
          "x": -125,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 331,
          "x": -125,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 332,
          "x": -125,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 333,
          "x": -125,
          "y": 5,
          "z": -20
        },
        {
          "hole": 334,
          "x": -125,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 335,
          "x": -125,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 336,
          "x": -125,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 337,
          "x": -125,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 338,
          "x": -125,
          "y": 5,
          "z": 20
        },
        {
          "hole": 339,
          "x": -125,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 340,
          "x": -125,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 341,
          "x": -126.1926,
          "y": 5,
          "z": 49.0587
        },
        {
          "hole": 342,
          "x": -129.6891,
          "y": 5,
          "z": 57.5
        },
        {
          "hole": 343,
          "x": -135.2513,
          "y": 5,
          "z": 64.7487
        },
        {
          "hole": 344,
          "x": -142.5,
          "y": 5,
          "z": 70.3109
        },
        {
          "hole": 345,
          "x": -150.9413,
          "y": 5,
          "z": 73.8074
        },
        {
          "hole": 346,
          "x": -169.0587,
          "y": 5,
          "z": 73.8074
        },
        {
          "hole": 347,
          "x": -177.5,
          "y": 5,
          "z": 70.3109
        },
        {
          "hole": 348,
          "x": -184.7487,
          "y": 5,
          "z": 64.7487
        },
        {
          "hole": 349,
          "x": -190.3109,
          "y": 5,
          "z": 57.5
        },
        {
          "hole": 350,
          "x": -193.8074,
          "y": 5,
          "z": 49.0587
        },
        {
          "hole": 351,
          "x": -195,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 352,
          "x": -195,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 353,
          "x": -195,
          "y": 5,
          "z": 20
        },
        {
          "hole": 354,
          "x": -195,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 355,
          "x": -195,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 356,
          "x": -195,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 357,
          "x": -195,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 358,
          "x": -195,
          "y": 5,
          "z": -20
        },
        {
          "hole": 359,
          "x": -195,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 360,
          "x": -195,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 361,
          "x": -195,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 362,
          "x": -195,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 363,
          "x": -195,
          "y": 5,
          "z": -60
        },
        {
          "hole": 364,
          "x": -195,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 365,
          "x": -195,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 366,
          "x": -195,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 367,
          "x": -195,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 368,
          "x": -195,
          "y": 5,
          "z": -100
        },
        {
          "hole": 369,
          "x": -195,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 370,
          "x": -195,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 371,
          "x": -195,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 372,
          "x": -195,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 373,
          "x": -195,
          "y": 5,
          "z": -140
        },
        {
          "hole": 374,
          "x": -195,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 375,
          "x": -195,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 376,
          "x": -195,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 377,
          "x": -195,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 378,
          "x": -195,
          "y": 5,
          "z": -180
        },
        {
          "hole": 379,
          "x": -195,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 380,
          "x": -195,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 381,
          "x": -195,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 382,
          "x": -195,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 383,
          "x": -195,
          "y": 5,
          "z": -220
        },
        {
          "hole": 384,
          "x": -195,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 385,
          "x": -195,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 386,
          "x": -195,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 387,
          "x": -195,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 388,
          "x": -195,
          "y": 5,
          "z": -260
        },
        {
          "hole": 389,
          "x": -195,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 390,
          "x": -195,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 391,
          "x": -196.5333,
          "y": 5,
          "z": -291.6469
        },
        {
          "hole": 392,
          "x": -201.0289,
          "y": 5,
          "z": -302.5
        },
        {
          "hole": 393,
          "x": -208.1802,
          "y": 5,
          "z": -311.8198
        },
        {
          "hole": 394,
          "x": -217.5,
          "y": 5,
          "z": -318.9711
        },
        {
          "hole": 395,
          "x": -228.3531,
          "y": 5,
          "z": -323.4667
        },
        {
          "hole": 396,
          "x": -251.6469,
          "y": 5,
          "z": -323.4667
        },
        {
          "hole": 397,
          "x": -262.5,
          "y": 5,
          "z": -318.9711
        },
        {
          "hole": 398,
          "x": -271.8198,
          "y": 5,
          "z": -311.8198
        },
        {
          "hole": 399,
          "x": -278.9711,
          "y": 5,
          "z": -302.5
        },
        {
          "hole": 400,
          "x": -283.4667,
          "y": 5,
          "z": -291.6469
        },
        {
          "hole": 401,
          "x": -285,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 402,
          "x": -285,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 403,
          "x": -285,
          "y": 5,
          "z": -260
        },
        {
          "hole": 404,
          "x": -285,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 405,
          "x": -285,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 406,
          "x": -285,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 407,
          "x": -285,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 408,
          "x": -285,
          "y": 5,
          "z": -220
        },
        {
          "hole": 409,
          "x": -285,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 410,
          "x": -285,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 411,
          "x": -285,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 412,
          "x": -285,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 413,
          "x": -285,
          "y": 5,
          "z": -180
        },
        {
          "hole": 414,
          "x": -285,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 415,
          "x": -285,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 416,
          "x": -285,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 417,
          "x": -285,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 418,
          "x": -285,
          "y": 5,
          "z": -140
        },
        {
          "hole": 419,
          "x": -285,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 420,
          "x": -285,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 421,
          "x": -285,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 422,
          "x": -285,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 423,
          "x": -285,
          "y": 5,
          "z": -100
        },
        {
          "hole": 424,
          "x": -285,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 425,
          "x": -285,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 426,
          "x": -285,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 427,
          "x": -285,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 428,
          "x": -285,
          "y": 5,
          "z": -60
        },
        {
          "hole": 429,
          "x": -285,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 430,
          "x": -285,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 431,
          "x": -285,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 432,
          "x": -285,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 433,
          "x": -285,
          "y": 5,
          "z": -20
        },
        {
          "hole": 434,
          "x": -285,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 435,
          "x": -285,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 436,
          "x": -285,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 437,
          "x": -285,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 438,
          "x": -285,
          "y": 5,
          "z": 20
        },
        {
          "hole": 439,
          "x": -285,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 440,
          "x": -285,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 441,
          "x": -285,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 442,
          "x": -285,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 443,
          "x": -285,
          "y": 5,
          "z": 60
        },
        {
          "hole": 444,
          "x": -285,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 445,
          "x": -285,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 446,
          "x": -285,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 447,
          "x": -285,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 448,
          "x": -285,
          "y": 5,
          "z": 100
        },
        {
          "hole": 449,
          "x": -285,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 450,
          "x": -285,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 451,
          "x": -283.4667,
          "y": 5,
          "z": 131.6469
        },
        {
          "hole": 452,
          "x": -278.9711,
          "y": 5,
          "z": 142.5
        },
        {
          "hole": 453,
          "x": -271.8198,
          "y": 5,
          "z": 151.8198
        },
        {
          "hole": 454,
          "x": -262.5,
          "y": 5,
          "z": 158.9711
        },
        {
          "hole": 455,
          "x": -251.6469,
          "y": 5,
          "z": 163.4667
        },
        {
          "hole": 456,
          "x": -235.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 457,
          "x": -227.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 458,
          "x": -220,
          "y": 5,
          "z": 165
        },
        {
          "hole": 459,
          "x": -212.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 460,
          "x": -204.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 461,
          "x": -195.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 462,
          "x": -187.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 463,
          "x": -180,
          "y": 5,
          "z": 165
        },
        {
          "hole": 464,
          "x": -172.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 465,
          "x": -164.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 466,
          "x": -155.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 467,
          "x": -147.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 468,
          "x": -140,
          "y": 5,
          "z": 165
        },
        {
          "hole": 469,
          "x": -132.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 470,
          "x": -124.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 471,
          "x": -115.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 472,
          "x": -107.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 473,
          "x": -100,
          "y": 5,
          "z": 165
        },
        {
          "hole": 474,
          "x": -92.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 475,
          "x": -84.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 476,
          "x": -75.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 477,
          "x": -67.75,
          "y": 5,
          "z": 165
        },
        {
          "hole": 478,
          "x": -60,
          "y": 5,
          "z": 165
        },
        {
          "hole": 479,
          "x": -52.25,
          "y": 5,
          "z": 165
        },
        {
          "hole": 480,
          "x": -44.5,
          "y": 5,
          "z": 165
        },
        {
          "hole": 481,
          "x": -20,
          "y": 5,
          "z": 160
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": 13,
          "y": 5,
          "z": 155
        },
        {
          "hole": 1,
          "x": 44.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 2,
          "x": 52.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 3,
          "x": 60,
          "y": 5,
          "z": 155
        },
        {
          "hole": 4,
          "x": 67.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 5,
          "x": 75.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 6,
          "x": 84.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 7,
          "x": 92.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 8,
          "x": 100,
          "y": 5,
          "z": 155
        },
        {
          "hole": 9,
          "x": 107.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 10,
          "x": 115.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 11,
          "x": 124.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 12,
          "x": 132.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 13,
          "x": 140,
          "y": 5,
          "z": 155
        },
        {
          "hole": 14,
          "x": 147.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 15,
          "x": 155.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 16,
          "x": 164.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 17,
          "x": 172.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 18,
          "x": 180,
          "y": 5,
          "z": 155
        },
        {
          "hole": 19,
          "x": 187.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 20,
          "x": 195.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 21,
          "x": 204.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 22,
          "x": 212.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 23,
          "x": 220,
          "y": 5,
          "z": 155
        },
        {
          "hole": 24,
          "x": 227.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 25,
          "x": 235.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 26,
          "x": 249.0587,
          "y": 5,
          "z": 153.8074
        },
        {
          "hole": 27,
          "x": 257.5,
          "y": 5,
          "z": 150.3109
        },
        {
          "hole": 28,
          "x": 264.7487,
          "y": 5,
          "z": 144.7487
        },
        {
          "hole": 29,
          "x": 270.3109,
          "y": 5,
          "z": 137.5
        },
        {
          "hole": 30,
          "x": 273.8074,
          "y": 5,
          "z": 129.0587
        },
        {
          "hole": 31,
          "x": 275,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 32,
          "x": 275,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 33,
          "x": 275,
          "y": 5,
          "z": 100
        },
        {
          "hole": 34,
          "x": 275,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 35,
          "x": 275,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 36,
          "x": 275,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 37,
          "x": 275,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 38,
          "x": 275,
          "y": 5,
          "z": 60
        },
        {
          "hole": 39,
          "x": 275,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 40,
          "x": 275,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 41,
          "x": 275,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 42,
          "x": 275,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 43,
          "x": 275,
          "y": 5,
          "z": 20
        },
        {
          "hole": 44,
          "x": 275,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 45,
          "x": 275,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 46,
          "x": 275,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 47,
          "x": 275,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 48,
          "x": 275,
          "y": 5,
          "z": -20
        },
        {
          "hole": 49,
          "x": 275,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 50,
          "x": 275,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 51,
          "x": 275,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 52,
          "x": 275,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 53,
          "x": 275,
          "y": 5,
          "z": -60
        },
        {
          "hole": 54,
          "x": 275,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 55,
          "x": 275,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 56,
          "x": 275,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 57,
          "x": 275,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 58,
          "x": 275,
          "y": 5,
          "z": -100
        },
        {
          "hole": 59,
          "x": 275,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 60,
          "x": 275,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 61,
          "x": 275,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 62,
          "x": 275,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 63,
          "x": 275,
          "y": 5,
          "z": -140
        },
        {
          "hole": 64,
          "x": 275,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 65,
          "x": 275,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 66,
          "x": 275,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 67,
          "x": 275,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 68,
          "x": 275,
          "y": 5,
          "z": -180
        },
        {
          "hole": 69,
          "x": 275,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 70,
          "x": 275,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 71,
          "x": 275,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 72,
          "x": 275,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 73,
          "x": 275,
          "y": 5,
          "z": -220
        },
        {
          "hole": 74,
          "x": 275,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 75,
          "x": 275,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 76,
          "x": 275,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 77,
          "x": 275,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 78,
          "x": 275,
          "y": 5,
          "z": -260
        },
        {
          "hole": 79,
          "x": 275,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 80,
          "x": 275,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 81,
          "x": 273.8074,
          "y": 5,
          "z": -289.0587
        },
        {
          "hole": 82,
          "x": 270.3109,
          "y": 5,
          "z": -297.5
        },
        {
          "hole": 83,
          "x": 264.7487,
          "y": 5,
          "z": -304.7487
        },
        {
          "hole": 84,
          "x": 257.5,
          "y": 5,
          "z": -310.3109
        },
        {
          "hole": 85,
          "x": 249.0587,
          "y": 5,
          "z": -313.8074
        },
        {
          "hole": 86,
          "x": 230.9413,
          "y": 5,
          "z": -313.8074
        },
        {
          "hole": 87,
          "x": 222.5,
          "y": 5,
          "z": -310.3109
        },
        {
          "hole": 88,
          "x": 215.2513,
          "y": 5,
          "z": -304.7487
        },
        {
          "hole": 89,
          "x": 209.6891,
          "y": 5,
          "z": -297.5
        },
        {
          "hole": 90,
          "x": 206.1926,
          "y": 5,
          "z": -289.0587
        },
        {
          "hole": 91,
          "x": 205,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 92,
          "x": 205,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 93,
          "x": 205,
          "y": 5,
          "z": -260
        },
        {
          "hole": 94,
          "x": 205,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 95,
          "x": 205,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 96,
          "x": 205,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 97,
          "x": 205,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 98,
          "x": 205,
          "y": 5,
          "z": -220
        },
        {
          "hole": 99,
          "x": 205,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 100,
          "x": 205,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 101,
          "x": 205,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 102,
          "x": 205,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 103,
          "x": 205,
          "y": 5,
          "z": -180
        },
        {
          "hole": 104,
          "x": 205,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 105,
          "x": 205,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 106,
          "x": 205,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 107,
          "x": 205,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 108,
          "x": 205,
          "y": 5,
          "z": -140
        },
        {
          "hole": 109,
          "x": 205,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 110,
          "x": 205,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 111,
          "x": 205,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 112,
          "x": 205,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 113,
          "x": 205,
          "y": 5,
          "z": -100
        },
        {
          "hole": 114,
          "x": 205,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 115,
          "x": 205,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 116,
          "x": 205,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 117,
          "x": 205,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 118,
          "x": 205,
          "y": 5,
          "z": -60
        },
        {
          "hole": 119,
          "x": 205,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 120,
          "x": 205,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 121,
          "x": 205,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 122,
          "x": 205,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 123,
          "x": 205,
          "y": 5,
          "z": -20
        },
        {
          "hole": 124,
          "x": 205,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 125,
          "x": 205,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 126,
          "x": 205,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 127,
          "x": 205,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 128,
          "x": 205,
          "y": 5,
          "z": 20
        },
        {
          "hole": 129,
          "x": 205,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 130,
          "x": 205,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 131,
          "x": 203.4667,
          "y": 5,
          "z": 51.6469
        },
        {
          "hole": 132,
          "x": 198.9711,
          "y": 5,
          "z": 62.5
        },
        {
          "hole": 133,
          "x": 191.8198,
          "y": 5,
          "z": 71.8198
        },
        {
          "hole": 134,
          "x": 182.5,
          "y": 5,
          "z": 78.9711
        },
        {
          "hole": 135,
          "x": 171.6469,
          "y": 5,
          "z": 83.4667
        },
        {
          "hole": 136,
          "x": 148.3531,
          "y": 5,
          "z": 83.4667
        },
        {
          "hole": 137,
          "x": 137.5,
          "y": 5,
          "z": 78.9711
        },
        {
          "hole": 138,
          "x": 128.1802,
          "y": 5,
          "z": 71.8198
        },
        {
          "hole": 139,
          "x": 121.0289,
          "y": 5,
          "z": 62.5
        },
        {
          "hole": 140,
          "x": 116.5333,
          "y": 5,
          "z": 51.6469
        },
        {
          "hole": 141,
          "x": 115,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 142,
          "x": 115,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 143,
          "x": 115,
          "y": 5,
          "z": 20
        },
        {
          "hole": 144,
          "x": 115,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 145,
          "x": 115,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 146,
          "x": 115,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 147,
          "x": 115,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 148,
          "x": 115,
          "y": 5,
          "z": -20
        },
        {
          "hole": 149,
          "x": 115,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 150,
          "x": 115,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 151,
          "x": 115,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 152,
          "x": 115,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 153,
          "x": 115,
          "y": 5,
          "z": -60
        },
        {
          "hole": 154,
          "x": 115,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 155,
          "x": 115,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 156,
          "x": 115,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 157,
          "x": 115,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 158,
          "x": 115,
          "y": 5,
          "z": -100
        },
        {
          "hole": 159,
          "x": 115,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 160,
          "x": 115,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 161,
          "x": 115,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 162,
          "x": 115,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 163,
          "x": 115,
          "y": 5,
          "z": -140
        },
        {
          "hole": 164,
          "x": 115,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 165,
          "x": 115,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 166,
          "x": 115,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 167,
          "x": 115,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 168,
          "x": 115,
          "y": 5,
          "z": -180
        },
        {
          "hole": 169,
          "x": 115,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 170,
          "x": 115,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 171,
          "x": 115,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 172,
          "x": 115,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 173,
          "x": 115,
          "y": 5,
          "z": -220
        },
        {
          "hole": 174,
          "x": 115,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 175,
          "x": 115,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 176,
          "x": 115,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 177,
          "x": 115,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 178,
          "x": 115,
          "y": 5,
          "z": -260
        },
        {
          "hole": 179,
          "x": 115,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 180,
          "x": 115,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 181,
          "x": 113.8074,
          "y": 5,
          "z": -289.0587
        },
        {
          "hole": 182,
          "x": 110.3109,
          "y": 5,
          "z": -297.5
        },
        {
          "hole": 183,
          "x": 104.7487,
          "y": 5,
          "z": -304.7487
        },
        {
          "hole": 184,
          "x": 97.5,
          "y": 5,
          "z": -310.3109
        },
        {
          "hole": 185,
          "x": 89.0587,
          "y": 5,
          "z": -313.8074
        },
        {
          "hole": 186,
          "x": 70.9413,
          "y": 5,
          "z": -313.8074
        },
        {
          "hole": 187,
          "x": 62.5,
          "y": 5,
          "z": -310.3109
        },
        {
          "hole": 188,
          "x": 55.2513,
          "y": 5,
          "z": -304.7487
        },
        {
          "hole": 189,
          "x": 49.6891,
          "y": 5,
          "z": -297.5
        },
        {
          "hole": 190,
          "x": 46.1926,
          "y": 5,
          "z": -289.0587
        },
        {
          "hole": 191,
          "x": 45,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 192,
          "x": 45,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 193,
          "x": 45,
          "y": 5,
          "z": -260
        },
        {
          "hole": 194,
          "x": 45,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 195,
          "x": 45,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 196,
          "x": 45,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 197,
          "x": 45,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 198,
          "x": 45,
          "y": 5,
          "z": -220
        },
        {
          "hole": 199,
          "x": 45,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 200,
          "x": 45,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 201,
          "x": 45,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 202,
          "x": 45,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 203,
          "x": 45,
          "y": 5,
          "z": -180
        },
        {
          "hole": 204,
          "x": 45,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 205,
          "x": 45,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 206,
          "x": 45,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 207,
          "x": 45,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 208,
          "x": 45,
          "y": 5,
          "z": -140
        },
        {
          "hole": 209,
          "x": 45,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 210,
          "x": 45,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 211,
          "x": 45,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 212,
          "x": 45,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 213,
          "x": 45,
          "y": 5,
          "z": -100
        },
        {
          "hole": 214,
          "x": 45,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 215,
          "x": 45,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 216,
          "x": 45,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 217,
          "x": 45,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 218,
          "x": 45,
          "y": 5,
          "z": -60
        },
        {
          "hole": 219,
          "x": 45,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 220,
          "x": 45,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 221,
          "x": 45,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 222,
          "x": 45,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 223,
          "x": 45,
          "y": 5,
          "z": -20
        },
        {
          "hole": 224,
          "x": 45,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 225,
          "x": 45,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 226,
          "x": 45,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 227,
          "x": 45,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 228,
          "x": 45,
          "y": 5,
          "z": 20
        },
        {
          "hole": 229,
          "x": 45,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 230,
          "x": 45,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 231,
          "x": 45,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 232,
          "x": 45,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 233,
          "x": 45,
          "y": 5,
          "z": 60
        },
        {
          "hole": 234,
          "x": 45,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 235,
          "x": 45,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 236,
          "x": 43.4667,
          "y": 5,
          "z": 91.6469
        },
        {
          "hole": 237,
          "x": 38.9711,
          "y": 5,
          "z": 102.5
        },
        {
          "hole": 238,
          "x": 31.8198,
          "y": 5,
          "z": 111.8198
        },
        {
          "hole": 239,
          "x": 22.5,
          "y": 5,
          "z": 118.9711
        },
        {
          "hole": 240,
          "x": 11.6469,
          "y": 5,
          "z": 123.4667
        },
        {
          "hole": 241,
          "x": -11.6469,
          "y": 5,
          "z": 123.4667
        },
        {
          "hole": 242,
          "x": -22.5,
          "y": 5,
          "z": 118.9711
        },
        {
          "hole": 243,
          "x": -31.8198,
          "y": 5,
          "z": 111.8198
        },
        {
          "hole": 244,
          "x": -38.9711,
          "y": 5,
          "z": 102.5
        },
        {
          "hole": 245,
          "x": -43.4667,
          "y": 5,
          "z": 91.6469
        },
        {
          "hole": 246,
          "x": -45,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 247,
          "x": -45,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 248,
          "x": -45,
          "y": 5,
          "z": 60
        },
        {
          "hole": 249,
          "x": -45,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 250,
          "x": -45,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 251,
          "x": -45,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 252,
          "x": -45,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 253,
          "x": -45,
          "y": 5,
          "z": 20
        },
        {
          "hole": 254,
          "x": -45,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 255,
          "x": -45,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 256,
          "x": -45,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 257,
          "x": -45,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 258,
          "x": -45,
          "y": 5,
          "z": -20
        },
        {
          "hole": 259,
          "x": -45,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 260,
          "x": -45,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 261,
          "x": -45,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 262,
          "x": -45,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 263,
          "x": -45,
          "y": 5,
          "z": -60
        },
        {
          "hole": 264,
          "x": -45,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 265,
          "x": -45,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 266,
          "x": -45,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 267,
          "x": -45,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 268,
          "x": -45,
          "y": 5,
          "z": -100
        },
        {
          "hole": 269,
          "x": -45,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 270,
          "x": -45,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 271,
          "x": -45,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 272,
          "x": -45,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 273,
          "x": -45,
          "y": 5,
          "z": -140
        },
        {
          "hole": 274,
          "x": -45,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 275,
          "x": -45,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 276,
          "x": -45,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 277,
          "x": -45,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 278,
          "x": -45,
          "y": 5,
          "z": -180
        },
        {
          "hole": 279,
          "x": -45,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 280,
          "x": -45,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 281,
          "x": -45,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 282,
          "x": -45,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 283,
          "x": -45,
          "y": 5,
          "z": -220
        },
        {
          "hole": 284,
          "x": -45,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 285,
          "x": -45,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 286,
          "x": -45,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 287,
          "x": -45,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 288,
          "x": -45,
          "y": 5,
          "z": -260
        },
        {
          "hole": 289,
          "x": -45,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 290,
          "x": -45,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 291,
          "x": -46.1926,
          "y": 5,
          "z": -289.0587
        },
        {
          "hole": 292,
          "x": -49.6891,
          "y": 5,
          "z": -297.5
        },
        {
          "hole": 293,
          "x": -55.2513,
          "y": 5,
          "z": -304.7487
        },
        {
          "hole": 294,
          "x": -62.5,
          "y": 5,
          "z": -310.3109
        },
        {
          "hole": 295,
          "x": -70.9413,
          "y": 5,
          "z": -313.8074
        },
        {
          "hole": 296,
          "x": -89.0587,
          "y": 5,
          "z": -313.8074
        },
        {
          "hole": 297,
          "x": -97.5,
          "y": 5,
          "z": -310.3109
        },
        {
          "hole": 298,
          "x": -104.7487,
          "y": 5,
          "z": -304.7487
        },
        {
          "hole": 299,
          "x": -110.3109,
          "y": 5,
          "z": -297.5
        },
        {
          "hole": 300,
          "x": -113.8074,
          "y": 5,
          "z": -289.0587
        },
        {
          "hole": 301,
          "x": -115,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 302,
          "x": -115,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 303,
          "x": -115,
          "y": 5,
          "z": -260
        },
        {
          "hole": 304,
          "x": -115,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 305,
          "x": -115,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 306,
          "x": -115,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 307,
          "x": -115,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 308,
          "x": -115,
          "y": 5,
          "z": -220
        },
        {
          "hole": 309,
          "x": -115,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 310,
          "x": -115,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 311,
          "x": -115,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 312,
          "x": -115,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 313,
          "x": -115,
          "y": 5,
          "z": -180
        },
        {
          "hole": 314,
          "x": -115,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 315,
          "x": -115,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 316,
          "x": -115,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 317,
          "x": -115,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 318,
          "x": -115,
          "y": 5,
          "z": -140
        },
        {
          "hole": 319,
          "x": -115,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 320,
          "x": -115,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 321,
          "x": -115,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 322,
          "x": -115,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 323,
          "x": -115,
          "y": 5,
          "z": -100
        },
        {
          "hole": 324,
          "x": -115,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 325,
          "x": -115,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 326,
          "x": -115,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 327,
          "x": -115,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 328,
          "x": -115,
          "y": 5,
          "z": -60
        },
        {
          "hole": 329,
          "x": -115,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 330,
          "x": -115,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 331,
          "x": -115,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 332,
          "x": -115,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 333,
          "x": -115,
          "y": 5,
          "z": -20
        },
        {
          "hole": 334,
          "x": -115,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 335,
          "x": -115,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 336,
          "x": -115,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 337,
          "x": -115,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 338,
          "x": -115,
          "y": 5,
          "z": 20
        },
        {
          "hole": 339,
          "x": -115,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 340,
          "x": -115,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 341,
          "x": -116.5333,
          "y": 5,
          "z": 51.6469
        },
        {
          "hole": 342,
          "x": -121.0289,
          "y": 5,
          "z": 62.5
        },
        {
          "hole": 343,
          "x": -128.1802,
          "y": 5,
          "z": 71.8198
        },
        {
          "hole": 344,
          "x": -137.5,
          "y": 5,
          "z": 78.9711
        },
        {
          "hole": 345,
          "x": -148.3531,
          "y": 5,
          "z": 83.4667
        },
        {
          "hole": 346,
          "x": -171.6469,
          "y": 5,
          "z": 83.4667
        },
        {
          "hole": 347,
          "x": -182.5,
          "y": 5,
          "z": 78.9711
        },
        {
          "hole": 348,
          "x": -191.8198,
          "y": 5,
          "z": 71.8198
        },
        {
          "hole": 349,
          "x": -198.9711,
          "y": 5,
          "z": 62.5
        },
        {
          "hole": 350,
          "x": -203.4667,
          "y": 5,
          "z": 51.6469
        },
        {
          "hole": 351,
          "x": -205,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 352,
          "x": -205,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 353,
          "x": -205,
          "y": 5,
          "z": 20
        },
        {
          "hole": 354,
          "x": -205,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 355,
          "x": -205,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 356,
          "x": -205,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 357,
          "x": -205,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 358,
          "x": -205,
          "y": 5,
          "z": -20
        },
        {
          "hole": 359,
          "x": -205,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 360,
          "x": -205,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 361,
          "x": -205,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 362,
          "x": -205,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 363,
          "x": -205,
          "y": 5,
          "z": -60
        },
        {
          "hole": 364,
          "x": -205,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 365,
          "x": -205,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 366,
          "x": -205,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 367,
          "x": -205,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 368,
          "x": -205,
          "y": 5,
          "z": -100
        },
        {
          "hole": 369,
          "x": -205,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 370,
          "x": -205,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 371,
          "x": -205,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 372,
          "x": -205,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 373,
          "x": -205,
          "y": 5,
          "z": -140
        },
        {
          "hole": 374,
          "x": -205,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 375,
          "x": -205,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 376,
          "x": -205,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 377,
          "x": -205,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 378,
          "x": -205,
          "y": 5,
          "z": -180
        },
        {
          "hole": 379,
          "x": -205,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 380,
          "x": -205,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 381,
          "x": -205,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 382,
          "x": -205,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 383,
          "x": -205,
          "y": 5,
          "z": -220
        },
        {
          "hole": 384,
          "x": -205,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 385,
          "x": -205,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 386,
          "x": -205,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 387,
          "x": -205,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 388,
          "x": -205,
          "y": 5,
          "z": -260
        },
        {
          "hole": 389,
          "x": -205,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 390,
          "x": -205,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 391,
          "x": -206.1926,
          "y": 5,
          "z": -289.0587
        },
        {
          "hole": 392,
          "x": -209.6891,
          "y": 5,
          "z": -297.5
        },
        {
          "hole": 393,
          "x": -215.2513,
          "y": 5,
          "z": -304.7487
        },
        {
          "hole": 394,
          "x": -222.5,
          "y": 5,
          "z": -310.3109
        },
        {
          "hole": 395,
          "x": -230.9413,
          "y": 5,
          "z": -313.8074
        },
        {
          "hole": 396,
          "x": -249.0587,
          "y": 5,
          "z": -313.8074
        },
        {
          "hole": 397,
          "x": -257.5,
          "y": 5,
          "z": -310.3109
        },
        {
          "hole": 398,
          "x": -264.7487,
          "y": 5,
          "z": -304.7487
        },
        {
          "hole": 399,
          "x": -270.3109,
          "y": 5,
          "z": -297.5
        },
        {
          "hole": 400,
          "x": -273.8074,
          "y": 5,
          "z": -289.0587
        },
        {
          "hole": 401,
          "x": -275,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 402,
          "x": -275,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 403,
          "x": -275,
          "y": 5,
          "z": -260
        },
        {
          "hole": 404,
          "x": -275,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 405,
          "x": -275,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 406,
          "x": -275,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 407,
          "x": -275,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 408,
          "x": -275,
          "y": 5,
          "z": -220
        },
        {
          "hole": 409,
          "x": -275,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 410,
          "x": -275,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 411,
          "x": -275,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 412,
          "x": -275,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 413,
          "x": -275,
          "y": 5,
          "z": -180
        },
        {
          "hole": 414,
          "x": -275,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 415,
          "x": -275,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 416,
          "x": -275,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 417,
          "x": -275,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 418,
          "x": -275,
          "y": 5,
          "z": -140
        },
        {
          "hole": 419,
          "x": -275,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 420,
          "x": -275,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 421,
          "x": -275,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 422,
          "x": -275,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 423,
          "x": -275,
          "y": 5,
          "z": -100
        },
        {
          "hole": 424,
          "x": -275,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 425,
          "x": -275,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 426,
          "x": -275,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 427,
          "x": -275,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 428,
          "x": -275,
          "y": 5,
          "z": -60
        },
        {
          "hole": 429,
          "x": -275,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 430,
          "x": -275,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 431,
          "x": -275,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 432,
          "x": -275,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 433,
          "x": -275,
          "y": 5,
          "z": -20
        },
        {
          "hole": 434,
          "x": -275,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 435,
          "x": -275,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 436,
          "x": -275,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 437,
          "x": -275,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 438,
          "x": -275,
          "y": 5,
          "z": 20
        },
        {
          "hole": 439,
          "x": -275,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 440,
          "x": -275,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 441,
          "x": -275,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 442,
          "x": -275,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 443,
          "x": -275,
          "y": 5,
          "z": 60
        },
        {
          "hole": 444,
          "x": -275,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 445,
          "x": -275,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 446,
          "x": -275,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 447,
          "x": -275,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 448,
          "x": -275,
          "y": 5,
          "z": 100
        },
        {
          "hole": 449,
          "x": -275,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 450,
          "x": -275,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 451,
          "x": -273.8074,
          "y": 5,
          "z": 129.0587
        },
        {
          "hole": 452,
          "x": -270.3109,
          "y": 5,
          "z": 137.5
        },
        {
          "hole": 453,
          "x": -264.7487,
          "y": 5,
          "z": 144.7487
        },
        {
          "hole": 454,
          "x": -257.5,
          "y": 5,
          "z": 150.3109
        },
        {
          "hole": 455,
          "x": -249.0587,
          "y": 5,
          "z": 153.8074
        },
        {
          "hole": 456,
          "x": -235.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 457,
          "x": -227.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 458,
          "x": -220,
          "y": 5,
          "z": 155
        },
        {
          "hole": 459,
          "x": -212.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 460,
          "x": -204.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 461,
          "x": -195.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 462,
          "x": -187.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 463,
          "x": -180,
          "y": 5,
          "z": 155
        },
        {
          "hole": 464,
          "x": -172.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 465,
          "x": -164.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 466,
          "x": -155.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 467,
          "x": -147.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 468,
          "x": -140,
          "y": 5,
          "z": 155
        },
        {
          "hole": 469,
          "x": -132.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 470,
          "x": -124.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 471,
          "x": -115.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 472,
          "x": -107.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 473,
          "x": -100,
          "y": 5,
          "z": 155
        },
        {
          "hole": 474,
          "x": -92.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 475,
          "x": -84.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 476,
          "x": -75.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 477,
          "x": -67.75,
          "y": 5,
          "z": 155
        },
        {
          "hole": 478,
          "x": -60,
          "y": 5,
          "z": 155
        },
        {
          "hole": 479,
          "x": -52.25,
          "y": 5,
          "z": 155
        },
        {
          "hole": 480,
          "x": -44.5,
          "y": 5,
          "z": 155
        },
        {
          "hole": 481,
          "x": -20,
          "y": 5,
          "z": 160
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": 13,
          "y": 5,
          "z": 145
        },
        {
          "hole": 1,
          "x": 44.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 2,
          "x": 52.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 3,
          "x": 60,
          "y": 5,
          "z": 145
        },
        {
          "hole": 4,
          "x": 67.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 5,
          "x": 75.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 6,
          "x": 84.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 7,
          "x": 92.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 8,
          "x": 100,
          "y": 5,
          "z": 145
        },
        {
          "hole": 9,
          "x": 107.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 10,
          "x": 115.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 11,
          "x": 124.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 12,
          "x": 132.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 13,
          "x": 140,
          "y": 5,
          "z": 145
        },
        {
          "hole": 14,
          "x": 147.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 15,
          "x": 155.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 16,
          "x": 164.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 17,
          "x": 172.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 18,
          "x": 180,
          "y": 5,
          "z": 145
        },
        {
          "hole": 19,
          "x": 187.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 20,
          "x": 195.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 21,
          "x": 204.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 22,
          "x": 212.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 23,
          "x": 220,
          "y": 5,
          "z": 145
        },
        {
          "hole": 24,
          "x": 227.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 25,
          "x": 235.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 26,
          "x": 246.4705,
          "y": 5,
          "z": 144.1481
        },
        {
          "hole": 27,
          "x": 252.5,
          "y": 5,
          "z": 141.6506
        },
        {
          "hole": 28,
          "x": 257.6777,
          "y": 5,
          "z": 137.6777
        },
        {
          "hole": 29,
          "x": 261.6506,
          "y": 5,
          "z": 132.5
        },
        {
          "hole": 30,
          "x": 264.1481,
          "y": 5,
          "z": 126.4705
        },
        {
          "hole": 31,
          "x": 265,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 32,
          "x": 265,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 33,
          "x": 265,
          "y": 5,
          "z": 100
        },
        {
          "hole": 34,
          "x": 265,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 35,
          "x": 265,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 36,
          "x": 265,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 37,
          "x": 265,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 38,
          "x": 265,
          "y": 5,
          "z": 60
        },
        {
          "hole": 39,
          "x": 265,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 40,
          "x": 265,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 41,
          "x": 265,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 42,
          "x": 265,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 43,
          "x": 265,
          "y": 5,
          "z": 20
        },
        {
          "hole": 44,
          "x": 265,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 45,
          "x": 265,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 46,
          "x": 265,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 47,
          "x": 265,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 48,
          "x": 265,
          "y": 5,
          "z": -20
        },
        {
          "hole": 49,
          "x": 265,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 50,
          "x": 265,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 51,
          "x": 265,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 52,
          "x": 265,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 53,
          "x": 265,
          "y": 5,
          "z": -60
        },
        {
          "hole": 54,
          "x": 265,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 55,
          "x": 265,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 56,
          "x": 265,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 57,
          "x": 265,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 58,
          "x": 265,
          "y": 5,
          "z": -100
        },
        {
          "hole": 59,
          "x": 265,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 60,
          "x": 265,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 61,
          "x": 265,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 62,
          "x": 265,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 63,
          "x": 265,
          "y": 5,
          "z": -140
        },
        {
          "hole": 64,
          "x": 265,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 65,
          "x": 265,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 66,
          "x": 265,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 67,
          "x": 265,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 68,
          "x": 265,
          "y": 5,
          "z": -180
        },
        {
          "hole": 69,
          "x": 265,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 70,
          "x": 265,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 71,
          "x": 265,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 72,
          "x": 265,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 73,
          "x": 265,
          "y": 5,
          "z": -220
        },
        {
          "hole": 74,
          "x": 265,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 75,
          "x": 265,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 76,
          "x": 265,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 77,
          "x": 265,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 78,
          "x": 265,
          "y": 5,
          "z": -260
        },
        {
          "hole": 79,
          "x": 265,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 80,
          "x": 265,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 81,
          "x": 264.1481,
          "y": 5,
          "z": -286.4705
        },
        {
          "hole": 82,
          "x": 261.6506,
          "y": 5,
          "z": -292.5
        },
        {
          "hole": 83,
          "x": 257.6777,
          "y": 5,
          "z": -297.6777
        },
        {
          "hole": 84,
          "x": 252.5,
          "y": 5,
          "z": -301.6506
        },
        {
          "hole": 85,
          "x": 246.4705,
          "y": 5,
          "z": -304.1481
        },
        {
          "hole": 86,
          "x": 233.5295,
          "y": 5,
          "z": -304.1481
        },
        {
          "hole": 87,
          "x": 227.5,
          "y": 5,
          "z": -301.6506
        },
        {
          "hole": 88,
          "x": 222.3223,
          "y": 5,
          "z": -297.6777
        },
        {
          "hole": 89,
          "x": 218.3494,
          "y": 5,
          "z": -292.5
        },
        {
          "hole": 90,
          "x": 215.8519,
          "y": 5,
          "z": -286.4705
        },
        {
          "hole": 91,
          "x": 215,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 92,
          "x": 215,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 93,
          "x": 215,
          "y": 5,
          "z": -260
        },
        {
          "hole": 94,
          "x": 215,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 95,
          "x": 215,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 96,
          "x": 215,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 97,
          "x": 215,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 98,
          "x": 215,
          "y": 5,
          "z": -220
        },
        {
          "hole": 99,
          "x": 215,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 100,
          "x": 215,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 101,
          "x": 215,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 102,
          "x": 215,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 103,
          "x": 215,
          "y": 5,
          "z": -180
        },
        {
          "hole": 104,
          "x": 215,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 105,
          "x": 215,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 106,
          "x": 215,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 107,
          "x": 215,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 108,
          "x": 215,
          "y": 5,
          "z": -140
        },
        {
          "hole": 109,
          "x": 215,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 110,
          "x": 215,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 111,
          "x": 215,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 112,
          "x": 215,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 113,
          "x": 215,
          "y": 5,
          "z": -100
        },
        {
          "hole": 114,
          "x": 215,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 115,
          "x": 215,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 116,
          "x": 215,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 117,
          "x": 215,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 118,
          "x": 215,
          "y": 5,
          "z": -60
        },
        {
          "hole": 119,
          "x": 215,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 120,
          "x": 215,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 121,
          "x": 215,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 122,
          "x": 215,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 123,
          "x": 215,
          "y": 5,
          "z": -20
        },
        {
          "hole": 124,
          "x": 215,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 125,
          "x": 215,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 126,
          "x": 215,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 127,
          "x": 215,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 128,
          "x": 215,
          "y": 5,
          "z": 20
        },
        {
          "hole": 129,
          "x": 215,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 130,
          "x": 215,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 131,
          "x": 213.1259,
          "y": 5,
          "z": 54.235
        },
        {
          "hole": 132,
          "x": 207.6314,
          "y": 5,
          "z": 67.5
        },
        {
          "hole": 133,
          "x": 198.8909,
          "y": 5,
          "z": 78.8909
        },
        {
          "hole": 134,
          "x": 187.5,
          "y": 5,
          "z": 87.6314
        },
        {
          "hole": 135,
          "x": 174.235,
          "y": 5,
          "z": 93.1259
        },
        {
          "hole": 136,
          "x": 145.765,
          "y": 5,
          "z": 93.1259
        },
        {
          "hole": 137,
          "x": 132.5,
          "y": 5,
          "z": 87.6314
        },
        {
          "hole": 138,
          "x": 121.1091,
          "y": 5,
          "z": 78.8909
        },
        {
          "hole": 139,
          "x": 112.3686,
          "y": 5,
          "z": 67.5
        },
        {
          "hole": 140,
          "x": 106.8741,
          "y": 5,
          "z": 54.235
        },
        {
          "hole": 141,
          "x": 105,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 142,
          "x": 105,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 143,
          "x": 105,
          "y": 5,
          "z": 20
        },
        {
          "hole": 144,
          "x": 105,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 145,
          "x": 105,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 146,
          "x": 105,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 147,
          "x": 105,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 148,
          "x": 105,
          "y": 5,
          "z": -20
        },
        {
          "hole": 149,
          "x": 105,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 150,
          "x": 105,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 151,
          "x": 105,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 152,
          "x": 105,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 153,
          "x": 105,
          "y": 5,
          "z": -60
        },
        {
          "hole": 154,
          "x": 105,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 155,
          "x": 105,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 156,
          "x": 105,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 157,
          "x": 105,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 158,
          "x": 105,
          "y": 5,
          "z": -100
        },
        {
          "hole": 159,
          "x": 105,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 160,
          "x": 105,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 161,
          "x": 105,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 162,
          "x": 105,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 163,
          "x": 105,
          "y": 5,
          "z": -140
        },
        {
          "hole": 164,
          "x": 105,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 165,
          "x": 105,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 166,
          "x": 105,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 167,
          "x": 105,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 168,
          "x": 105,
          "y": 5,
          "z": -180
        },
        {
          "hole": 169,
          "x": 105,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 170,
          "x": 105,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 171,
          "x": 105,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 172,
          "x": 105,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 173,
          "x": 105,
          "y": 5,
          "z": -220
        },
        {
          "hole": 174,
          "x": 105,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 175,
          "x": 105,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 176,
          "x": 105,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 177,
          "x": 105,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 178,
          "x": 105,
          "y": 5,
          "z": -260
        },
        {
          "hole": 179,
          "x": 105,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 180,
          "x": 105,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 181,
          "x": 104.1481,
          "y": 5,
          "z": -286.4705
        },
        {
          "hole": 182,
          "x": 101.6506,
          "y": 5,
          "z": -292.5
        },
        {
          "hole": 183,
          "x": 97.6777,
          "y": 5,
          "z": -297.6777
        },
        {
          "hole": 184,
          "x": 92.5,
          "y": 5,
          "z": -301.6506
        },
        {
          "hole": 185,
          "x": 86.4705,
          "y": 5,
          "z": -304.1481
        },
        {
          "hole": 186,
          "x": 73.5295,
          "y": 5,
          "z": -304.1481
        },
        {
          "hole": 187,
          "x": 67.5,
          "y": 5,
          "z": -301.6506
        },
        {
          "hole": 188,
          "x": 62.3223,
          "y": 5,
          "z": -297.6777
        },
        {
          "hole": 189,
          "x": 58.3494,
          "y": 5,
          "z": -292.5
        },
        {
          "hole": 190,
          "x": 55.8519,
          "y": 5,
          "z": -286.4705
        },
        {
          "hole": 191,
          "x": 55,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 192,
          "x": 55,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 193,
          "x": 55,
          "y": 5,
          "z": -260
        },
        {
          "hole": 194,
          "x": 55,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 195,
          "x": 55,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 196,
          "x": 55,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 197,
          "x": 55,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 198,
          "x": 55,
          "y": 5,
          "z": -220
        },
        {
          "hole": 199,
          "x": 55,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 200,
          "x": 55,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 201,
          "x": 55,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 202,
          "x": 55,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 203,
          "x": 55,
          "y": 5,
          "z": -180
        },
        {
          "hole": 204,
          "x": 55,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 205,
          "x": 55,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 206,
          "x": 55,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 207,
          "x": 55,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 208,
          "x": 55,
          "y": 5,
          "z": -140
        },
        {
          "hole": 209,
          "x": 55,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 210,
          "x": 55,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 211,
          "x": 55,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 212,
          "x": 55,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 213,
          "x": 55,
          "y": 5,
          "z": -100
        },
        {
          "hole": 214,
          "x": 55,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 215,
          "x": 55,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 216,
          "x": 55,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 217,
          "x": 55,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 218,
          "x": 55,
          "y": 5,
          "z": -60
        },
        {
          "hole": 219,
          "x": 55,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 220,
          "x": 55,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 221,
          "x": 55,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 222,
          "x": 55,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 223,
          "x": 55,
          "y": 5,
          "z": -20
        },
        {
          "hole": 224,
          "x": 55,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 225,
          "x": 55,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 226,
          "x": 55,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 227,
          "x": 55,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 228,
          "x": 55,
          "y": 5,
          "z": 20
        },
        {
          "hole": 229,
          "x": 55,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 230,
          "x": 55,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 231,
          "x": 55,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 232,
          "x": 55,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 233,
          "x": 55,
          "y": 5,
          "z": 60
        },
        {
          "hole": 234,
          "x": 55,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 235,
          "x": 55,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 236,
          "x": 53.1259,
          "y": 5,
          "z": 94.235
        },
        {
          "hole": 237,
          "x": 47.6314,
          "y": 5,
          "z": 107.5
        },
        {
          "hole": 238,
          "x": 38.8909,
          "y": 5,
          "z": 118.8909
        },
        {
          "hole": 239,
          "x": 27.5,
          "y": 5,
          "z": 127.6314
        },
        {
          "hole": 240,
          "x": 14.235,
          "y": 5,
          "z": 133.1259
        },
        {
          "hole": 241,
          "x": -14.235,
          "y": 5,
          "z": 133.1259
        },
        {
          "hole": 242,
          "x": -27.5,
          "y": 5,
          "z": 127.6314
        },
        {
          "hole": 243,
          "x": -38.8909,
          "y": 5,
          "z": 118.8909
        },
        {
          "hole": 244,
          "x": -47.6314,
          "y": 5,
          "z": 107.5
        },
        {
          "hole": 245,
          "x": -53.1259,
          "y": 5,
          "z": 94.235
        },
        {
          "hole": 246,
          "x": -55,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 247,
          "x": -55,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 248,
          "x": -55,
          "y": 5,
          "z": 60
        },
        {
          "hole": 249,
          "x": -55,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 250,
          "x": -55,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 251,
          "x": -55,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 252,
          "x": -55,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 253,
          "x": -55,
          "y": 5,
          "z": 20
        },
        {
          "hole": 254,
          "x": -55,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 255,
          "x": -55,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 256,
          "x": -55,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 257,
          "x": -55,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 258,
          "x": -55,
          "y": 5,
          "z": -20
        },
        {
          "hole": 259,
          "x": -55,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 260,
          "x": -55,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 261,
          "x": -55,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 262,
          "x": -55,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 263,
          "x": -55,
          "y": 5,
          "z": -60
        },
        {
          "hole": 264,
          "x": -55,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 265,
          "x": -55,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 266,
          "x": -55,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 267,
          "x": -55,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 268,
          "x": -55,
          "y": 5,
          "z": -100
        },
        {
          "hole": 269,
          "x": -55,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 270,
          "x": -55,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 271,
          "x": -55,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 272,
          "x": -55,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 273,
          "x": -55,
          "y": 5,
          "z": -140
        },
        {
          "hole": 274,
          "x": -55,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 275,
          "x": -55,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 276,
          "x": -55,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 277,
          "x": -55,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 278,
          "x": -55,
          "y": 5,
          "z": -180
        },
        {
          "hole": 279,
          "x": -55,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 280,
          "x": -55,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 281,
          "x": -55,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 282,
          "x": -55,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 283,
          "x": -55,
          "y": 5,
          "z": -220
        },
        {
          "hole": 284,
          "x": -55,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 285,
          "x": -55,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 286,
          "x": -55,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 287,
          "x": -55,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 288,
          "x": -55,
          "y": 5,
          "z": -260
        },
        {
          "hole": 289,
          "x": -55,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 290,
          "x": -55,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 291,
          "x": -55.8519,
          "y": 5,
          "z": -286.4705
        },
        {
          "hole": 292,
          "x": -58.3494,
          "y": 5,
          "z": -292.5
        },
        {
          "hole": 293,
          "x": -62.3223,
          "y": 5,
          "z": -297.6777
        },
        {
          "hole": 294,
          "x": -67.5,
          "y": 5,
          "z": -301.6506
        },
        {
          "hole": 295,
          "x": -73.5295,
          "y": 5,
          "z": -304.1481
        },
        {
          "hole": 296,
          "x": -86.4705,
          "y": 5,
          "z": -304.1481
        },
        {
          "hole": 297,
          "x": -92.5,
          "y": 5,
          "z": -301.6506
        },
        {
          "hole": 298,
          "x": -97.6777,
          "y": 5,
          "z": -297.6777
        },
        {
          "hole": 299,
          "x": -101.6506,
          "y": 5,
          "z": -292.5
        },
        {
          "hole": 300,
          "x": -104.1481,
          "y": 5,
          "z": -286.4705
        },
        {
          "hole": 301,
          "x": -105,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 302,
          "x": -105,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 303,
          "x": -105,
          "y": 5,
          "z": -260
        },
        {
          "hole": 304,
          "x": -105,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 305,
          "x": -105,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 306,
          "x": -105,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 307,
          "x": -105,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 308,
          "x": -105,
          "y": 5,
          "z": -220
        },
        {
          "hole": 309,
          "x": -105,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 310,
          "x": -105,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 311,
          "x": -105,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 312,
          "x": -105,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 313,
          "x": -105,
          "y": 5,
          "z": -180
        },
        {
          "hole": 314,
          "x": -105,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 315,
          "x": -105,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 316,
          "x": -105,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 317,
          "x": -105,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 318,
          "x": -105,
          "y": 5,
          "z": -140
        },
        {
          "hole": 319,
          "x": -105,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 320,
          "x": -105,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 321,
          "x": -105,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 322,
          "x": -105,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 323,
          "x": -105,
          "y": 5,
          "z": -100
        },
        {
          "hole": 324,
          "x": -105,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 325,
          "x": -105,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 326,
          "x": -105,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 327,
          "x": -105,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 328,
          "x": -105,
          "y": 5,
          "z": -60
        },
        {
          "hole": 329,
          "x": -105,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 330,
          "x": -105,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 331,
          "x": -105,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 332,
          "x": -105,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 333,
          "x": -105,
          "y": 5,
          "z": -20
        },
        {
          "hole": 334,
          "x": -105,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 335,
          "x": -105,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 336,
          "x": -105,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 337,
          "x": -105,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 338,
          "x": -105,
          "y": 5,
          "z": 20
        },
        {
          "hole": 339,
          "x": -105,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 340,
          "x": -105,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 341,
          "x": -106.8741,
          "y": 5,
          "z": 54.235
        },
        {
          "hole": 342,
          "x": -112.3686,
          "y": 5,
          "z": 67.5
        },
        {
          "hole": 343,
          "x": -121.1091,
          "y": 5,
          "z": 78.8909
        },
        {
          "hole": 344,
          "x": -132.5,
          "y": 5,
          "z": 87.6314
        },
        {
          "hole": 345,
          "x": -145.765,
          "y": 5,
          "z": 93.1259
        },
        {
          "hole": 346,
          "x": -174.235,
          "y": 5,
          "z": 93.1259
        },
        {
          "hole": 347,
          "x": -187.5,
          "y": 5,
          "z": 87.6314
        },
        {
          "hole": 348,
          "x": -198.8909,
          "y": 5,
          "z": 78.8909
        },
        {
          "hole": 349,
          "x": -207.6314,
          "y": 5,
          "z": 67.5
        },
        {
          "hole": 350,
          "x": -213.1259,
          "y": 5,
          "z": 54.235
        },
        {
          "hole": 351,
          "x": -215,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 352,
          "x": -215,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 353,
          "x": -215,
          "y": 5,
          "z": 20
        },
        {
          "hole": 354,
          "x": -215,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 355,
          "x": -215,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 356,
          "x": -215,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 357,
          "x": -215,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 358,
          "x": -215,
          "y": 5,
          "z": -20
        },
        {
          "hole": 359,
          "x": -215,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 360,
          "x": -215,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 361,
          "x": -215,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 362,
          "x": -215,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 363,
          "x": -215,
          "y": 5,
          "z": -60
        },
        {
          "hole": 364,
          "x": -215,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 365,
          "x": -215,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 366,
          "x": -215,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 367,
          "x": -215,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 368,
          "x": -215,
          "y": 5,
          "z": -100
        },
        {
          "hole": 369,
          "x": -215,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 370,
          "x": -215,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 371,
          "x": -215,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 372,
          "x": -215,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 373,
          "x": -215,
          "y": 5,
          "z": -140
        },
        {
          "hole": 374,
          "x": -215,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 375,
          "x": -215,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 376,
          "x": -215,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 377,
          "x": -215,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 378,
          "x": -215,
          "y": 5,
          "z": -180
        },
        {
          "hole": 379,
          "x": -215,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 380,
          "x": -215,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 381,
          "x": -215,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 382,
          "x": -215,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 383,
          "x": -215,
          "y": 5,
          "z": -220
        },
        {
          "hole": 384,
          "x": -215,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 385,
          "x": -215,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 386,
          "x": -215,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 387,
          "x": -215,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 388,
          "x": -215,
          "y": 5,
          "z": -260
        },
        {
          "hole": 389,
          "x": -215,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 390,
          "x": -215,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 391,
          "x": -215.8519,
          "y": 5,
          "z": -286.4705
        },
        {
          "hole": 392,
          "x": -218.3494,
          "y": 5,
          "z": -292.5
        },
        {
          "hole": 393,
          "x": -222.3223,
          "y": 5,
          "z": -297.6777
        },
        {
          "hole": 394,
          "x": -227.5,
          "y": 5,
          "z": -301.6506
        },
        {
          "hole": 395,
          "x": -233.5295,
          "y": 5,
          "z": -304.1481
        },
        {
          "hole": 396,
          "x": -246.4705,
          "y": 5,
          "z": -304.1481
        },
        {
          "hole": 397,
          "x": -252.5,
          "y": 5,
          "z": -301.6506
        },
        {
          "hole": 398,
          "x": -257.6777,
          "y": 5,
          "z": -297.6777
        },
        {
          "hole": 399,
          "x": -261.6506,
          "y": 5,
          "z": -292.5
        },
        {
          "hole": 400,
          "x": -264.1481,
          "y": 5,
          "z": -286.4705
        },
        {
          "hole": 401,
          "x": -265,
          "y": 5,
          "z": -275.5
        },
        {
          "hole": 402,
          "x": -265,
          "y": 5,
          "z": -267.75
        },
        {
          "hole": 403,
          "x": -265,
          "y": 5,
          "z": -260
        },
        {
          "hole": 404,
          "x": -265,
          "y": 5,
          "z": -252.25
        },
        {
          "hole": 405,
          "x": -265,
          "y": 5,
          "z": -244.5
        },
        {
          "hole": 406,
          "x": -265,
          "y": 5,
          "z": -235.5
        },
        {
          "hole": 407,
          "x": -265,
          "y": 5,
          "z": -227.75
        },
        {
          "hole": 408,
          "x": -265,
          "y": 5,
          "z": -220
        },
        {
          "hole": 409,
          "x": -265,
          "y": 5,
          "z": -212.25
        },
        {
          "hole": 410,
          "x": -265,
          "y": 5,
          "z": -204.5
        },
        {
          "hole": 411,
          "x": -265,
          "y": 5,
          "z": -195.5
        },
        {
          "hole": 412,
          "x": -265,
          "y": 5,
          "z": -187.75
        },
        {
          "hole": 413,
          "x": -265,
          "y": 5,
          "z": -180
        },
        {
          "hole": 414,
          "x": -265,
          "y": 5,
          "z": -172.25
        },
        {
          "hole": 415,
          "x": -265,
          "y": 5,
          "z": -164.5
        },
        {
          "hole": 416,
          "x": -265,
          "y": 5,
          "z": -155.5
        },
        {
          "hole": 417,
          "x": -265,
          "y": 5,
          "z": -147.75
        },
        {
          "hole": 418,
          "x": -265,
          "y": 5,
          "z": -140
        },
        {
          "hole": 419,
          "x": -265,
          "y": 5,
          "z": -132.25
        },
        {
          "hole": 420,
          "x": -265,
          "y": 5,
          "z": -124.5
        },
        {
          "hole": 421,
          "x": -265,
          "y": 5,
          "z": -115.5
        },
        {
          "hole": 422,
          "x": -265,
          "y": 5,
          "z": -107.75
        },
        {
          "hole": 423,
          "x": -265,
          "y": 5,
          "z": -100
        },
        {
          "hole": 424,
          "x": -265,
          "y": 5,
          "z": -92.25
        },
        {
          "hole": 425,
          "x": -265,
          "y": 5,
          "z": -84.5
        },
        {
          "hole": 426,
          "x": -265,
          "y": 5,
          "z": -75.5
        },
        {
          "hole": 427,
          "x": -265,
          "y": 5,
          "z": -67.75
        },
        {
          "hole": 428,
          "x": -265,
          "y": 5,
          "z": -60
        },
        {
          "hole": 429,
          "x": -265,
          "y": 5,
          "z": -52.25
        },
        {
          "hole": 430,
          "x": -265,
          "y": 5,
          "z": -44.5
        },
        {
          "hole": 431,
          "x": -265,
          "y": 5,
          "z": -35.5
        },
        {
          "hole": 432,
          "x": -265,
          "y": 5,
          "z": -27.75
        },
        {
          "hole": 433,
          "x": -265,
          "y": 5,
          "z": -20
        },
        {
          "hole": 434,
          "x": -265,
          "y": 5,
          "z": -12.25
        },
        {
          "hole": 435,
          "x": -265,
          "y": 5,
          "z": -4.5
        },
        {
          "hole": 436,
          "x": -265,
          "y": 5,
          "z": 4.5
        },
        {
          "hole": 437,
          "x": -265,
          "y": 5,
          "z": 12.25
        },
        {
          "hole": 438,
          "x": -265,
          "y": 5,
          "z": 20
        },
        {
          "hole": 439,
          "x": -265,
          "y": 5,
          "z": 27.75
        },
        {
          "hole": 440,
          "x": -265,
          "y": 5,
          "z": 35.5
        },
        {
          "hole": 441,
          "x": -265,
          "y": 5,
          "z": 44.5
        },
        {
          "hole": 442,
          "x": -265,
          "y": 5,
          "z": 52.25
        },
        {
          "hole": 443,
          "x": -265,
          "y": 5,
          "z": 60
        },
        {
          "hole": 444,
          "x": -265,
          "y": 5,
          "z": 67.75
        },
        {
          "hole": 445,
          "x": -265,
          "y": 5,
          "z": 75.5
        },
        {
          "hole": 446,
          "x": -265,
          "y": 5,
          "z": 84.5
        },
        {
          "hole": 447,
          "x": -265,
          "y": 5,
          "z": 92.25
        },
        {
          "hole": 448,
          "x": -265,
          "y": 5,
          "z": 100
        },
        {
          "hole": 449,
          "x": -265,
          "y": 5,
          "z": 107.75
        },
        {
          "hole": 450,
          "x": -265,
          "y": 5,
          "z": 115.5
        },
        {
          "hole": 451,
          "x": -264.1481,
          "y": 5,
          "z": 126.4705
        },
        {
          "hole": 452,
          "x": -261.6506,
          "y": 5,
          "z": 132.5
        },
        {
          "hole": 453,
          "x": -257.6777,
          "y": 5,
          "z": 137.6777
        },
        {
          "hole": 454,
          "x": -252.5,
          "y": 5,
          "z": 141.6506
        },
        {
          "hole": 455,
          "x": -246.4705,
          "y": 5,
          "z": 144.1481
        },
        {
          "hole": 456,
          "x": -235.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 457,
          "x": -227.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 458,
          "x": -220,
          "y": 5,
          "z": 145
        },
        {
          "hole": 459,
          "x": -212.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 460,
          "x": -204.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 461,
          "x": -195.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 462,
          "x": -187.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 463,
          "x": -180,
          "y": 5,
          "z": 145
        },
        {
          "hole": 464,
          "x": -172.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 465,
          "x": -164.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 466,
          "x": -155.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 467,
          "x": -147.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 468,
          "x": -140,
          "y": 5,
          "z": 145
        },
        {
          "hole": 469,
          "x": -132.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 470,
          "x": -124.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 471,
          "x": -115.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 472,
          "x": -107.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 473,
          "x": -100,
          "y": 5,
          "z": 145
        },
        {
          "hole": 474,
          "x": -92.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 475,
          "x": -84.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 476,
          "x": -75.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 477,
          "x": -67.75,
          "y": 5,
          "z": 145
        },
        {
          "hole": 478,
          "x": -60,
          "y": 5,
          "z": 145
        },
        {
          "hole": 479,
          "x": -52.25,
          "y": 5,
          "z": 145
        },
        {
          "hole": 480,
          "x": -44.5,
          "y": 5,
          "z": 145
        },
        {
          "hole": 481,
          "x": -20,
          "y": 5,
          "z": 160
        }
      ]
    }
  },
  {
    "id": "board-spiral",
    "name": "3D Spiral",
    "brand": "crazy,pints,adult",
    "desc": "3D Spiral cribbage board.",
    "target": 121,
    "trackCount": 2,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/spiral-thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/469cce6d4b1eeaac/spiral-board.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 35.7626,
          "y": 5,
          "z": 153.7339
        },
        {
          "hole": 1,
          "x": -44.9424,
          "y": 5,
          "z": 156.6635
        },
        {
          "hole": 2,
          "x": -94.9874,
          "y": 5,
          "z": 135.9342
        },
        {
          "hole": 3,
          "x": -137.9621,
          "y": 5,
          "z": 102.9585
        },
        {
          "hole": 4,
          "x": -170.9377,
          "y": 5,
          "z": 59.9839
        },
        {
          "hole": 5,
          "x": -191.667,
          "y": 5,
          "z": 9.9388
        },
        {
          "hole": 6,
          "x": -191.9226,
          "y": 5,
          "z": -95.5299
        },
        {
          "hole": 7,
          "x": -171.9425,
          "y": 5,
          "z": -143.7661
        },
        {
          "hole": 8,
          "x": -140.1588,
          "y": 5,
          "z": -185.1875
        },
        {
          "hole": 9,
          "x": -98.7374,
          "y": 5,
          "z": -216.9712
        },
        {
          "hole": 10,
          "x": -50.5013,
          "y": 5,
          "z": -236.9513
        },
        {
          "hole": 11,
          "x": 51.0852,
          "y": 5,
          "z": -237.2068
        },
        {
          "hole": 12,
          "x": 97.5126,
          "y": 5,
          "z": -217.976
        },
        {
          "hole": 13,
          "x": 137.3806,
          "y": 5,
          "z": -187.3842
        },
        {
          "hole": 14,
          "x": 167.9724,
          "y": 5,
          "z": -147.5161
        },
        {
          "hole": 15,
          "x": 187.2033,
          "y": 5,
          "z": -101.0888
        },
        {
          "hole": 16,
          "x": 187.4588,
          "y": 5,
          "z": -3.3846
        },
        {
          "hole": 17,
          "x": 168.9773,
          "y": 5,
          "z": 41.2339
        },
        {
          "hole": 18,
          "x": 139.5773,
          "y": 5,
          "z": 79.5486
        },
        {
          "hole": 19,
          "x": 101.2626,
          "y": 5,
          "z": 108.9486
        },
        {
          "hole": 20,
          "x": 56.6441,
          "y": 5,
          "z": 127.4302
        },
        {
          "hole": 21,
          "x": -37.1778,
          "y": 15,
          "z": 127.6857
        },
        {
          "hole": 22,
          "x": -79.9874,
          "y": 15,
          "z": 109.9534
        },
        {
          "hole": 23,
          "x": -116.7489,
          "y": 15,
          "z": 81.7453
        },
        {
          "hole": 24,
          "x": -144.9569,
          "y": 15,
          "z": 44.9839
        },
        {
          "hole": 25,
          "x": -162.6893,
          "y": 15,
          "z": 2.1743
        },
        {
          "hole": 26,
          "x": -162.9448,
          "y": 15,
          "z": -87.7654
        },
        {
          "hole": 27,
          "x": -145.9617,
          "y": 15,
          "z": -128.7661
        },
        {
          "hole": 28,
          "x": -118.9456,
          "y": 15,
          "z": -163.9743
        },
        {
          "hole": 29,
          "x": -83.7374,
          "y": 15,
          "z": -190.9904
        },
        {
          "hole": 30,
          "x": -42.7367,
          "y": 15,
          "z": -207.9735
        },
        {
          "hole": 31,
          "x": 43.3207,
          "y": 15,
          "z": -208.2291
        },
        {
          "hole": 32,
          "x": 82.5126,
          "y": 15,
          "z": -191.9952
        },
        {
          "hole": 33,
          "x": 116.1674,
          "y": 15,
          "z": -166.171
        },
        {
          "hole": 34,
          "x": 141.9917,
          "y": 15,
          "z": -132.5161
        },
        {
          "hole": 35,
          "x": 158.2255,
          "y": 15,
          "z": -93.3242
        },
        {
          "hole": 36,
          "x": 158.4811,
          "y": 15,
          "z": -11.1492
        },
        {
          "hole": 37,
          "x": 142.9965,
          "y": 15,
          "z": 26.2339
        },
        {
          "hole": 38,
          "x": 118.3641,
          "y": 15,
          "z": 58.3354
        },
        {
          "hole": 39,
          "x": 86.2626,
          "y": 15,
          "z": 82.9678
        },
        {
          "hole": 40,
          "x": 48.8795,
          "y": 15,
          "z": 98.4524
        },
        {
          "hole": 41,
          "x": -29.4132,
          "y": 25,
          "z": 98.7079
        },
        {
          "hole": 42,
          "x": -64.9874,
          "y": 25,
          "z": 83.9726
        },
        {
          "hole": 43,
          "x": -95.5357,
          "y": 25,
          "z": 60.5321
        },
        {
          "hole": 44,
          "x": -118.9762,
          "y": 25,
          "z": 29.9839
        },
        {
          "hole": 45,
          "x": -133.7115,
          "y": 25,
          "z": -5.5903
        },
        {
          "hole": 46,
          "x": -133.967,
          "y": 25,
          "z": -80.0008
        },
        {
          "hole": 47,
          "x": -119.981,
          "y": 25,
          "z": -113.7661
        },
        {
          "hole": 48,
          "x": -97.7324,
          "y": 25,
          "z": -142.7611
        },
        {
          "hole": 49,
          "x": -68.7374,
          "y": 25,
          "z": -165.0097
        },
        {
          "hole": 50,
          "x": -34.9721,
          "y": 25,
          "z": -178.9957
        },
        {
          "hole": 51,
          "x": 35.5561,
          "y": 25,
          "z": -179.2513
        },
        {
          "hole": 52,
          "x": 67.5126,
          "y": 25,
          "z": -166.0145
        },
        {
          "hole": 53,
          "x": 94.9542,
          "y": 25,
          "z": -144.9578
        },
        {
          "hole": 54,
          "x": 116.0109,
          "y": 25,
          "z": -117.5161
        },
        {
          "hole": 55,
          "x": 129.2477,
          "y": 25,
          "z": -85.5596
        },
        {
          "hole": 56,
          "x": 129.5033,
          "y": 25,
          "z": -18.9137
        },
        {
          "hole": 57,
          "x": 117.0157,
          "y": 25,
          "z": 11.2339
        },
        {
          "hole": 58,
          "x": 97.1509,
          "y": 25,
          "z": 37.1222
        },
        {
          "hole": 59,
          "x": 71.2626,
          "y": 25,
          "z": 56.9871
        },
        {
          "hole": 60,
          "x": 41.1149,
          "y": 25,
          "z": 69.4746
        },
        {
          "hole": 61,
          "x": -21.6487,
          "y": 35,
          "z": 69.7302
        },
        {
          "hole": 62,
          "x": -49.9874,
          "y": 35,
          "z": 57.9919
        },
        {
          "hole": 63,
          "x": -74.3225,
          "y": 35,
          "z": 39.3189
        },
        {
          "hole": 64,
          "x": -92.9954,
          "y": 35,
          "z": 14.9839
        },
        {
          "hole": 65,
          "x": -104.7337,
          "y": 35,
          "z": -13.3549
        },
        {
          "hole": 66,
          "x": -104.9893,
          "y": 35,
          "z": -72.2362
        },
        {
          "hole": 67,
          "x": -94.0002,
          "y": 35,
          "z": -98.7661
        },
        {
          "hole": 68,
          "x": -76.5192,
          "y": 35,
          "z": -121.5479
        },
        {
          "hole": 69,
          "x": -53.7374,
          "y": 35,
          "z": -139.0289
        },
        {
          "hole": 70,
          "x": -27.2075,
          "y": 35,
          "z": -150.018
        },
        {
          "hole": 71,
          "x": 27.7915,
          "y": 35,
          "z": -150.2735
        },
        {
          "hole": 72,
          "x": 52.5126,
          "y": 35,
          "z": -140.0337
        },
        {
          "hole": 73,
          "x": 73.741,
          "y": 35,
          "z": -123.7446
        },
        {
          "hole": 74,
          "x": 90.0302,
          "y": 35,
          "z": -102.5161
        },
        {
          "hole": 75,
          "x": 100.27,
          "y": 35,
          "z": -77.7951
        },
        {
          "hole": 76,
          "x": 100.5255,
          "y": 35,
          "z": -26.6783
        },
        {
          "hole": 77,
          "x": 91.035,
          "y": 35,
          "z": -3.7661
        },
        {
          "hole": 78,
          "x": 75.9377,
          "y": 35,
          "z": 15.909
        },
        {
          "hole": 79,
          "x": 56.2626,
          "y": 35,
          "z": 31.0063
        },
        {
          "hole": 80,
          "x": 33.3504,
          "y": 35,
          "z": 40.4968
        },
        {
          "hole": 81,
          "x": -13.8841,
          "y": 45,
          "z": 40.7524
        },
        {
          "hole": 82,
          "x": -34.9874,
          "y": 45,
          "z": 32.0111
        },
        {
          "hole": 83,
          "x": -53.1093,
          "y": 45,
          "z": 18.1057
        },
        {
          "hole": 84,
          "x": -67.0147,
          "y": 45,
          "z": -0.0161
        },
        {
          "hole": 85,
          "x": -75.7559,
          "y": 45,
          "z": -21.1194
        },
        {
          "hole": 86,
          "x": -76.0115,
          "y": 45,
          "z": -64.4716
        },
        {
          "hole": 87,
          "x": -68.0195,
          "y": 45,
          "z": -83.7661
        },
        {
          "hole": 88,
          "x": -55.306,
          "y": 45,
          "z": -100.3347
        },
        {
          "hole": 89,
          "x": -38.7374,
          "y": 45,
          "z": -113.0481
        },
        {
          "hole": 90,
          "x": -19.443,
          "y": 45,
          "z": -121.0402
        },
        {
          "hole": 91,
          "x": 20.0269,
          "y": 45,
          "z": -121.2957
        },
        {
          "hole": 92,
          "x": 37.5126,
          "y": 45,
          "z": -114.053
        },
        {
          "hole": 93,
          "x": 52.5278,
          "y": 45,
          "z": -102.5314
        },
        {
          "hole": 94,
          "x": 64.0494,
          "y": 45,
          "z": -87.5161
        },
        {
          "hole": 95,
          "x": 71.2922,
          "y": 45,
          "z": -70.0305
        },
        {
          "hole": 96,
          "x": 71.5477,
          "y": 45,
          "z": -34.4429
        },
        {
          "hole": 97,
          "x": 65.0542,
          "y": 45,
          "z": -18.7661
        },
        {
          "hole": 98,
          "x": 54.7245,
          "y": 45,
          "z": -5.3042
        },
        {
          "hole": 99,
          "x": 41.2626,
          "y": 45,
          "z": 5.0255
        },
        {
          "hole": 100,
          "x": 25.5858,
          "y": 45,
          "z": 11.5191
        },
        {
          "hole": 101,
          "x": -6.1195,
          "y": 55,
          "z": 11.7746
        },
        {
          "hole": 102,
          "x": -19.9874,
          "y": 55,
          "z": 6.0303
        },
        {
          "hole": 103,
          "x": -31.8961,
          "y": 55,
          "z": -3.1075
        },
        {
          "hole": 104,
          "x": -41.0339,
          "y": 55,
          "z": -15.0161
        },
        {
          "hole": 105,
          "x": -46.7782,
          "y": 55,
          "z": -28.884
        },
        {
          "hole": 106,
          "x": -47.0337,
          "y": 55,
          "z": -56.7071
        },
        {
          "hole": 107,
          "x": -42.0387,
          "y": 55,
          "z": -68.7661
        },
        {
          "hole": 108,
          "x": -34.0928,
          "y": 55,
          "z": -79.1215
        },
        {
          "hole": 109,
          "x": -23.7374,
          "y": 55,
          "z": -87.0674
        },
        {
          "hole": 110,
          "x": -11.6784,
          "y": 55,
          "z": -92.0624
        },
        {
          "hole": 111,
          "x": 12.2624,
          "y": 55,
          "z": -92.318
        },
        {
          "hole": 112,
          "x": 22.5126,
          "y": 55,
          "z": -88.0722
        },
        {
          "hole": 113,
          "x": 31.3146,
          "y": 55,
          "z": -81.3182
        },
        {
          "hole": 114,
          "x": 38.0686,
          "y": 55,
          "z": -72.5161
        },
        {
          "hole": 115,
          "x": 42.3144,
          "y": 55,
          "z": -62.2659
        },
        {
          "hole": 116,
          "x": 42.57,
          "y": 55,
          "z": -42.2074
        },
        {
          "hole": 117,
          "x": 39.0734,
          "y": 55,
          "z": -33.7661
        },
        {
          "hole": 118,
          "x": 33.5113,
          "y": 55,
          "z": -26.5174
        },
        {
          "hole": 119,
          "x": 26.2626,
          "y": 55,
          "z": -20.9552
        },
        {
          "hole": 120,
          "x": 17.8212,
          "y": 55,
          "z": -17.4587
        },
        {
          "hole": 121,
          "x": 0.0126,
          "y": 55,
          "z": -21.2661
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 35.7626,
          "y": 5,
          "z": 163.7339
        },
        {
          "hole": 1,
          "x": -42.3542,
          "y": 5,
          "z": 147.0042
        },
        {
          "hole": 2,
          "x": -89.9874,
          "y": 5,
          "z": 127.2739
        },
        {
          "hole": 3,
          "x": -130.891,
          "y": 5,
          "z": 95.8875
        },
        {
          "hole": 4,
          "x": -162.2774,
          "y": 5,
          "z": 54.9839
        },
        {
          "hole": 5,
          "x": -182.0078,
          "y": 5,
          "z": 7.3506
        },
        {
          "hole": 6,
          "x": -182.2633,
          "y": 5,
          "z": -92.9417
        },
        {
          "hole": 7,
          "x": -163.2823,
          "y": 5,
          "z": -138.7661
        },
        {
          "hole": 8,
          "x": -133.0877,
          "y": 5,
          "z": -178.1164
        },
        {
          "hole": 9,
          "x": -93.7374,
          "y": 5,
          "z": -208.3109
        },
        {
          "hole": 10,
          "x": -47.9131,
          "y": 5,
          "z": -227.292
        },
        {
          "hole": 11,
          "x": 48.497,
          "y": 5,
          "z": -227.5476
        },
        {
          "hole": 12,
          "x": 92.5126,
          "y": 5,
          "z": -209.3157
        },
        {
          "hole": 13,
          "x": 130.3095,
          "y": 5,
          "z": -180.3131
        },
        {
          "hole": 14,
          "x": 159.3122,
          "y": 5,
          "z": -142.5161
        },
        {
          "hole": 15,
          "x": 177.544,
          "y": 5,
          "z": -98.5006
        },
        {
          "hole": 16,
          "x": 177.7996,
          "y": 5,
          "z": -5.9728
        },
        {
          "hole": 17,
          "x": 160.317,
          "y": 5,
          "z": 36.2339
        },
        {
          "hole": 18,
          "x": 132.5062,
          "y": 5,
          "z": 72.4776
        },
        {
          "hole": 19,
          "x": 96.2626,
          "y": 5,
          "z": 100.2883
        },
        {
          "hole": 20,
          "x": 54.0559,
          "y": 5,
          "z": 117.7709
        },
        {
          "hole": 21,
          "x": -34.5896,
          "y": 15,
          "z": 118.0265
        },
        {
          "hole": 22,
          "x": -74.9874,
          "y": 15,
          "z": 101.2931
        },
        {
          "hole": 23,
          "x": -109.6778,
          "y": 15,
          "z": 74.6743
        },
        {
          "hole": 24,
          "x": -136.2967,
          "y": 15,
          "z": 39.9839
        },
        {
          "hole": 25,
          "x": -153.03,
          "y": 15,
          "z": -0.4139
        },
        {
          "hole": 26,
          "x": -153.2856,
          "y": 15,
          "z": -85.1772
        },
        {
          "hole": 27,
          "x": -137.3015,
          "y": 15,
          "z": -123.7661
        },
        {
          "hole": 28,
          "x": -111.8745,
          "y": 15,
          "z": -156.9032
        },
        {
          "hole": 29,
          "x": -78.7374,
          "y": 15,
          "z": -182.3302
        },
        {
          "hole": 30,
          "x": -40.1485,
          "y": 15,
          "z": -198.3142
        },
        {
          "hole": 31,
          "x": 40.7325,
          "y": 15,
          "z": -198.5698
        },
        {
          "hole": 32,
          "x": 77.5126,
          "y": 15,
          "z": -183.335
        },
        {
          "hole": 33,
          "x": 109.0963,
          "y": 15,
          "z": -159.0999
        },
        {
          "hole": 34,
          "x": 133.3314,
          "y": 15,
          "z": -127.5161
        },
        {
          "hole": 35,
          "x": 148.5662,
          "y": 15,
          "z": -90.736
        },
        {
          "hole": 36,
          "x": 148.8218,
          "y": 15,
          "z": -13.7374
        },
        {
          "hole": 37,
          "x": 134.3362,
          "y": 15,
          "z": 21.2339
        },
        {
          "hole": 38,
          "x": 111.293,
          "y": 15,
          "z": 51.2644
        },
        {
          "hole": 39,
          "x": 81.2626,
          "y": 15,
          "z": 74.3076
        },
        {
          "hole": 40,
          "x": 46.2913,
          "y": 15,
          "z": 88.7931
        },
        {
          "hole": 41,
          "x": -26.825,
          "y": 25,
          "z": 89.0487
        },
        {
          "hole": 42,
          "x": -59.9874,
          "y": 25,
          "z": 75.3124
        },
        {
          "hole": 43,
          "x": -88.4646,
          "y": 25,
          "z": 53.4611
        },
        {
          "hole": 44,
          "x": -110.3159,
          "y": 25,
          "z": 24.9839
        },
        {
          "hole": 45,
          "x": -124.0522,
          "y": 25,
          "z": -8.1785
        },
        {
          "hole": 46,
          "x": -124.3078,
          "y": 25,
          "z": -77.4126
        },
        {
          "hole": 47,
          "x": -111.3207,
          "y": 25,
          "z": -108.7661
        },
        {
          "hole": 48,
          "x": -90.6613,
          "y": 25,
          "z": -135.69
        },
        {
          "hole": 49,
          "x": -63.7374,
          "y": 25,
          "z": -156.3494
        },
        {
          "hole": 50,
          "x": -32.3839,
          "y": 25,
          "z": -169.3365
        },
        {
          "hole": 51,
          "x": 32.9679,
          "y": 25,
          "z": -169.592
        },
        {
          "hole": 52,
          "x": 62.5126,
          "y": 25,
          "z": -157.3542
        },
        {
          "hole": 53,
          "x": 87.8831,
          "y": 25,
          "z": -137.8867
        },
        {
          "hole": 54,
          "x": 107.3507,
          "y": 25,
          "z": -112.5161
        },
        {
          "hole": 55,
          "x": 119.5885,
          "y": 25,
          "z": -82.9714
        },
        {
          "hole": 56,
          "x": 119.844,
          "y": 25,
          "z": -21.5019
        },
        {
          "hole": 57,
          "x": 108.3555,
          "y": 25,
          "z": 6.2339
        },
        {
          "hole": 58,
          "x": 90.0798,
          "y": 25,
          "z": 30.0512
        },
        {
          "hole": 59,
          "x": 66.2626,
          "y": 25,
          "z": 48.3268
        },
        {
          "hole": 60,
          "x": 38.5267,
          "y": 25,
          "z": 59.8154
        },
        {
          "hole": 61,
          "x": -19.0605,
          "y": 35,
          "z": 60.0709
        },
        {
          "hole": 62,
          "x": -44.9874,
          "y": 35,
          "z": 49.3316
        },
        {
          "hole": 63,
          "x": -67.2514,
          "y": 35,
          "z": 32.2479
        },
        {
          "hole": 64,
          "x": -84.3352,
          "y": 35,
          "z": 9.9839
        },
        {
          "hole": 65,
          "x": -95.0745,
          "y": 35,
          "z": -15.9431
        },
        {
          "hole": 66,
          "x": -95.33,
          "y": 35,
          "z": -69.648
        },
        {
          "hole": 67,
          "x": -85.34,
          "y": 35,
          "z": -93.7661
        },
        {
          "hole": 68,
          "x": -69.4481,
          "y": 35,
          "z": -114.4768
        },
        {
          "hole": 69,
          "x": -48.7374,
          "y": 35,
          "z": -130.3687
        },
        {
          "hole": 70,
          "x": -24.6193,
          "y": 35,
          "z": -140.3587
        },
        {
          "hole": 71,
          "x": 25.2033,
          "y": 35,
          "z": -140.6143
        },
        {
          "hole": 72,
          "x": 47.5126,
          "y": 35,
          "z": -131.3735
        },
        {
          "hole": 73,
          "x": 66.6699,
          "y": 35,
          "z": -116.6735
        },
        {
          "hole": 74,
          "x": 81.3699,
          "y": 35,
          "z": -97.5161
        },
        {
          "hole": 75,
          "x": 90.6107,
          "y": 35,
          "z": -75.2069
        },
        {
          "hole": 76,
          "x": 90.8663,
          "y": 35,
          "z": -29.2665
        },
        {
          "hole": 77,
          "x": 82.3747,
          "y": 35,
          "z": -8.7661
        },
        {
          "hole": 78,
          "x": 68.8666,
          "y": 35,
          "z": 8.838
        },
        {
          "hole": 79,
          "x": 51.2626,
          "y": 35,
          "z": 22.346
        },
        {
          "hole": 80,
          "x": 30.7622,
          "y": 35,
          "z": 30.8376
        },
        {
          "hole": 81,
          "x": -11.2959,
          "y": 45,
          "z": 31.0931
        },
        {
          "hole": 82,
          "x": -29.9874,
          "y": 45,
          "z": 23.3509
        },
        {
          "hole": 83,
          "x": -46.0382,
          "y": 45,
          "z": 11.0347
        },
        {
          "hole": 84,
          "x": -58.3544,
          "y": 45,
          "z": -5.0161
        },
        {
          "hole": 85,
          "x": -66.0967,
          "y": 45,
          "z": -23.7076
        },
        {
          "hole": 86,
          "x": -66.3522,
          "y": 45,
          "z": -61.8834
        },
        {
          "hole": 87,
          "x": -59.3592,
          "y": 45,
          "z": -78.7661
        },
        {
          "hole": 88,
          "x": -48.2349,
          "y": 45,
          "z": -93.2636
        },
        {
          "hole": 89,
          "x": -33.7374,
          "y": 45,
          "z": -104.3879
        },
        {
          "hole": 90,
          "x": -16.8548,
          "y": 45,
          "z": -111.3809
        },
        {
          "hole": 91,
          "x": 17.4387,
          "y": 45,
          "z": -111.6365
        },
        {
          "hole": 92,
          "x": 32.5126,
          "y": 45,
          "z": -105.3927
        },
        {
          "hole": 93,
          "x": 45.4567,
          "y": 45,
          "z": -95.4603
        },
        {
          "hole": 94,
          "x": 55.3891,
          "y": 45,
          "z": -82.5161
        },
        {
          "hole": 95,
          "x": 61.6329,
          "y": 45,
          "z": -67.4423
        },
        {
          "hole": 96,
          "x": 61.8885,
          "y": 45,
          "z": -37.0311
        },
        {
          "hole": 97,
          "x": 56.394,
          "y": 45,
          "z": -23.7661
        },
        {
          "hole": 98,
          "x": 47.6534,
          "y": 45,
          "z": -12.3752
        },
        {
          "hole": 99,
          "x": 36.2626,
          "y": 45,
          "z": -3.6347
        },
        {
          "hole": 100,
          "x": 22.9976,
          "y": 45,
          "z": 1.8598
        },
        {
          "hole": 101,
          "x": -3.5313,
          "y": 55,
          "z": 2.1154
        },
        {
          "hole": 102,
          "x": -14.9874,
          "y": 55,
          "z": -2.6299
        },
        {
          "hole": 103,
          "x": -24.825,
          "y": 55,
          "z": -10.1785
        },
        {
          "hole": 104,
          "x": -32.3736,
          "y": 55,
          "z": -20.0161
        },
        {
          "hole": 105,
          "x": -37.1189,
          "y": 55,
          "z": -31.4722
        },
        {
          "hole": 106,
          "x": -37.3745,
          "y": 55,
          "z": -54.1189
        },
        {
          "hole": 107,
          "x": -33.3785,
          "y": 55,
          "z": -63.7661
        },
        {
          "hole": 108,
          "x": -27.0217,
          "y": 55,
          "z": -72.0504
        },
        {
          "hole": 109,
          "x": -18.7374,
          "y": 55,
          "z": -78.4071
        },
        {
          "hole": 110,
          "x": -9.0902,
          "y": 55,
          "z": -82.4031
        },
        {
          "hole": 111,
          "x": 9.6742,
          "y": 55,
          "z": -82.6587
        },
        {
          "hole": 112,
          "x": 17.5126,
          "y": 55,
          "z": -79.4119
        },
        {
          "hole": 113,
          "x": 24.2435,
          "y": 55,
          "z": -74.2471
        },
        {
          "hole": 114,
          "x": 29.4084,
          "y": 55,
          "z": -67.5161
        },
        {
          "hole": 115,
          "x": 32.6551,
          "y": 55,
          "z": -59.6777
        },
        {
          "hole": 116,
          "x": 32.9107,
          "y": 55,
          "z": -44.7956
        },
        {
          "hole": 117,
          "x": 30.4132,
          "y": 55,
          "z": -38.7661
        },
        {
          "hole": 118,
          "x": 26.4402,
          "y": 55,
          "z": -33.5884
        },
        {
          "hole": 119,
          "x": 21.2626,
          "y": 55,
          "z": -29.6155
        },
        {
          "hole": 120,
          "x": 15.233,
          "y": 55,
          "z": -27.118
        },
        {
          "hole": 121,
          "x": 0.0126,
          "y": 55,
          "z": -21.2661
        }
      ]
    }
  },
  {
    "id": "board-cribbage-clash-square",
    "name": "Cribbage Clash Square",
    "brand": "clash",
    "desc": "Cribbage Clash Square 3D cribbage board (12.3 MB)",
    "target": 481,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/cribbage-clash-square-thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/e78fceef8feb21ab/Cribbage_Clash_-_Square_-_stepped_-_height.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": -205,
          "y": 10,
          "z": -93
        },
        {
          "hole": 1,
          "x": -235,
          "y": 20,
          "z": -75.5
        },
        {
          "hole": 2,
          "x": -235,
          "y": 20,
          "z": -67.75
        },
        {
          "hole": 3,
          "x": -235,
          "y": 20,
          "z": -60
        },
        {
          "hole": 4,
          "x": -235,
          "y": 20,
          "z": -52.25
        },
        {
          "hole": 5,
          "x": -235,
          "y": 20,
          "z": -44.5
        },
        {
          "hole": 6,
          "x": -235,
          "y": 20,
          "z": -35.5
        },
        {
          "hole": 7,
          "x": -235,
          "y": 20,
          "z": -27.75
        },
        {
          "hole": 8,
          "x": -235,
          "y": 20,
          "z": -20
        },
        {
          "hole": 9,
          "x": -235,
          "y": 20,
          "z": -12.25
        },
        {
          "hole": 10,
          "x": -235,
          "y": 20,
          "z": -4.5
        },
        {
          "hole": 11,
          "x": -235,
          "y": 20,
          "z": 4.5
        },
        {
          "hole": 12,
          "x": -235,
          "y": 20,
          "z": 12.25
        },
        {
          "hole": 13,
          "x": -235,
          "y": 20,
          "z": 20
        },
        {
          "hole": 14,
          "x": -235,
          "y": 20,
          "z": 27.75
        },
        {
          "hole": 15,
          "x": -235,
          "y": 20,
          "z": 35.5
        },
        {
          "hole": 16,
          "x": -235,
          "y": 20,
          "z": 44.5
        },
        {
          "hole": 17,
          "x": -235,
          "y": 20,
          "z": 52.25
        },
        {
          "hole": 18,
          "x": -235,
          "y": 20,
          "z": 60
        },
        {
          "hole": 19,
          "x": -235,
          "y": 20,
          "z": 67.75
        },
        {
          "hole": 20,
          "x": -235,
          "y": 20,
          "z": 75.5
        },
        {
          "hole": 21,
          "x": -235,
          "y": 20,
          "z": 84.5
        },
        {
          "hole": 22,
          "x": -235,
          "y": 20,
          "z": 92.25
        },
        {
          "hole": 23,
          "x": -235,
          "y": 20,
          "z": 100
        },
        {
          "hole": 24,
          "x": -235,
          "y": 20,
          "z": 107.75
        },
        {
          "hole": 25,
          "x": -235,
          "y": 20,
          "z": 115.5
        },
        {
          "hole": 26,
          "x": -235,
          "y": 20,
          "z": 124.5
        },
        {
          "hole": 27,
          "x": -235,
          "y": 20,
          "z": 132.25
        },
        {
          "hole": 28,
          "x": -235,
          "y": 20,
          "z": 140
        },
        {
          "hole": 29,
          "x": -235,
          "y": 20,
          "z": 147.75
        },
        {
          "hole": 30,
          "x": -235,
          "y": 20,
          "z": 155.5
        },
        {
          "hole": 31,
          "x": -235,
          "y": 20,
          "z": 164.5
        },
        {
          "hole": 32,
          "x": -235,
          "y": 20,
          "z": 172.25
        },
        {
          "hole": 33,
          "x": -235,
          "y": 20,
          "z": 180
        },
        {
          "hole": 34,
          "x": -235,
          "y": 20,
          "z": 187.75
        },
        {
          "hole": 35,
          "x": -235,
          "y": 20,
          "z": 195.5
        },
        {
          "hole": 36,
          "x": -235,
          "y": 20,
          "z": 204.9999
        },
        {
          "hole": 37,
          "x": -235,
          "y": 20,
          "z": 212.4999
        },
        {
          "hole": 38,
          "x": -235,
          "y": 20,
          "z": 254.9999
        },
        {
          "hole": 39,
          "x": -192.5,
          "y": 20,
          "z": 254.9999
        },
        {
          "hole": 40,
          "x": -185,
          "y": 20,
          "z": 254.9999
        },
        {
          "hole": 41,
          "x": -175.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 42,
          "x": -167.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 43,
          "x": -160,
          "y": 30,
          "z": 255
        },
        {
          "hole": 44,
          "x": -152.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 45,
          "x": -144.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 46,
          "x": -135.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 47,
          "x": -127.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 48,
          "x": -120,
          "y": 30,
          "z": 255
        },
        {
          "hole": 49,
          "x": -112.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 50,
          "x": -104.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 51,
          "x": -95.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 52,
          "x": -87.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 53,
          "x": -80,
          "y": 30,
          "z": 255
        },
        {
          "hole": 54,
          "x": -72.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 55,
          "x": -64.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 56,
          "x": -55.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 57,
          "x": -47.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 58,
          "x": -40,
          "y": 30,
          "z": 255
        },
        {
          "hole": 59,
          "x": -32.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 60,
          "x": -24.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 61,
          "x": -15.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 62,
          "x": -7.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 63,
          "x": 0,
          "y": 30,
          "z": 255
        },
        {
          "hole": 64,
          "x": 7.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 65,
          "x": 15.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 66,
          "x": 24.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 67,
          "x": 32.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 68,
          "x": 40,
          "y": 30,
          "z": 255
        },
        {
          "hole": 69,
          "x": 47.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 70,
          "x": 55.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 71,
          "x": 64.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 72,
          "x": 72.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 73,
          "x": 80,
          "y": 30,
          "z": 255
        },
        {
          "hole": 74,
          "x": 87.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 75,
          "x": 95.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 76,
          "x": 104.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 77,
          "x": 112.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 78,
          "x": 120,
          "y": 30,
          "z": 255
        },
        {
          "hole": 79,
          "x": 127.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 80,
          "x": 135.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 81,
          "x": 144.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 82,
          "x": 152.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 83,
          "x": 160,
          "y": 30,
          "z": 255
        },
        {
          "hole": 84,
          "x": 167.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 85,
          "x": 175.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 86,
          "x": 184.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 87,
          "x": 192.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 88,
          "x": 200,
          "y": 30,
          "z": 255
        },
        {
          "hole": 89,
          "x": 207.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 90,
          "x": 215.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 91,
          "x": 224.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 92,
          "x": 232.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 93,
          "x": 240,
          "y": 30,
          "z": 255
        },
        {
          "hole": 94,
          "x": 247.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 95,
          "x": 255.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 96,
          "x": 264.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 97,
          "x": 272.25,
          "y": 30,
          "z": 255
        },
        {
          "hole": 98,
          "x": 280,
          "y": 30,
          "z": 255
        },
        {
          "hole": 99,
          "x": 287.75,
          "y": 30,
          "z": 255
        },
        {
          "hole": 100,
          "x": 295.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 101,
          "x": 305,
          "y": 30,
          "z": 255
        },
        {
          "hole": 102,
          "x": 312.5,
          "y": 30,
          "z": 255
        },
        {
          "hole": 103,
          "x": 355,
          "y": 30,
          "z": 255
        },
        {
          "hole": 104,
          "x": 355,
          "y": 30,
          "z": 212.5
        },
        {
          "hole": 105,
          "x": 355,
          "y": 30,
          "z": 205
        },
        {
          "hole": 106,
          "x": 355,
          "y": 40,
          "z": 195.5
        },
        {
          "hole": 107,
          "x": 355,
          "y": 40,
          "z": 187.75
        },
        {
          "hole": 108,
          "x": 355,
          "y": 40,
          "z": 180
        },
        {
          "hole": 109,
          "x": 355,
          "y": 40,
          "z": 172.25
        },
        {
          "hole": 110,
          "x": 355,
          "y": 40,
          "z": 164.5
        },
        {
          "hole": 111,
          "x": 355,
          "y": 40,
          "z": 155.5
        },
        {
          "hole": 112,
          "x": 355,
          "y": 40,
          "z": 147.75
        },
        {
          "hole": 113,
          "x": 355,
          "y": 40,
          "z": 140
        },
        {
          "hole": 114,
          "x": 355,
          "y": 40,
          "z": 132.25
        },
        {
          "hole": 115,
          "x": 355,
          "y": 40,
          "z": 124.5
        },
        {
          "hole": 116,
          "x": 355,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 117,
          "x": 355,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 118,
          "x": 355,
          "y": 40,
          "z": 100
        },
        {
          "hole": 119,
          "x": 355,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 120,
          "x": 355,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 121,
          "x": 355,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 122,
          "x": 355,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 123,
          "x": 355,
          "y": 40,
          "z": 60
        },
        {
          "hole": 124,
          "x": 355,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 125,
          "x": 355,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 126,
          "x": 355,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 127,
          "x": 355,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 128,
          "x": 355,
          "y": 40,
          "z": 20
        },
        {
          "hole": 129,
          "x": 355,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 130,
          "x": 355,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 131,
          "x": 355,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 132,
          "x": 355,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 133,
          "x": 355,
          "y": 40,
          "z": -20
        },
        {
          "hole": 134,
          "x": 355,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 135,
          "x": 355,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 136,
          "x": 355,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 137,
          "x": 355,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 138,
          "x": 355,
          "y": 40,
          "z": -60
        },
        {
          "hole": 139,
          "x": 355,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 140,
          "x": 355,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 141,
          "x": 355,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 142,
          "x": 355,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 143,
          "x": 355,
          "y": 40,
          "z": -100
        },
        {
          "hole": 144,
          "x": 355,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 145,
          "x": 355,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 146,
          "x": 355,
          "y": 40,
          "z": -124.5
        },
        {
          "hole": 147,
          "x": 355,
          "y": 40,
          "z": -132.25
        },
        {
          "hole": 148,
          "x": 355,
          "y": 40,
          "z": -140
        },
        {
          "hole": 149,
          "x": 355,
          "y": 40,
          "z": -147.75
        },
        {
          "hole": 150,
          "x": 355,
          "y": 40,
          "z": -155.5
        },
        {
          "hole": 151,
          "x": 355,
          "y": 40,
          "z": -164.5
        },
        {
          "hole": 152,
          "x": 355,
          "y": 40,
          "z": -172.25
        },
        {
          "hole": 153,
          "x": 355,
          "y": 40,
          "z": -180
        },
        {
          "hole": 154,
          "x": 355,
          "y": 40,
          "z": -187.75
        },
        {
          "hole": 155,
          "x": 355,
          "y": 40,
          "z": -195.5
        },
        {
          "hole": 156,
          "x": 355,
          "y": 40,
          "z": -204.5
        },
        {
          "hole": 157,
          "x": 355,
          "y": 40,
          "z": -212.25
        },
        {
          "hole": 158,
          "x": 355,
          "y": 40,
          "z": -220
        },
        {
          "hole": 159,
          "x": 355,
          "y": 40,
          "z": -227.75
        },
        {
          "hole": 160,
          "x": 355,
          "y": 40,
          "z": -235.5
        },
        {
          "hole": 161,
          "x": 355,
          "y": 40,
          "z": -245
        },
        {
          "hole": 162,
          "x": 355,
          "y": 40,
          "z": -262.5
        },
        {
          "hole": 163,
          "x": 355,
          "y": 40,
          "z": -315
        },
        {
          "hole": 164,
          "x": 302.5,
          "y": 40,
          "z": -315
        },
        {
          "hole": 165,
          "x": 285,
          "y": 40,
          "z": -315
        },
        {
          "hole": 166,
          "x": 275.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 167,
          "x": 267.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 168,
          "x": 260,
          "y": 50,
          "z": -315
        },
        {
          "hole": 169,
          "x": 252.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 170,
          "x": 244.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 171,
          "x": 235.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 172,
          "x": 227.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 173,
          "x": 220,
          "y": 50,
          "z": -315
        },
        {
          "hole": 174,
          "x": 212.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 175,
          "x": 204.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 176,
          "x": 195.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 177,
          "x": 187.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 178,
          "x": 180,
          "y": 50,
          "z": -315
        },
        {
          "hole": 179,
          "x": 172.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 180,
          "x": 164.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 181,
          "x": 155.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 182,
          "x": 147.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 183,
          "x": 140,
          "y": 50,
          "z": -315
        },
        {
          "hole": 184,
          "x": 132.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 185,
          "x": 124.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 186,
          "x": 115.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 187,
          "x": 107.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 188,
          "x": 100,
          "y": 50,
          "z": -315
        },
        {
          "hole": 189,
          "x": 92.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 190,
          "x": 84.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 191,
          "x": 75.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 192,
          "x": 67.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 193,
          "x": 60,
          "y": 50,
          "z": -315
        },
        {
          "hole": 194,
          "x": 52.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 195,
          "x": 44.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 196,
          "x": 35.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 197,
          "x": 27.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 198,
          "x": 20,
          "y": 50,
          "z": -315
        },
        {
          "hole": 199,
          "x": 12.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 200,
          "x": 4.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 201,
          "x": -4.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 202,
          "x": -12.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 203,
          "x": -20,
          "y": 50,
          "z": -315
        },
        {
          "hole": 204,
          "x": -27.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 205,
          "x": -35.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 206,
          "x": -44.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 207,
          "x": -52.25,
          "y": 50,
          "z": -315
        },
        {
          "hole": 208,
          "x": -60,
          "y": 50,
          "z": -315
        },
        {
          "hole": 209,
          "x": -67.75,
          "y": 50,
          "z": -315
        },
        {
          "hole": 210,
          "x": -75.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 211,
          "x": -85,
          "y": 50,
          "z": -315
        },
        {
          "hole": 212,
          "x": -102.5,
          "y": 50,
          "z": -315
        },
        {
          "hole": 213,
          "x": -155,
          "y": 50,
          "z": -315
        },
        {
          "hole": 214,
          "x": -155,
          "y": 50,
          "z": -262.5
        },
        {
          "hole": 215,
          "x": -155,
          "y": 50,
          "z": -245
        },
        {
          "hole": 216,
          "x": -155,
          "y": 60,
          "z": -235.5
        },
        {
          "hole": 217,
          "x": -155,
          "y": 60,
          "z": -227.75
        },
        {
          "hole": 218,
          "x": -155,
          "y": 60,
          "z": -220
        },
        {
          "hole": 219,
          "x": -155,
          "y": 60,
          "z": -212.25
        },
        {
          "hole": 220,
          "x": -155,
          "y": 60,
          "z": -204.5
        },
        {
          "hole": 221,
          "x": -155,
          "y": 60,
          "z": -195.5
        },
        {
          "hole": 222,
          "x": -155,
          "y": 60,
          "z": -187.75
        },
        {
          "hole": 223,
          "x": -155,
          "y": 60,
          "z": -180
        },
        {
          "hole": 224,
          "x": -155,
          "y": 60,
          "z": -172.25
        },
        {
          "hole": 225,
          "x": -155,
          "y": 60,
          "z": -164.5
        },
        {
          "hole": 226,
          "x": -155,
          "y": 60,
          "z": -155.5
        },
        {
          "hole": 227,
          "x": -155,
          "y": 60,
          "z": -147.75
        },
        {
          "hole": 228,
          "x": -155,
          "y": 60,
          "z": -140
        },
        {
          "hole": 229,
          "x": -155,
          "y": 60,
          "z": -132.25
        },
        {
          "hole": 230,
          "x": -155,
          "y": 60,
          "z": -124.5
        },
        {
          "hole": 231,
          "x": -155,
          "y": 60,
          "z": -115.5
        },
        {
          "hole": 232,
          "x": -155,
          "y": 60,
          "z": -107.75
        },
        {
          "hole": 233,
          "x": -155,
          "y": 60,
          "z": -100
        },
        {
          "hole": 234,
          "x": -155,
          "y": 60,
          "z": -92.25
        },
        {
          "hole": 235,
          "x": -155,
          "y": 60,
          "z": -84.5
        },
        {
          "hole": 236,
          "x": -155,
          "y": 60,
          "z": -75.5
        },
        {
          "hole": 237,
          "x": -155,
          "y": 60,
          "z": -67.75
        },
        {
          "hole": 238,
          "x": -155,
          "y": 60,
          "z": -60
        },
        {
          "hole": 239,
          "x": -155,
          "y": 60,
          "z": -52.25
        },
        {
          "hole": 240,
          "x": -155,
          "y": 60,
          "z": -44.5
        },
        {
          "hole": 241,
          "x": -155,
          "y": 60,
          "z": -35.5
        },
        {
          "hole": 242,
          "x": -155,
          "y": 60,
          "z": -27.75
        },
        {
          "hole": 243,
          "x": -155,
          "y": 60,
          "z": -20
        },
        {
          "hole": 244,
          "x": -155,
          "y": 60,
          "z": -12.25
        },
        {
          "hole": 245,
          "x": -155,
          "y": 60,
          "z": -4.5
        },
        {
          "hole": 246,
          "x": -155,
          "y": 60,
          "z": 4.5
        },
        {
          "hole": 247,
          "x": -155,
          "y": 60,
          "z": 12.25
        },
        {
          "hole": 248,
          "x": -155,
          "y": 60,
          "z": 20
        },
        {
          "hole": 249,
          "x": -155,
          "y": 60,
          "z": 27.75
        },
        {
          "hole": 250,
          "x": -155,
          "y": 60,
          "z": 35.5
        },
        {
          "hole": 251,
          "x": -155,
          "y": 60,
          "z": 44.5
        },
        {
          "hole": 252,
          "x": -155,
          "y": 60,
          "z": 52.25
        },
        {
          "hole": 253,
          "x": -155,
          "y": 60,
          "z": 60
        },
        {
          "hole": 254,
          "x": -155,
          "y": 60,
          "z": 67.75
        },
        {
          "hole": 255,
          "x": -155,
          "y": 60,
          "z": 75.5
        },
        {
          "hole": 256,
          "x": -155,
          "y": 60,
          "z": 84.5
        },
        {
          "hole": 257,
          "x": -155,
          "y": 60,
          "z": 92.25
        },
        {
          "hole": 258,
          "x": -155,
          "y": 60,
          "z": 100
        },
        {
          "hole": 259,
          "x": -155,
          "y": 60,
          "z": 107.75
        },
        {
          "hole": 260,
          "x": -155,
          "y": 60,
          "z": 115.5
        },
        {
          "hole": 261,
          "x": -155,
          "y": 60,
          "z": 125
        },
        {
          "hole": 262,
          "x": -155,
          "y": 60,
          "z": 132.5
        },
        {
          "hole": 263,
          "x": -155,
          "y": 60,
          "z": 175
        },
        {
          "hole": 264,
          "x": -112.5,
          "y": 60,
          "z": 175
        },
        {
          "hole": 265,
          "x": -105,
          "y": 60,
          "z": 175
        },
        {
          "hole": 266,
          "x": -95.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 267,
          "x": -87.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 268,
          "x": -80,
          "y": 70,
          "z": 175
        },
        {
          "hole": 269,
          "x": -72.25,
          "y": 70,
          "z": 175
        },
        {
          "hole": 270,
          "x": -64.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 271,
          "x": -55.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 272,
          "x": -47.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 273,
          "x": -40,
          "y": 70,
          "z": 175
        },
        {
          "hole": 274,
          "x": -32.25,
          "y": 70,
          "z": 175
        },
        {
          "hole": 275,
          "x": -24.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 276,
          "x": -15.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 277,
          "x": -7.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 278,
          "x": 0,
          "y": 70,
          "z": 175
        },
        {
          "hole": 279,
          "x": 7.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 280,
          "x": 15.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 281,
          "x": 24.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 282,
          "x": 32.25,
          "y": 70,
          "z": 175
        },
        {
          "hole": 283,
          "x": 40,
          "y": 70,
          "z": 175
        },
        {
          "hole": 284,
          "x": 47.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 285,
          "x": 55.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 286,
          "x": 64.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 287,
          "x": 72.25,
          "y": 70,
          "z": 175
        },
        {
          "hole": 288,
          "x": 80,
          "y": 70,
          "z": 175
        },
        {
          "hole": 289,
          "x": 87.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 290,
          "x": 95.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 291,
          "x": 104.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 292,
          "x": 112.25,
          "y": 70,
          "z": 175
        },
        {
          "hole": 293,
          "x": 120,
          "y": 70,
          "z": 175
        },
        {
          "hole": 294,
          "x": 127.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 295,
          "x": 135.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 296,
          "x": 144.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 297,
          "x": 152.25,
          "y": 70,
          "z": 175
        },
        {
          "hole": 298,
          "x": 160,
          "y": 70,
          "z": 175
        },
        {
          "hole": 299,
          "x": 167.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 300,
          "x": 175.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 301,
          "x": 184.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 302,
          "x": 192.25,
          "y": 70,
          "z": 175
        },
        {
          "hole": 303,
          "x": 200,
          "y": 70,
          "z": 175
        },
        {
          "hole": 304,
          "x": 207.75,
          "y": 70,
          "z": 175
        },
        {
          "hole": 305,
          "x": 215.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 306,
          "x": 225,
          "y": 70,
          "z": 175
        },
        {
          "hole": 307,
          "x": 232.5,
          "y": 70,
          "z": 175
        },
        {
          "hole": 308,
          "x": 275,
          "y": 70,
          "z": 175
        },
        {
          "hole": 309,
          "x": 275,
          "y": 70,
          "z": 132.5
        },
        {
          "hole": 310,
          "x": 275,
          "y": 70,
          "z": 125
        },
        {
          "hole": 311,
          "x": 275,
          "y": 80,
          "z": 115.5
        },
        {
          "hole": 312,
          "x": 275,
          "y": 80,
          "z": 107.75
        },
        {
          "hole": 313,
          "x": 275,
          "y": 80,
          "z": 100
        },
        {
          "hole": 314,
          "x": 275,
          "y": 80,
          "z": 92.25
        },
        {
          "hole": 315,
          "x": 275,
          "y": 80,
          "z": 84.5
        },
        {
          "hole": 316,
          "x": 275,
          "y": 80,
          "z": 75.5
        },
        {
          "hole": 317,
          "x": 275,
          "y": 80,
          "z": 67.75
        },
        {
          "hole": 318,
          "x": 275,
          "y": 80,
          "z": 60
        },
        {
          "hole": 319,
          "x": 275,
          "y": 80,
          "z": 52.25
        },
        {
          "hole": 320,
          "x": 275,
          "y": 80,
          "z": 44.5
        },
        {
          "hole": 321,
          "x": 275,
          "y": 80,
          "z": 35.5
        },
        {
          "hole": 322,
          "x": 275,
          "y": 80,
          "z": 27.75
        },
        {
          "hole": 323,
          "x": 275,
          "y": 80,
          "z": 20
        },
        {
          "hole": 324,
          "x": 275,
          "y": 80,
          "z": 12.25
        },
        {
          "hole": 325,
          "x": 275,
          "y": 80,
          "z": 4.5
        },
        {
          "hole": 326,
          "x": 275,
          "y": 80,
          "z": -4.5
        },
        {
          "hole": 327,
          "x": 275,
          "y": 80,
          "z": -12.25
        },
        {
          "hole": 328,
          "x": 275,
          "y": 80,
          "z": -20
        },
        {
          "hole": 329,
          "x": 275,
          "y": 80,
          "z": -27.75
        },
        {
          "hole": 330,
          "x": 275,
          "y": 80,
          "z": -35.5
        },
        {
          "hole": 331,
          "x": 275,
          "y": 80,
          "z": -44.5
        },
        {
          "hole": 332,
          "x": 275,
          "y": 80,
          "z": -52.25
        },
        {
          "hole": 333,
          "x": 275,
          "y": 80,
          "z": -60
        },
        {
          "hole": 334,
          "x": 275,
          "y": 80,
          "z": -67.75
        },
        {
          "hole": 335,
          "x": 275,
          "y": 80,
          "z": -75.5
        },
        {
          "hole": 336,
          "x": 275,
          "y": 80,
          "z": -84.5
        },
        {
          "hole": 337,
          "x": 275,
          "y": 80,
          "z": -92.25
        },
        {
          "hole": 338,
          "x": 275,
          "y": 80,
          "z": -100
        },
        {
          "hole": 339,
          "x": 275,
          "y": 80,
          "z": -107.75
        },
        {
          "hole": 340,
          "x": 275,
          "y": 80,
          "z": -115.5
        },
        {
          "hole": 341,
          "x": 275,
          "y": 80,
          "z": -124.5
        },
        {
          "hole": 342,
          "x": 275,
          "y": 80,
          "z": -132.25
        },
        {
          "hole": 343,
          "x": 275,
          "y": 80,
          "z": -140
        },
        {
          "hole": 344,
          "x": 275,
          "y": 80,
          "z": -147.75
        },
        {
          "hole": 345,
          "x": 275,
          "y": 80,
          "z": -155.5
        },
        {
          "hole": 346,
          "x": 275,
          "y": 80,
          "z": -165
        },
        {
          "hole": 347,
          "x": 275,
          "y": 80,
          "z": -182.5
        },
        {
          "hole": 348,
          "x": 275,
          "y": 80,
          "z": -235
        },
        {
          "hole": 349,
          "x": 222.5,
          "y": 80,
          "z": -235
        },
        {
          "hole": 350,
          "x": 205,
          "y": 80,
          "z": -235
        },
        {
          "hole": 351,
          "x": 195.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 352,
          "x": 187.75,
          "y": 90,
          "z": -235
        },
        {
          "hole": 353,
          "x": 180,
          "y": 90,
          "z": -235
        },
        {
          "hole": 354,
          "x": 172.25,
          "y": 90,
          "z": -235
        },
        {
          "hole": 355,
          "x": 164.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 356,
          "x": 155.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 357,
          "x": 147.75,
          "y": 90,
          "z": -235
        },
        {
          "hole": 358,
          "x": 140,
          "y": 90,
          "z": -235
        },
        {
          "hole": 359,
          "x": 132.25,
          "y": 90,
          "z": -235
        },
        {
          "hole": 360,
          "x": 124.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 361,
          "x": 115.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 362,
          "x": 107.75,
          "y": 90,
          "z": -235
        },
        {
          "hole": 363,
          "x": 100,
          "y": 90,
          "z": -235
        },
        {
          "hole": 364,
          "x": 92.25,
          "y": 90,
          "z": -235
        },
        {
          "hole": 365,
          "x": 84.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 366,
          "x": 75.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 367,
          "x": 67.75,
          "y": 90,
          "z": -235
        },
        {
          "hole": 368,
          "x": 60,
          "y": 90,
          "z": -235
        },
        {
          "hole": 369,
          "x": 52.25,
          "y": 90,
          "z": -235
        },
        {
          "hole": 370,
          "x": 44.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 371,
          "x": 35.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 372,
          "x": 27.75,
          "y": 90,
          "z": -235
        },
        {
          "hole": 373,
          "x": 20,
          "y": 90,
          "z": -235
        },
        {
          "hole": 374,
          "x": 12.25,
          "y": 90,
          "z": -235
        },
        {
          "hole": 375,
          "x": 4.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 376,
          "x": -5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 377,
          "x": -22.5,
          "y": 90,
          "z": -235
        },
        {
          "hole": 378,
          "x": -75,
          "y": 90,
          "z": -235
        },
        {
          "hole": 379,
          "x": -75,
          "y": 90,
          "z": -182.5
        },
        {
          "hole": 380,
          "x": -75,
          "y": 90,
          "z": -165
        },
        {
          "hole": 381,
          "x": -75,
          "y": 100,
          "z": -155.5
        },
        {
          "hole": 382,
          "x": -75,
          "y": 100,
          "z": -147.75
        },
        {
          "hole": 383,
          "x": -75,
          "y": 100,
          "z": -140
        },
        {
          "hole": 384,
          "x": -75,
          "y": 100,
          "z": -132.25
        },
        {
          "hole": 385,
          "x": -75,
          "y": 100,
          "z": -124.5
        },
        {
          "hole": 386,
          "x": -75,
          "y": 100,
          "z": -115.5
        },
        {
          "hole": 387,
          "x": -75,
          "y": 100,
          "z": -107.75
        },
        {
          "hole": 388,
          "x": -75,
          "y": 100,
          "z": -100
        },
        {
          "hole": 389,
          "x": -75,
          "y": 100,
          "z": -92.25
        },
        {
          "hole": 390,
          "x": -75,
          "y": 100,
          "z": -84.5
        },
        {
          "hole": 391,
          "x": -75,
          "y": 100,
          "z": -75.5
        },
        {
          "hole": 392,
          "x": -75,
          "y": 100,
          "z": -67.75
        },
        {
          "hole": 393,
          "x": -75,
          "y": 100,
          "z": -60
        },
        {
          "hole": 394,
          "x": -75,
          "y": 100,
          "z": -52.25
        },
        {
          "hole": 395,
          "x": -75,
          "y": 100,
          "z": -44.5
        },
        {
          "hole": 396,
          "x": -75,
          "y": 100,
          "z": -35.5
        },
        {
          "hole": 397,
          "x": -75,
          "y": 100,
          "z": -27.75
        },
        {
          "hole": 398,
          "x": -75,
          "y": 100,
          "z": -20
        },
        {
          "hole": 399,
          "x": -75,
          "y": 100,
          "z": -12.25
        },
        {
          "hole": 400,
          "x": -75,
          "y": 100,
          "z": -4.5
        },
        {
          "hole": 401,
          "x": -75,
          "y": 100,
          "z": 4.5
        },
        {
          "hole": 402,
          "x": -75,
          "y": 100,
          "z": 12.25
        },
        {
          "hole": 403,
          "x": -75,
          "y": 100,
          "z": 20
        },
        {
          "hole": 404,
          "x": -75,
          "y": 100,
          "z": 27.75
        },
        {
          "hole": 405,
          "x": -75,
          "y": 100,
          "z": 35.5
        },
        {
          "hole": 406,
          "x": -75,
          "y": 100,
          "z": 45
        },
        {
          "hole": 407,
          "x": -75,
          "y": 100,
          "z": 52.5
        },
        {
          "hole": 408,
          "x": -75,
          "y": 100,
          "z": 95
        },
        {
          "hole": 409,
          "x": -32.5,
          "y": 100,
          "z": 95
        },
        {
          "hole": 410,
          "x": -25,
          "y": 100,
          "z": 95
        },
        {
          "hole": 411,
          "x": -15.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 412,
          "x": -7.75,
          "y": 110,
          "z": 95
        },
        {
          "hole": 413,
          "x": 0,
          "y": 110,
          "z": 95
        },
        {
          "hole": 414,
          "x": 7.75,
          "y": 110,
          "z": 95
        },
        {
          "hole": 415,
          "x": 15.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 416,
          "x": 24.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 417,
          "x": 32.25,
          "y": 110,
          "z": 95
        },
        {
          "hole": 418,
          "x": 40,
          "y": 110,
          "z": 95
        },
        {
          "hole": 419,
          "x": 47.75,
          "y": 110,
          "z": 95
        },
        {
          "hole": 420,
          "x": 55.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 421,
          "x": 64.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 422,
          "x": 72.25,
          "y": 110,
          "z": 95
        },
        {
          "hole": 423,
          "x": 80,
          "y": 110,
          "z": 95
        },
        {
          "hole": 424,
          "x": 87.75,
          "y": 110,
          "z": 95
        },
        {
          "hole": 425,
          "x": 95.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 426,
          "x": 104.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 427,
          "x": 112.25,
          "y": 110,
          "z": 95
        },
        {
          "hole": 428,
          "x": 120,
          "y": 110,
          "z": 95
        },
        {
          "hole": 429,
          "x": 127.75,
          "y": 110,
          "z": 95
        },
        {
          "hole": 430,
          "x": 135.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 431,
          "x": 145,
          "y": 110,
          "z": 95
        },
        {
          "hole": 432,
          "x": 152.5,
          "y": 110,
          "z": 95
        },
        {
          "hole": 433,
          "x": 195,
          "y": 110,
          "z": 95
        },
        {
          "hole": 434,
          "x": 195,
          "y": 110,
          "z": 52.5
        },
        {
          "hole": 435,
          "x": 195,
          "y": 110,
          "z": 45
        },
        {
          "hole": 436,
          "x": 195,
          "y": 120,
          "z": 35.5
        },
        {
          "hole": 437,
          "x": 195,
          "y": 120,
          "z": 27.75
        },
        {
          "hole": 438,
          "x": 195,
          "y": 120,
          "z": 20
        },
        {
          "hole": 439,
          "x": 195,
          "y": 120,
          "z": 12.25
        },
        {
          "hole": 440,
          "x": 195,
          "y": 120,
          "z": 4.5
        },
        {
          "hole": 441,
          "x": 195,
          "y": 120,
          "z": -4.5
        },
        {
          "hole": 442,
          "x": 195,
          "y": 120,
          "z": -12.25
        },
        {
          "hole": 443,
          "x": 195,
          "y": 120,
          "z": -20
        },
        {
          "hole": 444,
          "x": 195,
          "y": 120,
          "z": -27.75
        },
        {
          "hole": 445,
          "x": 195,
          "y": 120,
          "z": -35.5
        },
        {
          "hole": 446,
          "x": 195,
          "y": 120,
          "z": -44.5
        },
        {
          "hole": 447,
          "x": 195,
          "y": 120,
          "z": -52.25
        },
        {
          "hole": 448,
          "x": 195,
          "y": 120,
          "z": -60
        },
        {
          "hole": 449,
          "x": 195,
          "y": 120,
          "z": -67.75
        },
        {
          "hole": 450,
          "x": 195,
          "y": 120,
          "z": -75.5
        },
        {
          "hole": 451,
          "x": 195,
          "y": 120,
          "z": -85
        },
        {
          "hole": 452,
          "x": 195,
          "y": 120,
          "z": -102.5
        },
        {
          "hole": 453,
          "x": 195,
          "y": 120,
          "z": -155
        },
        {
          "hole": 454,
          "x": 142.5,
          "y": 120,
          "z": -155
        },
        {
          "hole": 455,
          "x": 125,
          "y": 120,
          "z": -155
        },
        {
          "hole": 456,
          "x": 115.5,
          "y": 130,
          "z": -155
        },
        {
          "hole": 457,
          "x": 107.75,
          "y": 130,
          "z": -155
        },
        {
          "hole": 458,
          "x": 100,
          "y": 130,
          "z": -155
        },
        {
          "hole": 459,
          "x": 92.25,
          "y": 130,
          "z": -155
        },
        {
          "hole": 460,
          "x": 84.5,
          "y": 130,
          "z": -155
        },
        {
          "hole": 461,
          "x": 75,
          "y": 130,
          "z": -155
        },
        {
          "hole": 462,
          "x": 57.5,
          "y": 130,
          "z": -155
        },
        {
          "hole": 463,
          "x": 5,
          "y": 130,
          "z": -155
        },
        {
          "hole": 464,
          "x": 5,
          "y": 130,
          "z": -102.5
        },
        {
          "hole": 465,
          "x": 5,
          "y": 130,
          "z": -85
        },
        {
          "hole": 466,
          "x": 5,
          "y": 140,
          "z": -75.5
        },
        {
          "hole": 467,
          "x": 5,
          "y": 140,
          "z": -67.75
        },
        {
          "hole": 468,
          "x": 5,
          "y": 140,
          "z": -60
        },
        {
          "hole": 469,
          "x": 5,
          "y": 140,
          "z": -52.25
        },
        {
          "hole": 470,
          "x": 5,
          "y": 140,
          "z": -44.5
        },
        {
          "hole": 471,
          "x": 5,
          "y": 140,
          "z": -35
        },
        {
          "hole": 472,
          "x": 5,
          "y": 140,
          "z": -27.5
        },
        {
          "hole": 473,
          "x": 5,
          "y": 140,
          "z": 15
        },
        {
          "hole": 474,
          "x": 47.5,
          "y": 140,
          "z": 15
        },
        {
          "hole": 475,
          "x": 55,
          "y": 140,
          "z": 15
        },
        {
          "hole": 476,
          "x": 65,
          "y": 150,
          "z": 15
        },
        {
          "hole": 477,
          "x": 72.5,
          "y": 150,
          "z": 15
        },
        {
          "hole": 478,
          "x": 115,
          "y": 150,
          "z": 15
        },
        {
          "hole": 479,
          "x": 115,
          "y": 150,
          "z": -27.5
        },
        {
          "hole": 480,
          "x": 115,
          "y": 150,
          "z": -35
        },
        {
          "hole": 121,
          "x": 100,
          "y": 160,
          "z": -60
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": -215,
          "y": 10,
          "z": -93
        },
        {
          "hole": 1,
          "x": -225,
          "y": 20,
          "z": -75.5
        },
        {
          "hole": 2,
          "x": -225,
          "y": 20,
          "z": -67.75
        },
        {
          "hole": 3,
          "x": -225,
          "y": 20,
          "z": -60
        },
        {
          "hole": 4,
          "x": -225,
          "y": 20,
          "z": -52.25
        },
        {
          "hole": 5,
          "x": -225,
          "y": 20,
          "z": -44.5
        },
        {
          "hole": 6,
          "x": -225,
          "y": 20,
          "z": -35.5
        },
        {
          "hole": 7,
          "x": -225,
          "y": 20,
          "z": -27.75
        },
        {
          "hole": 8,
          "x": -225,
          "y": 20,
          "z": -20
        },
        {
          "hole": 9,
          "x": -225,
          "y": 20,
          "z": -12.25
        },
        {
          "hole": 10,
          "x": -225,
          "y": 20,
          "z": -4.5
        },
        {
          "hole": 11,
          "x": -225,
          "y": 20,
          "z": 4.5
        },
        {
          "hole": 12,
          "x": -225,
          "y": 20,
          "z": 12.25
        },
        {
          "hole": 13,
          "x": -225,
          "y": 20,
          "z": 20
        },
        {
          "hole": 14,
          "x": -225,
          "y": 20,
          "z": 27.75
        },
        {
          "hole": 15,
          "x": -225,
          "y": 20,
          "z": 35.5
        },
        {
          "hole": 16,
          "x": -225,
          "y": 20,
          "z": 44.5
        },
        {
          "hole": 17,
          "x": -225,
          "y": 20,
          "z": 52.25
        },
        {
          "hole": 18,
          "x": -225,
          "y": 20,
          "z": 60
        },
        {
          "hole": 19,
          "x": -225,
          "y": 20,
          "z": 67.75
        },
        {
          "hole": 20,
          "x": -225,
          "y": 20,
          "z": 75.5
        },
        {
          "hole": 21,
          "x": -225,
          "y": 20,
          "z": 84.5
        },
        {
          "hole": 22,
          "x": -225,
          "y": 20,
          "z": 92.25
        },
        {
          "hole": 23,
          "x": -225,
          "y": 20,
          "z": 100
        },
        {
          "hole": 24,
          "x": -225,
          "y": 20,
          "z": 107.75
        },
        {
          "hole": 25,
          "x": -225,
          "y": 20,
          "z": 115.5
        },
        {
          "hole": 26,
          "x": -225,
          "y": 20,
          "z": 124.5
        },
        {
          "hole": 27,
          "x": -225,
          "y": 20,
          "z": 132.25
        },
        {
          "hole": 28,
          "x": -225,
          "y": 20,
          "z": 140
        },
        {
          "hole": 29,
          "x": -225,
          "y": 20,
          "z": 147.75
        },
        {
          "hole": 30,
          "x": -225,
          "y": 20,
          "z": 155.5
        },
        {
          "hole": 31,
          "x": -225,
          "y": 20,
          "z": 164.5
        },
        {
          "hole": 32,
          "x": -225,
          "y": 20,
          "z": 172.25
        },
        {
          "hole": 33,
          "x": -225,
          "y": 20,
          "z": 180
        },
        {
          "hole": 34,
          "x": -225,
          "y": 20,
          "z": 187.75
        },
        {
          "hole": 35,
          "x": -225,
          "y": 20,
          "z": 195.5
        },
        {
          "hole": 36,
          "x": -225,
          "y": 20,
          "z": 204.9999
        },
        {
          "hole": 37,
          "x": -225,
          "y": 20,
          "z": 212.4999
        },
        {
          "hole": 38,
          "x": -225,
          "y": 20,
          "z": 244.9999
        },
        {
          "hole": 39,
          "x": -192.5,
          "y": 20,
          "z": 244.9999
        },
        {
          "hole": 40,
          "x": -185,
          "y": 20,
          "z": 244.9999
        },
        {
          "hole": 41,
          "x": -175.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 42,
          "x": -167.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 43,
          "x": -160,
          "y": 30,
          "z": 245
        },
        {
          "hole": 44,
          "x": -152.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 45,
          "x": -144.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 46,
          "x": -135.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 47,
          "x": -127.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 48,
          "x": -120,
          "y": 30,
          "z": 245
        },
        {
          "hole": 49,
          "x": -112.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 50,
          "x": -104.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 51,
          "x": -95.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 52,
          "x": -87.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 53,
          "x": -80,
          "y": 30,
          "z": 245
        },
        {
          "hole": 54,
          "x": -72.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 55,
          "x": -64.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 56,
          "x": -55.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 57,
          "x": -47.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 58,
          "x": -40,
          "y": 30,
          "z": 245
        },
        {
          "hole": 59,
          "x": -32.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 60,
          "x": -24.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 61,
          "x": -15.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 62,
          "x": -7.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 63,
          "x": 0,
          "y": 30,
          "z": 245
        },
        {
          "hole": 64,
          "x": 7.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 65,
          "x": 15.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 66,
          "x": 24.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 67,
          "x": 32.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 68,
          "x": 40,
          "y": 30,
          "z": 245
        },
        {
          "hole": 69,
          "x": 47.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 70,
          "x": 55.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 71,
          "x": 64.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 72,
          "x": 72.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 73,
          "x": 80,
          "y": 30,
          "z": 245
        },
        {
          "hole": 74,
          "x": 87.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 75,
          "x": 95.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 76,
          "x": 104.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 77,
          "x": 112.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 78,
          "x": 120,
          "y": 30,
          "z": 245
        },
        {
          "hole": 79,
          "x": 127.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 80,
          "x": 135.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 81,
          "x": 144.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 82,
          "x": 152.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 83,
          "x": 160,
          "y": 30,
          "z": 245
        },
        {
          "hole": 84,
          "x": 167.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 85,
          "x": 175.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 86,
          "x": 184.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 87,
          "x": 192.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 88,
          "x": 200,
          "y": 30,
          "z": 245
        },
        {
          "hole": 89,
          "x": 207.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 90,
          "x": 215.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 91,
          "x": 224.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 92,
          "x": 232.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 93,
          "x": 240,
          "y": 30,
          "z": 245
        },
        {
          "hole": 94,
          "x": 247.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 95,
          "x": 255.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 96,
          "x": 264.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 97,
          "x": 272.25,
          "y": 30,
          "z": 245
        },
        {
          "hole": 98,
          "x": 280,
          "y": 30,
          "z": 245
        },
        {
          "hole": 99,
          "x": 287.75,
          "y": 30,
          "z": 245
        },
        {
          "hole": 100,
          "x": 295.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 101,
          "x": 305,
          "y": 30,
          "z": 245
        },
        {
          "hole": 102,
          "x": 312.5,
          "y": 30,
          "z": 245
        },
        {
          "hole": 103,
          "x": 345,
          "y": 30,
          "z": 245
        },
        {
          "hole": 104,
          "x": 345,
          "y": 30,
          "z": 212.5
        },
        {
          "hole": 105,
          "x": 345,
          "y": 30,
          "z": 205
        },
        {
          "hole": 106,
          "x": 345,
          "y": 40,
          "z": 195.5
        },
        {
          "hole": 107,
          "x": 345,
          "y": 40,
          "z": 187.75
        },
        {
          "hole": 108,
          "x": 345,
          "y": 40,
          "z": 180
        },
        {
          "hole": 109,
          "x": 345,
          "y": 40,
          "z": 172.25
        },
        {
          "hole": 110,
          "x": 345,
          "y": 40,
          "z": 164.5
        },
        {
          "hole": 111,
          "x": 345,
          "y": 40,
          "z": 155.5
        },
        {
          "hole": 112,
          "x": 345,
          "y": 40,
          "z": 147.75
        },
        {
          "hole": 113,
          "x": 345,
          "y": 40,
          "z": 140
        },
        {
          "hole": 114,
          "x": 345,
          "y": 40,
          "z": 132.25
        },
        {
          "hole": 115,
          "x": 345,
          "y": 40,
          "z": 124.5
        },
        {
          "hole": 116,
          "x": 345,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 117,
          "x": 345,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 118,
          "x": 345,
          "y": 40,
          "z": 100
        },
        {
          "hole": 119,
          "x": 345,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 120,
          "x": 345,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 121,
          "x": 345,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 122,
          "x": 345,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 123,
          "x": 345,
          "y": 40,
          "z": 60
        },
        {
          "hole": 124,
          "x": 345,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 125,
          "x": 345,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 126,
          "x": 345,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 127,
          "x": 345,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 128,
          "x": 345,
          "y": 40,
          "z": 20
        },
        {
          "hole": 129,
          "x": 345,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 130,
          "x": 345,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 131,
          "x": 345,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 132,
          "x": 345,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 133,
          "x": 345,
          "y": 40,
          "z": -20
        },
        {
          "hole": 134,
          "x": 345,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 135,
          "x": 345,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 136,
          "x": 345,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 137,
          "x": 345,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 138,
          "x": 345,
          "y": 40,
          "z": -60
        },
        {
          "hole": 139,
          "x": 345,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 140,
          "x": 345,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 141,
          "x": 345,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 142,
          "x": 345,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 143,
          "x": 345,
          "y": 40,
          "z": -100
        },
        {
          "hole": 144,
          "x": 345,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 145,
          "x": 345,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 146,
          "x": 345,
          "y": 40,
          "z": -124.5
        },
        {
          "hole": 147,
          "x": 345,
          "y": 40,
          "z": -132.25
        },
        {
          "hole": 148,
          "x": 345,
          "y": 40,
          "z": -140
        },
        {
          "hole": 149,
          "x": 345,
          "y": 40,
          "z": -147.75
        },
        {
          "hole": 150,
          "x": 345,
          "y": 40,
          "z": -155.5
        },
        {
          "hole": 151,
          "x": 345,
          "y": 40,
          "z": -164.5
        },
        {
          "hole": 152,
          "x": 345,
          "y": 40,
          "z": -172.25
        },
        {
          "hole": 153,
          "x": 345,
          "y": 40,
          "z": -180
        },
        {
          "hole": 154,
          "x": 345,
          "y": 40,
          "z": -187.75
        },
        {
          "hole": 155,
          "x": 345,
          "y": 40,
          "z": -195.5
        },
        {
          "hole": 156,
          "x": 345,
          "y": 40,
          "z": -204.5
        },
        {
          "hole": 157,
          "x": 345,
          "y": 40,
          "z": -212.25
        },
        {
          "hole": 158,
          "x": 345,
          "y": 40,
          "z": -220
        },
        {
          "hole": 159,
          "x": 345,
          "y": 40,
          "z": -227.75
        },
        {
          "hole": 160,
          "x": 345,
          "y": 40,
          "z": -235.5
        },
        {
          "hole": 161,
          "x": 345,
          "y": 40,
          "z": -245
        },
        {
          "hole": 162,
          "x": 345,
          "y": 40,
          "z": -262.5
        },
        {
          "hole": 163,
          "x": 345,
          "y": 40,
          "z": -305
        },
        {
          "hole": 164,
          "x": 302.5,
          "y": 40,
          "z": -305
        },
        {
          "hole": 165,
          "x": 285,
          "y": 40,
          "z": -305
        },
        {
          "hole": 166,
          "x": 275.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 167,
          "x": 267.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 168,
          "x": 260,
          "y": 50,
          "z": -305
        },
        {
          "hole": 169,
          "x": 252.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 170,
          "x": 244.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 171,
          "x": 235.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 172,
          "x": 227.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 173,
          "x": 220,
          "y": 50,
          "z": -305
        },
        {
          "hole": 174,
          "x": 212.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 175,
          "x": 204.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 176,
          "x": 195.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 177,
          "x": 187.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 178,
          "x": 180,
          "y": 50,
          "z": -305
        },
        {
          "hole": 179,
          "x": 172.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 180,
          "x": 164.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 181,
          "x": 155.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 182,
          "x": 147.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 183,
          "x": 140,
          "y": 50,
          "z": -305
        },
        {
          "hole": 184,
          "x": 132.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 185,
          "x": 124.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 186,
          "x": 115.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 187,
          "x": 107.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 188,
          "x": 100,
          "y": 50,
          "z": -305
        },
        {
          "hole": 189,
          "x": 92.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 190,
          "x": 84.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 191,
          "x": 75.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 192,
          "x": 67.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 193,
          "x": 60,
          "y": 50,
          "z": -305
        },
        {
          "hole": 194,
          "x": 52.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 195,
          "x": 44.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 196,
          "x": 35.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 197,
          "x": 27.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 198,
          "x": 20,
          "y": 50,
          "z": -305
        },
        {
          "hole": 199,
          "x": 12.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 200,
          "x": 4.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 201,
          "x": -4.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 202,
          "x": -12.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 203,
          "x": -20,
          "y": 50,
          "z": -305
        },
        {
          "hole": 204,
          "x": -27.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 205,
          "x": -35.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 206,
          "x": -44.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 207,
          "x": -52.25,
          "y": 50,
          "z": -305
        },
        {
          "hole": 208,
          "x": -60,
          "y": 50,
          "z": -305
        },
        {
          "hole": 209,
          "x": -67.75,
          "y": 50,
          "z": -305
        },
        {
          "hole": 210,
          "x": -75.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 211,
          "x": -85,
          "y": 50,
          "z": -305
        },
        {
          "hole": 212,
          "x": -102.5,
          "y": 50,
          "z": -305
        },
        {
          "hole": 213,
          "x": -145,
          "y": 50,
          "z": -305
        },
        {
          "hole": 214,
          "x": -145,
          "y": 50,
          "z": -262.5
        },
        {
          "hole": 215,
          "x": -145,
          "y": 50,
          "z": -245
        },
        {
          "hole": 216,
          "x": -145,
          "y": 60,
          "z": -235.5
        },
        {
          "hole": 217,
          "x": -145,
          "y": 60,
          "z": -227.75
        },
        {
          "hole": 218,
          "x": -145,
          "y": 60,
          "z": -220
        },
        {
          "hole": 219,
          "x": -145,
          "y": 60,
          "z": -212.25
        },
        {
          "hole": 220,
          "x": -145,
          "y": 60,
          "z": -204.5
        },
        {
          "hole": 221,
          "x": -145,
          "y": 60,
          "z": -195.5
        },
        {
          "hole": 222,
          "x": -145,
          "y": 60,
          "z": -187.75
        },
        {
          "hole": 223,
          "x": -145,
          "y": 60,
          "z": -180
        },
        {
          "hole": 224,
          "x": -145,
          "y": 60,
          "z": -172.25
        },
        {
          "hole": 225,
          "x": -145,
          "y": 60,
          "z": -164.5
        },
        {
          "hole": 226,
          "x": -145,
          "y": 60,
          "z": -155.5
        },
        {
          "hole": 227,
          "x": -145,
          "y": 60,
          "z": -147.75
        },
        {
          "hole": 228,
          "x": -145,
          "y": 60,
          "z": -140
        },
        {
          "hole": 229,
          "x": -145,
          "y": 60,
          "z": -132.25
        },
        {
          "hole": 230,
          "x": -145,
          "y": 60,
          "z": -124.5
        },
        {
          "hole": 231,
          "x": -145,
          "y": 60,
          "z": -115.5
        },
        {
          "hole": 232,
          "x": -145,
          "y": 60,
          "z": -107.75
        },
        {
          "hole": 233,
          "x": -145,
          "y": 60,
          "z": -100
        },
        {
          "hole": 234,
          "x": -145,
          "y": 60,
          "z": -92.25
        },
        {
          "hole": 235,
          "x": -145,
          "y": 60,
          "z": -84.5
        },
        {
          "hole": 236,
          "x": -145,
          "y": 60,
          "z": -75.5
        },
        {
          "hole": 237,
          "x": -145,
          "y": 60,
          "z": -67.75
        },
        {
          "hole": 238,
          "x": -145,
          "y": 60,
          "z": -60
        },
        {
          "hole": 239,
          "x": -145,
          "y": 60,
          "z": -52.25
        },
        {
          "hole": 240,
          "x": -145,
          "y": 60,
          "z": -44.5
        },
        {
          "hole": 241,
          "x": -145,
          "y": 60,
          "z": -35.5
        },
        {
          "hole": 242,
          "x": -145,
          "y": 60,
          "z": -27.75
        },
        {
          "hole": 243,
          "x": -145,
          "y": 60,
          "z": -20
        },
        {
          "hole": 244,
          "x": -145,
          "y": 60,
          "z": -12.25
        },
        {
          "hole": 245,
          "x": -145,
          "y": 60,
          "z": -4.5
        },
        {
          "hole": 246,
          "x": -145,
          "y": 60,
          "z": 4.5
        },
        {
          "hole": 247,
          "x": -145,
          "y": 60,
          "z": 12.25
        },
        {
          "hole": 248,
          "x": -145,
          "y": 60,
          "z": 20
        },
        {
          "hole": 249,
          "x": -145,
          "y": 60,
          "z": 27.75
        },
        {
          "hole": 250,
          "x": -145,
          "y": 60,
          "z": 35.5
        },
        {
          "hole": 251,
          "x": -145,
          "y": 60,
          "z": 44.5
        },
        {
          "hole": 252,
          "x": -145,
          "y": 60,
          "z": 52.25
        },
        {
          "hole": 253,
          "x": -145,
          "y": 60,
          "z": 60
        },
        {
          "hole": 254,
          "x": -145,
          "y": 60,
          "z": 67.75
        },
        {
          "hole": 255,
          "x": -145,
          "y": 60,
          "z": 75.5
        },
        {
          "hole": 256,
          "x": -145,
          "y": 60,
          "z": 84.5
        },
        {
          "hole": 257,
          "x": -145,
          "y": 60,
          "z": 92.25
        },
        {
          "hole": 258,
          "x": -145,
          "y": 60,
          "z": 100
        },
        {
          "hole": 259,
          "x": -145,
          "y": 60,
          "z": 107.75
        },
        {
          "hole": 260,
          "x": -145,
          "y": 60,
          "z": 115.5
        },
        {
          "hole": 261,
          "x": -145,
          "y": 60,
          "z": 125
        },
        {
          "hole": 262,
          "x": -145,
          "y": 60,
          "z": 132.5
        },
        {
          "hole": 263,
          "x": -145,
          "y": 60,
          "z": 165
        },
        {
          "hole": 264,
          "x": -112.5,
          "y": 60,
          "z": 165
        },
        {
          "hole": 265,
          "x": -105,
          "y": 60,
          "z": 165
        },
        {
          "hole": 266,
          "x": -95.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 267,
          "x": -87.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 268,
          "x": -80,
          "y": 70,
          "z": 165
        },
        {
          "hole": 269,
          "x": -72.25,
          "y": 70,
          "z": 165
        },
        {
          "hole": 270,
          "x": -64.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 271,
          "x": -55.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 272,
          "x": -47.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 273,
          "x": -40,
          "y": 70,
          "z": 165
        },
        {
          "hole": 274,
          "x": -32.25,
          "y": 70,
          "z": 165
        },
        {
          "hole": 275,
          "x": -24.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 276,
          "x": -15.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 277,
          "x": -7.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 278,
          "x": 0,
          "y": 70,
          "z": 165
        },
        {
          "hole": 279,
          "x": 7.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 280,
          "x": 15.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 281,
          "x": 24.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 282,
          "x": 32.25,
          "y": 70,
          "z": 165
        },
        {
          "hole": 283,
          "x": 40,
          "y": 70,
          "z": 165
        },
        {
          "hole": 284,
          "x": 47.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 285,
          "x": 55.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 286,
          "x": 64.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 287,
          "x": 72.25,
          "y": 70,
          "z": 165
        },
        {
          "hole": 288,
          "x": 80,
          "y": 70,
          "z": 165
        },
        {
          "hole": 289,
          "x": 87.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 290,
          "x": 95.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 291,
          "x": 104.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 292,
          "x": 112.25,
          "y": 70,
          "z": 165
        },
        {
          "hole": 293,
          "x": 120,
          "y": 70,
          "z": 165
        },
        {
          "hole": 294,
          "x": 127.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 295,
          "x": 135.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 296,
          "x": 144.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 297,
          "x": 152.25,
          "y": 70,
          "z": 165
        },
        {
          "hole": 298,
          "x": 160,
          "y": 70,
          "z": 165
        },
        {
          "hole": 299,
          "x": 167.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 300,
          "x": 175.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 301,
          "x": 184.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 302,
          "x": 192.25,
          "y": 70,
          "z": 165
        },
        {
          "hole": 303,
          "x": 200,
          "y": 70,
          "z": 165
        },
        {
          "hole": 304,
          "x": 207.75,
          "y": 70,
          "z": 165
        },
        {
          "hole": 305,
          "x": 215.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 306,
          "x": 225,
          "y": 70,
          "z": 165
        },
        {
          "hole": 307,
          "x": 232.5,
          "y": 70,
          "z": 165
        },
        {
          "hole": 308,
          "x": 265,
          "y": 70,
          "z": 165
        },
        {
          "hole": 309,
          "x": 265,
          "y": 70,
          "z": 132.5
        },
        {
          "hole": 310,
          "x": 265,
          "y": 70,
          "z": 125
        },
        {
          "hole": 311,
          "x": 265,
          "y": 80,
          "z": 115.5
        },
        {
          "hole": 312,
          "x": 265,
          "y": 80,
          "z": 107.75
        },
        {
          "hole": 313,
          "x": 265,
          "y": 80,
          "z": 100
        },
        {
          "hole": 314,
          "x": 265,
          "y": 80,
          "z": 92.25
        },
        {
          "hole": 315,
          "x": 265,
          "y": 80,
          "z": 84.5
        },
        {
          "hole": 316,
          "x": 265,
          "y": 80,
          "z": 75.5
        },
        {
          "hole": 317,
          "x": 265,
          "y": 80,
          "z": 67.75
        },
        {
          "hole": 318,
          "x": 265,
          "y": 80,
          "z": 60
        },
        {
          "hole": 319,
          "x": 265,
          "y": 80,
          "z": 52.25
        },
        {
          "hole": 320,
          "x": 265,
          "y": 80,
          "z": 44.5
        },
        {
          "hole": 321,
          "x": 265,
          "y": 80,
          "z": 35.5
        },
        {
          "hole": 322,
          "x": 265,
          "y": 80,
          "z": 27.75
        },
        {
          "hole": 323,
          "x": 265,
          "y": 80,
          "z": 20
        },
        {
          "hole": 324,
          "x": 265,
          "y": 80,
          "z": 12.25
        },
        {
          "hole": 325,
          "x": 265,
          "y": 80,
          "z": 4.5
        },
        {
          "hole": 326,
          "x": 265,
          "y": 80,
          "z": -4.5
        },
        {
          "hole": 327,
          "x": 265,
          "y": 80,
          "z": -12.25
        },
        {
          "hole": 328,
          "x": 265,
          "y": 80,
          "z": -20
        },
        {
          "hole": 329,
          "x": 265,
          "y": 80,
          "z": -27.75
        },
        {
          "hole": 330,
          "x": 265,
          "y": 80,
          "z": -35.5
        },
        {
          "hole": 331,
          "x": 265,
          "y": 80,
          "z": -44.5
        },
        {
          "hole": 332,
          "x": 265,
          "y": 80,
          "z": -52.25
        },
        {
          "hole": 333,
          "x": 265,
          "y": 80,
          "z": -60
        },
        {
          "hole": 334,
          "x": 265,
          "y": 80,
          "z": -67.75
        },
        {
          "hole": 335,
          "x": 265,
          "y": 80,
          "z": -75.5
        },
        {
          "hole": 336,
          "x": 265,
          "y": 80,
          "z": -84.5
        },
        {
          "hole": 337,
          "x": 265,
          "y": 80,
          "z": -92.25
        },
        {
          "hole": 338,
          "x": 265,
          "y": 80,
          "z": -100
        },
        {
          "hole": 339,
          "x": 265,
          "y": 80,
          "z": -107.75
        },
        {
          "hole": 340,
          "x": 265,
          "y": 80,
          "z": -115.5
        },
        {
          "hole": 341,
          "x": 265,
          "y": 80,
          "z": -124.5
        },
        {
          "hole": 342,
          "x": 265,
          "y": 80,
          "z": -132.25
        },
        {
          "hole": 343,
          "x": 265,
          "y": 80,
          "z": -140
        },
        {
          "hole": 344,
          "x": 265,
          "y": 80,
          "z": -147.75
        },
        {
          "hole": 345,
          "x": 265,
          "y": 80,
          "z": -155.5
        },
        {
          "hole": 346,
          "x": 265,
          "y": 80,
          "z": -165
        },
        {
          "hole": 347,
          "x": 265,
          "y": 80,
          "z": -182.5
        },
        {
          "hole": 348,
          "x": 265,
          "y": 80,
          "z": -225
        },
        {
          "hole": 349,
          "x": 222.5,
          "y": 80,
          "z": -225
        },
        {
          "hole": 350,
          "x": 205,
          "y": 80,
          "z": -225
        },
        {
          "hole": 351,
          "x": 195.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 352,
          "x": 187.75,
          "y": 90,
          "z": -225
        },
        {
          "hole": 353,
          "x": 180,
          "y": 90,
          "z": -225
        },
        {
          "hole": 354,
          "x": 172.25,
          "y": 90,
          "z": -225
        },
        {
          "hole": 355,
          "x": 164.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 356,
          "x": 155.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 357,
          "x": 147.75,
          "y": 90,
          "z": -225
        },
        {
          "hole": 358,
          "x": 140,
          "y": 90,
          "z": -225
        },
        {
          "hole": 359,
          "x": 132.25,
          "y": 90,
          "z": -225
        },
        {
          "hole": 360,
          "x": 124.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 361,
          "x": 115.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 362,
          "x": 107.75,
          "y": 90,
          "z": -225
        },
        {
          "hole": 363,
          "x": 100,
          "y": 90,
          "z": -225
        },
        {
          "hole": 364,
          "x": 92.25,
          "y": 90,
          "z": -225
        },
        {
          "hole": 365,
          "x": 84.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 366,
          "x": 75.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 367,
          "x": 67.75,
          "y": 90,
          "z": -225
        },
        {
          "hole": 368,
          "x": 60,
          "y": 90,
          "z": -225
        },
        {
          "hole": 369,
          "x": 52.25,
          "y": 90,
          "z": -225
        },
        {
          "hole": 370,
          "x": 44.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 371,
          "x": 35.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 372,
          "x": 27.75,
          "y": 90,
          "z": -225
        },
        {
          "hole": 373,
          "x": 20,
          "y": 90,
          "z": -225
        },
        {
          "hole": 374,
          "x": 12.25,
          "y": 90,
          "z": -225
        },
        {
          "hole": 375,
          "x": 4.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 376,
          "x": -5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 377,
          "x": -22.5,
          "y": 90,
          "z": -225
        },
        {
          "hole": 378,
          "x": -65,
          "y": 90,
          "z": -225
        },
        {
          "hole": 379,
          "x": -65,
          "y": 90,
          "z": -182.5
        },
        {
          "hole": 380,
          "x": -65,
          "y": 90,
          "z": -165
        },
        {
          "hole": 381,
          "x": -65,
          "y": 100,
          "z": -155.5
        },
        {
          "hole": 382,
          "x": -65,
          "y": 100,
          "z": -147.75
        },
        {
          "hole": 383,
          "x": -65,
          "y": 100,
          "z": -140
        },
        {
          "hole": 384,
          "x": -65,
          "y": 100,
          "z": -132.25
        },
        {
          "hole": 385,
          "x": -65,
          "y": 100,
          "z": -124.5
        },
        {
          "hole": 386,
          "x": -65,
          "y": 100,
          "z": -115.5
        },
        {
          "hole": 387,
          "x": -65,
          "y": 100,
          "z": -107.75
        },
        {
          "hole": 388,
          "x": -65,
          "y": 100,
          "z": -100
        },
        {
          "hole": 389,
          "x": -65,
          "y": 100,
          "z": -92.25
        },
        {
          "hole": 390,
          "x": -65,
          "y": 100,
          "z": -84.5
        },
        {
          "hole": 391,
          "x": -65,
          "y": 100,
          "z": -75.5
        },
        {
          "hole": 392,
          "x": -65,
          "y": 100,
          "z": -67.75
        },
        {
          "hole": 393,
          "x": -65,
          "y": 100,
          "z": -60
        },
        {
          "hole": 394,
          "x": -65,
          "y": 100,
          "z": -52.25
        },
        {
          "hole": 395,
          "x": -65,
          "y": 100,
          "z": -44.5
        },
        {
          "hole": 396,
          "x": -65,
          "y": 100,
          "z": -35.5
        },
        {
          "hole": 397,
          "x": -65,
          "y": 100,
          "z": -27.75
        },
        {
          "hole": 398,
          "x": -65,
          "y": 100,
          "z": -20
        },
        {
          "hole": 399,
          "x": -65,
          "y": 100,
          "z": -12.25
        },
        {
          "hole": 400,
          "x": -65,
          "y": 100,
          "z": -4.5
        },
        {
          "hole": 401,
          "x": -65,
          "y": 100,
          "z": 4.5
        },
        {
          "hole": 402,
          "x": -65,
          "y": 100,
          "z": 12.25
        },
        {
          "hole": 403,
          "x": -65,
          "y": 100,
          "z": 20
        },
        {
          "hole": 404,
          "x": -65,
          "y": 100,
          "z": 27.75
        },
        {
          "hole": 405,
          "x": -65,
          "y": 100,
          "z": 35.5
        },
        {
          "hole": 406,
          "x": -65,
          "y": 100,
          "z": 45
        },
        {
          "hole": 407,
          "x": -65,
          "y": 100,
          "z": 52.5
        },
        {
          "hole": 408,
          "x": -65,
          "y": 100,
          "z": 85
        },
        {
          "hole": 409,
          "x": -32.5,
          "y": 100,
          "z": 85
        },
        {
          "hole": 410,
          "x": -25,
          "y": 100,
          "z": 85
        },
        {
          "hole": 411,
          "x": -15.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 412,
          "x": -7.75,
          "y": 110,
          "z": 85
        },
        {
          "hole": 413,
          "x": 0,
          "y": 110,
          "z": 85
        },
        {
          "hole": 414,
          "x": 7.75,
          "y": 110,
          "z": 85
        },
        {
          "hole": 415,
          "x": 15.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 416,
          "x": 24.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 417,
          "x": 32.25,
          "y": 110,
          "z": 85
        },
        {
          "hole": 418,
          "x": 40,
          "y": 110,
          "z": 85
        },
        {
          "hole": 419,
          "x": 47.75,
          "y": 110,
          "z": 85
        },
        {
          "hole": 420,
          "x": 55.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 421,
          "x": 64.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 422,
          "x": 72.25,
          "y": 110,
          "z": 85
        },
        {
          "hole": 423,
          "x": 80,
          "y": 110,
          "z": 85
        },
        {
          "hole": 424,
          "x": 87.75,
          "y": 110,
          "z": 85
        },
        {
          "hole": 425,
          "x": 95.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 426,
          "x": 104.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 427,
          "x": 112.25,
          "y": 110,
          "z": 85
        },
        {
          "hole": 428,
          "x": 120,
          "y": 110,
          "z": 85
        },
        {
          "hole": 429,
          "x": 127.75,
          "y": 110,
          "z": 85
        },
        {
          "hole": 430,
          "x": 135.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 431,
          "x": 145,
          "y": 110,
          "z": 85
        },
        {
          "hole": 432,
          "x": 152.5,
          "y": 110,
          "z": 85
        },
        {
          "hole": 433,
          "x": 185,
          "y": 110,
          "z": 85
        },
        {
          "hole": 434,
          "x": 185,
          "y": 110,
          "z": 52.5
        },
        {
          "hole": 435,
          "x": 185,
          "y": 110,
          "z": 45
        },
        {
          "hole": 436,
          "x": 185,
          "y": 120,
          "z": 35.5
        },
        {
          "hole": 437,
          "x": 185,
          "y": 120,
          "z": 27.75
        },
        {
          "hole": 438,
          "x": 185,
          "y": 120,
          "z": 20
        },
        {
          "hole": 439,
          "x": 185,
          "y": 120,
          "z": 12.25
        },
        {
          "hole": 440,
          "x": 185,
          "y": 120,
          "z": 4.5
        },
        {
          "hole": 441,
          "x": 185,
          "y": 120,
          "z": -4.5
        },
        {
          "hole": 442,
          "x": 185,
          "y": 120,
          "z": -12.25
        },
        {
          "hole": 443,
          "x": 185,
          "y": 120,
          "z": -20
        },
        {
          "hole": 444,
          "x": 185,
          "y": 120,
          "z": -27.75
        },
        {
          "hole": 445,
          "x": 185,
          "y": 120,
          "z": -35.5
        },
        {
          "hole": 446,
          "x": 185,
          "y": 120,
          "z": -44.5
        },
        {
          "hole": 447,
          "x": 185,
          "y": 120,
          "z": -52.25
        },
        {
          "hole": 448,
          "x": 185,
          "y": 120,
          "z": -60
        },
        {
          "hole": 449,
          "x": 185,
          "y": 120,
          "z": -67.75
        },
        {
          "hole": 450,
          "x": 185,
          "y": 120,
          "z": -75.5
        },
        {
          "hole": 451,
          "x": 185,
          "y": 120,
          "z": -85
        },
        {
          "hole": 452,
          "x": 185,
          "y": 120,
          "z": -102.5
        },
        {
          "hole": 453,
          "x": 185,
          "y": 120,
          "z": -145
        },
        {
          "hole": 454,
          "x": 142.5,
          "y": 120,
          "z": -145
        },
        {
          "hole": 455,
          "x": 125,
          "y": 120,
          "z": -145
        },
        {
          "hole": 456,
          "x": 115.5,
          "y": 130,
          "z": -145
        },
        {
          "hole": 457,
          "x": 107.75,
          "y": 130,
          "z": -145
        },
        {
          "hole": 458,
          "x": 100,
          "y": 130,
          "z": -145
        },
        {
          "hole": 459,
          "x": 92.25,
          "y": 130,
          "z": -145
        },
        {
          "hole": 460,
          "x": 84.5,
          "y": 130,
          "z": -145
        },
        {
          "hole": 461,
          "x": 75,
          "y": 130,
          "z": -145
        },
        {
          "hole": 462,
          "x": 57.5,
          "y": 130,
          "z": -145
        },
        {
          "hole": 463,
          "x": 15,
          "y": 130,
          "z": -145
        },
        {
          "hole": 464,
          "x": 15,
          "y": 130,
          "z": -102.5
        },
        {
          "hole": 465,
          "x": 15,
          "y": 130,
          "z": -85
        },
        {
          "hole": 466,
          "x": 15,
          "y": 140,
          "z": -75.5
        },
        {
          "hole": 467,
          "x": 15,
          "y": 140,
          "z": -67.75
        },
        {
          "hole": 468,
          "x": 15,
          "y": 140,
          "z": -60
        },
        {
          "hole": 469,
          "x": 15,
          "y": 140,
          "z": -52.25
        },
        {
          "hole": 470,
          "x": 15,
          "y": 140,
          "z": -44.5
        },
        {
          "hole": 471,
          "x": 15,
          "y": 140,
          "z": -35
        },
        {
          "hole": 472,
          "x": 15,
          "y": 140,
          "z": -27.5
        },
        {
          "hole": 473,
          "x": 15,
          "y": 140,
          "z": 5
        },
        {
          "hole": 474,
          "x": 47.5,
          "y": 140,
          "z": 5
        },
        {
          "hole": 475,
          "x": 55,
          "y": 140,
          "z": 5
        },
        {
          "hole": 476,
          "x": 65,
          "y": 150,
          "z": 5
        },
        {
          "hole": 477,
          "x": 72.5,
          "y": 150,
          "z": 5
        },
        {
          "hole": 478,
          "x": 105,
          "y": 150,
          "z": 5
        },
        {
          "hole": 479,
          "x": 105,
          "y": 150,
          "z": -27.5
        },
        {
          "hole": 480,
          "x": 105,
          "y": 150,
          "z": -35
        },
        {
          "hole": 121,
          "x": 100,
          "y": 160,
          "z": -60
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": -225,
          "y": 10,
          "z": -93
        },
        {
          "hole": 1,
          "x": -215,
          "y": 20,
          "z": -75.5
        },
        {
          "hole": 2,
          "x": -215,
          "y": 20,
          "z": -67.75
        },
        {
          "hole": 3,
          "x": -215,
          "y": 20,
          "z": -60
        },
        {
          "hole": 4,
          "x": -215,
          "y": 20,
          "z": -52.25
        },
        {
          "hole": 5,
          "x": -215,
          "y": 20,
          "z": -44.5
        },
        {
          "hole": 6,
          "x": -215,
          "y": 20,
          "z": -35.5
        },
        {
          "hole": 7,
          "x": -215,
          "y": 20,
          "z": -27.75
        },
        {
          "hole": 8,
          "x": -215,
          "y": 20,
          "z": -20
        },
        {
          "hole": 9,
          "x": -215,
          "y": 20,
          "z": -12.25
        },
        {
          "hole": 10,
          "x": -215,
          "y": 20,
          "z": -4.5
        },
        {
          "hole": 11,
          "x": -215,
          "y": 20,
          "z": 4.5
        },
        {
          "hole": 12,
          "x": -215,
          "y": 20,
          "z": 12.25
        },
        {
          "hole": 13,
          "x": -215,
          "y": 20,
          "z": 20
        },
        {
          "hole": 14,
          "x": -215,
          "y": 20,
          "z": 27.75
        },
        {
          "hole": 15,
          "x": -215,
          "y": 20,
          "z": 35.5
        },
        {
          "hole": 16,
          "x": -215,
          "y": 20,
          "z": 44.5
        },
        {
          "hole": 17,
          "x": -215,
          "y": 20,
          "z": 52.25
        },
        {
          "hole": 18,
          "x": -215,
          "y": 20,
          "z": 60
        },
        {
          "hole": 19,
          "x": -215,
          "y": 20,
          "z": 67.75
        },
        {
          "hole": 20,
          "x": -215,
          "y": 20,
          "z": 75.5
        },
        {
          "hole": 21,
          "x": -215,
          "y": 20,
          "z": 84.5
        },
        {
          "hole": 22,
          "x": -215,
          "y": 20,
          "z": 92.25
        },
        {
          "hole": 23,
          "x": -215,
          "y": 20,
          "z": 100
        },
        {
          "hole": 24,
          "x": -215,
          "y": 20,
          "z": 107.75
        },
        {
          "hole": 25,
          "x": -215,
          "y": 20,
          "z": 115.5
        },
        {
          "hole": 26,
          "x": -215,
          "y": 20,
          "z": 124.5
        },
        {
          "hole": 27,
          "x": -215,
          "y": 20,
          "z": 132.25
        },
        {
          "hole": 28,
          "x": -215,
          "y": 20,
          "z": 140
        },
        {
          "hole": 29,
          "x": -215,
          "y": 20,
          "z": 147.75
        },
        {
          "hole": 30,
          "x": -215,
          "y": 20,
          "z": 155.5
        },
        {
          "hole": 31,
          "x": -215,
          "y": 20,
          "z": 164.5
        },
        {
          "hole": 32,
          "x": -215,
          "y": 20,
          "z": 172.25
        },
        {
          "hole": 33,
          "x": -215,
          "y": 20,
          "z": 180
        },
        {
          "hole": 34,
          "x": -215,
          "y": 20,
          "z": 187.75
        },
        {
          "hole": 35,
          "x": -215,
          "y": 20,
          "z": 195.5
        },
        {
          "hole": 36,
          "x": -215,
          "y": 20,
          "z": 204.9999
        },
        {
          "hole": 37,
          "x": -215,
          "y": 20,
          "z": 212.4999
        },
        {
          "hole": 38,
          "x": -215,
          "y": 20,
          "z": 234.9999
        },
        {
          "hole": 39,
          "x": -192.5,
          "y": 20,
          "z": 234.9999
        },
        {
          "hole": 40,
          "x": -185,
          "y": 20,
          "z": 234.9999
        },
        {
          "hole": 41,
          "x": -175.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 42,
          "x": -167.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 43,
          "x": -160,
          "y": 30,
          "z": 235
        },
        {
          "hole": 44,
          "x": -152.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 45,
          "x": -144.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 46,
          "x": -135.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 47,
          "x": -127.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 48,
          "x": -120,
          "y": 30,
          "z": 235
        },
        {
          "hole": 49,
          "x": -112.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 50,
          "x": -104.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 51,
          "x": -95.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 52,
          "x": -87.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 53,
          "x": -80,
          "y": 30,
          "z": 235
        },
        {
          "hole": 54,
          "x": -72.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 55,
          "x": -64.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 56,
          "x": -55.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 57,
          "x": -47.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 58,
          "x": -40,
          "y": 30,
          "z": 235
        },
        {
          "hole": 59,
          "x": -32.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 60,
          "x": -24.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 61,
          "x": -15.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 62,
          "x": -7.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 63,
          "x": 0,
          "y": 30,
          "z": 235
        },
        {
          "hole": 64,
          "x": 7.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 65,
          "x": 15.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 66,
          "x": 24.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 67,
          "x": 32.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 68,
          "x": 40,
          "y": 30,
          "z": 235
        },
        {
          "hole": 69,
          "x": 47.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 70,
          "x": 55.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 71,
          "x": 64.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 72,
          "x": 72.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 73,
          "x": 80,
          "y": 30,
          "z": 235
        },
        {
          "hole": 74,
          "x": 87.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 75,
          "x": 95.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 76,
          "x": 104.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 77,
          "x": 112.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 78,
          "x": 120,
          "y": 30,
          "z": 235
        },
        {
          "hole": 79,
          "x": 127.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 80,
          "x": 135.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 81,
          "x": 144.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 82,
          "x": 152.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 83,
          "x": 160,
          "y": 30,
          "z": 235
        },
        {
          "hole": 84,
          "x": 167.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 85,
          "x": 175.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 86,
          "x": 184.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 87,
          "x": 192.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 88,
          "x": 200,
          "y": 30,
          "z": 235
        },
        {
          "hole": 89,
          "x": 207.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 90,
          "x": 215.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 91,
          "x": 224.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 92,
          "x": 232.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 93,
          "x": 240,
          "y": 30,
          "z": 235
        },
        {
          "hole": 94,
          "x": 247.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 95,
          "x": 255.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 96,
          "x": 264.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 97,
          "x": 272.25,
          "y": 30,
          "z": 235
        },
        {
          "hole": 98,
          "x": 280,
          "y": 30,
          "z": 235
        },
        {
          "hole": 99,
          "x": 287.75,
          "y": 30,
          "z": 235
        },
        {
          "hole": 100,
          "x": 295.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 101,
          "x": 305,
          "y": 30,
          "z": 235
        },
        {
          "hole": 102,
          "x": 312.5,
          "y": 30,
          "z": 235
        },
        {
          "hole": 103,
          "x": 335,
          "y": 30,
          "z": 235
        },
        {
          "hole": 104,
          "x": 335,
          "y": 30,
          "z": 212.5
        },
        {
          "hole": 105,
          "x": 335,
          "y": 30,
          "z": 205
        },
        {
          "hole": 106,
          "x": 335,
          "y": 40,
          "z": 195.5
        },
        {
          "hole": 107,
          "x": 335,
          "y": 40,
          "z": 187.75
        },
        {
          "hole": 108,
          "x": 335,
          "y": 40,
          "z": 180
        },
        {
          "hole": 109,
          "x": 335,
          "y": 40,
          "z": 172.25
        },
        {
          "hole": 110,
          "x": 335,
          "y": 40,
          "z": 164.5
        },
        {
          "hole": 111,
          "x": 335,
          "y": 40,
          "z": 155.5
        },
        {
          "hole": 112,
          "x": 335,
          "y": 40,
          "z": 147.75
        },
        {
          "hole": 113,
          "x": 335,
          "y": 40,
          "z": 140
        },
        {
          "hole": 114,
          "x": 335,
          "y": 40,
          "z": 132.25
        },
        {
          "hole": 115,
          "x": 335,
          "y": 40,
          "z": 124.5
        },
        {
          "hole": 116,
          "x": 335,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 117,
          "x": 335,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 118,
          "x": 335,
          "y": 40,
          "z": 100
        },
        {
          "hole": 119,
          "x": 335,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 120,
          "x": 335,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 121,
          "x": 335,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 122,
          "x": 335,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 123,
          "x": 335,
          "y": 40,
          "z": 60
        },
        {
          "hole": 124,
          "x": 335,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 125,
          "x": 335,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 126,
          "x": 335,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 127,
          "x": 335,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 128,
          "x": 335,
          "y": 40,
          "z": 20
        },
        {
          "hole": 129,
          "x": 335,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 130,
          "x": 335,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 131,
          "x": 335,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 132,
          "x": 335,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 133,
          "x": 335,
          "y": 40,
          "z": -20
        },
        {
          "hole": 134,
          "x": 335,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 135,
          "x": 335,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 136,
          "x": 335,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 137,
          "x": 335,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 138,
          "x": 335,
          "y": 40,
          "z": -60
        },
        {
          "hole": 139,
          "x": 335,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 140,
          "x": 335,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 141,
          "x": 335,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 142,
          "x": 335,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 143,
          "x": 335,
          "y": 40,
          "z": -100
        },
        {
          "hole": 144,
          "x": 335,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 145,
          "x": 335,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 146,
          "x": 335,
          "y": 40,
          "z": -124.5
        },
        {
          "hole": 147,
          "x": 335,
          "y": 40,
          "z": -132.25
        },
        {
          "hole": 148,
          "x": 335,
          "y": 40,
          "z": -140
        },
        {
          "hole": 149,
          "x": 335,
          "y": 40,
          "z": -147.75
        },
        {
          "hole": 150,
          "x": 335,
          "y": 40,
          "z": -155.5
        },
        {
          "hole": 151,
          "x": 335,
          "y": 40,
          "z": -164.5
        },
        {
          "hole": 152,
          "x": 335,
          "y": 40,
          "z": -172.25
        },
        {
          "hole": 153,
          "x": 335,
          "y": 40,
          "z": -180
        },
        {
          "hole": 154,
          "x": 335,
          "y": 40,
          "z": -187.75
        },
        {
          "hole": 155,
          "x": 335,
          "y": 40,
          "z": -195.5
        },
        {
          "hole": 156,
          "x": 335,
          "y": 40,
          "z": -204.5
        },
        {
          "hole": 157,
          "x": 335,
          "y": 40,
          "z": -212.25
        },
        {
          "hole": 158,
          "x": 335,
          "y": 40,
          "z": -220
        },
        {
          "hole": 159,
          "x": 335,
          "y": 40,
          "z": -227.75
        },
        {
          "hole": 160,
          "x": 335,
          "y": 40,
          "z": -235.5
        },
        {
          "hole": 161,
          "x": 335,
          "y": 40,
          "z": -245
        },
        {
          "hole": 162,
          "x": 335,
          "y": 40,
          "z": -262.5
        },
        {
          "hole": 163,
          "x": 335,
          "y": 40,
          "z": -295
        },
        {
          "hole": 164,
          "x": 302.5,
          "y": 40,
          "z": -295
        },
        {
          "hole": 165,
          "x": 285,
          "y": 40,
          "z": -295
        },
        {
          "hole": 166,
          "x": 275.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 167,
          "x": 267.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 168,
          "x": 260,
          "y": 50,
          "z": -295
        },
        {
          "hole": 169,
          "x": 252.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 170,
          "x": 244.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 171,
          "x": 235.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 172,
          "x": 227.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 173,
          "x": 220,
          "y": 50,
          "z": -295
        },
        {
          "hole": 174,
          "x": 212.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 175,
          "x": 204.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 176,
          "x": 195.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 177,
          "x": 187.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 178,
          "x": 180,
          "y": 50,
          "z": -295
        },
        {
          "hole": 179,
          "x": 172.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 180,
          "x": 164.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 181,
          "x": 155.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 182,
          "x": 147.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 183,
          "x": 140,
          "y": 50,
          "z": -295
        },
        {
          "hole": 184,
          "x": 132.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 185,
          "x": 124.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 186,
          "x": 115.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 187,
          "x": 107.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 188,
          "x": 100,
          "y": 50,
          "z": -295
        },
        {
          "hole": 189,
          "x": 92.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 190,
          "x": 84.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 191,
          "x": 75.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 192,
          "x": 67.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 193,
          "x": 60,
          "y": 50,
          "z": -295
        },
        {
          "hole": 194,
          "x": 52.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 195,
          "x": 44.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 196,
          "x": 35.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 197,
          "x": 27.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 198,
          "x": 20,
          "y": 50,
          "z": -295
        },
        {
          "hole": 199,
          "x": 12.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 200,
          "x": 4.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 201,
          "x": -4.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 202,
          "x": -12.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 203,
          "x": -20,
          "y": 50,
          "z": -295
        },
        {
          "hole": 204,
          "x": -27.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 205,
          "x": -35.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 206,
          "x": -44.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 207,
          "x": -52.25,
          "y": 50,
          "z": -295
        },
        {
          "hole": 208,
          "x": -60,
          "y": 50,
          "z": -295
        },
        {
          "hole": 209,
          "x": -67.75,
          "y": 50,
          "z": -295
        },
        {
          "hole": 210,
          "x": -75.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 211,
          "x": -85,
          "y": 50,
          "z": -295
        },
        {
          "hole": 212,
          "x": -102.5,
          "y": 50,
          "z": -295
        },
        {
          "hole": 213,
          "x": -135,
          "y": 50,
          "z": -295
        },
        {
          "hole": 214,
          "x": -135,
          "y": 50,
          "z": -262.5
        },
        {
          "hole": 215,
          "x": -135,
          "y": 50,
          "z": -245
        },
        {
          "hole": 216,
          "x": -135,
          "y": 60,
          "z": -235.5
        },
        {
          "hole": 217,
          "x": -135,
          "y": 60,
          "z": -227.75
        },
        {
          "hole": 218,
          "x": -135,
          "y": 60,
          "z": -220
        },
        {
          "hole": 219,
          "x": -135,
          "y": 60,
          "z": -212.25
        },
        {
          "hole": 220,
          "x": -135,
          "y": 60,
          "z": -204.5
        },
        {
          "hole": 221,
          "x": -135,
          "y": 60,
          "z": -195.5
        },
        {
          "hole": 222,
          "x": -135,
          "y": 60,
          "z": -187.75
        },
        {
          "hole": 223,
          "x": -135,
          "y": 60,
          "z": -180
        },
        {
          "hole": 224,
          "x": -135,
          "y": 60,
          "z": -172.25
        },
        {
          "hole": 225,
          "x": -135,
          "y": 60,
          "z": -164.5
        },
        {
          "hole": 226,
          "x": -135,
          "y": 60,
          "z": -155.5
        },
        {
          "hole": 227,
          "x": -135,
          "y": 60,
          "z": -147.75
        },
        {
          "hole": 228,
          "x": -135,
          "y": 60,
          "z": -140
        },
        {
          "hole": 229,
          "x": -135,
          "y": 60,
          "z": -132.25
        },
        {
          "hole": 230,
          "x": -135,
          "y": 60,
          "z": -124.5
        },
        {
          "hole": 231,
          "x": -135,
          "y": 60,
          "z": -115.5
        },
        {
          "hole": 232,
          "x": -135,
          "y": 60,
          "z": -107.75
        },
        {
          "hole": 233,
          "x": -135,
          "y": 60,
          "z": -100
        },
        {
          "hole": 234,
          "x": -135,
          "y": 60,
          "z": -92.25
        },
        {
          "hole": 235,
          "x": -135,
          "y": 60,
          "z": -84.5
        },
        {
          "hole": 236,
          "x": -135,
          "y": 60,
          "z": -75.5
        },
        {
          "hole": 237,
          "x": -135,
          "y": 60,
          "z": -67.75
        },
        {
          "hole": 238,
          "x": -135,
          "y": 60,
          "z": -60
        },
        {
          "hole": 239,
          "x": -135,
          "y": 60,
          "z": -52.25
        },
        {
          "hole": 240,
          "x": -135,
          "y": 60,
          "z": -44.5
        },
        {
          "hole": 241,
          "x": -135,
          "y": 60,
          "z": -35.5
        },
        {
          "hole": 242,
          "x": -135,
          "y": 60,
          "z": -27.75
        },
        {
          "hole": 243,
          "x": -135,
          "y": 60,
          "z": -20
        },
        {
          "hole": 244,
          "x": -135,
          "y": 60,
          "z": -12.25
        },
        {
          "hole": 245,
          "x": -135,
          "y": 60,
          "z": -4.5
        },
        {
          "hole": 246,
          "x": -135,
          "y": 60,
          "z": 4.5
        },
        {
          "hole": 247,
          "x": -135,
          "y": 60,
          "z": 12.25
        },
        {
          "hole": 248,
          "x": -135,
          "y": 60,
          "z": 20
        },
        {
          "hole": 249,
          "x": -135,
          "y": 60,
          "z": 27.75
        },
        {
          "hole": 250,
          "x": -135,
          "y": 60,
          "z": 35.5
        },
        {
          "hole": 251,
          "x": -135,
          "y": 60,
          "z": 44.5
        },
        {
          "hole": 252,
          "x": -135,
          "y": 60,
          "z": 52.25
        },
        {
          "hole": 253,
          "x": -135,
          "y": 60,
          "z": 60
        },
        {
          "hole": 254,
          "x": -135,
          "y": 60,
          "z": 67.75
        },
        {
          "hole": 255,
          "x": -135,
          "y": 60,
          "z": 75.5
        },
        {
          "hole": 256,
          "x": -135,
          "y": 60,
          "z": 84.5
        },
        {
          "hole": 257,
          "x": -135,
          "y": 60,
          "z": 92.25
        },
        {
          "hole": 258,
          "x": -135,
          "y": 60,
          "z": 100
        },
        {
          "hole": 259,
          "x": -135,
          "y": 60,
          "z": 107.75
        },
        {
          "hole": 260,
          "x": -135,
          "y": 60,
          "z": 115.5
        },
        {
          "hole": 261,
          "x": -135,
          "y": 60,
          "z": 125
        },
        {
          "hole": 262,
          "x": -135,
          "y": 60,
          "z": 132.5
        },
        {
          "hole": 263,
          "x": -135,
          "y": 60,
          "z": 155
        },
        {
          "hole": 264,
          "x": -112.5,
          "y": 60,
          "z": 155
        },
        {
          "hole": 265,
          "x": -105,
          "y": 60,
          "z": 155
        },
        {
          "hole": 266,
          "x": -95.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 267,
          "x": -87.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 268,
          "x": -80,
          "y": 70,
          "z": 155
        },
        {
          "hole": 269,
          "x": -72.25,
          "y": 70,
          "z": 155
        },
        {
          "hole": 270,
          "x": -64.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 271,
          "x": -55.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 272,
          "x": -47.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 273,
          "x": -40,
          "y": 70,
          "z": 155
        },
        {
          "hole": 274,
          "x": -32.25,
          "y": 70,
          "z": 155
        },
        {
          "hole": 275,
          "x": -24.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 276,
          "x": -15.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 277,
          "x": -7.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 278,
          "x": 0,
          "y": 70,
          "z": 155
        },
        {
          "hole": 279,
          "x": 7.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 280,
          "x": 15.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 281,
          "x": 24.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 282,
          "x": 32.25,
          "y": 70,
          "z": 155
        },
        {
          "hole": 283,
          "x": 40,
          "y": 70,
          "z": 155
        },
        {
          "hole": 284,
          "x": 47.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 285,
          "x": 55.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 286,
          "x": 64.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 287,
          "x": 72.25,
          "y": 70,
          "z": 155
        },
        {
          "hole": 288,
          "x": 80,
          "y": 70,
          "z": 155
        },
        {
          "hole": 289,
          "x": 87.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 290,
          "x": 95.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 291,
          "x": 104.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 292,
          "x": 112.25,
          "y": 70,
          "z": 155
        },
        {
          "hole": 293,
          "x": 120,
          "y": 70,
          "z": 155
        },
        {
          "hole": 294,
          "x": 127.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 295,
          "x": 135.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 296,
          "x": 144.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 297,
          "x": 152.25,
          "y": 70,
          "z": 155
        },
        {
          "hole": 298,
          "x": 160,
          "y": 70,
          "z": 155
        },
        {
          "hole": 299,
          "x": 167.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 300,
          "x": 175.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 301,
          "x": 184.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 302,
          "x": 192.25,
          "y": 70,
          "z": 155
        },
        {
          "hole": 303,
          "x": 200,
          "y": 70,
          "z": 155
        },
        {
          "hole": 304,
          "x": 207.75,
          "y": 70,
          "z": 155
        },
        {
          "hole": 305,
          "x": 215.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 306,
          "x": 225,
          "y": 70,
          "z": 155
        },
        {
          "hole": 307,
          "x": 232.5,
          "y": 70,
          "z": 155
        },
        {
          "hole": 308,
          "x": 255,
          "y": 70,
          "z": 155
        },
        {
          "hole": 309,
          "x": 255,
          "y": 70,
          "z": 132.5
        },
        {
          "hole": 310,
          "x": 255,
          "y": 70,
          "z": 125
        },
        {
          "hole": 311,
          "x": 255,
          "y": 80,
          "z": 115.5
        },
        {
          "hole": 312,
          "x": 255,
          "y": 80,
          "z": 107.75
        },
        {
          "hole": 313,
          "x": 255,
          "y": 80,
          "z": 100
        },
        {
          "hole": 314,
          "x": 255,
          "y": 80,
          "z": 92.25
        },
        {
          "hole": 315,
          "x": 255,
          "y": 80,
          "z": 84.5
        },
        {
          "hole": 316,
          "x": 255,
          "y": 80,
          "z": 75.5
        },
        {
          "hole": 317,
          "x": 255,
          "y": 80,
          "z": 67.75
        },
        {
          "hole": 318,
          "x": 255,
          "y": 80,
          "z": 60
        },
        {
          "hole": 319,
          "x": 255,
          "y": 80,
          "z": 52.25
        },
        {
          "hole": 320,
          "x": 255,
          "y": 80,
          "z": 44.5
        },
        {
          "hole": 321,
          "x": 255,
          "y": 80,
          "z": 35.5
        },
        {
          "hole": 322,
          "x": 255,
          "y": 80,
          "z": 27.75
        },
        {
          "hole": 323,
          "x": 255,
          "y": 80,
          "z": 20
        },
        {
          "hole": 324,
          "x": 255,
          "y": 80,
          "z": 12.25
        },
        {
          "hole": 325,
          "x": 255,
          "y": 80,
          "z": 4.5
        },
        {
          "hole": 326,
          "x": 255,
          "y": 80,
          "z": -4.5
        },
        {
          "hole": 327,
          "x": 255,
          "y": 80,
          "z": -12.25
        },
        {
          "hole": 328,
          "x": 255,
          "y": 80,
          "z": -20
        },
        {
          "hole": 329,
          "x": 255,
          "y": 80,
          "z": -27.75
        },
        {
          "hole": 330,
          "x": 255,
          "y": 80,
          "z": -35.5
        },
        {
          "hole": 331,
          "x": 255,
          "y": 80,
          "z": -44.5
        },
        {
          "hole": 332,
          "x": 255,
          "y": 80,
          "z": -52.25
        },
        {
          "hole": 333,
          "x": 255,
          "y": 80,
          "z": -60
        },
        {
          "hole": 334,
          "x": 255,
          "y": 80,
          "z": -67.75
        },
        {
          "hole": 335,
          "x": 255,
          "y": 80,
          "z": -75.5
        },
        {
          "hole": 336,
          "x": 255,
          "y": 80,
          "z": -84.5
        },
        {
          "hole": 337,
          "x": 255,
          "y": 80,
          "z": -92.25
        },
        {
          "hole": 338,
          "x": 255,
          "y": 80,
          "z": -100
        },
        {
          "hole": 339,
          "x": 255,
          "y": 80,
          "z": -107.75
        },
        {
          "hole": 340,
          "x": 255,
          "y": 80,
          "z": -115.5
        },
        {
          "hole": 341,
          "x": 255,
          "y": 80,
          "z": -124.5
        },
        {
          "hole": 342,
          "x": 255,
          "y": 80,
          "z": -132.25
        },
        {
          "hole": 343,
          "x": 255,
          "y": 80,
          "z": -140
        },
        {
          "hole": 344,
          "x": 255,
          "y": 80,
          "z": -147.75
        },
        {
          "hole": 345,
          "x": 255,
          "y": 80,
          "z": -155.5
        },
        {
          "hole": 346,
          "x": 255,
          "y": 80,
          "z": -165
        },
        {
          "hole": 347,
          "x": 255,
          "y": 80,
          "z": -182.5
        },
        {
          "hole": 348,
          "x": 255,
          "y": 80,
          "z": -215
        },
        {
          "hole": 349,
          "x": 222.5,
          "y": 80,
          "z": -215
        },
        {
          "hole": 350,
          "x": 205,
          "y": 80,
          "z": -215
        },
        {
          "hole": 351,
          "x": 195.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 352,
          "x": 187.75,
          "y": 90,
          "z": -215
        },
        {
          "hole": 353,
          "x": 180,
          "y": 90,
          "z": -215
        },
        {
          "hole": 354,
          "x": 172.25,
          "y": 90,
          "z": -215
        },
        {
          "hole": 355,
          "x": 164.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 356,
          "x": 155.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 357,
          "x": 147.75,
          "y": 90,
          "z": -215
        },
        {
          "hole": 358,
          "x": 140,
          "y": 90,
          "z": -215
        },
        {
          "hole": 359,
          "x": 132.25,
          "y": 90,
          "z": -215
        },
        {
          "hole": 360,
          "x": 124.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 361,
          "x": 115.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 362,
          "x": 107.75,
          "y": 90,
          "z": -215
        },
        {
          "hole": 363,
          "x": 100,
          "y": 90,
          "z": -215
        },
        {
          "hole": 364,
          "x": 92.25,
          "y": 90,
          "z": -215
        },
        {
          "hole": 365,
          "x": 84.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 366,
          "x": 75.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 367,
          "x": 67.75,
          "y": 90,
          "z": -215
        },
        {
          "hole": 368,
          "x": 60,
          "y": 90,
          "z": -215
        },
        {
          "hole": 369,
          "x": 52.25,
          "y": 90,
          "z": -215
        },
        {
          "hole": 370,
          "x": 44.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 371,
          "x": 35.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 372,
          "x": 27.75,
          "y": 90,
          "z": -215
        },
        {
          "hole": 373,
          "x": 20,
          "y": 90,
          "z": -215
        },
        {
          "hole": 374,
          "x": 12.25,
          "y": 90,
          "z": -215
        },
        {
          "hole": 375,
          "x": 4.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 376,
          "x": -5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 377,
          "x": -22.5,
          "y": 90,
          "z": -215
        },
        {
          "hole": 378,
          "x": -55,
          "y": 90,
          "z": -215
        },
        {
          "hole": 379,
          "x": -55,
          "y": 90,
          "z": -182.5
        },
        {
          "hole": 380,
          "x": -55,
          "y": 90,
          "z": -165
        },
        {
          "hole": 381,
          "x": -55,
          "y": 100,
          "z": -155.5
        },
        {
          "hole": 382,
          "x": -55,
          "y": 100,
          "z": -147.75
        },
        {
          "hole": 383,
          "x": -55,
          "y": 100,
          "z": -140
        },
        {
          "hole": 384,
          "x": -55,
          "y": 100,
          "z": -132.25
        },
        {
          "hole": 385,
          "x": -55,
          "y": 100,
          "z": -124.5
        },
        {
          "hole": 386,
          "x": -55,
          "y": 100,
          "z": -115.5
        },
        {
          "hole": 387,
          "x": -55,
          "y": 100,
          "z": -107.75
        },
        {
          "hole": 388,
          "x": -55,
          "y": 100,
          "z": -100
        },
        {
          "hole": 389,
          "x": -55,
          "y": 100,
          "z": -92.25
        },
        {
          "hole": 390,
          "x": -55,
          "y": 100,
          "z": -84.5
        },
        {
          "hole": 391,
          "x": -55,
          "y": 100,
          "z": -75.5
        },
        {
          "hole": 392,
          "x": -55,
          "y": 100,
          "z": -67.75
        },
        {
          "hole": 393,
          "x": -55,
          "y": 100,
          "z": -60
        },
        {
          "hole": 394,
          "x": -55,
          "y": 100,
          "z": -52.25
        },
        {
          "hole": 395,
          "x": -55,
          "y": 100,
          "z": -44.5
        },
        {
          "hole": 396,
          "x": -55,
          "y": 100,
          "z": -35.5
        },
        {
          "hole": 397,
          "x": -55,
          "y": 100,
          "z": -27.75
        },
        {
          "hole": 398,
          "x": -55,
          "y": 100,
          "z": -20
        },
        {
          "hole": 399,
          "x": -55,
          "y": 100,
          "z": -12.25
        },
        {
          "hole": 400,
          "x": -55,
          "y": 100,
          "z": -4.5
        },
        {
          "hole": 401,
          "x": -55,
          "y": 100,
          "z": 4.5
        },
        {
          "hole": 402,
          "x": -55,
          "y": 100,
          "z": 12.25
        },
        {
          "hole": 403,
          "x": -55,
          "y": 100,
          "z": 20
        },
        {
          "hole": 404,
          "x": -55,
          "y": 100,
          "z": 27.75
        },
        {
          "hole": 405,
          "x": -55,
          "y": 100,
          "z": 35.5
        },
        {
          "hole": 406,
          "x": -55,
          "y": 100,
          "z": 45
        },
        {
          "hole": 407,
          "x": -55,
          "y": 100,
          "z": 52.5
        },
        {
          "hole": 408,
          "x": -55,
          "y": 100,
          "z": 75
        },
        {
          "hole": 409,
          "x": -32.5,
          "y": 100,
          "z": 75
        },
        {
          "hole": 410,
          "x": -25,
          "y": 100,
          "z": 75
        },
        {
          "hole": 411,
          "x": -15.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 412,
          "x": -7.75,
          "y": 110,
          "z": 75
        },
        {
          "hole": 413,
          "x": 0,
          "y": 110,
          "z": 75
        },
        {
          "hole": 414,
          "x": 7.75,
          "y": 110,
          "z": 75
        },
        {
          "hole": 415,
          "x": 15.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 416,
          "x": 24.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 417,
          "x": 32.25,
          "y": 110,
          "z": 75
        },
        {
          "hole": 418,
          "x": 40,
          "y": 110,
          "z": 75
        },
        {
          "hole": 419,
          "x": 47.75,
          "y": 110,
          "z": 75
        },
        {
          "hole": 420,
          "x": 55.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 421,
          "x": 64.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 422,
          "x": 72.25,
          "y": 110,
          "z": 75
        },
        {
          "hole": 423,
          "x": 80,
          "y": 110,
          "z": 75
        },
        {
          "hole": 424,
          "x": 87.75,
          "y": 110,
          "z": 75
        },
        {
          "hole": 425,
          "x": 95.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 426,
          "x": 104.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 427,
          "x": 112.25,
          "y": 110,
          "z": 75
        },
        {
          "hole": 428,
          "x": 120,
          "y": 110,
          "z": 75
        },
        {
          "hole": 429,
          "x": 127.75,
          "y": 110,
          "z": 75
        },
        {
          "hole": 430,
          "x": 135.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 431,
          "x": 145,
          "y": 110,
          "z": 75
        },
        {
          "hole": 432,
          "x": 152.5,
          "y": 110,
          "z": 75
        },
        {
          "hole": 433,
          "x": 175,
          "y": 110,
          "z": 75
        },
        {
          "hole": 434,
          "x": 175,
          "y": 110,
          "z": 52.5
        },
        {
          "hole": 435,
          "x": 175,
          "y": 110,
          "z": 45
        },
        {
          "hole": 436,
          "x": 175,
          "y": 120,
          "z": 35.5
        },
        {
          "hole": 437,
          "x": 175,
          "y": 120,
          "z": 27.75
        },
        {
          "hole": 438,
          "x": 175,
          "y": 120,
          "z": 20
        },
        {
          "hole": 439,
          "x": 175,
          "y": 120,
          "z": 12.25
        },
        {
          "hole": 440,
          "x": 175,
          "y": 120,
          "z": 4.5
        },
        {
          "hole": 441,
          "x": 175,
          "y": 120,
          "z": -4.5
        },
        {
          "hole": 442,
          "x": 175,
          "y": 120,
          "z": -12.25
        },
        {
          "hole": 443,
          "x": 175,
          "y": 120,
          "z": -20
        },
        {
          "hole": 444,
          "x": 175,
          "y": 120,
          "z": -27.75
        },
        {
          "hole": 445,
          "x": 175,
          "y": 120,
          "z": -35.5
        },
        {
          "hole": 446,
          "x": 175,
          "y": 120,
          "z": -44.5
        },
        {
          "hole": 447,
          "x": 175,
          "y": 120,
          "z": -52.25
        },
        {
          "hole": 448,
          "x": 175,
          "y": 120,
          "z": -60
        },
        {
          "hole": 449,
          "x": 175,
          "y": 120,
          "z": -67.75
        },
        {
          "hole": 450,
          "x": 175,
          "y": 120,
          "z": -75.5
        },
        {
          "hole": 451,
          "x": 175,
          "y": 120,
          "z": -85
        },
        {
          "hole": 452,
          "x": 175,
          "y": 120,
          "z": -102.5
        },
        {
          "hole": 453,
          "x": 175,
          "y": 120,
          "z": -135
        },
        {
          "hole": 454,
          "x": 142.5,
          "y": 120,
          "z": -135
        },
        {
          "hole": 455,
          "x": 125,
          "y": 120,
          "z": -135
        },
        {
          "hole": 456,
          "x": 115.5,
          "y": 130,
          "z": -135
        },
        {
          "hole": 457,
          "x": 107.75,
          "y": 130,
          "z": -135
        },
        {
          "hole": 458,
          "x": 100,
          "y": 130,
          "z": -135
        },
        {
          "hole": 459,
          "x": 92.25,
          "y": 130,
          "z": -135
        },
        {
          "hole": 460,
          "x": 84.5,
          "y": 130,
          "z": -135
        },
        {
          "hole": 461,
          "x": 75,
          "y": 130,
          "z": -135
        },
        {
          "hole": 462,
          "x": 57.5,
          "y": 130,
          "z": -135
        },
        {
          "hole": 463,
          "x": 25,
          "y": 130,
          "z": -135
        },
        {
          "hole": 464,
          "x": 25,
          "y": 130,
          "z": -102.5
        },
        {
          "hole": 465,
          "x": 25,
          "y": 130,
          "z": -85
        },
        {
          "hole": 466,
          "x": 25,
          "y": 140,
          "z": -75.5
        },
        {
          "hole": 467,
          "x": 25,
          "y": 140,
          "z": -67.75
        },
        {
          "hole": 468,
          "x": 25,
          "y": 140,
          "z": -60
        },
        {
          "hole": 469,
          "x": 25,
          "y": 140,
          "z": -52.25
        },
        {
          "hole": 470,
          "x": 25,
          "y": 140,
          "z": -44.5
        },
        {
          "hole": 471,
          "x": 25,
          "y": 140,
          "z": -35
        },
        {
          "hole": 472,
          "x": 25,
          "y": 140,
          "z": -27.5
        },
        {
          "hole": 473,
          "x": 25,
          "y": 140,
          "z": -5
        },
        {
          "hole": 474,
          "x": 47.5,
          "y": 140,
          "z": -5
        },
        {
          "hole": 475,
          "x": 55,
          "y": 140,
          "z": -5
        },
        {
          "hole": 476,
          "x": 65,
          "y": 150,
          "z": -5
        },
        {
          "hole": 477,
          "x": 72.5,
          "y": 150,
          "z": -5
        },
        {
          "hole": 478,
          "x": 95,
          "y": 150,
          "z": -5
        },
        {
          "hole": 479,
          "x": 95,
          "y": 150,
          "z": -27.5
        },
        {
          "hole": 480,
          "x": 95,
          "y": 150,
          "z": -35
        },
        {
          "hole": 121,
          "x": 100,
          "y": 160,
          "z": -60
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": -235,
          "y": 10,
          "z": -93
        },
        {
          "hole": 1,
          "x": -205,
          "y": 20,
          "z": -75.5
        },
        {
          "hole": 2,
          "x": -205,
          "y": 20,
          "z": -67.75
        },
        {
          "hole": 3,
          "x": -205,
          "y": 20,
          "z": -60
        },
        {
          "hole": 4,
          "x": -205,
          "y": 20,
          "z": -52.25
        },
        {
          "hole": 5,
          "x": -205,
          "y": 20,
          "z": -44.5
        },
        {
          "hole": 6,
          "x": -205,
          "y": 20,
          "z": -35.5
        },
        {
          "hole": 7,
          "x": -205,
          "y": 20,
          "z": -27.75
        },
        {
          "hole": 8,
          "x": -205,
          "y": 20,
          "z": -20
        },
        {
          "hole": 9,
          "x": -205,
          "y": 20,
          "z": -12.25
        },
        {
          "hole": 10,
          "x": -205,
          "y": 20,
          "z": -4.5
        },
        {
          "hole": 11,
          "x": -205,
          "y": 20,
          "z": 4.5
        },
        {
          "hole": 12,
          "x": -205,
          "y": 20,
          "z": 12.25
        },
        {
          "hole": 13,
          "x": -205,
          "y": 20,
          "z": 20
        },
        {
          "hole": 14,
          "x": -205,
          "y": 20,
          "z": 27.75
        },
        {
          "hole": 15,
          "x": -205,
          "y": 20,
          "z": 35.5
        },
        {
          "hole": 16,
          "x": -205,
          "y": 20,
          "z": 44.5
        },
        {
          "hole": 17,
          "x": -205,
          "y": 20,
          "z": 52.25
        },
        {
          "hole": 18,
          "x": -205,
          "y": 20,
          "z": 60
        },
        {
          "hole": 19,
          "x": -205,
          "y": 20,
          "z": 67.75
        },
        {
          "hole": 20,
          "x": -205,
          "y": 20,
          "z": 75.5
        },
        {
          "hole": 21,
          "x": -205,
          "y": 20,
          "z": 84.5
        },
        {
          "hole": 22,
          "x": -205,
          "y": 20,
          "z": 92.25
        },
        {
          "hole": 23,
          "x": -205,
          "y": 20,
          "z": 100
        },
        {
          "hole": 24,
          "x": -205,
          "y": 20,
          "z": 107.75
        },
        {
          "hole": 25,
          "x": -205,
          "y": 20,
          "z": 115.5
        },
        {
          "hole": 26,
          "x": -205,
          "y": 20,
          "z": 124.5
        },
        {
          "hole": 27,
          "x": -205,
          "y": 20,
          "z": 132.25
        },
        {
          "hole": 28,
          "x": -205,
          "y": 20,
          "z": 140
        },
        {
          "hole": 29,
          "x": -205,
          "y": 20,
          "z": 147.75
        },
        {
          "hole": 30,
          "x": -205,
          "y": 20,
          "z": 155.5
        },
        {
          "hole": 31,
          "x": -205,
          "y": 20,
          "z": 164.5
        },
        {
          "hole": 32,
          "x": -205,
          "y": 20,
          "z": 172.25
        },
        {
          "hole": 33,
          "x": -205,
          "y": 20,
          "z": 180
        },
        {
          "hole": 34,
          "x": -205,
          "y": 20,
          "z": 187.75
        },
        {
          "hole": 35,
          "x": -205,
          "y": 20,
          "z": 195.5
        },
        {
          "hole": 36,
          "x": -205,
          "y": 20,
          "z": 204.9999
        },
        {
          "hole": 37,
          "x": -205,
          "y": 20,
          "z": 212.4999
        },
        {
          "hole": 38,
          "x": -205,
          "y": 20,
          "z": 224.9999
        },
        {
          "hole": 39,
          "x": -192.5,
          "y": 20,
          "z": 224.9999
        },
        {
          "hole": 40,
          "x": -185,
          "y": 20,
          "z": 224.9999
        },
        {
          "hole": 41,
          "x": -175.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 42,
          "x": -167.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 43,
          "x": -160,
          "y": 30,
          "z": 225
        },
        {
          "hole": 44,
          "x": -152.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 45,
          "x": -144.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 46,
          "x": -135.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 47,
          "x": -127.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 48,
          "x": -120,
          "y": 30,
          "z": 225
        },
        {
          "hole": 49,
          "x": -112.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 50,
          "x": -104.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 51,
          "x": -95.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 52,
          "x": -87.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 53,
          "x": -80,
          "y": 30,
          "z": 225
        },
        {
          "hole": 54,
          "x": -72.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 55,
          "x": -64.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 56,
          "x": -55.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 57,
          "x": -47.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 58,
          "x": -40,
          "y": 30,
          "z": 225
        },
        {
          "hole": 59,
          "x": -32.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 60,
          "x": -24.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 61,
          "x": -15.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 62,
          "x": -7.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 63,
          "x": 0,
          "y": 30,
          "z": 225
        },
        {
          "hole": 64,
          "x": 7.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 65,
          "x": 15.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 66,
          "x": 24.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 67,
          "x": 32.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 68,
          "x": 40,
          "y": 30,
          "z": 225
        },
        {
          "hole": 69,
          "x": 47.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 70,
          "x": 55.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 71,
          "x": 64.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 72,
          "x": 72.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 73,
          "x": 80,
          "y": 30,
          "z": 225
        },
        {
          "hole": 74,
          "x": 87.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 75,
          "x": 95.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 76,
          "x": 104.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 77,
          "x": 112.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 78,
          "x": 120,
          "y": 30,
          "z": 225
        },
        {
          "hole": 79,
          "x": 127.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 80,
          "x": 135.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 81,
          "x": 144.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 82,
          "x": 152.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 83,
          "x": 160,
          "y": 30,
          "z": 225
        },
        {
          "hole": 84,
          "x": 167.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 85,
          "x": 175.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 86,
          "x": 184.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 87,
          "x": 192.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 88,
          "x": 200,
          "y": 30,
          "z": 225
        },
        {
          "hole": 89,
          "x": 207.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 90,
          "x": 215.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 91,
          "x": 224.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 92,
          "x": 232.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 93,
          "x": 240,
          "y": 30,
          "z": 225
        },
        {
          "hole": 94,
          "x": 247.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 95,
          "x": 255.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 96,
          "x": 264.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 97,
          "x": 272.25,
          "y": 30,
          "z": 225
        },
        {
          "hole": 98,
          "x": 280,
          "y": 30,
          "z": 225
        },
        {
          "hole": 99,
          "x": 287.75,
          "y": 30,
          "z": 225
        },
        {
          "hole": 100,
          "x": 295.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 101,
          "x": 305,
          "y": 30,
          "z": 225
        },
        {
          "hole": 102,
          "x": 312.5,
          "y": 30,
          "z": 225
        },
        {
          "hole": 103,
          "x": 325,
          "y": 30,
          "z": 225
        },
        {
          "hole": 104,
          "x": 325,
          "y": 30,
          "z": 212.5
        },
        {
          "hole": 105,
          "x": 325,
          "y": 30,
          "z": 205
        },
        {
          "hole": 106,
          "x": 325,
          "y": 40,
          "z": 195.5
        },
        {
          "hole": 107,
          "x": 325,
          "y": 40,
          "z": 187.75
        },
        {
          "hole": 108,
          "x": 325,
          "y": 40,
          "z": 180
        },
        {
          "hole": 109,
          "x": 325,
          "y": 40,
          "z": 172.25
        },
        {
          "hole": 110,
          "x": 325,
          "y": 40,
          "z": 164.5
        },
        {
          "hole": 111,
          "x": 325,
          "y": 40,
          "z": 155.5
        },
        {
          "hole": 112,
          "x": 325,
          "y": 40,
          "z": 147.75
        },
        {
          "hole": 113,
          "x": 325,
          "y": 40,
          "z": 140
        },
        {
          "hole": 114,
          "x": 325,
          "y": 40,
          "z": 132.25
        },
        {
          "hole": 115,
          "x": 325,
          "y": 40,
          "z": 124.5
        },
        {
          "hole": 116,
          "x": 325,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 117,
          "x": 325,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 118,
          "x": 325,
          "y": 40,
          "z": 100
        },
        {
          "hole": 119,
          "x": 325,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 120,
          "x": 325,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 121,
          "x": 325,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 122,
          "x": 325,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 123,
          "x": 325,
          "y": 40,
          "z": 60
        },
        {
          "hole": 124,
          "x": 325,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 125,
          "x": 325,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 126,
          "x": 325,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 127,
          "x": 325,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 128,
          "x": 325,
          "y": 40,
          "z": 20
        },
        {
          "hole": 129,
          "x": 325,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 130,
          "x": 325,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 131,
          "x": 325,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 132,
          "x": 325,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 133,
          "x": 325,
          "y": 40,
          "z": -20
        },
        {
          "hole": 134,
          "x": 325,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 135,
          "x": 325,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 136,
          "x": 325,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 137,
          "x": 325,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 138,
          "x": 325,
          "y": 40,
          "z": -60
        },
        {
          "hole": 139,
          "x": 325,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 140,
          "x": 325,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 141,
          "x": 325,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 142,
          "x": 325,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 143,
          "x": 325,
          "y": 40,
          "z": -100
        },
        {
          "hole": 144,
          "x": 325,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 145,
          "x": 325,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 146,
          "x": 325,
          "y": 40,
          "z": -124.5
        },
        {
          "hole": 147,
          "x": 325,
          "y": 40,
          "z": -132.25
        },
        {
          "hole": 148,
          "x": 325,
          "y": 40,
          "z": -140
        },
        {
          "hole": 149,
          "x": 325,
          "y": 40,
          "z": -147.75
        },
        {
          "hole": 150,
          "x": 325,
          "y": 40,
          "z": -155.5
        },
        {
          "hole": 151,
          "x": 325,
          "y": 40,
          "z": -164.5
        },
        {
          "hole": 152,
          "x": 325,
          "y": 40,
          "z": -172.25
        },
        {
          "hole": 153,
          "x": 325,
          "y": 40,
          "z": -180
        },
        {
          "hole": 154,
          "x": 325,
          "y": 40,
          "z": -187.75
        },
        {
          "hole": 155,
          "x": 325,
          "y": 40,
          "z": -195.5
        },
        {
          "hole": 156,
          "x": 325,
          "y": 40,
          "z": -204.5
        },
        {
          "hole": 157,
          "x": 325,
          "y": 40,
          "z": -212.25
        },
        {
          "hole": 158,
          "x": 325,
          "y": 40,
          "z": -220
        },
        {
          "hole": 159,
          "x": 325,
          "y": 40,
          "z": -227.75
        },
        {
          "hole": 160,
          "x": 325,
          "y": 40,
          "z": -235.5
        },
        {
          "hole": 161,
          "x": 325,
          "y": 40,
          "z": -245
        },
        {
          "hole": 162,
          "x": 325,
          "y": 40,
          "z": -262.5
        },
        {
          "hole": 163,
          "x": 325,
          "y": 40,
          "z": -285
        },
        {
          "hole": 164,
          "x": 302.5,
          "y": 40,
          "z": -285
        },
        {
          "hole": 165,
          "x": 285,
          "y": 40,
          "z": -285
        },
        {
          "hole": 166,
          "x": 275.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 167,
          "x": 267.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 168,
          "x": 260,
          "y": 50,
          "z": -285
        },
        {
          "hole": 169,
          "x": 252.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 170,
          "x": 244.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 171,
          "x": 235.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 172,
          "x": 227.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 173,
          "x": 220,
          "y": 50,
          "z": -285
        },
        {
          "hole": 174,
          "x": 212.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 175,
          "x": 204.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 176,
          "x": 195.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 177,
          "x": 187.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 178,
          "x": 180,
          "y": 50,
          "z": -285
        },
        {
          "hole": 179,
          "x": 172.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 180,
          "x": 164.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 181,
          "x": 155.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 182,
          "x": 147.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 183,
          "x": 140,
          "y": 50,
          "z": -285
        },
        {
          "hole": 184,
          "x": 132.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 185,
          "x": 124.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 186,
          "x": 115.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 187,
          "x": 107.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 188,
          "x": 100,
          "y": 50,
          "z": -285
        },
        {
          "hole": 189,
          "x": 92.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 190,
          "x": 84.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 191,
          "x": 75.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 192,
          "x": 67.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 193,
          "x": 60,
          "y": 50,
          "z": -285
        },
        {
          "hole": 194,
          "x": 52.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 195,
          "x": 44.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 196,
          "x": 35.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 197,
          "x": 27.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 198,
          "x": 20,
          "y": 50,
          "z": -285
        },
        {
          "hole": 199,
          "x": 12.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 200,
          "x": 4.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 201,
          "x": -4.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 202,
          "x": -12.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 203,
          "x": -20,
          "y": 50,
          "z": -285
        },
        {
          "hole": 204,
          "x": -27.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 205,
          "x": -35.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 206,
          "x": -44.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 207,
          "x": -52.25,
          "y": 50,
          "z": -285
        },
        {
          "hole": 208,
          "x": -60,
          "y": 50,
          "z": -285
        },
        {
          "hole": 209,
          "x": -67.75,
          "y": 50,
          "z": -285
        },
        {
          "hole": 210,
          "x": -75.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 211,
          "x": -85,
          "y": 50,
          "z": -285
        },
        {
          "hole": 212,
          "x": -102.5,
          "y": 50,
          "z": -285
        },
        {
          "hole": 213,
          "x": -125,
          "y": 50,
          "z": -285
        },
        {
          "hole": 214,
          "x": -125,
          "y": 50,
          "z": -262.5
        },
        {
          "hole": 215,
          "x": -125,
          "y": 50,
          "z": -245
        },
        {
          "hole": 216,
          "x": -125,
          "y": 60,
          "z": -235.5
        },
        {
          "hole": 217,
          "x": -125,
          "y": 60,
          "z": -227.75
        },
        {
          "hole": 218,
          "x": -125,
          "y": 60,
          "z": -220
        },
        {
          "hole": 219,
          "x": -125,
          "y": 60,
          "z": -212.25
        },
        {
          "hole": 220,
          "x": -125,
          "y": 60,
          "z": -204.5
        },
        {
          "hole": 221,
          "x": -125,
          "y": 60,
          "z": -195.5
        },
        {
          "hole": 222,
          "x": -125,
          "y": 60,
          "z": -187.75
        },
        {
          "hole": 223,
          "x": -125,
          "y": 60,
          "z": -180
        },
        {
          "hole": 224,
          "x": -125,
          "y": 60,
          "z": -172.25
        },
        {
          "hole": 225,
          "x": -125,
          "y": 60,
          "z": -164.5
        },
        {
          "hole": 226,
          "x": -125,
          "y": 60,
          "z": -155.5
        },
        {
          "hole": 227,
          "x": -125,
          "y": 60,
          "z": -147.75
        },
        {
          "hole": 228,
          "x": -125,
          "y": 60,
          "z": -140
        },
        {
          "hole": 229,
          "x": -125,
          "y": 60,
          "z": -132.25
        },
        {
          "hole": 230,
          "x": -125,
          "y": 60,
          "z": -124.5
        },
        {
          "hole": 231,
          "x": -125,
          "y": 60,
          "z": -115.5
        },
        {
          "hole": 232,
          "x": -125,
          "y": 60,
          "z": -107.75
        },
        {
          "hole": 233,
          "x": -125,
          "y": 60,
          "z": -100
        },
        {
          "hole": 234,
          "x": -125,
          "y": 60,
          "z": -92.25
        },
        {
          "hole": 235,
          "x": -125,
          "y": 60,
          "z": -84.5
        },
        {
          "hole": 236,
          "x": -125,
          "y": 60,
          "z": -75.5
        },
        {
          "hole": 237,
          "x": -125,
          "y": 60,
          "z": -67.75
        },
        {
          "hole": 238,
          "x": -125,
          "y": 60,
          "z": -60
        },
        {
          "hole": 239,
          "x": -125,
          "y": 60,
          "z": -52.25
        },
        {
          "hole": 240,
          "x": -125,
          "y": 60,
          "z": -44.5
        },
        {
          "hole": 241,
          "x": -125,
          "y": 60,
          "z": -35.5
        },
        {
          "hole": 242,
          "x": -125,
          "y": 60,
          "z": -27.75
        },
        {
          "hole": 243,
          "x": -125,
          "y": 60,
          "z": -20
        },
        {
          "hole": 244,
          "x": -125,
          "y": 60,
          "z": -12.25
        },
        {
          "hole": 245,
          "x": -125,
          "y": 60,
          "z": -4.5
        },
        {
          "hole": 246,
          "x": -125,
          "y": 60,
          "z": 4.5
        },
        {
          "hole": 247,
          "x": -125,
          "y": 60,
          "z": 12.25
        },
        {
          "hole": 248,
          "x": -125,
          "y": 60,
          "z": 20
        },
        {
          "hole": 249,
          "x": -125,
          "y": 60,
          "z": 27.75
        },
        {
          "hole": 250,
          "x": -125,
          "y": 60,
          "z": 35.5
        },
        {
          "hole": 251,
          "x": -125,
          "y": 60,
          "z": 44.5
        },
        {
          "hole": 252,
          "x": -125,
          "y": 60,
          "z": 52.25
        },
        {
          "hole": 253,
          "x": -125,
          "y": 60,
          "z": 60
        },
        {
          "hole": 254,
          "x": -125,
          "y": 60,
          "z": 67.75
        },
        {
          "hole": 255,
          "x": -125,
          "y": 60,
          "z": 75.5
        },
        {
          "hole": 256,
          "x": -125,
          "y": 60,
          "z": 84.5
        },
        {
          "hole": 257,
          "x": -125,
          "y": 60,
          "z": 92.25
        },
        {
          "hole": 258,
          "x": -125,
          "y": 60,
          "z": 100
        },
        {
          "hole": 259,
          "x": -125,
          "y": 60,
          "z": 107.75
        },
        {
          "hole": 260,
          "x": -125,
          "y": 60,
          "z": 115.5
        },
        {
          "hole": 261,
          "x": -125,
          "y": 60,
          "z": 125
        },
        {
          "hole": 262,
          "x": -125,
          "y": 60,
          "z": 132.5
        },
        {
          "hole": 263,
          "x": -125,
          "y": 60,
          "z": 145
        },
        {
          "hole": 264,
          "x": -112.5,
          "y": 60,
          "z": 145
        },
        {
          "hole": 265,
          "x": -105,
          "y": 60,
          "z": 145
        },
        {
          "hole": 266,
          "x": -95.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 267,
          "x": -87.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 268,
          "x": -80,
          "y": 70,
          "z": 145
        },
        {
          "hole": 269,
          "x": -72.25,
          "y": 70,
          "z": 145
        },
        {
          "hole": 270,
          "x": -64.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 271,
          "x": -55.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 272,
          "x": -47.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 273,
          "x": -40,
          "y": 70,
          "z": 145
        },
        {
          "hole": 274,
          "x": -32.25,
          "y": 70,
          "z": 145
        },
        {
          "hole": 275,
          "x": -24.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 276,
          "x": -15.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 277,
          "x": -7.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 278,
          "x": 0,
          "y": 70,
          "z": 145
        },
        {
          "hole": 279,
          "x": 7.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 280,
          "x": 15.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 281,
          "x": 24.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 282,
          "x": 32.25,
          "y": 70,
          "z": 145
        },
        {
          "hole": 283,
          "x": 40,
          "y": 70,
          "z": 145
        },
        {
          "hole": 284,
          "x": 47.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 285,
          "x": 55.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 286,
          "x": 64.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 287,
          "x": 72.25,
          "y": 70,
          "z": 145
        },
        {
          "hole": 288,
          "x": 80,
          "y": 70,
          "z": 145
        },
        {
          "hole": 289,
          "x": 87.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 290,
          "x": 95.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 291,
          "x": 104.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 292,
          "x": 112.25,
          "y": 70,
          "z": 145
        },
        {
          "hole": 293,
          "x": 120,
          "y": 70,
          "z": 145
        },
        {
          "hole": 294,
          "x": 127.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 295,
          "x": 135.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 296,
          "x": 144.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 297,
          "x": 152.25,
          "y": 70,
          "z": 145
        },
        {
          "hole": 298,
          "x": 160,
          "y": 70,
          "z": 145
        },
        {
          "hole": 299,
          "x": 167.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 300,
          "x": 175.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 301,
          "x": 184.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 302,
          "x": 192.25,
          "y": 70,
          "z": 145
        },
        {
          "hole": 303,
          "x": 200,
          "y": 70,
          "z": 145
        },
        {
          "hole": 304,
          "x": 207.75,
          "y": 70,
          "z": 145
        },
        {
          "hole": 305,
          "x": 215.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 306,
          "x": 225,
          "y": 70,
          "z": 145
        },
        {
          "hole": 307,
          "x": 232.5,
          "y": 70,
          "z": 145
        },
        {
          "hole": 308,
          "x": 245,
          "y": 70,
          "z": 145
        },
        {
          "hole": 309,
          "x": 245,
          "y": 70,
          "z": 132.5
        },
        {
          "hole": 310,
          "x": 245,
          "y": 70,
          "z": 125
        },
        {
          "hole": 311,
          "x": 245,
          "y": 80,
          "z": 115.5
        },
        {
          "hole": 312,
          "x": 245,
          "y": 80,
          "z": 107.75
        },
        {
          "hole": 313,
          "x": 245,
          "y": 80,
          "z": 100
        },
        {
          "hole": 314,
          "x": 245,
          "y": 80,
          "z": 92.25
        },
        {
          "hole": 315,
          "x": 245,
          "y": 80,
          "z": 84.5
        },
        {
          "hole": 316,
          "x": 245,
          "y": 80,
          "z": 75.5
        },
        {
          "hole": 317,
          "x": 245,
          "y": 80,
          "z": 67.75
        },
        {
          "hole": 318,
          "x": 245,
          "y": 80,
          "z": 60
        },
        {
          "hole": 319,
          "x": 245,
          "y": 80,
          "z": 52.25
        },
        {
          "hole": 320,
          "x": 245,
          "y": 80,
          "z": 44.5
        },
        {
          "hole": 321,
          "x": 245,
          "y": 80,
          "z": 35.5
        },
        {
          "hole": 322,
          "x": 245,
          "y": 80,
          "z": 27.75
        },
        {
          "hole": 323,
          "x": 245,
          "y": 80,
          "z": 20
        },
        {
          "hole": 324,
          "x": 245,
          "y": 80,
          "z": 12.25
        },
        {
          "hole": 325,
          "x": 245,
          "y": 80,
          "z": 4.5
        },
        {
          "hole": 326,
          "x": 245,
          "y": 80,
          "z": -4.5
        },
        {
          "hole": 327,
          "x": 245,
          "y": 80,
          "z": -12.25
        },
        {
          "hole": 328,
          "x": 245,
          "y": 80,
          "z": -20
        },
        {
          "hole": 329,
          "x": 245,
          "y": 80,
          "z": -27.75
        },
        {
          "hole": 330,
          "x": 245,
          "y": 80,
          "z": -35.5
        },
        {
          "hole": 331,
          "x": 245,
          "y": 80,
          "z": -44.5
        },
        {
          "hole": 332,
          "x": 245,
          "y": 80,
          "z": -52.25
        },
        {
          "hole": 333,
          "x": 245,
          "y": 80,
          "z": -60
        },
        {
          "hole": 334,
          "x": 245,
          "y": 80,
          "z": -67.75
        },
        {
          "hole": 335,
          "x": 245,
          "y": 80,
          "z": -75.5
        },
        {
          "hole": 336,
          "x": 245,
          "y": 80,
          "z": -84.5
        },
        {
          "hole": 337,
          "x": 245,
          "y": 80,
          "z": -92.25
        },
        {
          "hole": 338,
          "x": 245,
          "y": 80,
          "z": -100
        },
        {
          "hole": 339,
          "x": 245,
          "y": 80,
          "z": -107.75
        },
        {
          "hole": 340,
          "x": 245,
          "y": 80,
          "z": -115.5
        },
        {
          "hole": 341,
          "x": 245,
          "y": 80,
          "z": -124.5
        },
        {
          "hole": 342,
          "x": 245,
          "y": 80,
          "z": -132.25
        },
        {
          "hole": 343,
          "x": 245,
          "y": 80,
          "z": -140
        },
        {
          "hole": 344,
          "x": 245,
          "y": 80,
          "z": -147.75
        },
        {
          "hole": 345,
          "x": 245,
          "y": 80,
          "z": -155.5
        },
        {
          "hole": 346,
          "x": 245,
          "y": 80,
          "z": -165
        },
        {
          "hole": 347,
          "x": 245,
          "y": 80,
          "z": -182.5
        },
        {
          "hole": 348,
          "x": 245,
          "y": 80,
          "z": -205
        },
        {
          "hole": 349,
          "x": 222.5,
          "y": 80,
          "z": -205
        },
        {
          "hole": 350,
          "x": 205,
          "y": 80,
          "z": -205
        },
        {
          "hole": 351,
          "x": 195.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 352,
          "x": 187.75,
          "y": 90,
          "z": -205
        },
        {
          "hole": 353,
          "x": 180,
          "y": 90,
          "z": -205
        },
        {
          "hole": 354,
          "x": 172.25,
          "y": 90,
          "z": -205
        },
        {
          "hole": 355,
          "x": 164.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 356,
          "x": 155.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 357,
          "x": 147.75,
          "y": 90,
          "z": -205
        },
        {
          "hole": 358,
          "x": 140,
          "y": 90,
          "z": -205
        },
        {
          "hole": 359,
          "x": 132.25,
          "y": 90,
          "z": -205
        },
        {
          "hole": 360,
          "x": 124.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 361,
          "x": 115.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 362,
          "x": 107.75,
          "y": 90,
          "z": -205
        },
        {
          "hole": 363,
          "x": 100,
          "y": 90,
          "z": -205
        },
        {
          "hole": 364,
          "x": 92.25,
          "y": 90,
          "z": -205
        },
        {
          "hole": 365,
          "x": 84.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 366,
          "x": 75.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 367,
          "x": 67.75,
          "y": 90,
          "z": -205
        },
        {
          "hole": 368,
          "x": 60,
          "y": 90,
          "z": -205
        },
        {
          "hole": 369,
          "x": 52.25,
          "y": 90,
          "z": -205
        },
        {
          "hole": 370,
          "x": 44.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 371,
          "x": 35.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 372,
          "x": 27.75,
          "y": 90,
          "z": -205
        },
        {
          "hole": 373,
          "x": 20,
          "y": 90,
          "z": -205
        },
        {
          "hole": 374,
          "x": 12.25,
          "y": 90,
          "z": -205
        },
        {
          "hole": 375,
          "x": 4.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 376,
          "x": -5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 377,
          "x": -22.5,
          "y": 90,
          "z": -205
        },
        {
          "hole": 378,
          "x": -45,
          "y": 90,
          "z": -205
        },
        {
          "hole": 379,
          "x": -45,
          "y": 90,
          "z": -182.5
        },
        {
          "hole": 380,
          "x": -45,
          "y": 90,
          "z": -165
        },
        {
          "hole": 381,
          "x": -45,
          "y": 100,
          "z": -155.5
        },
        {
          "hole": 382,
          "x": -45,
          "y": 100,
          "z": -147.75
        },
        {
          "hole": 383,
          "x": -45,
          "y": 100,
          "z": -140
        },
        {
          "hole": 384,
          "x": -45,
          "y": 100,
          "z": -132.25
        },
        {
          "hole": 385,
          "x": -45,
          "y": 100,
          "z": -124.5
        },
        {
          "hole": 386,
          "x": -45,
          "y": 100,
          "z": -115.5
        },
        {
          "hole": 387,
          "x": -45,
          "y": 100,
          "z": -107.75
        },
        {
          "hole": 388,
          "x": -45,
          "y": 100,
          "z": -100
        },
        {
          "hole": 389,
          "x": -45,
          "y": 100,
          "z": -92.25
        },
        {
          "hole": 390,
          "x": -45,
          "y": 100,
          "z": -84.5
        },
        {
          "hole": 391,
          "x": -45,
          "y": 100,
          "z": -75.5
        },
        {
          "hole": 392,
          "x": -45,
          "y": 100,
          "z": -67.75
        },
        {
          "hole": 393,
          "x": -45,
          "y": 100,
          "z": -60
        },
        {
          "hole": 394,
          "x": -45,
          "y": 100,
          "z": -52.25
        },
        {
          "hole": 395,
          "x": -45,
          "y": 100,
          "z": -44.5
        },
        {
          "hole": 396,
          "x": -45,
          "y": 100,
          "z": -35.5
        },
        {
          "hole": 397,
          "x": -45,
          "y": 100,
          "z": -27.75
        },
        {
          "hole": 398,
          "x": -45,
          "y": 100,
          "z": -20
        },
        {
          "hole": 399,
          "x": -45,
          "y": 100,
          "z": -12.25
        },
        {
          "hole": 400,
          "x": -45,
          "y": 100,
          "z": -4.5
        },
        {
          "hole": 401,
          "x": -45,
          "y": 100,
          "z": 4.5
        },
        {
          "hole": 402,
          "x": -45,
          "y": 100,
          "z": 12.25
        },
        {
          "hole": 403,
          "x": -45,
          "y": 100,
          "z": 20
        },
        {
          "hole": 404,
          "x": -45,
          "y": 100,
          "z": 27.75
        },
        {
          "hole": 405,
          "x": -45,
          "y": 100,
          "z": 35.5
        },
        {
          "hole": 406,
          "x": -45,
          "y": 100,
          "z": 45
        },
        {
          "hole": 407,
          "x": -45,
          "y": 100,
          "z": 52.5
        },
        {
          "hole": 408,
          "x": -45,
          "y": 100,
          "z": 65
        },
        {
          "hole": 409,
          "x": -32.5,
          "y": 100,
          "z": 65
        },
        {
          "hole": 410,
          "x": -25,
          "y": 100,
          "z": 65
        },
        {
          "hole": 411,
          "x": -15.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 412,
          "x": -7.75,
          "y": 110,
          "z": 65
        },
        {
          "hole": 413,
          "x": 0,
          "y": 110,
          "z": 65
        },
        {
          "hole": 414,
          "x": 7.75,
          "y": 110,
          "z": 65
        },
        {
          "hole": 415,
          "x": 15.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 416,
          "x": 24.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 417,
          "x": 32.25,
          "y": 110,
          "z": 65
        },
        {
          "hole": 418,
          "x": 40,
          "y": 110,
          "z": 65
        },
        {
          "hole": 419,
          "x": 47.75,
          "y": 110,
          "z": 65
        },
        {
          "hole": 420,
          "x": 55.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 421,
          "x": 64.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 422,
          "x": 72.25,
          "y": 110,
          "z": 65
        },
        {
          "hole": 423,
          "x": 80,
          "y": 110,
          "z": 65
        },
        {
          "hole": 424,
          "x": 87.75,
          "y": 110,
          "z": 65
        },
        {
          "hole": 425,
          "x": 95.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 426,
          "x": 104.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 427,
          "x": 112.25,
          "y": 110,
          "z": 65
        },
        {
          "hole": 428,
          "x": 120,
          "y": 110,
          "z": 65
        },
        {
          "hole": 429,
          "x": 127.75,
          "y": 110,
          "z": 65
        },
        {
          "hole": 430,
          "x": 135.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 431,
          "x": 145,
          "y": 110,
          "z": 65
        },
        {
          "hole": 432,
          "x": 152.5,
          "y": 110,
          "z": 65
        },
        {
          "hole": 433,
          "x": 165,
          "y": 110,
          "z": 65
        },
        {
          "hole": 434,
          "x": 165,
          "y": 110,
          "z": 52.5
        },
        {
          "hole": 435,
          "x": 165,
          "y": 110,
          "z": 45
        },
        {
          "hole": 436,
          "x": 165,
          "y": 120,
          "z": 35.5
        },
        {
          "hole": 437,
          "x": 165,
          "y": 120,
          "z": 27.75
        },
        {
          "hole": 438,
          "x": 165,
          "y": 120,
          "z": 20
        },
        {
          "hole": 439,
          "x": 165,
          "y": 120,
          "z": 12.25
        },
        {
          "hole": 440,
          "x": 165,
          "y": 120,
          "z": 4.5
        },
        {
          "hole": 441,
          "x": 165,
          "y": 120,
          "z": -4.5
        },
        {
          "hole": 442,
          "x": 165,
          "y": 120,
          "z": -12.25
        },
        {
          "hole": 443,
          "x": 165,
          "y": 120,
          "z": -20
        },
        {
          "hole": 444,
          "x": 165,
          "y": 120,
          "z": -27.75
        },
        {
          "hole": 445,
          "x": 165,
          "y": 120,
          "z": -35.5
        },
        {
          "hole": 446,
          "x": 165,
          "y": 120,
          "z": -44.5
        },
        {
          "hole": 447,
          "x": 165,
          "y": 120,
          "z": -52.25
        },
        {
          "hole": 448,
          "x": 165,
          "y": 120,
          "z": -60
        },
        {
          "hole": 449,
          "x": 165,
          "y": 120,
          "z": -67.75
        },
        {
          "hole": 450,
          "x": 165,
          "y": 120,
          "z": -75.5
        },
        {
          "hole": 451,
          "x": 165,
          "y": 120,
          "z": -85
        },
        {
          "hole": 452,
          "x": 165,
          "y": 120,
          "z": -102.5
        },
        {
          "hole": 453,
          "x": 165,
          "y": 120,
          "z": -125
        },
        {
          "hole": 454,
          "x": 142.5,
          "y": 120,
          "z": -125
        },
        {
          "hole": 455,
          "x": 125,
          "y": 120,
          "z": -125
        },
        {
          "hole": 456,
          "x": 115.5,
          "y": 130,
          "z": -125
        },
        {
          "hole": 457,
          "x": 107.75,
          "y": 130,
          "z": -125
        },
        {
          "hole": 458,
          "x": 100,
          "y": 130,
          "z": -125
        },
        {
          "hole": 459,
          "x": 92.25,
          "y": 130,
          "z": -125
        },
        {
          "hole": 460,
          "x": 84.5,
          "y": 130,
          "z": -125
        },
        {
          "hole": 461,
          "x": 75,
          "y": 130,
          "z": -125
        },
        {
          "hole": 462,
          "x": 57.5,
          "y": 130,
          "z": -125
        },
        {
          "hole": 463,
          "x": 35,
          "y": 130,
          "z": -125
        },
        {
          "hole": 464,
          "x": 35,
          "y": 130,
          "z": -102.5
        },
        {
          "hole": 465,
          "x": 35,
          "y": 130,
          "z": -85
        },
        {
          "hole": 466,
          "x": 35,
          "y": 140,
          "z": -75.5
        },
        {
          "hole": 467,
          "x": 35,
          "y": 140,
          "z": -67.75
        },
        {
          "hole": 468,
          "x": 35,
          "y": 140,
          "z": -60
        },
        {
          "hole": 469,
          "x": 35,
          "y": 140,
          "z": -52.25
        },
        {
          "hole": 470,
          "x": 35,
          "y": 140,
          "z": -44.5
        },
        {
          "hole": 471,
          "x": 35,
          "y": 140,
          "z": -35
        },
        {
          "hole": 472,
          "x": 35,
          "y": 140,
          "z": -27.5
        },
        {
          "hole": 473,
          "x": 35,
          "y": 140,
          "z": -15
        },
        {
          "hole": 474,
          "x": 47.5,
          "y": 140,
          "z": -15
        },
        {
          "hole": 475,
          "x": 55,
          "y": 140,
          "z": -15
        },
        {
          "hole": 476,
          "x": 65,
          "y": 150,
          "z": -15
        },
        {
          "hole": 477,
          "x": 72.5,
          "y": 150,
          "z": -15
        },
        {
          "hole": 478,
          "x": 85,
          "y": 150,
          "z": -15
        },
        {
          "hole": 479,
          "x": 85,
          "y": 150,
          "z": -27.5
        },
        {
          "hole": 480,
          "x": 85,
          "y": 150,
          "z": -35
        },
        {
          "hole": 121,
          "x": 100,
          "y": 160,
          "z": -60
        }
      ]
    }
  },
  {
    "id": "board-cribbage-clash-spiral",
    "name": "Cribbage Clash Spiral",
    "brand": "clash",
    "desc": "Cribbage Clash Spiral 3D cribbage board (20.3 MB)",
    "target": 481,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/spiral_-_no_gap_-_height_-_colored_-_thumbnail.png?v=",
    "modelUrl": "https://cdn.shopify.com/3d/models/2a5c3782f2524344/cibbage_clash_-_spiral_-_no_gap_-_height_-_colored.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": -229.4967,
          "y": 10,
          "z": 122.5
        },
        {
          "hole": 1,
          "x": 53.1259,
          "y": 230,
          "z": 14.235
        },
        {
          "hole": 2,
          "x": 47.6314,
          "y": 230,
          "z": 27.5
        },
        {
          "hole": 3,
          "x": 38.8909,
          "y": 230,
          "z": 38.8909
        },
        {
          "hole": 4,
          "x": 27.5,
          "y": 230,
          "z": 47.6314
        },
        {
          "hole": 5,
          "x": 14.235,
          "y": 230,
          "z": 53.1259
        },
        {
          "hole": 6,
          "x": -16.8232,
          "y": 220,
          "z": 52.7852
        },
        {
          "hole": 7,
          "x": -32.5,
          "y": 220,
          "z": 46.2917
        },
        {
          "hole": 8,
          "x": -45.9619,
          "y": 220,
          "z": 35.9619
        },
        {
          "hole": 9,
          "x": -56.2917,
          "y": 220,
          "z": 22.5
        },
        {
          "hole": 10,
          "x": -62.7852,
          "y": 220,
          "z": 6.8232
        },
        {
          "hole": 11,
          "x": -62.4444,
          "y": 210,
          "z": -29.4114
        },
        {
          "hole": 12,
          "x": -54.9519,
          "y": 210,
          "z": -47.5
        },
        {
          "hole": 13,
          "x": -43.033,
          "y": 210,
          "z": -63.033
        },
        {
          "hole": 14,
          "x": -27.5,
          "y": 210,
          "z": -74.9519
        },
        {
          "hole": 15,
          "x": -9.4114,
          "y": 210,
          "z": -82.4444
        },
        {
          "hole": 16,
          "x": 31.9996,
          "y": 200,
          "z": -82.1037
        },
        {
          "hole": 17,
          "x": 52.5,
          "y": 200,
          "z": -73.6122
        },
        {
          "hole": 18,
          "x": 70.1041,
          "y": 200,
          "z": -60.1041
        },
        {
          "hole": 19,
          "x": 83.6122,
          "y": 200,
          "z": -42.5
        },
        {
          "hole": 20,
          "x": 92.1037,
          "y": 200,
          "z": -21.9996
        },
        {
          "hole": 21,
          "x": 94.1873,
          "y": 190,
          "z": 12.4
        },
        {
          "hole": 22,
          "x": 91.763,
          "y": 190,
          "z": 24.5878
        },
        {
          "hole": 23,
          "x": 87.7686,
          "y": 190,
          "z": 36.3549
        },
        {
          "hole": 24,
          "x": 82.2724,
          "y": 190,
          "z": 47.5
        },
        {
          "hole": 25,
          "x": 75.3686,
          "y": 190,
          "z": 57.8323
        },
        {
          "hole": 26,
          "x": 57.8323,
          "y": 190,
          "z": 75.3685
        },
        {
          "hole": 27,
          "x": 47.5,
          "y": 190,
          "z": 82.2724
        },
        {
          "hole": 28,
          "x": 36.3549,
          "y": 190,
          "z": 87.7685
        },
        {
          "hole": 29,
          "x": 24.5878,
          "y": 190,
          "z": 91.7629
        },
        {
          "hole": 30,
          "x": 12.4,
          "y": 190,
          "z": 94.1872
        },
        {
          "hole": 31,
          "x": -13.7053,
          "y": 180,
          "z": 94.1017
        },
        {
          "hole": 32,
          "x": -27.176,
          "y": 180,
          "z": 91.4222
        },
        {
          "hole": 33,
          "x": -40.1818,
          "y": 180,
          "z": 87.0073
        },
        {
          "hole": 34,
          "x": -52.5,
          "y": 180,
          "z": 80.9327
        },
        {
          "hole": 35,
          "x": -63.92,
          "y": 180,
          "z": 73.3021
        },
        {
          "hole": 36,
          "x": -83.3021,
          "y": 180,
          "z": 53.9199
        },
        {
          "hole": 37,
          "x": -90.9327,
          "y": 180,
          "z": 42.5
        },
        {
          "hole": 38,
          "x": -97.0073,
          "y": 180,
          "z": 30.1818
        },
        {
          "hole": 39,
          "x": -101.4222,
          "y": 180,
          "z": 17.176
        },
        {
          "hole": 40,
          "x": -104.1017,
          "y": 180,
          "z": 3.7053
        },
        {
          "hole": 41,
          "x": -104.0162,
          "y": 170,
          "z": -25.0105
        },
        {
          "hole": 42,
          "x": -101.0815,
          "y": 170,
          "z": -39.7642
        },
        {
          "hole": 43,
          "x": -96.2461,
          "y": 170,
          "z": -54.0086
        },
        {
          "hole": 44,
          "x": -89.5929,
          "y": 170,
          "z": -67.5
        },
        {
          "hole": 45,
          "x": -81.2356,
          "y": 170,
          "z": -80.0076
        },
        {
          "hole": 46,
          "x": -60.0076,
          "y": 170,
          "z": -101.2356
        },
        {
          "hole": 47,
          "x": -47.5,
          "y": 170,
          "z": -109.5929
        },
        {
          "hole": 48,
          "x": -34.0086,
          "y": 170,
          "z": -116.2461
        },
        {
          "hole": 49,
          "x": -19.7642,
          "y": 170,
          "z": -121.0815
        },
        {
          "hole": 50,
          "x": -5.0105,
          "y": 170,
          "z": -124.0162
        },
        {
          "hole": 51,
          "x": 26.3158,
          "y": 160,
          "z": -123.9306
        },
        {
          "hole": 52,
          "x": 42.3524,
          "y": 160,
          "z": -120.7407
        },
        {
          "hole": 53,
          "x": 57.8354,
          "y": 160,
          "z": -115.4849
        },
        {
          "hole": 54,
          "x": 72.5,
          "y": 160,
          "z": -108.2532
        },
        {
          "hole": 55,
          "x": 86.0952,
          "y": 160,
          "z": -99.1692
        },
        {
          "hole": 56,
          "x": 109.1692,
          "y": 160,
          "z": -76.0952
        },
        {
          "hole": 57,
          "x": 118.2532,
          "y": 160,
          "z": -62.5
        },
        {
          "hole": 58,
          "x": 125.4849,
          "y": 160,
          "z": -47.8354
        },
        {
          "hole": 59,
          "x": 130.7407,
          "y": 160,
          "z": -32.3524
        },
        {
          "hole": 60,
          "x": 133.9306,
          "y": 160,
          "z": -16.3158
        },
        {
          "hole": 61,
          "x": 134.7109,
          "y": 150,
          "z": 8.8294
        },
        {
          "hole": 62,
          "x": 133.845,
          "y": 150,
          "z": 17.621
        },
        {
          "hole": 63,
          "x": 132.406,
          "y": 150,
          "z": 26.3372
        },
        {
          "hole": 64,
          "x": 130.4,
          "y": 150,
          "z": 34.9406
        },
        {
          "hole": 65,
          "x": 127.8356,
          "y": 150,
          "z": 43.3943
        },
        {
          "hole": 66,
          "x": 121.0778,
          "y": 150,
          "z": 59.709
        },
        {
          "hole": 67,
          "x": 116.9134,
          "y": 150,
          "z": 67.5
        },
        {
          "hole": 68,
          "x": 112.2484,
          "y": 150,
          "z": 75.002
        },
        {
          "hole": 69,
          "x": 107.1027,
          "y": 150,
          "z": 82.1828
        },
        {
          "hole": 70,
          "x": 101.4984,
          "y": 150,
          "z": 89.0117
        },
        {
          "hole": 71,
          "x": 89.0117,
          "y": 150,
          "z": 101.4984
        },
        {
          "hole": 72,
          "x": 82.1828,
          "y": 150,
          "z": 107.1027
        },
        {
          "hole": 73,
          "x": 75.002,
          "y": 150,
          "z": 112.2484
        },
        {
          "hole": 74,
          "x": 67.5,
          "y": 150,
          "z": 116.9134
        },
        {
          "hole": 75,
          "x": 59.709,
          "y": 150,
          "z": 121.0778
        },
        {
          "hole": 76,
          "x": 43.3943,
          "y": 150,
          "z": 127.8356
        },
        {
          "hole": 77,
          "x": 34.9406,
          "y": 150,
          "z": 130.4
        },
        {
          "hole": 78,
          "x": 26.3372,
          "y": 150,
          "z": 132.406
        },
        {
          "hole": 79,
          "x": 17.621,
          "y": 150,
          "z": 133.845
        },
        {
          "hole": 80,
          "x": 8.8294,
          "y": 150,
          "z": 134.7109
        },
        {
          "hole": 81,
          "x": -9.4835,
          "y": 140,
          "z": 134.6895
        },
        {
          "hole": 82,
          "x": -18.9263,
          "y": 140,
          "z": 133.7595
        },
        {
          "hole": 83,
          "x": -28.2881,
          "y": 140,
          "z": 132.2139
        },
        {
          "hole": 84,
          "x": -37.5288,
          "y": 140,
          "z": 130.0592
        },
        {
          "hole": 85,
          "x": -46.6087,
          "y": 140,
          "z": 127.3049
        },
        {
          "hole": 86,
          "x": -64.1318,
          "y": 140,
          "z": 120.0465
        },
        {
          "hole": 87,
          "x": -72.5,
          "y": 140,
          "z": 115.5737
        },
        {
          "hole": 88,
          "x": -80.5577,
          "y": 140,
          "z": 110.5631
        },
        {
          "hole": 89,
          "x": -88.2704,
          "y": 140,
          "z": 105.0362
        },
        {
          "hole": 90,
          "x": -95.6051,
          "y": 140,
          "z": 99.0168
        },
        {
          "hole": 91,
          "x": -109.0168,
          "y": 140,
          "z": 85.6051
        },
        {
          "hole": 92,
          "x": -115.0362,
          "y": 140,
          "z": 78.2704
        },
        {
          "hole": 93,
          "x": -120.5631,
          "y": 140,
          "z": 70.5577
        },
        {
          "hole": 94,
          "x": -125.5737,
          "y": 140,
          "z": 62.5
        },
        {
          "hole": 95,
          "x": -130.0466,
          "y": 140,
          "z": 54.1319
        },
        {
          "hole": 96,
          "x": -137.3049,
          "y": 140,
          "z": 36.6087
        },
        {
          "hole": 97,
          "x": -140.0592,
          "y": 140,
          "z": 27.5288
        },
        {
          "hole": 98,
          "x": -142.2139,
          "y": 140,
          "z": 18.2881
        },
        {
          "hole": 99,
          "x": -143.7595,
          "y": 140,
          "z": 8.9263
        },
        {
          "hole": 100,
          "x": -144.6895,
          "y": 140,
          "z": -0.5165
        },
        {
          "hole": 101,
          "x": -144.6681,
          "y": 130,
          "z": -20.1375
        },
        {
          "hole": 102,
          "x": -143.6739,
          "y": 130,
          "z": -30.2316
        },
        {
          "hole": 103,
          "x": -142.0217,
          "y": 130,
          "z": -40.239
        },
        {
          "hole": 104,
          "x": -139.7185,
          "y": 130,
          "z": -50.117
        },
        {
          "hole": 105,
          "x": -136.7742,
          "y": 130,
          "z": -59.8231
        },
        {
          "hole": 106,
          "x": -129.0153,
          "y": 130,
          "z": -78.5547
        },
        {
          "hole": 107,
          "x": -124.2339,
          "y": 130,
          "z": -87.5
        },
        {
          "hole": 108,
          "x": -118.8778,
          "y": 130,
          "z": -96.1134
        },
        {
          "hole": 109,
          "x": -112.9698,
          "y": 130,
          "z": -104.358
        },
        {
          "hole": 110,
          "x": -106.5352,
          "y": 130,
          "z": -112.1986
        },
        {
          "hole": 111,
          "x": -92.1986,
          "y": 130,
          "z": -126.5352
        },
        {
          "hole": 112,
          "x": -84.358,
          "y": 130,
          "z": -132.9698
        },
        {
          "hole": 113,
          "x": -76.1134,
          "y": 130,
          "z": -138.8778
        },
        {
          "hole": 114,
          "x": -67.5,
          "y": 130,
          "z": -144.2339
        },
        {
          "hole": 115,
          "x": -58.5547,
          "y": 130,
          "z": -149.0153
        },
        {
          "hole": 116,
          "x": -39.8231,
          "y": 130,
          "z": -156.7742
        },
        {
          "hole": 117,
          "x": -30.1169,
          "y": 130,
          "z": -159.7185
        },
        {
          "hole": 118,
          "x": -20.239,
          "y": 130,
          "z": -162.0217
        },
        {
          "hole": 119,
          "x": -10.2315,
          "y": 130,
          "z": -163.6739
        },
        {
          "hole": 120,
          "x": -0.1375,
          "y": 130,
          "z": -164.6681
        },
        {
          "hole": 121,
          "x": 20.7915,
          "y": 120,
          "z": -164.6467
        },
        {
          "hole": 122,
          "x": 31.5368,
          "y": 120,
          "z": -163.5884
        },
        {
          "hole": 123,
          "x": 42.1899,
          "y": 120,
          "z": -161.8296
        },
        {
          "hole": 124,
          "x": 52.7051,
          "y": 120,
          "z": -159.3778
        },
        {
          "hole": 125,
          "x": 63.0375,
          "y": 120,
          "z": -156.2435
        },
        {
          "hole": 126,
          "x": 82.9776,
          "y": 120,
          "z": -147.984
        },
        {
          "hole": 127,
          "x": 92.5,
          "y": 120,
          "z": -142.8942
        },
        {
          "hole": 128,
          "x": 101.6691,
          "y": 120,
          "z": -137.1925
        },
        {
          "hole": 129,
          "x": 110.4456,
          "y": 120,
          "z": -130.9033
        },
        {
          "hole": 130,
          "x": 118.7921,
          "y": 120,
          "z": -124.0536
        },
        {
          "hole": 131,
          "x": 134.0536,
          "y": 120,
          "z": -108.7921
        },
        {
          "hole": 132,
          "x": 140.9033,
          "y": 120,
          "z": -100.4456
        },
        {
          "hole": 133,
          "x": 147.1925,
          "y": 120,
          "z": -91.6691
        },
        {
          "hole": 134,
          "x": 152.8942,
          "y": 120,
          "z": -82.5
        },
        {
          "hole": 135,
          "x": 157.984,
          "y": 120,
          "z": -72.9776
        },
        {
          "hole": 136,
          "x": 166.2435,
          "y": 120,
          "z": -53.0375
        },
        {
          "hole": 137,
          "x": 169.3778,
          "y": 120,
          "z": -42.7051
        },
        {
          "hole": 138,
          "x": 171.8296,
          "y": 120,
          "z": -32.1899
        },
        {
          "hole": 139,
          "x": 173.5884,
          "y": 120,
          "z": -21.5368
        },
        {
          "hole": 140,
          "x": 174.6467,
          "y": 120,
          "z": -10.7915
        },
        {
          "hole": 141,
          "x": 174.8334,
          "y": 110,
          "z": 7.6334
        },
        {
          "hole": 142,
          "x": 174.3341,
          "y": 110,
          "z": 15.2523
        },
        {
          "hole": 143,
          "x": 173.5029,
          "y": 110,
          "z": 22.8421
        },
        {
          "hole": 144,
          "x": 172.3414,
          "y": 110,
          "z": 30.3884
        },
        {
          "hole": 145,
          "x": 170.8518,
          "y": 110,
          "z": 37.8769
        },
        {
          "hole": 146,
          "x": 166.9005,
          "y": 110,
          "z": 52.6235
        },
        {
          "hole": 147,
          "x": 164.4462,
          "y": 110,
          "z": 59.8535
        },
        {
          "hole": 148,
          "x": 161.6789,
          "y": 110,
          "z": 66.9696
        },
        {
          "hole": 149,
          "x": 158.6039,
          "y": 110,
          "z": 73.9582
        },
        {
          "hole": 150,
          "x": 155.2269,
          "y": 110,
          "z": 80.806
        },
        {
          "hole": 151,
          "x": 147.5935,
          "y": 110,
          "z": 94.0274
        },
        {
          "hole": 152,
          "x": 143.3516,
          "y": 110,
          "z": 100.3759
        },
        {
          "hole": 153,
          "x": 138.8368,
          "y": 110,
          "z": 106.5333
        },
        {
          "hole": 154,
          "x": 134.0578,
          "y": 110,
          "z": 112.4878
        },
        {
          "hole": 155,
          "x": 129.0235,
          "y": 110,
          "z": 118.2283
        },
        {
          "hole": 156,
          "x": 118.2283,
          "y": 110,
          "z": 129.0235
        },
        {
          "hole": 157,
          "x": 112.4878,
          "y": 110,
          "z": 134.0578
        },
        {
          "hole": 158,
          "x": 106.5333,
          "y": 110,
          "z": 138.8368
        },
        {
          "hole": 159,
          "x": 100.3759,
          "y": 110,
          "z": 143.3516
        },
        {
          "hole": 160,
          "x": 94.0274,
          "y": 110,
          "z": 147.5935
        },
        {
          "hole": 161,
          "x": 80.806,
          "y": 110,
          "z": 155.2269
        },
        {
          "hole": 162,
          "x": 73.9582,
          "y": 110,
          "z": 158.6039
        },
        {
          "hole": 163,
          "x": 66.9696,
          "y": 110,
          "z": 161.6789
        },
        {
          "hole": 164,
          "x": 59.8535,
          "y": 110,
          "z": 164.4462
        },
        {
          "hole": 165,
          "x": 52.6235,
          "y": 110,
          "z": 166.9005
        },
        {
          "hole": 166,
          "x": 37.8769,
          "y": 110,
          "z": 170.8518
        },
        {
          "hole": 167,
          "x": 30.3884,
          "y": 110,
          "z": 172.3414
        },
        {
          "hole": 168,
          "x": 22.8421,
          "y": 110,
          "z": 173.5028
        },
        {
          "hole": 169,
          "x": 15.2523,
          "y": 110,
          "z": 174.3341
        },
        {
          "hole": 170,
          "x": 7.6334,
          "y": 110,
          "z": 174.8334
        },
        {
          "hole": 171,
          "x": -8.0696,
          "y": 100,
          "z": 174.8239
        },
        {
          "hole": 172,
          "x": -16.1238,
          "y": 100,
          "z": 174.296
        },
        {
          "hole": 173,
          "x": -24.1473,
          "y": 100,
          "z": 173.4173
        },
        {
          "hole": 174,
          "x": -32.1249,
          "y": 100,
          "z": 172.1894
        },
        {
          "hole": 175,
          "x": -40.0413,
          "y": 100,
          "z": 170.6148
        },
        {
          "hole": 176,
          "x": -55.6306,
          "y": 100,
          "z": 166.4376
        },
        {
          "hole": 177,
          "x": -63.2737,
          "y": 100,
          "z": 163.8431
        },
        {
          "hole": 178,
          "x": -70.7964,
          "y": 100,
          "z": 160.9177
        },
        {
          "hole": 179,
          "x": -78.1844,
          "y": 100,
          "z": 157.6669
        },
        {
          "hole": 180,
          "x": -85.4235,
          "y": 100,
          "z": 154.097
        },
        {
          "hole": 181,
          "x": -99.4004,
          "y": 100,
          "z": 146.0274
        },
        {
          "hole": 182,
          "x": -106.1116,
          "y": 100,
          "z": 141.5431
        },
        {
          "hole": 183,
          "x": -112.6209,
          "y": 100,
          "z": 136.7704
        },
        {
          "hole": 184,
          "x": -118.9157,
          "y": 100,
          "z": 131.7182
        },
        {
          "hole": 185,
          "x": -124.9842,
          "y": 100,
          "z": 126.3963
        },
        {
          "hole": 186,
          "x": -136.3963,
          "y": 100,
          "z": 114.9842
        },
        {
          "hole": 187,
          "x": -141.7182,
          "y": 100,
          "z": 108.9157
        },
        {
          "hole": 188,
          "x": -146.7704,
          "y": 100,
          "z": 102.6209
        },
        {
          "hole": 189,
          "x": -151.5431,
          "y": 100,
          "z": 96.1116
        },
        {
          "hole": 190,
          "x": -156.0274,
          "y": 100,
          "z": 89.4004
        },
        {
          "hole": 191,
          "x": -164.097,
          "y": 100,
          "z": 75.4235
        },
        {
          "hole": 192,
          "x": -167.6669,
          "y": 100,
          "z": 68.1844
        },
        {
          "hole": 193,
          "x": -170.9177,
          "y": 100,
          "z": 60.7964
        },
        {
          "hole": 194,
          "x": -173.8431,
          "y": 100,
          "z": 53.2737
        },
        {
          "hole": 195,
          "x": -176.4376,
          "y": 100,
          "z": 45.6306
        },
        {
          "hole": 196,
          "x": -180.6148,
          "y": 100,
          "z": 30.0413
        },
        {
          "hole": 197,
          "x": -182.1894,
          "y": 100,
          "z": 22.1249
        },
        {
          "hole": 198,
          "x": -183.4173,
          "y": 100,
          "z": 14.1473
        },
        {
          "hole": 199,
          "x": -184.296,
          "y": 100,
          "z": 6.1238
        },
        {
          "hole": 200,
          "x": -184.8239,
          "y": 100,
          "z": -1.9304
        },
        {
          "hole": 201,
          "x": -184.8144,
          "y": 90,
          "z": -18.5058
        },
        {
          "hole": 202,
          "x": -184.258,
          "y": 90,
          "z": -26.9954
        },
        {
          "hole": 203,
          "x": -183.3318,
          "y": 90,
          "z": -35.4526
        },
        {
          "hole": 204,
          "x": -182.0375,
          "y": 90,
          "z": -43.8614
        },
        {
          "hole": 205,
          "x": -180.3777,
          "y": 90,
          "z": -52.2057
        },
        {
          "hole": 206,
          "x": -175.9748,
          "y": 90,
          "z": -68.6376
        },
        {
          "hole": 207,
          "x": -173.2401,
          "y": 90,
          "z": -76.6939
        },
        {
          "hole": 208,
          "x": -170.1565,
          "y": 90,
          "z": -84.6233
        },
        {
          "hole": 209,
          "x": -166.73,
          "y": 90,
          "z": -92.4106
        },
        {
          "hole": 210,
          "x": -162.9671,
          "y": 90,
          "z": -100.041
        },
        {
          "hole": 211,
          "x": -154.4613,
          "y": 90,
          "z": -114.7734
        },
        {
          "hole": 212,
          "x": -149.7347,
          "y": 90,
          "z": -121.8474
        },
        {
          "hole": 213,
          "x": -144.7039,
          "y": 90,
          "z": -128.7085
        },
        {
          "hole": 214,
          "x": -139.3787,
          "y": 90,
          "z": -135.3436
        },
        {
          "hole": 215,
          "x": -133.7691,
          "y": 90,
          "z": -141.7401
        },
        {
          "hole": 216,
          "x": -121.7401,
          "y": 90,
          "z": -153.7691
        },
        {
          "hole": 217,
          "x": -115.3436,
          "y": 90,
          "z": -159.3787
        },
        {
          "hole": 218,
          "x": -108.7085,
          "y": 90,
          "z": -164.7039
        },
        {
          "hole": 219,
          "x": -101.8474,
          "y": 90,
          "z": -169.7346
        },
        {
          "hole": 220,
          "x": -94.7734,
          "y": 90,
          "z": -174.4613
        },
        {
          "hole": 221,
          "x": -80.041,
          "y": 90,
          "z": -182.9671
        },
        {
          "hole": 222,
          "x": -72.4105,
          "y": 90,
          "z": -186.73
        },
        {
          "hole": 223,
          "x": -64.6233,
          "y": 90,
          "z": -190.1565
        },
        {
          "hole": 224,
          "x": -56.6939,
          "y": 90,
          "z": -193.2401
        },
        {
          "hole": 225,
          "x": -48.6376,
          "y": 90,
          "z": -195.9748
        },
        {
          "hole": 226,
          "x": -32.2057,
          "y": 90,
          "z": -200.3777
        },
        {
          "hole": 227,
          "x": -23.8614,
          "y": 90,
          "z": -202.0375
        },
        {
          "hole": 228,
          "x": -15.4526,
          "y": 90,
          "z": -203.3317
        },
        {
          "hole": 229,
          "x": -6.9954,
          "y": 90,
          "z": -204.2579
        },
        {
          "hole": 230,
          "x": 1.4942,
          "y": 90,
          "z": -204.8144
        },
        {
          "hole": 231,
          "x": 18.942,
          "y": 80,
          "z": -204.8049
        },
        {
          "hole": 232,
          "x": 27.8669,
          "y": 80,
          "z": -204.2199
        },
        {
          "hole": 233,
          "x": 36.7579,
          "y": 80,
          "z": -203.2462
        },
        {
          "hole": 234,
          "x": 45.5979,
          "y": 80,
          "z": -201.8856
        },
        {
          "hole": 235,
          "x": 54.3701,
          "y": 80,
          "z": -200.1407
        },
        {
          "hole": 236,
          "x": 71.6447,
          "y": 80,
          "z": -195.512
        },
        {
          "hole": 237,
          "x": 80.1141,
          "y": 80,
          "z": -192.637
        },
        {
          "hole": 238,
          "x": 88.4501,
          "y": 80,
          "z": -189.3953
        },
        {
          "hole": 239,
          "x": 96.6367,
          "y": 80,
          "z": -185.7931
        },
        {
          "hole": 240,
          "x": 104.6585,
          "y": 80,
          "z": -181.8372
        },
        {
          "hole": 241,
          "x": 120.1464,
          "y": 80,
          "z": -172.8952
        },
        {
          "hole": 242,
          "x": 127.5832,
          "y": 80,
          "z": -167.9262
        },
        {
          "hole": 243,
          "x": 134.7961,
          "y": 80,
          "z": -162.6374
        },
        {
          "hole": 244,
          "x": 141.7715,
          "y": 80,
          "z": -157.0391
        },
        {
          "hole": 245,
          "x": 148.496,
          "y": 80,
          "z": -151.1418
        },
        {
          "hole": 246,
          "x": 161.1419,
          "y": 80,
          "z": -138.496
        },
        {
          "hole": 247,
          "x": 167.0391,
          "y": 80,
          "z": -131.7714
        },
        {
          "hole": 248,
          "x": 172.6374,
          "y": 80,
          "z": -124.7961
        },
        {
          "hole": 249,
          "x": 177.9262,
          "y": 80,
          "z": -117.5832
        },
        {
          "hole": 250,
          "x": 182.8952,
          "y": 80,
          "z": -110.1464
        },
        {
          "hole": 251,
          "x": 191.8372,
          "y": 80,
          "z": -94.6585
        },
        {
          "hole": 252,
          "x": 195.7931,
          "y": 80,
          "z": -86.6367
        },
        {
          "hole": 253,
          "x": 199.3953,
          "y": 80,
          "z": -78.4501
        },
        {
          "hole": 254,
          "x": 202.637,
          "y": 80,
          "z": -70.1141
        },
        {
          "hole": 255,
          "x": 205.512,
          "y": 80,
          "z": -61.6447
        },
        {
          "hole": 256,
          "x": 210.1407,
          "y": 80,
          "z": -44.3701
        },
        {
          "hole": 257,
          "x": 211.8856,
          "y": 80,
          "z": -35.5979
        },
        {
          "hole": 258,
          "x": 213.2462,
          "y": 80,
          "z": -26.7578
        },
        {
          "hole": 259,
          "x": 214.2199,
          "y": 80,
          "z": -17.8669
        },
        {
          "hole": 260,
          "x": 214.8049,
          "y": 80,
          "z": -8.942
        },
        {
          "hole": 261,
          "x": 214.8849,
          "y": 70,
          "z": 7.0346
        },
        {
          "hole": 262,
          "x": 214.5397,
          "y": 70,
          "z": 14.0617
        },
        {
          "hole": 263,
          "x": 213.9647,
          "y": 70,
          "z": 21.0737
        },
        {
          "hole": 264,
          "x": 213.1606,
          "y": 70,
          "z": 28.0631
        },
        {
          "hole": 265,
          "x": 212.1283,
          "y": 70,
          "z": 35.0225
        },
        {
          "hole": 266,
          "x": 209.3835,
          "y": 70,
          "z": 48.8214
        },
        {
          "hole": 267,
          "x": 207.674,
          "y": 70,
          "z": 55.6461
        },
        {
          "hole": 268,
          "x": 205.7422,
          "y": 70,
          "z": 62.4112
        },
        {
          "hole": 269,
          "x": 203.59,
          "y": 70,
          "z": 69.1095
        },
        {
          "hole": 270,
          "x": 201.2198,
          "y": 70,
          "z": 75.7338
        },
        {
          "hole": 271,
          "x": 195.8357,
          "y": 70,
          "z": 88.732
        },
        {
          "hole": 272,
          "x": 192.8276,
          "y": 70,
          "z": 95.0921
        },
        {
          "hole": 273,
          "x": 189.6131,
          "y": 70,
          "z": 101.3503
        },
        {
          "hole": 274,
          "x": 186.1955,
          "y": 70,
          "z": 107.5
        },
        {
          "hole": 275,
          "x": 182.5785,
          "y": 70,
          "z": 113.5346
        },
        {
          "hole": 276,
          "x": 174.762,
          "y": 70,
          "z": 125.2327
        },
        {
          "hole": 277,
          "x": 170.571,
          "y": 70,
          "z": 130.8837
        },
        {
          "hole": 278,
          "x": 166.1972,
          "y": 70,
          "z": 136.3946
        },
        {
          "hole": 279,
          "x": 161.6456,
          "y": 70,
          "z": 141.7594
        },
        {
          "hole": 280,
          "x": 156.9208,
          "y": 70,
          "z": 146.9723
        },
        {
          "hole": 281,
          "x": 146.9723,
          "y": 70,
          "z": 156.9208
        },
        {
          "hole": 282,
          "x": 141.7593,
          "y": 70,
          "z": 161.6456
        },
        {
          "hole": 283,
          "x": 136.3946,
          "y": 70,
          "z": 166.1972
        },
        {
          "hole": 284,
          "x": 130.8837,
          "y": 70,
          "z": 170.571
        },
        {
          "hole": 285,
          "x": 125.2327,
          "y": 70,
          "z": 174.762
        },
        {
          "hole": 286,
          "x": 113.5346,
          "y": 70,
          "z": 182.5785
        },
        {
          "hole": 287,
          "x": 107.5,
          "y": 70,
          "z": 186.1955
        },
        {
          "hole": 288,
          "x": 101.3503,
          "y": 70,
          "z": 189.6131
        },
        {
          "hole": 289,
          "x": 95.0921,
          "y": 70,
          "z": 192.8276
        },
        {
          "hole": 290,
          "x": 88.732,
          "y": 70,
          "z": 195.8357
        },
        {
          "hole": 291,
          "x": 75.7338,
          "y": 70,
          "z": 201.2198
        },
        {
          "hole": 292,
          "x": 69.1095,
          "y": 70,
          "z": 203.59
        },
        {
          "hole": 293,
          "x": 62.4112,
          "y": 70,
          "z": 205.7422
        },
        {
          "hole": 294,
          "x": 55.6461,
          "y": 70,
          "z": 207.674
        },
        {
          "hole": 295,
          "x": 48.8214,
          "y": 70,
          "z": 209.3835
        },
        {
          "hole": 296,
          "x": 35.0226,
          "y": 70,
          "z": 212.1283
        },
        {
          "hole": 297,
          "x": 28.0632,
          "y": 70,
          "z": 213.1606
        },
        {
          "hole": 298,
          "x": 21.0737,
          "y": 70,
          "z": 213.9647
        },
        {
          "hole": 299,
          "x": 14.0617,
          "y": 70,
          "z": 214.5397
        },
        {
          "hole": 300,
          "x": 7.0346,
          "y": 70,
          "z": 214.8849
        },
        {
          "hole": 301,
          "x": -7.3618,
          "y": 60,
          "z": 214.8795
        },
        {
          "hole": 302,
          "x": -14.7157,
          "y": 60,
          "z": 214.5183
        },
        {
          "hole": 303,
          "x": -22.0539,
          "y": 60,
          "z": 213.9166
        },
        {
          "hole": 304,
          "x": -29.3684,
          "y": 60,
          "z": 213.0751
        },
        {
          "hole": 305,
          "x": -36.6515,
          "y": 60,
          "z": 211.9947
        },
        {
          "hole": 306,
          "x": -51.0922,
          "y": 60,
          "z": 209.1223
        },
        {
          "hole": 307,
          "x": -58.2343,
          "y": 60,
          "z": 207.3333
        },
        {
          "hole": 308,
          "x": -65.3141,
          "y": 60,
          "z": 205.3116
        },
        {
          "hole": 309,
          "x": -72.3239,
          "y": 60,
          "z": 203.0593
        },
        {
          "hole": 310,
          "x": -79.2563,
          "y": 60,
          "z": 200.5788
        },
        {
          "hole": 311,
          "x": -92.8591,
          "y": 60,
          "z": 194.9444
        },
        {
          "hole": 312,
          "x": -99.515,
          "y": 60,
          "z": 191.7964
        },
        {
          "hole": 313,
          "x": -106.0643,
          "y": 60,
          "z": 188.4323
        },
        {
          "hole": 314,
          "x": -112.5,
          "y": 60,
          "z": 184.8557
        },
        {
          "hole": 315,
          "x": -118.8153,
          "y": 60,
          "z": 181.0705
        },
        {
          "hole": 316,
          "x": -131.0575,
          "y": 60,
          "z": 172.8905
        },
        {
          "hole": 317,
          "x": -136.9713,
          "y": 60,
          "z": 168.5045
        },
        {
          "hole": 318,
          "x": -142.7385,
          "y": 60,
          "z": 163.9273
        },
        {
          "hole": 319,
          "x": -148.3528,
          "y": 60,
          "z": 159.164
        },
        {
          "hole": 320,
          "x": -153.8083,
          "y": 60,
          "z": 154.2194
        },
        {
          "hole": 321,
          "x": -164.2194,
          "y": 60,
          "z": 143.8083
        },
        {
          "hole": 322,
          "x": -169.164,
          "y": 60,
          "z": 138.3528
        },
        {
          "hole": 323,
          "x": -173.9273,
          "y": 60,
          "z": 132.7385
        },
        {
          "hole": 324,
          "x": -178.5045,
          "y": 60,
          "z": 126.9713
        },
        {
          "hole": 325,
          "x": -182.8905,
          "y": 60,
          "z": 121.0575
        },
        {
          "hole": 326,
          "x": -191.0705,
          "y": 60,
          "z": 108.8153
        },
        {
          "hole": 327,
          "x": -194.8557,
          "y": 60,
          "z": 102.5
        },
        {
          "hole": 328,
          "x": -198.4323,
          "y": 60,
          "z": 96.0643
        },
        {
          "hole": 329,
          "x": -201.7964,
          "y": 60,
          "z": 89.515
        },
        {
          "hole": 330,
          "x": -204.9444,
          "y": 60,
          "z": 82.8591
        },
        {
          "hole": 331,
          "x": -210.5788,
          "y": 60,
          "z": 69.2563
        },
        {
          "hole": 332,
          "x": -213.0593,
          "y": 60,
          "z": 62.3239
        },
        {
          "hole": 333,
          "x": -215.3116,
          "y": 60,
          "z": 55.3141
        },
        {
          "hole": 334,
          "x": -217.3333,
          "y": 60,
          "z": 48.2343
        },
        {
          "hole": 335,
          "x": -219.1223,
          "y": 60,
          "z": 41.0922
        },
        {
          "hole": 336,
          "x": -221.9947,
          "y": 60,
          "z": 26.6515
        },
        {
          "hole": 337,
          "x": -223.0751,
          "y": 60,
          "z": 19.3684
        },
        {
          "hole": 338,
          "x": -223.9166,
          "y": 60,
          "z": 12.0539
        },
        {
          "hole": 339,
          "x": -224.5183,
          "y": 60,
          "z": 4.7157
        },
        {
          "hole": 340,
          "x": -224.8795,
          "y": 60,
          "z": -2.6382
        },
        {
          "hole": 341,
          "x": -224.8742,
          "y": 50,
          "z": -17.689
        },
        {
          "hole": 342,
          "x": -224.4968,
          "y": 50,
          "z": -25.3697
        },
        {
          "hole": 343,
          "x": -223.8684,
          "y": 50,
          "z": -33.034
        },
        {
          "hole": 344,
          "x": -222.9895,
          "y": 50,
          "z": -40.6737
        },
        {
          "hole": 345,
          "x": -221.8612,
          "y": 50,
          "z": -48.2804
        },
        {
          "hole": 346,
          "x": -218.8611,
          "y": 50,
          "z": -63.3629
        },
        {
          "hole": 347,
          "x": -216.9926,
          "y": 50,
          "z": -70.8225
        },
        {
          "hole": 348,
          "x": -214.881,
          "y": 50,
          "z": -78.2169
        },
        {
          "hole": 349,
          "x": -212.5286,
          "y": 50,
          "z": -85.5383
        },
        {
          "hole": 350,
          "x": -209.9379,
          "y": 50,
          "z": -92.7788
        },
        {
          "hole": 351,
          "x": -204.053,
          "y": 50,
          "z": -106.9862
        },
        {
          "hole": 352,
          "x": -200.7651,
          "y": 50,
          "z": -113.9378
        },
        {
          "hole": 353,
          "x": -197.2515,
          "y": 50,
          "z": -120.7782
        },
        {
          "hole": 354,
          "x": -193.516,
          "y": 50,
          "z": -127.5
        },
        {
          "hole": 355,
          "x": -189.5625,
          "y": 50,
          "z": -134.0959
        },
        {
          "hole": 356,
          "x": -181.019,
          "y": 50,
          "z": -146.8823
        },
        {
          "hole": 357,
          "x": -176.438,
          "y": 50,
          "z": -153.0589
        },
        {
          "hole": 358,
          "x": -171.6575,
          "y": 50,
          "z": -159.0824
        },
        {
          "hole": 359,
          "x": -166.6824,
          "y": 50,
          "z": -164.9463
        },
        {
          "hole": 360,
          "x": -161.5181,
          "y": 50,
          "z": -170.6442
        },
        {
          "hole": 361,
          "x": -150.6442,
          "y": 50,
          "z": -181.5181
        },
        {
          "hole": 362,
          "x": -144.9463,
          "y": 50,
          "z": -186.6824
        },
        {
          "hole": 363,
          "x": -139.0824,
          "y": 50,
          "z": -191.6575
        },
        {
          "hole": 364,
          "x": -133.0589,
          "y": 50,
          "z": -196.438
        },
        {
          "hole": 365,
          "x": -126.8823,
          "y": 50,
          "z": -201.019
        },
        {
          "hole": 366,
          "x": -114.0959,
          "y": 50,
          "z": -209.5625
        },
        {
          "hole": 367,
          "x": -107.5,
          "y": 50,
          "z": -213.516
        },
        {
          "hole": 368,
          "x": -100.7782,
          "y": 50,
          "z": -217.2515
        },
        {
          "hole": 369,
          "x": -93.9378,
          "y": 50,
          "z": -220.7651
        },
        {
          "hole": 370,
          "x": -86.9862,
          "y": 50,
          "z": -224.053
        },
        {
          "hole": 371,
          "x": -72.7787,
          "y": 50,
          "z": -229.9379
        },
        {
          "hole": 372,
          "x": -65.5383,
          "y": 50,
          "z": -232.5286
        },
        {
          "hole": 373,
          "x": -58.2169,
          "y": 50,
          "z": -234.881
        },
        {
          "hole": 374,
          "x": -50.8225,
          "y": 50,
          "z": -236.9926
        },
        {
          "hole": 375,
          "x": -43.3629,
          "y": 50,
          "z": -238.8611
        },
        {
          "hole": 376,
          "x": -28.2804,
          "y": 50,
          "z": -241.8612
        },
        {
          "hole": 377,
          "x": -20.6737,
          "y": 50,
          "z": -242.9895
        },
        {
          "hole": 378,
          "x": -13.034,
          "y": 50,
          "z": -243.8684
        },
        {
          "hole": 379,
          "x": -5.3697,
          "y": 50,
          "z": -244.4968
        },
        {
          "hole": 380,
          "x": 2.311,
          "y": 50,
          "z": -244.8742
        },
        {
          "hole": 381,
          "x": 18.0162,
          "y": 40,
          "z": -244.8688
        },
        {
          "hole": 382,
          "x": 26.0238,
          "y": 40,
          "z": -244.4755
        },
        {
          "hole": 383,
          "x": 34.0142,
          "y": 40,
          "z": -243.8203
        },
        {
          "hole": 384,
          "x": 41.9789,
          "y": 40,
          "z": -242.904
        },
        {
          "hole": 385,
          "x": 49.9094,
          "y": 40,
          "z": -241.7276
        },
        {
          "hole": 386,
          "x": 65.6337,
          "y": 40,
          "z": -238.5999
        },
        {
          "hole": 387,
          "x": 73.4107,
          "y": 40,
          "z": -236.6518
        },
        {
          "hole": 388,
          "x": 81.1198,
          "y": 40,
          "z": -234.4504
        },
        {
          "hole": 389,
          "x": 88.7527,
          "y": 40,
          "z": -231.9979
        },
        {
          "hole": 390,
          "x": 96.3013,
          "y": 40,
          "z": -229.297
        },
        {
          "hole": 391,
          "x": 111.1132,
          "y": 40,
          "z": -223.1616
        },
        {
          "hole": 392,
          "x": 118.3607,
          "y": 40,
          "z": -219.7338
        },
        {
          "hole": 393,
          "x": 125.4922,
          "y": 40,
          "z": -216.0707
        },
        {
          "hole": 394,
          "x": 132.5,
          "y": 40,
          "z": -212.1762
        },
        {
          "hole": 395,
          "x": 139.3766,
          "y": 40,
          "z": -208.0545
        },
        {
          "hole": 396,
          "x": 152.707,
          "y": 40,
          "z": -199.1474
        },
        {
          "hole": 397,
          "x": 159.1466,
          "y": 40,
          "z": -194.3716
        },
        {
          "hole": 398,
          "x": 165.4264,
          "y": 40,
          "z": -189.3876
        },
        {
          "hole": 399,
          "x": 171.5397,
          "y": 40,
          "z": -184.2008
        },
        {
          "hole": 400,
          "x": 177.4801,
          "y": 40,
          "z": -178.8167
        },
        {
          "hole": 401,
          "x": 188.8167,
          "y": 40,
          "z": -167.4801
        },
        {
          "hole": 402,
          "x": 194.2007,
          "y": 40,
          "z": -161.5397
        },
        {
          "hole": 403,
          "x": 199.3876,
          "y": 40,
          "z": -155.4264
        },
        {
          "hole": 404,
          "x": 204.3716,
          "y": 40,
          "z": -149.1466
        },
        {
          "hole": 405,
          "x": 209.1474,
          "y": 40,
          "z": -142.707
        },
        {
          "hole": 406,
          "x": 218.0545,
          "y": 40,
          "z": -129.3766
        },
        {
          "hole": 407,
          "x": 222.1762,
          "y": 40,
          "z": -122.5
        },
        {
          "hole": 408,
          "x": 226.0707,
          "y": 40,
          "z": -115.4922
        },
        {
          "hole": 409,
          "x": 229.7338,
          "y": 40,
          "z": -108.3607
        },
        {
          "hole": 410,
          "x": 233.1616,
          "y": 40,
          "z": -101.1132
        },
        {
          "hole": 411,
          "x": 239.2969,
          "y": 40,
          "z": -86.3013
        },
        {
          "hole": 412,
          "x": 241.9979,
          "y": 40,
          "z": -78.7527
        },
        {
          "hole": 413,
          "x": 244.4504,
          "y": 40,
          "z": -71.1198
        },
        {
          "hole": 414,
          "x": 246.6518,
          "y": 40,
          "z": -63.4107
        },
        {
          "hole": 415,
          "x": 248.5999,
          "y": 40,
          "z": -55.6337
        },
        {
          "hole": 416,
          "x": 251.7276,
          "y": 40,
          "z": -39.9094
        },
        {
          "hole": 417,
          "x": 252.904,
          "y": 40,
          "z": -31.9789
        },
        {
          "hole": 418,
          "x": 253.8203,
          "y": 40,
          "z": -24.0142
        },
        {
          "hole": 419,
          "x": 254.4754,
          "y": 40,
          "z": -16.0238
        },
        {
          "hole": 420,
          "x": 254.8688,
          "y": 40,
          "z": -8.0162
        },
        {
          "hole": 421,
          "x": 254.8635,
          "y": 30,
          "z": 8.3434
        },
        {
          "hole": 422,
          "x": 254.454,
          "y": 30,
          "z": 16.6778
        },
        {
          "hole": 423,
          "x": 253.7721,
          "y": 30,
          "z": 24.9944
        },
        {
          "hole": 424,
          "x": 252.8184,
          "y": 30,
          "z": 33.2842
        },
        {
          "hole": 425,
          "x": 251.594,
          "y": 30,
          "z": 41.5383
        },
        {
          "hole": 426,
          "x": 248.3386,
          "y": 30,
          "z": 57.9044
        },
        {
          "hole": 427,
          "x": 246.3111,
          "y": 30,
          "z": 65.9989
        },
        {
          "hole": 428,
          "x": 244.0198,
          "y": 30,
          "z": 74.0226
        },
        {
          "hole": 429,
          "x": 241.4672,
          "y": 30,
          "z": 81.9671
        },
        {
          "hole": 430,
          "x": 238.656,
          "y": 30,
          "z": 89.8238
        },
        {
          "hole": 431,
          "x": 232.2703,
          "y": 30,
          "z": 105.2403
        },
        {
          "hole": 432,
          "x": 228.7025,
          "y": 30,
          "z": 112.7836
        },
        {
          "hole": 433,
          "x": 224.8899,
          "y": 30,
          "z": 120.2062
        },
        {
          "hole": 434,
          "x": 220.8365,
          "y": 30,
          "z": 127.5
        },
        {
          "hole": 435,
          "x": 216.5465,
          "y": 30,
          "z": 134.6573
        },
        {
          "hole": 436,
          "x": 207.2759,
          "y": 30,
          "z": 148.5318
        },
        {
          "hole": 437,
          "x": 202.3051,
          "y": 30,
          "z": 155.2342
        },
        {
          "hole": 438,
          "x": 197.1177,
          "y": 30,
          "z": 161.7703
        },
        {
          "hole": 439,
          "x": 191.7191,
          "y": 30,
          "z": 168.1332
        },
        {
          "hole": 440,
          "x": 186.1153,
          "y": 30,
          "z": 174.316
        },
        {
          "hole": 441,
          "x": 174.316,
          "y": 30,
          "z": 186.1153
        },
        {
          "hole": 442,
          "x": 168.1332,
          "y": 30,
          "z": 191.7191
        },
        {
          "hole": 443,
          "x": 161.7703,
          "y": 30,
          "z": 197.1177
        },
        {
          "hole": 444,
          "x": 155.2342,
          "y": 30,
          "z": 202.3051
        },
        {
          "hole": 445,
          "x": 148.5318,
          "y": 30,
          "z": 207.2759
        },
        {
          "hole": 446,
          "x": 134.6573,
          "y": 30,
          "z": 216.5466
        },
        {
          "hole": 447,
          "x": 127.5,
          "y": 30,
          "z": 220.8365
        },
        {
          "hole": 448,
          "x": 120.2062,
          "y": 30,
          "z": 224.8899
        },
        {
          "hole": 449,
          "x": 112.7836,
          "y": 30,
          "z": 228.7025
        },
        {
          "hole": 450,
          "x": 105.2403,
          "y": 30,
          "z": 232.2703
        },
        {
          "hole": 451,
          "x": 89.8238,
          "y": 30,
          "z": 238.656
        },
        {
          "hole": 452,
          "x": 81.9671,
          "y": 30,
          "z": 241.4672
        },
        {
          "hole": 453,
          "x": 74.0226,
          "y": 30,
          "z": 244.0198
        },
        {
          "hole": 454,
          "x": 65.9989,
          "y": 30,
          "z": 246.3111
        },
        {
          "hole": 455,
          "x": 57.9045,
          "y": 30,
          "z": 248.3386
        },
        {
          "hole": 456,
          "x": 41.5384,
          "y": 30,
          "z": 251.594
        },
        {
          "hole": 457,
          "x": 33.2842,
          "y": 30,
          "z": 252.8184
        },
        {
          "hole": 458,
          "x": 24.9944,
          "y": 30,
          "z": 253.7721
        },
        {
          "hole": 459,
          "x": 16.6778,
          "y": 30,
          "z": 254.454
        },
        {
          "hole": 460,
          "x": 8.3434,
          "y": 30,
          "z": 254.8635
        },
        {
          "hole": 461,
          "x": -8.6706,
          "y": 20,
          "z": 254.8581
        },
        {
          "hole": 462,
          "x": -17.3318,
          "y": 20,
          "z": 254.4326
        },
        {
          "hole": 463,
          "x": -25.9745,
          "y": 20,
          "z": 253.724
        },
        {
          "hole": 464,
          "x": -34.5894,
          "y": 20,
          "z": 252.7329
        },
        {
          "hole": 465,
          "x": -43.1673,
          "y": 20,
          "z": 251.4605
        },
        {
          "hole": 466,
          "x": -60.1752,
          "y": 20,
          "z": 248.0774
        },
        {
          "hole": 467,
          "x": -68.5871,
          "y": 20,
          "z": 245.9703
        },
        {
          "hole": 468,
          "x": -76.9254,
          "y": 20,
          "z": 243.5892
        },
        {
          "hole": 469,
          "x": -85.1815,
          "y": 20,
          "z": 240.9365
        },
        {
          "hole": 470,
          "x": -93.3463,
          "y": 20,
          "z": 238.0151
        },
        {
          "hole": 471,
          "x": -109.3674,
          "y": 20,
          "z": 231.3789
        },
        {
          "hole": 472,
          "x": -117.2065,
          "y": 20,
          "z": 227.6713
        },
        {
          "hole": 473,
          "x": -124.9201,
          "y": 20,
          "z": 223.7091
        },
        {
          "hole": 474,
          "x": -132.5,
          "y": 20,
          "z": 219.4967
        },
        {
          "hole": 475,
          "x": -139.938,
          "y": 20,
          "z": 215.0386
        },
        {
          "hole": 476,
          "x": -154.3566,
          "y": 20,
          "z": 205.4044
        },
        {
          "hole": 477,
          "x": -161.3218,
          "y": 20,
          "z": 200.2386
        },
        {
          "hole": 478,
          "x": -168.1142,
          "y": 20,
          "z": 194.8478
        },
        {
          "hole": 479,
          "x": -174.7266,
          "y": 20,
          "z": 189.2375
        },
        {
          "hole": 480,
          "x": -181.152,
          "y": 20,
          "z": 183.414
        },
        {
          "hole": 481,
          "x": 40,
          "y": 240,
          "z": -6.25
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": -220.8365,
          "y": 10,
          "z": 117.5
        },
        {
          "hole": 1,
          "x": 43.4667,
          "y": 230,
          "z": 11.6469
        },
        {
          "hole": 2,
          "x": 38.9711,
          "y": 230,
          "z": 22.5
        },
        {
          "hole": 3,
          "x": 31.8198,
          "y": 230,
          "z": 31.8198
        },
        {
          "hole": 4,
          "x": 22.5,
          "y": 230,
          "z": 38.9711
        },
        {
          "hole": 5,
          "x": 11.6469,
          "y": 230,
          "z": 43.4667
        },
        {
          "hole": 6,
          "x": -14.235,
          "y": 220,
          "z": 43.1259
        },
        {
          "hole": 7,
          "x": -27.5,
          "y": 220,
          "z": 37.6314
        },
        {
          "hole": 8,
          "x": -38.8909,
          "y": 220,
          "z": 28.8909
        },
        {
          "hole": 9,
          "x": -47.6314,
          "y": 220,
          "z": 17.5
        },
        {
          "hole": 10,
          "x": -53.1259,
          "y": 220,
          "z": 4.235
        },
        {
          "hole": 11,
          "x": -52.7852,
          "y": 210,
          "z": -26.8232
        },
        {
          "hole": 12,
          "x": -46.2917,
          "y": 210,
          "z": -42.5
        },
        {
          "hole": 13,
          "x": -35.9619,
          "y": 210,
          "z": -55.9619
        },
        {
          "hole": 14,
          "x": -22.5,
          "y": 210,
          "z": -66.2917
        },
        {
          "hole": 15,
          "x": -6.8232,
          "y": 210,
          "z": -72.7852
        },
        {
          "hole": 16,
          "x": 29.4114,
          "y": 200,
          "z": -72.4444
        },
        {
          "hole": 17,
          "x": 47.5,
          "y": 200,
          "z": -64.9519
        },
        {
          "hole": 18,
          "x": 63.033,
          "y": 200,
          "z": -53.033
        },
        {
          "hole": 19,
          "x": 74.9519,
          "y": 200,
          "z": -37.5
        },
        {
          "hole": 20,
          "x": 82.4444,
          "y": 200,
          "z": -19.4114
        },
        {
          "hole": 21,
          "x": 84.2728,
          "y": 190,
          "z": 11.0947
        },
        {
          "hole": 22,
          "x": 82.1037,
          "y": 190,
          "z": 21.9996
        },
        {
          "hole": 23,
          "x": 78.5298,
          "y": 190,
          "z": 32.5281
        },
        {
          "hole": 24,
          "x": 73.6122,
          "y": 190,
          "z": 42.5
        },
        {
          "hole": 25,
          "x": 67.435,
          "y": 190,
          "z": 51.7447
        },
        {
          "hole": 26,
          "x": 51.7447,
          "y": 190,
          "z": 67.435
        },
        {
          "hole": 27,
          "x": 42.5,
          "y": 190,
          "z": 73.6121
        },
        {
          "hole": 28,
          "x": 32.5281,
          "y": 190,
          "z": 78.5297
        },
        {
          "hole": 29,
          "x": 21.9996,
          "y": 190,
          "z": 82.1037
        },
        {
          "hole": 30,
          "x": 11.0947,
          "y": 190,
          "z": 84.2728
        },
        {
          "hole": 31,
          "x": -12.4,
          "y": 180,
          "z": 84.1873
        },
        {
          "hole": 32,
          "x": -24.5878,
          "y": 180,
          "z": 81.7629
        },
        {
          "hole": 33,
          "x": -36.3549,
          "y": 180,
          "z": 77.7686
        },
        {
          "hole": 34,
          "x": -47.5,
          "y": 180,
          "z": 72.2724
        },
        {
          "hole": 35,
          "x": -57.8323,
          "y": 180,
          "z": 65.3686
        },
        {
          "hole": 36,
          "x": -75.3686,
          "y": 180,
          "z": 47.8323
        },
        {
          "hole": 37,
          "x": -82.2724,
          "y": 180,
          "z": 37.5
        },
        {
          "hole": 38,
          "x": -87.7685,
          "y": 180,
          "z": 26.3549
        },
        {
          "hole": 39,
          "x": -91.7629,
          "y": 180,
          "z": 14.5878
        },
        {
          "hole": 40,
          "x": -94.1873,
          "y": 180,
          "z": 2.4
        },
        {
          "hole": 41,
          "x": -94.1017,
          "y": 170,
          "z": -23.7053
        },
        {
          "hole": 42,
          "x": -91.4222,
          "y": 170,
          "z": -37.176
        },
        {
          "hole": 43,
          "x": -87.0073,
          "y": 170,
          "z": -50.1818
        },
        {
          "hole": 44,
          "x": -80.9327,
          "y": 170,
          "z": -62.5
        },
        {
          "hole": 45,
          "x": -73.3021,
          "y": 170,
          "z": -73.92
        },
        {
          "hole": 46,
          "x": -53.9199,
          "y": 170,
          "z": -93.3021
        },
        {
          "hole": 47,
          "x": -42.5,
          "y": 170,
          "z": -100.9327
        },
        {
          "hole": 48,
          "x": -30.1818,
          "y": 170,
          "z": -107.0073
        },
        {
          "hole": 49,
          "x": -17.176,
          "y": 170,
          "z": -111.4222
        },
        {
          "hole": 50,
          "x": -3.7053,
          "y": 170,
          "z": -114.1017
        },
        {
          "hole": 51,
          "x": 25.0105,
          "y": 160,
          "z": -114.0162
        },
        {
          "hole": 52,
          "x": 39.7642,
          "y": 160,
          "z": -111.0815
        },
        {
          "hole": 53,
          "x": 54.0086,
          "y": 160,
          "z": -106.2461
        },
        {
          "hole": 54,
          "x": 67.5,
          "y": 160,
          "z": -99.5929
        },
        {
          "hole": 55,
          "x": 80.0076,
          "y": 160,
          "z": -91.2356
        },
        {
          "hole": 56,
          "x": 101.2356,
          "y": 160,
          "z": -70.0076
        },
        {
          "hole": 57,
          "x": 109.5929,
          "y": 160,
          "z": -57.5
        },
        {
          "hole": 58,
          "x": 116.2461,
          "y": 160,
          "z": -44.0086
        },
        {
          "hole": 59,
          "x": 121.0815,
          "y": 160,
          "z": -29.7642
        },
        {
          "hole": 60,
          "x": 124.0161,
          "y": 160,
          "z": -15.0105
        },
        {
          "hole": 61,
          "x": 124.7324,
          "y": 150,
          "z": 8.1754
        },
        {
          "hole": 62,
          "x": 123.9306,
          "y": 150,
          "z": 16.3158
        },
        {
          "hole": 63,
          "x": 122.5981,
          "y": 150,
          "z": 24.3863
        },
        {
          "hole": 64,
          "x": 120.7407,
          "y": 150,
          "z": 32.3524
        },
        {
          "hole": 65,
          "x": 118.3663,
          "y": 150,
          "z": 40.1799
        },
        {
          "hole": 66,
          "x": 112.1091,
          "y": 150,
          "z": 55.2861
        },
        {
          "hole": 67,
          "x": 108.2532,
          "y": 150,
          "z": 62.5
        },
        {
          "hole": 68,
          "x": 103.9337,
          "y": 150,
          "z": 69.4463
        },
        {
          "hole": 69,
          "x": 99.1692,
          "y": 150,
          "z": 76.0952
        },
        {
          "hole": 70,
          "x": 93.98,
          "y": 150,
          "z": 82.4182
        },
        {
          "hole": 71,
          "x": 82.4182,
          "y": 150,
          "z": 93.98
        },
        {
          "hole": 72,
          "x": 76.0952,
          "y": 150,
          "z": 99.1692
        },
        {
          "hole": 73,
          "x": 69.4463,
          "y": 150,
          "z": 103.9337
        },
        {
          "hole": 74,
          "x": 62.5,
          "y": 150,
          "z": 108.2532
        },
        {
          "hole": 75,
          "x": 55.2861,
          "y": 150,
          "z": 112.1091
        },
        {
          "hole": 76,
          "x": 40.1799,
          "y": 150,
          "z": 118.3663
        },
        {
          "hole": 77,
          "x": 32.3524,
          "y": 150,
          "z": 120.7407
        },
        {
          "hole": 78,
          "x": 24.3863,
          "y": 150,
          "z": 122.5982
        },
        {
          "hole": 79,
          "x": 16.3158,
          "y": 150,
          "z": 123.9306
        },
        {
          "hole": 80,
          "x": 8.1754,
          "y": 150,
          "z": 124.7324
        },
        {
          "hole": 81,
          "x": -8.8294,
          "y": 140,
          "z": 124.711
        },
        {
          "hole": 82,
          "x": -17.621,
          "y": 140,
          "z": 123.8451
        },
        {
          "hole": 83,
          "x": -26.3372,
          "y": 140,
          "z": 122.406
        },
        {
          "hole": 84,
          "x": -34.9406,
          "y": 140,
          "z": 120.4
        },
        {
          "hole": 85,
          "x": -43.3943,
          "y": 140,
          "z": 117.8356
        },
        {
          "hole": 86,
          "x": -59.709,
          "y": 140,
          "z": 111.0778
        },
        {
          "hole": 87,
          "x": -67.5,
          "y": 140,
          "z": 106.9134
        },
        {
          "hole": 88,
          "x": -75.002,
          "y": 140,
          "z": 102.2484
        },
        {
          "hole": 89,
          "x": -82.1828,
          "y": 140,
          "z": 97.1027
        },
        {
          "hole": 90,
          "x": -89.0117,
          "y": 140,
          "z": 91.4984
        },
        {
          "hole": 91,
          "x": -101.4984,
          "y": 140,
          "z": 79.0117
        },
        {
          "hole": 92,
          "x": -107.1027,
          "y": 140,
          "z": 72.1828
        },
        {
          "hole": 93,
          "x": -112.2484,
          "y": 140,
          "z": 65.002
        },
        {
          "hole": 94,
          "x": -116.9134,
          "y": 140,
          "z": 57.5
        },
        {
          "hole": 95,
          "x": -121.0778,
          "y": 140,
          "z": 49.709
        },
        {
          "hole": 96,
          "x": -127.8356,
          "y": 140,
          "z": 33.3943
        },
        {
          "hole": 97,
          "x": -130.4,
          "y": 140,
          "z": 24.9406
        },
        {
          "hole": 98,
          "x": -132.406,
          "y": 140,
          "z": 16.3372
        },
        {
          "hole": 99,
          "x": -133.8451,
          "y": 140,
          "z": 7.621
        },
        {
          "hole": 100,
          "x": -134.711,
          "y": 140,
          "z": -1.1706
        },
        {
          "hole": 101,
          "x": -134.6895,
          "y": 130,
          "z": -19.4835
        },
        {
          "hole": 102,
          "x": -133.7595,
          "y": 130,
          "z": -28.9263
        },
        {
          "hole": 103,
          "x": -132.2139,
          "y": 130,
          "z": -38.2881
        },
        {
          "hole": 104,
          "x": -130.0592,
          "y": 130,
          "z": -47.5288
        },
        {
          "hole": 105,
          "x": -127.3049,
          "y": 130,
          "z": -56.6087
        },
        {
          "hole": 106,
          "x": -120.0465,
          "y": 130,
          "z": -74.1319
        },
        {
          "hole": 107,
          "x": -115.5737,
          "y": 130,
          "z": -82.5
        },
        {
          "hole": 108,
          "x": -110.5631,
          "y": 130,
          "z": -90.5577
        },
        {
          "hole": 109,
          "x": -105.0362,
          "y": 130,
          "z": -98.2704
        },
        {
          "hole": 110,
          "x": -99.0168,
          "y": 130,
          "z": -105.6051
        },
        {
          "hole": 111,
          "x": -85.6051,
          "y": 130,
          "z": -119.0168
        },
        {
          "hole": 112,
          "x": -78.2704,
          "y": 130,
          "z": -125.0362
        },
        {
          "hole": 113,
          "x": -70.5577,
          "y": 130,
          "z": -130.5631
        },
        {
          "hole": 114,
          "x": -62.5,
          "y": 130,
          "z": -135.5737
        },
        {
          "hole": 115,
          "x": -54.1318,
          "y": 130,
          "z": -140.0465
        },
        {
          "hole": 116,
          "x": -36.6087,
          "y": 130,
          "z": -147.3049
        },
        {
          "hole": 117,
          "x": -27.5287,
          "y": 130,
          "z": -150.0592
        },
        {
          "hole": 118,
          "x": -18.2881,
          "y": 130,
          "z": -152.2139
        },
        {
          "hole": 119,
          "x": -8.9263,
          "y": 130,
          "z": -153.7595
        },
        {
          "hole": 120,
          "x": 0.5166,
          "y": 130,
          "z": -154.6895
        },
        {
          "hole": 121,
          "x": 20.1375,
          "y": 120,
          "z": -154.6681
        },
        {
          "hole": 122,
          "x": 30.2316,
          "y": 120,
          "z": -153.674
        },
        {
          "hole": 123,
          "x": 40.239,
          "y": 120,
          "z": -152.0217
        },
        {
          "hole": 124,
          "x": 50.117,
          "y": 120,
          "z": -149.7185
        },
        {
          "hole": 125,
          "x": 59.8231,
          "y": 120,
          "z": -146.7742
        },
        {
          "hole": 126,
          "x": 78.5548,
          "y": 120,
          "z": -139.0153
        },
        {
          "hole": 127,
          "x": 87.5,
          "y": 120,
          "z": -134.2339
        },
        {
          "hole": 128,
          "x": 96.1134,
          "y": 120,
          "z": -128.8778
        },
        {
          "hole": 129,
          "x": 104.358,
          "y": 120,
          "z": -122.9698
        },
        {
          "hole": 130,
          "x": 112.1986,
          "y": 120,
          "z": -116.5352
        },
        {
          "hole": 131,
          "x": 126.5352,
          "y": 120,
          "z": -102.1986
        },
        {
          "hole": 132,
          "x": 132.9698,
          "y": 120,
          "z": -94.358
        },
        {
          "hole": 133,
          "x": 138.8778,
          "y": 120,
          "z": -86.1134
        },
        {
          "hole": 134,
          "x": 144.2339,
          "y": 120,
          "z": -77.5
        },
        {
          "hole": 135,
          "x": 149.0153,
          "y": 120,
          "z": -68.5547
        },
        {
          "hole": 136,
          "x": 156.7742,
          "y": 120,
          "z": -49.8231
        },
        {
          "hole": 137,
          "x": 159.7185,
          "y": 120,
          "z": -40.117
        },
        {
          "hole": 138,
          "x": 162.0217,
          "y": 120,
          "z": -30.239
        },
        {
          "hole": 139,
          "x": 163.6739,
          "y": 120,
          "z": -20.2316
        },
        {
          "hole": 140,
          "x": 164.6681,
          "y": 120,
          "z": -10.1375
        },
        {
          "hole": 141,
          "x": 164.843,
          "y": 110,
          "z": 7.1972
        },
        {
          "hole": 142,
          "x": 164.3721,
          "y": 110,
          "z": 14.3807
        },
        {
          "hole": 143,
          "x": 163.5884,
          "y": 110,
          "z": 21.5368
        },
        {
          "hole": 144,
          "x": 162.4933,
          "y": 110,
          "z": 28.6519
        },
        {
          "hole": 145,
          "x": 161.0888,
          "y": 110,
          "z": 35.7125
        },
        {
          "hole": 146,
          "x": 157.3633,
          "y": 110,
          "z": 49.6165
        },
        {
          "hole": 147,
          "x": 155.0493,
          "y": 110,
          "z": 56.4333
        },
        {
          "hole": 148,
          "x": 152.4401,
          "y": 110,
          "z": 63.1428
        },
        {
          "hole": 149,
          "x": 149.5408,
          "y": 110,
          "z": 69.732
        },
        {
          "hole": 150,
          "x": 146.3568,
          "y": 110,
          "z": 76.1885
        },
        {
          "hole": 151,
          "x": 139.1596,
          "y": 110,
          "z": 88.6544
        },
        {
          "hole": 152,
          "x": 135.1601,
          "y": 110,
          "z": 94.6401
        },
        {
          "hole": 153,
          "x": 130.9033,
          "y": 110,
          "z": 100.4456
        },
        {
          "hole": 154,
          "x": 126.3973,
          "y": 110,
          "z": 106.06
        },
        {
          "hole": 155,
          "x": 121.6508,
          "y": 110,
          "z": 111.4724
        },
        {
          "hole": 156,
          "x": 111.4724,
          "y": 110,
          "z": 121.6508
        },
        {
          "hole": 157,
          "x": 106.06,
          "y": 110,
          "z": 126.3973
        },
        {
          "hole": 158,
          "x": 100.4456,
          "y": 110,
          "z": 130.9033
        },
        {
          "hole": 159,
          "x": 94.6401,
          "y": 110,
          "z": 135.1601
        },
        {
          "hole": 160,
          "x": 88.6544,
          "y": 110,
          "z": 139.1596
        },
        {
          "hole": 161,
          "x": 76.1885,
          "y": 110,
          "z": 146.3568
        },
        {
          "hole": 162,
          "x": 69.732,
          "y": 110,
          "z": 149.5408
        },
        {
          "hole": 163,
          "x": 63.1428,
          "y": 110,
          "z": 152.4401
        },
        {
          "hole": 164,
          "x": 56.4333,
          "y": 110,
          "z": 155.0493
        },
        {
          "hole": 165,
          "x": 49.6165,
          "y": 110,
          "z": 157.3633
        },
        {
          "hole": 166,
          "x": 35.7125,
          "y": 110,
          "z": 161.0888
        },
        {
          "hole": 167,
          "x": 28.652,
          "y": 110,
          "z": 162.4933
        },
        {
          "hole": 168,
          "x": 21.5368,
          "y": 110,
          "z": 163.5884
        },
        {
          "hole": 169,
          "x": 14.3807,
          "y": 110,
          "z": 164.3721
        },
        {
          "hole": 170,
          "x": 7.1972,
          "y": 110,
          "z": 164.843
        },
        {
          "hole": 171,
          "x": -7.6334,
          "y": 100,
          "z": 164.8334
        },
        {
          "hole": 172,
          "x": -15.2523,
          "y": 100,
          "z": 164.3341
        },
        {
          "hole": 173,
          "x": -22.8421,
          "y": 100,
          "z": 163.5029
        },
        {
          "hole": 174,
          "x": -30.3884,
          "y": 100,
          "z": 162.3414
        },
        {
          "hole": 175,
          "x": -37.8769,
          "y": 100,
          "z": 160.8518
        },
        {
          "hole": 176,
          "x": -52.6235,
          "y": 100,
          "z": 156.9005
        },
        {
          "hole": 177,
          "x": -59.8535,
          "y": 100,
          "z": 154.4462
        },
        {
          "hole": 178,
          "x": -66.9696,
          "y": 100,
          "z": 151.6789
        },
        {
          "hole": 179,
          "x": -73.9582,
          "y": 100,
          "z": 148.6039
        },
        {
          "hole": 180,
          "x": -80.806,
          "y": 100,
          "z": 145.2269
        },
        {
          "hole": 181,
          "x": -94.0274,
          "y": 100,
          "z": 137.5935
        },
        {
          "hole": 182,
          "x": -100.3759,
          "y": 100,
          "z": 133.3516
        },
        {
          "hole": 183,
          "x": -106.5332,
          "y": 100,
          "z": 128.8368
        },
        {
          "hole": 184,
          "x": -112.4878,
          "y": 100,
          "z": 124.0578
        },
        {
          "hole": 185,
          "x": -118.2283,
          "y": 100,
          "z": 119.0235
        },
        {
          "hole": 186,
          "x": -129.0235,
          "y": 100,
          "z": 108.2283
        },
        {
          "hole": 187,
          "x": -134.0578,
          "y": 100,
          "z": 102.4878
        },
        {
          "hole": 188,
          "x": -138.8368,
          "y": 100,
          "z": 96.5332
        },
        {
          "hole": 189,
          "x": -143.3516,
          "y": 100,
          "z": 90.3759
        },
        {
          "hole": 190,
          "x": -147.5935,
          "y": 100,
          "z": 84.0274
        },
        {
          "hole": 191,
          "x": -155.2269,
          "y": 100,
          "z": 70.806
        },
        {
          "hole": 192,
          "x": -158.6039,
          "y": 100,
          "z": 63.9582
        },
        {
          "hole": 193,
          "x": -161.6789,
          "y": 100,
          "z": 56.9696
        },
        {
          "hole": 194,
          "x": -164.4462,
          "y": 100,
          "z": 49.8535
        },
        {
          "hole": 195,
          "x": -166.9005,
          "y": 100,
          "z": 42.6235
        },
        {
          "hole": 196,
          "x": -170.8518,
          "y": 100,
          "z": 27.8769
        },
        {
          "hole": 197,
          "x": -172.3414,
          "y": 100,
          "z": 20.3884
        },
        {
          "hole": 198,
          "x": -173.5028,
          "y": 100,
          "z": 12.8421
        },
        {
          "hole": 199,
          "x": -174.3341,
          "y": 100,
          "z": 5.2522
        },
        {
          "hole": 200,
          "x": -174.8334,
          "y": 100,
          "z": -2.3666
        },
        {
          "hole": 201,
          "x": -174.8239,
          "y": 90,
          "z": -18.0696
        },
        {
          "hole": 202,
          "x": -174.296,
          "y": 90,
          "z": -26.1238
        },
        {
          "hole": 203,
          "x": -173.4173,
          "y": 90,
          "z": -34.1473
        },
        {
          "hole": 204,
          "x": -172.1894,
          "y": 90,
          "z": -42.1249
        },
        {
          "hole": 205,
          "x": -170.6148,
          "y": 90,
          "z": -50.0413
        },
        {
          "hole": 206,
          "x": -166.4376,
          "y": 90,
          "z": -65.6306
        },
        {
          "hole": 207,
          "x": -163.8431,
          "y": 90,
          "z": -73.2737
        },
        {
          "hole": 208,
          "x": -160.9177,
          "y": 90,
          "z": -80.7964
        },
        {
          "hole": 209,
          "x": -157.667,
          "y": 90,
          "z": -88.1844
        },
        {
          "hole": 210,
          "x": -154.097,
          "y": 90,
          "z": -95.4235
        },
        {
          "hole": 211,
          "x": -146.0274,
          "y": 90,
          "z": -109.4004
        },
        {
          "hole": 212,
          "x": -141.5431,
          "y": 90,
          "z": -116.1116
        },
        {
          "hole": 213,
          "x": -136.7704,
          "y": 90,
          "z": -122.6209
        },
        {
          "hole": 214,
          "x": -131.7182,
          "y": 90,
          "z": -128.9157
        },
        {
          "hole": 215,
          "x": -126.3963,
          "y": 90,
          "z": -134.9842
        },
        {
          "hole": 216,
          "x": -114.9842,
          "y": 90,
          "z": -146.3963
        },
        {
          "hole": 217,
          "x": -108.9157,
          "y": 90,
          "z": -151.7182
        },
        {
          "hole": 218,
          "x": -102.6209,
          "y": 90,
          "z": -156.7704
        },
        {
          "hole": 219,
          "x": -96.1117,
          "y": 90,
          "z": -161.5431
        },
        {
          "hole": 220,
          "x": -89.4004,
          "y": 90,
          "z": -166.0274
        },
        {
          "hole": 221,
          "x": -75.4235,
          "y": 90,
          "z": -174.097
        },
        {
          "hole": 222,
          "x": -68.1844,
          "y": 90,
          "z": -177.6669
        },
        {
          "hole": 223,
          "x": -60.7964,
          "y": 90,
          "z": -180.9177
        },
        {
          "hole": 224,
          "x": -53.2737,
          "y": 90,
          "z": -183.8431
        },
        {
          "hole": 225,
          "x": -45.6306,
          "y": 90,
          "z": -186.4376
        },
        {
          "hole": 226,
          "x": -30.0413,
          "y": 90,
          "z": -190.6147
        },
        {
          "hole": 227,
          "x": -22.1249,
          "y": 90,
          "z": -192.1894
        },
        {
          "hole": 228,
          "x": -14.1474,
          "y": 90,
          "z": -193.4173
        },
        {
          "hole": 229,
          "x": -6.1238,
          "y": 90,
          "z": -194.296
        },
        {
          "hole": 230,
          "x": 1.9304,
          "y": 90,
          "z": -194.8239
        },
        {
          "hole": 231,
          "x": 18.5058,
          "y": 80,
          "z": -194.8144
        },
        {
          "hole": 232,
          "x": 26.9954,
          "y": 80,
          "z": -194.258
        },
        {
          "hole": 233,
          "x": 35.4526,
          "y": 80,
          "z": -193.3317
        },
        {
          "hole": 234,
          "x": 43.8614,
          "y": 80,
          "z": -192.0375
        },
        {
          "hole": 235,
          "x": 52.2057,
          "y": 80,
          "z": -190.3777
        },
        {
          "hole": 236,
          "x": 68.6376,
          "y": 80,
          "z": -185.9748
        },
        {
          "hole": 237,
          "x": 76.6939,
          "y": 80,
          "z": -183.24
        },
        {
          "hole": 238,
          "x": 84.6233,
          "y": 80,
          "z": -180.1565
        },
        {
          "hole": 239,
          "x": 92.4106,
          "y": 80,
          "z": -176.73
        },
        {
          "hole": 240,
          "x": 100.041,
          "y": 80,
          "z": -172.9671
        },
        {
          "hole": 241,
          "x": 114.7734,
          "y": 80,
          "z": -164.4613
        },
        {
          "hole": 242,
          "x": 121.8474,
          "y": 80,
          "z": -159.7346
        },
        {
          "hole": 243,
          "x": 128.7085,
          "y": 80,
          "z": -154.7039
        },
        {
          "hole": 244,
          "x": 135.3436,
          "y": 80,
          "z": -149.3786
        },
        {
          "hole": 245,
          "x": 141.7401,
          "y": 80,
          "z": -143.7691
        },
        {
          "hole": 246,
          "x": 153.7691,
          "y": 80,
          "z": -131.7401
        },
        {
          "hole": 247,
          "x": 159.3787,
          "y": 80,
          "z": -125.3436
        },
        {
          "hole": 248,
          "x": 164.7039,
          "y": 80,
          "z": -118.7085
        },
        {
          "hole": 249,
          "x": 169.7346,
          "y": 80,
          "z": -111.8474
        },
        {
          "hole": 250,
          "x": 174.4613,
          "y": 80,
          "z": -104.7734
        },
        {
          "hole": 251,
          "x": 182.9671,
          "y": 80,
          "z": -90.041
        },
        {
          "hole": 252,
          "x": 186.73,
          "y": 80,
          "z": -82.4105
        },
        {
          "hole": 253,
          "x": 190.1565,
          "y": 80,
          "z": -74.6233
        },
        {
          "hole": 254,
          "x": 193.2401,
          "y": 80,
          "z": -66.6939
        },
        {
          "hole": 255,
          "x": 195.9748,
          "y": 80,
          "z": -58.6376
        },
        {
          "hole": 256,
          "x": 200.3777,
          "y": 80,
          "z": -42.2057
        },
        {
          "hole": 257,
          "x": 202.0375,
          "y": 80,
          "z": -33.8614
        },
        {
          "hole": 258,
          "x": 203.3317,
          "y": 80,
          "z": -25.4526
        },
        {
          "hole": 259,
          "x": 204.258,
          "y": 80,
          "z": -16.9953
        },
        {
          "hole": 260,
          "x": 204.8144,
          "y": 80,
          "z": -8.5058
        },
        {
          "hole": 261,
          "x": 204.8902,
          "y": 70,
          "z": 6.7074
        },
        {
          "hole": 262,
          "x": 204.5611,
          "y": 70,
          "z": 13.4076
        },
        {
          "hole": 263,
          "x": 204.0129,
          "y": 70,
          "z": 20.0935
        },
        {
          "hole": 264,
          "x": 203.2462,
          "y": 70,
          "z": 26.7579
        },
        {
          "hole": 265,
          "x": 202.2619,
          "y": 70,
          "z": 33.3936
        },
        {
          "hole": 266,
          "x": 199.6448,
          "y": 70,
          "z": 46.5506
        },
        {
          "hole": 267,
          "x": 198.0148,
          "y": 70,
          "z": 53.0579
        },
        {
          "hole": 268,
          "x": 196.1728,
          "y": 70,
          "z": 59.5084
        },
        {
          "hole": 269,
          "x": 194.1207,
          "y": 70,
          "z": 65.8951
        },
        {
          "hole": 270,
          "x": 191.8607,
          "y": 70,
          "z": 72.2113
        },
        {
          "hole": 271,
          "x": 186.7271,
          "y": 70,
          "z": 84.6049
        },
        {
          "hole": 272,
          "x": 183.8589,
          "y": 70,
          "z": 90.6692
        },
        {
          "hole": 273,
          "x": 180.7939,
          "y": 70,
          "z": 96.6363
        },
        {
          "hole": 274,
          "x": 177.5352,
          "y": 70,
          "z": 102.5
        },
        {
          "hole": 275,
          "x": 174.0864,
          "y": 70,
          "z": 108.2539
        },
        {
          "hole": 276,
          "x": 166.6336,
          "y": 70,
          "z": 119.4079
        },
        {
          "hole": 277,
          "x": 162.6374,
          "y": 70,
          "z": 124.7961
        },
        {
          "hole": 278,
          "x": 158.4671,
          "y": 70,
          "z": 130.0506
        },
        {
          "hole": 279,
          "x": 154.1272,
          "y": 70,
          "z": 135.1659
        },
        {
          "hole": 280,
          "x": 149.6221,
          "y": 70,
          "z": 140.1364
        },
        {
          "hole": 281,
          "x": 140.1364,
          "y": 70,
          "z": 149.6221
        },
        {
          "hole": 282,
          "x": 135.1659,
          "y": 70,
          "z": 154.1272
        },
        {
          "hole": 283,
          "x": 130.0506,
          "y": 70,
          "z": 158.4671
        },
        {
          "hole": 284,
          "x": 124.7961,
          "y": 70,
          "z": 162.6374
        },
        {
          "hole": 285,
          "x": 119.4079,
          "y": 70,
          "z": 166.6336
        },
        {
          "hole": 286,
          "x": 108.2539,
          "y": 70,
          "z": 174.0864
        },
        {
          "hole": 287,
          "x": 102.5,
          "y": 70,
          "z": 177.5352
        },
        {
          "hole": 288,
          "x": 96.6363,
          "y": 70,
          "z": 180.7939
        },
        {
          "hole": 289,
          "x": 90.6692,
          "y": 70,
          "z": 183.8589
        },
        {
          "hole": 290,
          "x": 84.6049,
          "y": 70,
          "z": 186.7271
        },
        {
          "hole": 291,
          "x": 72.2113,
          "y": 70,
          "z": 191.8607
        },
        {
          "hole": 292,
          "x": 65.8951,
          "y": 70,
          "z": 194.1207
        },
        {
          "hole": 293,
          "x": 59.5084,
          "y": 70,
          "z": 196.1728
        },
        {
          "hole": 294,
          "x": 53.0579,
          "y": 70,
          "z": 198.0148
        },
        {
          "hole": 295,
          "x": 46.5506,
          "y": 70,
          "z": 199.6448
        },
        {
          "hole": 296,
          "x": 33.3936,
          "y": 70,
          "z": 202.2619
        },
        {
          "hole": 297,
          "x": 26.7579,
          "y": 70,
          "z": 203.2462
        },
        {
          "hole": 298,
          "x": 20.0935,
          "y": 70,
          "z": 204.0129
        },
        {
          "hole": 299,
          "x": 13.4077,
          "y": 70,
          "z": 204.5611
        },
        {
          "hole": 300,
          "x": 6.7074,
          "y": 70,
          "z": 204.8902
        },
        {
          "hole": 301,
          "x": -7.0346,
          "y": 60,
          "z": 204.8849
        },
        {
          "hole": 302,
          "x": -14.0617,
          "y": 60,
          "z": 204.5397
        },
        {
          "hole": 303,
          "x": -21.0737,
          "y": 60,
          "z": 203.9647
        },
        {
          "hole": 304,
          "x": -28.0631,
          "y": 60,
          "z": 203.1606
        },
        {
          "hole": 305,
          "x": -35.0225,
          "y": 60,
          "z": 202.1283
        },
        {
          "hole": 306,
          "x": -48.8214,
          "y": 60,
          "z": 199.3835
        },
        {
          "hole": 307,
          "x": -55.6461,
          "y": 60,
          "z": 197.674
        },
        {
          "hole": 308,
          "x": -62.4112,
          "y": 60,
          "z": 195.7422
        },
        {
          "hole": 309,
          "x": -69.1095,
          "y": 60,
          "z": 193.59
        },
        {
          "hole": 310,
          "x": -75.7338,
          "y": 60,
          "z": 191.2198
        },
        {
          "hole": 311,
          "x": -88.732,
          "y": 60,
          "z": 185.8357
        },
        {
          "hole": 312,
          "x": -95.0921,
          "y": 60,
          "z": 182.8276
        },
        {
          "hole": 313,
          "x": -101.3503,
          "y": 60,
          "z": 179.6131
        },
        {
          "hole": 314,
          "x": -107.5,
          "y": 60,
          "z": 176.1955
        },
        {
          "hole": 315,
          "x": -113.5346,
          "y": 60,
          "z": 172.5785
        },
        {
          "hole": 316,
          "x": -125.2327,
          "y": 60,
          "z": 164.762
        },
        {
          "hole": 317,
          "x": -130.8837,
          "y": 60,
          "z": 160.571
        },
        {
          "hole": 318,
          "x": -136.3946,
          "y": 60,
          "z": 156.1972
        },
        {
          "hole": 319,
          "x": -141.7594,
          "y": 60,
          "z": 151.6456
        },
        {
          "hole": 320,
          "x": -146.9723,
          "y": 60,
          "z": 146.9208
        },
        {
          "hole": 321,
          "x": -156.9208,
          "y": 60,
          "z": 136.9723
        },
        {
          "hole": 322,
          "x": -161.6456,
          "y": 60,
          "z": 131.7593
        },
        {
          "hole": 323,
          "x": -166.1972,
          "y": 60,
          "z": 126.3946
        },
        {
          "hole": 324,
          "x": -170.571,
          "y": 60,
          "z": 120.8837
        },
        {
          "hole": 325,
          "x": -174.762,
          "y": 60,
          "z": 115.2327
        },
        {
          "hole": 326,
          "x": -182.5785,
          "y": 60,
          "z": 103.5346
        },
        {
          "hole": 327,
          "x": -186.1955,
          "y": 60,
          "z": 97.5
        },
        {
          "hole": 328,
          "x": -189.6131,
          "y": 60,
          "z": 91.3503
        },
        {
          "hole": 329,
          "x": -192.8276,
          "y": 60,
          "z": 85.0921
        },
        {
          "hole": 330,
          "x": -195.8357,
          "y": 60,
          "z": 78.732
        },
        {
          "hole": 331,
          "x": -201.2198,
          "y": 60,
          "z": 65.7338
        },
        {
          "hole": 332,
          "x": -203.59,
          "y": 60,
          "z": 59.1095
        },
        {
          "hole": 333,
          "x": -205.7422,
          "y": 60,
          "z": 52.4112
        },
        {
          "hole": 334,
          "x": -207.674,
          "y": 60,
          "z": 45.6461
        },
        {
          "hole": 335,
          "x": -209.3835,
          "y": 60,
          "z": 38.8214
        },
        {
          "hole": 336,
          "x": -212.1283,
          "y": 60,
          "z": 25.0225
        },
        {
          "hole": 337,
          "x": -213.1606,
          "y": 60,
          "z": 18.0631
        },
        {
          "hole": 338,
          "x": -213.9647,
          "y": 60,
          "z": 11.0737
        },
        {
          "hole": 339,
          "x": -214.5397,
          "y": 60,
          "z": 4.0617
        },
        {
          "hole": 340,
          "x": -214.8849,
          "y": 60,
          "z": -2.9654
        },
        {
          "hole": 341,
          "x": -214.8795,
          "y": 50,
          "z": -17.3618
        },
        {
          "hole": 342,
          "x": -214.5183,
          "y": 50,
          "z": -24.7157
        },
        {
          "hole": 343,
          "x": -213.9166,
          "y": 50,
          "z": -32.0539
        },
        {
          "hole": 344,
          "x": -213.0751,
          "y": 50,
          "z": -39.3684
        },
        {
          "hole": 345,
          "x": -211.9947,
          "y": 50,
          "z": -46.6515
        },
        {
          "hole": 346,
          "x": -209.1223,
          "y": 50,
          "z": -61.0922
        },
        {
          "hole": 347,
          "x": -207.3333,
          "y": 50,
          "z": -68.2343
        },
        {
          "hole": 348,
          "x": -205.3116,
          "y": 50,
          "z": -75.3141
        },
        {
          "hole": 349,
          "x": -203.0593,
          "y": 50,
          "z": -82.3239
        },
        {
          "hole": 350,
          "x": -200.5788,
          "y": 50,
          "z": -89.2563
        },
        {
          "hole": 351,
          "x": -194.9444,
          "y": 50,
          "z": -102.8591
        },
        {
          "hole": 352,
          "x": -191.7964,
          "y": 50,
          "z": -109.515
        },
        {
          "hole": 353,
          "x": -188.4323,
          "y": 50,
          "z": -116.0643
        },
        {
          "hole": 354,
          "x": -184.8557,
          "y": 50,
          "z": -122.5
        },
        {
          "hole": 355,
          "x": -181.0705,
          "y": 50,
          "z": -128.8153
        },
        {
          "hole": 356,
          "x": -172.8905,
          "y": 50,
          "z": -141.0575
        },
        {
          "hole": 357,
          "x": -168.5045,
          "y": 50,
          "z": -146.9713
        },
        {
          "hole": 358,
          "x": -163.9273,
          "y": 50,
          "z": -152.7385
        },
        {
          "hole": 359,
          "x": -159.164,
          "y": 50,
          "z": -158.3528
        },
        {
          "hole": 360,
          "x": -154.2194,
          "y": 50,
          "z": -163.8083
        },
        {
          "hole": 361,
          "x": -143.8083,
          "y": 50,
          "z": -174.2194
        },
        {
          "hole": 362,
          "x": -138.3528,
          "y": 50,
          "z": -179.164
        },
        {
          "hole": 363,
          "x": -132.7385,
          "y": 50,
          "z": -183.9273
        },
        {
          "hole": 364,
          "x": -126.9713,
          "y": 50,
          "z": -188.5045
        },
        {
          "hole": 365,
          "x": -121.0575,
          "y": 50,
          "z": -192.8905
        },
        {
          "hole": 366,
          "x": -108.8153,
          "y": 50,
          "z": -201.0705
        },
        {
          "hole": 367,
          "x": -102.5,
          "y": 50,
          "z": -204.8557
        },
        {
          "hole": 368,
          "x": -96.0643,
          "y": 50,
          "z": -208.4323
        },
        {
          "hole": 369,
          "x": -89.515,
          "y": 50,
          "z": -211.7964
        },
        {
          "hole": 370,
          "x": -82.8591,
          "y": 50,
          "z": -214.9444
        },
        {
          "hole": 371,
          "x": -69.2562,
          "y": 50,
          "z": -220.5788
        },
        {
          "hole": 372,
          "x": -62.3239,
          "y": 50,
          "z": -223.0593
        },
        {
          "hole": 373,
          "x": -55.314,
          "y": 50,
          "z": -225.3116
        },
        {
          "hole": 374,
          "x": -48.2343,
          "y": 50,
          "z": -227.3333
        },
        {
          "hole": 375,
          "x": -41.0921,
          "y": 50,
          "z": -229.1223
        },
        {
          "hole": 376,
          "x": -26.6515,
          "y": 50,
          "z": -231.9947
        },
        {
          "hole": 377,
          "x": -19.3684,
          "y": 50,
          "z": -233.0751
        },
        {
          "hole": 378,
          "x": -12.0539,
          "y": 50,
          "z": -233.9165
        },
        {
          "hole": 379,
          "x": -4.7157,
          "y": 50,
          "z": -234.5182
        },
        {
          "hole": 380,
          "x": 2.6382,
          "y": 50,
          "z": -234.8795
        },
        {
          "hole": 381,
          "x": 17.689,
          "y": 40,
          "z": -234.8742
        },
        {
          "hole": 382,
          "x": 25.3697,
          "y": 40,
          "z": -234.4969
        },
        {
          "hole": 383,
          "x": 33.034,
          "y": 40,
          "z": -233.8684
        },
        {
          "hole": 384,
          "x": 40.6737,
          "y": 40,
          "z": -232.9896
        },
        {
          "hole": 385,
          "x": 48.2804,
          "y": 40,
          "z": -231.8612
        },
        {
          "hole": 386,
          "x": 63.363,
          "y": 40,
          "z": -228.8611
        },
        {
          "hole": 387,
          "x": 70.8225,
          "y": 40,
          "z": -226.9926
        },
        {
          "hole": 388,
          "x": 78.2169,
          "y": 40,
          "z": -224.881
        },
        {
          "hole": 389,
          "x": 85.5383,
          "y": 40,
          "z": -222.5286
        },
        {
          "hole": 390,
          "x": 92.7788,
          "y": 40,
          "z": -219.9379
        },
        {
          "hole": 391,
          "x": 106.9862,
          "y": 40,
          "z": -214.053
        },
        {
          "hole": 392,
          "x": 113.9379,
          "y": 40,
          "z": -210.7651
        },
        {
          "hole": 393,
          "x": 120.7782,
          "y": 40,
          "z": -207.2515
        },
        {
          "hole": 394,
          "x": 127.5,
          "y": 40,
          "z": -203.516
        },
        {
          "hole": 395,
          "x": 134.096,
          "y": 40,
          "z": -199.5625
        },
        {
          "hole": 396,
          "x": 146.8823,
          "y": 40,
          "z": -191.019
        },
        {
          "hole": 397,
          "x": 153.0589,
          "y": 40,
          "z": -186.438
        },
        {
          "hole": 398,
          "x": 159.0824,
          "y": 40,
          "z": -181.6575
        },
        {
          "hole": 399,
          "x": 164.9463,
          "y": 40,
          "z": -176.6824
        },
        {
          "hole": 400,
          "x": 170.6442,
          "y": 40,
          "z": -171.5181
        },
        {
          "hole": 401,
          "x": 181.5181,
          "y": 40,
          "z": -160.6442
        },
        {
          "hole": 402,
          "x": 186.6824,
          "y": 40,
          "z": -154.9463
        },
        {
          "hole": 403,
          "x": 191.6575,
          "y": 40,
          "z": -149.0824
        },
        {
          "hole": 404,
          "x": 196.438,
          "y": 40,
          "z": -143.0589
        },
        {
          "hole": 405,
          "x": 201.019,
          "y": 40,
          "z": -136.8823
        },
        {
          "hole": 406,
          "x": 209.5625,
          "y": 40,
          "z": -124.096
        },
        {
          "hole": 407,
          "x": 213.516,
          "y": 40,
          "z": -117.5
        },
        {
          "hole": 408,
          "x": 217.2515,
          "y": 40,
          "z": -110.7783
        },
        {
          "hole": 409,
          "x": 220.7651,
          "y": 40,
          "z": -103.9379
        },
        {
          "hole": 410,
          "x": 224.053,
          "y": 40,
          "z": -96.9862
        },
        {
          "hole": 411,
          "x": 229.9379,
          "y": 40,
          "z": -82.7788
        },
        {
          "hole": 412,
          "x": 232.5286,
          "y": 40,
          "z": -75.5383
        },
        {
          "hole": 413,
          "x": 234.881,
          "y": 40,
          "z": -68.2169
        },
        {
          "hole": 414,
          "x": 236.9926,
          "y": 40,
          "z": -60.8225
        },
        {
          "hole": 415,
          "x": 238.8611,
          "y": 40,
          "z": -53.3629
        },
        {
          "hole": 416,
          "x": 241.8612,
          "y": 40,
          "z": -38.2804
        },
        {
          "hole": 417,
          "x": 242.9895,
          "y": 40,
          "z": -30.6737
        },
        {
          "hole": 418,
          "x": 243.8684,
          "y": 40,
          "z": -23.034
        },
        {
          "hole": 419,
          "x": 244.4968,
          "y": 40,
          "z": -15.3697
        },
        {
          "hole": 420,
          "x": 244.8742,
          "y": 40,
          "z": -7.689
        },
        {
          "hole": 421,
          "x": 244.8688,
          "y": 30,
          "z": 8.0162
        },
        {
          "hole": 422,
          "x": 244.4754,
          "y": 30,
          "z": 16.0238
        },
        {
          "hole": 423,
          "x": 243.8203,
          "y": 30,
          "z": 24.0142
        },
        {
          "hole": 424,
          "x": 242.904,
          "y": 30,
          "z": 31.9789
        },
        {
          "hole": 425,
          "x": 241.7276,
          "y": 30,
          "z": 39.9094
        },
        {
          "hole": 426,
          "x": 238.5999,
          "y": 30,
          "z": 55.6337
        },
        {
          "hole": 427,
          "x": 236.6518,
          "y": 30,
          "z": 63.4107
        },
        {
          "hole": 428,
          "x": 234.4504,
          "y": 30,
          "z": 71.1197
        },
        {
          "hole": 429,
          "x": 231.9979,
          "y": 30,
          "z": 78.7527
        },
        {
          "hole": 430,
          "x": 229.2969,
          "y": 30,
          "z": 86.3013
        },
        {
          "hole": 431,
          "x": 223.1616,
          "y": 30,
          "z": 101.1132
        },
        {
          "hole": 432,
          "x": 219.7338,
          "y": 30,
          "z": 108.3607
        },
        {
          "hole": 433,
          "x": 216.0707,
          "y": 30,
          "z": 115.4922
        },
        {
          "hole": 434,
          "x": 212.1762,
          "y": 30,
          "z": 122.5
        },
        {
          "hole": 435,
          "x": 208.0545,
          "y": 30,
          "z": 129.3766
        },
        {
          "hole": 436,
          "x": 199.1474,
          "y": 30,
          "z": 142.707
        },
        {
          "hole": 437,
          "x": 194.3716,
          "y": 30,
          "z": 149.1466
        },
        {
          "hole": 438,
          "x": 189.3876,
          "y": 30,
          "z": 155.4264
        },
        {
          "hole": 439,
          "x": 184.2007,
          "y": 30,
          "z": 161.5397
        },
        {
          "hole": 440,
          "x": 178.8167,
          "y": 30,
          "z": 167.4801
        },
        {
          "hole": 441,
          "x": 167.4801,
          "y": 30,
          "z": 178.8167
        },
        {
          "hole": 442,
          "x": 161.5397,
          "y": 30,
          "z": 184.2008
        },
        {
          "hole": 443,
          "x": 155.4264,
          "y": 30,
          "z": 189.3876
        },
        {
          "hole": 444,
          "x": 149.1465,
          "y": 30,
          "z": 194.3716
        },
        {
          "hole": 445,
          "x": 142.707,
          "y": 30,
          "z": 199.1474
        },
        {
          "hole": 446,
          "x": 129.3766,
          "y": 30,
          "z": 208.0545
        },
        {
          "hole": 447,
          "x": 122.5,
          "y": 30,
          "z": 212.1762
        },
        {
          "hole": 448,
          "x": 115.4922,
          "y": 30,
          "z": 216.0707
        },
        {
          "hole": 449,
          "x": 108.3607,
          "y": 30,
          "z": 219.7338
        },
        {
          "hole": 450,
          "x": 101.1132,
          "y": 30,
          "z": 223.1616
        },
        {
          "hole": 451,
          "x": 86.3013,
          "y": 30,
          "z": 229.2969
        },
        {
          "hole": 452,
          "x": 78.7527,
          "y": 30,
          "z": 231.9979
        },
        {
          "hole": 453,
          "x": 71.1198,
          "y": 30,
          "z": 234.4504
        },
        {
          "hole": 454,
          "x": 63.4107,
          "y": 30,
          "z": 236.6518
        },
        {
          "hole": 455,
          "x": 55.6337,
          "y": 30,
          "z": 238.5999
        },
        {
          "hole": 456,
          "x": 39.9094,
          "y": 30,
          "z": 241.7276
        },
        {
          "hole": 457,
          "x": 31.979,
          "y": 30,
          "z": 242.904
        },
        {
          "hole": 458,
          "x": 24.0142,
          "y": 30,
          "z": 243.8203
        },
        {
          "hole": 459,
          "x": 16.0238,
          "y": 30,
          "z": 244.4754
        },
        {
          "hole": 460,
          "x": 8.0162,
          "y": 30,
          "z": 244.8688
        },
        {
          "hole": 461,
          "x": -8.3434,
          "y": 20,
          "z": 244.8635
        },
        {
          "hole": 462,
          "x": -16.6778,
          "y": 20,
          "z": 244.454
        },
        {
          "hole": 463,
          "x": -24.9944,
          "y": 20,
          "z": 243.7721
        },
        {
          "hole": 464,
          "x": -33.2842,
          "y": 20,
          "z": 242.8184
        },
        {
          "hole": 465,
          "x": -41.5383,
          "y": 20,
          "z": 241.594
        },
        {
          "hole": 466,
          "x": -57.9045,
          "y": 20,
          "z": 238.3386
        },
        {
          "hole": 467,
          "x": -65.9989,
          "y": 20,
          "z": 236.3111
        },
        {
          "hole": 468,
          "x": -74.0226,
          "y": 20,
          "z": 234.0198
        },
        {
          "hole": 469,
          "x": -81.9671,
          "y": 20,
          "z": 231.4672
        },
        {
          "hole": 470,
          "x": -89.8238,
          "y": 20,
          "z": 228.656
        },
        {
          "hole": 471,
          "x": -105.2403,
          "y": 20,
          "z": 222.2703
        },
        {
          "hole": 472,
          "x": -112.7836,
          "y": 20,
          "z": 218.7025
        },
        {
          "hole": 473,
          "x": -120.2062,
          "y": 20,
          "z": 214.8899
        },
        {
          "hole": 474,
          "x": -127.5,
          "y": 20,
          "z": 210.8365
        },
        {
          "hole": 475,
          "x": -134.6573,
          "y": 20,
          "z": 206.5465
        },
        {
          "hole": 476,
          "x": -148.5318,
          "y": 20,
          "z": 197.2759
        },
        {
          "hole": 477,
          "x": -155.2342,
          "y": 20,
          "z": 192.3051
        },
        {
          "hole": 478,
          "x": -161.7703,
          "y": 20,
          "z": 187.1177
        },
        {
          "hole": 479,
          "x": -168.1332,
          "y": 20,
          "z": 181.7191
        },
        {
          "hole": 480,
          "x": -174.316,
          "y": 20,
          "z": 176.1153
        },
        {
          "hole": 481,
          "x": 40,
          "y": 240,
          "z": -6.25
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": -212.1762,
          "y": 10,
          "z": 112.5
        },
        {
          "hole": 1,
          "x": 33.8074,
          "y": 230,
          "z": 9.0587
        },
        {
          "hole": 2,
          "x": 30.3109,
          "y": 230,
          "z": 17.5
        },
        {
          "hole": 3,
          "x": 24.7487,
          "y": 230,
          "z": 24.7487
        },
        {
          "hole": 4,
          "x": 17.5,
          "y": 230,
          "z": 30.3109
        },
        {
          "hole": 5,
          "x": 9.0587,
          "y": 230,
          "z": 33.8074
        },
        {
          "hole": 6,
          "x": -11.6469,
          "y": 220,
          "z": 33.4667
        },
        {
          "hole": 7,
          "x": -22.5,
          "y": 220,
          "z": 28.9711
        },
        {
          "hole": 8,
          "x": -31.8198,
          "y": 220,
          "z": 21.8198
        },
        {
          "hole": 9,
          "x": -38.9711,
          "y": 220,
          "z": 12.5
        },
        {
          "hole": 10,
          "x": -43.4667,
          "y": 220,
          "z": 1.6469
        },
        {
          "hole": 11,
          "x": -43.1259,
          "y": 210,
          "z": -24.235
        },
        {
          "hole": 12,
          "x": -37.6314,
          "y": 210,
          "z": -37.5
        },
        {
          "hole": 13,
          "x": -28.8909,
          "y": 210,
          "z": -48.8909
        },
        {
          "hole": 14,
          "x": -17.5,
          "y": 210,
          "z": -57.6314
        },
        {
          "hole": 15,
          "x": -4.235,
          "y": 210,
          "z": -63.1259
        },
        {
          "hole": 16,
          "x": 26.8232,
          "y": 200,
          "z": -62.7852
        },
        {
          "hole": 17,
          "x": 42.5,
          "y": 200,
          "z": -56.2917
        },
        {
          "hole": 18,
          "x": 55.9619,
          "y": 200,
          "z": -45.9619
        },
        {
          "hole": 19,
          "x": 66.2917,
          "y": 200,
          "z": -32.5
        },
        {
          "hole": 20,
          "x": 72.7852,
          "y": 200,
          "z": -16.8232
        },
        {
          "hole": 21,
          "x": 74.3584,
          "y": 190,
          "z": 9.7895
        },
        {
          "hole": 22,
          "x": 72.4444,
          "y": 190,
          "z": 19.4114
        },
        {
          "hole": 23,
          "x": 69.291,
          "y": 190,
          "z": 28.7013
        },
        {
          "hole": 24,
          "x": 64.9519,
          "y": 190,
          "z": 37.5
        },
        {
          "hole": 25,
          "x": 59.5015,
          "y": 190,
          "z": 45.6571
        },
        {
          "hole": 26,
          "x": 45.6571,
          "y": 190,
          "z": 59.5015
        },
        {
          "hole": 27,
          "x": 37.5,
          "y": 190,
          "z": 64.9519
        },
        {
          "hole": 28,
          "x": 28.7013,
          "y": 190,
          "z": 69.2909
        },
        {
          "hole": 29,
          "x": 19.4114,
          "y": 190,
          "z": 72.4444
        },
        {
          "hole": 30,
          "x": 9.7895,
          "y": 190,
          "z": 74.3583
        },
        {
          "hole": 31,
          "x": -11.0947,
          "y": 180,
          "z": 74.2728
        },
        {
          "hole": 32,
          "x": -21.9996,
          "y": 180,
          "z": 72.1037
        },
        {
          "hole": 33,
          "x": -32.5281,
          "y": 180,
          "z": 68.5298
        },
        {
          "hole": 34,
          "x": -42.5,
          "y": 180,
          "z": 63.6122
        },
        {
          "hole": 35,
          "x": -51.7447,
          "y": 180,
          "z": 57.435
        },
        {
          "hole": 36,
          "x": -67.435,
          "y": 180,
          "z": 41.7447
        },
        {
          "hole": 37,
          "x": -73.6122,
          "y": 180,
          "z": 32.5
        },
        {
          "hole": 38,
          "x": -78.5298,
          "y": 180,
          "z": 22.5281
        },
        {
          "hole": 39,
          "x": -82.1037,
          "y": 180,
          "z": 11.9996
        },
        {
          "hole": 40,
          "x": -84.2728,
          "y": 180,
          "z": 1.0947
        },
        {
          "hole": 41,
          "x": -84.1873,
          "y": 170,
          "z": -22.4
        },
        {
          "hole": 42,
          "x": -81.763,
          "y": 170,
          "z": -34.5878
        },
        {
          "hole": 43,
          "x": -77.7686,
          "y": 170,
          "z": -46.3549
        },
        {
          "hole": 44,
          "x": -72.2724,
          "y": 170,
          "z": -57.5
        },
        {
          "hole": 45,
          "x": -65.3686,
          "y": 170,
          "z": -67.8323
        },
        {
          "hole": 46,
          "x": -47.8323,
          "y": 170,
          "z": -85.3686
        },
        {
          "hole": 47,
          "x": -37.5,
          "y": 170,
          "z": -92.2724
        },
        {
          "hole": 48,
          "x": -26.3549,
          "y": 170,
          "z": -97.7686
        },
        {
          "hole": 49,
          "x": -14.5878,
          "y": 170,
          "z": -101.763
        },
        {
          "hole": 50,
          "x": -2.4,
          "y": 170,
          "z": -104.1873
        },
        {
          "hole": 51,
          "x": 23.7053,
          "y": 160,
          "z": -104.1017
        },
        {
          "hole": 52,
          "x": 37.176,
          "y": 160,
          "z": -101.4222
        },
        {
          "hole": 53,
          "x": 50.1818,
          "y": 160,
          "z": -97.0074
        },
        {
          "hole": 54,
          "x": 62.5,
          "y": 160,
          "z": -90.9327
        },
        {
          "hole": 55,
          "x": 73.92,
          "y": 160,
          "z": -83.3021
        },
        {
          "hole": 56,
          "x": 93.3021,
          "y": 160,
          "z": -63.9199
        },
        {
          "hole": 57,
          "x": 100.9327,
          "y": 160,
          "z": -52.5
        },
        {
          "hole": 58,
          "x": 107.0073,
          "y": 160,
          "z": -40.1818
        },
        {
          "hole": 59,
          "x": 111.4222,
          "y": 160,
          "z": -27.176
        },
        {
          "hole": 60,
          "x": 114.1017,
          "y": 160,
          "z": -13.7053
        },
        {
          "hole": 61,
          "x": 114.7538,
          "y": 150,
          "z": 7.5214
        },
        {
          "hole": 62,
          "x": 114.0161,
          "y": 150,
          "z": 15.0105
        },
        {
          "hole": 63,
          "x": 112.7903,
          "y": 150,
          "z": 22.4354
        },
        {
          "hole": 64,
          "x": 111.0815,
          "y": 150,
          "z": 29.7642
        },
        {
          "hole": 65,
          "x": 108.897,
          "y": 150,
          "z": 36.9655
        },
        {
          "hole": 66,
          "x": 103.1404,
          "y": 150,
          "z": 50.8632
        },
        {
          "hole": 67,
          "x": 99.5929,
          "y": 150,
          "z": 57.5
        },
        {
          "hole": 68,
          "x": 95.619,
          "y": 150,
          "z": 63.8906
        },
        {
          "hole": 69,
          "x": 91.2356,
          "y": 150,
          "z": 70.0076
        },
        {
          "hole": 70,
          "x": 86.4616,
          "y": 150,
          "z": 75.8248
        },
        {
          "hole": 71,
          "x": 75.8248,
          "y": 150,
          "z": 86.4616
        },
        {
          "hole": 72,
          "x": 70.0076,
          "y": 150,
          "z": 91.2356
        },
        {
          "hole": 73,
          "x": 63.8906,
          "y": 150,
          "z": 95.619
        },
        {
          "hole": 74,
          "x": 57.5,
          "y": 150,
          "z": 99.5929
        },
        {
          "hole": 75,
          "x": 50.8632,
          "y": 150,
          "z": 103.1404
        },
        {
          "hole": 76,
          "x": 36.9655,
          "y": 150,
          "z": 108.897
        },
        {
          "hole": 77,
          "x": 29.7642,
          "y": 150,
          "z": 111.0815
        },
        {
          "hole": 78,
          "x": 22.4354,
          "y": 150,
          "z": 112.7903
        },
        {
          "hole": 79,
          "x": 15.0105,
          "y": 150,
          "z": 114.0162
        },
        {
          "hole": 80,
          "x": 7.5214,
          "y": 150,
          "z": 114.7538
        },
        {
          "hole": 81,
          "x": -8.1754,
          "y": 140,
          "z": 114.7324
        },
        {
          "hole": 82,
          "x": -16.3158,
          "y": 140,
          "z": 113.9306
        },
        {
          "hole": 83,
          "x": -24.3863,
          "y": 140,
          "z": 112.5982
        },
        {
          "hole": 84,
          "x": -32.3524,
          "y": 140,
          "z": 110.7407
        },
        {
          "hole": 85,
          "x": -40.1799,
          "y": 140,
          "z": 108.3663
        },
        {
          "hole": 86,
          "x": -55.2861,
          "y": 140,
          "z": 102.1091
        },
        {
          "hole": 87,
          "x": -62.5,
          "y": 140,
          "z": 98.2532
        },
        {
          "hole": 88,
          "x": -69.4463,
          "y": 140,
          "z": 93.9337
        },
        {
          "hole": 89,
          "x": -76.0952,
          "y": 140,
          "z": 89.1692
        },
        {
          "hole": 90,
          "x": -82.4182,
          "y": 140,
          "z": 83.98
        },
        {
          "hole": 91,
          "x": -93.98,
          "y": 140,
          "z": 72.4182
        },
        {
          "hole": 92,
          "x": -99.1692,
          "y": 140,
          "z": 66.0952
        },
        {
          "hole": 93,
          "x": -103.9337,
          "y": 140,
          "z": 59.4463
        },
        {
          "hole": 94,
          "x": -108.2532,
          "y": 140,
          "z": 52.5
        },
        {
          "hole": 95,
          "x": -112.1091,
          "y": 140,
          "z": 45.2861
        },
        {
          "hole": 96,
          "x": -118.3663,
          "y": 140,
          "z": 30.1799
        },
        {
          "hole": 97,
          "x": -120.7407,
          "y": 140,
          "z": 22.3524
        },
        {
          "hole": 98,
          "x": -122.5982,
          "y": 140,
          "z": 14.3863
        },
        {
          "hole": 99,
          "x": -123.9306,
          "y": 140,
          "z": 6.3158
        },
        {
          "hole": 100,
          "x": -124.7324,
          "y": 140,
          "z": -1.8246
        },
        {
          "hole": 101,
          "x": -124.7109,
          "y": 130,
          "z": -18.8294
        },
        {
          "hole": 102,
          "x": -123.845,
          "y": 130,
          "z": -27.621
        },
        {
          "hole": 103,
          "x": -122.406,
          "y": 130,
          "z": -36.3372
        },
        {
          "hole": 104,
          "x": -120.4,
          "y": 130,
          "z": -44.9406
        },
        {
          "hole": 105,
          "x": -117.8356,
          "y": 130,
          "z": -53.3943
        },
        {
          "hole": 106,
          "x": -111.0778,
          "y": 130,
          "z": -69.709
        },
        {
          "hole": 107,
          "x": -106.9134,
          "y": 130,
          "z": -77.5
        },
        {
          "hole": 108,
          "x": -102.2484,
          "y": 130,
          "z": -85.002
        },
        {
          "hole": 109,
          "x": -97.1027,
          "y": 130,
          "z": -92.1828
        },
        {
          "hole": 110,
          "x": -91.4984,
          "y": 130,
          "z": -99.0117
        },
        {
          "hole": 111,
          "x": -79.0117,
          "y": 130,
          "z": -111.4984
        },
        {
          "hole": 112,
          "x": -72.1828,
          "y": 130,
          "z": -117.1027
        },
        {
          "hole": 113,
          "x": -65.002,
          "y": 130,
          "z": -122.2484
        },
        {
          "hole": 114,
          "x": -57.5,
          "y": 130,
          "z": -126.9134
        },
        {
          "hole": 115,
          "x": -49.709,
          "y": 130,
          "z": -131.0778
        },
        {
          "hole": 116,
          "x": -33.3943,
          "y": 130,
          "z": -137.8356
        },
        {
          "hole": 117,
          "x": -24.9405,
          "y": 130,
          "z": -140.4
        },
        {
          "hole": 118,
          "x": -16.3372,
          "y": 130,
          "z": -142.406
        },
        {
          "hole": 119,
          "x": -7.621,
          "y": 130,
          "z": -143.845
        },
        {
          "hole": 120,
          "x": 1.1706,
          "y": 130,
          "z": -144.7109
        },
        {
          "hole": 121,
          "x": 19.4835,
          "y": 120,
          "z": -144.6895
        },
        {
          "hole": 122,
          "x": 28.9263,
          "y": 120,
          "z": -143.7595
        },
        {
          "hole": 123,
          "x": 38.2881,
          "y": 120,
          "z": -142.2139
        },
        {
          "hole": 124,
          "x": 47.5288,
          "y": 120,
          "z": -140.0592
        },
        {
          "hole": 125,
          "x": 56.6087,
          "y": 120,
          "z": -137.3049
        },
        {
          "hole": 126,
          "x": 74.1319,
          "y": 120,
          "z": -130.0465
        },
        {
          "hole": 127,
          "x": 82.5,
          "y": 120,
          "z": -125.5737
        },
        {
          "hole": 128,
          "x": 90.5577,
          "y": 120,
          "z": -120.5631
        },
        {
          "hole": 129,
          "x": 98.2704,
          "y": 120,
          "z": -115.0362
        },
        {
          "hole": 130,
          "x": 105.6051,
          "y": 120,
          "z": -109.0168
        },
        {
          "hole": 131,
          "x": 119.0168,
          "y": 120,
          "z": -95.6051
        },
        {
          "hole": 132,
          "x": 125.0362,
          "y": 120,
          "z": -88.2704
        },
        {
          "hole": 133,
          "x": 130.5631,
          "y": 120,
          "z": -80.5577
        },
        {
          "hole": 134,
          "x": 135.5737,
          "y": 120,
          "z": -72.5
        },
        {
          "hole": 135,
          "x": 140.0465,
          "y": 120,
          "z": -64.1319
        },
        {
          "hole": 136,
          "x": 147.3049,
          "y": 120,
          "z": -46.6087
        },
        {
          "hole": 137,
          "x": 150.0592,
          "y": 120,
          "z": -37.5288
        },
        {
          "hole": 138,
          "x": 152.2139,
          "y": 120,
          "z": -28.2881
        },
        {
          "hole": 139,
          "x": 153.7595,
          "y": 120,
          "z": -18.9263
        },
        {
          "hole": 140,
          "x": 154.6895,
          "y": 120,
          "z": -9.4835
        },
        {
          "hole": 141,
          "x": 154.8525,
          "y": 110,
          "z": 6.761
        },
        {
          "hole": 142,
          "x": 154.4102,
          "y": 110,
          "z": 13.5091
        },
        {
          "hole": 143,
          "x": 153.674,
          "y": 110,
          "z": 20.2316
        },
        {
          "hole": 144,
          "x": 152.6452,
          "y": 110,
          "z": 26.9155
        },
        {
          "hole": 145,
          "x": 151.3259,
          "y": 110,
          "z": 33.5481
        },
        {
          "hole": 146,
          "x": 147.8261,
          "y": 110,
          "z": 46.6094
        },
        {
          "hole": 147,
          "x": 145.6524,
          "y": 110,
          "z": 53.0131
        },
        {
          "hole": 148,
          "x": 143.2013,
          "y": 110,
          "z": 59.3159
        },
        {
          "hole": 149,
          "x": 140.4777,
          "y": 110,
          "z": 65.5058
        },
        {
          "hole": 150,
          "x": 137.4867,
          "y": 110,
          "z": 71.571
        },
        {
          "hole": 151,
          "x": 130.7257,
          "y": 110,
          "z": 83.2814
        },
        {
          "hole": 152,
          "x": 126.9686,
          "y": 110,
          "z": 88.9043
        },
        {
          "hole": 153,
          "x": 122.9698,
          "y": 110,
          "z": 94.358
        },
        {
          "hole": 154,
          "x": 118.7369,
          "y": 110,
          "z": 99.6321
        },
        {
          "hole": 155,
          "x": 114.278,
          "y": 110,
          "z": 104.7165
        },
        {
          "hole": 156,
          "x": 104.7165,
          "y": 110,
          "z": 114.278
        },
        {
          "hole": 157,
          "x": 99.6321,
          "y": 110,
          "z": 118.7369
        },
        {
          "hole": 158,
          "x": 94.358,
          "y": 110,
          "z": 122.9698
        },
        {
          "hole": 159,
          "x": 88.9044,
          "y": 110,
          "z": 126.9686
        },
        {
          "hole": 160,
          "x": 83.2814,
          "y": 110,
          "z": 130.7257
        },
        {
          "hole": 161,
          "x": 71.571,
          "y": 110,
          "z": 137.4867
        },
        {
          "hole": 162,
          "x": 65.5058,
          "y": 110,
          "z": 140.4777
        },
        {
          "hole": 163,
          "x": 59.3159,
          "y": 110,
          "z": 143.2013
        },
        {
          "hole": 164,
          "x": 53.0131,
          "y": 110,
          "z": 145.6524
        },
        {
          "hole": 165,
          "x": 46.6094,
          "y": 110,
          "z": 147.8261
        },
        {
          "hole": 166,
          "x": 33.5482,
          "y": 110,
          "z": 151.3259
        },
        {
          "hole": 167,
          "x": 26.9155,
          "y": 110,
          "z": 152.6452
        },
        {
          "hole": 168,
          "x": 20.2316,
          "y": 110,
          "z": 153.674
        },
        {
          "hole": 169,
          "x": 13.5092,
          "y": 110,
          "z": 154.4102
        },
        {
          "hole": 170,
          "x": 6.761,
          "y": 110,
          "z": 154.8525
        },
        {
          "hole": 171,
          "x": -7.1972,
          "y": 100,
          "z": 154.843
        },
        {
          "hole": 172,
          "x": -14.3807,
          "y": 100,
          "z": 154.3721
        },
        {
          "hole": 173,
          "x": -21.5368,
          "y": 100,
          "z": 153.5884
        },
        {
          "hole": 174,
          "x": -28.6519,
          "y": 100,
          "z": 152.4933
        },
        {
          "hole": 175,
          "x": -35.7125,
          "y": 100,
          "z": 151.0888
        },
        {
          "hole": 176,
          "x": -49.6165,
          "y": 100,
          "z": 147.3633
        },
        {
          "hole": 177,
          "x": -56.4333,
          "y": 100,
          "z": 145.0493
        },
        {
          "hole": 178,
          "x": -63.1428,
          "y": 100,
          "z": 142.4401
        },
        {
          "hole": 179,
          "x": -69.732,
          "y": 100,
          "z": 139.5408
        },
        {
          "hole": 180,
          "x": -76.1885,
          "y": 100,
          "z": 136.3568
        },
        {
          "hole": 181,
          "x": -88.6544,
          "y": 100,
          "z": 129.1596
        },
        {
          "hole": 182,
          "x": -94.6401,
          "y": 100,
          "z": 125.1601
        },
        {
          "hole": 183,
          "x": -100.4456,
          "y": 100,
          "z": 120.9033
        },
        {
          "hole": 184,
          "x": -106.06,
          "y": 100,
          "z": 116.3973
        },
        {
          "hole": 185,
          "x": -111.4724,
          "y": 100,
          "z": 111.6508
        },
        {
          "hole": 186,
          "x": -121.6508,
          "y": 100,
          "z": 101.4724
        },
        {
          "hole": 187,
          "x": -126.3973,
          "y": 100,
          "z": 96.06
        },
        {
          "hole": 188,
          "x": -130.9033,
          "y": 100,
          "z": 90.4456
        },
        {
          "hole": 189,
          "x": -135.1601,
          "y": 100,
          "z": 84.6401
        },
        {
          "hole": 190,
          "x": -139.1596,
          "y": 100,
          "z": 78.6544
        },
        {
          "hole": 191,
          "x": -146.3568,
          "y": 100,
          "z": 66.1885
        },
        {
          "hole": 192,
          "x": -149.5408,
          "y": 100,
          "z": 59.732
        },
        {
          "hole": 193,
          "x": -152.4401,
          "y": 100,
          "z": 53.1428
        },
        {
          "hole": 194,
          "x": -155.0493,
          "y": 100,
          "z": 46.4333
        },
        {
          "hole": 195,
          "x": -157.3633,
          "y": 100,
          "z": 39.6165
        },
        {
          "hole": 196,
          "x": -161.0888,
          "y": 100,
          "z": 25.7125
        },
        {
          "hole": 197,
          "x": -162.4933,
          "y": 100,
          "z": 18.6519
        },
        {
          "hole": 198,
          "x": -163.5884,
          "y": 100,
          "z": 11.5368
        },
        {
          "hole": 199,
          "x": -164.3721,
          "y": 100,
          "z": 4.3807
        },
        {
          "hole": 200,
          "x": -164.843,
          "y": 100,
          "z": -2.8028
        },
        {
          "hole": 201,
          "x": -164.8335,
          "y": 90,
          "z": -17.6334
        },
        {
          "hole": 202,
          "x": -164.3341,
          "y": 90,
          "z": -25.2523
        },
        {
          "hole": 203,
          "x": -163.5029,
          "y": 90,
          "z": -32.8421
        },
        {
          "hole": 204,
          "x": -162.3414,
          "y": 90,
          "z": -40.3884
        },
        {
          "hole": 205,
          "x": -160.8518,
          "y": 90,
          "z": -47.8769
        },
        {
          "hole": 206,
          "x": -156.9005,
          "y": 90,
          "z": -62.6235
        },
        {
          "hole": 207,
          "x": -154.4462,
          "y": 90,
          "z": -69.8535
        },
        {
          "hole": 208,
          "x": -151.6789,
          "y": 90,
          "z": -76.9696
        },
        {
          "hole": 209,
          "x": -148.6039,
          "y": 90,
          "z": -83.9582
        },
        {
          "hole": 210,
          "x": -145.2269,
          "y": 90,
          "z": -90.806
        },
        {
          "hole": 211,
          "x": -137.5935,
          "y": 90,
          "z": -104.0274
        },
        {
          "hole": 212,
          "x": -133.3516,
          "y": 90,
          "z": -110.3759
        },
        {
          "hole": 213,
          "x": -128.8368,
          "y": 90,
          "z": -116.5332
        },
        {
          "hole": 214,
          "x": -124.0578,
          "y": 90,
          "z": -122.4878
        },
        {
          "hole": 215,
          "x": -119.0235,
          "y": 90,
          "z": -128.2283
        },
        {
          "hole": 216,
          "x": -108.2283,
          "y": 90,
          "z": -139.0235
        },
        {
          "hole": 217,
          "x": -102.4879,
          "y": 90,
          "z": -144.0578
        },
        {
          "hole": 218,
          "x": -96.5333,
          "y": 90,
          "z": -148.8368
        },
        {
          "hole": 219,
          "x": -90.3759,
          "y": 90,
          "z": -153.3516
        },
        {
          "hole": 220,
          "x": -84.0275,
          "y": 90,
          "z": -157.5935
        },
        {
          "hole": 221,
          "x": -70.806,
          "y": 90,
          "z": -165.2269
        },
        {
          "hole": 222,
          "x": -63.9582,
          "y": 90,
          "z": -168.6039
        },
        {
          "hole": 223,
          "x": -56.9696,
          "y": 90,
          "z": -171.6789
        },
        {
          "hole": 224,
          "x": -49.8535,
          "y": 90,
          "z": -174.4462
        },
        {
          "hole": 225,
          "x": -42.6235,
          "y": 90,
          "z": -176.9005
        },
        {
          "hole": 226,
          "x": -27.8769,
          "y": 90,
          "z": -180.8518
        },
        {
          "hole": 227,
          "x": -20.3884,
          "y": 90,
          "z": -182.3413
        },
        {
          "hole": 228,
          "x": -12.8421,
          "y": 90,
          "z": -183.5028
        },
        {
          "hole": 229,
          "x": -5.2523,
          "y": 90,
          "z": -184.3341
        },
        {
          "hole": 230,
          "x": 2.3666,
          "y": 90,
          "z": -184.8334
        },
        {
          "hole": 231,
          "x": 18.0696,
          "y": 80,
          "z": -184.8239
        },
        {
          "hole": 232,
          "x": 26.1238,
          "y": 80,
          "z": -184.296
        },
        {
          "hole": 233,
          "x": 34.1473,
          "y": 80,
          "z": -183.4173
        },
        {
          "hole": 234,
          "x": 42.1249,
          "y": 80,
          "z": -182.1894
        },
        {
          "hole": 235,
          "x": 50.0413,
          "y": 80,
          "z": -180.6147
        },
        {
          "hole": 236,
          "x": 65.6306,
          "y": 80,
          "z": -176.4376
        },
        {
          "hole": 237,
          "x": 73.2737,
          "y": 80,
          "z": -173.8431
        },
        {
          "hole": 238,
          "x": 80.7964,
          "y": 80,
          "z": -170.9177
        },
        {
          "hole": 239,
          "x": 88.1844,
          "y": 80,
          "z": -167.6669
        },
        {
          "hole": 240,
          "x": 95.4235,
          "y": 80,
          "z": -164.097
        },
        {
          "hole": 241,
          "x": 109.4004,
          "y": 80,
          "z": -156.0274
        },
        {
          "hole": 242,
          "x": 116.1116,
          "y": 80,
          "z": -151.5431
        },
        {
          "hole": 243,
          "x": 122.6209,
          "y": 80,
          "z": -146.7703
        },
        {
          "hole": 244,
          "x": 128.9157,
          "y": 80,
          "z": -141.7182
        },
        {
          "hole": 245,
          "x": 134.9842,
          "y": 80,
          "z": -136.3963
        },
        {
          "hole": 246,
          "x": 146.3963,
          "y": 80,
          "z": -124.9842
        },
        {
          "hole": 247,
          "x": 151.7182,
          "y": 80,
          "z": -118.9157
        },
        {
          "hole": 248,
          "x": 156.7704,
          "y": 80,
          "z": -112.6208
        },
        {
          "hole": 249,
          "x": 161.5431,
          "y": 80,
          "z": -106.1116
        },
        {
          "hole": 250,
          "x": 166.0274,
          "y": 80,
          "z": -99.4004
        },
        {
          "hole": 251,
          "x": 174.097,
          "y": 80,
          "z": -85.4235
        },
        {
          "hole": 252,
          "x": 177.6669,
          "y": 80,
          "z": -78.1844
        },
        {
          "hole": 253,
          "x": 180.9177,
          "y": 80,
          "z": -70.7964
        },
        {
          "hole": 254,
          "x": 183.8431,
          "y": 80,
          "z": -63.2737
        },
        {
          "hole": 255,
          "x": 186.4376,
          "y": 80,
          "z": -55.6306
        },
        {
          "hole": 256,
          "x": 190.6148,
          "y": 80,
          "z": -40.0413
        },
        {
          "hole": 257,
          "x": 192.1894,
          "y": 80,
          "z": -32.1249
        },
        {
          "hole": 258,
          "x": 193.4173,
          "y": 80,
          "z": -24.1473
        },
        {
          "hole": 259,
          "x": 194.296,
          "y": 80,
          "z": -16.1238
        },
        {
          "hole": 260,
          "x": 194.8239,
          "y": 80,
          "z": -8.0696
        },
        {
          "hole": 261,
          "x": 194.8956,
          "y": 70,
          "z": 6.3802
        },
        {
          "hole": 262,
          "x": 194.5825,
          "y": 70,
          "z": 12.7536
        },
        {
          "hole": 263,
          "x": 194.061,
          "y": 70,
          "z": 19.1133
        },
        {
          "hole": 264,
          "x": 193.3317,
          "y": 70,
          "z": 25.4526
        },
        {
          "hole": 265,
          "x": 192.3954,
          "y": 70,
          "z": 31.7646
        },
        {
          "hole": 266,
          "x": 189.906,
          "y": 70,
          "z": 44.2799
        },
        {
          "hole": 267,
          "x": 188.3555,
          "y": 70,
          "z": 50.4697
        },
        {
          "hole": 268,
          "x": 186.6034,
          "y": 70,
          "z": 56.6055
        },
        {
          "hole": 269,
          "x": 184.6514,
          "y": 70,
          "z": 62.6807
        },
        {
          "hole": 270,
          "x": 182.5016,
          "y": 70,
          "z": 68.6888
        },
        {
          "hole": 271,
          "x": 177.6184,
          "y": 70,
          "z": 80.4779
        },
        {
          "hole": 272,
          "x": 174.8902,
          "y": 70,
          "z": 86.2463
        },
        {
          "hole": 273,
          "x": 171.9746,
          "y": 70,
          "z": 91.9224
        },
        {
          "hole": 274,
          "x": 168.8749,
          "y": 70,
          "z": 97.5
        },
        {
          "hole": 275,
          "x": 165.5944,
          "y": 70,
          "z": 102.9732
        },
        {
          "hole": 276,
          "x": 158.5051,
          "y": 70,
          "z": 113.5832
        },
        {
          "hole": 277,
          "x": 154.7039,
          "y": 70,
          "z": 118.7085
        },
        {
          "hole": 278,
          "x": 150.737,
          "y": 70,
          "z": 123.7067
        },
        {
          "hole": 279,
          "x": 146.6088,
          "y": 70,
          "z": 128.5724
        },
        {
          "hole": 280,
          "x": 142.3235,
          "y": 70,
          "z": 133.3005
        },
        {
          "hole": 281,
          "x": 133.3005,
          "y": 70,
          "z": 142.3235
        },
        {
          "hole": 282,
          "x": 128.5724,
          "y": 70,
          "z": 146.6088
        },
        {
          "hole": 283,
          "x": 123.7067,
          "y": 70,
          "z": 150.737
        },
        {
          "hole": 284,
          "x": 118.7085,
          "y": 70,
          "z": 154.7039
        },
        {
          "hole": 285,
          "x": 113.5831,
          "y": 70,
          "z": 158.5051
        },
        {
          "hole": 286,
          "x": 102.9732,
          "y": 70,
          "z": 165.5944
        },
        {
          "hole": 287,
          "x": 97.5,
          "y": 70,
          "z": 168.875
        },
        {
          "hole": 288,
          "x": 91.9224,
          "y": 70,
          "z": 171.9746
        },
        {
          "hole": 289,
          "x": 86.2463,
          "y": 70,
          "z": 174.8902
        },
        {
          "hole": 290,
          "x": 80.4779,
          "y": 70,
          "z": 177.6184
        },
        {
          "hole": 291,
          "x": 68.6888,
          "y": 70,
          "z": 182.5017
        },
        {
          "hole": 292,
          "x": 62.6807,
          "y": 70,
          "z": 184.6514
        },
        {
          "hole": 293,
          "x": 56.6055,
          "y": 70,
          "z": 186.6034
        },
        {
          "hole": 294,
          "x": 50.4697,
          "y": 70,
          "z": 188.3555
        },
        {
          "hole": 295,
          "x": 44.2799,
          "y": 70,
          "z": 189.906
        },
        {
          "hole": 296,
          "x": 31.7646,
          "y": 70,
          "z": 192.3954
        },
        {
          "hole": 297,
          "x": 25.4526,
          "y": 70,
          "z": 193.3317
        },
        {
          "hole": 298,
          "x": 19.1134,
          "y": 70,
          "z": 194.061
        },
        {
          "hole": 299,
          "x": 12.7536,
          "y": 70,
          "z": 194.5825
        },
        {
          "hole": 300,
          "x": 6.3802,
          "y": 70,
          "z": 194.8956
        },
        {
          "hole": 301,
          "x": -6.7074,
          "y": 60,
          "z": 194.8902
        },
        {
          "hole": 302,
          "x": -13.4076,
          "y": 60,
          "z": 194.5611
        },
        {
          "hole": 303,
          "x": -20.0935,
          "y": 60,
          "z": 194.0129
        },
        {
          "hole": 304,
          "x": -26.7579,
          "y": 60,
          "z": 193.2462
        },
        {
          "hole": 305,
          "x": -33.3936,
          "y": 60,
          "z": 192.2619
        },
        {
          "hole": 306,
          "x": -46.5506,
          "y": 60,
          "z": 189.6448
        },
        {
          "hole": 307,
          "x": -53.0579,
          "y": 60,
          "z": 188.0148
        },
        {
          "hole": 308,
          "x": -59.5084,
          "y": 60,
          "z": 186.1728
        },
        {
          "hole": 309,
          "x": -65.8951,
          "y": 60,
          "z": 184.1207
        },
        {
          "hole": 310,
          "x": -72.2113,
          "y": 60,
          "z": 181.8607
        },
        {
          "hole": 311,
          "x": -84.6049,
          "y": 60,
          "z": 176.7271
        },
        {
          "hole": 312,
          "x": -90.6692,
          "y": 60,
          "z": 173.8589
        },
        {
          "hole": 313,
          "x": -96.6363,
          "y": 60,
          "z": 170.7939
        },
        {
          "hole": 314,
          "x": -102.5,
          "y": 60,
          "z": 167.5352
        },
        {
          "hole": 315,
          "x": -108.2539,
          "y": 60,
          "z": 164.0864
        },
        {
          "hole": 316,
          "x": -119.4079,
          "y": 60,
          "z": 156.6336
        },
        {
          "hole": 317,
          "x": -124.7961,
          "y": 60,
          "z": 152.6374
        },
        {
          "hole": 318,
          "x": -130.0506,
          "y": 60,
          "z": 148.4671
        },
        {
          "hole": 319,
          "x": -135.1659,
          "y": 60,
          "z": 144.1272
        },
        {
          "hole": 320,
          "x": -140.1364,
          "y": 60,
          "z": 139.6221
        },
        {
          "hole": 321,
          "x": -149.6221,
          "y": 60,
          "z": 130.1364
        },
        {
          "hole": 322,
          "x": -154.1272,
          "y": 60,
          "z": 125.1659
        },
        {
          "hole": 323,
          "x": -158.4671,
          "y": 60,
          "z": 120.0506
        },
        {
          "hole": 324,
          "x": -162.6374,
          "y": 60,
          "z": 114.7961
        },
        {
          "hole": 325,
          "x": -166.6336,
          "y": 60,
          "z": 109.4079
        },
        {
          "hole": 326,
          "x": -174.0864,
          "y": 60,
          "z": 98.2539
        },
        {
          "hole": 327,
          "x": -177.5352,
          "y": 60,
          "z": 92.5
        },
        {
          "hole": 328,
          "x": -180.7939,
          "y": 60,
          "z": 86.6363
        },
        {
          "hole": 329,
          "x": -183.8589,
          "y": 60,
          "z": 80.6692
        },
        {
          "hole": 330,
          "x": -186.7271,
          "y": 60,
          "z": 74.6049
        },
        {
          "hole": 331,
          "x": -191.8607,
          "y": 60,
          "z": 62.2113
        },
        {
          "hole": 332,
          "x": -194.1207,
          "y": 60,
          "z": 55.8951
        },
        {
          "hole": 333,
          "x": -196.1728,
          "y": 60,
          "z": 49.5084
        },
        {
          "hole": 334,
          "x": -198.0148,
          "y": 60,
          "z": 43.0579
        },
        {
          "hole": 335,
          "x": -199.6448,
          "y": 60,
          "z": 36.5506
        },
        {
          "hole": 336,
          "x": -202.2619,
          "y": 60,
          "z": 23.3936
        },
        {
          "hole": 337,
          "x": -203.2462,
          "y": 60,
          "z": 16.7579
        },
        {
          "hole": 338,
          "x": -204.0129,
          "y": 60,
          "z": 10.0935
        },
        {
          "hole": 339,
          "x": -204.5611,
          "y": 60,
          "z": 3.4077
        },
        {
          "hole": 340,
          "x": -204.8902,
          "y": 60,
          "z": -3.2926
        },
        {
          "hole": 341,
          "x": -204.8849,
          "y": 50,
          "z": -17.0346
        },
        {
          "hole": 342,
          "x": -204.5397,
          "y": 50,
          "z": -24.0617
        },
        {
          "hole": 343,
          "x": -203.9647,
          "y": 50,
          "z": -31.0737
        },
        {
          "hole": 344,
          "x": -203.1606,
          "y": 50,
          "z": -38.0631
        },
        {
          "hole": 345,
          "x": -202.1283,
          "y": 50,
          "z": -45.0225
        },
        {
          "hole": 346,
          "x": -199.3835,
          "y": 50,
          "z": -58.8214
        },
        {
          "hole": 347,
          "x": -197.674,
          "y": 50,
          "z": -65.6461
        },
        {
          "hole": 348,
          "x": -195.7422,
          "y": 50,
          "z": -72.4112
        },
        {
          "hole": 349,
          "x": -193.59,
          "y": 50,
          "z": -79.1095
        },
        {
          "hole": 350,
          "x": -191.2198,
          "y": 50,
          "z": -85.7338
        },
        {
          "hole": 351,
          "x": -185.8357,
          "y": 50,
          "z": -98.732
        },
        {
          "hole": 352,
          "x": -182.8276,
          "y": 50,
          "z": -105.0921
        },
        {
          "hole": 353,
          "x": -179.6131,
          "y": 50,
          "z": -111.3503
        },
        {
          "hole": 354,
          "x": -176.1955,
          "y": 50,
          "z": -117.5
        },
        {
          "hole": 355,
          "x": -172.5785,
          "y": 50,
          "z": -123.5346
        },
        {
          "hole": 356,
          "x": -164.762,
          "y": 50,
          "z": -135.2327
        },
        {
          "hole": 357,
          "x": -160.571,
          "y": 50,
          "z": -140.8837
        },
        {
          "hole": 358,
          "x": -156.1972,
          "y": 50,
          "z": -146.3946
        },
        {
          "hole": 359,
          "x": -151.6456,
          "y": 50,
          "z": -151.7594
        },
        {
          "hole": 360,
          "x": -146.9208,
          "y": 50,
          "z": -156.9723
        },
        {
          "hole": 361,
          "x": -136.9723,
          "y": 50,
          "z": -166.9208
        },
        {
          "hole": 362,
          "x": -131.7593,
          "y": 50,
          "z": -171.6456
        },
        {
          "hole": 363,
          "x": -126.3946,
          "y": 50,
          "z": -176.1972
        },
        {
          "hole": 364,
          "x": -120.8837,
          "y": 50,
          "z": -180.571
        },
        {
          "hole": 365,
          "x": -115.2327,
          "y": 50,
          "z": -184.762
        },
        {
          "hole": 366,
          "x": -103.5346,
          "y": 50,
          "z": -192.5785
        },
        {
          "hole": 367,
          "x": -97.5,
          "y": 50,
          "z": -196.1955
        },
        {
          "hole": 368,
          "x": -91.3503,
          "y": 50,
          "z": -199.6131
        },
        {
          "hole": 369,
          "x": -85.0921,
          "y": 50,
          "z": -202.8276
        },
        {
          "hole": 370,
          "x": -78.732,
          "y": 50,
          "z": -205.8357
        },
        {
          "hole": 371,
          "x": -65.7337,
          "y": 50,
          "z": -211.2198
        },
        {
          "hole": 372,
          "x": -59.1095,
          "y": 50,
          "z": -213.59
        },
        {
          "hole": 373,
          "x": -52.4112,
          "y": 50,
          "z": -215.7422
        },
        {
          "hole": 374,
          "x": -45.6461,
          "y": 50,
          "z": -217.674
        },
        {
          "hole": 375,
          "x": -38.8214,
          "y": 50,
          "z": -219.3835
        },
        {
          "hole": 376,
          "x": -25.0225,
          "y": 50,
          "z": -222.1283
        },
        {
          "hole": 377,
          "x": -18.0631,
          "y": 50,
          "z": -223.1606
        },
        {
          "hole": 378,
          "x": -11.0737,
          "y": 50,
          "z": -223.9647
        },
        {
          "hole": 379,
          "x": -4.0617,
          "y": 50,
          "z": -224.5396
        },
        {
          "hole": 380,
          "x": 2.9654,
          "y": 50,
          "z": -224.8849
        },
        {
          "hole": 381,
          "x": 17.3618,
          "y": 40,
          "z": -224.8795
        },
        {
          "hole": 382,
          "x": 24.7157,
          "y": 40,
          "z": -224.5183
        },
        {
          "hole": 383,
          "x": 32.0539,
          "y": 40,
          "z": -223.9166
        },
        {
          "hole": 384,
          "x": 39.3684,
          "y": 40,
          "z": -223.0751
        },
        {
          "hole": 385,
          "x": 46.6515,
          "y": 40,
          "z": -221.9948
        },
        {
          "hole": 386,
          "x": 61.0922,
          "y": 40,
          "z": -219.1223
        },
        {
          "hole": 387,
          "x": 68.2343,
          "y": 40,
          "z": -217.3333
        },
        {
          "hole": 388,
          "x": 75.3141,
          "y": 40,
          "z": -215.3116
        },
        {
          "hole": 389,
          "x": 82.3239,
          "y": 40,
          "z": -213.0593
        },
        {
          "hole": 390,
          "x": 89.2563,
          "y": 40,
          "z": -210.5788
        },
        {
          "hole": 391,
          "x": 102.8591,
          "y": 40,
          "z": -204.9444
        },
        {
          "hole": 392,
          "x": 109.515,
          "y": 40,
          "z": -201.7964
        },
        {
          "hole": 393,
          "x": 116.0643,
          "y": 40,
          "z": -198.4323
        },
        {
          "hole": 394,
          "x": 122.5,
          "y": 40,
          "z": -194.8557
        },
        {
          "hole": 395,
          "x": 128.8153,
          "y": 40,
          "z": -191.0705
        },
        {
          "hole": 396,
          "x": 141.0575,
          "y": 40,
          "z": -182.8905
        },
        {
          "hole": 397,
          "x": 146.9713,
          "y": 40,
          "z": -178.5045
        },
        {
          "hole": 398,
          "x": 152.7385,
          "y": 40,
          "z": -173.9274
        },
        {
          "hole": 399,
          "x": 158.3528,
          "y": 40,
          "z": -169.164
        },
        {
          "hole": 400,
          "x": 163.8083,
          "y": 40,
          "z": -164.2194
        },
        {
          "hole": 401,
          "x": 174.2194,
          "y": 40,
          "z": -153.8083
        },
        {
          "hole": 402,
          "x": 179.164,
          "y": 40,
          "z": -148.3528
        },
        {
          "hole": 403,
          "x": 183.9273,
          "y": 40,
          "z": -142.7385
        },
        {
          "hole": 404,
          "x": 188.5045,
          "y": 40,
          "z": -136.9713
        },
        {
          "hole": 405,
          "x": 192.8905,
          "y": 40,
          "z": -131.0575
        },
        {
          "hole": 406,
          "x": 201.0705,
          "y": 40,
          "z": -118.8153
        },
        {
          "hole": 407,
          "x": 204.8557,
          "y": 40,
          "z": -112.5
        },
        {
          "hole": 408,
          "x": 208.4323,
          "y": 40,
          "z": -106.0643
        },
        {
          "hole": 409,
          "x": 211.7964,
          "y": 40,
          "z": -99.515
        },
        {
          "hole": 410,
          "x": 214.9444,
          "y": 40,
          "z": -92.8591
        },
        {
          "hole": 411,
          "x": 220.5788,
          "y": 40,
          "z": -79.2563
        },
        {
          "hole": 412,
          "x": 223.0593,
          "y": 40,
          "z": -72.3239
        },
        {
          "hole": 413,
          "x": 225.3116,
          "y": 40,
          "z": -65.3141
        },
        {
          "hole": 414,
          "x": 227.3333,
          "y": 40,
          "z": -58.2343
        },
        {
          "hole": 415,
          "x": 229.1223,
          "y": 40,
          "z": -51.0922
        },
        {
          "hole": 416,
          "x": 231.9947,
          "y": 40,
          "z": -36.6515
        },
        {
          "hole": 417,
          "x": 233.0751,
          "y": 40,
          "z": -29.3684
        },
        {
          "hole": 418,
          "x": 233.9166,
          "y": 40,
          "z": -22.0539
        },
        {
          "hole": 419,
          "x": 234.5183,
          "y": 40,
          "z": -14.7157
        },
        {
          "hole": 420,
          "x": 234.8795,
          "y": 40,
          "z": -7.3618
        },
        {
          "hole": 421,
          "x": 234.8742,
          "y": 30,
          "z": 7.689
        },
        {
          "hole": 422,
          "x": 234.4968,
          "y": 30,
          "z": 15.3697
        },
        {
          "hole": 423,
          "x": 233.8684,
          "y": 30,
          "z": 23.034
        },
        {
          "hole": 424,
          "x": 232.9895,
          "y": 30,
          "z": 30.6737
        },
        {
          "hole": 425,
          "x": 231.8612,
          "y": 30,
          "z": 38.2804
        },
        {
          "hole": 426,
          "x": 228.8611,
          "y": 30,
          "z": 53.3629
        },
        {
          "hole": 427,
          "x": 226.9926,
          "y": 30,
          "z": 60.8225
        },
        {
          "hole": 428,
          "x": 224.881,
          "y": 30,
          "z": 68.2169
        },
        {
          "hole": 429,
          "x": 222.5286,
          "y": 30,
          "z": 75.5383
        },
        {
          "hole": 430,
          "x": 219.9379,
          "y": 30,
          "z": 82.7788
        },
        {
          "hole": 431,
          "x": 214.053,
          "y": 30,
          "z": 96.9862
        },
        {
          "hole": 432,
          "x": 210.7651,
          "y": 30,
          "z": 103.9378
        },
        {
          "hole": 433,
          "x": 207.2515,
          "y": 30,
          "z": 110.7782
        },
        {
          "hole": 434,
          "x": 203.516,
          "y": 30,
          "z": 117.5
        },
        {
          "hole": 435,
          "x": 199.5625,
          "y": 30,
          "z": 124.0959
        },
        {
          "hole": 436,
          "x": 191.019,
          "y": 30,
          "z": 136.8823
        },
        {
          "hole": 437,
          "x": 186.438,
          "y": 30,
          "z": 143.0589
        },
        {
          "hole": 438,
          "x": 181.6575,
          "y": 30,
          "z": 149.0824
        },
        {
          "hole": 439,
          "x": 176.6824,
          "y": 30,
          "z": 154.9463
        },
        {
          "hole": 440,
          "x": 171.5181,
          "y": 30,
          "z": 160.6442
        },
        {
          "hole": 441,
          "x": 160.6442,
          "y": 30,
          "z": 171.5181
        },
        {
          "hole": 442,
          "x": 154.9463,
          "y": 30,
          "z": 176.6824
        },
        {
          "hole": 443,
          "x": 149.0824,
          "y": 30,
          "z": 181.6575
        },
        {
          "hole": 444,
          "x": 143.0589,
          "y": 30,
          "z": 186.438
        },
        {
          "hole": 445,
          "x": 136.8823,
          "y": 30,
          "z": 191.019
        },
        {
          "hole": 446,
          "x": 124.0959,
          "y": 30,
          "z": 199.5625
        },
        {
          "hole": 447,
          "x": 117.5,
          "y": 30,
          "z": 203.516
        },
        {
          "hole": 448,
          "x": 110.7782,
          "y": 30,
          "z": 207.2515
        },
        {
          "hole": 449,
          "x": 103.9378,
          "y": 30,
          "z": 210.7651
        },
        {
          "hole": 450,
          "x": 96.9862,
          "y": 30,
          "z": 214.053
        },
        {
          "hole": 451,
          "x": 82.7788,
          "y": 30,
          "z": 219.9379
        },
        {
          "hole": 452,
          "x": 75.5383,
          "y": 30,
          "z": 222.5286
        },
        {
          "hole": 453,
          "x": 68.2169,
          "y": 30,
          "z": 224.881
        },
        {
          "hole": 454,
          "x": 60.8225,
          "y": 30,
          "z": 226.9926
        },
        {
          "hole": 455,
          "x": 53.3629,
          "y": 30,
          "z": 228.8611
        },
        {
          "hole": 456,
          "x": 38.2805,
          "y": 30,
          "z": 231.8612
        },
        {
          "hole": 457,
          "x": 30.6737,
          "y": 30,
          "z": 232.9895
        },
        {
          "hole": 458,
          "x": 23.0341,
          "y": 30,
          "z": 233.8684
        },
        {
          "hole": 459,
          "x": 15.3698,
          "y": 30,
          "z": 234.4968
        },
        {
          "hole": 460,
          "x": 7.689,
          "y": 30,
          "z": 234.8742
        },
        {
          "hole": 461,
          "x": -8.0162,
          "y": 20,
          "z": 234.8688
        },
        {
          "hole": 462,
          "x": -16.0238,
          "y": 20,
          "z": 234.4754
        },
        {
          "hole": 463,
          "x": -24.0142,
          "y": 20,
          "z": 233.8203
        },
        {
          "hole": 464,
          "x": -31.9789,
          "y": 20,
          "z": 232.904
        },
        {
          "hole": 465,
          "x": -39.9094,
          "y": 20,
          "z": 231.7276
        },
        {
          "hole": 466,
          "x": -55.6337,
          "y": 20,
          "z": 228.5999
        },
        {
          "hole": 467,
          "x": -63.4107,
          "y": 20,
          "z": 226.6518
        },
        {
          "hole": 468,
          "x": -71.1198,
          "y": 20,
          "z": 224.4504
        },
        {
          "hole": 469,
          "x": -78.7527,
          "y": 20,
          "z": 221.9979
        },
        {
          "hole": 470,
          "x": -86.3013,
          "y": 20,
          "z": 219.2969
        },
        {
          "hole": 471,
          "x": -101.1132,
          "y": 20,
          "z": 213.1616
        },
        {
          "hole": 472,
          "x": -108.3607,
          "y": 20,
          "z": 209.7338
        },
        {
          "hole": 473,
          "x": -115.4922,
          "y": 20,
          "z": 206.0707
        },
        {
          "hole": 474,
          "x": -122.5,
          "y": 20,
          "z": 202.1762
        },
        {
          "hole": 475,
          "x": -129.3766,
          "y": 20,
          "z": 198.0545
        },
        {
          "hole": 476,
          "x": -142.707,
          "y": 20,
          "z": 189.1474
        },
        {
          "hole": 477,
          "x": -149.1466,
          "y": 20,
          "z": 184.3716
        },
        {
          "hole": 478,
          "x": -155.4264,
          "y": 20,
          "z": 179.3876
        },
        {
          "hole": 479,
          "x": -161.5397,
          "y": 20,
          "z": 174.2007
        },
        {
          "hole": 480,
          "x": -167.4801,
          "y": 20,
          "z": 168.8167
        },
        {
          "hole": 481,
          "x": 40,
          "y": 240,
          "z": -6.25
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": -203.516,
          "y": 10,
          "z": 107.5
        },
        {
          "hole": 1,
          "x": 24.1481,
          "y": 230,
          "z": 6.4705
        },
        {
          "hole": 2,
          "x": 21.6506,
          "y": 230,
          "z": 12.5
        },
        {
          "hole": 3,
          "x": 17.6777,
          "y": 230,
          "z": 17.6777
        },
        {
          "hole": 4,
          "x": 12.5,
          "y": 230,
          "z": 21.6506
        },
        {
          "hole": 5,
          "x": 6.4705,
          "y": 230,
          "z": 24.1481
        },
        {
          "hole": 6,
          "x": -9.0587,
          "y": 220,
          "z": 23.8074
        },
        {
          "hole": 7,
          "x": -17.5,
          "y": 220,
          "z": 20.3109
        },
        {
          "hole": 8,
          "x": -24.7487,
          "y": 220,
          "z": 14.7487
        },
        {
          "hole": 9,
          "x": -30.3109,
          "y": 220,
          "z": 7.5
        },
        {
          "hole": 10,
          "x": -33.8074,
          "y": 220,
          "z": -0.9413
        },
        {
          "hole": 11,
          "x": -33.4667,
          "y": 210,
          "z": -21.6469
        },
        {
          "hole": 12,
          "x": -28.9711,
          "y": 210,
          "z": -32.5
        },
        {
          "hole": 13,
          "x": -21.8198,
          "y": 210,
          "z": -41.8198
        },
        {
          "hole": 14,
          "x": -12.5,
          "y": 210,
          "z": -48.9711
        },
        {
          "hole": 15,
          "x": -1.6469,
          "y": 210,
          "z": -53.4667
        },
        {
          "hole": 16,
          "x": 24.235,
          "y": 200,
          "z": -53.1259
        },
        {
          "hole": 17,
          "x": 37.5,
          "y": 200,
          "z": -47.6314
        },
        {
          "hole": 18,
          "x": 48.8909,
          "y": 200,
          "z": -38.8909
        },
        {
          "hole": 19,
          "x": 57.6314,
          "y": 200,
          "z": -27.5
        },
        {
          "hole": 20,
          "x": 63.1259,
          "y": 200,
          "z": -14.235
        },
        {
          "hole": 21,
          "x": 64.4439,
          "y": 190,
          "z": 8.4842
        },
        {
          "hole": 22,
          "x": 62.7852,
          "y": 190,
          "z": 16.8232
        },
        {
          "hole": 23,
          "x": 60.0522,
          "y": 190,
          "z": 24.8744
        },
        {
          "hole": 24,
          "x": 56.2917,
          "y": 190,
          "z": 32.5
        },
        {
          "hole": 25,
          "x": 51.568,
          "y": 190,
          "z": 39.5695
        },
        {
          "hole": 26,
          "x": 39.5695,
          "y": 190,
          "z": 51.568
        },
        {
          "hole": 27,
          "x": 32.5,
          "y": 190,
          "z": 56.2916
        },
        {
          "hole": 28,
          "x": 24.8744,
          "y": 190,
          "z": 60.0522
        },
        {
          "hole": 29,
          "x": 16.8232,
          "y": 190,
          "z": 62.7852
        },
        {
          "hole": 30,
          "x": 8.4842,
          "y": 190,
          "z": 64.4439
        },
        {
          "hole": 31,
          "x": -9.7895,
          "y": 180,
          "z": 64.3584
        },
        {
          "hole": 32,
          "x": -19.4114,
          "y": 180,
          "z": 62.4444
        },
        {
          "hole": 33,
          "x": -28.7013,
          "y": 180,
          "z": 59.291
        },
        {
          "hole": 34,
          "x": -37.5,
          "y": 180,
          "z": 54.9519
        },
        {
          "hole": 35,
          "x": -45.6571,
          "y": 180,
          "z": 49.5015
        },
        {
          "hole": 36,
          "x": -59.5015,
          "y": 180,
          "z": 35.6571
        },
        {
          "hole": 37,
          "x": -64.9519,
          "y": 180,
          "z": 27.5
        },
        {
          "hole": 38,
          "x": -69.291,
          "y": 180,
          "z": 18.7013
        },
        {
          "hole": 39,
          "x": -72.4444,
          "y": 180,
          "z": 9.4114
        },
        {
          "hole": 40,
          "x": -74.3584,
          "y": 180,
          "z": -0.2105
        },
        {
          "hole": 41,
          "x": -74.2728,
          "y": 170,
          "z": -21.0947
        },
        {
          "hole": 42,
          "x": -72.1037,
          "y": 170,
          "z": -31.9996
        },
        {
          "hole": 43,
          "x": -68.5298,
          "y": 170,
          "z": -42.5281
        },
        {
          "hole": 44,
          "x": -63.6122,
          "y": 170,
          "z": -52.5
        },
        {
          "hole": 45,
          "x": -57.435,
          "y": 170,
          "z": -61.7447
        },
        {
          "hole": 46,
          "x": -41.7447,
          "y": 170,
          "z": -77.435
        },
        {
          "hole": 47,
          "x": -32.5,
          "y": 170,
          "z": -83.6122
        },
        {
          "hole": 48,
          "x": -22.5281,
          "y": 170,
          "z": -88.5298
        },
        {
          "hole": 49,
          "x": -11.9996,
          "y": 170,
          "z": -92.1037
        },
        {
          "hole": 50,
          "x": -1.0947,
          "y": 170,
          "z": -94.2728
        },
        {
          "hole": 51,
          "x": 22.4,
          "y": 160,
          "z": -94.1873
        },
        {
          "hole": 52,
          "x": 34.5878,
          "y": 160,
          "z": -91.763
        },
        {
          "hole": 53,
          "x": 46.3549,
          "y": 160,
          "z": -87.7686
        },
        {
          "hole": 54,
          "x": 57.5,
          "y": 160,
          "z": -82.2724
        },
        {
          "hole": 55,
          "x": 67.8323,
          "y": 160,
          "z": -75.3686
        },
        {
          "hole": 56,
          "x": 85.3686,
          "y": 160,
          "z": -57.8323
        },
        {
          "hole": 57,
          "x": 92.2724,
          "y": 160,
          "z": -47.5
        },
        {
          "hole": 58,
          "x": 97.7685,
          "y": 160,
          "z": -36.3549
        },
        {
          "hole": 59,
          "x": 101.7629,
          "y": 160,
          "z": -24.5878
        },
        {
          "hole": 60,
          "x": 104.1873,
          "y": 160,
          "z": -12.4
        },
        {
          "hole": 61,
          "x": 104.7752,
          "y": 150,
          "z": 6.8673
        },
        {
          "hole": 62,
          "x": 104.1017,
          "y": 150,
          "z": 13.7052
        },
        {
          "hole": 63,
          "x": 102.9824,
          "y": 150,
          "z": 20.4845
        },
        {
          "hole": 64,
          "x": 101.4222,
          "y": 150,
          "z": 27.176
        },
        {
          "hole": 65,
          "x": 99.4277,
          "y": 150,
          "z": 33.7511
        },
        {
          "hole": 66,
          "x": 94.1716,
          "y": 150,
          "z": 46.4403
        },
        {
          "hole": 67,
          "x": 90.9327,
          "y": 150,
          "z": 52.5
        },
        {
          "hole": 68,
          "x": 87.3043,
          "y": 150,
          "z": 58.3349
        },
        {
          "hole": 69,
          "x": 83.3021,
          "y": 150,
          "z": 63.9199
        },
        {
          "hole": 70,
          "x": 78.9432,
          "y": 150,
          "z": 69.2313
        },
        {
          "hole": 71,
          "x": 69.2313,
          "y": 150,
          "z": 78.9432
        },
        {
          "hole": 72,
          "x": 63.9199,
          "y": 150,
          "z": 83.3021
        },
        {
          "hole": 73,
          "x": 58.3349,
          "y": 150,
          "z": 87.3043
        },
        {
          "hole": 74,
          "x": 52.5,
          "y": 150,
          "z": 90.9327
        },
        {
          "hole": 75,
          "x": 46.4403,
          "y": 150,
          "z": 94.1716
        },
        {
          "hole": 76,
          "x": 33.7511,
          "y": 150,
          "z": 99.4277
        },
        {
          "hole": 77,
          "x": 27.176,
          "y": 150,
          "z": 101.4222
        },
        {
          "hole": 78,
          "x": 20.4845,
          "y": 150,
          "z": 102.9824
        },
        {
          "hole": 79,
          "x": 13.7053,
          "y": 150,
          "z": 104.1017
        },
        {
          "hole": 80,
          "x": 6.8673,
          "y": 150,
          "z": 104.7752
        },
        {
          "hole": 81,
          "x": -7.5214,
          "y": 140,
          "z": 104.7538
        },
        {
          "hole": 82,
          "x": -15.0105,
          "y": 140,
          "z": 104.0162
        },
        {
          "hole": 83,
          "x": -22.4354,
          "y": 140,
          "z": 102.7903
        },
        {
          "hole": 84,
          "x": -29.7642,
          "y": 140,
          "z": 101.0815
        },
        {
          "hole": 85,
          "x": -36.9655,
          "y": 140,
          "z": 98.897
        },
        {
          "hole": 86,
          "x": -50.8632,
          "y": 140,
          "z": 93.1404
        },
        {
          "hole": 87,
          "x": -57.5,
          "y": 140,
          "z": 89.5929
        },
        {
          "hole": 88,
          "x": -63.8906,
          "y": 140,
          "z": 85.619
        },
        {
          "hole": 89,
          "x": -70.0076,
          "y": 140,
          "z": 81.2356
        },
        {
          "hole": 90,
          "x": -75.8248,
          "y": 140,
          "z": 76.4616
        },
        {
          "hole": 91,
          "x": -86.4616,
          "y": 140,
          "z": 65.8248
        },
        {
          "hole": 92,
          "x": -91.2356,
          "y": 140,
          "z": 60.0076
        },
        {
          "hole": 93,
          "x": -95.619,
          "y": 140,
          "z": 53.8906
        },
        {
          "hole": 94,
          "x": -99.5929,
          "y": 140,
          "z": 47.5
        },
        {
          "hole": 95,
          "x": -103.1404,
          "y": 140,
          "z": 40.8632
        },
        {
          "hole": 96,
          "x": -108.897,
          "y": 140,
          "z": 26.9655
        },
        {
          "hole": 97,
          "x": -111.0815,
          "y": 140,
          "z": 19.7642
        },
        {
          "hole": 98,
          "x": -112.7903,
          "y": 140,
          "z": 12.4354
        },
        {
          "hole": 99,
          "x": -114.0162,
          "y": 140,
          "z": 5.0105
        },
        {
          "hole": 100,
          "x": -114.7538,
          "y": 140,
          "z": -2.4786
        },
        {
          "hole": 101,
          "x": -114.7324,
          "y": 130,
          "z": -18.1754
        },
        {
          "hole": 102,
          "x": -113.9306,
          "y": 130,
          "z": -26.3158
        },
        {
          "hole": 103,
          "x": -112.5981,
          "y": 130,
          "z": -34.3863
        },
        {
          "hole": 104,
          "x": -110.7407,
          "y": 130,
          "z": -42.3524
        },
        {
          "hole": 105,
          "x": -108.3663,
          "y": 130,
          "z": -50.1799
        },
        {
          "hole": 106,
          "x": -102.1091,
          "y": 130,
          "z": -65.2861
        },
        {
          "hole": 107,
          "x": -98.2532,
          "y": 130,
          "z": -72.5
        },
        {
          "hole": 108,
          "x": -93.9337,
          "y": 130,
          "z": -79.4463
        },
        {
          "hole": 109,
          "x": -89.1692,
          "y": 130,
          "z": -86.0952
        },
        {
          "hole": 110,
          "x": -83.98,
          "y": 130,
          "z": -92.4182
        },
        {
          "hole": 111,
          "x": -72.4182,
          "y": 130,
          "z": -103.98
        },
        {
          "hole": 112,
          "x": -66.0952,
          "y": 130,
          "z": -109.1692
        },
        {
          "hole": 113,
          "x": -59.4463,
          "y": 130,
          "z": -113.9337
        },
        {
          "hole": 114,
          "x": -52.5,
          "y": 130,
          "z": -118.2532
        },
        {
          "hole": 115,
          "x": -45.2861,
          "y": 130,
          "z": -122.1091
        },
        {
          "hole": 116,
          "x": -30.1799,
          "y": 130,
          "z": -128.3663
        },
        {
          "hole": 117,
          "x": -22.3524,
          "y": 130,
          "z": -130.7407
        },
        {
          "hole": 118,
          "x": -14.3863,
          "y": 130,
          "z": -132.5982
        },
        {
          "hole": 119,
          "x": -6.3158,
          "y": 130,
          "z": -133.9306
        },
        {
          "hole": 120,
          "x": 1.8246,
          "y": 130,
          "z": -134.7324
        },
        {
          "hole": 121,
          "x": 18.8294,
          "y": 120,
          "z": -134.711
        },
        {
          "hole": 122,
          "x": 27.621,
          "y": 120,
          "z": -133.8451
        },
        {
          "hole": 123,
          "x": 36.3372,
          "y": 120,
          "z": -132.406
        },
        {
          "hole": 124,
          "x": 44.9406,
          "y": 120,
          "z": -130.4
        },
        {
          "hole": 125,
          "x": 53.3943,
          "y": 120,
          "z": -127.8356
        },
        {
          "hole": 126,
          "x": 69.709,
          "y": 120,
          "z": -121.0778
        },
        {
          "hole": 127,
          "x": 77.5,
          "y": 120,
          "z": -116.9134
        },
        {
          "hole": 128,
          "x": 85.002,
          "y": 120,
          "z": -112.2484
        },
        {
          "hole": 129,
          "x": 92.1828,
          "y": 120,
          "z": -107.1027
        },
        {
          "hole": 130,
          "x": 99.0117,
          "y": 120,
          "z": -101.4984
        },
        {
          "hole": 131,
          "x": 111.4984,
          "y": 120,
          "z": -89.0117
        },
        {
          "hole": 132,
          "x": 117.1027,
          "y": 120,
          "z": -82.1828
        },
        {
          "hole": 133,
          "x": 122.2484,
          "y": 120,
          "z": -75.002
        },
        {
          "hole": 134,
          "x": 126.9134,
          "y": 120,
          "z": -67.5
        },
        {
          "hole": 135,
          "x": 131.0778,
          "y": 120,
          "z": -59.709
        },
        {
          "hole": 136,
          "x": 137.8356,
          "y": 120,
          "z": -43.3943
        },
        {
          "hole": 137,
          "x": 140.4,
          "y": 120,
          "z": -34.9406
        },
        {
          "hole": 138,
          "x": 142.406,
          "y": 120,
          "z": -26.3372
        },
        {
          "hole": 139,
          "x": 143.8451,
          "y": 120,
          "z": -17.621
        },
        {
          "hole": 140,
          "x": 144.711,
          "y": 120,
          "z": -8.8294
        },
        {
          "hole": 141,
          "x": 144.862,
          "y": 110,
          "z": 6.3248
        },
        {
          "hole": 142,
          "x": 144.4482,
          "y": 110,
          "z": 12.6376
        },
        {
          "hole": 143,
          "x": 143.7595,
          "y": 110,
          "z": 18.9263
        },
        {
          "hole": 144,
          "x": 142.7971,
          "y": 110,
          "z": 25.179
        },
        {
          "hole": 145,
          "x": 141.5629,
          "y": 110,
          "z": 31.3837
        },
        {
          "hole": 146,
          "x": 138.289,
          "y": 110,
          "z": 43.6023
        },
        {
          "hole": 147,
          "x": 136.2554,
          "y": 110,
          "z": 49.5929
        },
        {
          "hole": 148,
          "x": 133.9625,
          "y": 110,
          "z": 55.4891
        },
        {
          "hole": 149,
          "x": 131.4146,
          "y": 110,
          "z": 61.2796
        },
        {
          "hole": 150,
          "x": 128.6166,
          "y": 110,
          "z": 66.9535
        },
        {
          "hole": 151,
          "x": 122.2918,
          "y": 110,
          "z": 77.9084
        },
        {
          "hole": 152,
          "x": 118.777,
          "y": 110,
          "z": 83.1686
        },
        {
          "hole": 153,
          "x": 115.0362,
          "y": 110,
          "z": 88.2704
        },
        {
          "hole": 154,
          "x": 111.0764,
          "y": 110,
          "z": 93.2042
        },
        {
          "hole": 155,
          "x": 106.9052,
          "y": 110,
          "z": 97.9606
        },
        {
          "hole": 156,
          "x": 97.9606,
          "y": 110,
          "z": 106.9052
        },
        {
          "hole": 157,
          "x": 93.2042,
          "y": 110,
          "z": 111.0764
        },
        {
          "hole": 158,
          "x": 88.2704,
          "y": 110,
          "z": 115.0362
        },
        {
          "hole": 159,
          "x": 83.1686,
          "y": 110,
          "z": 118.777
        },
        {
          "hole": 160,
          "x": 77.9084,
          "y": 110,
          "z": 122.2918
        },
        {
          "hole": 161,
          "x": 66.9536,
          "y": 110,
          "z": 128.6166
        },
        {
          "hole": 162,
          "x": 61.2797,
          "y": 110,
          "z": 131.4146
        },
        {
          "hole": 163,
          "x": 55.4891,
          "y": 110,
          "z": 133.9625
        },
        {
          "hole": 164,
          "x": 49.5929,
          "y": 110,
          "z": 136.2554
        },
        {
          "hole": 165,
          "x": 43.6023,
          "y": 110,
          "z": 138.289
        },
        {
          "hole": 166,
          "x": 31.3838,
          "y": 110,
          "z": 141.5629
        },
        {
          "hole": 167,
          "x": 25.179,
          "y": 110,
          "z": 142.7971
        },
        {
          "hole": 168,
          "x": 18.9263,
          "y": 110,
          "z": 143.7595
        },
        {
          "hole": 169,
          "x": 12.6376,
          "y": 110,
          "z": 144.4482
        },
        {
          "hole": 170,
          "x": 6.3248,
          "y": 110,
          "z": 144.862
        },
        {
          "hole": 171,
          "x": -6.761,
          "y": 100,
          "z": 144.8525
        },
        {
          "hole": 172,
          "x": -13.5091,
          "y": 100,
          "z": 144.4102
        },
        {
          "hole": 173,
          "x": -20.2316,
          "y": 100,
          "z": 143.674
        },
        {
          "hole": 174,
          "x": -26.9155,
          "y": 100,
          "z": 142.6452
        },
        {
          "hole": 175,
          "x": -33.5481,
          "y": 100,
          "z": 141.3259
        },
        {
          "hole": 176,
          "x": -46.6094,
          "y": 100,
          "z": 137.8261
        },
        {
          "hole": 177,
          "x": -53.0131,
          "y": 100,
          "z": 135.6524
        },
        {
          "hole": 178,
          "x": -59.3159,
          "y": 100,
          "z": 133.2013
        },
        {
          "hole": 179,
          "x": -65.5058,
          "y": 100,
          "z": 130.4777
        },
        {
          "hole": 180,
          "x": -71.571,
          "y": 100,
          "z": 127.4867
        },
        {
          "hole": 181,
          "x": -83.2814,
          "y": 100,
          "z": 120.7257
        },
        {
          "hole": 182,
          "x": -88.9043,
          "y": 100,
          "z": 116.9686
        },
        {
          "hole": 183,
          "x": -94.358,
          "y": 100,
          "z": 112.9698
        },
        {
          "hole": 184,
          "x": -99.6321,
          "y": 100,
          "z": 108.7369
        },
        {
          "hole": 185,
          "x": -104.7165,
          "y": 100,
          "z": 104.278
        },
        {
          "hole": 186,
          "x": -114.278,
          "y": 100,
          "z": 94.7165
        },
        {
          "hole": 187,
          "x": -118.7369,
          "y": 100,
          "z": 89.6321
        },
        {
          "hole": 188,
          "x": -122.9698,
          "y": 100,
          "z": 84.358
        },
        {
          "hole": 189,
          "x": -126.9686,
          "y": 100,
          "z": 78.9043
        },
        {
          "hole": 190,
          "x": -130.7257,
          "y": 100,
          "z": 73.2814
        },
        {
          "hole": 191,
          "x": -137.4867,
          "y": 100,
          "z": 61.571
        },
        {
          "hole": 192,
          "x": -140.4777,
          "y": 100,
          "z": 55.5058
        },
        {
          "hole": 193,
          "x": -143.2013,
          "y": 100,
          "z": 49.3159
        },
        {
          "hole": 194,
          "x": -145.6524,
          "y": 100,
          "z": 43.0131
        },
        {
          "hole": 195,
          "x": -147.8261,
          "y": 100,
          "z": 36.6094
        },
        {
          "hole": 196,
          "x": -151.3259,
          "y": 100,
          "z": 23.5481
        },
        {
          "hole": 197,
          "x": -152.6452,
          "y": 100,
          "z": 16.9155
        },
        {
          "hole": 198,
          "x": -153.674,
          "y": 100,
          "z": 10.2316
        },
        {
          "hole": 199,
          "x": -154.4102,
          "y": 100,
          "z": 3.5091
        },
        {
          "hole": 200,
          "x": -154.8525,
          "y": 100,
          "z": -3.239
        },
        {
          "hole": 201,
          "x": -154.843,
          "y": 90,
          "z": -17.1972
        },
        {
          "hole": 202,
          "x": -154.3721,
          "y": 90,
          "z": -24.3807
        },
        {
          "hole": 203,
          "x": -153.5884,
          "y": 90,
          "z": -31.5368
        },
        {
          "hole": 204,
          "x": -152.4933,
          "y": 90,
          "z": -38.6519
        },
        {
          "hole": 205,
          "x": -151.0889,
          "y": 90,
          "z": -45.7125
        },
        {
          "hole": 206,
          "x": -147.3633,
          "y": 90,
          "z": -59.6165
        },
        {
          "hole": 207,
          "x": -145.0493,
          "y": 90,
          "z": -66.4333
        },
        {
          "hole": 208,
          "x": -142.4401,
          "y": 90,
          "z": -73.1428
        },
        {
          "hole": 209,
          "x": -139.5408,
          "y": 90,
          "z": -79.732
        },
        {
          "hole": 210,
          "x": -136.3568,
          "y": 90,
          "z": -86.1885
        },
        {
          "hole": 211,
          "x": -129.1596,
          "y": 90,
          "z": -98.6544
        },
        {
          "hole": 212,
          "x": -125.1601,
          "y": 90,
          "z": -104.6401
        },
        {
          "hole": 213,
          "x": -120.9033,
          "y": 90,
          "z": -110.4456
        },
        {
          "hole": 214,
          "x": -116.3973,
          "y": 90,
          "z": -116.06
        },
        {
          "hole": 215,
          "x": -111.6508,
          "y": 90,
          "z": -121.4724
        },
        {
          "hole": 216,
          "x": -101.4724,
          "y": 90,
          "z": -131.6508
        },
        {
          "hole": 217,
          "x": -96.06,
          "y": 90,
          "z": -136.3973
        },
        {
          "hole": 218,
          "x": -90.4457,
          "y": 90,
          "z": -140.9033
        },
        {
          "hole": 219,
          "x": -84.6401,
          "y": 90,
          "z": -145.1601
        },
        {
          "hole": 220,
          "x": -78.6545,
          "y": 90,
          "z": -149.1596
        },
        {
          "hole": 221,
          "x": -66.1885,
          "y": 90,
          "z": -156.3568
        },
        {
          "hole": 222,
          "x": -59.732,
          "y": 90,
          "z": -159.5408
        },
        {
          "hole": 223,
          "x": -53.1428,
          "y": 90,
          "z": -162.4401
        },
        {
          "hole": 224,
          "x": -46.4333,
          "y": 90,
          "z": -165.0493
        },
        {
          "hole": 225,
          "x": -39.6164,
          "y": 90,
          "z": -167.3633
        },
        {
          "hole": 226,
          "x": -25.7125,
          "y": 90,
          "z": -171.0888
        },
        {
          "hole": 227,
          "x": -18.652,
          "y": 90,
          "z": -172.4933
        },
        {
          "hole": 228,
          "x": -11.5368,
          "y": 90,
          "z": -173.5884
        },
        {
          "hole": 229,
          "x": -4.3807,
          "y": 90,
          "z": -174.3721
        },
        {
          "hole": 230,
          "x": 2.8028,
          "y": 90,
          "z": -174.8429
        },
        {
          "hole": 231,
          "x": 17.6334,
          "y": 80,
          "z": -174.8334
        },
        {
          "hole": 232,
          "x": 25.2523,
          "y": 80,
          "z": -174.3341
        },
        {
          "hole": 233,
          "x": 32.8421,
          "y": 80,
          "z": -173.5028
        },
        {
          "hole": 234,
          "x": 40.3884,
          "y": 80,
          "z": -172.3413
        },
        {
          "hole": 235,
          "x": 47.8769,
          "y": 80,
          "z": -170.8518
        },
        {
          "hole": 236,
          "x": 62.6235,
          "y": 80,
          "z": -166.9004
        },
        {
          "hole": 237,
          "x": 69.8535,
          "y": 80,
          "z": -164.4462
        },
        {
          "hole": 238,
          "x": 76.9696,
          "y": 80,
          "z": -161.6789
        },
        {
          "hole": 239,
          "x": 83.9582,
          "y": 80,
          "z": -158.6038
        },
        {
          "hole": 240,
          "x": 90.806,
          "y": 80,
          "z": -155.2269
        },
        {
          "hole": 241,
          "x": 104.0274,
          "y": 80,
          "z": -147.5935
        },
        {
          "hole": 242,
          "x": 110.3759,
          "y": 80,
          "z": -143.3516
        },
        {
          "hole": 243,
          "x": 116.5332,
          "y": 80,
          "z": -138.8368
        },
        {
          "hole": 244,
          "x": 122.4878,
          "y": 80,
          "z": -134.0578
        },
        {
          "hole": 245,
          "x": 128.2283,
          "y": 80,
          "z": -129.0235
        },
        {
          "hole": 246,
          "x": 139.0235,
          "y": 80,
          "z": -118.2283
        },
        {
          "hole": 247,
          "x": 144.0578,
          "y": 80,
          "z": -112.4878
        },
        {
          "hole": 248,
          "x": 148.8368,
          "y": 80,
          "z": -106.5332
        },
        {
          "hole": 249,
          "x": 153.3516,
          "y": 80,
          "z": -100.3759
        },
        {
          "hole": 250,
          "x": 157.5935,
          "y": 80,
          "z": -94.0274
        },
        {
          "hole": 251,
          "x": 165.2269,
          "y": 80,
          "z": -80.806
        },
        {
          "hole": 252,
          "x": 168.6039,
          "y": 80,
          "z": -73.9582
        },
        {
          "hole": 253,
          "x": 171.6789,
          "y": 80,
          "z": -66.9696
        },
        {
          "hole": 254,
          "x": 174.4462,
          "y": 80,
          "z": -59.8535
        },
        {
          "hole": 255,
          "x": 176.9005,
          "y": 80,
          "z": -52.6235
        },
        {
          "hole": 256,
          "x": 180.8518,
          "y": 80,
          "z": -37.8769
        },
        {
          "hole": 257,
          "x": 182.3414,
          "y": 80,
          "z": -30.3884
        },
        {
          "hole": 258,
          "x": 183.5028,
          "y": 80,
          "z": -22.8421
        },
        {
          "hole": 259,
          "x": 184.3341,
          "y": 80,
          "z": -15.2522
        },
        {
          "hole": 260,
          "x": 184.8334,
          "y": 80,
          "z": -7.6334
        },
        {
          "hole": 261,
          "x": 184.9009,
          "y": 70,
          "z": 6.053
        },
        {
          "hole": 262,
          "x": 184.6039,
          "y": 70,
          "z": 12.0996
        },
        {
          "hole": 263,
          "x": 184.1092,
          "y": 70,
          "z": 18.1332
        },
        {
          "hole": 264,
          "x": 183.4173,
          "y": 70,
          "z": 24.1473
        },
        {
          "hole": 265,
          "x": 182.529,
          "y": 70,
          "z": 30.1357
        },
        {
          "hole": 266,
          "x": 180.1672,
          "y": 70,
          "z": 42.0091
        },
        {
          "hole": 267,
          "x": 178.6963,
          "y": 70,
          "z": 47.8815
        },
        {
          "hole": 268,
          "x": 177.034,
          "y": 70,
          "z": 53.7027
        },
        {
          "hole": 269,
          "x": 175.1821,
          "y": 70,
          "z": 59.4663
        },
        {
          "hole": 270,
          "x": 173.1426,
          "y": 70,
          "z": 65.1663
        },
        {
          "hole": 271,
          "x": 168.5098,
          "y": 70,
          "z": 76.3508
        },
        {
          "hole": 272,
          "x": 165.9215,
          "y": 70,
          "z": 81.8234
        },
        {
          "hole": 273,
          "x": 163.1554,
          "y": 70,
          "z": 87.2084
        },
        {
          "hole": 274,
          "x": 160.2147,
          "y": 70,
          "z": 92.5
        },
        {
          "hole": 275,
          "x": 157.1024,
          "y": 70,
          "z": 97.6926
        },
        {
          "hole": 276,
          "x": 150.3766,
          "y": 70,
          "z": 107.7584
        },
        {
          "hole": 277,
          "x": 146.7704,
          "y": 70,
          "z": 112.6209
        },
        {
          "hole": 278,
          "x": 143.0069,
          "y": 70,
          "z": 117.3628
        },
        {
          "hole": 279,
          "x": 139.0904,
          "y": 70,
          "z": 121.979
        },
        {
          "hole": 280,
          "x": 135.0249,
          "y": 70,
          "z": 126.4646
        },
        {
          "hole": 281,
          "x": 126.4646,
          "y": 70,
          "z": 135.0249
        },
        {
          "hole": 282,
          "x": 121.979,
          "y": 70,
          "z": 139.0904
        },
        {
          "hole": 283,
          "x": 117.3628,
          "y": 70,
          "z": 143.0069
        },
        {
          "hole": 284,
          "x": 112.6209,
          "y": 70,
          "z": 146.7704
        },
        {
          "hole": 285,
          "x": 107.7584,
          "y": 70,
          "z": 150.3766
        },
        {
          "hole": 286,
          "x": 97.6926,
          "y": 70,
          "z": 157.1024
        },
        {
          "hole": 287,
          "x": 92.5,
          "y": 70,
          "z": 160.2147
        },
        {
          "hole": 288,
          "x": 87.2084,
          "y": 70,
          "z": 163.1554
        },
        {
          "hole": 289,
          "x": 81.8234,
          "y": 70,
          "z": 165.9215
        },
        {
          "hole": 290,
          "x": 76.3508,
          "y": 70,
          "z": 168.5098
        },
        {
          "hole": 291,
          "x": 65.1663,
          "y": 70,
          "z": 173.1426
        },
        {
          "hole": 292,
          "x": 59.4663,
          "y": 70,
          "z": 175.1821
        },
        {
          "hole": 293,
          "x": 53.7027,
          "y": 70,
          "z": 177.034
        },
        {
          "hole": 294,
          "x": 47.8815,
          "y": 70,
          "z": 178.6963
        },
        {
          "hole": 295,
          "x": 42.0091,
          "y": 70,
          "z": 180.1672
        },
        {
          "hole": 296,
          "x": 30.1357,
          "y": 70,
          "z": 182.529
        },
        {
          "hole": 297,
          "x": 24.1474,
          "y": 70,
          "z": 183.4173
        },
        {
          "hole": 298,
          "x": 18.1332,
          "y": 70,
          "z": 184.1092
        },
        {
          "hole": 299,
          "x": 12.0996,
          "y": 70,
          "z": 184.6039
        },
        {
          "hole": 300,
          "x": 6.0531,
          "y": 70,
          "z": 184.9009
        },
        {
          "hole": 301,
          "x": -6.3802,
          "y": 60,
          "z": 184.8956
        },
        {
          "hole": 302,
          "x": -12.7536,
          "y": 60,
          "z": 184.5825
        },
        {
          "hole": 303,
          "x": -19.1133,
          "y": 60,
          "z": 184.061
        },
        {
          "hole": 304,
          "x": -25.4526,
          "y": 60,
          "z": 183.3317
        },
        {
          "hole": 305,
          "x": -31.7646,
          "y": 60,
          "z": 182.3954
        },
        {
          "hole": 306,
          "x": -44.2799,
          "y": 60,
          "z": 179.906
        },
        {
          "hole": 307,
          "x": -50.4697,
          "y": 60,
          "z": 178.3555
        },
        {
          "hole": 308,
          "x": -56.6055,
          "y": 60,
          "z": 176.6034
        },
        {
          "hole": 309,
          "x": -62.6807,
          "y": 60,
          "z": 174.6514
        },
        {
          "hole": 310,
          "x": -68.6888,
          "y": 60,
          "z": 172.5016
        },
        {
          "hole": 311,
          "x": -80.4779,
          "y": 60,
          "z": 167.6184
        },
        {
          "hole": 312,
          "x": -86.2463,
          "y": 60,
          "z": 164.8902
        },
        {
          "hole": 313,
          "x": -91.9224,
          "y": 60,
          "z": 161.9746
        },
        {
          "hole": 314,
          "x": -97.5,
          "y": 60,
          "z": 158.8749
        },
        {
          "hole": 315,
          "x": -102.9732,
          "y": 60,
          "z": 155.5944
        },
        {
          "hole": 316,
          "x": -113.5832,
          "y": 60,
          "z": 148.5051
        },
        {
          "hole": 317,
          "x": -118.7085,
          "y": 60,
          "z": 144.7039
        },
        {
          "hole": 318,
          "x": -123.7067,
          "y": 60,
          "z": 140.737
        },
        {
          "hole": 319,
          "x": -128.5724,
          "y": 60,
          "z": 136.6088
        },
        {
          "hole": 320,
          "x": -133.3005,
          "y": 60,
          "z": 132.3235
        },
        {
          "hole": 321,
          "x": -142.3235,
          "y": 60,
          "z": 123.3005
        },
        {
          "hole": 322,
          "x": -146.6088,
          "y": 60,
          "z": 118.5724
        },
        {
          "hole": 323,
          "x": -150.737,
          "y": 60,
          "z": 113.7067
        },
        {
          "hole": 324,
          "x": -154.7039,
          "y": 60,
          "z": 108.7085
        },
        {
          "hole": 325,
          "x": -158.5051,
          "y": 60,
          "z": 103.5831
        },
        {
          "hole": 326,
          "x": -165.5944,
          "y": 60,
          "z": 92.9732
        },
        {
          "hole": 327,
          "x": -168.875,
          "y": 60,
          "z": 87.5
        },
        {
          "hole": 328,
          "x": -171.9746,
          "y": 60,
          "z": 81.9224
        },
        {
          "hole": 329,
          "x": -174.8902,
          "y": 60,
          "z": 76.2463
        },
        {
          "hole": 330,
          "x": -177.6184,
          "y": 60,
          "z": 70.4779
        },
        {
          "hole": 331,
          "x": -182.5017,
          "y": 60,
          "z": 58.6888
        },
        {
          "hole": 332,
          "x": -184.6514,
          "y": 60,
          "z": 52.6807
        },
        {
          "hole": 333,
          "x": -186.6034,
          "y": 60,
          "z": 46.6055
        },
        {
          "hole": 334,
          "x": -188.3555,
          "y": 60,
          "z": 40.4697
        },
        {
          "hole": 335,
          "x": -189.906,
          "y": 60,
          "z": 34.2799
        },
        {
          "hole": 336,
          "x": -192.3954,
          "y": 60,
          "z": 21.7646
        },
        {
          "hole": 337,
          "x": -193.3317,
          "y": 60,
          "z": 15.4526
        },
        {
          "hole": 338,
          "x": -194.061,
          "y": 60,
          "z": 9.1134
        },
        {
          "hole": 339,
          "x": -194.5825,
          "y": 60,
          "z": 2.7536
        },
        {
          "hole": 340,
          "x": -194.8956,
          "y": 60,
          "z": -3.6198
        },
        {
          "hole": 341,
          "x": -194.8902,
          "y": 50,
          "z": -16.7074
        },
        {
          "hole": 342,
          "x": -194.5611,
          "y": 50,
          "z": -23.4076
        },
        {
          "hole": 343,
          "x": -194.0129,
          "y": 50,
          "z": -30.0935
        },
        {
          "hole": 344,
          "x": -193.2462,
          "y": 50,
          "z": -36.7579
        },
        {
          "hole": 345,
          "x": -192.2619,
          "y": 50,
          "z": -43.3936
        },
        {
          "hole": 346,
          "x": -189.6448,
          "y": 50,
          "z": -56.5506
        },
        {
          "hole": 347,
          "x": -188.0148,
          "y": 50,
          "z": -63.0579
        },
        {
          "hole": 348,
          "x": -186.1728,
          "y": 50,
          "z": -69.5084
        },
        {
          "hole": 349,
          "x": -184.1207,
          "y": 50,
          "z": -75.8951
        },
        {
          "hole": 350,
          "x": -181.8607,
          "y": 50,
          "z": -82.2113
        },
        {
          "hole": 351,
          "x": -176.7271,
          "y": 50,
          "z": -94.6049
        },
        {
          "hole": 352,
          "x": -173.8589,
          "y": 50,
          "z": -100.6692
        },
        {
          "hole": 353,
          "x": -170.7939,
          "y": 50,
          "z": -106.6363
        },
        {
          "hole": 354,
          "x": -167.5352,
          "y": 50,
          "z": -112.5
        },
        {
          "hole": 355,
          "x": -164.0864,
          "y": 50,
          "z": -118.2539
        },
        {
          "hole": 356,
          "x": -156.6336,
          "y": 50,
          "z": -129.4079
        },
        {
          "hole": 357,
          "x": -152.6374,
          "y": 50,
          "z": -134.7961
        },
        {
          "hole": 358,
          "x": -148.4671,
          "y": 50,
          "z": -140.0506
        },
        {
          "hole": 359,
          "x": -144.1272,
          "y": 50,
          "z": -145.1659
        },
        {
          "hole": 360,
          "x": -139.6221,
          "y": 50,
          "z": -150.1364
        },
        {
          "hole": 361,
          "x": -130.1364,
          "y": 50,
          "z": -159.6221
        },
        {
          "hole": 362,
          "x": -125.1659,
          "y": 50,
          "z": -164.1272
        },
        {
          "hole": 363,
          "x": -120.0506,
          "y": 50,
          "z": -168.4671
        },
        {
          "hole": 364,
          "x": -114.7961,
          "y": 50,
          "z": -172.6374
        },
        {
          "hole": 365,
          "x": -109.4079,
          "y": 50,
          "z": -176.6336
        },
        {
          "hole": 366,
          "x": -98.2539,
          "y": 50,
          "z": -184.0864
        },
        {
          "hole": 367,
          "x": -92.5,
          "y": 50,
          "z": -187.5352
        },
        {
          "hole": 368,
          "x": -86.6363,
          "y": 50,
          "z": -190.7939
        },
        {
          "hole": 369,
          "x": -80.6692,
          "y": 50,
          "z": -193.8589
        },
        {
          "hole": 370,
          "x": -74.6049,
          "y": 50,
          "z": -196.7271
        },
        {
          "hole": 371,
          "x": -62.2112,
          "y": 50,
          "z": -201.8607
        },
        {
          "hole": 372,
          "x": -55.8951,
          "y": 50,
          "z": -204.1207
        },
        {
          "hole": 373,
          "x": -49.5083,
          "y": 50,
          "z": -206.1728
        },
        {
          "hole": 374,
          "x": -43.0579,
          "y": 50,
          "z": -208.0148
        },
        {
          "hole": 375,
          "x": -36.5506,
          "y": 50,
          "z": -209.6448
        },
        {
          "hole": 376,
          "x": -23.3936,
          "y": 50,
          "z": -212.2619
        },
        {
          "hole": 377,
          "x": -16.7579,
          "y": 50,
          "z": -213.2462
        },
        {
          "hole": 378,
          "x": -10.0935,
          "y": 50,
          "z": -214.0128
        },
        {
          "hole": 379,
          "x": -3.4077,
          "y": 50,
          "z": -214.5611
        },
        {
          "hole": 380,
          "x": 3.2926,
          "y": 50,
          "z": -214.8902
        },
        {
          "hole": 381,
          "x": 17.0346,
          "y": 40,
          "z": -214.8849
        },
        {
          "hole": 382,
          "x": 24.0617,
          "y": 40,
          "z": -214.5397
        },
        {
          "hole": 383,
          "x": 31.0737,
          "y": 40,
          "z": -213.9647
        },
        {
          "hole": 384,
          "x": 38.0631,
          "y": 40,
          "z": -213.1607
        },
        {
          "hole": 385,
          "x": 45.0225,
          "y": 40,
          "z": -212.1283
        },
        {
          "hole": 386,
          "x": 58.8214,
          "y": 40,
          "z": -209.3836
        },
        {
          "hole": 387,
          "x": 65.6461,
          "y": 40,
          "z": -207.6741
        },
        {
          "hole": 388,
          "x": 72.4112,
          "y": 40,
          "z": -205.7422
        },
        {
          "hole": 389,
          "x": 79.1095,
          "y": 40,
          "z": -203.59
        },
        {
          "hole": 390,
          "x": 85.7338,
          "y": 40,
          "z": -201.2198
        },
        {
          "hole": 391,
          "x": 98.732,
          "y": 40,
          "z": -195.8357
        },
        {
          "hole": 392,
          "x": 105.0921,
          "y": 40,
          "z": -192.8276
        },
        {
          "hole": 393,
          "x": 111.3503,
          "y": 40,
          "z": -189.6131
        },
        {
          "hole": 394,
          "x": 117.5,
          "y": 40,
          "z": -186.1955
        },
        {
          "hole": 395,
          "x": 123.5346,
          "y": 40,
          "z": -182.5785
        },
        {
          "hole": 396,
          "x": 135.2327,
          "y": 40,
          "z": -174.762
        },
        {
          "hole": 397,
          "x": 140.8837,
          "y": 40,
          "z": -170.571
        },
        {
          "hole": 398,
          "x": 146.3946,
          "y": 40,
          "z": -166.1973
        },
        {
          "hole": 399,
          "x": 151.7594,
          "y": 40,
          "z": -161.6456
        },
        {
          "hole": 400,
          "x": 156.9723,
          "y": 40,
          "z": -156.9208
        },
        {
          "hole": 401,
          "x": 166.9208,
          "y": 40,
          "z": -146.9724
        },
        {
          "hole": 402,
          "x": 171.6456,
          "y": 40,
          "z": -141.7594
        },
        {
          "hole": 403,
          "x": 176.1972,
          "y": 40,
          "z": -136.3946
        },
        {
          "hole": 404,
          "x": 180.571,
          "y": 40,
          "z": -130.8837
        },
        {
          "hole": 405,
          "x": 184.762,
          "y": 40,
          "z": -125.2327
        },
        {
          "hole": 406,
          "x": 192.5785,
          "y": 40,
          "z": -113.5346
        },
        {
          "hole": 407,
          "x": 196.1955,
          "y": 40,
          "z": -107.5
        },
        {
          "hole": 408,
          "x": 199.6131,
          "y": 40,
          "z": -101.3503
        },
        {
          "hole": 409,
          "x": 202.8276,
          "y": 40,
          "z": -95.0921
        },
        {
          "hole": 410,
          "x": 205.8357,
          "y": 40,
          "z": -88.732
        },
        {
          "hole": 411,
          "x": 211.2198,
          "y": 40,
          "z": -75.7338
        },
        {
          "hole": 412,
          "x": 213.59,
          "y": 40,
          "z": -69.1095
        },
        {
          "hole": 413,
          "x": 215.7422,
          "y": 40,
          "z": -62.4112
        },
        {
          "hole": 414,
          "x": 217.674,
          "y": 40,
          "z": -55.6461
        },
        {
          "hole": 415,
          "x": 219.3835,
          "y": 40,
          "z": -48.8214
        },
        {
          "hole": 416,
          "x": 222.1283,
          "y": 40,
          "z": -35.0225
        },
        {
          "hole": 417,
          "x": 223.1606,
          "y": 40,
          "z": -28.0631
        },
        {
          "hole": 418,
          "x": 223.9647,
          "y": 40,
          "z": -21.0737
        },
        {
          "hole": 419,
          "x": 224.5397,
          "y": 40,
          "z": -14.0617
        },
        {
          "hole": 420,
          "x": 224.8849,
          "y": 40,
          "z": -7.0346
        },
        {
          "hole": 421,
          "x": 224.8795,
          "y": 30,
          "z": 7.3618
        },
        {
          "hole": 422,
          "x": 224.5183,
          "y": 30,
          "z": 14.7157
        },
        {
          "hole": 423,
          "x": 223.9166,
          "y": 30,
          "z": 22.0539
        },
        {
          "hole": 424,
          "x": 223.0751,
          "y": 30,
          "z": 29.3684
        },
        {
          "hole": 425,
          "x": 221.9947,
          "y": 30,
          "z": 36.6515
        },
        {
          "hole": 426,
          "x": 219.1223,
          "y": 30,
          "z": 51.0922
        },
        {
          "hole": 427,
          "x": 217.3333,
          "y": 30,
          "z": 58.2343
        },
        {
          "hole": 428,
          "x": 215.3116,
          "y": 30,
          "z": 65.3141
        },
        {
          "hole": 429,
          "x": 213.0593,
          "y": 30,
          "z": 72.3239
        },
        {
          "hole": 430,
          "x": 210.5788,
          "y": 30,
          "z": 79.2563
        },
        {
          "hole": 431,
          "x": 204.9444,
          "y": 30,
          "z": 92.8591
        },
        {
          "hole": 432,
          "x": 201.7964,
          "y": 30,
          "z": 99.515
        },
        {
          "hole": 433,
          "x": 198.4323,
          "y": 30,
          "z": 106.0643
        },
        {
          "hole": 434,
          "x": 194.8557,
          "y": 30,
          "z": 112.5
        },
        {
          "hole": 435,
          "x": 191.0705,
          "y": 30,
          "z": 118.8153
        },
        {
          "hole": 436,
          "x": 182.8905,
          "y": 30,
          "z": 131.0575
        },
        {
          "hole": 437,
          "x": 178.5045,
          "y": 30,
          "z": 136.9713
        },
        {
          "hole": 438,
          "x": 173.9273,
          "y": 30,
          "z": 142.7385
        },
        {
          "hole": 439,
          "x": 169.164,
          "y": 30,
          "z": 148.3528
        },
        {
          "hole": 440,
          "x": 164.2194,
          "y": 30,
          "z": 153.8083
        },
        {
          "hole": 441,
          "x": 153.8083,
          "y": 30,
          "z": 164.2194
        },
        {
          "hole": 442,
          "x": 148.3528,
          "y": 30,
          "z": 169.164
        },
        {
          "hole": 443,
          "x": 142.7385,
          "y": 30,
          "z": 173.9273
        },
        {
          "hole": 444,
          "x": 136.9713,
          "y": 30,
          "z": 178.5045
        },
        {
          "hole": 445,
          "x": 131.0575,
          "y": 30,
          "z": 182.8905
        },
        {
          "hole": 446,
          "x": 118.8153,
          "y": 30,
          "z": 191.0705
        },
        {
          "hole": 447,
          "x": 112.5,
          "y": 30,
          "z": 194.8557
        },
        {
          "hole": 448,
          "x": 106.0643,
          "y": 30,
          "z": 198.4323
        },
        {
          "hole": 449,
          "x": 99.515,
          "y": 30,
          "z": 201.7964
        },
        {
          "hole": 450,
          "x": 92.8591,
          "y": 30,
          "z": 204.9444
        },
        {
          "hole": 451,
          "x": 79.2563,
          "y": 30,
          "z": 210.5788
        },
        {
          "hole": 452,
          "x": 72.3239,
          "y": 30,
          "z": 213.0593
        },
        {
          "hole": 453,
          "x": 65.3141,
          "y": 30,
          "z": 215.3116
        },
        {
          "hole": 454,
          "x": 58.2343,
          "y": 30,
          "z": 217.3333
        },
        {
          "hole": 455,
          "x": 51.0922,
          "y": 30,
          "z": 219.1223
        },
        {
          "hole": 456,
          "x": 36.6515,
          "y": 30,
          "z": 221.9947
        },
        {
          "hole": 457,
          "x": 29.3684,
          "y": 30,
          "z": 223.0751
        },
        {
          "hole": 458,
          "x": 22.0539,
          "y": 30,
          "z": 223.9166
        },
        {
          "hole": 459,
          "x": 14.7157,
          "y": 30,
          "z": 224.5183
        },
        {
          "hole": 460,
          "x": 7.3618,
          "y": 30,
          "z": 224.8795
        },
        {
          "hole": 461,
          "x": -7.689,
          "y": 20,
          "z": 224.8742
        },
        {
          "hole": 462,
          "x": -15.3697,
          "y": 20,
          "z": 224.4968
        },
        {
          "hole": 463,
          "x": -23.034,
          "y": 20,
          "z": 223.8684
        },
        {
          "hole": 464,
          "x": -30.6737,
          "y": 20,
          "z": 222.9895
        },
        {
          "hole": 465,
          "x": -38.2804,
          "y": 20,
          "z": 221.8612
        },
        {
          "hole": 466,
          "x": -53.3629,
          "y": 20,
          "z": 218.8611
        },
        {
          "hole": 467,
          "x": -60.8225,
          "y": 20,
          "z": 216.9926
        },
        {
          "hole": 468,
          "x": -68.2169,
          "y": 20,
          "z": 214.881
        },
        {
          "hole": 469,
          "x": -75.5383,
          "y": 20,
          "z": 212.5286
        },
        {
          "hole": 470,
          "x": -82.7788,
          "y": 20,
          "z": 209.9379
        },
        {
          "hole": 471,
          "x": -96.9862,
          "y": 20,
          "z": 204.053
        },
        {
          "hole": 472,
          "x": -103.9378,
          "y": 20,
          "z": 200.7651
        },
        {
          "hole": 473,
          "x": -110.7782,
          "y": 20,
          "z": 197.2515
        },
        {
          "hole": 474,
          "x": -117.5,
          "y": 20,
          "z": 193.516
        },
        {
          "hole": 475,
          "x": -124.0959,
          "y": 20,
          "z": 189.5625
        },
        {
          "hole": 476,
          "x": -136.8823,
          "y": 20,
          "z": 181.019
        },
        {
          "hole": 477,
          "x": -143.0589,
          "y": 20,
          "z": 176.438
        },
        {
          "hole": 478,
          "x": -149.0824,
          "y": 20,
          "z": 171.6575
        },
        {
          "hole": 479,
          "x": -154.9463,
          "y": 20,
          "z": 166.6824
        },
        {
          "hole": 480,
          "x": -160.6442,
          "y": 20,
          "z": 161.5181
        },
        {
          "hole": 481,
          "x": 40,
          "y": 240,
          "z": -6.25
        }
      ]
    }
  },
  {
    "id": "board-fidget-spinner-cribbage",
    "name": "Fidget Spinner",
    "brand": "crazy,pints,adult",
    "desc": "Fidget Spinner Cribbage 3D cribbage board (45.5 MB)",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/fidget_spinner_-_sunken_-_3d_-_thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/5730422d65587cc2/fidget_spinner_-_sunken_-_3d.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": -8.2905,
          "y": 30,
          "z": -223.8537
        },
        {
          "hole": -1,
          "x": -16.5073,
          "y": 30,
          "z": -222.7719
        },
        {
          "hole": 1,
          "x": -32.5025,
          "y": 40,
          "z": -218.4857
        },
        {
          "hole": 2,
          "x": -40.1593,
          "y": 40,
          "z": -215.3141
        },
        {
          "hole": 3,
          "x": -47.5106,
          "y": 40,
          "z": -211.4873
        },
        {
          "hole": 4,
          "x": -54.5004,
          "y": 40,
          "z": -207.0343
        },
        {
          "hole": 5,
          "x": -61.0754,
          "y": 40,
          "z": -201.9891
        },
        {
          "hole": 6,
          "x": -75.3792,
          "y": 40,
          "z": -187.1234
        },
        {
          "hole": 7,
          "x": -82.2831,
          "y": 40,
          "z": -176.7911
        },
        {
          "hole": 8,
          "x": -87.7792,
          "y": 40,
          "z": -165.646
        },
        {
          "hole": 9,
          "x": -91.7736,
          "y": 40,
          "z": -153.8789
        },
        {
          "hole": 10,
          "x": -94.1979,
          "y": 40,
          "z": -141.6911
        },
        {
          "hole": 11,
          "x": -96.3886,
          "y": 40,
          "z": -121.5158
        },
        {
          "hole": 12,
          "x": -98.0473,
          "y": 40,
          "z": -113.1767
        },
        {
          "hole": 13,
          "x": -100.7803,
          "y": 40,
          "z": -105.1255
        },
        {
          "hole": 14,
          "x": -104.5408,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 15,
          "x": -109.2645,
          "y": 40,
          "z": -90.4305
        },
        {
          "hole": 16,
          "x": -120.4305,
          "y": 40,
          "z": -78.432
        },
        {
          "hole": 17,
          "x": -127.5,
          "y": 40,
          "z": -73.7084
        },
        {
          "hole": 18,
          "x": -135.1255,
          "y": 40,
          "z": -69.9478
        },
        {
          "hole": 19,
          "x": -143.1767,
          "y": 40,
          "z": -67.2148
        },
        {
          "hole": 20,
          "x": -151.5157,
          "y": 40,
          "z": -65.5561
        },
        {
          "hole": 21,
          "x": -172.7561,
          "y": 50,
          "z": -64.1873
        },
        {
          "hole": 22,
          "x": -184.9439,
          "y": 50,
          "z": -61.763
        },
        {
          "hole": 23,
          "x": -196.711,
          "y": 50,
          "z": -57.7686
        },
        {
          "hole": 24,
          "x": -207.8561,
          "y": 50,
          "z": -52.2725
        },
        {
          "hole": 25,
          "x": -218.1884,
          "y": 50,
          "z": -45.3686
        },
        {
          "hole": 26,
          "x": -235.7248,
          "y": 50,
          "z": -27.8324
        },
        {
          "hole": 27,
          "x": -242.6286,
          "y": 50,
          "z": -17.5
        },
        {
          "hole": 28,
          "x": -248.1248,
          "y": 50,
          "z": -6.355
        },
        {
          "hole": 29,
          "x": -252.1192,
          "y": 50,
          "z": 5.4122
        },
        {
          "hole": 30,
          "x": -254.5435,
          "y": 50,
          "z": 17.6
        },
        {
          "hole": 31,
          "x": -254.1872,
          "y": 50,
          "z": 42.4
        },
        {
          "hole": 32,
          "x": -251.7629,
          "y": 50,
          "z": 54.5878
        },
        {
          "hole": 33,
          "x": -247.7685,
          "y": 50,
          "z": 66.3549
        },
        {
          "hole": 34,
          "x": -242.2724,
          "y": 50,
          "z": 77.5
        },
        {
          "hole": 35,
          "x": -235.3685,
          "y": 50,
          "z": 87.8323
        },
        {
          "hole": 36,
          "x": -217.8323,
          "y": 50,
          "z": 105.3685
        },
        {
          "hole": 37,
          "x": -207.5,
          "y": 50,
          "z": 112.2724
        },
        {
          "hole": 38,
          "x": -196.3549,
          "y": 50,
          "z": 117.7685
        },
        {
          "hole": 39,
          "x": -184.5878,
          "y": 50,
          "z": 121.7629
        },
        {
          "hole": 40,
          "x": -172.4,
          "y": 50,
          "z": 124.1872
        },
        {
          "hole": 41,
          "x": -147.6,
          "y": 50,
          "z": 124.1872
        },
        {
          "hole": 42,
          "x": -135.4122,
          "y": 50,
          "z": 121.7629
        },
        {
          "hole": 43,
          "x": -123.6451,
          "y": 50,
          "z": 117.7685
        },
        {
          "hole": 44,
          "x": -112.5,
          "y": 50,
          "z": 112.2724
        },
        {
          "hole": 45,
          "x": -102.1677,
          "y": 50,
          "z": 105.3685
        },
        {
          "hole": 46,
          "x": -84.6314,
          "y": 50,
          "z": 87.8323
        },
        {
          "hole": 47,
          "x": -77.7276,
          "y": 50,
          "z": 77.5
        },
        {
          "hole": 48,
          "x": -72.2314,
          "y": 50,
          "z": 66.3549
        },
        {
          "hole": 49,
          "x": -68.2371,
          "y": 50,
          "z": 54.5878
        },
        {
          "hole": 50,
          "x": -65.8127,
          "y": 50,
          "z": 42.4
        },
        {
          "hole": 51,
          "x": -64.4546,
          "y": 60,
          "z": 22.2247
        },
        {
          "hole": 52,
          "x": -62.7959,
          "y": 60,
          "z": 13.8856
        },
        {
          "hole": 53,
          "x": -60.0628,
          "y": 60,
          "z": 5.8344
        },
        {
          "hole": 54,
          "x": -56.3023,
          "y": 60,
          "z": -1.7911
        },
        {
          "hole": 55,
          "x": -51.5786,
          "y": 60,
          "z": -8.8606
        },
        {
          "hole": 56,
          "x": -39.5802,
          "y": 60,
          "z": -20.8591
        },
        {
          "hole": 57,
          "x": -32.5107,
          "y": 60,
          "z": -25.5828
        },
        {
          "hole": 58,
          "x": -24.8851,
          "y": 60,
          "z": -29.3433
        },
        {
          "hole": 59,
          "x": -16.8339,
          "y": 60,
          "z": -32.0763
        },
        {
          "hole": 60,
          "x": -8.4949,
          "y": 60,
          "z": -33.7351
        },
        {
          "hole": 61,
          "x": 8.4735,
          "y": 60,
          "z": -33.735
        },
        {
          "hole": 62,
          "x": 16.8126,
          "y": 60,
          "z": -32.0763
        },
        {
          "hole": 63,
          "x": 24.8637,
          "y": 60,
          "z": -29.3433
        },
        {
          "hole": 64,
          "x": 32.4893,
          "y": 60,
          "z": -25.5828
        },
        {
          "hole": 65,
          "x": 39.5588,
          "y": 60,
          "z": -20.8591
        },
        {
          "hole": 66,
          "x": 75.3579,
          "y": 60,
          "z": -27.1235
        },
        {
          "hole": 67,
          "x": 82.2617,
          "y": 60,
          "z": -16.7911
        },
        {
          "hole": 68,
          "x": 87.7579,
          "y": 60,
          "z": -5.6461
        },
        {
          "hole": 69,
          "x": 91.7523,
          "y": 60,
          "z": 6.1211
        },
        {
          "hole": 70,
          "x": 94.1766,
          "y": 60,
          "z": 18.3089
        },
        {
          "hole": 71,
          "x": 65.8128,
          "y": 50,
          "z": 42.4
        },
        {
          "hole": 72,
          "x": 68.2371,
          "y": 50,
          "z": 54.5878
        },
        {
          "hole": 73,
          "x": 72.2315,
          "y": 50,
          "z": 66.3549
        },
        {
          "hole": 74,
          "x": 77.7276,
          "y": 50,
          "z": 77.5
        },
        {
          "hole": 75,
          "x": 84.6314,
          "y": 50,
          "z": 87.8323
        },
        {
          "hole": 76,
          "x": 102.1677,
          "y": 50,
          "z": 105.3686
        },
        {
          "hole": 77,
          "x": 112.5,
          "y": 50,
          "z": 112.2724
        },
        {
          "hole": 78,
          "x": 123.6451,
          "y": 50,
          "z": 117.7685
        },
        {
          "hole": 79,
          "x": 135.4122,
          "y": 50,
          "z": 121.7629
        },
        {
          "hole": 80,
          "x": 147.6,
          "y": 50,
          "z": 124.1872
        },
        {
          "hole": 81,
          "x": 172.4,
          "y": 50,
          "z": 124.1873
        },
        {
          "hole": 82,
          "x": 184.5878,
          "y": 50,
          "z": 121.7629
        },
        {
          "hole": 83,
          "x": 196.355,
          "y": 50,
          "z": 117.7685
        },
        {
          "hole": 84,
          "x": 207.5,
          "y": 50,
          "z": 112.2724
        },
        {
          "hole": 85,
          "x": 217.8324,
          "y": 50,
          "z": 105.3686
        },
        {
          "hole": 86,
          "x": 235.3686,
          "y": 50,
          "z": 87.8323
        },
        {
          "hole": 87,
          "x": 242.2724,
          "y": 50,
          "z": 77.5
        },
        {
          "hole": 88,
          "x": 247.7686,
          "y": 50,
          "z": 66.3549
        },
        {
          "hole": 89,
          "x": 251.763,
          "y": 50,
          "z": 54.5878
        },
        {
          "hole": 90,
          "x": 254.1873,
          "y": 50,
          "z": 42.4
        },
        {
          "hole": 91,
          "x": 254.1872,
          "y": 50,
          "z": 18.3089
        },
        {
          "hole": 92,
          "x": 251.7629,
          "y": 50,
          "z": 6.1211
        },
        {
          "hole": 93,
          "x": 247.7685,
          "y": 50,
          "z": -5.646
        },
        {
          "hole": 94,
          "x": 242.2724,
          "y": 50,
          "z": -16.7911
        },
        {
          "hole": 95,
          "x": 235.3685,
          "y": 50,
          "z": -27.1234
        },
        {
          "hole": 96,
          "x": 217.8323,
          "y": 50,
          "z": -44.6597
        },
        {
          "hole": 97,
          "x": 207.5,
          "y": 50,
          "z": -51.5635
        },
        {
          "hole": 98,
          "x": 196.3549,
          "y": 50,
          "z": -57.0597
        },
        {
          "hole": 99,
          "x": 184.5878,
          "y": 50,
          "z": -61.0541
        },
        {
          "hole": 100,
          "x": 172.4,
          "y": 50,
          "z": -63.4784
        },
        {
          "hole": 101,
          "x": 151.5158,
          "y": 40,
          "z": -65.5561
        },
        {
          "hole": 102,
          "x": 143.1768,
          "y": 40,
          "z": -67.2149
        },
        {
          "hole": 103,
          "x": 135.1256,
          "y": 40,
          "z": -69.9479
        },
        {
          "hole": 104,
          "x": 127.5,
          "y": 40,
          "z": -73.7084
        },
        {
          "hole": 105,
          "x": 120.4305,
          "y": 40,
          "z": -78.4321
        },
        {
          "hole": 106,
          "x": 108.432,
          "y": 40,
          "z": -90.4305
        },
        {
          "hole": 107,
          "x": 103.7083,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 108,
          "x": 99.9478,
          "y": 40,
          "z": -105.1256
        },
        {
          "hole": 109,
          "x": 97.2148,
          "y": 40,
          "z": -113.1768
        },
        {
          "hole": 110,
          "x": 95.5561,
          "y": 40,
          "z": -121.5158
        },
        {
          "hole": 111,
          "x": 93.344,
          "y": 40,
          "z": -142.3999
        },
        {
          "hole": 112,
          "x": 90.9197,
          "y": 40,
          "z": -154.5877
        },
        {
          "hole": 113,
          "x": 86.9253,
          "y": 40,
          "z": -166.3548
        },
        {
          "hole": 114,
          "x": 81.4292,
          "y": 40,
          "z": -177.4999
        },
        {
          "hole": 115,
          "x": 74.5253,
          "y": 40,
          "z": -187.8322
        },
        {
          "hole": 116,
          "x": 61.0541,
          "y": 40,
          "z": -201.9892
        },
        {
          "hole": 117,
          "x": 54.4791,
          "y": 40,
          "z": -207.0344
        },
        {
          "hole": 118,
          "x": 47.4893,
          "y": 40,
          "z": -211.4874
        },
        {
          "hole": 119,
          "x": 40.1381,
          "y": 40,
          "z": -215.3142
        },
        {
          "hole": 120,
          "x": 32.4812,
          "y": 40,
          "z": -218.4858
        },
        {
          "hole": 121,
          "x": 8.2691,
          "y": 30,
          "z": -223.8537
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": -7.419,
          "y": 20,
          "z": -213.8917
        },
        {
          "hole": -1,
          "x": -14.7708,
          "y": 20,
          "z": -212.9239
        },
        {
          "hole": 1,
          "x": -29.0823,
          "y": 30,
          "z": -209.0888
        },
        {
          "hole": 2,
          "x": -35.9332,
          "y": 30,
          "z": -206.2511
        },
        {
          "hole": 3,
          "x": -42.5106,
          "y": 30,
          "z": -202.8271
        },
        {
          "hole": 4,
          "x": -48.7646,
          "y": 30,
          "z": -198.8428
        },
        {
          "hole": 5,
          "x": -54.6476,
          "y": 30,
          "z": -194.3287
        },
        {
          "hole": 6,
          "x": -67.4457,
          "y": 30,
          "z": -181.0358
        },
        {
          "hole": 7,
          "x": -73.6228,
          "y": 30,
          "z": -171.7911
        },
        {
          "hole": 8,
          "x": -78.5404,
          "y": 30,
          "z": -161.8192
        },
        {
          "hole": 9,
          "x": -82.1143,
          "y": 30,
          "z": -151.2907
        },
        {
          "hole": 10,
          "x": -84.2835,
          "y": 30,
          "z": -140.3858
        },
        {
          "hole": 11,
          "x": -86.4741,
          "y": 30,
          "z": -120.2105
        },
        {
          "hole": 12,
          "x": -88.3881,
          "y": 30,
          "z": -110.5885
        },
        {
          "hole": 13,
          "x": -91.5415,
          "y": 30,
          "z": -101.2987
        },
        {
          "hole": 14,
          "x": -95.8806,
          "y": 30,
          "z": -92.5
        },
        {
          "hole": 15,
          "x": -101.331,
          "y": 30,
          "z": -84.3429
        },
        {
          "hole": 16,
          "x": -114.3428,
          "y": 30,
          "z": -70.4985
        },
        {
          "hole": 17,
          "x": -122.5,
          "y": 30,
          "z": -65.0481
        },
        {
          "hole": 18,
          "x": -131.2987,
          "y": 30,
          "z": -60.709
        },
        {
          "hole": 19,
          "x": -140.5885,
          "y": 30,
          "z": -57.5556
        },
        {
          "hole": 20,
          "x": -150.2105,
          "y": 30,
          "z": -55.6416
        },
        {
          "hole": 21,
          "x": -171.4508,
          "y": 40,
          "z": -54.2729
        },
        {
          "hole": 22,
          "x": -182.3557,
          "y": 40,
          "z": -52.1038
        },
        {
          "hole": 23,
          "x": -192.8842,
          "y": 40,
          "z": -48.5298
        },
        {
          "hole": 24,
          "x": -202.8561,
          "y": 40,
          "z": -43.6122
        },
        {
          "hole": 25,
          "x": -212.1008,
          "y": 40,
          "z": -37.4351
        },
        {
          "hole": 26,
          "x": -227.7912,
          "y": 40,
          "z": -21.7447
        },
        {
          "hole": 27,
          "x": -233.9684,
          "y": 40,
          "z": -12.5
        },
        {
          "hole": 28,
          "x": -238.886,
          "y": 40,
          "z": -2.5281
        },
        {
          "hole": 29,
          "x": -242.4599,
          "y": 40,
          "z": 8.0004
        },
        {
          "hole": 30,
          "x": -244.629,
          "y": 40,
          "z": 18.9052
        },
        {
          "hole": 31,
          "x": -244.2728,
          "y": 40,
          "z": 41.0947
        },
        {
          "hole": 32,
          "x": -242.1037,
          "y": 40,
          "z": 51.9996
        },
        {
          "hole": 33,
          "x": -238.5297,
          "y": 40,
          "z": 62.5281
        },
        {
          "hole": 34,
          "x": -233.6121,
          "y": 40,
          "z": 72.5
        },
        {
          "hole": 35,
          "x": -227.435,
          "y": 40,
          "z": 81.7447
        },
        {
          "hole": 36,
          "x": -211.7447,
          "y": 40,
          "z": 97.435
        },
        {
          "hole": 37,
          "x": -202.5,
          "y": 40,
          "z": 103.6121
        },
        {
          "hole": 38,
          "x": -192.5281,
          "y": 40,
          "z": 108.5297
        },
        {
          "hole": 39,
          "x": -181.9996,
          "y": 40,
          "z": 112.1037
        },
        {
          "hole": 40,
          "x": -171.0947,
          "y": 40,
          "z": 114.2728
        },
        {
          "hole": 41,
          "x": -148.9053,
          "y": 40,
          "z": 114.2728
        },
        {
          "hole": 42,
          "x": -138.0004,
          "y": 40,
          "z": 112.1037
        },
        {
          "hole": 43,
          "x": -127.4719,
          "y": 40,
          "z": 108.5297
        },
        {
          "hole": 44,
          "x": -117.5,
          "y": 40,
          "z": 103.6121
        },
        {
          "hole": 45,
          "x": -108.2553,
          "y": 40,
          "z": 97.435
        },
        {
          "hole": 46,
          "x": -92.565,
          "y": 40,
          "z": 81.7447
        },
        {
          "hole": 47,
          "x": -86.3878,
          "y": 40,
          "z": 72.5
        },
        {
          "hole": 48,
          "x": -81.4702,
          "y": 40,
          "z": 62.5281
        },
        {
          "hole": 49,
          "x": -77.8963,
          "y": 40,
          "z": 51.9996
        },
        {
          "hole": 50,
          "x": -75.7272,
          "y": 40,
          "z": 41.0947
        },
        {
          "hole": 51,
          "x": -74.369,
          "y": 50,
          "z": 20.9194
        },
        {
          "hole": 52,
          "x": -72.4551,
          "y": 50,
          "z": 11.2974
        },
        {
          "hole": 53,
          "x": -69.3016,
          "y": 50,
          "z": 2.0076
        },
        {
          "hole": 54,
          "x": -64.9626,
          "y": 50,
          "z": -6.7911
        },
        {
          "hole": 55,
          "x": -59.5122,
          "y": 50,
          "z": -14.9482
        },
        {
          "hole": 56,
          "x": -45.6678,
          "y": 50,
          "z": -28.7926
        },
        {
          "hole": 57,
          "x": -37.5107,
          "y": 50,
          "z": -34.243
        },
        {
          "hole": 58,
          "x": -28.7119,
          "y": 50,
          "z": -38.5821
        },
        {
          "hole": 59,
          "x": -19.4221,
          "y": 50,
          "z": -41.7356
        },
        {
          "hole": 60,
          "x": -9.8001,
          "y": 50,
          "z": -43.6495
        },
        {
          "hole": 61,
          "x": 9.7788,
          "y": 50,
          "z": -43.6495
        },
        {
          "hole": 62,
          "x": 19.4007,
          "y": 50,
          "z": -41.7356
        },
        {
          "hole": 63,
          "x": 28.6906,
          "y": 50,
          "z": -38.5821
        },
        {
          "hole": 64,
          "x": 37.4893,
          "y": 50,
          "z": -34.243
        },
        {
          "hole": 65,
          "x": 45.6464,
          "y": 50,
          "z": -28.7926
        },
        {
          "hole": 66,
          "x": 67.4243,
          "y": 50,
          "z": -21.0359
        },
        {
          "hole": 67,
          "x": 73.6015,
          "y": 50,
          "z": -11.7911
        },
        {
          "hole": 68,
          "x": 78.5191,
          "y": 50,
          "z": -1.8192
        },
        {
          "hole": 69,
          "x": 82.093,
          "y": 50,
          "z": 8.7092
        },
        {
          "hole": 70,
          "x": 84.2621,
          "y": 50,
          "z": 19.6141
        },
        {
          "hole": 71,
          "x": 75.7272,
          "y": 40,
          "z": 41.0947
        },
        {
          "hole": 72,
          "x": 77.8963,
          "y": 40,
          "z": 51.9996
        },
        {
          "hole": 73,
          "x": 81.4703,
          "y": 40,
          "z": 62.5281
        },
        {
          "hole": 74,
          "x": 86.3879,
          "y": 40,
          "z": 72.5
        },
        {
          "hole": 75,
          "x": 92.565,
          "y": 40,
          "z": 81.7447
        },
        {
          "hole": 76,
          "x": 108.2553,
          "y": 40,
          "z": 97.435
        },
        {
          "hole": 77,
          "x": 117.5,
          "y": 40,
          "z": 103.6121
        },
        {
          "hole": 78,
          "x": 127.4719,
          "y": 40,
          "z": 108.5297
        },
        {
          "hole": 79,
          "x": 138.0004,
          "y": 40,
          "z": 112.1037
        },
        {
          "hole": 80,
          "x": 148.9053,
          "y": 40,
          "z": 114.2728
        },
        {
          "hole": 81,
          "x": 171.0948,
          "y": 40,
          "z": 114.2728
        },
        {
          "hole": 82,
          "x": 181.9996,
          "y": 40,
          "z": 112.1037
        },
        {
          "hole": 83,
          "x": 192.5281,
          "y": 40,
          "z": 108.5298
        },
        {
          "hole": 84,
          "x": 202.5,
          "y": 40,
          "z": 103.6122
        },
        {
          "hole": 85,
          "x": 211.7447,
          "y": 40,
          "z": 97.435
        },
        {
          "hole": 86,
          "x": 227.4351,
          "y": 40,
          "z": 81.7447
        },
        {
          "hole": 87,
          "x": 233.6122,
          "y": 40,
          "z": 72.5
        },
        {
          "hole": 88,
          "x": 238.5298,
          "y": 40,
          "z": 62.5281
        },
        {
          "hole": 89,
          "x": 242.1037,
          "y": 40,
          "z": 51.9996
        },
        {
          "hole": 90,
          "x": 244.2728,
          "y": 40,
          "z": 41.0947
        },
        {
          "hole": 91,
          "x": 244.2728,
          "y": 40,
          "z": 19.6142
        },
        {
          "hole": 92,
          "x": 242.1037,
          "y": 40,
          "z": 8.7093
        },
        {
          "hole": 93,
          "x": 238.5297,
          "y": 40,
          "z": -1.8192
        },
        {
          "hole": 94,
          "x": 233.6121,
          "y": 40,
          "z": -11.7911
        },
        {
          "hole": 95,
          "x": 227.435,
          "y": 40,
          "z": -21.0358
        },
        {
          "hole": 96,
          "x": 211.7447,
          "y": 40,
          "z": -36.7261
        },
        {
          "hole": 97,
          "x": 202.5,
          "y": 40,
          "z": -42.9033
        },
        {
          "hole": 98,
          "x": 192.5281,
          "y": 40,
          "z": -47.8209
        },
        {
          "hole": 99,
          "x": 181.9996,
          "y": 40,
          "z": -51.3948
        },
        {
          "hole": 100,
          "x": 171.0947,
          "y": 40,
          "z": -53.5639
        },
        {
          "hole": 101,
          "x": 150.2105,
          "y": 30,
          "z": -55.6417
        },
        {
          "hole": 102,
          "x": 140.5886,
          "y": 30,
          "z": -57.5556
        },
        {
          "hole": 103,
          "x": 131.2987,
          "y": 30,
          "z": -60.7091
        },
        {
          "hole": 104,
          "x": 122.5,
          "y": 30,
          "z": -65.0481
        },
        {
          "hole": 105,
          "x": 114.3429,
          "y": 30,
          "z": -70.4985
        },
        {
          "hole": 106,
          "x": 100.4985,
          "y": 30,
          "z": -84.3429
        },
        {
          "hole": 107,
          "x": 95.0481,
          "y": 30,
          "z": -92.5
        },
        {
          "hole": 108,
          "x": 90.709,
          "y": 30,
          "z": -101.2988
        },
        {
          "hole": 109,
          "x": 87.5556,
          "y": 30,
          "z": -110.5886
        },
        {
          "hole": 110,
          "x": 85.6416,
          "y": 30,
          "z": -120.2106
        },
        {
          "hole": 111,
          "x": 83.4296,
          "y": 30,
          "z": -141.0946
        },
        {
          "hole": 112,
          "x": 81.2605,
          "y": 30,
          "z": -151.9995
        },
        {
          "hole": 113,
          "x": 77.6865,
          "y": 30,
          "z": -162.528
        },
        {
          "hole": 114,
          "x": 72.7689,
          "y": 30,
          "z": -172.4999
        },
        {
          "hole": 115,
          "x": 66.5918,
          "y": 30,
          "z": -181.7446
        },
        {
          "hole": 116,
          "x": 54.6263,
          "y": 30,
          "z": -194.3288
        },
        {
          "hole": 117,
          "x": 48.7433,
          "y": 30,
          "z": -198.8429
        },
        {
          "hole": 118,
          "x": 42.4893,
          "y": 30,
          "z": -202.8272
        },
        {
          "hole": 119,
          "x": 35.9119,
          "y": 30,
          "z": -206.2512
        },
        {
          "hole": 120,
          "x": 29.061,
          "y": 30,
          "z": -209.0889
        },
        {
          "hole": 121,
          "x": 7.3975,
          "y": 20,
          "z": -213.8917
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": -6.5474,
          "y": 20,
          "z": -203.9298
        },
        {
          "hole": -1,
          "x": -13.0344,
          "y": 20,
          "z": -203.0758
        },
        {
          "hole": 1,
          "x": -25.6621,
          "y": 30,
          "z": -199.6918
        },
        {
          "hole": 2,
          "x": -31.707,
          "y": 30,
          "z": -197.188
        },
        {
          "hole": 3,
          "x": -37.5106,
          "y": 30,
          "z": -194.1668
        },
        {
          "hole": 4,
          "x": -43.0288,
          "y": 30,
          "z": -190.6513
        },
        {
          "hole": 5,
          "x": -48.2197,
          "y": 30,
          "z": -186.6682
        },
        {
          "hole": 6,
          "x": -59.5122,
          "y": 30,
          "z": -174.9482
        },
        {
          "hole": 7,
          "x": -64.9626,
          "y": 30,
          "z": -166.7911
        },
        {
          "hole": 8,
          "x": -69.3016,
          "y": 30,
          "z": -157.9924
        },
        {
          "hole": 9,
          "x": -72.4551,
          "y": 30,
          "z": -148.7025
        },
        {
          "hole": 10,
          "x": -74.369,
          "y": 30,
          "z": -139.0806
        },
        {
          "hole": 11,
          "x": -76.5597,
          "y": 30,
          "z": -118.9052
        },
        {
          "hole": 12,
          "x": -78.7288,
          "y": 30,
          "z": -108.0004
        },
        {
          "hole": 13,
          "x": -82.3027,
          "y": 30,
          "z": -97.4719
        },
        {
          "hole": 14,
          "x": -87.2203,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 15,
          "x": -93.3975,
          "y": 30,
          "z": -78.2553
        },
        {
          "hole": 16,
          "x": -108.2552,
          "y": 30,
          "z": -62.565
        },
        {
          "hole": 17,
          "x": -117.5,
          "y": 30,
          "z": -56.3879
        },
        {
          "hole": 18,
          "x": -127.4719,
          "y": 30,
          "z": -51.4703
        },
        {
          "hole": 19,
          "x": -138.0003,
          "y": 30,
          "z": -47.8963
        },
        {
          "hole": 20,
          "x": -148.9052,
          "y": 30,
          "z": -45.7272
        },
        {
          "hole": 21,
          "x": -170.1456,
          "y": 40,
          "z": -44.3584
        },
        {
          "hole": 22,
          "x": -179.7675,
          "y": 40,
          "z": -42.4445
        },
        {
          "hole": 23,
          "x": -189.0574,
          "y": 40,
          "z": -39.291
        },
        {
          "hole": 24,
          "x": -197.8561,
          "y": 40,
          "z": -34.952
        },
        {
          "hole": 25,
          "x": -206.0132,
          "y": 40,
          "z": -29.5016
        },
        {
          "hole": 26,
          "x": -219.8577,
          "y": 40,
          "z": -15.6571
        },
        {
          "hole": 27,
          "x": -225.3081,
          "y": 40,
          "z": -7.5
        },
        {
          "hole": 28,
          "x": -229.6472,
          "y": 40,
          "z": 1.2987
        },
        {
          "hole": 29,
          "x": -232.8006,
          "y": 40,
          "z": 10.5885
        },
        {
          "hole": 30,
          "x": -234.7146,
          "y": 40,
          "z": 20.2105
        },
        {
          "hole": 31,
          "x": -234.3583,
          "y": 40,
          "z": 39.7895
        },
        {
          "hole": 32,
          "x": -232.4444,
          "y": 40,
          "z": 49.4114
        },
        {
          "hole": 33,
          "x": -229.2909,
          "y": 40,
          "z": 58.7013
        },
        {
          "hole": 34,
          "x": -224.9519,
          "y": 40,
          "z": 67.5
        },
        {
          "hole": 35,
          "x": -219.5015,
          "y": 40,
          "z": 75.6571
        },
        {
          "hole": 36,
          "x": -205.6571,
          "y": 40,
          "z": 89.5015
        },
        {
          "hole": 37,
          "x": -197.5,
          "y": 40,
          "z": 94.9519
        },
        {
          "hole": 38,
          "x": -188.7012,
          "y": 40,
          "z": 99.2909
        },
        {
          "hole": 39,
          "x": -179.4114,
          "y": 40,
          "z": 102.4444
        },
        {
          "hole": 40,
          "x": -169.7894,
          "y": 40,
          "z": 104.3583
        },
        {
          "hole": 41,
          "x": -150.2105,
          "y": 40,
          "z": 104.3583
        },
        {
          "hole": 42,
          "x": -140.5886,
          "y": 40,
          "z": 102.4444
        },
        {
          "hole": 43,
          "x": -131.2987,
          "y": 40,
          "z": 99.2909
        },
        {
          "hole": 44,
          "x": -122.5,
          "y": 40,
          "z": 94.9519
        },
        {
          "hole": 45,
          "x": -114.3429,
          "y": 40,
          "z": 89.5015
        },
        {
          "hole": 46,
          "x": -100.4985,
          "y": 40,
          "z": 75.6571
        },
        {
          "hole": 47,
          "x": -95.0481,
          "y": 40,
          "z": 67.5
        },
        {
          "hole": 48,
          "x": -90.709,
          "y": 40,
          "z": 58.7012
        },
        {
          "hole": 49,
          "x": -87.5556,
          "y": 40,
          "z": 49.4114
        },
        {
          "hole": 50,
          "x": -85.6416,
          "y": 40,
          "z": 39.7895
        },
        {
          "hole": 51,
          "x": -84.2835,
          "y": 50,
          "z": 19.6141
        },
        {
          "hole": 52,
          "x": -82.1144,
          "y": 50,
          "z": 8.7092
        },
        {
          "hole": 53,
          "x": -78.5404,
          "y": 50,
          "z": -1.8192
        },
        {
          "hole": 54,
          "x": -73.6228,
          "y": 50,
          "z": -11.7911
        },
        {
          "hole": 55,
          "x": -67.4457,
          "y": 50,
          "z": -21.0359
        },
        {
          "hole": 56,
          "x": -51.7554,
          "y": 50,
          "z": -36.7262
        },
        {
          "hole": 57,
          "x": -42.5107,
          "y": 50,
          "z": -42.9033
        },
        {
          "hole": 58,
          "x": -32.5388,
          "y": 50,
          "z": -47.8209
        },
        {
          "hole": 59,
          "x": -22.0103,
          "y": 50,
          "z": -51.3948
        },
        {
          "hole": 60,
          "x": -11.1054,
          "y": 50,
          "z": -53.564
        },
        {
          "hole": 61,
          "x": 11.084,
          "y": 50,
          "z": -53.5639
        },
        {
          "hole": 62,
          "x": 21.9889,
          "y": 50,
          "z": -51.3948
        },
        {
          "hole": 63,
          "x": 32.5174,
          "y": 50,
          "z": -47.8209
        },
        {
          "hole": 64,
          "x": 42.4893,
          "y": 50,
          "z": -42.9033
        },
        {
          "hole": 65,
          "x": 51.734,
          "y": 50,
          "z": -36.7262
        },
        {
          "hole": 66,
          "x": 59.4908,
          "y": 50,
          "z": -14.9482
        },
        {
          "hole": 67,
          "x": 64.9412,
          "y": 50,
          "z": -6.7911
        },
        {
          "hole": 68,
          "x": 69.2803,
          "y": 50,
          "z": 2.0076
        },
        {
          "hole": 69,
          "x": 72.4337,
          "y": 50,
          "z": 11.2974
        },
        {
          "hole": 70,
          "x": 74.3477,
          "y": 50,
          "z": 20.9194
        },
        {
          "hole": 71,
          "x": 85.6416,
          "y": 40,
          "z": 39.7894
        },
        {
          "hole": 72,
          "x": 87.5556,
          "y": 40,
          "z": 49.4114
        },
        {
          "hole": 73,
          "x": 90.709,
          "y": 40,
          "z": 58.7012
        },
        {
          "hole": 74,
          "x": 95.0481,
          "y": 40,
          "z": 67.5
        },
        {
          "hole": 75,
          "x": 100.4985,
          "y": 40,
          "z": 75.6571
        },
        {
          "hole": 76,
          "x": 114.3429,
          "y": 40,
          "z": 89.5015
        },
        {
          "hole": 77,
          "x": 122.5,
          "y": 40,
          "z": 94.9519
        },
        {
          "hole": 78,
          "x": 131.2987,
          "y": 40,
          "z": 99.2909
        },
        {
          "hole": 79,
          "x": 140.5886,
          "y": 40,
          "z": 102.4444
        },
        {
          "hole": 80,
          "x": 150.2105,
          "y": 40,
          "z": 104.3583
        },
        {
          "hole": 81,
          "x": 169.7895,
          "y": 40,
          "z": 104.3584
        },
        {
          "hole": 82,
          "x": 179.4115,
          "y": 40,
          "z": 102.4444
        },
        {
          "hole": 83,
          "x": 188.7013,
          "y": 40,
          "z": 99.291
        },
        {
          "hole": 84,
          "x": 197.5,
          "y": 40,
          "z": 94.9519
        },
        {
          "hole": 85,
          "x": 205.6571,
          "y": 40,
          "z": 89.5015
        },
        {
          "hole": 86,
          "x": 219.5015,
          "y": 40,
          "z": 75.6571
        },
        {
          "hole": 87,
          "x": 224.9519,
          "y": 40,
          "z": 67.5
        },
        {
          "hole": 88,
          "x": 229.291,
          "y": 40,
          "z": 58.7012
        },
        {
          "hole": 89,
          "x": 232.4445,
          "y": 40,
          "z": 49.4114
        },
        {
          "hole": 90,
          "x": 234.3584,
          "y": 40,
          "z": 39.7894
        },
        {
          "hole": 91,
          "x": 234.3583,
          "y": 40,
          "z": 20.9194
        },
        {
          "hole": 92,
          "x": 232.4444,
          "y": 40,
          "z": 11.2975
        },
        {
          "hole": 93,
          "x": 229.2909,
          "y": 40,
          "z": 2.0077
        },
        {
          "hole": 94,
          "x": 224.9519,
          "y": 40,
          "z": -6.7911
        },
        {
          "hole": 95,
          "x": 219.5015,
          "y": 40,
          "z": -14.9482
        },
        {
          "hole": 96,
          "x": 205.6571,
          "y": 40,
          "z": -28.7926
        },
        {
          "hole": 97,
          "x": 197.5,
          "y": 40,
          "z": -34.243
        },
        {
          "hole": 98,
          "x": 188.7013,
          "y": 40,
          "z": -38.5821
        },
        {
          "hole": 99,
          "x": 179.4114,
          "y": 40,
          "z": -41.7355
        },
        {
          "hole": 100,
          "x": 169.7895,
          "y": 40,
          "z": -43.6495
        },
        {
          "hole": 101,
          "x": 148.9053,
          "y": 30,
          "z": -45.7272
        },
        {
          "hole": 102,
          "x": 138.0004,
          "y": 30,
          "z": -47.8964
        },
        {
          "hole": 103,
          "x": 127.4719,
          "y": 30,
          "z": -51.4703
        },
        {
          "hole": 104,
          "x": 117.5,
          "y": 30,
          "z": -56.3879
        },
        {
          "hole": 105,
          "x": 108.2553,
          "y": 30,
          "z": -62.565
        },
        {
          "hole": 106,
          "x": 92.565,
          "y": 30,
          "z": -78.2553
        },
        {
          "hole": 107,
          "x": 86.3878,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 108,
          "x": 81.4702,
          "y": 30,
          "z": -97.4719
        },
        {
          "hole": 109,
          "x": 77.8963,
          "y": 30,
          "z": -108.0004
        },
        {
          "hole": 110,
          "x": 75.7272,
          "y": 30,
          "z": -118.9053
        },
        {
          "hole": 111,
          "x": 73.5151,
          "y": 30,
          "z": -139.7894
        },
        {
          "hole": 112,
          "x": 71.6012,
          "y": 30,
          "z": -149.4113
        },
        {
          "hole": 113,
          "x": 68.4477,
          "y": 30,
          "z": -158.7012
        },
        {
          "hole": 114,
          "x": 64.1087,
          "y": 30,
          "z": -167.4999
        },
        {
          "hole": 115,
          "x": 58.6583,
          "y": 30,
          "z": -175.657
        },
        {
          "hole": 116,
          "x": 48.1984,
          "y": 30,
          "z": -186.6683
        },
        {
          "hole": 117,
          "x": 43.0076,
          "y": 30,
          "z": -190.6514
        },
        {
          "hole": 118,
          "x": 37.4893,
          "y": 30,
          "z": -194.1669
        },
        {
          "hole": 119,
          "x": 31.6857,
          "y": 30,
          "z": -197.1881
        },
        {
          "hole": 120,
          "x": 25.6408,
          "y": 30,
          "z": -199.6919
        },
        {
          "hole": 121,
          "x": 6.5259,
          "y": 20,
          "z": -203.9298
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": -5.6759,
          "y": 30,
          "z": -193.9679
        },
        {
          "hole": -1,
          "x": -11.2979,
          "y": 30,
          "z": -193.2277
        },
        {
          "hole": 1,
          "x": -22.2419,
          "y": 40,
          "z": -190.2949
        },
        {
          "hole": 2,
          "x": -27.4808,
          "y": 40,
          "z": -188.1249
        },
        {
          "hole": 3,
          "x": -32.5106,
          "y": 40,
          "z": -185.5066
        },
        {
          "hole": 4,
          "x": -37.2931,
          "y": 40,
          "z": -182.4598
        },
        {
          "hole": 5,
          "x": -41.7918,
          "y": 40,
          "z": -179.0078
        },
        {
          "hole": 6,
          "x": -51.5786,
          "y": 40,
          "z": -168.8606
        },
        {
          "hole": 7,
          "x": -56.3023,
          "y": 40,
          "z": -161.7911
        },
        {
          "hole": 8,
          "x": -60.0628,
          "y": 40,
          "z": -154.1655
        },
        {
          "hole": 9,
          "x": -62.7958,
          "y": 40,
          "z": -146.1143
        },
        {
          "hole": 10,
          "x": -64.4546,
          "y": 40,
          "z": -137.7753
        },
        {
          "hole": 11,
          "x": -66.6452,
          "y": 40,
          "z": -117.6
        },
        {
          "hole": 12,
          "x": -69.0695,
          "y": 40,
          "z": -105.4122
        },
        {
          "hole": 13,
          "x": -73.0639,
          "y": 40,
          "z": -93.645
        },
        {
          "hole": 14,
          "x": -78.5601,
          "y": 40,
          "z": -82.5
        },
        {
          "hole": 15,
          "x": -85.4639,
          "y": 40,
          "z": -72.1676
        },
        {
          "hole": 16,
          "x": -102.1676,
          "y": 40,
          "z": -54.6314
        },
        {
          "hole": 17,
          "x": -112.5,
          "y": 40,
          "z": -47.7276
        },
        {
          "hole": 18,
          "x": -123.645,
          "y": 40,
          "z": -42.2315
        },
        {
          "hole": 19,
          "x": -135.4121,
          "y": 40,
          "z": -38.2371
        },
        {
          "hole": 20,
          "x": -147.6,
          "y": 40,
          "z": -35.8128
        },
        {
          "hole": 21,
          "x": -168.8403,
          "y": 50,
          "z": -34.444
        },
        {
          "hole": 22,
          "x": -177.1793,
          "y": 50,
          "z": -32.7853
        },
        {
          "hole": 23,
          "x": -185.2305,
          "y": 50,
          "z": -30.0523
        },
        {
          "hole": 24,
          "x": -192.8561,
          "y": 50,
          "z": -26.2917
        },
        {
          "hole": 25,
          "x": -199.9256,
          "y": 50,
          "z": -21.5681
        },
        {
          "hole": 26,
          "x": -211.9242,
          "y": 50,
          "z": -9.5695
        },
        {
          "hole": 27,
          "x": -216.6479,
          "y": 50,
          "z": -2.5
        },
        {
          "hole": 28,
          "x": -220.4084,
          "y": 50,
          "z": 5.1256
        },
        {
          "hole": 29,
          "x": -223.1414,
          "y": 50,
          "z": 13.1767
        },
        {
          "hole": 30,
          "x": -224.8001,
          "y": 50,
          "z": 21.5158
        },
        {
          "hole": 31,
          "x": -224.4439,
          "y": 50,
          "z": 38.4842
        },
        {
          "hole": 32,
          "x": -222.7851,
          "y": 50,
          "z": 46.8233
        },
        {
          "hole": 33,
          "x": -220.0521,
          "y": 50,
          "z": 54.8744
        },
        {
          "hole": 34,
          "x": -216.2916,
          "y": 50,
          "z": 62.5
        },
        {
          "hole": 35,
          "x": -211.5679,
          "y": 50,
          "z": 69.5695
        },
        {
          "hole": 36,
          "x": -199.5695,
          "y": 50,
          "z": 81.5679
        },
        {
          "hole": 37,
          "x": -192.5,
          "y": 50,
          "z": 86.2916
        },
        {
          "hole": 38,
          "x": -184.8744,
          "y": 50,
          "z": 90.0521
        },
        {
          "hole": 39,
          "x": -176.8232,
          "y": 50,
          "z": 92.7852
        },
        {
          "hole": 40,
          "x": -168.4842,
          "y": 50,
          "z": 94.4439
        },
        {
          "hole": 41,
          "x": -151.5158,
          "y": 50,
          "z": 94.4439
        },
        {
          "hole": 42,
          "x": -143.1768,
          "y": 50,
          "z": 92.7851
        },
        {
          "hole": 43,
          "x": -135.1256,
          "y": 50,
          "z": 90.0521
        },
        {
          "hole": 44,
          "x": -127.5,
          "y": 50,
          "z": 86.2916
        },
        {
          "hole": 45,
          "x": -120.4305,
          "y": 50,
          "z": 81.5679
        },
        {
          "hole": 46,
          "x": -108.432,
          "y": 50,
          "z": 69.5695
        },
        {
          "hole": 47,
          "x": -103.7084,
          "y": 50,
          "z": 62.5
        },
        {
          "hole": 48,
          "x": -99.9478,
          "y": 50,
          "z": 54.8744
        },
        {
          "hole": 49,
          "x": -97.2148,
          "y": 50,
          "z": 46.8232
        },
        {
          "hole": 50,
          "x": -95.5561,
          "y": 50,
          "z": 38.4842
        },
        {
          "hole": 51,
          "x": -94.1979,
          "y": 60,
          "z": 18.3089
        },
        {
          "hole": 52,
          "x": -91.7736,
          "y": 60,
          "z": 6.1211
        },
        {
          "hole": 53,
          "x": -87.7792,
          "y": 60,
          "z": -5.6461
        },
        {
          "hole": 54,
          "x": -82.2831,
          "y": 60,
          "z": -16.7911
        },
        {
          "hole": 55,
          "x": -75.3792,
          "y": 60,
          "z": -27.1235
        },
        {
          "hole": 56,
          "x": -57.843,
          "y": 60,
          "z": -44.6597
        },
        {
          "hole": 57,
          "x": -47.5107,
          "y": 60,
          "z": -51.5636
        },
        {
          "hole": 58,
          "x": -36.3656,
          "y": 60,
          "z": -57.0597
        },
        {
          "hole": 59,
          "x": -24.5985,
          "y": 60,
          "z": -61.0541
        },
        {
          "hole": 60,
          "x": -12.4107,
          "y": 60,
          "z": -63.4784
        },
        {
          "hole": 61,
          "x": 12.3893,
          "y": 60,
          "z": -63.4784
        },
        {
          "hole": 62,
          "x": 24.5771,
          "y": 60,
          "z": -61.0541
        },
        {
          "hole": 63,
          "x": 36.3442,
          "y": 60,
          "z": -57.0597
        },
        {
          "hole": 64,
          "x": 47.4893,
          "y": 60,
          "z": -51.5635
        },
        {
          "hole": 65,
          "x": 57.8216,
          "y": 60,
          "z": -44.6597
        },
        {
          "hole": 66,
          "x": 51.5573,
          "y": 60,
          "z": -8.8606
        },
        {
          "hole": 67,
          "x": 56.281,
          "y": 60,
          "z": -1.7911
        },
        {
          "hole": 68,
          "x": 60.0415,
          "y": 60,
          "z": 5.8344
        },
        {
          "hole": 69,
          "x": 62.7745,
          "y": 60,
          "z": 13.8856
        },
        {
          "hole": 70,
          "x": 64.4332,
          "y": 60,
          "z": 22.2247
        },
        {
          "hole": 71,
          "x": 95.5561,
          "y": 50,
          "z": 38.4842
        },
        {
          "hole": 72,
          "x": 97.2148,
          "y": 50,
          "z": 46.8232
        },
        {
          "hole": 73,
          "x": 99.9478,
          "y": 50,
          "z": 54.8744
        },
        {
          "hole": 74,
          "x": 103.7084,
          "y": 50,
          "z": 62.5
        },
        {
          "hole": 75,
          "x": 108.432,
          "y": 50,
          "z": 69.5695
        },
        {
          "hole": 76,
          "x": 120.4305,
          "y": 50,
          "z": 81.568
        },
        {
          "hole": 77,
          "x": 127.5,
          "y": 50,
          "z": 86.2916
        },
        {
          "hole": 78,
          "x": 135.1256,
          "y": 50,
          "z": 90.0522
        },
        {
          "hole": 79,
          "x": 143.1768,
          "y": 50,
          "z": 92.7852
        },
        {
          "hole": 80,
          "x": 151.5158,
          "y": 50,
          "z": 94.4439
        },
        {
          "hole": 81,
          "x": 168.4842,
          "y": 50,
          "z": 94.4439
        },
        {
          "hole": 82,
          "x": 176.8233,
          "y": 50,
          "z": 92.7852
        },
        {
          "hole": 83,
          "x": 184.8745,
          "y": 50,
          "z": 90.0522
        },
        {
          "hole": 84,
          "x": 192.5,
          "y": 50,
          "z": 86.2916
        },
        {
          "hole": 85,
          "x": 199.5695,
          "y": 50,
          "z": 81.568
        },
        {
          "hole": 86,
          "x": 211.568,
          "y": 50,
          "z": 69.5695
        },
        {
          "hole": 87,
          "x": 216.2917,
          "y": 50,
          "z": 62.5
        },
        {
          "hole": 88,
          "x": 220.0522,
          "y": 50,
          "z": 54.8744
        },
        {
          "hole": 89,
          "x": 222.7852,
          "y": 50,
          "z": 46.8232
        },
        {
          "hole": 90,
          "x": 224.4439,
          "y": 50,
          "z": 38.4842
        },
        {
          "hole": 91,
          "x": 224.4439,
          "y": 50,
          "z": 22.2247
        },
        {
          "hole": 92,
          "x": 222.7852,
          "y": 50,
          "z": 13.8857
        },
        {
          "hole": 93,
          "x": 220.0521,
          "y": 50,
          "z": 5.8345
        },
        {
          "hole": 94,
          "x": 216.2916,
          "y": 50,
          "z": -1.7911
        },
        {
          "hole": 95,
          "x": 211.5679,
          "y": 50,
          "z": -8.8606
        },
        {
          "hole": 96,
          "x": 199.5695,
          "y": 50,
          "z": -20.8591
        },
        {
          "hole": 97,
          "x": 192.5,
          "y": 50,
          "z": -25.5828
        },
        {
          "hole": 98,
          "x": 184.8744,
          "y": 50,
          "z": -29.3433
        },
        {
          "hole": 99,
          "x": 176.8232,
          "y": 50,
          "z": -32.0763
        },
        {
          "hole": 100,
          "x": 168.4842,
          "y": 50,
          "z": -33.735
        },
        {
          "hole": 101,
          "x": 147.6,
          "y": 40,
          "z": -35.8128
        },
        {
          "hole": 102,
          "x": 135.4122,
          "y": 40,
          "z": -38.2371
        },
        {
          "hole": 103,
          "x": 123.6451,
          "y": 40,
          "z": -42.2315
        },
        {
          "hole": 104,
          "x": 112.5,
          "y": 40,
          "z": -47.7276
        },
        {
          "hole": 105,
          "x": 102.1677,
          "y": 40,
          "z": -54.6315
        },
        {
          "hole": 106,
          "x": 84.6314,
          "y": 40,
          "z": -72.1677
        },
        {
          "hole": 107,
          "x": 77.7276,
          "y": 40,
          "z": -82.5
        },
        {
          "hole": 108,
          "x": 72.2314,
          "y": 40,
          "z": -93.6451
        },
        {
          "hole": 109,
          "x": 68.237,
          "y": 40,
          "z": -105.4122
        },
        {
          "hole": 110,
          "x": 65.8127,
          "y": 40,
          "z": -117.6
        },
        {
          "hole": 111,
          "x": 63.6007,
          "y": 40,
          "z": -138.4841
        },
        {
          "hole": 112,
          "x": 61.942,
          "y": 40,
          "z": -146.8232
        },
        {
          "hole": 113,
          "x": 59.209,
          "y": 40,
          "z": -154.8743
        },
        {
          "hole": 114,
          "x": 55.4484,
          "y": 40,
          "z": -162.4999
        },
        {
          "hole": 115,
          "x": 50.7248,
          "y": 40,
          "z": -169.5694
        },
        {
          "hole": 116,
          "x": 41.7705,
          "y": 40,
          "z": -179.0079
        },
        {
          "hole": 117,
          "x": 37.2718,
          "y": 40,
          "z": -182.4599
        },
        {
          "hole": 118,
          "x": 32.4893,
          "y": 40,
          "z": -185.5067
        },
        {
          "hole": 119,
          "x": 27.4595,
          "y": 40,
          "z": -188.125
        },
        {
          "hole": 120,
          "x": 22.2206,
          "y": 40,
          "z": -190.295
        },
        {
          "hole": 121,
          "x": 5.6544,
          "y": 30,
          "z": -193.9679
        }
      ]
    }
  },
  {
    "id": "board-baseball-stadium",
    "name": "Baseball Stadium",
    "brand": "crazy,pints,adult",
    "desc": "Baseball Stadium Cribbage 3D cribbage board (6.2 MB)",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/crazy-baseball-stadium-thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/97bec5b478d23010/crazy-baseball-stadium.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": -190.6568,
          "y": 50,
          "z": 169.4436
        },
        {
          "hole": 1,
          "x": -125,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 2,
          "x": -125,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 3,
          "x": -125,
          "y": 40,
          "z": 100
        },
        {
          "hole": 4,
          "x": -125,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 5,
          "x": -125,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 6,
          "x": -125,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 7,
          "x": -125,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 8,
          "x": -125,
          "y": 40,
          "z": 60
        },
        {
          "hole": 9,
          "x": -125,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 10,
          "x": -125,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 11,
          "x": -125,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 12,
          "x": -125,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 13,
          "x": -125,
          "y": 40,
          "z": 20
        },
        {
          "hole": 14,
          "x": -125,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 15,
          "x": -125,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 16,
          "x": -125,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 17,
          "x": -125,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 18,
          "x": -125,
          "y": 40,
          "z": -20
        },
        {
          "hole": 19,
          "x": -125,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 20,
          "x": -125,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 21,
          "x": -125,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 22,
          "x": -125,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 23,
          "x": -125,
          "y": 40,
          "z": -60
        },
        {
          "hole": 24,
          "x": -125,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 25,
          "x": -125,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 26,
          "x": -125,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 27,
          "x": -125,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 28,
          "x": -125,
          "y": 40,
          "z": -100
        },
        {
          "hole": 29,
          "x": -125,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 30,
          "x": -125,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 31,
          "x": -115.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 32,
          "x": -107.75,
          "y": 40,
          "z": -155
        },
        {
          "hole": 33,
          "x": -100,
          "y": 40,
          "z": -155
        },
        {
          "hole": 34,
          "x": -92.25,
          "y": 40,
          "z": -155
        },
        {
          "hole": 35,
          "x": -84.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 36,
          "x": -75.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 37,
          "x": -67.75,
          "y": 40,
          "z": -155
        },
        {
          "hole": 38,
          "x": -60,
          "y": 40,
          "z": -155
        },
        {
          "hole": 39,
          "x": -52.25,
          "y": 40,
          "z": -155
        },
        {
          "hole": 40,
          "x": -44.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 41,
          "x": -35.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 42,
          "x": -27.75,
          "y": 40,
          "z": -155
        },
        {
          "hole": 43,
          "x": -20,
          "y": 40,
          "z": -155
        },
        {
          "hole": 44,
          "x": -12.25,
          "y": 40,
          "z": -155
        },
        {
          "hole": 45,
          "x": -4.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 46,
          "x": 4.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 47,
          "x": 12.25,
          "y": 40,
          "z": -155
        },
        {
          "hole": 48,
          "x": 20,
          "y": 40,
          "z": -155
        },
        {
          "hole": 49,
          "x": 27.75,
          "y": 40,
          "z": -155
        },
        {
          "hole": 50,
          "x": 35.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 51,
          "x": 44.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 52,
          "x": 52.25,
          "y": 40,
          "z": -155
        },
        {
          "hole": 53,
          "x": 60,
          "y": 40,
          "z": -155
        },
        {
          "hole": 54,
          "x": 67.75,
          "y": 40,
          "z": -155
        },
        {
          "hole": 55,
          "x": 75.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 56,
          "x": 84.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 57,
          "x": 92.25,
          "y": 40,
          "z": -155
        },
        {
          "hole": 58,
          "x": 100,
          "y": 40,
          "z": -155
        },
        {
          "hole": 59,
          "x": 107.75,
          "y": 40,
          "z": -155
        },
        {
          "hole": 60,
          "x": 115.5,
          "y": 40,
          "z": -155
        },
        {
          "hole": 61,
          "x": 155,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 62,
          "x": 155,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 63,
          "x": 155,
          "y": 40,
          "z": -100
        },
        {
          "hole": 64,
          "x": 155,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 65,
          "x": 155,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 66,
          "x": 155,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 67,
          "x": 155,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 68,
          "x": 155,
          "y": 40,
          "z": -60
        },
        {
          "hole": 69,
          "x": 155,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 70,
          "x": 155,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 71,
          "x": 155,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 72,
          "x": 155,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 73,
          "x": 155,
          "y": 40,
          "z": -20
        },
        {
          "hole": 74,
          "x": 155,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 75,
          "x": 155,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 76,
          "x": 155,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 77,
          "x": 155,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 78,
          "x": 155,
          "y": 40,
          "z": 20
        },
        {
          "hole": 79,
          "x": 155,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 80,
          "x": 155,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 81,
          "x": 155,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 82,
          "x": 155,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 83,
          "x": 155,
          "y": 40,
          "z": 60
        },
        {
          "hole": 84,
          "x": 155,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 85,
          "x": 155,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 86,
          "x": 155,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 87,
          "x": 155,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 88,
          "x": 155,
          "y": 40,
          "z": 100
        },
        {
          "hole": 89,
          "x": 155,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 90,
          "x": 155,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 91,
          "x": 115.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 92,
          "x": 107.75,
          "y": 40,
          "z": 125
        },
        {
          "hole": 93,
          "x": 100,
          "y": 40,
          "z": 125
        },
        {
          "hole": 94,
          "x": 92.25,
          "y": 40,
          "z": 125
        },
        {
          "hole": 95,
          "x": 84.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 96,
          "x": 75.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 97,
          "x": 67.75,
          "y": 40,
          "z": 125
        },
        {
          "hole": 98,
          "x": 60,
          "y": 40,
          "z": 125
        },
        {
          "hole": 99,
          "x": 52.25,
          "y": 40,
          "z": 125
        },
        {
          "hole": 100,
          "x": 44.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 101,
          "x": 35.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 102,
          "x": 27.75,
          "y": 40,
          "z": 125
        },
        {
          "hole": 103,
          "x": 20,
          "y": 40,
          "z": 125
        },
        {
          "hole": 104,
          "x": 12.25,
          "y": 40,
          "z": 125
        },
        {
          "hole": 105,
          "x": 4.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 106,
          "x": -4.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 107,
          "x": -12.25,
          "y": 40,
          "z": 125
        },
        {
          "hole": 108,
          "x": -20,
          "y": 40,
          "z": 125
        },
        {
          "hole": 109,
          "x": -27.75,
          "y": 40,
          "z": 125
        },
        {
          "hole": 110,
          "x": -35.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 111,
          "x": -44.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 112,
          "x": -52.25,
          "y": 40,
          "z": 125
        },
        {
          "hole": 113,
          "x": -60,
          "y": 40,
          "z": 125
        },
        {
          "hole": 114,
          "x": -67.75,
          "y": 40,
          "z": 125
        },
        {
          "hole": 115,
          "x": -75.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 116,
          "x": -84.5,
          "y": 40,
          "z": 125
        },
        {
          "hole": 117,
          "x": -92.25,
          "y": 40,
          "z": 125
        },
        {
          "hole": 118,
          "x": -100,
          "y": 40,
          "z": 125
        },
        {
          "hole": 119,
          "x": -107.75,
          "y": 40,
          "z": 125
        },
        {
          "hole": 120,
          "x": -115.5,
          "y": 40,
          "z": 125
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": -183.5858,
          "y": 50,
          "z": 176.5147
        },
        {
          "hole": 1,
          "x": -135,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 2,
          "x": -135,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 3,
          "x": -135,
          "y": 40,
          "z": 100
        },
        {
          "hole": 4,
          "x": -135,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 5,
          "x": -135,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 6,
          "x": -135,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 7,
          "x": -135,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 8,
          "x": -135,
          "y": 40,
          "z": 60
        },
        {
          "hole": 9,
          "x": -135,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 10,
          "x": -135,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 11,
          "x": -135,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 12,
          "x": -135,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 13,
          "x": -135,
          "y": 40,
          "z": 20
        },
        {
          "hole": 14,
          "x": -135,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 15,
          "x": -135,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 16,
          "x": -135,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 17,
          "x": -135,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 18,
          "x": -135,
          "y": 40,
          "z": -20
        },
        {
          "hole": 19,
          "x": -135,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 20,
          "x": -135,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 21,
          "x": -135,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 22,
          "x": -135,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 23,
          "x": -135,
          "y": 40,
          "z": -60
        },
        {
          "hole": 24,
          "x": -135,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 25,
          "x": -135,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 26,
          "x": -135,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 27,
          "x": -135,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 28,
          "x": -135,
          "y": 40,
          "z": -100
        },
        {
          "hole": 29,
          "x": -135,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 30,
          "x": -135,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 31,
          "x": -115.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 32,
          "x": -107.75,
          "y": 40,
          "z": -145
        },
        {
          "hole": 33,
          "x": -100,
          "y": 40,
          "z": -145
        },
        {
          "hole": 34,
          "x": -92.25,
          "y": 40,
          "z": -145
        },
        {
          "hole": 35,
          "x": -84.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 36,
          "x": -75.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 37,
          "x": -67.75,
          "y": 40,
          "z": -145
        },
        {
          "hole": 38,
          "x": -60,
          "y": 40,
          "z": -145
        },
        {
          "hole": 39,
          "x": -52.25,
          "y": 40,
          "z": -145
        },
        {
          "hole": 40,
          "x": -44.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 41,
          "x": -35.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 42,
          "x": -27.75,
          "y": 40,
          "z": -145
        },
        {
          "hole": 43,
          "x": -20,
          "y": 40,
          "z": -145
        },
        {
          "hole": 44,
          "x": -12.25,
          "y": 40,
          "z": -145
        },
        {
          "hole": 45,
          "x": -4.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 46,
          "x": 4.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 47,
          "x": 12.25,
          "y": 40,
          "z": -145
        },
        {
          "hole": 48,
          "x": 20,
          "y": 40,
          "z": -145
        },
        {
          "hole": 49,
          "x": 27.75,
          "y": 40,
          "z": -145
        },
        {
          "hole": 50,
          "x": 35.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 51,
          "x": 44.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 52,
          "x": 52.25,
          "y": 40,
          "z": -145
        },
        {
          "hole": 53,
          "x": 60,
          "y": 40,
          "z": -145
        },
        {
          "hole": 54,
          "x": 67.75,
          "y": 40,
          "z": -145
        },
        {
          "hole": 55,
          "x": 75.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 56,
          "x": 84.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 57,
          "x": 92.25,
          "y": 40,
          "z": -145
        },
        {
          "hole": 58,
          "x": 100,
          "y": 40,
          "z": -145
        },
        {
          "hole": 59,
          "x": 107.75,
          "y": 40,
          "z": -145
        },
        {
          "hole": 60,
          "x": 115.5,
          "y": 40,
          "z": -145
        },
        {
          "hole": 61,
          "x": 145,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 62,
          "x": 145,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 63,
          "x": 145,
          "y": 40,
          "z": -100
        },
        {
          "hole": 64,
          "x": 145,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 65,
          "x": 145,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 66,
          "x": 145,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 67,
          "x": 145,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 68,
          "x": 145,
          "y": 40,
          "z": -60
        },
        {
          "hole": 69,
          "x": 145,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 70,
          "x": 145,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 71,
          "x": 145,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 72,
          "x": 145,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 73,
          "x": 145,
          "y": 40,
          "z": -20
        },
        {
          "hole": 74,
          "x": 145,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 75,
          "x": 145,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 76,
          "x": 145,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 77,
          "x": 145,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 78,
          "x": 145,
          "y": 40,
          "z": 20
        },
        {
          "hole": 79,
          "x": 145,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 80,
          "x": 145,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 81,
          "x": 145,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 82,
          "x": 145,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 83,
          "x": 145,
          "y": 40,
          "z": 60
        },
        {
          "hole": 84,
          "x": 145,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 85,
          "x": 145,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 86,
          "x": 145,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 87,
          "x": 145,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 88,
          "x": 145,
          "y": 40,
          "z": 100
        },
        {
          "hole": 89,
          "x": 145,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 90,
          "x": 145,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 91,
          "x": 115.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 92,
          "x": 107.75,
          "y": 40,
          "z": 135
        },
        {
          "hole": 93,
          "x": 100,
          "y": 40,
          "z": 135
        },
        {
          "hole": 94,
          "x": 92.25,
          "y": 40,
          "z": 135
        },
        {
          "hole": 95,
          "x": 84.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 96,
          "x": 75.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 97,
          "x": 67.75,
          "y": 40,
          "z": 135
        },
        {
          "hole": 98,
          "x": 60,
          "y": 40,
          "z": 135
        },
        {
          "hole": 99,
          "x": 52.25,
          "y": 40,
          "z": 135
        },
        {
          "hole": 100,
          "x": 44.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 101,
          "x": 35.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 102,
          "x": 27.75,
          "y": 40,
          "z": 135
        },
        {
          "hole": 103,
          "x": 20,
          "y": 40,
          "z": 135
        },
        {
          "hole": 104,
          "x": 12.25,
          "y": 40,
          "z": 135
        },
        {
          "hole": 105,
          "x": 4.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 106,
          "x": -4.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 107,
          "x": -12.25,
          "y": 40,
          "z": 135
        },
        {
          "hole": 108,
          "x": -20,
          "y": 40,
          "z": 135
        },
        {
          "hole": 109,
          "x": -27.75,
          "y": 40,
          "z": 135
        },
        {
          "hole": 110,
          "x": -35.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 111,
          "x": -44.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 112,
          "x": -52.25,
          "y": 40,
          "z": 135
        },
        {
          "hole": 113,
          "x": -60,
          "y": 40,
          "z": 135
        },
        {
          "hole": 114,
          "x": -67.75,
          "y": 40,
          "z": 135
        },
        {
          "hole": 115,
          "x": -75.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 116,
          "x": -84.5,
          "y": 40,
          "z": 135
        },
        {
          "hole": 117,
          "x": -92.25,
          "y": 40,
          "z": 135
        },
        {
          "hole": 118,
          "x": -100,
          "y": 40,
          "z": 135
        },
        {
          "hole": 119,
          "x": -107.75,
          "y": 40,
          "z": 135
        },
        {
          "hole": 120,
          "x": -115.5,
          "y": 40,
          "z": 135
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": -176.5147,
          "y": 50,
          "z": 183.5858
        },
        {
          "hole": 1,
          "x": -145,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 2,
          "x": -145,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 3,
          "x": -145,
          "y": 40,
          "z": 100
        },
        {
          "hole": 4,
          "x": -145,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 5,
          "x": -145,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 6,
          "x": -145,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 7,
          "x": -145,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 8,
          "x": -145,
          "y": 40,
          "z": 60
        },
        {
          "hole": 9,
          "x": -145,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 10,
          "x": -145,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 11,
          "x": -145,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 12,
          "x": -145,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 13,
          "x": -145,
          "y": 40,
          "z": 20
        },
        {
          "hole": 14,
          "x": -145,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 15,
          "x": -145,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 16,
          "x": -145,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 17,
          "x": -145,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 18,
          "x": -145,
          "y": 40,
          "z": -20
        },
        {
          "hole": 19,
          "x": -145,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 20,
          "x": -145,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 21,
          "x": -145,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 22,
          "x": -145,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 23,
          "x": -145,
          "y": 40,
          "z": -60
        },
        {
          "hole": 24,
          "x": -145,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 25,
          "x": -145,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 26,
          "x": -145,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 27,
          "x": -145,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 28,
          "x": -145,
          "y": 40,
          "z": -100
        },
        {
          "hole": 29,
          "x": -145,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 30,
          "x": -145,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 31,
          "x": -115.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 32,
          "x": -107.75,
          "y": 40,
          "z": -135
        },
        {
          "hole": 33,
          "x": -100,
          "y": 40,
          "z": -135
        },
        {
          "hole": 34,
          "x": -92.25,
          "y": 40,
          "z": -135
        },
        {
          "hole": 35,
          "x": -84.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 36,
          "x": -75.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 37,
          "x": -67.75,
          "y": 40,
          "z": -135
        },
        {
          "hole": 38,
          "x": -60,
          "y": 40,
          "z": -135
        },
        {
          "hole": 39,
          "x": -52.25,
          "y": 40,
          "z": -135
        },
        {
          "hole": 40,
          "x": -44.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 41,
          "x": -35.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 42,
          "x": -27.75,
          "y": 40,
          "z": -135
        },
        {
          "hole": 43,
          "x": -20,
          "y": 40,
          "z": -135
        },
        {
          "hole": 44,
          "x": -12.25,
          "y": 40,
          "z": -135
        },
        {
          "hole": 45,
          "x": -4.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 46,
          "x": 4.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 47,
          "x": 12.25,
          "y": 40,
          "z": -135
        },
        {
          "hole": 48,
          "x": 20,
          "y": 40,
          "z": -135
        },
        {
          "hole": 49,
          "x": 27.75,
          "y": 40,
          "z": -135
        },
        {
          "hole": 50,
          "x": 35.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 51,
          "x": 44.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 52,
          "x": 52.25,
          "y": 40,
          "z": -135
        },
        {
          "hole": 53,
          "x": 60,
          "y": 40,
          "z": -135
        },
        {
          "hole": 54,
          "x": 67.75,
          "y": 40,
          "z": -135
        },
        {
          "hole": 55,
          "x": 75.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 56,
          "x": 84.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 57,
          "x": 92.25,
          "y": 40,
          "z": -135
        },
        {
          "hole": 58,
          "x": 100,
          "y": 40,
          "z": -135
        },
        {
          "hole": 59,
          "x": 107.75,
          "y": 40,
          "z": -135
        },
        {
          "hole": 60,
          "x": 115.5,
          "y": 40,
          "z": -135
        },
        {
          "hole": 61,
          "x": 135,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 62,
          "x": 135,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 63,
          "x": 135,
          "y": 40,
          "z": -100
        },
        {
          "hole": 64,
          "x": 135,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 65,
          "x": 135,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 66,
          "x": 135,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 67,
          "x": 135,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 68,
          "x": 135,
          "y": 40,
          "z": -60
        },
        {
          "hole": 69,
          "x": 135,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 70,
          "x": 135,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 71,
          "x": 135,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 72,
          "x": 135,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 73,
          "x": 135,
          "y": 40,
          "z": -20
        },
        {
          "hole": 74,
          "x": 135,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 75,
          "x": 135,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 76,
          "x": 135,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 77,
          "x": 135,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 78,
          "x": 135,
          "y": 40,
          "z": 20
        },
        {
          "hole": 79,
          "x": 135,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 80,
          "x": 135,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 81,
          "x": 135,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 82,
          "x": 135,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 83,
          "x": 135,
          "y": 40,
          "z": 60
        },
        {
          "hole": 84,
          "x": 135,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 85,
          "x": 135,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 86,
          "x": 135,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 87,
          "x": 135,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 88,
          "x": 135,
          "y": 40,
          "z": 100
        },
        {
          "hole": 89,
          "x": 135,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 90,
          "x": 135,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 91,
          "x": 115.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 92,
          "x": 107.75,
          "y": 40,
          "z": 145
        },
        {
          "hole": 93,
          "x": 100,
          "y": 40,
          "z": 145
        },
        {
          "hole": 94,
          "x": 92.25,
          "y": 40,
          "z": 145
        },
        {
          "hole": 95,
          "x": 84.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 96,
          "x": 75.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 97,
          "x": 67.75,
          "y": 40,
          "z": 145
        },
        {
          "hole": 98,
          "x": 60,
          "y": 40,
          "z": 145
        },
        {
          "hole": 99,
          "x": 52.25,
          "y": 40,
          "z": 145
        },
        {
          "hole": 100,
          "x": 44.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 101,
          "x": 35.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 102,
          "x": 27.75,
          "y": 40,
          "z": 145
        },
        {
          "hole": 103,
          "x": 20,
          "y": 40,
          "z": 145
        },
        {
          "hole": 104,
          "x": 12.25,
          "y": 40,
          "z": 145
        },
        {
          "hole": 105,
          "x": 4.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 106,
          "x": -4.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 107,
          "x": -12.25,
          "y": 40,
          "z": 145
        },
        {
          "hole": 108,
          "x": -20,
          "y": 40,
          "z": 145
        },
        {
          "hole": 109,
          "x": -27.75,
          "y": 40,
          "z": 145
        },
        {
          "hole": 110,
          "x": -35.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 111,
          "x": -44.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 112,
          "x": -52.25,
          "y": 40,
          "z": 145
        },
        {
          "hole": 113,
          "x": -60,
          "y": 40,
          "z": 145
        },
        {
          "hole": 114,
          "x": -67.75,
          "y": 40,
          "z": 145
        },
        {
          "hole": 115,
          "x": -75.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 116,
          "x": -84.5,
          "y": 40,
          "z": 145
        },
        {
          "hole": 117,
          "x": -92.25,
          "y": 40,
          "z": 145
        },
        {
          "hole": 118,
          "x": -100,
          "y": 40,
          "z": 145
        },
        {
          "hole": 119,
          "x": -107.75,
          "y": 40,
          "z": 145
        },
        {
          "hole": 120,
          "x": -115.5,
          "y": 40,
          "z": 145
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": -169.4436,
          "y": 50,
          "z": 190.6568
        },
        {
          "hole": 1,
          "x": -155,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 2,
          "x": -155,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 3,
          "x": -155,
          "y": 40,
          "z": 100
        },
        {
          "hole": 4,
          "x": -155,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 5,
          "x": -155,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 6,
          "x": -155,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 7,
          "x": -155,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 8,
          "x": -155,
          "y": 40,
          "z": 60
        },
        {
          "hole": 9,
          "x": -155,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 10,
          "x": -155,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 11,
          "x": -155,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 12,
          "x": -155,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 13,
          "x": -155,
          "y": 40,
          "z": 20
        },
        {
          "hole": 14,
          "x": -155,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 15,
          "x": -155,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 16,
          "x": -155,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 17,
          "x": -155,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 18,
          "x": -155,
          "y": 40,
          "z": -20
        },
        {
          "hole": 19,
          "x": -155,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 20,
          "x": -155,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 21,
          "x": -155,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 22,
          "x": -155,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 23,
          "x": -155,
          "y": 40,
          "z": -60
        },
        {
          "hole": 24,
          "x": -155,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 25,
          "x": -155,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 26,
          "x": -155,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 27,
          "x": -155,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 28,
          "x": -155,
          "y": 40,
          "z": -100
        },
        {
          "hole": 29,
          "x": -155,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 30,
          "x": -155,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 31,
          "x": -115.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 32,
          "x": -107.75,
          "y": 40,
          "z": -125
        },
        {
          "hole": 33,
          "x": -100,
          "y": 40,
          "z": -125
        },
        {
          "hole": 34,
          "x": -92.25,
          "y": 40,
          "z": -125
        },
        {
          "hole": 35,
          "x": -84.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 36,
          "x": -75.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 37,
          "x": -67.75,
          "y": 40,
          "z": -125
        },
        {
          "hole": 38,
          "x": -60,
          "y": 40,
          "z": -125
        },
        {
          "hole": 39,
          "x": -52.25,
          "y": 40,
          "z": -125
        },
        {
          "hole": 40,
          "x": -44.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 41,
          "x": -35.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 42,
          "x": -27.75,
          "y": 40,
          "z": -125
        },
        {
          "hole": 43,
          "x": -20,
          "y": 40,
          "z": -125
        },
        {
          "hole": 44,
          "x": -12.25,
          "y": 40,
          "z": -125
        },
        {
          "hole": 45,
          "x": -4.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 46,
          "x": 4.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 47,
          "x": 12.25,
          "y": 40,
          "z": -125
        },
        {
          "hole": 48,
          "x": 20,
          "y": 40,
          "z": -125
        },
        {
          "hole": 49,
          "x": 27.75,
          "y": 40,
          "z": -125
        },
        {
          "hole": 50,
          "x": 35.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 51,
          "x": 44.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 52,
          "x": 52.25,
          "y": 40,
          "z": -125
        },
        {
          "hole": 53,
          "x": 60,
          "y": 40,
          "z": -125
        },
        {
          "hole": 54,
          "x": 67.75,
          "y": 40,
          "z": -125
        },
        {
          "hole": 55,
          "x": 75.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 56,
          "x": 84.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 57,
          "x": 92.25,
          "y": 40,
          "z": -125
        },
        {
          "hole": 58,
          "x": 100,
          "y": 40,
          "z": -125
        },
        {
          "hole": 59,
          "x": 107.75,
          "y": 40,
          "z": -125
        },
        {
          "hole": 60,
          "x": 115.5,
          "y": 40,
          "z": -125
        },
        {
          "hole": 61,
          "x": 125,
          "y": 40,
          "z": -115.5
        },
        {
          "hole": 62,
          "x": 125,
          "y": 40,
          "z": -107.75
        },
        {
          "hole": 63,
          "x": 125,
          "y": 40,
          "z": -100
        },
        {
          "hole": 64,
          "x": 125,
          "y": 40,
          "z": -92.25
        },
        {
          "hole": 65,
          "x": 125,
          "y": 40,
          "z": -84.5
        },
        {
          "hole": 66,
          "x": 125,
          "y": 40,
          "z": -75.5
        },
        {
          "hole": 67,
          "x": 125,
          "y": 40,
          "z": -67.75
        },
        {
          "hole": 68,
          "x": 125,
          "y": 40,
          "z": -60
        },
        {
          "hole": 69,
          "x": 125,
          "y": 40,
          "z": -52.25
        },
        {
          "hole": 70,
          "x": 125,
          "y": 40,
          "z": -44.5
        },
        {
          "hole": 71,
          "x": 125,
          "y": 40,
          "z": -35.5
        },
        {
          "hole": 72,
          "x": 125,
          "y": 40,
          "z": -27.75
        },
        {
          "hole": 73,
          "x": 125,
          "y": 40,
          "z": -20
        },
        {
          "hole": 74,
          "x": 125,
          "y": 40,
          "z": -12.25
        },
        {
          "hole": 75,
          "x": 125,
          "y": 40,
          "z": -4.5
        },
        {
          "hole": 76,
          "x": 125,
          "y": 40,
          "z": 4.5
        },
        {
          "hole": 77,
          "x": 125,
          "y": 40,
          "z": 12.25
        },
        {
          "hole": 78,
          "x": 125,
          "y": 40,
          "z": 20
        },
        {
          "hole": 79,
          "x": 125,
          "y": 40,
          "z": 27.75
        },
        {
          "hole": 80,
          "x": 125,
          "y": 40,
          "z": 35.5
        },
        {
          "hole": 81,
          "x": 125,
          "y": 40,
          "z": 44.5
        },
        {
          "hole": 82,
          "x": 125,
          "y": 40,
          "z": 52.25
        },
        {
          "hole": 83,
          "x": 125,
          "y": 40,
          "z": 60
        },
        {
          "hole": 84,
          "x": 125,
          "y": 40,
          "z": 67.75
        },
        {
          "hole": 85,
          "x": 125,
          "y": 40,
          "z": 75.5
        },
        {
          "hole": 86,
          "x": 125,
          "y": 40,
          "z": 84.5
        },
        {
          "hole": 87,
          "x": 125,
          "y": 40,
          "z": 92.25
        },
        {
          "hole": 88,
          "x": 125,
          "y": 40,
          "z": 100
        },
        {
          "hole": 89,
          "x": 125,
          "y": 40,
          "z": 107.75
        },
        {
          "hole": 90,
          "x": 125,
          "y": 40,
          "z": 115.5
        },
        {
          "hole": 91,
          "x": 115.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 92,
          "x": 107.75,
          "y": 40,
          "z": 155
        },
        {
          "hole": 93,
          "x": 100,
          "y": 40,
          "z": 155
        },
        {
          "hole": 94,
          "x": 92.25,
          "y": 40,
          "z": 155
        },
        {
          "hole": 95,
          "x": 84.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 96,
          "x": 75.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 97,
          "x": 67.75,
          "y": 40,
          "z": 155
        },
        {
          "hole": 98,
          "x": 60,
          "y": 40,
          "z": 155
        },
        {
          "hole": 99,
          "x": 52.25,
          "y": 40,
          "z": 155
        },
        {
          "hole": 100,
          "x": 44.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 101,
          "x": 35.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 102,
          "x": 27.75,
          "y": 40,
          "z": 155
        },
        {
          "hole": 103,
          "x": 20,
          "y": 40,
          "z": 155
        },
        {
          "hole": 104,
          "x": 12.25,
          "y": 40,
          "z": 155
        },
        {
          "hole": 105,
          "x": 4.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 106,
          "x": -4.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 107,
          "x": -12.25,
          "y": 40,
          "z": 155
        },
        {
          "hole": 108,
          "x": -20,
          "y": 40,
          "z": 155
        },
        {
          "hole": 109,
          "x": -27.75,
          "y": 40,
          "z": 155
        },
        {
          "hole": 110,
          "x": -35.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 111,
          "x": -44.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 112,
          "x": -52.25,
          "y": 40,
          "z": 155
        },
        {
          "hole": 113,
          "x": -60,
          "y": 40,
          "z": 155
        },
        {
          "hole": 114,
          "x": -67.75,
          "y": 40,
          "z": 155
        },
        {
          "hole": 115,
          "x": -75.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 116,
          "x": -84.5,
          "y": 40,
          "z": 155
        },
        {
          "hole": 117,
          "x": -92.25,
          "y": 40,
          "z": 155
        },
        {
          "hole": 118,
          "x": -100,
          "y": 40,
          "z": 155
        },
        {
          "hole": 119,
          "x": -107.75,
          "y": 40,
          "z": 155
        },
        {
          "hole": 120,
          "x": -115.5,
          "y": 40,
          "z": 155
        }
      ]
    }
  },
  {
    "id": "board-football-stadium",
    "name": "Football Stadium",
    "brand": "crazy,pints,adult",
    "desc": "Football Stadium Cribbage 3D cribbage board (9.4 MB)",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/Stadium_-_Football_-_Crazy_-_Thumbnail.png",
    "modelUrl": "https://cdn.shopify.com/3d/models/9fe4175dafce835a/Stadium_-_Football_-_Crazy.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 7,
          "y": 20,
          "z": 85
        },
        {
          "hole": 1,
          "x": 24.5,
          "y": 50,
          "z": 115
        },
        {
          "hole": 2,
          "x": 32.25,
          "y": 50,
          "z": 115
        },
        {
          "hole": 3,
          "x": 40,
          "y": 50,
          "z": 115
        },
        {
          "hole": 4,
          "x": 47.75,
          "y": 50,
          "z": 115
        },
        {
          "hole": 5,
          "x": 55.5,
          "y": 50,
          "z": 115
        },
        {
          "hole": 6,
          "x": 64.5,
          "y": 50,
          "z": 115
        },
        {
          "hole": 7,
          "x": 72.25,
          "y": 50,
          "z": 115
        },
        {
          "hole": 8,
          "x": 80,
          "y": 50,
          "z": 115
        },
        {
          "hole": 9,
          "x": 87.75,
          "y": 50,
          "z": 115
        },
        {
          "hole": 10,
          "x": 95.5,
          "y": 50,
          "z": 115
        },
        {
          "hole": 11,
          "x": 107.5214,
          "y": 50,
          "z": 114.7538
        },
        {
          "hole": 12,
          "x": 115.0105,
          "y": 50,
          "z": 114.0162
        },
        {
          "hole": 13,
          "x": 122.4354,
          "y": 50,
          "z": 112.7903
        },
        {
          "hole": 14,
          "x": 129.7642,
          "y": 50,
          "z": 111.0815
        },
        {
          "hole": 15,
          "x": 136.9655,
          "y": 50,
          "z": 108.897
        },
        {
          "hole": 16,
          "x": 150.8632,
          "y": 50,
          "z": 103.1404
        },
        {
          "hole": 17,
          "x": 157.5,
          "y": 50,
          "z": 99.5929
        },
        {
          "hole": 18,
          "x": 163.8906,
          "y": 50,
          "z": 95.619
        },
        {
          "hole": 19,
          "x": 170.0076,
          "y": 50,
          "z": 91.2356
        },
        {
          "hole": 20,
          "x": 175.8248,
          "y": 50,
          "z": 86.4616
        },
        {
          "hole": 21,
          "x": 186.4616,
          "y": 50,
          "z": 75.8248
        },
        {
          "hole": 22,
          "x": 191.2356,
          "y": 50,
          "z": 70.0076
        },
        {
          "hole": 23,
          "x": 195.619,
          "y": 50,
          "z": 63.8906
        },
        {
          "hole": 24,
          "x": 199.5929,
          "y": 50,
          "z": 57.5
        },
        {
          "hole": 25,
          "x": 203.1404,
          "y": 50,
          "z": 50.8632
        },
        {
          "hole": 26,
          "x": 208.897,
          "y": 50,
          "z": 36.9655
        },
        {
          "hole": 27,
          "x": 211.0815,
          "y": 50,
          "z": 29.7642
        },
        {
          "hole": 28,
          "x": 212.7903,
          "y": 50,
          "z": 22.4354
        },
        {
          "hole": 29,
          "x": 214.0162,
          "y": 50,
          "z": 15.0105
        },
        {
          "hole": 30,
          "x": 214.7538,
          "y": 50,
          "z": 7.5214
        },
        {
          "hole": 31,
          "x": 214.7537,
          "y": 50,
          "z": -7.5213
        },
        {
          "hole": 32,
          "x": 214.0161,
          "y": 50,
          "z": -15.0105
        },
        {
          "hole": 33,
          "x": 212.7903,
          "y": 50,
          "z": -22.4354
        },
        {
          "hole": 34,
          "x": 211.0814,
          "y": 50,
          "z": -29.7642
        },
        {
          "hole": 35,
          "x": 208.8969,
          "y": 50,
          "z": -36.9655
        },
        {
          "hole": 36,
          "x": 203.1403,
          "y": 50,
          "z": -50.8632
        },
        {
          "hole": 37,
          "x": 199.5929,
          "y": 50,
          "z": -57.5
        },
        {
          "hole": 38,
          "x": 195.619,
          "y": 50,
          "z": -63.8906
        },
        {
          "hole": 39,
          "x": 191.2356,
          "y": 50,
          "z": -70.0076
        },
        {
          "hole": 40,
          "x": 186.4615,
          "y": 50,
          "z": -75.8248
        },
        {
          "hole": 41,
          "x": 175.8248,
          "y": 50,
          "z": -86.4616
        },
        {
          "hole": 42,
          "x": 170.0076,
          "y": 50,
          "z": -91.2357
        },
        {
          "hole": 43,
          "x": 163.8906,
          "y": 50,
          "z": -95.619
        },
        {
          "hole": 44,
          "x": 157.5,
          "y": 50,
          "z": -99.5929
        },
        {
          "hole": 45,
          "x": 150.8632,
          "y": 50,
          "z": -103.1404
        },
        {
          "hole": 46,
          "x": 136.9655,
          "y": 50,
          "z": -108.897
        },
        {
          "hole": 47,
          "x": 129.7642,
          "y": 50,
          "z": -111.0815
        },
        {
          "hole": 48,
          "x": 122.4354,
          "y": 50,
          "z": -112.7903
        },
        {
          "hole": 49,
          "x": 115.0105,
          "y": 50,
          "z": -114.0162
        },
        {
          "hole": 50,
          "x": 107.5214,
          "y": 50,
          "z": -114.7538
        },
        {
          "hole": 51,
          "x": 95.5,
          "y": 50,
          "z": -115
        },
        {
          "hole": 52,
          "x": 87.75,
          "y": 50,
          "z": -115
        },
        {
          "hole": 53,
          "x": 80,
          "y": 50,
          "z": -115
        },
        {
          "hole": 54,
          "x": 72.25,
          "y": 50,
          "z": -115
        },
        {
          "hole": 55,
          "x": 64.5,
          "y": 50,
          "z": -115
        },
        {
          "hole": 56,
          "x": 55.5,
          "y": 50,
          "z": -115
        },
        {
          "hole": 57,
          "x": 47.75,
          "y": 50,
          "z": -115
        },
        {
          "hole": 58,
          "x": 40,
          "y": 50,
          "z": -115
        },
        {
          "hole": 59,
          "x": 32.25,
          "y": 50,
          "z": -115
        },
        {
          "hole": 60,
          "x": 24.5,
          "y": 50,
          "z": -115
        },
        {
          "hole": 61,
          "x": 15.5,
          "y": 50,
          "z": -115
        },
        {
          "hole": 62,
          "x": 7.75,
          "y": 50,
          "z": -115
        },
        {
          "hole": 63,
          "x": 0,
          "y": 50,
          "z": -115
        },
        {
          "hole": 64,
          "x": -7.75,
          "y": 50,
          "z": -115
        },
        {
          "hole": 65,
          "x": -15.5,
          "y": 50,
          "z": -115
        },
        {
          "hole": 66,
          "x": -24.5,
          "y": 50,
          "z": -115
        },
        {
          "hole": 67,
          "x": -32.25,
          "y": 50,
          "z": -115
        },
        {
          "hole": 68,
          "x": -40,
          "y": 50,
          "z": -115
        },
        {
          "hole": 69,
          "x": -47.75,
          "y": 50,
          "z": -115
        },
        {
          "hole": 70,
          "x": -55.5,
          "y": 50,
          "z": -115
        },
        {
          "hole": 71,
          "x": -64.4999,
          "y": 50,
          "z": -114.9999
        },
        {
          "hole": 72,
          "x": -72.2499,
          "y": 50,
          "z": -114.9999
        },
        {
          "hole": 73,
          "x": -79.9999,
          "y": 50,
          "z": -114.9999
        },
        {
          "hole": 74,
          "x": -87.7499,
          "y": 50,
          "z": -115
        },
        {
          "hole": 75,
          "x": -95.4999,
          "y": 50,
          "z": -115
        },
        {
          "hole": 76,
          "x": -107.5213,
          "y": 50,
          "z": -114.7538
        },
        {
          "hole": 77,
          "x": -115.0105,
          "y": 50,
          "z": -114.0162
        },
        {
          "hole": 78,
          "x": -122.4354,
          "y": 50,
          "z": -112.7903
        },
        {
          "hole": 79,
          "x": -129.7642,
          "y": 50,
          "z": -111.0815
        },
        {
          "hole": 80,
          "x": -136.9655,
          "y": 50,
          "z": -108.897
        },
        {
          "hole": 81,
          "x": -150.8631,
          "y": 50,
          "z": -103.1403
        },
        {
          "hole": 82,
          "x": -157.4999,
          "y": 50,
          "z": -99.5929
        },
        {
          "hole": 83,
          "x": -163.8905,
          "y": 50,
          "z": -95.619
        },
        {
          "hole": 84,
          "x": -170.0075,
          "y": 50,
          "z": -91.2356
        },
        {
          "hole": 85,
          "x": -175.8247,
          "y": 50,
          "z": -86.4616
        },
        {
          "hole": 86,
          "x": -186.4616,
          "y": 50,
          "z": -75.8248
        },
        {
          "hole": 87,
          "x": -191.2356,
          "y": 50,
          "z": -70.0076
        },
        {
          "hole": 88,
          "x": -195.619,
          "y": 50,
          "z": -63.8906
        },
        {
          "hole": 89,
          "x": -199.5929,
          "y": 50,
          "z": -57.5
        },
        {
          "hole": 90,
          "x": -203.1404,
          "y": 50,
          "z": -50.8632
        },
        {
          "hole": 91,
          "x": -208.897,
          "y": 50,
          "z": -36.9655
        },
        {
          "hole": 92,
          "x": -211.0815,
          "y": 50,
          "z": -29.7642
        },
        {
          "hole": 93,
          "x": -212.7903,
          "y": 50,
          "z": -22.4354
        },
        {
          "hole": 94,
          "x": -214.0162,
          "y": 50,
          "z": -15.0105
        },
        {
          "hole": 95,
          "x": -214.7538,
          "y": 50,
          "z": -7.5214
        },
        {
          "hole": 96,
          "x": -214.7538,
          "y": 50,
          "z": 7.5214
        },
        {
          "hole": 97,
          "x": -214.0162,
          "y": 50,
          "z": 15.0105
        },
        {
          "hole": 98,
          "x": -212.7903,
          "y": 50,
          "z": 22.4354
        },
        {
          "hole": 99,
          "x": -211.0815,
          "y": 50,
          "z": 29.7642
        },
        {
          "hole": 100,
          "x": -208.897,
          "y": 50,
          "z": 36.9655
        },
        {
          "hole": 101,
          "x": -203.1403,
          "y": 50,
          "z": 50.8632
        },
        {
          "hole": 102,
          "x": -199.5929,
          "y": 50,
          "z": 57.5
        },
        {
          "hole": 103,
          "x": -195.619,
          "y": 50,
          "z": 63.8906
        },
        {
          "hole": 104,
          "x": -191.2356,
          "y": 50,
          "z": 70.0076
        },
        {
          "hole": 105,
          "x": -186.4616,
          "y": 50,
          "z": 75.8248
        },
        {
          "hole": 106,
          "x": -175.8248,
          "y": 50,
          "z": 86.4615
        },
        {
          "hole": 107,
          "x": -170.0076,
          "y": 50,
          "z": 91.2356
        },
        {
          "hole": 108,
          "x": -163.8906,
          "y": 50,
          "z": 95.619
        },
        {
          "hole": 109,
          "x": -157.5,
          "y": 50,
          "z": 99.5929
        },
        {
          "hole": 110,
          "x": -150.8632,
          "y": 50,
          "z": 103.1403
        },
        {
          "hole": 111,
          "x": -136.9655,
          "y": 50,
          "z": 108.897
        },
        {
          "hole": 112,
          "x": -129.7642,
          "y": 50,
          "z": 111.0815
        },
        {
          "hole": 113,
          "x": -122.4354,
          "y": 50,
          "z": 112.7903
        },
        {
          "hole": 114,
          "x": -115.0105,
          "y": 50,
          "z": 114.0162
        },
        {
          "hole": 115,
          "x": -107.5214,
          "y": 50,
          "z": 114.7538
        },
        {
          "hole": 116,
          "x": -95.5,
          "y": 50,
          "z": 115
        },
        {
          "hole": 117,
          "x": -87.75,
          "y": 50,
          "z": 115
        },
        {
          "hole": 118,
          "x": -80,
          "y": 50,
          "z": 115
        },
        {
          "hole": 119,
          "x": -72.25,
          "y": 50,
          "z": 115
        },
        {
          "hole": 120,
          "x": -64.5,
          "y": 50,
          "z": 115
        },
        {
          "hole": 121,
          "x": -40,
          "y": 20,
          "z": 100
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 7,
          "y": 30,
          "z": 95
        },
        {
          "hole": 1,
          "x": 24.5,
          "y": 40,
          "z": 105
        },
        {
          "hole": 2,
          "x": 32.25,
          "y": 40,
          "z": 105
        },
        {
          "hole": 3,
          "x": 40,
          "y": 40,
          "z": 105
        },
        {
          "hole": 4,
          "x": 47.75,
          "y": 40,
          "z": 105
        },
        {
          "hole": 5,
          "x": 55.5,
          "y": 40,
          "z": 105
        },
        {
          "hole": 6,
          "x": 64.5,
          "y": 40,
          "z": 105
        },
        {
          "hole": 7,
          "x": 72.25,
          "y": 40,
          "z": 105
        },
        {
          "hole": 8,
          "x": 80,
          "y": 40,
          "z": 105
        },
        {
          "hole": 9,
          "x": 87.75,
          "y": 40,
          "z": 105
        },
        {
          "hole": 10,
          "x": 95.5,
          "y": 40,
          "z": 105
        },
        {
          "hole": 11,
          "x": 106.8673,
          "y": 40,
          "z": 104.7752
        },
        {
          "hole": 12,
          "x": 113.7052,
          "y": 40,
          "z": 104.1017
        },
        {
          "hole": 13,
          "x": 120.4845,
          "y": 40,
          "z": 102.9825
        },
        {
          "hole": 14,
          "x": 127.176,
          "y": 40,
          "z": 101.4222
        },
        {
          "hole": 15,
          "x": 133.7511,
          "y": 40,
          "z": 99.4277
        },
        {
          "hole": 16,
          "x": 146.4403,
          "y": 40,
          "z": 94.1716
        },
        {
          "hole": 17,
          "x": 152.5,
          "y": 40,
          "z": 90.9327
        },
        {
          "hole": 18,
          "x": 158.3349,
          "y": 40,
          "z": 87.3043
        },
        {
          "hole": 19,
          "x": 163.9199,
          "y": 40,
          "z": 83.3021
        },
        {
          "hole": 20,
          "x": 169.2313,
          "y": 40,
          "z": 78.9432
        },
        {
          "hole": 21,
          "x": 178.9432,
          "y": 40,
          "z": 69.2313
        },
        {
          "hole": 22,
          "x": 183.3021,
          "y": 40,
          "z": 63.92
        },
        {
          "hole": 23,
          "x": 187.3043,
          "y": 40,
          "z": 58.3349
        },
        {
          "hole": 24,
          "x": 190.9327,
          "y": 40,
          "z": 52.5
        },
        {
          "hole": 25,
          "x": 194.1716,
          "y": 40,
          "z": 46.4403
        },
        {
          "hole": 26,
          "x": 199.4277,
          "y": 40,
          "z": 33.7511
        },
        {
          "hole": 27,
          "x": 201.4222,
          "y": 40,
          "z": 27.176
        },
        {
          "hole": 28,
          "x": 202.9824,
          "y": 40,
          "z": 20.4845
        },
        {
          "hole": 29,
          "x": 204.1017,
          "y": 40,
          "z": 13.7052
        },
        {
          "hole": 30,
          "x": 204.7752,
          "y": 40,
          "z": 6.8673
        },
        {
          "hole": 31,
          "x": 204.7752,
          "y": 40,
          "z": -6.8673
        },
        {
          "hole": 32,
          "x": 204.1017,
          "y": 40,
          "z": -13.7052
        },
        {
          "hole": 33,
          "x": 202.9824,
          "y": 40,
          "z": -20.4845
        },
        {
          "hole": 34,
          "x": 201.4222,
          "y": 40,
          "z": -27.176
        },
        {
          "hole": 35,
          "x": 199.4276,
          "y": 40,
          "z": -33.7511
        },
        {
          "hole": 36,
          "x": 194.1716,
          "y": 40,
          "z": -46.4403
        },
        {
          "hole": 37,
          "x": 190.9326,
          "y": 40,
          "z": -52.5
        },
        {
          "hole": 38,
          "x": 187.3043,
          "y": 40,
          "z": -58.3349
        },
        {
          "hole": 39,
          "x": 183.3021,
          "y": 40,
          "z": -63.92
        },
        {
          "hole": 40,
          "x": 178.9431,
          "y": 40,
          "z": -69.2313
        },
        {
          "hole": 41,
          "x": 169.2313,
          "y": 40,
          "z": -78.9432
        },
        {
          "hole": 42,
          "x": 163.92,
          "y": 40,
          "z": -83.3021
        },
        {
          "hole": 43,
          "x": 158.3349,
          "y": 40,
          "z": -87.3043
        },
        {
          "hole": 44,
          "x": 152.5,
          "y": 40,
          "z": -90.9327
        },
        {
          "hole": 45,
          "x": 146.4403,
          "y": 40,
          "z": -94.1717
        },
        {
          "hole": 46,
          "x": 133.7511,
          "y": 40,
          "z": -99.4277
        },
        {
          "hole": 47,
          "x": 127.176,
          "y": 40,
          "z": -101.4222
        },
        {
          "hole": 48,
          "x": 120.4845,
          "y": 40,
          "z": -102.9825
        },
        {
          "hole": 49,
          "x": 113.7053,
          "y": 40,
          "z": -104.1017
        },
        {
          "hole": 50,
          "x": 106.8673,
          "y": 40,
          "z": -104.7752
        },
        {
          "hole": 51,
          "x": 95.5,
          "y": 40,
          "z": -105
        },
        {
          "hole": 52,
          "x": 87.75,
          "y": 40,
          "z": -105
        },
        {
          "hole": 53,
          "x": 80,
          "y": 40,
          "z": -105
        },
        {
          "hole": 54,
          "x": 72.25,
          "y": 40,
          "z": -105
        },
        {
          "hole": 55,
          "x": 64.5,
          "y": 40,
          "z": -105
        },
        {
          "hole": 56,
          "x": 55.5,
          "y": 40,
          "z": -105
        },
        {
          "hole": 57,
          "x": 47.75,
          "y": 40,
          "z": -105
        },
        {
          "hole": 58,
          "x": 40,
          "y": 40,
          "z": -105
        },
        {
          "hole": 59,
          "x": 32.25,
          "y": 40,
          "z": -105
        },
        {
          "hole": 60,
          "x": 24.5,
          "y": 40,
          "z": -105
        },
        {
          "hole": 61,
          "x": 15.5,
          "y": 40,
          "z": -105
        },
        {
          "hole": 62,
          "x": 7.75,
          "y": 40,
          "z": -105
        },
        {
          "hole": 63,
          "x": 0,
          "y": 40,
          "z": -105
        },
        {
          "hole": 64,
          "x": -7.75,
          "y": 40,
          "z": -105
        },
        {
          "hole": 65,
          "x": -15.5,
          "y": 40,
          "z": -105
        },
        {
          "hole": 66,
          "x": -24.5,
          "y": 40,
          "z": -105
        },
        {
          "hole": 67,
          "x": -32.25,
          "y": 40,
          "z": -105
        },
        {
          "hole": 68,
          "x": -40,
          "y": 40,
          "z": -105
        },
        {
          "hole": 69,
          "x": -47.75,
          "y": 40,
          "z": -105
        },
        {
          "hole": 70,
          "x": -55.5,
          "y": 40,
          "z": -105
        },
        {
          "hole": 71,
          "x": -64.4999,
          "y": 40,
          "z": -105
        },
        {
          "hole": 72,
          "x": -72.2499,
          "y": 40,
          "z": -105
        },
        {
          "hole": 73,
          "x": -79.9999,
          "y": 40,
          "z": -105
        },
        {
          "hole": 74,
          "x": -87.7499,
          "y": 40,
          "z": -105
        },
        {
          "hole": 75,
          "x": -95.4999,
          "y": 40,
          "z": -105
        },
        {
          "hole": 76,
          "x": -106.8673,
          "y": 40,
          "z": -104.7752
        },
        {
          "hole": 77,
          "x": -113.7052,
          "y": 40,
          "z": -104.1017
        },
        {
          "hole": 78,
          "x": -120.4845,
          "y": 40,
          "z": -102.9825
        },
        {
          "hole": 79,
          "x": -127.176,
          "y": 40,
          "z": -101.4222
        },
        {
          "hole": 80,
          "x": -133.7511,
          "y": 40,
          "z": -99.4277
        },
        {
          "hole": 81,
          "x": -146.4403,
          "y": 40,
          "z": -94.1716
        },
        {
          "hole": 82,
          "x": -152.4999,
          "y": 40,
          "z": -90.9326
        },
        {
          "hole": 83,
          "x": -158.3348,
          "y": 40,
          "z": -87.3043
        },
        {
          "hole": 84,
          "x": -163.9199,
          "y": 40,
          "z": -83.3021
        },
        {
          "hole": 85,
          "x": -169.2313,
          "y": 40,
          "z": -78.9432
        },
        {
          "hole": 86,
          "x": -178.9432,
          "y": 40,
          "z": -69.2313
        },
        {
          "hole": 87,
          "x": -183.3021,
          "y": 40,
          "z": -63.92
        },
        {
          "hole": 88,
          "x": -187.3043,
          "y": 40,
          "z": -58.3349
        },
        {
          "hole": 89,
          "x": -190.9327,
          "y": 40,
          "z": -52.5
        },
        {
          "hole": 90,
          "x": -194.1717,
          "y": 40,
          "z": -46.4403
        },
        {
          "hole": 91,
          "x": -199.4277,
          "y": 40,
          "z": -33.7511
        },
        {
          "hole": 92,
          "x": -201.4222,
          "y": 40,
          "z": -27.176
        },
        {
          "hole": 93,
          "x": -202.9825,
          "y": 40,
          "z": -20.4845
        },
        {
          "hole": 94,
          "x": -204.1017,
          "y": 40,
          "z": -13.7053
        },
        {
          "hole": 95,
          "x": -204.7752,
          "y": 40,
          "z": -6.8673
        },
        {
          "hole": 96,
          "x": -204.7752,
          "y": 40,
          "z": 6.8673
        },
        {
          "hole": 97,
          "x": -204.1017,
          "y": 40,
          "z": 13.7052
        },
        {
          "hole": 98,
          "x": -202.9825,
          "y": 40,
          "z": 20.4845
        },
        {
          "hole": 99,
          "x": -201.4222,
          "y": 40,
          "z": 27.176
        },
        {
          "hole": 100,
          "x": -199.4277,
          "y": 40,
          "z": 33.7511
        },
        {
          "hole": 101,
          "x": -194.1716,
          "y": 40,
          "z": 46.4403
        },
        {
          "hole": 102,
          "x": -190.9326,
          "y": 40,
          "z": 52.5
        },
        {
          "hole": 103,
          "x": -187.3043,
          "y": 40,
          "z": 58.3349
        },
        {
          "hole": 104,
          "x": -183.3021,
          "y": 40,
          "z": 63.9199
        },
        {
          "hole": 105,
          "x": -178.9432,
          "y": 40,
          "z": 69.2313
        },
        {
          "hole": 106,
          "x": -169.2313,
          "y": 40,
          "z": 78.9431
        },
        {
          "hole": 107,
          "x": -163.92,
          "y": 40,
          "z": 83.3021
        },
        {
          "hole": 108,
          "x": -158.3349,
          "y": 40,
          "z": 87.3043
        },
        {
          "hole": 109,
          "x": -152.5,
          "y": 40,
          "z": 90.9326
        },
        {
          "hole": 110,
          "x": -146.4403,
          "y": 40,
          "z": 94.1716
        },
        {
          "hole": 111,
          "x": -133.7512,
          "y": 40,
          "z": 99.4277
        },
        {
          "hole": 112,
          "x": -127.176,
          "y": 40,
          "z": 101.4222
        },
        {
          "hole": 113,
          "x": -120.4845,
          "y": 40,
          "z": 102.9825
        },
        {
          "hole": 114,
          "x": -113.7053,
          "y": 40,
          "z": 104.1017
        },
        {
          "hole": 115,
          "x": -106.8673,
          "y": 40,
          "z": 104.7752
        },
        {
          "hole": 116,
          "x": -95.5,
          "y": 40,
          "z": 105
        },
        {
          "hole": 117,
          "x": -87.75,
          "y": 40,
          "z": 105
        },
        {
          "hole": 118,
          "x": -80,
          "y": 40,
          "z": 105
        },
        {
          "hole": 119,
          "x": -72.25,
          "y": 40,
          "z": 105
        },
        {
          "hole": 120,
          "x": -64.5,
          "y": 40,
          "z": 105
        },
        {
          "hole": 121,
          "x": -40,
          "y": 30,
          "z": 100
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": 7,
          "y": 40,
          "z": 105
        },
        {
          "hole": 1,
          "x": 24.5,
          "y": 30,
          "z": 95
        },
        {
          "hole": 2,
          "x": 32.25,
          "y": 30,
          "z": 95
        },
        {
          "hole": 3,
          "x": 40,
          "y": 30,
          "z": 95
        },
        {
          "hole": 4,
          "x": 47.75,
          "y": 30,
          "z": 95
        },
        {
          "hole": 5,
          "x": 55.5,
          "y": 30,
          "z": 95
        },
        {
          "hole": 6,
          "x": 64.5,
          "y": 30,
          "z": 95
        },
        {
          "hole": 7,
          "x": 72.25,
          "y": 30,
          "z": 95
        },
        {
          "hole": 8,
          "x": 80,
          "y": 30,
          "z": 95
        },
        {
          "hole": 9,
          "x": 87.75,
          "y": 30,
          "z": 95
        },
        {
          "hole": 10,
          "x": 95.5,
          "y": 30,
          "z": 95
        },
        {
          "hole": 11,
          "x": 106.2133,
          "y": 30,
          "z": 94.7966
        },
        {
          "hole": 12,
          "x": 112.4,
          "y": 30,
          "z": 94.1873
        },
        {
          "hole": 13,
          "x": 118.5336,
          "y": 30,
          "z": 93.1746
        },
        {
          "hole": 14,
          "x": 124.5878,
          "y": 30,
          "z": 91.763
        },
        {
          "hole": 15,
          "x": 130.5367,
          "y": 30,
          "z": 89.9584
        },
        {
          "hole": 16,
          "x": 142.0174,
          "y": 30,
          "z": 85.2029
        },
        {
          "hole": 17,
          "x": 147.5,
          "y": 30,
          "z": 82.2724
        },
        {
          "hole": 18,
          "x": 152.7792,
          "y": 30,
          "z": 78.9896
        },
        {
          "hole": 19,
          "x": 157.8323,
          "y": 30,
          "z": 75.3686
        },
        {
          "hole": 20,
          "x": 162.6378,
          "y": 30,
          "z": 71.4248
        },
        {
          "hole": 21,
          "x": 171.4248,
          "y": 30,
          "z": 62.6379
        },
        {
          "hole": 22,
          "x": 175.3686,
          "y": 30,
          "z": 57.8323
        },
        {
          "hole": 23,
          "x": 178.9896,
          "y": 30,
          "z": 52.7792
        },
        {
          "hole": 24,
          "x": 182.2724,
          "y": 30,
          "z": 47.5
        },
        {
          "hole": 25,
          "x": 185.2029,
          "y": 30,
          "z": 42.0174
        },
        {
          "hole": 26,
          "x": 189.9584,
          "y": 30,
          "z": 30.5367
        },
        {
          "hole": 27,
          "x": 191.7629,
          "y": 30,
          "z": 24.5878
        },
        {
          "hole": 28,
          "x": 193.1746,
          "y": 30,
          "z": 18.5336
        },
        {
          "hole": 29,
          "x": 194.1873,
          "y": 30,
          "z": 12.4
        },
        {
          "hole": 30,
          "x": 194.7966,
          "y": 30,
          "z": 6.2133
        },
        {
          "hole": 31,
          "x": 194.7966,
          "y": 30,
          "z": -6.2133
        },
        {
          "hole": 32,
          "x": 194.1872,
          "y": 30,
          "z": -12.4
        },
        {
          "hole": 33,
          "x": 193.1746,
          "y": 30,
          "z": -18.5336
        },
        {
          "hole": 34,
          "x": 191.7629,
          "y": 30,
          "z": -24.5878
        },
        {
          "hole": 35,
          "x": 189.9583,
          "y": 30,
          "z": -30.5367
        },
        {
          "hole": 36,
          "x": 185.2029,
          "y": 30,
          "z": -42.0174
        },
        {
          "hole": 37,
          "x": 182.2724,
          "y": 30,
          "z": -47.5
        },
        {
          "hole": 38,
          "x": 178.9896,
          "y": 30,
          "z": -52.7792
        },
        {
          "hole": 39,
          "x": 175.3685,
          "y": 30,
          "z": -57.8324
        },
        {
          "hole": 40,
          "x": 171.4247,
          "y": 30,
          "z": -62.6379
        },
        {
          "hole": 41,
          "x": 162.6379,
          "y": 30,
          "z": -71.4248
        },
        {
          "hole": 42,
          "x": 157.8323,
          "y": 30,
          "z": -75.3686
        },
        {
          "hole": 43,
          "x": 152.7792,
          "y": 30,
          "z": -78.9896
        },
        {
          "hole": 44,
          "x": 147.5,
          "y": 30,
          "z": -82.2724
        },
        {
          "hole": 45,
          "x": 142.0174,
          "y": 30,
          "z": -85.2029
        },
        {
          "hole": 46,
          "x": 130.5367,
          "y": 30,
          "z": -89.9584
        },
        {
          "hole": 47,
          "x": 124.5878,
          "y": 30,
          "z": -91.763
        },
        {
          "hole": 48,
          "x": 118.5336,
          "y": 30,
          "z": -93.1746
        },
        {
          "hole": 49,
          "x": 112.4,
          "y": 30,
          "z": -94.1873
        },
        {
          "hole": 50,
          "x": 106.2133,
          "y": 30,
          "z": -94.7966
        },
        {
          "hole": 51,
          "x": 95.5,
          "y": 30,
          "z": -95
        },
        {
          "hole": 52,
          "x": 87.75,
          "y": 30,
          "z": -95
        },
        {
          "hole": 53,
          "x": 80,
          "y": 30,
          "z": -95
        },
        {
          "hole": 54,
          "x": 72.25,
          "y": 30,
          "z": -95
        },
        {
          "hole": 55,
          "x": 64.5,
          "y": 30,
          "z": -95
        },
        {
          "hole": 56,
          "x": 55.5,
          "y": 30,
          "z": -95
        },
        {
          "hole": 57,
          "x": 47.75,
          "y": 30,
          "z": -95
        },
        {
          "hole": 58,
          "x": 40,
          "y": 30,
          "z": -95
        },
        {
          "hole": 59,
          "x": 32.25,
          "y": 30,
          "z": -95
        },
        {
          "hole": 60,
          "x": 24.5,
          "y": 30,
          "z": -95
        },
        {
          "hole": 61,
          "x": 15.5,
          "y": 30,
          "z": -95
        },
        {
          "hole": 62,
          "x": 7.75,
          "y": 30,
          "z": -95
        },
        {
          "hole": 63,
          "x": 0,
          "y": 30,
          "z": -95
        },
        {
          "hole": 64,
          "x": -7.75,
          "y": 30,
          "z": -95
        },
        {
          "hole": 65,
          "x": -15.5,
          "y": 30,
          "z": -95
        },
        {
          "hole": 66,
          "x": -24.5,
          "y": 30,
          "z": -95
        },
        {
          "hole": 67,
          "x": -32.25,
          "y": 30,
          "z": -95
        },
        {
          "hole": 68,
          "x": -40,
          "y": 30,
          "z": -95
        },
        {
          "hole": 69,
          "x": -47.75,
          "y": 30,
          "z": -95
        },
        {
          "hole": 70,
          "x": -55.5,
          "y": 30,
          "z": -95
        },
        {
          "hole": 71,
          "x": -64.4999,
          "y": 30,
          "z": -95
        },
        {
          "hole": 72,
          "x": -72.2499,
          "y": 30,
          "z": -95
        },
        {
          "hole": 73,
          "x": -79.9999,
          "y": 30,
          "z": -95
        },
        {
          "hole": 74,
          "x": -87.7499,
          "y": 30,
          "z": -95
        },
        {
          "hole": 75,
          "x": -95.4999,
          "y": 30,
          "z": -95
        },
        {
          "hole": 76,
          "x": -106.2133,
          "y": 30,
          "z": -94.7966
        },
        {
          "hole": 77,
          "x": -112.4,
          "y": 30,
          "z": -94.1873
        },
        {
          "hole": 78,
          "x": -118.5336,
          "y": 30,
          "z": -93.1746
        },
        {
          "hole": 79,
          "x": -124.5878,
          "y": 30,
          "z": -91.763
        },
        {
          "hole": 80,
          "x": -130.5367,
          "y": 30,
          "z": -89.9584
        },
        {
          "hole": 81,
          "x": -142.0174,
          "y": 30,
          "z": -85.2029
        },
        {
          "hole": 82,
          "x": -147.4999,
          "y": 30,
          "z": -82.2724
        },
        {
          "hole": 83,
          "x": -152.7791,
          "y": 30,
          "z": -78.9896
        },
        {
          "hole": 84,
          "x": -157.8323,
          "y": 30,
          "z": -75.3685
        },
        {
          "hole": 85,
          "x": -162.6378,
          "y": 30,
          "z": -71.4248
        },
        {
          "hole": 86,
          "x": -171.4248,
          "y": 30,
          "z": -62.6379
        },
        {
          "hole": 87,
          "x": -175.3686,
          "y": 30,
          "z": -57.8324
        },
        {
          "hole": 88,
          "x": -178.9896,
          "y": 30,
          "z": -52.7792
        },
        {
          "hole": 89,
          "x": -182.2724,
          "y": 30,
          "z": -47.5
        },
        {
          "hole": 90,
          "x": -185.2029,
          "y": 30,
          "z": -42.0174
        },
        {
          "hole": 91,
          "x": -189.9584,
          "y": 30,
          "z": -30.5368
        },
        {
          "hole": 92,
          "x": -191.763,
          "y": 30,
          "z": -24.5878
        },
        {
          "hole": 93,
          "x": -193.1746,
          "y": 30,
          "z": -18.5336
        },
        {
          "hole": 94,
          "x": -194.1873,
          "y": 30,
          "z": -12.4
        },
        {
          "hole": 95,
          "x": -194.7966,
          "y": 30,
          "z": -6.2133
        },
        {
          "hole": 96,
          "x": -194.7966,
          "y": 30,
          "z": 6.2133
        },
        {
          "hole": 97,
          "x": -194.1873,
          "y": 30,
          "z": 12.4
        },
        {
          "hole": 98,
          "x": -193.1746,
          "y": 30,
          "z": 18.5336
        },
        {
          "hole": 99,
          "x": -191.763,
          "y": 30,
          "z": 24.5878
        },
        {
          "hole": 100,
          "x": -189.9584,
          "y": 30,
          "z": 30.5367
        },
        {
          "hole": 101,
          "x": -185.2029,
          "y": 30,
          "z": 42.0174
        },
        {
          "hole": 102,
          "x": -182.2724,
          "y": 30,
          "z": 47.5
        },
        {
          "hole": 103,
          "x": -178.9896,
          "y": 30,
          "z": 52.7792
        },
        {
          "hole": 104,
          "x": -175.3685,
          "y": 30,
          "z": 57.8323
        },
        {
          "hole": 105,
          "x": -171.4248,
          "y": 30,
          "z": 62.6378
        },
        {
          "hole": 106,
          "x": -162.6379,
          "y": 30,
          "z": 71.4247
        },
        {
          "hole": 107,
          "x": -157.8323,
          "y": 30,
          "z": 75.3685
        },
        {
          "hole": 108,
          "x": -152.7792,
          "y": 30,
          "z": 78.9896
        },
        {
          "hole": 109,
          "x": -147.5,
          "y": 30,
          "z": 82.2724
        },
        {
          "hole": 110,
          "x": -142.0174,
          "y": 30,
          "z": 85.2029
        },
        {
          "hole": 111,
          "x": -130.5368,
          "y": 30,
          "z": 89.9584
        },
        {
          "hole": 112,
          "x": -124.5878,
          "y": 30,
          "z": 91.763
        },
        {
          "hole": 113,
          "x": -118.5336,
          "y": 30,
          "z": 93.1746
        },
        {
          "hole": 114,
          "x": -112.4,
          "y": 30,
          "z": 94.1873
        },
        {
          "hole": 115,
          "x": -106.2133,
          "y": 30,
          "z": 94.7966
        },
        {
          "hole": 116,
          "x": -95.5,
          "y": 30,
          "z": 95
        },
        {
          "hole": 117,
          "x": -87.75,
          "y": 30,
          "z": 95
        },
        {
          "hole": 118,
          "x": -80,
          "y": 30,
          "z": 95
        },
        {
          "hole": 119,
          "x": -72.25,
          "y": 30,
          "z": 95
        },
        {
          "hole": 120,
          "x": -64.5,
          "y": 30,
          "z": 95
        },
        {
          "hole": 121,
          "x": -40,
          "y": 40,
          "z": 100
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": 7,
          "y": 50,
          "z": 115
        },
        {
          "hole": 1,
          "x": 24.5,
          "y": 20,
          "z": 85
        },
        {
          "hole": 2,
          "x": 32.25,
          "y": 20,
          "z": 85
        },
        {
          "hole": 3,
          "x": 40,
          "y": 20,
          "z": 85
        },
        {
          "hole": 4,
          "x": 47.75,
          "y": 20,
          "z": 85
        },
        {
          "hole": 5,
          "x": 55.5,
          "y": 20,
          "z": 85
        },
        {
          "hole": 6,
          "x": 64.5,
          "y": 20,
          "z": 85
        },
        {
          "hole": 7,
          "x": 72.25,
          "y": 20,
          "z": 85
        },
        {
          "hole": 8,
          "x": 80,
          "y": 20,
          "z": 85
        },
        {
          "hole": 9,
          "x": 87.75,
          "y": 20,
          "z": 85
        },
        {
          "hole": 10,
          "x": 95.5,
          "y": 20,
          "z": 85
        },
        {
          "hole": 11,
          "x": 105.5593,
          "y": 20,
          "z": 84.818
        },
        {
          "hole": 12,
          "x": 111.0947,
          "y": 20,
          "z": 84.2728
        },
        {
          "hole": 13,
          "x": 116.5827,
          "y": 20,
          "z": 83.3668
        },
        {
          "hole": 14,
          "x": 121.9996,
          "y": 20,
          "z": 82.1037
        },
        {
          "hole": 15,
          "x": 127.3224,
          "y": 20,
          "z": 80.4891
        },
        {
          "hole": 16,
          "x": 137.5945,
          "y": 20,
          "z": 76.2342
        },
        {
          "hole": 17,
          "x": 142.5,
          "y": 20,
          "z": 73.6122
        },
        {
          "hole": 18,
          "x": 147.2235,
          "y": 20,
          "z": 70.6749
        },
        {
          "hole": 19,
          "x": 151.7447,
          "y": 20,
          "z": 67.435
        },
        {
          "hole": 20,
          "x": 156.0444,
          "y": 20,
          "z": 63.9064
        },
        {
          "hole": 21,
          "x": 163.9064,
          "y": 20,
          "z": 56.0444
        },
        {
          "hole": 22,
          "x": 167.435,
          "y": 20,
          "z": 51.7447
        },
        {
          "hole": 23,
          "x": 170.6749,
          "y": 20,
          "z": 47.2235
        },
        {
          "hole": 24,
          "x": 173.6122,
          "y": 20,
          "z": 42.5
        },
        {
          "hole": 25,
          "x": 176.2342,
          "y": 20,
          "z": 37.5945
        },
        {
          "hole": 26,
          "x": 180.4891,
          "y": 20,
          "z": 27.3223
        },
        {
          "hole": 27,
          "x": 182.1037,
          "y": 20,
          "z": 21.9996
        },
        {
          "hole": 28,
          "x": 183.3667,
          "y": 20,
          "z": 16.5827
        },
        {
          "hole": 29,
          "x": 184.2728,
          "y": 20,
          "z": 11.0947
        },
        {
          "hole": 30,
          "x": 184.818,
          "y": 20,
          "z": 5.5593
        },
        {
          "hole": 31,
          "x": 184.818,
          "y": 20,
          "z": -5.5593
        },
        {
          "hole": 32,
          "x": 184.2728,
          "y": 20,
          "z": -11.0947
        },
        {
          "hole": 33,
          "x": 183.3667,
          "y": 20,
          "z": -16.5827
        },
        {
          "hole": 34,
          "x": 182.1037,
          "y": 20,
          "z": -21.9996
        },
        {
          "hole": 35,
          "x": 180.489,
          "y": 20,
          "z": -27.3223
        },
        {
          "hole": 36,
          "x": 176.2341,
          "y": 20,
          "z": -37.5946
        },
        {
          "hole": 37,
          "x": 173.6121,
          "y": 20,
          "z": -42.5
        },
        {
          "hole": 38,
          "x": 170.6749,
          "y": 20,
          "z": -47.2235
        },
        {
          "hole": 39,
          "x": 167.435,
          "y": 20,
          "z": -51.7447
        },
        {
          "hole": 40,
          "x": 163.9063,
          "y": 20,
          "z": -56.0444
        },
        {
          "hole": 41,
          "x": 156.0444,
          "y": 20,
          "z": -63.9064
        },
        {
          "hole": 42,
          "x": 151.7447,
          "y": 20,
          "z": -67.4351
        },
        {
          "hole": 43,
          "x": 147.2235,
          "y": 20,
          "z": -70.6749
        },
        {
          "hole": 44,
          "x": 142.5,
          "y": 20,
          "z": -73.6122
        },
        {
          "hole": 45,
          "x": 137.5945,
          "y": 20,
          "z": -76.2342
        },
        {
          "hole": 46,
          "x": 127.3224,
          "y": 20,
          "z": -80.4891
        },
        {
          "hole": 47,
          "x": 121.9996,
          "y": 20,
          "z": -82.1037
        },
        {
          "hole": 48,
          "x": 116.5827,
          "y": 20,
          "z": -83.3668
        },
        {
          "hole": 49,
          "x": 111.0947,
          "y": 20,
          "z": -84.2728
        },
        {
          "hole": 50,
          "x": 105.5593,
          "y": 20,
          "z": -84.818
        },
        {
          "hole": 51,
          "x": 95.5,
          "y": 20,
          "z": -85
        },
        {
          "hole": 52,
          "x": 87.75,
          "y": 20,
          "z": -85
        },
        {
          "hole": 53,
          "x": 80,
          "y": 20,
          "z": -85
        },
        {
          "hole": 54,
          "x": 72.25,
          "y": 20,
          "z": -85
        },
        {
          "hole": 55,
          "x": 64.5,
          "y": 20,
          "z": -85
        },
        {
          "hole": 56,
          "x": 55.5,
          "y": 20,
          "z": -85
        },
        {
          "hole": 57,
          "x": 47.75,
          "y": 20,
          "z": -85
        },
        {
          "hole": 58,
          "x": 40,
          "y": 20,
          "z": -85
        },
        {
          "hole": 59,
          "x": 32.25,
          "y": 20,
          "z": -85
        },
        {
          "hole": 60,
          "x": 24.5,
          "y": 20,
          "z": -85
        },
        {
          "hole": 61,
          "x": 15.5,
          "y": 20,
          "z": -85
        },
        {
          "hole": 62,
          "x": 7.75,
          "y": 20,
          "z": -85
        },
        {
          "hole": 63,
          "x": 0,
          "y": 20,
          "z": -85
        },
        {
          "hole": 64,
          "x": -7.75,
          "y": 20,
          "z": -85
        },
        {
          "hole": 65,
          "x": -15.5,
          "y": 20,
          "z": -85
        },
        {
          "hole": 66,
          "x": -24.5,
          "y": 20,
          "z": -85
        },
        {
          "hole": 67,
          "x": -32.25,
          "y": 20,
          "z": -85
        },
        {
          "hole": 68,
          "x": -40,
          "y": 20,
          "z": -85
        },
        {
          "hole": 69,
          "x": -47.75,
          "y": 20,
          "z": -85
        },
        {
          "hole": 70,
          "x": -55.5,
          "y": 20,
          "z": -85
        },
        {
          "hole": 71,
          "x": -64.4999,
          "y": 20,
          "z": -85
        },
        {
          "hole": 72,
          "x": -72.2499,
          "y": 20,
          "z": -85
        },
        {
          "hole": 73,
          "x": -79.9999,
          "y": 20,
          "z": -85
        },
        {
          "hole": 74,
          "x": -87.7499,
          "y": 20,
          "z": -85
        },
        {
          "hole": 75,
          "x": -95.4999,
          "y": 20,
          "z": -85
        },
        {
          "hole": 76,
          "x": -105.5593,
          "y": 20,
          "z": -84.818
        },
        {
          "hole": 77,
          "x": -111.0947,
          "y": 20,
          "z": -84.2728
        },
        {
          "hole": 78,
          "x": -116.5827,
          "y": 20,
          "z": -83.3668
        },
        {
          "hole": 79,
          "x": -121.9996,
          "y": 20,
          "z": -82.1037
        },
        {
          "hole": 80,
          "x": -127.3223,
          "y": 20,
          "z": -80.4891
        },
        {
          "hole": 81,
          "x": -137.5945,
          "y": 20,
          "z": -76.2342
        },
        {
          "hole": 82,
          "x": -142.4999,
          "y": 20,
          "z": -73.6121
        },
        {
          "hole": 83,
          "x": -147.2234,
          "y": 20,
          "z": -70.6749
        },
        {
          "hole": 84,
          "x": -151.7447,
          "y": 20,
          "z": -67.435
        },
        {
          "hole": 85,
          "x": -156.0443,
          "y": 20,
          "z": -63.9064
        },
        {
          "hole": 86,
          "x": -163.9064,
          "y": 20,
          "z": -56.0444
        },
        {
          "hole": 87,
          "x": -167.435,
          "y": 20,
          "z": -51.7447
        },
        {
          "hole": 88,
          "x": -170.6749,
          "y": 20,
          "z": -47.2235
        },
        {
          "hole": 89,
          "x": -173.6122,
          "y": 20,
          "z": -42.5
        },
        {
          "hole": 90,
          "x": -176.2342,
          "y": 20,
          "z": -37.5946
        },
        {
          "hole": 91,
          "x": -180.4891,
          "y": 20,
          "z": -27.3224
        },
        {
          "hole": 92,
          "x": -182.1037,
          "y": 20,
          "z": -21.9996
        },
        {
          "hole": 93,
          "x": -183.3667,
          "y": 20,
          "z": -16.5827
        },
        {
          "hole": 94,
          "x": -184.2728,
          "y": 20,
          "z": -11.0947
        },
        {
          "hole": 95,
          "x": -184.818,
          "y": 20,
          "z": -5.5593
        },
        {
          "hole": 96,
          "x": -184.818,
          "y": 20,
          "z": 5.5593
        },
        {
          "hole": 97,
          "x": -184.2728,
          "y": 20,
          "z": 11.0947
        },
        {
          "hole": 98,
          "x": -183.3668,
          "y": 20,
          "z": 16.5827
        },
        {
          "hole": 99,
          "x": -182.1037,
          "y": 20,
          "z": 21.9996
        },
        {
          "hole": 100,
          "x": -180.4891,
          "y": 20,
          "z": 27.3223
        },
        {
          "hole": 101,
          "x": -176.2342,
          "y": 20,
          "z": 37.5945
        },
        {
          "hole": 102,
          "x": -173.6121,
          "y": 20,
          "z": 42.5
        },
        {
          "hole": 103,
          "x": -170.6749,
          "y": 20,
          "z": 47.2235
        },
        {
          "hole": 104,
          "x": -167.435,
          "y": 20,
          "z": 51.7447
        },
        {
          "hole": 105,
          "x": -163.9064,
          "y": 20,
          "z": 56.0444
        },
        {
          "hole": 106,
          "x": -156.0444,
          "y": 20,
          "z": 63.9063
        },
        {
          "hole": 107,
          "x": -151.7447,
          "y": 20,
          "z": 67.435
        },
        {
          "hole": 108,
          "x": -147.2235,
          "y": 20,
          "z": 70.6749
        },
        {
          "hole": 109,
          "x": -142.5,
          "y": 20,
          "z": 73.6121
        },
        {
          "hole": 110,
          "x": -137.5945,
          "y": 20,
          "z": 76.2341
        },
        {
          "hole": 111,
          "x": -127.3224,
          "y": 20,
          "z": 80.4891
        },
        {
          "hole": 112,
          "x": -121.9996,
          "y": 20,
          "z": 82.1037
        },
        {
          "hole": 113,
          "x": -116.5827,
          "y": 20,
          "z": 83.3667
        },
        {
          "hole": 114,
          "x": -111.0947,
          "y": 20,
          "z": 84.2728
        },
        {
          "hole": 115,
          "x": -105.5593,
          "y": 20,
          "z": 84.818
        },
        {
          "hole": 116,
          "x": -95.5,
          "y": 20,
          "z": 85
        },
        {
          "hole": 117,
          "x": -87.75,
          "y": 20,
          "z": 85
        },
        {
          "hole": 118,
          "x": -80,
          "y": 20,
          "z": 85
        },
        {
          "hole": 119,
          "x": -72.25,
          "y": 20,
          "z": 85
        },
        {
          "hole": 120,
          "x": -64.5,
          "y": 20,
          "z": 85
        },
        {
          "hole": 121,
          "x": -40,
          "y": 50,
          "z": 100
        }
      ]
    }
  },
  {
    "id": "board-hockey-rink",
    "name": "Hockey Rink",
    "brand": "crazy,pints,adult",
    "desc": "Hockey Rink Cribbage 3D cribbage board (8.8 MB)",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/hockey_rink_thumbnail.png?v=1792022321",
    "modelUrl": "https://cdn.shopify.com/3d/models/35db708682e15a0f/hockey_rink.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 30,
          "z": 82.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 6,
          "x": 90.0213,
          "y": 60,
          "z": 112.2538
        },
        {
          "hole": 7,
          "x": 97.5105,
          "y": 60,
          "z": 111.5162
        },
        {
          "hole": 8,
          "x": 104.9354,
          "y": 60,
          "z": 110.2903
        },
        {
          "hole": 9,
          "x": 112.2642,
          "y": 60,
          "z": 108.5815
        },
        {
          "hole": 10,
          "x": 119.4655,
          "y": 60,
          "z": 106.397
        },
        {
          "hole": 11,
          "x": 133.3631,
          "y": 60,
          "z": 100.6404
        },
        {
          "hole": 12,
          "x": 139.9999,
          "y": 60,
          "z": 97.0929
        },
        {
          "hole": 13,
          "x": 146.3905,
          "y": 60,
          "z": 93.119
        },
        {
          "hole": 14,
          "x": 152.5075,
          "y": 60,
          "z": 88.7356
        },
        {
          "hole": 15,
          "x": 158.3247,
          "y": 60,
          "z": 83.9616
        },
        {
          "hole": 16,
          "x": 168.9614,
          "y": 60,
          "z": 73.3247
        },
        {
          "hole": 17,
          "x": 173.7355,
          "y": 60,
          "z": 67.5075
        },
        {
          "hole": 18,
          "x": 178.1189,
          "y": 60,
          "z": 61.3905
        },
        {
          "hole": 19,
          "x": 182.0928,
          "y": 60,
          "z": 55
        },
        {
          "hole": 20,
          "x": 185.6402,
          "y": 60,
          "z": 48.3632
        },
        {
          "hole": 21,
          "x": 191.397,
          "y": 60,
          "z": 34.4655
        },
        {
          "hole": 22,
          "x": 193.5815,
          "y": 60,
          "z": 27.2642
        },
        {
          "hole": 23,
          "x": 195.2903,
          "y": 60,
          "z": 19.9354
        },
        {
          "hole": 24,
          "x": 196.5162,
          "y": 60,
          "z": 12.5105
        },
        {
          "hole": 25,
          "x": 197.2538,
          "y": 60,
          "z": 5.0214
        },
        {
          "hole": 26,
          "x": 197.2538,
          "y": 60,
          "z": -10.0214
        },
        {
          "hole": 27,
          "x": 196.5162,
          "y": 60,
          "z": -17.5105
        },
        {
          "hole": 28,
          "x": 195.2903,
          "y": 60,
          "z": -24.9354
        },
        {
          "hole": 29,
          "x": 193.5815,
          "y": 60,
          "z": -32.2642
        },
        {
          "hole": 30,
          "x": 191.397,
          "y": 60,
          "z": -39.4655
        },
        {
          "hole": 31,
          "x": 185.6403,
          "y": 60,
          "z": -53.3632
        },
        {
          "hole": 32,
          "x": 182.0929,
          "y": 60,
          "z": -60
        },
        {
          "hole": 33,
          "x": 178.119,
          "y": 60,
          "z": -66.3906
        },
        {
          "hole": 34,
          "x": 173.7356,
          "y": 60,
          "z": -72.5076
        },
        {
          "hole": 35,
          "x": 168.9615,
          "y": 60,
          "z": -78.3248
        },
        {
          "hole": 36,
          "x": 158.3247,
          "y": 60,
          "z": -88.9616
        },
        {
          "hole": 37,
          "x": 152.5075,
          "y": 60,
          "z": -93.7356
        },
        {
          "hole": 38,
          "x": 146.3905,
          "y": 60,
          "z": -98.119
        },
        {
          "hole": 39,
          "x": 140,
          "y": 60,
          "z": -102.0929
        },
        {
          "hole": 40,
          "x": 133.3632,
          "y": 60,
          "z": -105.6404
        },
        {
          "hole": 41,
          "x": 119.4655,
          "y": 60,
          "z": -111.397
        },
        {
          "hole": 42,
          "x": 112.2642,
          "y": 60,
          "z": -113.5815
        },
        {
          "hole": 43,
          "x": 104.9354,
          "y": 60,
          "z": -115.2903
        },
        {
          "hole": 44,
          "x": 97.5105,
          "y": 60,
          "z": -116.5162
        },
        {
          "hole": 45,
          "x": 90.0214,
          "y": 60,
          "z": -117.2538
        },
        {
          "hole": 46,
          "x": 78,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 71,
          "x": -125.0214,
          "y": 60,
          "z": -117.2538
        },
        {
          "hole": 72,
          "x": -132.5105,
          "y": 60,
          "z": -116.5161
        },
        {
          "hole": 73,
          "x": -139.9354,
          "y": 60,
          "z": -115.2903
        },
        {
          "hole": 74,
          "x": -147.2642,
          "y": 60,
          "z": -113.5815
        },
        {
          "hole": 75,
          "x": -154.4655,
          "y": 60,
          "z": -111.3969
        },
        {
          "hole": 76,
          "x": -168.3632,
          "y": 60,
          "z": -105.6403
        },
        {
          "hole": 77,
          "x": -175,
          "y": 60,
          "z": -102.0929
        },
        {
          "hole": 78,
          "x": -181.3906,
          "y": 60,
          "z": -98.119
        },
        {
          "hole": 79,
          "x": -187.5075,
          "y": 60,
          "z": -93.7356
        },
        {
          "hole": 80,
          "x": -193.3247,
          "y": 60,
          "z": -88.9616
        },
        {
          "hole": 81,
          "x": -203.9616,
          "y": 60,
          "z": -78.3248
        },
        {
          "hole": 82,
          "x": -208.7356,
          "y": 60,
          "z": -72.5076
        },
        {
          "hole": 83,
          "x": -213.119,
          "y": 60,
          "z": -66.3906
        },
        {
          "hole": 84,
          "x": -217.0929,
          "y": 60,
          "z": -60
        },
        {
          "hole": 85,
          "x": -220.6404,
          "y": 60,
          "z": -53.3632
        },
        {
          "hole": 86,
          "x": -226.397,
          "y": 60,
          "z": -39.4655
        },
        {
          "hole": 87,
          "x": -228.5815,
          "y": 60,
          "z": -32.2642
        },
        {
          "hole": 88,
          "x": -230.2903,
          "y": 60,
          "z": -24.9354
        },
        {
          "hole": 89,
          "x": -231.5162,
          "y": 60,
          "z": -17.5105
        },
        {
          "hole": 90,
          "x": -232.2538,
          "y": 60,
          "z": -10.0214
        },
        {
          "hole": 91,
          "x": -232.2538,
          "y": 60,
          "z": 5.0214
        },
        {
          "hole": 92,
          "x": -231.5162,
          "y": 60,
          "z": 12.5105
        },
        {
          "hole": 93,
          "x": -230.2903,
          "y": 60,
          "z": 19.9354
        },
        {
          "hole": 94,
          "x": -228.5815,
          "y": 60,
          "z": 27.2642
        },
        {
          "hole": 95,
          "x": -226.397,
          "y": 60,
          "z": 34.4655
        },
        {
          "hole": 96,
          "x": -220.6404,
          "y": 60,
          "z": 48.3633
        },
        {
          "hole": 97,
          "x": -217.0929,
          "y": 60,
          "z": 55.0001
        },
        {
          "hole": 98,
          "x": -213.119,
          "y": 60,
          "z": 61.3906
        },
        {
          "hole": 99,
          "x": -208.7356,
          "y": 60,
          "z": 67.5076
        },
        {
          "hole": 100,
          "x": -203.9616,
          "y": 60,
          "z": 73.3248
        },
        {
          "hole": 101,
          "x": -193.3248,
          "y": 60,
          "z": 83.9616
        },
        {
          "hole": 102,
          "x": -187.5076,
          "y": 60,
          "z": 88.7357
        },
        {
          "hole": 103,
          "x": -181.3906,
          "y": 60,
          "z": 93.119
        },
        {
          "hole": 104,
          "x": -175,
          "y": 60,
          "z": 97.0929
        },
        {
          "hole": 105,
          "x": -168.3632,
          "y": 60,
          "z": 100.6404
        },
        {
          "hole": 106,
          "x": -154.4655,
          "y": 60,
          "z": 106.397
        },
        {
          "hole": 107,
          "x": -147.2642,
          "y": 60,
          "z": 108.5815
        },
        {
          "hole": 108,
          "x": -139.9354,
          "y": 60,
          "z": 110.2903
        },
        {
          "hole": 109,
          "x": -132.5105,
          "y": 60,
          "z": 111.5162
        },
        {
          "hole": 110,
          "x": -125.0214,
          "y": 60,
          "z": 112.2538
        },
        {
          "hole": 111,
          "x": -113,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 60,
          "z": 112.5
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 40,
          "z": 92.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 6,
          "x": 89.3673,
          "y": 50,
          "z": 102.2752
        },
        {
          "hole": 7,
          "x": 96.2052,
          "y": 50,
          "z": 101.6017
        },
        {
          "hole": 8,
          "x": 102.9845,
          "y": 50,
          "z": 100.4825
        },
        {
          "hole": 9,
          "x": 109.676,
          "y": 50,
          "z": 98.9222
        },
        {
          "hole": 10,
          "x": 116.2511,
          "y": 50,
          "z": 96.9277
        },
        {
          "hole": 11,
          "x": 128.9403,
          "y": 50,
          "z": 91.6716
        },
        {
          "hole": 12,
          "x": 134.9999,
          "y": 50,
          "z": 88.4327
        },
        {
          "hole": 13,
          "x": 140.8348,
          "y": 50,
          "z": 84.8043
        },
        {
          "hole": 14,
          "x": 146.4199,
          "y": 50,
          "z": 80.8021
        },
        {
          "hole": 15,
          "x": 151.7313,
          "y": 50,
          "z": 76.4432
        },
        {
          "hole": 16,
          "x": 161.443,
          "y": 50,
          "z": 66.7313
        },
        {
          "hole": 17,
          "x": 165.802,
          "y": 50,
          "z": 61.4199
        },
        {
          "hole": 18,
          "x": 169.8042,
          "y": 50,
          "z": 55.8348
        },
        {
          "hole": 19,
          "x": 173.4325,
          "y": 50,
          "z": 50
        },
        {
          "hole": 20,
          "x": 176.6715,
          "y": 50,
          "z": 43.9403
        },
        {
          "hole": 21,
          "x": 181.9277,
          "y": 50,
          "z": 31.2512
        },
        {
          "hole": 22,
          "x": 183.9222,
          "y": 50,
          "z": 24.676
        },
        {
          "hole": 23,
          "x": 185.4825,
          "y": 50,
          "z": 17.9845
        },
        {
          "hole": 24,
          "x": 186.6017,
          "y": 50,
          "z": 11.2053
        },
        {
          "hole": 25,
          "x": 187.2752,
          "y": 50,
          "z": 4.3673
        },
        {
          "hole": 26,
          "x": 187.2752,
          "y": 50,
          "z": -9.3673
        },
        {
          "hole": 27,
          "x": 186.6017,
          "y": 50,
          "z": -16.2052
        },
        {
          "hole": 28,
          "x": 185.4825,
          "y": 50,
          "z": -22.9845
        },
        {
          "hole": 29,
          "x": 183.9222,
          "y": 50,
          "z": -29.676
        },
        {
          "hole": 30,
          "x": 181.9277,
          "y": 50,
          "z": -36.2511
        },
        {
          "hole": 31,
          "x": 176.6716,
          "y": 50,
          "z": -48.9403
        },
        {
          "hole": 32,
          "x": 173.4326,
          "y": 50,
          "z": -55
        },
        {
          "hole": 33,
          "x": 169.8043,
          "y": 50,
          "z": -60.8349
        },
        {
          "hole": 34,
          "x": 165.8021,
          "y": 50,
          "z": -66.4199
        },
        {
          "hole": 35,
          "x": 161.4431,
          "y": 50,
          "z": -71.7313
        },
        {
          "hole": 36,
          "x": 151.7313,
          "y": 50,
          "z": -81.4432
        },
        {
          "hole": 37,
          "x": 146.4199,
          "y": 50,
          "z": -85.8021
        },
        {
          "hole": 38,
          "x": 140.8348,
          "y": 50,
          "z": -89.8043
        },
        {
          "hole": 39,
          "x": 135,
          "y": 50,
          "z": -93.4327
        },
        {
          "hole": 40,
          "x": 128.9403,
          "y": 50,
          "z": -96.6716
        },
        {
          "hole": 41,
          "x": 116.2511,
          "y": 50,
          "z": -101.9277
        },
        {
          "hole": 42,
          "x": 109.676,
          "y": 50,
          "z": -103.9222
        },
        {
          "hole": 43,
          "x": 102.9845,
          "y": 50,
          "z": -105.4825
        },
        {
          "hole": 44,
          "x": 96.2053,
          "y": 50,
          "z": -106.6017
        },
        {
          "hole": 45,
          "x": 89.3673,
          "y": 50,
          "z": -107.2752
        },
        {
          "hole": 46,
          "x": 78,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 71,
          "x": -124.3673,
          "y": 50,
          "z": -107.2752
        },
        {
          "hole": 72,
          "x": -131.2052,
          "y": 50,
          "z": -106.6017
        },
        {
          "hole": 73,
          "x": -137.9845,
          "y": 50,
          "z": -105.4824
        },
        {
          "hole": 74,
          "x": -144.676,
          "y": 50,
          "z": -103.9222
        },
        {
          "hole": 75,
          "x": -151.2511,
          "y": 50,
          "z": -101.9276
        },
        {
          "hole": 76,
          "x": -163.9403,
          "y": 50,
          "z": -96.6716
        },
        {
          "hole": 77,
          "x": -170,
          "y": 50,
          "z": -93.4326
        },
        {
          "hole": 78,
          "x": -175.8349,
          "y": 50,
          "z": -89.8043
        },
        {
          "hole": 79,
          "x": -181.4199,
          "y": 50,
          "z": -85.8021
        },
        {
          "hole": 80,
          "x": -186.7313,
          "y": 50,
          "z": -81.4432
        },
        {
          "hole": 81,
          "x": -196.4432,
          "y": 50,
          "z": -71.7313
        },
        {
          "hole": 82,
          "x": -200.8021,
          "y": 50,
          "z": -66.42
        },
        {
          "hole": 83,
          "x": -204.8043,
          "y": 50,
          "z": -60.8349
        },
        {
          "hole": 84,
          "x": -208.4327,
          "y": 50,
          "z": -55
        },
        {
          "hole": 85,
          "x": -211.6716,
          "y": 50,
          "z": -48.9403
        },
        {
          "hole": 86,
          "x": -216.9277,
          "y": 50,
          "z": -36.2511
        },
        {
          "hole": 87,
          "x": -218.9222,
          "y": 50,
          "z": -29.676
        },
        {
          "hole": 88,
          "x": -220.4825,
          "y": 50,
          "z": -22.9845
        },
        {
          "hole": 89,
          "x": -221.6017,
          "y": 50,
          "z": -16.2053
        },
        {
          "hole": 90,
          "x": -222.2752,
          "y": 50,
          "z": -9.3673
        },
        {
          "hole": 91,
          "x": -222.2752,
          "y": 50,
          "z": 4.3673
        },
        {
          "hole": 92,
          "x": -221.6017,
          "y": 50,
          "z": 11.2053
        },
        {
          "hole": 93,
          "x": -220.4825,
          "y": 50,
          "z": 17.9845
        },
        {
          "hole": 94,
          "x": -218.9222,
          "y": 50,
          "z": 24.676
        },
        {
          "hole": 95,
          "x": -216.9277,
          "y": 50,
          "z": 31.2512
        },
        {
          "hole": 96,
          "x": -211.6716,
          "y": 50,
          "z": 43.9404
        },
        {
          "hole": 97,
          "x": -208.4327,
          "y": 50,
          "z": 50.0001
        },
        {
          "hole": 98,
          "x": -204.8043,
          "y": 50,
          "z": 55.8349
        },
        {
          "hole": 99,
          "x": -200.8021,
          "y": 50,
          "z": 61.42
        },
        {
          "hole": 100,
          "x": -196.4432,
          "y": 50,
          "z": 66.7314
        },
        {
          "hole": 101,
          "x": -186.7313,
          "y": 50,
          "z": 76.4432
        },
        {
          "hole": 102,
          "x": -181.4199,
          "y": 50,
          "z": 80.8021
        },
        {
          "hole": 103,
          "x": -175.8349,
          "y": 50,
          "z": 84.8043
        },
        {
          "hole": 104,
          "x": -170,
          "y": 50,
          "z": 88.4327
        },
        {
          "hole": 105,
          "x": -163.9403,
          "y": 50,
          "z": 91.6717
        },
        {
          "hole": 106,
          "x": -151.2511,
          "y": 50,
          "z": 96.9277
        },
        {
          "hole": 107,
          "x": -144.676,
          "y": 50,
          "z": 98.9222
        },
        {
          "hole": 108,
          "x": -137.9845,
          "y": 50,
          "z": 100.4825
        },
        {
          "hole": 109,
          "x": -131.2053,
          "y": 50,
          "z": 101.6017
        },
        {
          "hole": 110,
          "x": -124.3673,
          "y": 50,
          "z": 102.2752
        },
        {
          "hole": 111,
          "x": -113,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 50,
          "z": 102.5
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 50,
          "z": 102.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 6,
          "x": 88.7133,
          "y": 40,
          "z": 92.2966
        },
        {
          "hole": 7,
          "x": 94.9,
          "y": 40,
          "z": 91.6873
        },
        {
          "hole": 8,
          "x": 101.0336,
          "y": 40,
          "z": 90.6746
        },
        {
          "hole": 9,
          "x": 107.0878,
          "y": 40,
          "z": 89.263
        },
        {
          "hole": 10,
          "x": 113.0367,
          "y": 40,
          "z": 87.4584
        },
        {
          "hole": 11,
          "x": 124.5174,
          "y": 40,
          "z": 82.7029
        },
        {
          "hole": 12,
          "x": 129.9999,
          "y": 40,
          "z": 79.7724
        },
        {
          "hole": 13,
          "x": 135.2791,
          "y": 40,
          "z": 76.4896
        },
        {
          "hole": 14,
          "x": 140.3323,
          "y": 40,
          "z": 72.8686
        },
        {
          "hole": 15,
          "x": 145.1378,
          "y": 40,
          "z": 68.9248
        },
        {
          "hole": 16,
          "x": 153.9246,
          "y": 40,
          "z": 60.1378
        },
        {
          "hole": 17,
          "x": 157.8684,
          "y": 40,
          "z": 55.3323
        },
        {
          "hole": 18,
          "x": 161.4895,
          "y": 40,
          "z": 50.2791
        },
        {
          "hole": 19,
          "x": 164.7723,
          "y": 40,
          "z": 45
        },
        {
          "hole": 20,
          "x": 167.7028,
          "y": 40,
          "z": 39.5174
        },
        {
          "hole": 21,
          "x": 172.4584,
          "y": 40,
          "z": 28.0368
        },
        {
          "hole": 22,
          "x": 174.263,
          "y": 40,
          "z": 22.0878
        },
        {
          "hole": 23,
          "x": 175.6746,
          "y": 40,
          "z": 16.0336
        },
        {
          "hole": 24,
          "x": 176.6873,
          "y": 40,
          "z": 9.9
        },
        {
          "hole": 25,
          "x": 177.2966,
          "y": 40,
          "z": 3.7133
        },
        {
          "hole": 26,
          "x": 177.2966,
          "y": 40,
          "z": -8.7133
        },
        {
          "hole": 27,
          "x": 176.6873,
          "y": 40,
          "z": -14.9
        },
        {
          "hole": 28,
          "x": 175.6746,
          "y": 40,
          "z": -21.0336
        },
        {
          "hole": 29,
          "x": 174.263,
          "y": 40,
          "z": -27.0878
        },
        {
          "hole": 30,
          "x": 172.4584,
          "y": 40,
          "z": -33.0367
        },
        {
          "hole": 31,
          "x": 167.7029,
          "y": 40,
          "z": -44.5174
        },
        {
          "hole": 32,
          "x": 164.7724,
          "y": 40,
          "z": -50
        },
        {
          "hole": 33,
          "x": 161.4896,
          "y": 40,
          "z": -55.2792
        },
        {
          "hole": 34,
          "x": 157.8685,
          "y": 40,
          "z": -60.3323
        },
        {
          "hole": 35,
          "x": 153.9247,
          "y": 40,
          "z": -65.1378
        },
        {
          "hole": 36,
          "x": 145.1378,
          "y": 40,
          "z": -73.9248
        },
        {
          "hole": 37,
          "x": 140.3323,
          "y": 40,
          "z": -77.8686
        },
        {
          "hole": 38,
          "x": 135.2791,
          "y": 40,
          "z": -81.4896
        },
        {
          "hole": 39,
          "x": 130,
          "y": 40,
          "z": -84.7724
        },
        {
          "hole": 40,
          "x": 124.5174,
          "y": 40,
          "z": -87.7029
        },
        {
          "hole": 41,
          "x": 113.0367,
          "y": 40,
          "z": -92.4584
        },
        {
          "hole": 42,
          "x": 107.0878,
          "y": 40,
          "z": -94.263
        },
        {
          "hole": 43,
          "x": 101.0336,
          "y": 40,
          "z": -95.6746
        },
        {
          "hole": 44,
          "x": 94.9,
          "y": 40,
          "z": -96.6873
        },
        {
          "hole": 45,
          "x": 88.7133,
          "y": 40,
          "z": -97.2966
        },
        {
          "hole": 46,
          "x": 78,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 71,
          "x": -123.7133,
          "y": 40,
          "z": -97.2966
        },
        {
          "hole": 72,
          "x": -129.9,
          "y": 40,
          "z": -96.6872
        },
        {
          "hole": 73,
          "x": -136.0336,
          "y": 40,
          "z": -95.6746
        },
        {
          "hole": 74,
          "x": -142.0878,
          "y": 40,
          "z": -94.2629
        },
        {
          "hole": 75,
          "x": -148.0367,
          "y": 40,
          "z": -92.4583
        },
        {
          "hole": 76,
          "x": -159.5174,
          "y": 40,
          "z": -87.7029
        },
        {
          "hole": 77,
          "x": -165,
          "y": 40,
          "z": -84.7724
        },
        {
          "hole": 78,
          "x": -170.2792,
          "y": 40,
          "z": -81.4896
        },
        {
          "hole": 79,
          "x": -175.3323,
          "y": 40,
          "z": -77.8685
        },
        {
          "hole": 80,
          "x": -180.1378,
          "y": 40,
          "z": -73.9248
        },
        {
          "hole": 81,
          "x": -188.9248,
          "y": 40,
          "z": -65.1379
        },
        {
          "hole": 82,
          "x": -192.8686,
          "y": 40,
          "z": -60.3323
        },
        {
          "hole": 83,
          "x": -196.4896,
          "y": 40,
          "z": -55.2792
        },
        {
          "hole": 84,
          "x": -199.7724,
          "y": 40,
          "z": -50
        },
        {
          "hole": 85,
          "x": -202.7029,
          "y": 40,
          "z": -44.5174
        },
        {
          "hole": 86,
          "x": -207.4584,
          "y": 40,
          "z": -33.0367
        },
        {
          "hole": 87,
          "x": -209.263,
          "y": 40,
          "z": -27.0878
        },
        {
          "hole": 88,
          "x": -210.6746,
          "y": 40,
          "z": -21.0336
        },
        {
          "hole": 89,
          "x": -211.6873,
          "y": 40,
          "z": -14.9
        },
        {
          "hole": 90,
          "x": -212.2966,
          "y": 40,
          "z": -8.7133
        },
        {
          "hole": 91,
          "x": -212.2966,
          "y": 40,
          "z": 3.7133
        },
        {
          "hole": 92,
          "x": -211.6873,
          "y": 40,
          "z": 9.9
        },
        {
          "hole": 93,
          "x": -210.6746,
          "y": 40,
          "z": 16.0336
        },
        {
          "hole": 94,
          "x": -209.263,
          "y": 40,
          "z": 22.0878
        },
        {
          "hole": 95,
          "x": -207.4584,
          "y": 40,
          "z": 28.0368
        },
        {
          "hole": 96,
          "x": -202.7029,
          "y": 40,
          "z": 39.5175
        },
        {
          "hole": 97,
          "x": -199.7724,
          "y": 40,
          "z": 45.0001
        },
        {
          "hole": 98,
          "x": -196.4896,
          "y": 40,
          "z": 50.2792
        },
        {
          "hole": 99,
          "x": -192.8686,
          "y": 40,
          "z": 55.3324
        },
        {
          "hole": 100,
          "x": -188.9248,
          "y": 40,
          "z": 60.1379
        },
        {
          "hole": 101,
          "x": -180.1378,
          "y": 40,
          "z": 68.9248
        },
        {
          "hole": 102,
          "x": -175.3323,
          "y": 40,
          "z": 72.8686
        },
        {
          "hole": 103,
          "x": -170.2792,
          "y": 40,
          "z": 76.4896
        },
        {
          "hole": 104,
          "x": -165,
          "y": 40,
          "z": 79.7724
        },
        {
          "hole": 105,
          "x": -159.5174,
          "y": 40,
          "z": 82.7029
        },
        {
          "hole": 106,
          "x": -148.0367,
          "y": 40,
          "z": 87.4584
        },
        {
          "hole": 107,
          "x": -142.0878,
          "y": 40,
          "z": 89.263
        },
        {
          "hole": 108,
          "x": -136.0336,
          "y": 40,
          "z": 90.6746
        },
        {
          "hole": 109,
          "x": -129.9,
          "y": 40,
          "z": 91.6873
        },
        {
          "hole": 110,
          "x": -123.7133,
          "y": 40,
          "z": 92.2966
        },
        {
          "hole": 111,
          "x": -113,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 40,
          "z": 92.5
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 60,
          "z": 112.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 6,
          "x": 88.0592,
          "y": 30,
          "z": 82.318
        },
        {
          "hole": 7,
          "x": 93.5947,
          "y": 30,
          "z": 81.7728
        },
        {
          "hole": 8,
          "x": 99.0827,
          "y": 30,
          "z": 80.8668
        },
        {
          "hole": 9,
          "x": 104.4996,
          "y": 30,
          "z": 79.6037
        },
        {
          "hole": 10,
          "x": 109.8223,
          "y": 30,
          "z": 77.9891
        },
        {
          "hole": 11,
          "x": 120.0945,
          "y": 30,
          "z": 73.7342
        },
        {
          "hole": 12,
          "x": 124.9999,
          "y": 30,
          "z": 71.1121
        },
        {
          "hole": 13,
          "x": 129.7234,
          "y": 30,
          "z": 68.1749
        },
        {
          "hole": 14,
          "x": 134.2447,
          "y": 30,
          "z": 64.935
        },
        {
          "hole": 15,
          "x": 138.5443,
          "y": 30,
          "z": 61.4064
        },
        {
          "hole": 16,
          "x": 146.4063,
          "y": 30,
          "z": 53.5444
        },
        {
          "hole": 17,
          "x": 149.9349,
          "y": 30,
          "z": 49.2447
        },
        {
          "hole": 18,
          "x": 153.1748,
          "y": 30,
          "z": 44.7234
        },
        {
          "hole": 19,
          "x": 156.112,
          "y": 30,
          "z": 40
        },
        {
          "hole": 20,
          "x": 158.7341,
          "y": 30,
          "z": 35.0945
        },
        {
          "hole": 21,
          "x": 162.9891,
          "y": 30,
          "z": 24.8224
        },
        {
          "hole": 22,
          "x": 164.6037,
          "y": 30,
          "z": 19.4996
        },
        {
          "hole": 23,
          "x": 165.8668,
          "y": 30,
          "z": 14.0827
        },
        {
          "hole": 24,
          "x": 166.7728,
          "y": 30,
          "z": 8.5947
        },
        {
          "hole": 25,
          "x": 167.318,
          "y": 30,
          "z": 3.0593
        },
        {
          "hole": 26,
          "x": 167.318,
          "y": 30,
          "z": -8.0593
        },
        {
          "hole": 27,
          "x": 166.7728,
          "y": 30,
          "z": -13.5947
        },
        {
          "hole": 28,
          "x": 165.8668,
          "y": 30,
          "z": -19.0827
        },
        {
          "hole": 29,
          "x": 164.6037,
          "y": 30,
          "z": -24.4996
        },
        {
          "hole": 30,
          "x": 162.9891,
          "y": 30,
          "z": -29.8224
        },
        {
          "hole": 31,
          "x": 158.7341,
          "y": 30,
          "z": -40.0945
        },
        {
          "hole": 32,
          "x": 156.1121,
          "y": 30,
          "z": -45
        },
        {
          "hole": 33,
          "x": 153.1749,
          "y": 30,
          "z": -49.7235
        },
        {
          "hole": 34,
          "x": 149.935,
          "y": 30,
          "z": -54.2447
        },
        {
          "hole": 35,
          "x": 146.4063,
          "y": 30,
          "z": -58.5444
        },
        {
          "hole": 36,
          "x": 138.5444,
          "y": 30,
          "z": -66.4064
        },
        {
          "hole": 37,
          "x": 134.2447,
          "y": 30,
          "z": -69.935
        },
        {
          "hole": 38,
          "x": 129.7234,
          "y": 30,
          "z": -73.1749
        },
        {
          "hole": 39,
          "x": 125,
          "y": 30,
          "z": -76.1122
        },
        {
          "hole": 40,
          "x": 120.0945,
          "y": 30,
          "z": -78.7342
        },
        {
          "hole": 41,
          "x": 109.8224,
          "y": 30,
          "z": -82.9891
        },
        {
          "hole": 42,
          "x": 104.4996,
          "y": 30,
          "z": -84.6037
        },
        {
          "hole": 43,
          "x": 99.0827,
          "y": 30,
          "z": -85.8667
        },
        {
          "hole": 44,
          "x": 93.5947,
          "y": 30,
          "z": -86.7728
        },
        {
          "hole": 45,
          "x": 88.0593,
          "y": 30,
          "z": -87.318
        },
        {
          "hole": 46,
          "x": 78,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 71,
          "x": -123.0593,
          "y": 30,
          "z": -87.318
        },
        {
          "hole": 72,
          "x": -128.5947,
          "y": 30,
          "z": -86.7728
        },
        {
          "hole": 73,
          "x": -134.0827,
          "y": 30,
          "z": -85.8667
        },
        {
          "hole": 74,
          "x": -139.4996,
          "y": 30,
          "z": -84.6037
        },
        {
          "hole": 75,
          "x": -144.8223,
          "y": 30,
          "z": -82.989
        },
        {
          "hole": 76,
          "x": -155.0945,
          "y": 30,
          "z": -78.7342
        },
        {
          "hole": 77,
          "x": -160,
          "y": 30,
          "z": -76.1121
        },
        {
          "hole": 78,
          "x": -164.7234,
          "y": 30,
          "z": -73.1749
        },
        {
          "hole": 79,
          "x": -169.2447,
          "y": 30,
          "z": -69.935
        },
        {
          "hole": 80,
          "x": -173.5444,
          "y": 30,
          "z": -66.4064
        },
        {
          "hole": 81,
          "x": -181.4064,
          "y": 30,
          "z": -58.5444
        },
        {
          "hole": 82,
          "x": -184.935,
          "y": 30,
          "z": -54.2447
        },
        {
          "hole": 83,
          "x": -188.1749,
          "y": 30,
          "z": -49.7235
        },
        {
          "hole": 84,
          "x": -191.1122,
          "y": 30,
          "z": -45
        },
        {
          "hole": 85,
          "x": -193.7342,
          "y": 30,
          "z": -40.0945
        },
        {
          "hole": 86,
          "x": -197.9891,
          "y": 30,
          "z": -29.8224
        },
        {
          "hole": 87,
          "x": -199.6037,
          "y": 30,
          "z": -24.4996
        },
        {
          "hole": 88,
          "x": -200.8668,
          "y": 30,
          "z": -19.0827
        },
        {
          "hole": 89,
          "x": -201.7728,
          "y": 30,
          "z": -13.5947
        },
        {
          "hole": 90,
          "x": -202.318,
          "y": 30,
          "z": -8.0593
        },
        {
          "hole": 91,
          "x": -202.318,
          "y": 30,
          "z": 3.0593
        },
        {
          "hole": 92,
          "x": -201.7728,
          "y": 30,
          "z": 8.5947
        },
        {
          "hole": 93,
          "x": -200.8668,
          "y": 30,
          "z": 14.0827
        },
        {
          "hole": 94,
          "x": -199.6037,
          "y": 30,
          "z": 19.4996
        },
        {
          "hole": 95,
          "x": -197.9891,
          "y": 30,
          "z": 24.8224
        },
        {
          "hole": 96,
          "x": -193.7342,
          "y": 30,
          "z": 35.0946
        },
        {
          "hole": 97,
          "x": -191.1122,
          "y": 30,
          "z": 40.0001
        },
        {
          "hole": 98,
          "x": -188.1749,
          "y": 30,
          "z": 44.7235
        },
        {
          "hole": 99,
          "x": -184.935,
          "y": 30,
          "z": 49.2448
        },
        {
          "hole": 100,
          "x": -181.4064,
          "y": 30,
          "z": 53.5444
        },
        {
          "hole": 101,
          "x": -173.5444,
          "y": 30,
          "z": 61.4064
        },
        {
          "hole": 102,
          "x": -169.2447,
          "y": 30,
          "z": 64.9351
        },
        {
          "hole": 103,
          "x": -164.7235,
          "y": 30,
          "z": 68.1749
        },
        {
          "hole": 104,
          "x": -160,
          "y": 30,
          "z": 71.1122
        },
        {
          "hole": 105,
          "x": -155.0945,
          "y": 30,
          "z": 73.7342
        },
        {
          "hole": 106,
          "x": -144.8224,
          "y": 30,
          "z": 77.9891
        },
        {
          "hole": 107,
          "x": -139.4996,
          "y": 30,
          "z": 79.6037
        },
        {
          "hole": 108,
          "x": -134.0827,
          "y": 30,
          "z": 80.8667
        },
        {
          "hole": 109,
          "x": -128.5947,
          "y": 30,
          "z": 81.7728
        },
        {
          "hole": 110,
          "x": -123.0593,
          "y": 30,
          "z": 82.318
        },
        {
          "hole": 111,
          "x": -113,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 30,
          "z": 82.5
        }
      ]
    }
  },
  {
    "id": "board-soccer-field",
    "name": "Soccer Field",
    "brand": "crazy,pints,adult",
    "desc": "Soccer Field Cribbage 3D cribbage board (8.8 MB)",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/soccer-field-crazy-thumbnail.png?v=1792021029",
    "modelUrl": "https://cdn.shopify.com/3d/models/ec653d35f4b4eac7/soccer_field.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 30,
          "z": 82.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 6,
          "x": 90.0213,
          "y": 60,
          "z": 112.2538
        },
        {
          "hole": 7,
          "x": 97.5105,
          "y": 60,
          "z": 111.5162
        },
        {
          "hole": 8,
          "x": 104.9354,
          "y": 60,
          "z": 110.2903
        },
        {
          "hole": 9,
          "x": 112.2642,
          "y": 60,
          "z": 108.5815
        },
        {
          "hole": 10,
          "x": 119.4655,
          "y": 60,
          "z": 106.397
        },
        {
          "hole": 11,
          "x": 133.3631,
          "y": 60,
          "z": 100.6404
        },
        {
          "hole": 12,
          "x": 139.9999,
          "y": 60,
          "z": 97.0929
        },
        {
          "hole": 13,
          "x": 146.3905,
          "y": 60,
          "z": 93.119
        },
        {
          "hole": 14,
          "x": 152.5075,
          "y": 60,
          "z": 88.7356
        },
        {
          "hole": 15,
          "x": 158.3247,
          "y": 60,
          "z": 83.9616
        },
        {
          "hole": 16,
          "x": 168.9614,
          "y": 60,
          "z": 73.3247
        },
        {
          "hole": 17,
          "x": 173.7355,
          "y": 60,
          "z": 67.5075
        },
        {
          "hole": 18,
          "x": 178.1189,
          "y": 60,
          "z": 61.3905
        },
        {
          "hole": 19,
          "x": 182.0928,
          "y": 60,
          "z": 55
        },
        {
          "hole": 20,
          "x": 185.6402,
          "y": 60,
          "z": 48.3632
        },
        {
          "hole": 21,
          "x": 191.397,
          "y": 60,
          "z": 34.4655
        },
        {
          "hole": 22,
          "x": 193.5815,
          "y": 60,
          "z": 27.2642
        },
        {
          "hole": 23,
          "x": 195.2903,
          "y": 60,
          "z": 19.9354
        },
        {
          "hole": 24,
          "x": 196.5162,
          "y": 60,
          "z": 12.5105
        },
        {
          "hole": 25,
          "x": 197.2538,
          "y": 60,
          "z": 5.0214
        },
        {
          "hole": 26,
          "x": 197.2538,
          "y": 60,
          "z": -10.0214
        },
        {
          "hole": 27,
          "x": 196.5162,
          "y": 60,
          "z": -17.5105
        },
        {
          "hole": 28,
          "x": 195.2903,
          "y": 60,
          "z": -24.9354
        },
        {
          "hole": 29,
          "x": 193.5815,
          "y": 60,
          "z": -32.2642
        },
        {
          "hole": 30,
          "x": 191.397,
          "y": 60,
          "z": -39.4655
        },
        {
          "hole": 31,
          "x": 185.6403,
          "y": 60,
          "z": -53.3632
        },
        {
          "hole": 32,
          "x": 182.0929,
          "y": 60,
          "z": -60
        },
        {
          "hole": 33,
          "x": 178.119,
          "y": 60,
          "z": -66.3906
        },
        {
          "hole": 34,
          "x": 173.7356,
          "y": 60,
          "z": -72.5076
        },
        {
          "hole": 35,
          "x": 168.9615,
          "y": 60,
          "z": -78.3248
        },
        {
          "hole": 36,
          "x": 158.3247,
          "y": 60,
          "z": -88.9616
        },
        {
          "hole": 37,
          "x": 152.5075,
          "y": 60,
          "z": -93.7356
        },
        {
          "hole": 38,
          "x": 146.3905,
          "y": 60,
          "z": -98.119
        },
        {
          "hole": 39,
          "x": 140,
          "y": 60,
          "z": -102.0929
        },
        {
          "hole": 40,
          "x": 133.3632,
          "y": 60,
          "z": -105.6404
        },
        {
          "hole": 41,
          "x": 119.4655,
          "y": 60,
          "z": -111.397
        },
        {
          "hole": 42,
          "x": 112.2642,
          "y": 60,
          "z": -113.5815
        },
        {
          "hole": 43,
          "x": 104.9354,
          "y": 60,
          "z": -115.2903
        },
        {
          "hole": 44,
          "x": 97.5105,
          "y": 60,
          "z": -116.5162
        },
        {
          "hole": 45,
          "x": 90.0214,
          "y": 60,
          "z": -117.2538
        },
        {
          "hole": 46,
          "x": 78,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 71,
          "x": -125.0214,
          "y": 60,
          "z": -117.2538
        },
        {
          "hole": 72,
          "x": -132.5105,
          "y": 60,
          "z": -116.5161
        },
        {
          "hole": 73,
          "x": -139.9354,
          "y": 60,
          "z": -115.2903
        },
        {
          "hole": 74,
          "x": -147.2642,
          "y": 60,
          "z": -113.5815
        },
        {
          "hole": 75,
          "x": -154.4655,
          "y": 60,
          "z": -111.3969
        },
        {
          "hole": 76,
          "x": -168.3632,
          "y": 60,
          "z": -105.6403
        },
        {
          "hole": 77,
          "x": -175,
          "y": 60,
          "z": -102.0929
        },
        {
          "hole": 78,
          "x": -181.3906,
          "y": 60,
          "z": -98.119
        },
        {
          "hole": 79,
          "x": -187.5075,
          "y": 60,
          "z": -93.7356
        },
        {
          "hole": 80,
          "x": -193.3247,
          "y": 60,
          "z": -88.9616
        },
        {
          "hole": 81,
          "x": -203.9616,
          "y": 60,
          "z": -78.3248
        },
        {
          "hole": 82,
          "x": -208.7356,
          "y": 60,
          "z": -72.5076
        },
        {
          "hole": 83,
          "x": -213.119,
          "y": 60,
          "z": -66.3906
        },
        {
          "hole": 84,
          "x": -217.0929,
          "y": 60,
          "z": -60
        },
        {
          "hole": 85,
          "x": -220.6404,
          "y": 60,
          "z": -53.3632
        },
        {
          "hole": 86,
          "x": -226.397,
          "y": 60,
          "z": -39.4655
        },
        {
          "hole": 87,
          "x": -228.5815,
          "y": 60,
          "z": -32.2642
        },
        {
          "hole": 88,
          "x": -230.2903,
          "y": 60,
          "z": -24.9354
        },
        {
          "hole": 89,
          "x": -231.5162,
          "y": 60,
          "z": -17.5105
        },
        {
          "hole": 90,
          "x": -232.2538,
          "y": 60,
          "z": -10.0214
        },
        {
          "hole": 91,
          "x": -232.2538,
          "y": 60,
          "z": 5.0214
        },
        {
          "hole": 92,
          "x": -231.5162,
          "y": 60,
          "z": 12.5105
        },
        {
          "hole": 93,
          "x": -230.2903,
          "y": 60,
          "z": 19.9354
        },
        {
          "hole": 94,
          "x": -228.5815,
          "y": 60,
          "z": 27.2642
        },
        {
          "hole": 95,
          "x": -226.397,
          "y": 60,
          "z": 34.4655
        },
        {
          "hole": 96,
          "x": -220.6404,
          "y": 60,
          "z": 48.3633
        },
        {
          "hole": 97,
          "x": -217.0929,
          "y": 60,
          "z": 55.0001
        },
        {
          "hole": 98,
          "x": -213.119,
          "y": 60,
          "z": 61.3906
        },
        {
          "hole": 99,
          "x": -208.7356,
          "y": 60,
          "z": 67.5076
        },
        {
          "hole": 100,
          "x": -203.9616,
          "y": 60,
          "z": 73.3248
        },
        {
          "hole": 101,
          "x": -193.3248,
          "y": 60,
          "z": 83.9616
        },
        {
          "hole": 102,
          "x": -187.5076,
          "y": 60,
          "z": 88.7357
        },
        {
          "hole": 103,
          "x": -181.3906,
          "y": 60,
          "z": 93.119
        },
        {
          "hole": 104,
          "x": -175,
          "y": 60,
          "z": 97.0929
        },
        {
          "hole": 105,
          "x": -168.3632,
          "y": 60,
          "z": 100.6404
        },
        {
          "hole": 106,
          "x": -154.4655,
          "y": 60,
          "z": 106.397
        },
        {
          "hole": 107,
          "x": -147.2642,
          "y": 60,
          "z": 108.5815
        },
        {
          "hole": 108,
          "x": -139.9354,
          "y": 60,
          "z": 110.2903
        },
        {
          "hole": 109,
          "x": -132.5105,
          "y": 60,
          "z": 111.5162
        },
        {
          "hole": 110,
          "x": -125.0214,
          "y": 60,
          "z": 112.2538
        },
        {
          "hole": 111,
          "x": -113,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 60,
          "z": 112.5
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 40,
          "z": 92.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 6,
          "x": 89.3673,
          "y": 50,
          "z": 102.2752
        },
        {
          "hole": 7,
          "x": 96.2052,
          "y": 50,
          "z": 101.6017
        },
        {
          "hole": 8,
          "x": 102.9845,
          "y": 50,
          "z": 100.4825
        },
        {
          "hole": 9,
          "x": 109.676,
          "y": 50,
          "z": 98.9222
        },
        {
          "hole": 10,
          "x": 116.2511,
          "y": 50,
          "z": 96.9277
        },
        {
          "hole": 11,
          "x": 128.9403,
          "y": 50,
          "z": 91.6716
        },
        {
          "hole": 12,
          "x": 134.9999,
          "y": 50,
          "z": 88.4327
        },
        {
          "hole": 13,
          "x": 140.8348,
          "y": 50,
          "z": 84.8043
        },
        {
          "hole": 14,
          "x": 146.4199,
          "y": 50,
          "z": 80.8021
        },
        {
          "hole": 15,
          "x": 151.7313,
          "y": 50,
          "z": 76.4432
        },
        {
          "hole": 16,
          "x": 161.443,
          "y": 50,
          "z": 66.7313
        },
        {
          "hole": 17,
          "x": 165.802,
          "y": 50,
          "z": 61.4199
        },
        {
          "hole": 18,
          "x": 169.8042,
          "y": 50,
          "z": 55.8348
        },
        {
          "hole": 19,
          "x": 173.4325,
          "y": 50,
          "z": 50
        },
        {
          "hole": 20,
          "x": 176.6715,
          "y": 50,
          "z": 43.9403
        },
        {
          "hole": 21,
          "x": 181.9277,
          "y": 50,
          "z": 31.2512
        },
        {
          "hole": 22,
          "x": 183.9222,
          "y": 50,
          "z": 24.676
        },
        {
          "hole": 23,
          "x": 185.4825,
          "y": 50,
          "z": 17.9845
        },
        {
          "hole": 24,
          "x": 186.6017,
          "y": 50,
          "z": 11.2053
        },
        {
          "hole": 25,
          "x": 187.2752,
          "y": 50,
          "z": 4.3673
        },
        {
          "hole": 26,
          "x": 187.2752,
          "y": 50,
          "z": -9.3673
        },
        {
          "hole": 27,
          "x": 186.6017,
          "y": 50,
          "z": -16.2052
        },
        {
          "hole": 28,
          "x": 185.4825,
          "y": 50,
          "z": -22.9845
        },
        {
          "hole": 29,
          "x": 183.9222,
          "y": 50,
          "z": -29.676
        },
        {
          "hole": 30,
          "x": 181.9277,
          "y": 50,
          "z": -36.2511
        },
        {
          "hole": 31,
          "x": 176.6716,
          "y": 50,
          "z": -48.9403
        },
        {
          "hole": 32,
          "x": 173.4326,
          "y": 50,
          "z": -55
        },
        {
          "hole": 33,
          "x": 169.8043,
          "y": 50,
          "z": -60.8349
        },
        {
          "hole": 34,
          "x": 165.8021,
          "y": 50,
          "z": -66.4199
        },
        {
          "hole": 35,
          "x": 161.4431,
          "y": 50,
          "z": -71.7313
        },
        {
          "hole": 36,
          "x": 151.7313,
          "y": 50,
          "z": -81.4432
        },
        {
          "hole": 37,
          "x": 146.4199,
          "y": 50,
          "z": -85.8021
        },
        {
          "hole": 38,
          "x": 140.8348,
          "y": 50,
          "z": -89.8043
        },
        {
          "hole": 39,
          "x": 135,
          "y": 50,
          "z": -93.4327
        },
        {
          "hole": 40,
          "x": 128.9403,
          "y": 50,
          "z": -96.6716
        },
        {
          "hole": 41,
          "x": 116.2511,
          "y": 50,
          "z": -101.9277
        },
        {
          "hole": 42,
          "x": 109.676,
          "y": 50,
          "z": -103.9222
        },
        {
          "hole": 43,
          "x": 102.9845,
          "y": 50,
          "z": -105.4825
        },
        {
          "hole": 44,
          "x": 96.2053,
          "y": 50,
          "z": -106.6017
        },
        {
          "hole": 45,
          "x": 89.3673,
          "y": 50,
          "z": -107.2752
        },
        {
          "hole": 46,
          "x": 78,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 71,
          "x": -124.3673,
          "y": 50,
          "z": -107.2752
        },
        {
          "hole": 72,
          "x": -131.2052,
          "y": 50,
          "z": -106.6017
        },
        {
          "hole": 73,
          "x": -137.9845,
          "y": 50,
          "z": -105.4824
        },
        {
          "hole": 74,
          "x": -144.676,
          "y": 50,
          "z": -103.9222
        },
        {
          "hole": 75,
          "x": -151.2511,
          "y": 50,
          "z": -101.9276
        },
        {
          "hole": 76,
          "x": -163.9403,
          "y": 50,
          "z": -96.6716
        },
        {
          "hole": 77,
          "x": -170,
          "y": 50,
          "z": -93.4326
        },
        {
          "hole": 78,
          "x": -175.8349,
          "y": 50,
          "z": -89.8043
        },
        {
          "hole": 79,
          "x": -181.4199,
          "y": 50,
          "z": -85.8021
        },
        {
          "hole": 80,
          "x": -186.7313,
          "y": 50,
          "z": -81.4432
        },
        {
          "hole": 81,
          "x": -196.4432,
          "y": 50,
          "z": -71.7313
        },
        {
          "hole": 82,
          "x": -200.8021,
          "y": 50,
          "z": -66.42
        },
        {
          "hole": 83,
          "x": -204.8043,
          "y": 50,
          "z": -60.8349
        },
        {
          "hole": 84,
          "x": -208.4327,
          "y": 50,
          "z": -55
        },
        {
          "hole": 85,
          "x": -211.6716,
          "y": 50,
          "z": -48.9403
        },
        {
          "hole": 86,
          "x": -216.9277,
          "y": 50,
          "z": -36.2511
        },
        {
          "hole": 87,
          "x": -218.9222,
          "y": 50,
          "z": -29.676
        },
        {
          "hole": 88,
          "x": -220.4825,
          "y": 50,
          "z": -22.9845
        },
        {
          "hole": 89,
          "x": -221.6017,
          "y": 50,
          "z": -16.2053
        },
        {
          "hole": 90,
          "x": -222.2752,
          "y": 50,
          "z": -9.3673
        },
        {
          "hole": 91,
          "x": -222.2752,
          "y": 50,
          "z": 4.3673
        },
        {
          "hole": 92,
          "x": -221.6017,
          "y": 50,
          "z": 11.2053
        },
        {
          "hole": 93,
          "x": -220.4825,
          "y": 50,
          "z": 17.9845
        },
        {
          "hole": 94,
          "x": -218.9222,
          "y": 50,
          "z": 24.676
        },
        {
          "hole": 95,
          "x": -216.9277,
          "y": 50,
          "z": 31.2512
        },
        {
          "hole": 96,
          "x": -211.6716,
          "y": 50,
          "z": 43.9404
        },
        {
          "hole": 97,
          "x": -208.4327,
          "y": 50,
          "z": 50.0001
        },
        {
          "hole": 98,
          "x": -204.8043,
          "y": 50,
          "z": 55.8349
        },
        {
          "hole": 99,
          "x": -200.8021,
          "y": 50,
          "z": 61.42
        },
        {
          "hole": 100,
          "x": -196.4432,
          "y": 50,
          "z": 66.7314
        },
        {
          "hole": 101,
          "x": -186.7313,
          "y": 50,
          "z": 76.4432
        },
        {
          "hole": 102,
          "x": -181.4199,
          "y": 50,
          "z": 80.8021
        },
        {
          "hole": 103,
          "x": -175.8349,
          "y": 50,
          "z": 84.8043
        },
        {
          "hole": 104,
          "x": -170,
          "y": 50,
          "z": 88.4327
        },
        {
          "hole": 105,
          "x": -163.9403,
          "y": 50,
          "z": 91.6717
        },
        {
          "hole": 106,
          "x": -151.2511,
          "y": 50,
          "z": 96.9277
        },
        {
          "hole": 107,
          "x": -144.676,
          "y": 50,
          "z": 98.9222
        },
        {
          "hole": 108,
          "x": -137.9845,
          "y": 50,
          "z": 100.4825
        },
        {
          "hole": 109,
          "x": -131.2053,
          "y": 50,
          "z": 101.6017
        },
        {
          "hole": 110,
          "x": -124.3673,
          "y": 50,
          "z": 102.2752
        },
        {
          "hole": 111,
          "x": -113,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 50,
          "z": 102.5
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 50,
          "z": 102.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 6,
          "x": 88.7133,
          "y": 40,
          "z": 92.2966
        },
        {
          "hole": 7,
          "x": 94.9,
          "y": 40,
          "z": 91.6873
        },
        {
          "hole": 8,
          "x": 101.0336,
          "y": 40,
          "z": 90.6746
        },
        {
          "hole": 9,
          "x": 107.0878,
          "y": 40,
          "z": 89.263
        },
        {
          "hole": 10,
          "x": 113.0367,
          "y": 40,
          "z": 87.4584
        },
        {
          "hole": 11,
          "x": 124.5174,
          "y": 40,
          "z": 82.7029
        },
        {
          "hole": 12,
          "x": 129.9999,
          "y": 40,
          "z": 79.7724
        },
        {
          "hole": 13,
          "x": 135.2791,
          "y": 40,
          "z": 76.4896
        },
        {
          "hole": 14,
          "x": 140.3323,
          "y": 40,
          "z": 72.8686
        },
        {
          "hole": 15,
          "x": 145.1378,
          "y": 40,
          "z": 68.9248
        },
        {
          "hole": 16,
          "x": 153.9246,
          "y": 40,
          "z": 60.1378
        },
        {
          "hole": 17,
          "x": 157.8684,
          "y": 40,
          "z": 55.3323
        },
        {
          "hole": 18,
          "x": 161.4895,
          "y": 40,
          "z": 50.2791
        },
        {
          "hole": 19,
          "x": 164.7723,
          "y": 40,
          "z": 45
        },
        {
          "hole": 20,
          "x": 167.7028,
          "y": 40,
          "z": 39.5174
        },
        {
          "hole": 21,
          "x": 172.4584,
          "y": 40,
          "z": 28.0368
        },
        {
          "hole": 22,
          "x": 174.263,
          "y": 40,
          "z": 22.0878
        },
        {
          "hole": 23,
          "x": 175.6746,
          "y": 40,
          "z": 16.0336
        },
        {
          "hole": 24,
          "x": 176.6873,
          "y": 40,
          "z": 9.9
        },
        {
          "hole": 25,
          "x": 177.2966,
          "y": 40,
          "z": 3.7133
        },
        {
          "hole": 26,
          "x": 177.2966,
          "y": 40,
          "z": -8.7133
        },
        {
          "hole": 27,
          "x": 176.6873,
          "y": 40,
          "z": -14.9
        },
        {
          "hole": 28,
          "x": 175.6746,
          "y": 40,
          "z": -21.0336
        },
        {
          "hole": 29,
          "x": 174.263,
          "y": 40,
          "z": -27.0878
        },
        {
          "hole": 30,
          "x": 172.4584,
          "y": 40,
          "z": -33.0367
        },
        {
          "hole": 31,
          "x": 167.7029,
          "y": 40,
          "z": -44.5174
        },
        {
          "hole": 32,
          "x": 164.7724,
          "y": 40,
          "z": -50
        },
        {
          "hole": 33,
          "x": 161.4896,
          "y": 40,
          "z": -55.2792
        },
        {
          "hole": 34,
          "x": 157.8685,
          "y": 40,
          "z": -60.3323
        },
        {
          "hole": 35,
          "x": 153.9247,
          "y": 40,
          "z": -65.1378
        },
        {
          "hole": 36,
          "x": 145.1378,
          "y": 40,
          "z": -73.9248
        },
        {
          "hole": 37,
          "x": 140.3323,
          "y": 40,
          "z": -77.8686
        },
        {
          "hole": 38,
          "x": 135.2791,
          "y": 40,
          "z": -81.4896
        },
        {
          "hole": 39,
          "x": 130,
          "y": 40,
          "z": -84.7724
        },
        {
          "hole": 40,
          "x": 124.5174,
          "y": 40,
          "z": -87.7029
        },
        {
          "hole": 41,
          "x": 113.0367,
          "y": 40,
          "z": -92.4584
        },
        {
          "hole": 42,
          "x": 107.0878,
          "y": 40,
          "z": -94.263
        },
        {
          "hole": 43,
          "x": 101.0336,
          "y": 40,
          "z": -95.6746
        },
        {
          "hole": 44,
          "x": 94.9,
          "y": 40,
          "z": -96.6873
        },
        {
          "hole": 45,
          "x": 88.7133,
          "y": 40,
          "z": -97.2966
        },
        {
          "hole": 46,
          "x": 78,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 71,
          "x": -123.7133,
          "y": 40,
          "z": -97.2966
        },
        {
          "hole": 72,
          "x": -129.9,
          "y": 40,
          "z": -96.6872
        },
        {
          "hole": 73,
          "x": -136.0336,
          "y": 40,
          "z": -95.6746
        },
        {
          "hole": 74,
          "x": -142.0878,
          "y": 40,
          "z": -94.2629
        },
        {
          "hole": 75,
          "x": -148.0367,
          "y": 40,
          "z": -92.4583
        },
        {
          "hole": 76,
          "x": -159.5174,
          "y": 40,
          "z": -87.7029
        },
        {
          "hole": 77,
          "x": -165,
          "y": 40,
          "z": -84.7724
        },
        {
          "hole": 78,
          "x": -170.2792,
          "y": 40,
          "z": -81.4896
        },
        {
          "hole": 79,
          "x": -175.3323,
          "y": 40,
          "z": -77.8685
        },
        {
          "hole": 80,
          "x": -180.1378,
          "y": 40,
          "z": -73.9248
        },
        {
          "hole": 81,
          "x": -188.9248,
          "y": 40,
          "z": -65.1379
        },
        {
          "hole": 82,
          "x": -192.8686,
          "y": 40,
          "z": -60.3323
        },
        {
          "hole": 83,
          "x": -196.4896,
          "y": 40,
          "z": -55.2792
        },
        {
          "hole": 84,
          "x": -199.7724,
          "y": 40,
          "z": -50
        },
        {
          "hole": 85,
          "x": -202.7029,
          "y": 40,
          "z": -44.5174
        },
        {
          "hole": 86,
          "x": -207.4584,
          "y": 40,
          "z": -33.0367
        },
        {
          "hole": 87,
          "x": -209.263,
          "y": 40,
          "z": -27.0878
        },
        {
          "hole": 88,
          "x": -210.6746,
          "y": 40,
          "z": -21.0336
        },
        {
          "hole": 89,
          "x": -211.6873,
          "y": 40,
          "z": -14.9
        },
        {
          "hole": 90,
          "x": -212.2966,
          "y": 40,
          "z": -8.7133
        },
        {
          "hole": 91,
          "x": -212.2966,
          "y": 40,
          "z": 3.7133
        },
        {
          "hole": 92,
          "x": -211.6873,
          "y": 40,
          "z": 9.9
        },
        {
          "hole": 93,
          "x": -210.6746,
          "y": 40,
          "z": 16.0336
        },
        {
          "hole": 94,
          "x": -209.263,
          "y": 40,
          "z": 22.0878
        },
        {
          "hole": 95,
          "x": -207.4584,
          "y": 40,
          "z": 28.0368
        },
        {
          "hole": 96,
          "x": -202.7029,
          "y": 40,
          "z": 39.5175
        },
        {
          "hole": 97,
          "x": -199.7724,
          "y": 40,
          "z": 45.0001
        },
        {
          "hole": 98,
          "x": -196.4896,
          "y": 40,
          "z": 50.2792
        },
        {
          "hole": 99,
          "x": -192.8686,
          "y": 40,
          "z": 55.3324
        },
        {
          "hole": 100,
          "x": -188.9248,
          "y": 40,
          "z": 60.1379
        },
        {
          "hole": 101,
          "x": -180.1378,
          "y": 40,
          "z": 68.9248
        },
        {
          "hole": 102,
          "x": -175.3323,
          "y": 40,
          "z": 72.8686
        },
        {
          "hole": 103,
          "x": -170.2792,
          "y": 40,
          "z": 76.4896
        },
        {
          "hole": 104,
          "x": -165,
          "y": 40,
          "z": 79.7724
        },
        {
          "hole": 105,
          "x": -159.5174,
          "y": 40,
          "z": 82.7029
        },
        {
          "hole": 106,
          "x": -148.0367,
          "y": 40,
          "z": 87.4584
        },
        {
          "hole": 107,
          "x": -142.0878,
          "y": 40,
          "z": 89.263
        },
        {
          "hole": 108,
          "x": -136.0336,
          "y": 40,
          "z": 90.6746
        },
        {
          "hole": 109,
          "x": -129.9,
          "y": 40,
          "z": 91.6873
        },
        {
          "hole": 110,
          "x": -123.7133,
          "y": 40,
          "z": 92.2966
        },
        {
          "hole": 111,
          "x": -113,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 40,
          "z": 92.5
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 60,
          "z": 112.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 6,
          "x": 88.0592,
          "y": 30,
          "z": 82.318
        },
        {
          "hole": 7,
          "x": 93.5947,
          "y": 30,
          "z": 81.7728
        },
        {
          "hole": 8,
          "x": 99.0827,
          "y": 30,
          "z": 80.8668
        },
        {
          "hole": 9,
          "x": 104.4996,
          "y": 30,
          "z": 79.6037
        },
        {
          "hole": 10,
          "x": 109.8223,
          "y": 30,
          "z": 77.9891
        },
        {
          "hole": 11,
          "x": 120.0945,
          "y": 30,
          "z": 73.7342
        },
        {
          "hole": 12,
          "x": 124.9999,
          "y": 30,
          "z": 71.1121
        },
        {
          "hole": 13,
          "x": 129.7234,
          "y": 30,
          "z": 68.1749
        },
        {
          "hole": 14,
          "x": 134.2447,
          "y": 30,
          "z": 64.935
        },
        {
          "hole": 15,
          "x": 138.5443,
          "y": 30,
          "z": 61.4064
        },
        {
          "hole": 16,
          "x": 146.4063,
          "y": 30,
          "z": 53.5444
        },
        {
          "hole": 17,
          "x": 149.9349,
          "y": 30,
          "z": 49.2447
        },
        {
          "hole": 18,
          "x": 153.1748,
          "y": 30,
          "z": 44.7234
        },
        {
          "hole": 19,
          "x": 156.112,
          "y": 30,
          "z": 40
        },
        {
          "hole": 20,
          "x": 158.7341,
          "y": 30,
          "z": 35.0945
        },
        {
          "hole": 21,
          "x": 162.9891,
          "y": 30,
          "z": 24.8224
        },
        {
          "hole": 22,
          "x": 164.6037,
          "y": 30,
          "z": 19.4996
        },
        {
          "hole": 23,
          "x": 165.8668,
          "y": 30,
          "z": 14.0827
        },
        {
          "hole": 24,
          "x": 166.7728,
          "y": 30,
          "z": 8.5947
        },
        {
          "hole": 25,
          "x": 167.318,
          "y": 30,
          "z": 3.0593
        },
        {
          "hole": 26,
          "x": 167.318,
          "y": 30,
          "z": -8.0593
        },
        {
          "hole": 27,
          "x": 166.7728,
          "y": 30,
          "z": -13.5947
        },
        {
          "hole": 28,
          "x": 165.8668,
          "y": 30,
          "z": -19.0827
        },
        {
          "hole": 29,
          "x": 164.6037,
          "y": 30,
          "z": -24.4996
        },
        {
          "hole": 30,
          "x": 162.9891,
          "y": 30,
          "z": -29.8224
        },
        {
          "hole": 31,
          "x": 158.7341,
          "y": 30,
          "z": -40.0945
        },
        {
          "hole": 32,
          "x": 156.1121,
          "y": 30,
          "z": -45
        },
        {
          "hole": 33,
          "x": 153.1749,
          "y": 30,
          "z": -49.7235
        },
        {
          "hole": 34,
          "x": 149.935,
          "y": 30,
          "z": -54.2447
        },
        {
          "hole": 35,
          "x": 146.4063,
          "y": 30,
          "z": -58.5444
        },
        {
          "hole": 36,
          "x": 138.5444,
          "y": 30,
          "z": -66.4064
        },
        {
          "hole": 37,
          "x": 134.2447,
          "y": 30,
          "z": -69.935
        },
        {
          "hole": 38,
          "x": 129.7234,
          "y": 30,
          "z": -73.1749
        },
        {
          "hole": 39,
          "x": 125,
          "y": 30,
          "z": -76.1122
        },
        {
          "hole": 40,
          "x": 120.0945,
          "y": 30,
          "z": -78.7342
        },
        {
          "hole": 41,
          "x": 109.8224,
          "y": 30,
          "z": -82.9891
        },
        {
          "hole": 42,
          "x": 104.4996,
          "y": 30,
          "z": -84.6037
        },
        {
          "hole": 43,
          "x": 99.0827,
          "y": 30,
          "z": -85.8667
        },
        {
          "hole": 44,
          "x": 93.5947,
          "y": 30,
          "z": -86.7728
        },
        {
          "hole": 45,
          "x": 88.0593,
          "y": 30,
          "z": -87.318
        },
        {
          "hole": 46,
          "x": 78,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 71,
          "x": -123.0593,
          "y": 30,
          "z": -87.318
        },
        {
          "hole": 72,
          "x": -128.5947,
          "y": 30,
          "z": -86.7728
        },
        {
          "hole": 73,
          "x": -134.0827,
          "y": 30,
          "z": -85.8667
        },
        {
          "hole": 74,
          "x": -139.4996,
          "y": 30,
          "z": -84.6037
        },
        {
          "hole": 75,
          "x": -144.8223,
          "y": 30,
          "z": -82.989
        },
        {
          "hole": 76,
          "x": -155.0945,
          "y": 30,
          "z": -78.7342
        },
        {
          "hole": 77,
          "x": -160,
          "y": 30,
          "z": -76.1121
        },
        {
          "hole": 78,
          "x": -164.7234,
          "y": 30,
          "z": -73.1749
        },
        {
          "hole": 79,
          "x": -169.2447,
          "y": 30,
          "z": -69.935
        },
        {
          "hole": 80,
          "x": -173.5444,
          "y": 30,
          "z": -66.4064
        },
        {
          "hole": 81,
          "x": -181.4064,
          "y": 30,
          "z": -58.5444
        },
        {
          "hole": 82,
          "x": -184.935,
          "y": 30,
          "z": -54.2447
        },
        {
          "hole": 83,
          "x": -188.1749,
          "y": 30,
          "z": -49.7235
        },
        {
          "hole": 84,
          "x": -191.1122,
          "y": 30,
          "z": -45
        },
        {
          "hole": 85,
          "x": -193.7342,
          "y": 30,
          "z": -40.0945
        },
        {
          "hole": 86,
          "x": -197.9891,
          "y": 30,
          "z": -29.8224
        },
        {
          "hole": 87,
          "x": -199.6037,
          "y": 30,
          "z": -24.4996
        },
        {
          "hole": 88,
          "x": -200.8668,
          "y": 30,
          "z": -19.0827
        },
        {
          "hole": 89,
          "x": -201.7728,
          "y": 30,
          "z": -13.5947
        },
        {
          "hole": 90,
          "x": -202.318,
          "y": 30,
          "z": -8.0593
        },
        {
          "hole": 91,
          "x": -202.318,
          "y": 30,
          "z": 3.0593
        },
        {
          "hole": 92,
          "x": -201.7728,
          "y": 30,
          "z": 8.5947
        },
        {
          "hole": 93,
          "x": -200.8668,
          "y": 30,
          "z": 14.0827
        },
        {
          "hole": 94,
          "x": -199.6037,
          "y": 30,
          "z": 19.4996
        },
        {
          "hole": 95,
          "x": -197.9891,
          "y": 30,
          "z": 24.8224
        },
        {
          "hole": 96,
          "x": -193.7342,
          "y": 30,
          "z": 35.0946
        },
        {
          "hole": 97,
          "x": -191.1122,
          "y": 30,
          "z": 40.0001
        },
        {
          "hole": 98,
          "x": -188.1749,
          "y": 30,
          "z": 44.7235
        },
        {
          "hole": 99,
          "x": -184.935,
          "y": 30,
          "z": 49.2448
        },
        {
          "hole": 100,
          "x": -181.4064,
          "y": 30,
          "z": 53.5444
        },
        {
          "hole": 101,
          "x": -173.5444,
          "y": 30,
          "z": 61.4064
        },
        {
          "hole": 102,
          "x": -169.2447,
          "y": 30,
          "z": 64.9351
        },
        {
          "hole": 103,
          "x": -164.7235,
          "y": 30,
          "z": 68.1749
        },
        {
          "hole": 104,
          "x": -160,
          "y": 30,
          "z": 71.1122
        },
        {
          "hole": 105,
          "x": -155.0945,
          "y": 30,
          "z": 73.7342
        },
        {
          "hole": 106,
          "x": -144.8224,
          "y": 30,
          "z": 77.9891
        },
        {
          "hole": 107,
          "x": -139.4996,
          "y": 30,
          "z": 79.6037
        },
        {
          "hole": 108,
          "x": -134.0827,
          "y": 30,
          "z": 80.8667
        },
        {
          "hole": 109,
          "x": -128.5947,
          "y": 30,
          "z": 81.7728
        },
        {
          "hole": 110,
          "x": -123.0593,
          "y": 30,
          "z": 82.318
        },
        {
          "hole": 111,
          "x": -113,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 30,
          "z": 82.5
        }
      ]
    }
  },
  {
    "id": "board-basketball-court",
    "name": "Basketball Court",
    "brand": "crazy,pints,adult",
    "desc": "basketball Court Cribbage 3D cribbage board (8.8 MB)",
    "target": 121,
    "trackCount": 4,
    "thumbnailUrl": "https://cdn.shopify.com/s/files/1/0800/0657/8461/files/basketball-court-crazy-thumbnail.png?v=1792021029",
    "modelUrl": "https://cdn.shopify.com/3d/models/44fb8729ec0418de/basketball-court-crazy.glb",
    "cameraDefaults": {
      "fov": 44,
      "position": [
        0,
        48,
        38
      ],
      "target": [
        0,
        0,
        0
      ],
      "minDistance": 15,
      "maxDistance": 95
    },
    "lightingPreset": "studio",
    "woodFinish": "walnut",
    "coordinatesData": {
      "p1": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 30,
          "z": 82.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 6,
          "x": 90.0213,
          "y": 60,
          "z": 112.2538
        },
        {
          "hole": 7,
          "x": 97.5105,
          "y": 60,
          "z": 111.5162
        },
        {
          "hole": 8,
          "x": 104.9354,
          "y": 60,
          "z": 110.2903
        },
        {
          "hole": 9,
          "x": 112.2642,
          "y": 60,
          "z": 108.5815
        },
        {
          "hole": 10,
          "x": 119.4655,
          "y": 60,
          "z": 106.397
        },
        {
          "hole": 11,
          "x": 133.3631,
          "y": 60,
          "z": 100.6404
        },
        {
          "hole": 12,
          "x": 139.9999,
          "y": 60,
          "z": 97.0929
        },
        {
          "hole": 13,
          "x": 146.3905,
          "y": 60,
          "z": 93.119
        },
        {
          "hole": 14,
          "x": 152.5075,
          "y": 60,
          "z": 88.7356
        },
        {
          "hole": 15,
          "x": 158.3247,
          "y": 60,
          "z": 83.9616
        },
        {
          "hole": 16,
          "x": 168.9614,
          "y": 60,
          "z": 73.3247
        },
        {
          "hole": 17,
          "x": 173.7355,
          "y": 60,
          "z": 67.5075
        },
        {
          "hole": 18,
          "x": 178.1189,
          "y": 60,
          "z": 61.3905
        },
        {
          "hole": 19,
          "x": 182.0928,
          "y": 60,
          "z": 55
        },
        {
          "hole": 20,
          "x": 185.6402,
          "y": 60,
          "z": 48.3632
        },
        {
          "hole": 21,
          "x": 191.397,
          "y": 60,
          "z": 34.4655
        },
        {
          "hole": 22,
          "x": 193.5815,
          "y": 60,
          "z": 27.2642
        },
        {
          "hole": 23,
          "x": 195.2903,
          "y": 60,
          "z": 19.9354
        },
        {
          "hole": 24,
          "x": 196.5162,
          "y": 60,
          "z": 12.5105
        },
        {
          "hole": 25,
          "x": 197.2538,
          "y": 60,
          "z": 5.0214
        },
        {
          "hole": 26,
          "x": 197.2538,
          "y": 60,
          "z": -10.0214
        },
        {
          "hole": 27,
          "x": 196.5162,
          "y": 60,
          "z": -17.5105
        },
        {
          "hole": 28,
          "x": 195.2903,
          "y": 60,
          "z": -24.9354
        },
        {
          "hole": 29,
          "x": 193.5815,
          "y": 60,
          "z": -32.2642
        },
        {
          "hole": 30,
          "x": 191.397,
          "y": 60,
          "z": -39.4655
        },
        {
          "hole": 31,
          "x": 185.6403,
          "y": 60,
          "z": -53.3632
        },
        {
          "hole": 32,
          "x": 182.0929,
          "y": 60,
          "z": -60
        },
        {
          "hole": 33,
          "x": 178.119,
          "y": 60,
          "z": -66.3906
        },
        {
          "hole": 34,
          "x": 173.7356,
          "y": 60,
          "z": -72.5076
        },
        {
          "hole": 35,
          "x": 168.9615,
          "y": 60,
          "z": -78.3248
        },
        {
          "hole": 36,
          "x": 158.3247,
          "y": 60,
          "z": -88.9616
        },
        {
          "hole": 37,
          "x": 152.5075,
          "y": 60,
          "z": -93.7356
        },
        {
          "hole": 38,
          "x": 146.3905,
          "y": 60,
          "z": -98.119
        },
        {
          "hole": 39,
          "x": 140,
          "y": 60,
          "z": -102.0929
        },
        {
          "hole": 40,
          "x": 133.3632,
          "y": 60,
          "z": -105.6404
        },
        {
          "hole": 41,
          "x": 119.4655,
          "y": 60,
          "z": -111.397
        },
        {
          "hole": 42,
          "x": 112.2642,
          "y": 60,
          "z": -113.5815
        },
        {
          "hole": 43,
          "x": 104.9354,
          "y": 60,
          "z": -115.2903
        },
        {
          "hole": 44,
          "x": 97.5105,
          "y": 60,
          "z": -116.5162
        },
        {
          "hole": 45,
          "x": 90.0214,
          "y": 60,
          "z": -117.2538
        },
        {
          "hole": 46,
          "x": 78,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 60,
          "z": -117.5
        },
        {
          "hole": 71,
          "x": -125.0214,
          "y": 60,
          "z": -117.2538
        },
        {
          "hole": 72,
          "x": -132.5105,
          "y": 60,
          "z": -116.5161
        },
        {
          "hole": 73,
          "x": -139.9354,
          "y": 60,
          "z": -115.2903
        },
        {
          "hole": 74,
          "x": -147.2642,
          "y": 60,
          "z": -113.5815
        },
        {
          "hole": 75,
          "x": -154.4655,
          "y": 60,
          "z": -111.3969
        },
        {
          "hole": 76,
          "x": -168.3632,
          "y": 60,
          "z": -105.6403
        },
        {
          "hole": 77,
          "x": -175,
          "y": 60,
          "z": -102.0929
        },
        {
          "hole": 78,
          "x": -181.3906,
          "y": 60,
          "z": -98.119
        },
        {
          "hole": 79,
          "x": -187.5075,
          "y": 60,
          "z": -93.7356
        },
        {
          "hole": 80,
          "x": -193.3247,
          "y": 60,
          "z": -88.9616
        },
        {
          "hole": 81,
          "x": -203.9616,
          "y": 60,
          "z": -78.3248
        },
        {
          "hole": 82,
          "x": -208.7356,
          "y": 60,
          "z": -72.5076
        },
        {
          "hole": 83,
          "x": -213.119,
          "y": 60,
          "z": -66.3906
        },
        {
          "hole": 84,
          "x": -217.0929,
          "y": 60,
          "z": -60
        },
        {
          "hole": 85,
          "x": -220.6404,
          "y": 60,
          "z": -53.3632
        },
        {
          "hole": 86,
          "x": -226.397,
          "y": 60,
          "z": -39.4655
        },
        {
          "hole": 87,
          "x": -228.5815,
          "y": 60,
          "z": -32.2642
        },
        {
          "hole": 88,
          "x": -230.2903,
          "y": 60,
          "z": -24.9354
        },
        {
          "hole": 89,
          "x": -231.5162,
          "y": 60,
          "z": -17.5105
        },
        {
          "hole": 90,
          "x": -232.2538,
          "y": 60,
          "z": -10.0214
        },
        {
          "hole": 91,
          "x": -232.2538,
          "y": 60,
          "z": 5.0214
        },
        {
          "hole": 92,
          "x": -231.5162,
          "y": 60,
          "z": 12.5105
        },
        {
          "hole": 93,
          "x": -230.2903,
          "y": 60,
          "z": 19.9354
        },
        {
          "hole": 94,
          "x": -228.5815,
          "y": 60,
          "z": 27.2642
        },
        {
          "hole": 95,
          "x": -226.397,
          "y": 60,
          "z": 34.4655
        },
        {
          "hole": 96,
          "x": -220.6404,
          "y": 60,
          "z": 48.3633
        },
        {
          "hole": 97,
          "x": -217.0929,
          "y": 60,
          "z": 55.0001
        },
        {
          "hole": 98,
          "x": -213.119,
          "y": 60,
          "z": 61.3906
        },
        {
          "hole": 99,
          "x": -208.7356,
          "y": 60,
          "z": 67.5076
        },
        {
          "hole": 100,
          "x": -203.9616,
          "y": 60,
          "z": 73.3248
        },
        {
          "hole": 101,
          "x": -193.3248,
          "y": 60,
          "z": 83.9616
        },
        {
          "hole": 102,
          "x": -187.5076,
          "y": 60,
          "z": 88.7357
        },
        {
          "hole": 103,
          "x": -181.3906,
          "y": 60,
          "z": 93.119
        },
        {
          "hole": 104,
          "x": -175,
          "y": 60,
          "z": 97.0929
        },
        {
          "hole": 105,
          "x": -168.3632,
          "y": 60,
          "z": 100.6404
        },
        {
          "hole": 106,
          "x": -154.4655,
          "y": 60,
          "z": 106.397
        },
        {
          "hole": 107,
          "x": -147.2642,
          "y": 60,
          "z": 108.5815
        },
        {
          "hole": 108,
          "x": -139.9354,
          "y": 60,
          "z": 110.2903
        },
        {
          "hole": 109,
          "x": -132.5105,
          "y": 60,
          "z": 111.5162
        },
        {
          "hole": 110,
          "x": -125.0214,
          "y": 60,
          "z": 112.2538
        },
        {
          "hole": 111,
          "x": -113,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 60,
          "z": 112.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 60,
          "z": 112.5
        }
      ],
      "p2": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 40,
          "z": 92.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 6,
          "x": 89.3673,
          "y": 50,
          "z": 102.2752
        },
        {
          "hole": 7,
          "x": 96.2052,
          "y": 50,
          "z": 101.6017
        },
        {
          "hole": 8,
          "x": 102.9845,
          "y": 50,
          "z": 100.4825
        },
        {
          "hole": 9,
          "x": 109.676,
          "y": 50,
          "z": 98.9222
        },
        {
          "hole": 10,
          "x": 116.2511,
          "y": 50,
          "z": 96.9277
        },
        {
          "hole": 11,
          "x": 128.9403,
          "y": 50,
          "z": 91.6716
        },
        {
          "hole": 12,
          "x": 134.9999,
          "y": 50,
          "z": 88.4327
        },
        {
          "hole": 13,
          "x": 140.8348,
          "y": 50,
          "z": 84.8043
        },
        {
          "hole": 14,
          "x": 146.4199,
          "y": 50,
          "z": 80.8021
        },
        {
          "hole": 15,
          "x": 151.7313,
          "y": 50,
          "z": 76.4432
        },
        {
          "hole": 16,
          "x": 161.443,
          "y": 50,
          "z": 66.7313
        },
        {
          "hole": 17,
          "x": 165.802,
          "y": 50,
          "z": 61.4199
        },
        {
          "hole": 18,
          "x": 169.8042,
          "y": 50,
          "z": 55.8348
        },
        {
          "hole": 19,
          "x": 173.4325,
          "y": 50,
          "z": 50
        },
        {
          "hole": 20,
          "x": 176.6715,
          "y": 50,
          "z": 43.9403
        },
        {
          "hole": 21,
          "x": 181.9277,
          "y": 50,
          "z": 31.2512
        },
        {
          "hole": 22,
          "x": 183.9222,
          "y": 50,
          "z": 24.676
        },
        {
          "hole": 23,
          "x": 185.4825,
          "y": 50,
          "z": 17.9845
        },
        {
          "hole": 24,
          "x": 186.6017,
          "y": 50,
          "z": 11.2053
        },
        {
          "hole": 25,
          "x": 187.2752,
          "y": 50,
          "z": 4.3673
        },
        {
          "hole": 26,
          "x": 187.2752,
          "y": 50,
          "z": -9.3673
        },
        {
          "hole": 27,
          "x": 186.6017,
          "y": 50,
          "z": -16.2052
        },
        {
          "hole": 28,
          "x": 185.4825,
          "y": 50,
          "z": -22.9845
        },
        {
          "hole": 29,
          "x": 183.9222,
          "y": 50,
          "z": -29.676
        },
        {
          "hole": 30,
          "x": 181.9277,
          "y": 50,
          "z": -36.2511
        },
        {
          "hole": 31,
          "x": 176.6716,
          "y": 50,
          "z": -48.9403
        },
        {
          "hole": 32,
          "x": 173.4326,
          "y": 50,
          "z": -55
        },
        {
          "hole": 33,
          "x": 169.8043,
          "y": 50,
          "z": -60.8349
        },
        {
          "hole": 34,
          "x": 165.8021,
          "y": 50,
          "z": -66.4199
        },
        {
          "hole": 35,
          "x": 161.4431,
          "y": 50,
          "z": -71.7313
        },
        {
          "hole": 36,
          "x": 151.7313,
          "y": 50,
          "z": -81.4432
        },
        {
          "hole": 37,
          "x": 146.4199,
          "y": 50,
          "z": -85.8021
        },
        {
          "hole": 38,
          "x": 140.8348,
          "y": 50,
          "z": -89.8043
        },
        {
          "hole": 39,
          "x": 135,
          "y": 50,
          "z": -93.4327
        },
        {
          "hole": 40,
          "x": 128.9403,
          "y": 50,
          "z": -96.6716
        },
        {
          "hole": 41,
          "x": 116.2511,
          "y": 50,
          "z": -101.9277
        },
        {
          "hole": 42,
          "x": 109.676,
          "y": 50,
          "z": -103.9222
        },
        {
          "hole": 43,
          "x": 102.9845,
          "y": 50,
          "z": -105.4825
        },
        {
          "hole": 44,
          "x": 96.2053,
          "y": 50,
          "z": -106.6017
        },
        {
          "hole": 45,
          "x": 89.3673,
          "y": 50,
          "z": -107.2752
        },
        {
          "hole": 46,
          "x": 78,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 50,
          "z": -107.5
        },
        {
          "hole": 71,
          "x": -124.3673,
          "y": 50,
          "z": -107.2752
        },
        {
          "hole": 72,
          "x": -131.2052,
          "y": 50,
          "z": -106.6017
        },
        {
          "hole": 73,
          "x": -137.9845,
          "y": 50,
          "z": -105.4824
        },
        {
          "hole": 74,
          "x": -144.676,
          "y": 50,
          "z": -103.9222
        },
        {
          "hole": 75,
          "x": -151.2511,
          "y": 50,
          "z": -101.9276
        },
        {
          "hole": 76,
          "x": -163.9403,
          "y": 50,
          "z": -96.6716
        },
        {
          "hole": 77,
          "x": -170,
          "y": 50,
          "z": -93.4326
        },
        {
          "hole": 78,
          "x": -175.8349,
          "y": 50,
          "z": -89.8043
        },
        {
          "hole": 79,
          "x": -181.4199,
          "y": 50,
          "z": -85.8021
        },
        {
          "hole": 80,
          "x": -186.7313,
          "y": 50,
          "z": -81.4432
        },
        {
          "hole": 81,
          "x": -196.4432,
          "y": 50,
          "z": -71.7313
        },
        {
          "hole": 82,
          "x": -200.8021,
          "y": 50,
          "z": -66.42
        },
        {
          "hole": 83,
          "x": -204.8043,
          "y": 50,
          "z": -60.8349
        },
        {
          "hole": 84,
          "x": -208.4327,
          "y": 50,
          "z": -55
        },
        {
          "hole": 85,
          "x": -211.6716,
          "y": 50,
          "z": -48.9403
        },
        {
          "hole": 86,
          "x": -216.9277,
          "y": 50,
          "z": -36.2511
        },
        {
          "hole": 87,
          "x": -218.9222,
          "y": 50,
          "z": -29.676
        },
        {
          "hole": 88,
          "x": -220.4825,
          "y": 50,
          "z": -22.9845
        },
        {
          "hole": 89,
          "x": -221.6017,
          "y": 50,
          "z": -16.2053
        },
        {
          "hole": 90,
          "x": -222.2752,
          "y": 50,
          "z": -9.3673
        },
        {
          "hole": 91,
          "x": -222.2752,
          "y": 50,
          "z": 4.3673
        },
        {
          "hole": 92,
          "x": -221.6017,
          "y": 50,
          "z": 11.2053
        },
        {
          "hole": 93,
          "x": -220.4825,
          "y": 50,
          "z": 17.9845
        },
        {
          "hole": 94,
          "x": -218.9222,
          "y": 50,
          "z": 24.676
        },
        {
          "hole": 95,
          "x": -216.9277,
          "y": 50,
          "z": 31.2512
        },
        {
          "hole": 96,
          "x": -211.6716,
          "y": 50,
          "z": 43.9404
        },
        {
          "hole": 97,
          "x": -208.4327,
          "y": 50,
          "z": 50.0001
        },
        {
          "hole": 98,
          "x": -204.8043,
          "y": 50,
          "z": 55.8349
        },
        {
          "hole": 99,
          "x": -200.8021,
          "y": 50,
          "z": 61.42
        },
        {
          "hole": 100,
          "x": -196.4432,
          "y": 50,
          "z": 66.7314
        },
        {
          "hole": 101,
          "x": -186.7313,
          "y": 50,
          "z": 76.4432
        },
        {
          "hole": 102,
          "x": -181.4199,
          "y": 50,
          "z": 80.8021
        },
        {
          "hole": 103,
          "x": -175.8349,
          "y": 50,
          "z": 84.8043
        },
        {
          "hole": 104,
          "x": -170,
          "y": 50,
          "z": 88.4327
        },
        {
          "hole": 105,
          "x": -163.9403,
          "y": 50,
          "z": 91.6717
        },
        {
          "hole": 106,
          "x": -151.2511,
          "y": 50,
          "z": 96.9277
        },
        {
          "hole": 107,
          "x": -144.676,
          "y": 50,
          "z": 98.9222
        },
        {
          "hole": 108,
          "x": -137.9845,
          "y": 50,
          "z": 100.4825
        },
        {
          "hole": 109,
          "x": -131.2053,
          "y": 50,
          "z": 101.6017
        },
        {
          "hole": 110,
          "x": -124.3673,
          "y": 50,
          "z": 102.2752
        },
        {
          "hole": 111,
          "x": -113,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 50,
          "z": 102.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 50,
          "z": 102.5
        }
      ],
      "p3": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 50,
          "z": 102.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 6,
          "x": 88.7133,
          "y": 40,
          "z": 92.2966
        },
        {
          "hole": 7,
          "x": 94.9,
          "y": 40,
          "z": 91.6873
        },
        {
          "hole": 8,
          "x": 101.0336,
          "y": 40,
          "z": 90.6746
        },
        {
          "hole": 9,
          "x": 107.0878,
          "y": 40,
          "z": 89.263
        },
        {
          "hole": 10,
          "x": 113.0367,
          "y": 40,
          "z": 87.4584
        },
        {
          "hole": 11,
          "x": 124.5174,
          "y": 40,
          "z": 82.7029
        },
        {
          "hole": 12,
          "x": 129.9999,
          "y": 40,
          "z": 79.7724
        },
        {
          "hole": 13,
          "x": 135.2791,
          "y": 40,
          "z": 76.4896
        },
        {
          "hole": 14,
          "x": 140.3323,
          "y": 40,
          "z": 72.8686
        },
        {
          "hole": 15,
          "x": 145.1378,
          "y": 40,
          "z": 68.9248
        },
        {
          "hole": 16,
          "x": 153.9246,
          "y": 40,
          "z": 60.1378
        },
        {
          "hole": 17,
          "x": 157.8684,
          "y": 40,
          "z": 55.3323
        },
        {
          "hole": 18,
          "x": 161.4895,
          "y": 40,
          "z": 50.2791
        },
        {
          "hole": 19,
          "x": 164.7723,
          "y": 40,
          "z": 45
        },
        {
          "hole": 20,
          "x": 167.7028,
          "y": 40,
          "z": 39.5174
        },
        {
          "hole": 21,
          "x": 172.4584,
          "y": 40,
          "z": 28.0368
        },
        {
          "hole": 22,
          "x": 174.263,
          "y": 40,
          "z": 22.0878
        },
        {
          "hole": 23,
          "x": 175.6746,
          "y": 40,
          "z": 16.0336
        },
        {
          "hole": 24,
          "x": 176.6873,
          "y": 40,
          "z": 9.9
        },
        {
          "hole": 25,
          "x": 177.2966,
          "y": 40,
          "z": 3.7133
        },
        {
          "hole": 26,
          "x": 177.2966,
          "y": 40,
          "z": -8.7133
        },
        {
          "hole": 27,
          "x": 176.6873,
          "y": 40,
          "z": -14.9
        },
        {
          "hole": 28,
          "x": 175.6746,
          "y": 40,
          "z": -21.0336
        },
        {
          "hole": 29,
          "x": 174.263,
          "y": 40,
          "z": -27.0878
        },
        {
          "hole": 30,
          "x": 172.4584,
          "y": 40,
          "z": -33.0367
        },
        {
          "hole": 31,
          "x": 167.7029,
          "y": 40,
          "z": -44.5174
        },
        {
          "hole": 32,
          "x": 164.7724,
          "y": 40,
          "z": -50
        },
        {
          "hole": 33,
          "x": 161.4896,
          "y": 40,
          "z": -55.2792
        },
        {
          "hole": 34,
          "x": 157.8685,
          "y": 40,
          "z": -60.3323
        },
        {
          "hole": 35,
          "x": 153.9247,
          "y": 40,
          "z": -65.1378
        },
        {
          "hole": 36,
          "x": 145.1378,
          "y": 40,
          "z": -73.9248
        },
        {
          "hole": 37,
          "x": 140.3323,
          "y": 40,
          "z": -77.8686
        },
        {
          "hole": 38,
          "x": 135.2791,
          "y": 40,
          "z": -81.4896
        },
        {
          "hole": 39,
          "x": 130,
          "y": 40,
          "z": -84.7724
        },
        {
          "hole": 40,
          "x": 124.5174,
          "y": 40,
          "z": -87.7029
        },
        {
          "hole": 41,
          "x": 113.0367,
          "y": 40,
          "z": -92.4584
        },
        {
          "hole": 42,
          "x": 107.0878,
          "y": 40,
          "z": -94.263
        },
        {
          "hole": 43,
          "x": 101.0336,
          "y": 40,
          "z": -95.6746
        },
        {
          "hole": 44,
          "x": 94.9,
          "y": 40,
          "z": -96.6873
        },
        {
          "hole": 45,
          "x": 88.7133,
          "y": 40,
          "z": -97.2966
        },
        {
          "hole": 46,
          "x": 78,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 40,
          "z": -97.5
        },
        {
          "hole": 71,
          "x": -123.7133,
          "y": 40,
          "z": -97.2966
        },
        {
          "hole": 72,
          "x": -129.9,
          "y": 40,
          "z": -96.6872
        },
        {
          "hole": 73,
          "x": -136.0336,
          "y": 40,
          "z": -95.6746
        },
        {
          "hole": 74,
          "x": -142.0878,
          "y": 40,
          "z": -94.2629
        },
        {
          "hole": 75,
          "x": -148.0367,
          "y": 40,
          "z": -92.4583
        },
        {
          "hole": 76,
          "x": -159.5174,
          "y": 40,
          "z": -87.7029
        },
        {
          "hole": 77,
          "x": -165,
          "y": 40,
          "z": -84.7724
        },
        {
          "hole": 78,
          "x": -170.2792,
          "y": 40,
          "z": -81.4896
        },
        {
          "hole": 79,
          "x": -175.3323,
          "y": 40,
          "z": -77.8685
        },
        {
          "hole": 80,
          "x": -180.1378,
          "y": 40,
          "z": -73.9248
        },
        {
          "hole": 81,
          "x": -188.9248,
          "y": 40,
          "z": -65.1379
        },
        {
          "hole": 82,
          "x": -192.8686,
          "y": 40,
          "z": -60.3323
        },
        {
          "hole": 83,
          "x": -196.4896,
          "y": 40,
          "z": -55.2792
        },
        {
          "hole": 84,
          "x": -199.7724,
          "y": 40,
          "z": -50
        },
        {
          "hole": 85,
          "x": -202.7029,
          "y": 40,
          "z": -44.5174
        },
        {
          "hole": 86,
          "x": -207.4584,
          "y": 40,
          "z": -33.0367
        },
        {
          "hole": 87,
          "x": -209.263,
          "y": 40,
          "z": -27.0878
        },
        {
          "hole": 88,
          "x": -210.6746,
          "y": 40,
          "z": -21.0336
        },
        {
          "hole": 89,
          "x": -211.6873,
          "y": 40,
          "z": -14.9
        },
        {
          "hole": 90,
          "x": -212.2966,
          "y": 40,
          "z": -8.7133
        },
        {
          "hole": 91,
          "x": -212.2966,
          "y": 40,
          "z": 3.7133
        },
        {
          "hole": 92,
          "x": -211.6873,
          "y": 40,
          "z": 9.9
        },
        {
          "hole": 93,
          "x": -210.6746,
          "y": 40,
          "z": 16.0336
        },
        {
          "hole": 94,
          "x": -209.263,
          "y": 40,
          "z": 22.0878
        },
        {
          "hole": 95,
          "x": -207.4584,
          "y": 40,
          "z": 28.0368
        },
        {
          "hole": 96,
          "x": -202.7029,
          "y": 40,
          "z": 39.5175
        },
        {
          "hole": 97,
          "x": -199.7724,
          "y": 40,
          "z": 45.0001
        },
        {
          "hole": 98,
          "x": -196.4896,
          "y": 40,
          "z": 50.2792
        },
        {
          "hole": 99,
          "x": -192.8686,
          "y": 40,
          "z": 55.3324
        },
        {
          "hole": 100,
          "x": -188.9248,
          "y": 40,
          "z": 60.1379
        },
        {
          "hole": 101,
          "x": -180.1378,
          "y": 40,
          "z": 68.9248
        },
        {
          "hole": 102,
          "x": -175.3323,
          "y": 40,
          "z": 72.8686
        },
        {
          "hole": 103,
          "x": -170.2792,
          "y": 40,
          "z": 76.4896
        },
        {
          "hole": 104,
          "x": -165,
          "y": 40,
          "z": 79.7724
        },
        {
          "hole": 105,
          "x": -159.5174,
          "y": 40,
          "z": 82.7029
        },
        {
          "hole": 106,
          "x": -148.0367,
          "y": 40,
          "z": 87.4584
        },
        {
          "hole": 107,
          "x": -142.0878,
          "y": 40,
          "z": 89.263
        },
        {
          "hole": 108,
          "x": -136.0336,
          "y": 40,
          "z": 90.6746
        },
        {
          "hole": 109,
          "x": -129.9,
          "y": 40,
          "z": 91.6873
        },
        {
          "hole": 110,
          "x": -123.7133,
          "y": 40,
          "z": 92.2966
        },
        {
          "hole": 111,
          "x": -113,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 40,
          "z": 92.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 40,
          "z": 92.5
        }
      ],
      "p4": [
        {
          "hole": 0,
          "x": 29.5,
          "y": 60,
          "z": 112.3246
        },
        {
          "hole": 1,
          "x": 47,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 2,
          "x": 54.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 3,
          "x": 62.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 4,
          "x": 70.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 5,
          "x": 78,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 6,
          "x": 88.0592,
          "y": 30,
          "z": 82.318
        },
        {
          "hole": 7,
          "x": 93.5947,
          "y": 30,
          "z": 81.7728
        },
        {
          "hole": 8,
          "x": 99.0827,
          "y": 30,
          "z": 80.8668
        },
        {
          "hole": 9,
          "x": 104.4996,
          "y": 30,
          "z": 79.6037
        },
        {
          "hole": 10,
          "x": 109.8223,
          "y": 30,
          "z": 77.9891
        },
        {
          "hole": 11,
          "x": 120.0945,
          "y": 30,
          "z": 73.7342
        },
        {
          "hole": 12,
          "x": 124.9999,
          "y": 30,
          "z": 71.1121
        },
        {
          "hole": 13,
          "x": 129.7234,
          "y": 30,
          "z": 68.1749
        },
        {
          "hole": 14,
          "x": 134.2447,
          "y": 30,
          "z": 64.935
        },
        {
          "hole": 15,
          "x": 138.5443,
          "y": 30,
          "z": 61.4064
        },
        {
          "hole": 16,
          "x": 146.4063,
          "y": 30,
          "z": 53.5444
        },
        {
          "hole": 17,
          "x": 149.9349,
          "y": 30,
          "z": 49.2447
        },
        {
          "hole": 18,
          "x": 153.1748,
          "y": 30,
          "z": 44.7234
        },
        {
          "hole": 19,
          "x": 156.112,
          "y": 30,
          "z": 40
        },
        {
          "hole": 20,
          "x": 158.7341,
          "y": 30,
          "z": 35.0945
        },
        {
          "hole": 21,
          "x": 162.9891,
          "y": 30,
          "z": 24.8224
        },
        {
          "hole": 22,
          "x": 164.6037,
          "y": 30,
          "z": 19.4996
        },
        {
          "hole": 23,
          "x": 165.8668,
          "y": 30,
          "z": 14.0827
        },
        {
          "hole": 24,
          "x": 166.7728,
          "y": 30,
          "z": 8.5947
        },
        {
          "hole": 25,
          "x": 167.318,
          "y": 30,
          "z": 3.0593
        },
        {
          "hole": 26,
          "x": 167.318,
          "y": 30,
          "z": -8.0593
        },
        {
          "hole": 27,
          "x": 166.7728,
          "y": 30,
          "z": -13.5947
        },
        {
          "hole": 28,
          "x": 165.8668,
          "y": 30,
          "z": -19.0827
        },
        {
          "hole": 29,
          "x": 164.6037,
          "y": 30,
          "z": -24.4996
        },
        {
          "hole": 30,
          "x": 162.9891,
          "y": 30,
          "z": -29.8224
        },
        {
          "hole": 31,
          "x": 158.7341,
          "y": 30,
          "z": -40.0945
        },
        {
          "hole": 32,
          "x": 156.1121,
          "y": 30,
          "z": -45
        },
        {
          "hole": 33,
          "x": 153.1749,
          "y": 30,
          "z": -49.7235
        },
        {
          "hole": 34,
          "x": 149.935,
          "y": 30,
          "z": -54.2447
        },
        {
          "hole": 35,
          "x": 146.4063,
          "y": 30,
          "z": -58.5444
        },
        {
          "hole": 36,
          "x": 138.5444,
          "y": 30,
          "z": -66.4064
        },
        {
          "hole": 37,
          "x": 134.2447,
          "y": 30,
          "z": -69.935
        },
        {
          "hole": 38,
          "x": 129.7234,
          "y": 30,
          "z": -73.1749
        },
        {
          "hole": 39,
          "x": 125,
          "y": 30,
          "z": -76.1122
        },
        {
          "hole": 40,
          "x": 120.0945,
          "y": 30,
          "z": -78.7342
        },
        {
          "hole": 41,
          "x": 109.8224,
          "y": 30,
          "z": -82.9891
        },
        {
          "hole": 42,
          "x": 104.4996,
          "y": 30,
          "z": -84.6037
        },
        {
          "hole": 43,
          "x": 99.0827,
          "y": 30,
          "z": -85.8667
        },
        {
          "hole": 44,
          "x": 93.5947,
          "y": 30,
          "z": -86.7728
        },
        {
          "hole": 45,
          "x": 88.0593,
          "y": 30,
          "z": -87.318
        },
        {
          "hole": 46,
          "x": 78,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 47,
          "x": 70.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 48,
          "x": 62.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 49,
          "x": 54.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 50,
          "x": 47,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 51,
          "x": 38,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 52,
          "x": 30.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 53,
          "x": 22.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 54,
          "x": 14.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 55,
          "x": 7,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 56,
          "x": -2,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 57,
          "x": -9.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 58,
          "x": -17.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 59,
          "x": -25.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 60,
          "x": -33,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 61,
          "x": -42,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 62,
          "x": -49.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 63,
          "x": -57.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 64,
          "x": -65.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 65,
          "x": -73,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 66,
          "x": -82,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 67,
          "x": -89.75,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 68,
          "x": -97.5,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 69,
          "x": -105.25,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 70,
          "x": -113,
          "y": 30,
          "z": -87.5
        },
        {
          "hole": 71,
          "x": -123.0593,
          "y": 30,
          "z": -87.318
        },
        {
          "hole": 72,
          "x": -128.5947,
          "y": 30,
          "z": -86.7728
        },
        {
          "hole": 73,
          "x": -134.0827,
          "y": 30,
          "z": -85.8667
        },
        {
          "hole": 74,
          "x": -139.4996,
          "y": 30,
          "z": -84.6037
        },
        {
          "hole": 75,
          "x": -144.8223,
          "y": 30,
          "z": -82.989
        },
        {
          "hole": 76,
          "x": -155.0945,
          "y": 30,
          "z": -78.7342
        },
        {
          "hole": 77,
          "x": -160,
          "y": 30,
          "z": -76.1121
        },
        {
          "hole": 78,
          "x": -164.7234,
          "y": 30,
          "z": -73.1749
        },
        {
          "hole": 79,
          "x": -169.2447,
          "y": 30,
          "z": -69.935
        },
        {
          "hole": 80,
          "x": -173.5444,
          "y": 30,
          "z": -66.4064
        },
        {
          "hole": 81,
          "x": -181.4064,
          "y": 30,
          "z": -58.5444
        },
        {
          "hole": 82,
          "x": -184.935,
          "y": 30,
          "z": -54.2447
        },
        {
          "hole": 83,
          "x": -188.1749,
          "y": 30,
          "z": -49.7235
        },
        {
          "hole": 84,
          "x": -191.1122,
          "y": 30,
          "z": -45
        },
        {
          "hole": 85,
          "x": -193.7342,
          "y": 30,
          "z": -40.0945
        },
        {
          "hole": 86,
          "x": -197.9891,
          "y": 30,
          "z": -29.8224
        },
        {
          "hole": 87,
          "x": -199.6037,
          "y": 30,
          "z": -24.4996
        },
        {
          "hole": 88,
          "x": -200.8668,
          "y": 30,
          "z": -19.0827
        },
        {
          "hole": 89,
          "x": -201.7728,
          "y": 30,
          "z": -13.5947
        },
        {
          "hole": 90,
          "x": -202.318,
          "y": 30,
          "z": -8.0593
        },
        {
          "hole": 91,
          "x": -202.318,
          "y": 30,
          "z": 3.0593
        },
        {
          "hole": 92,
          "x": -201.7728,
          "y": 30,
          "z": 8.5947
        },
        {
          "hole": 93,
          "x": -200.8668,
          "y": 30,
          "z": 14.0827
        },
        {
          "hole": 94,
          "x": -199.6037,
          "y": 30,
          "z": 19.4996
        },
        {
          "hole": 95,
          "x": -197.9891,
          "y": 30,
          "z": 24.8224
        },
        {
          "hole": 96,
          "x": -193.7342,
          "y": 30,
          "z": 35.0946
        },
        {
          "hole": 97,
          "x": -191.1122,
          "y": 30,
          "z": 40.0001
        },
        {
          "hole": 98,
          "x": -188.1749,
          "y": 30,
          "z": 44.7235
        },
        {
          "hole": 99,
          "x": -184.935,
          "y": 30,
          "z": 49.2448
        },
        {
          "hole": 100,
          "x": -181.4064,
          "y": 30,
          "z": 53.5444
        },
        {
          "hole": 101,
          "x": -173.5444,
          "y": 30,
          "z": 61.4064
        },
        {
          "hole": 102,
          "x": -169.2447,
          "y": 30,
          "z": 64.9351
        },
        {
          "hole": 103,
          "x": -164.7235,
          "y": 30,
          "z": 68.1749
        },
        {
          "hole": 104,
          "x": -160,
          "y": 30,
          "z": 71.1122
        },
        {
          "hole": 105,
          "x": -155.0945,
          "y": 30,
          "z": 73.7342
        },
        {
          "hole": 106,
          "x": -144.8224,
          "y": 30,
          "z": 77.9891
        },
        {
          "hole": 107,
          "x": -139.4996,
          "y": 30,
          "z": 79.6037
        },
        {
          "hole": 108,
          "x": -134.0827,
          "y": 30,
          "z": 80.8667
        },
        {
          "hole": 109,
          "x": -128.5947,
          "y": 30,
          "z": 81.7728
        },
        {
          "hole": 110,
          "x": -123.0593,
          "y": 30,
          "z": 82.318
        },
        {
          "hole": 111,
          "x": -113,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 112,
          "x": -105.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 113,
          "x": -97.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 114,
          "x": -89.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 115,
          "x": -82,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 116,
          "x": -73,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 117,
          "x": -65.25,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 118,
          "x": -57.5,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 119,
          "x": -49.75,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 120,
          "x": -42,
          "y": 30,
          "z": 82.5
        },
        {
          "hole": 121,
          "x": -17.5,
          "y": 30,
          "z": 82.5
        }
      ]
    }
  }
]